import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ConstraintNumber: { input: any; output: any; }
  ConstraintString: { input: any; output: any; }
  ISODate: { input: any; output: any; }
  ISODateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type GqlAbandonedCartProduct = {
  __typename?: 'AbandonedCartProduct';
  category?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type GqlAccount = {
  __typename?: 'Account';
  accountAlias: Scalars['String']['output'];
  accountGuid: Scalars['String']['output'];
  availableBalance: Scalars['Float']['output'];
  bankName: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
};

export type GqlAccountBalance = {
  __typename?: 'AccountBalance';
  accountBalanceCents: Scalars['Int']['output'];
  accountBalanceCurrency: Scalars['String']['output'];
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  insufficient: Scalars['Boolean']['output'];
  multiplier: Scalars['Float']['output'];
  orderTotalCents: Scalars['Int']['output'];
  orderTotalCurrency: Scalars['String']['output'];
  pendingTransactionTotalCents?: Maybe<Scalars['Int']['output']>;
  phase: Scalars['String']['output'];
};

export type GqlAccountDetailsInput = {
  accountAlias?: InputMaybe<Scalars['String']['input']>;
  accountNumber: Scalars['String']['input'];
  accountOwners?: InputMaybe<Array<Scalars['String']['input']>>;
  accountType: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type GqlAchBatch = {
  __typename?: 'AchBatch';
  effectiveDate?: Maybe<GqlGoogleProtobufTimestamp>;
  estimatedSettledAt?: Maybe<GqlGoogleProtobufTimestamp>;
  failedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName: Scalars['String']['output'];
  generatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String']['output'];
  processedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  status: Scalars['String']['output'];
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchEntry = {
  __typename?: 'AchEntry';
  achFileId?: Maybe<Scalars['String']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  secCode?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchEntryV2 = {
  __typename?: 'AchEntryV2';
  achFileId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  batchFileId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  effectiveAt?: Maybe<GqlGoogleProtobufTimestamp>;
  failedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  secCode?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchRawBatchFile = {
  __typename?: 'AchRawBatchFile';
  fileString: Scalars['String']['output'];
};

export type GqlAchReturn = {
  __typename?: 'AchReturn';
  achEntryId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlAchReturnFileUploadResult = {
  __typename?: 'AchReturnFileUploadResult';
  error?: Maybe<GqlErrorMessage>;
  identificationNumber: Scalars['String']['output'];
  markedAsReturned: Scalars['Boolean']['output'];
};

export type GqlAchReturnResponse = {
  __typename?: 'AchReturnResponse';
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  discretionaryData?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  originalAchEntry: Scalars['String']['output'];
  rdfiIdentification?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  secCode?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV2 = {
  __typename?: 'AchReturnV2';
  achEntryId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV4 = {
  __typename?: 'AchReturnV4';
  achEntryId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV5 = {
  __typename?: 'AchReturnV5';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  returnedSourceId?: Maybe<Scalars['String']['output']>;
  returnedSourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReversal = {
  __typename?: 'AchReversal';
  achEntryId: Scalars['String']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  state?: Maybe<Scalars['String']['output']>;
  successfulAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlActionEstimates = {
  __typename?: 'ActionEstimates';
  delivery?: Maybe<GqlActionEstimatesValues>;
  pickup?: Maybe<GqlActionEstimatesValues>;
};

export type GqlActionEstimatesValues = {
  __typename?: 'ActionEstimatesValues';
  deliveryTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  rangeInMinutes?: Maybe<Scalars['Int']['output']>;
  readyInMinutes?: Maybe<Scalars['Float']['output']>;
};

export type GqlActivateBankAccountResponse = {
  __typename?: 'ActivateBankAccountResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlActivatePaymentMethodResponse = {
  __typename?: 'ActivatePaymentMethodResponse';
  genericResponse?: Maybe<GqlGenericResponse>;
};

export type GqlActiveDispenariesResult = {
  __typename?: 'ActiveDispenariesResult';
  dispensaries?: Maybe<Array<Maybe<GqlActiveDispensaries>>>;
  meta?: Maybe<GqlActiveDispensariesMeta>;
};

export type GqlActiveDispensaries = {
  __typename?: 'ActiveDispensaries';
  _id?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<GqlActiveDispensariesIntegration>;
  profile?: Maybe<GqlActiveDispensariesProfile>;
};

export type GqlActiveDispensariesIntegration = {
  __typename?: 'ActiveDispensariesIntegration';
  adapter?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlActiveDispensariesMeta = {
  __typename?: 'ActiveDispensariesMeta';
  allStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlActiveDispensariesProfile = {
  __typename?: 'ActiveDispensariesProfile';
  cName?: Maybe<Scalars['String']['output']>;
  /** @deprecated To be removed */
  chain?: Maybe<Scalars['String']['output']>;
  connectedProductPercentage?: Maybe<Scalars['Float']['output']>;
  embeddedPageViews?: Maybe<Scalars['Int']['output']>;
  hideFromCCT?: Maybe<Scalars['Boolean']['output']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']['output']>;
  menuScore?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum AdDataSource {
  kevel = 'kevel',
  moloco = 'moloco'
}

export enum AdInventoryId {
  /** @deprecated legacy AD inventoryID */
  categoryBrandAuc = 'category_brand_auc',
  categoryCarouselAuc = 'category_carousel_auc',
  /** @deprecated legacy AD inventoryID */
  homeBrandAuc = 'home_brand_auc',
  homeCarouselAuc = 'home_carousel_auc'
}

export type GqlAdSettings = {
  __typename?: 'AdSettings';
  enableAdsForDefault?: Maybe<Scalars['Boolean']['output']>;
  enableAdsForEmbedded?: Maybe<Scalars['Boolean']['output']>;
  enableAdsForKiosk?: Maybe<Scalars['Boolean']['output']>;
  enableAdsForStoreFront?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlAdTrackers = {
  __typename?: 'AdTrackers';
  clickUrl: Scalars['String']['output'];
  impressionUrl: Scalars['String']['output'];
};

export type GqlAddressBasedDispensaryDataResult = {
  __typename?: 'AddressBasedDispensaryDataResult';
  deliveryInfo: GqlDispensaries_DeliveryInfo;
  taxes?: Maybe<Array<GqlDispensaries_TaxConfig_Tax>>;
};

export type GqlAdminOrderListType = {
  __typename?: 'AdminOrderListType';
  orders?: Maybe<Array<Maybe<GqlAdminOrderType>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlAdminOrderType = {
  __typename?: 'AdminOrderType';
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  deliveryEstimate?: Maybe<Scalars['String']['output']>;
  deliveryInfo?: Maybe<GqlOrders_DeliveryInfo>;
  deliveryOption?: Maybe<Scalars['Boolean']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  dispoTimezone?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationEstimates?: Maybe<GqlDurationEstimates>;
  effectiveStatus?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fleetManagementTask?: Maybe<GqlOrders_FleetManagementTask>;
  hypur?: Maybe<GqlHypurDetails>;
  isAfterHoursOrder?: Maybe<Scalars['Boolean']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isKioskOrder?: Maybe<Scalars['Boolean']['output']>;
  isScheduledOrder?: Maybe<Scalars['Boolean']['output']>;
  kioskName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlOrders_Location>;
  moneris?: Maybe<Array<Maybe<GqlMonerisDetails>>>;
  onfleetTask?: Maybe<GqlOrders_FleetManagementTask>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  originKioskId?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<GqlPaymentDetails>>>;
  paysafe?: Maybe<GqlPaysafeDetails>;
  pos?: Maybe<GqlOrders_Pos>;
  reopened?: Maybe<Scalars['Boolean']['output']>;
  reservation?: Maybe<GqlOrderReservation>;
  status?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  voiceCallInfo?: Maybe<GqlVoiceCallInfo>;
};

export type GqlAdminProductReview = {
  __typename?: 'AdminProductReview';
  aiFlagReason?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  dispensaryId: Scalars['String']['output'];
  effects: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  moderatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  moderatedBy?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  posProductId?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  reviewerDisplayName?: Maybe<Scalars['String']['output']>;
  status: ReviewStatus;
  updatedAt: Scalars['ISODateTime']['output'];
  user?: Maybe<GqlUsers>;
  userId: Scalars['String']['output'];
};

export type GqlAdminProductReviewsResponse = {
  __typename?: 'AdminProductReviewsResponse';
  meta?: Maybe<GqlQueryInfoType>;
  productReviews: Array<GqlAdminProductReview>;
};

export type GqlAdminReviewFilterOptions = {
  __typename?: 'AdminReviewFilterOptions';
  dispensaryIds: Array<Scalars['String']['output']>;
  productIds: Array<Scalars['String']['output']>;
};

export type GqlAdminTransferToken = {
  __typename?: 'AdminTransferToken';
  transferToken: Scalars['String']['output'];
};

export type GqlAdsInspectorDutchieAdDecisionData = {
  __typename?: 'AdsInspectorDutchieAdDecisionData';
  adProviderDecisionId: Scalars['String']['output'];
  adProviderFilters: Scalars['JSON']['output'];
  adType: Scalars['String']['output'];
  items: Array<GqlAdsInspectorDutchieAdDecisionItemData>;
  maxItems?: Maybe<Scalars['Int']['output']>;
  menuFilters: Scalars['JSON']['output'];
  minItems?: Maybe<Scalars['Int']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
};

export type GqlAdsInspectorDutchieAdDecisionEvent = {
  __typename?: 'AdsInspectorDutchieAdDecisionEvent';
  data: GqlAdsInspectorDutchieAdDecisionData;
  timestamp: Scalars['ISODateTime']['output'];
};

export type GqlAdsInspectorDutchieAdDecisionItemData = {
  __typename?: 'AdsInspectorDutchieAdDecisionItemData';
  adProviderDecisionId: Scalars['String']['output'];
  adProviderDecisionItemId: Scalars['String']['output'];
  brandId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  clickUrl: Scalars['String']['output'];
  impressionUrl: Scalars['String']['output'];
  libraryProductId: Scalars['String']['output'];
  menuProductId?: Maybe<Scalars['String']['output']>;
  rejectedReasons: Array<Scalars['String']['output']>;
};

export type GqlAdsInspectorDutchieAdTrackerData = {
  __typename?: 'AdsInspectorDutchieAdTrackerData';
  adProviderDecisionId: Scalars['String']['output'];
  adProviderDecisionItemId: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  trackerType: Scalars['String']['output'];
  uiPlacement: Scalars['String']['output'];
  uiPlacementIndex: Scalars['Int']['output'];
  uiVariant: Scalars['String']['output'];
  uiVersion: Scalars['String']['output'];
};

export type GqlAdsInspectorDutchieAdTrackerEvent = {
  __typename?: 'AdsInspectorDutchieAdTrackerEvent';
  data: GqlAdsInspectorDutchieAdTrackerData;
  timestamp: Scalars['ISODateTime']['output'];
};

export type GqlAdsInspectorEvents = {
  __typename?: 'AdsInspectorEvents';
  dutchieAdDecisions: Array<GqlAdsInspectorDutchieAdDecisionEvent>;
  dutchieAdTrackers: Array<GqlAdsInspectorDutchieAdTrackerEvent>;
  timeframe: GqlAdsInspectorEventsTimeframe;
  totalCount: Scalars['Int']['output'];
};

export type GqlAdsInspectorEventsInput = {
  dispensaryId: Scalars['String']['input'];
  menuVariant: Scalars['String']['input'];
};

export type GqlAdsInspectorEventsTimeframe = {
  __typename?: 'AdsInspectorEventsTimeframe';
  end?: Maybe<Scalars['ISODateTime']['output']>;
  start?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlAeroSyncLinkStart = {
  __typename?: 'AeroSyncLinkStart';
  token: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type GqlAgeVerification = {
  __typename?: 'AgeVerification';
  isAgeVerified: Scalars['Boolean']['output'];
};

export type GqlAllotmentCheckInput = {
  cart: Array<GqlCartItemInput>;
  dateOfBirth: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  medicalCardNumber: Scalars['String']['input'];
};

export type GqlAllotmentDetail = {
  __typename?: 'AllotmentDetail';
  category?: Maybe<Scalars['String']['output']>;
  isUnlimited?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  parentCategory?: Maybe<Scalars['String']['output']>;
  remainingThisCycle?: Maybe<Scalars['Float']['output']>;
  remainingWithCart?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<AllotmentStatus>;
  unit?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
  usedInCart?: Maybe<Scalars['Float']['output']>;
  usedThisCycle?: Maybe<Scalars['Float']['output']>;
};

export type GqlAllotmentInfo = {
  __typename?: 'AllotmentInfo';
  details?: Maybe<Array<Maybe<GqlAllotmentDetail>>>;
  error?: Maybe<Scalars['String']['output']>;
  status: AllotmentStatus;
};

export enum AllotmentStatus {
  error = 'ERROR',
  exceeded = 'EXCEEDED',
  withinLimits = 'WITHIN_LIMITS'
}

export type GqlAnalyticsInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  mobileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type GqlAnalyticsMeta = {
  __typename?: 'AnalyticsMeta';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlAnalyticsOrdersByDate = {
  __typename?: 'AnalyticsOrdersByDate';
  date?: Maybe<Scalars['String']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlAnalyticsPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlAnalyticsSort = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlApplicableCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlApplicationRule = {
  __typename?: 'ApplicationRule';
  _id?: Maybe<Scalars['String']['output']>;
  applicationType?: Maybe<ApplicationType>;
  comparisonOperator?: Maybe<ComparisonOperators>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type GqlApplicationRuleInput = {
  applicationType?: InputMaybe<ApplicationType>;
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum ApplicationScope {
  all = 'ALL',
  each = 'EACH'
}

export enum ApplicationType {
  quantity = 'quantity',
  totalQuantity = 'totalQuantity'
}

export type GqlAppliedReward = {
  allowStacking?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated using costV2 to change from Int to Float */
  cost?: InputMaybe<Scalars['Int']['input']>;
  costV2?: InputMaybe<Scalars['Float']['input']>;
  discountId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDposLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isRedeemableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rewardType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlApproveInstoreCartAuthorization = {
  __typename?: 'ApproveInstoreCartAuthorization';
  authorized: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  errorContext?: Maybe<GqlApproveInstoreCartErrorContext>;
  status: Scalars['String']['output'];
};

export type GqlApproveInstoreCartErrorContext = {
  __typename?: 'ApproveInstoreCartErrorContext';
  budtenderMessage?: Maybe<Scalars['String']['output']>;
  consumerMessage?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  posMessage?: Maybe<Scalars['String']['output']>;
};

export type GqlApproveInstoreCartResponse = {
  __typename?: 'ApproveInstoreCartResponse';
  authorization: GqlApproveInstoreCartAuthorization;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlAssessment = {
  __typename?: 'Assessment';
  createdAt: GqlGoogleProtobufTimestamp;
  decision: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalType: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  transactionId: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
};

export type GqlAssetUsage = {
  __typename?: 'AssetUsage';
  dispensaryId: Scalars['String']['output'];
  dispensaryName: Scalars['String']['output'];
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
  usageType: Scalars['String']['output'];
};

export type GqlAssumedSessionInfo = {
  __typename?: 'AssumedSessionInfo';
  actorEmail?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlAudienceCondition = {
  __typename?: 'AudienceCondition';
  segmentId: Scalars['String']['output'];
};

export type GqlAudienceConditionInput = {
  segmentId: Scalars['String']['input'];
};

export type GqlAutoConfirmSettings = {
  __typename?: 'AutoConfirmSettings';
  autoClose?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlAutoConfirmSettingsInput = {
  autoClose?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Mirrors CmsContentAutosaveResult (see cms-content/type.js) for the pages-specific
 * in-place draft save.
 */
export type GqlAutosavePageResult = {
  __typename?: 'AutosavePageResult';
  created: Scalars['Boolean']['output'];
  status: CmsContentVersionStatus;
  variantId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type GqlBackInStockSubscriptionStatus = {
  __typename?: 'BackInStockSubscriptionStatus';
  subscribed: Scalars['Boolean']['output'];
};

export type GqlBankAccount = {
  __typename?: 'BankAccount';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlBankAccountDetails = {
  __typename?: 'BankAccountDetails';
  accountAlias: Scalars['String']['output'];
  aggregator: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  billingAddressId?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['ISODateTime']['output']>;
  financialInstitutionLogo?: Maybe<Scalars['String']['output']>;
  lastDigits: Scalars['String']['output'];
  status: ConnectionStatus;
};

export type GqlBankAccountPaymentMethod = {
  __typename?: 'BankAccountPaymentMethod';
  aggregator?: Maybe<Scalars['String']['output']>;
  bankAccountDetails: GqlBankAccountDetails;
  createdAt: Scalars['ISODateTime']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type?: Maybe<DutchiePayPaymentMethodType>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlBankAccounts = {
  __typename?: 'BankAccounts';
  bankAccounts?: Maybe<Array<GqlBankAccount>>;
};

export type GqlBankDetails = {
  __typename?: 'BankDetails';
  accountAlias?: Maybe<Scalars['String']['output']>;
  bankName: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
  linked?: Maybe<Scalars['Boolean']['output']>;
  ownerName?: Maybe<Array<Scalars['String']['output']>>;
};

export type GqlBaseOrderingSettings = {
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  creditCardByPhoneCheckoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlBasicSettingsInput = {
  autoConfirmSettings?: InputMaybe<GqlAutoConfirmSettingsInput>;
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  creditCardByPhoneCheckoutMessage?: InputMaybe<Scalars['String']['input']>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<GqlNotificationSettingsInput>;
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  pickupReminders?: InputMaybe<GqlPickupRemindersInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlBfdNotCarriedRetailerPreview = {
  __typename?: 'BfdNotCarriedRetailerPreview';
  meta: GqlBfdNotCarriedRetailerPreviewMeta;
  topProspects: Array<GqlBfdNotCarriedRetailerProspect>;
};

export type GqlBfdNotCarriedRetailerPreviewMeta = {
  __typename?: 'BfdNotCarriedRetailerPreviewMeta';
  totalChainCount: Scalars['Int']['output'];
  totalLocationCount: Scalars['Int']['output'];
};

export type GqlBfdNotCarriedRetailerProspect = {
  __typename?: 'BfdNotCarriedRetailerProspect';
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposLspId: Scalars['String']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationCount: Scalars['Int']['output'];
};

export type GqlBfdPosCategory = {
  __typename?: 'BfdPosCategory';
  name: Scalars['String']['output'];
  posCategoryId: Scalars['Int']['output'];
};

export type GqlBfdPosFilterCriterion = {
  __typename?: 'BfdPosFilterCriterion';
  dimension: Scalars['String']['output'];
  valueId: Scalars['String']['output'];
  valueName: Scalars['String']['output'];
};

export type GqlBfdPosProduct = {
  __typename?: 'BfdPosProduct';
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  isFilterCriteria: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  posProductId: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
};

export type GqlBillingAddress = {
  __typename?: 'BillingAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlBillingAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type GqlBlockedAddress = {
  __typename?: 'BlockedAddress';
  addedByRetailerId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlBlockedAddressInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBogoConditionItem = {
  __typename?: 'BogoConditionItem';
  _id?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlBogoConditionItemInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  enterpriseProductId?: InputMaybe<Scalars['String']['input']>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCategoriesAndSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlBogoRewardItem = {
  __typename?: 'BogoRewardItem';
  _id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use applicationRules */
  applicationRule?: Maybe<GqlApplicationRule>;
  applicationRules?: Maybe<Array<GqlApplicationRule>>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  dollarDiscount?: Maybe<Scalars['String']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  percentDiscount?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetPrice?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlBogoRewardItemInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  dollarDiscount?: InputMaybe<Scalars['String']['input']>;
  enterpriseProductId?: InputMaybe<Scalars['String']['input']>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  percentDiscount?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCategoriesAndSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetPrice?: InputMaybe<Scalars['String']['input']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlBogoSavingsObj = {
  __typename?: 'BogoSavingsObj';
  displayAsPercentDiscount?: Maybe<Scalars['Boolean']['output']>;
  individual?: Maybe<Array<Maybe<GqlBogoSavings_Individual>>>;
  isDiscountToCartReward?: Maybe<Scalars['Boolean']['output']>;
  menuBogoDiscount?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type GqlBogoSavings_Individual = {
  __typename?: 'BogoSavings_Individual';
  conditionQuantity?: Maybe<Scalars['Int']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  displayAsPercentDiscount?: Maybe<Scalars['Boolean']['output']>;
  isDiscountToCartReward?: Maybe<Scalars['Boolean']['output']>;
  maxApplicable?: Maybe<Scalars['Int']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  percentDiscount?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
};

export type GqlBrand = {
  __typename?: 'Brand';
  /** @deprecated Use id */
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  aliasList: Array<Maybe<Scalars['String']['output']>>;
  brandCollisions?: Maybe<Array<GqlBrandCollision>>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  creatorUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  enterprise?: Maybe<GqlEnterprise>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isGlobal: Scalars['Boolean']['output'];
  libraryProductsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentBrand?: Maybe<GqlBrand>;
  parentBrandId?: Maybe<Scalars['ID']['output']>;
  productsCount: Scalars['Int']['output'];
  regions?: Maybe<Array<GqlRegion>>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Whether the requesting brand has accepted the consolidated Brand Agreement.
 * Scoped per-brand: once any user from a brand accepts, this reports accepted
 * for everyone else from that brand too. Deliberately excludes the acceptance
 * record's IP address/user agent, which are captured server-side for audit
 * purposes only and never exposed here.
 */
export type GqlBrandAgreementStatus = {
  __typename?: 'BrandAgreementStatus';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  acceptedAt?: Maybe<Scalars['ISODateTime']['output']>;
  acceptedByEmail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GqlBrandAppPermission = {
  __typename?: 'BrandAppPermission';
  id: Scalars['ID']['output'];
};

export type GqlBrandCampaignDailyInsight = {
  __typename?: 'BrandCampaignDailyInsight';
  clicks: Scalars['Int']['output'];
  date: Scalars['ISODateTime']['output'];
  impressions: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  spend: Scalars['Float']['output'];
};

export type GqlBrandCampaignInsight = {
  __typename?: 'BrandCampaignInsight';
  adType: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  category: Scalars['String']['output'];
  insights: Array<GqlBrandCampaignDailyInsight>;
  state: Scalars['String']['output'];
  subbrand?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandCampaignInsightsFilterInput = {
  dataSource?: InputMaybe<AdDataSource>;
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  startDate?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlBrandCatalogConnectionMetrics = {
  __typename?: 'BrandCatalogConnectionMetrics';
  gmv: Scalars['Float']['output'];
  gmvCoverage?: Maybe<Scalars['Float']['output']>;
  productCount: Scalars['Int']['output'];
  productCoverage?: Maybe<Scalars['Float']['output']>;
};

export type GqlBrandCatalogContacts = {
  __typename?: 'BrandCatalogContacts';
  catalogOwner?: Maybe<GqlBrandCatalogOwner>;
  retailerContact?: Maybe<GqlBrandCatalogRetailerContact>;
};

export type GqlBrandCatalogContentHealth = {
  __typename?: 'BrandCatalogContentHealth';
  brandDefined: GqlBrandCatalogContentMetrics;
  pendingRetailerAdoption: GqlBrandCatalogContentMetrics;
  retailerEdited: GqlBrandCatalogContentMetrics;
  totalConnectedProductCount: Scalars['Int']['output'];
};

export type GqlBrandCatalogContentMetrics = {
  __typename?: 'BrandCatalogContentMetrics';
  gmv?: Maybe<Scalars['Float']['output']>;
  gmvCoverage?: Maybe<Scalars['Float']['output']>;
  productCount: Scalars['Int']['output'];
  productCoverage?: Maybe<Scalars['Float']['output']>;
};

export enum BrandCatalogGroupConnectionStatus {
  connected = 'CONNECTED',
  notConnected = 'NOT_CONNECTED',
  partiallyConnected = 'PARTIALLY_CONNECTED'
}

export type GqlBrandCatalogHealth = {
  __typename?: 'BrandCatalogHealth';
  activeCatalogProductCount: Scalars['Int']['output'];
  contacts?: Maybe<GqlBrandCatalogContacts>;
  content?: Maybe<GqlBrandCatalogContentHealth>;
  groupBy: BrandCatalogHealthGroupBy;
  participation: GqlBrandCatalogParticipation;
  productUniverse: BrandCatalogProductUniverse;
  verification?: Maybe<GqlBrandCatalogVerification>;
  window: GqlBrandCatalogHealthWindow;
};

export enum BrandCatalogHealthGroupBy {
  location = 'LOCATION',
  lsp = 'LSP'
}

export type GqlBrandCatalogHealthWindow = {
  __typename?: 'BrandCatalogHealthWindow';
  completedDays: Scalars['Int']['output'];
  endDate: Scalars['ISODate']['output'];
  startDate: Scalars['ISODate']['output'];
};

export type GqlBrandCatalogOwner = {
  __typename?: 'BrandCatalogOwner';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  receivesVerificationReminders: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandCatalogParticipation = {
  __typename?: 'BrandCatalogParticipation';
  connected: GqlBrandCatalogConnectionMetrics;
  groups: Array<GqlBrandCatalogParticipationGroup>;
  notConnected: GqlBrandCatalogConnectionMetrics;
  totalGmv: Scalars['Float']['output'];
  totalProductCount: Scalars['Int']['output'];
};

export type GqlBrandCatalogParticipationGroup = {
  __typename?: 'BrandCatalogParticipationGroup';
  connected: GqlBrandCatalogConnectionMetrics;
  connectionStatus?: Maybe<BrandCatalogGroupConnectionStatus>;
  id: Scalars['ID']['output'];
  locationCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notConnected: GqlBrandCatalogConnectionMetrics;
  totalGmv: Scalars['Float']['output'];
  totalProductCount: Scalars['Int']['output'];
};

export type GqlBrandCatalogPerson = {
  __typename?: 'BrandCatalogPerson';
  displayName: Scalars['String']['output'];
};

export enum BrandCatalogProductUniverse {
  soldAndBrandMatched = 'SOLD_AND_BRAND_MATCHED'
}

export type GqlBrandCatalogRetailerContact = {
  __typename?: 'BrandCatalogRetailerContact';
  email: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandCatalogVerification = {
  __typename?: 'BrandCatalogVerification';
  attestedProductCount: Scalars['Int']['output'];
  confirmedAt?: Maybe<Scalars['ISODate']['output']>;
  confirmedBy?: Maybe<GqlBrandCatalogPerson>;
  linksRemainAfterLapse: Scalars['Boolean']['output'];
  reminderStartDay?: Maybe<Scalars['Int']['output']>;
  reminderStartsAt?: Maybe<Scalars['ISODate']['output']>;
  status: BrandCatalogVerificationStatus;
  validThrough?: Maybe<Scalars['ISODate']['output']>;
};

export enum BrandCatalogVerificationStatus {
  expired = 'EXPIRED',
  expiring = 'EXPIRING',
  unverified = 'UNVERIFIED',
  verified = 'VERIFIED'
}

export type GqlBrandCategory = {
  __typename?: 'BrandCategory';
  details: GqlBrandCategoryDetails;
  insights: GqlBrandInventoryInsights;
};

export type GqlBrandCategoryDetails = {
  __typename?: 'BrandCategoryDetails';
  ecomCategory: Scalars['String']['output'];
};

export type GqlBrandCategoryInsightsSummary = {
  __typename?: 'BrandCategoryInsightsSummary';
  categories: Array<GqlBrandCategory>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandCollision = {
  __typename?: 'BrandCollision';
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  firstBrand: GqlBrand;
  id: Scalars['ID']['output'];
  isAllowed: Scalars['Boolean']['output'];
  secondBrand: GqlBrand;
};

export type GqlBrandCollisionList = {
  __typename?: 'BrandCollisionList';
  brandCollisions: Array<GqlBrandCollision>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandEnterpriseSetting = {
  __typename?: 'BrandEnterpriseSetting';
  adsEnabled: Scalars['Boolean']['output'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['String']['output'];
  enterprise: GqlEnterprise;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlBrandEnterpriseSettingList = {
  __typename?: 'BrandEnterpriseSettingList';
  meta?: Maybe<GqlBrandEnterpriseSettingsMeta>;
  settings?: Maybe<Array<GqlBrandEnterpriseSetting>>;
};

export type GqlBrandEnterpriseSettingsMeta = {
  __typename?: 'BrandEnterpriseSettingsMeta';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlBrandExportsFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BrandExportsStatusEnum>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandExportsResponse = {
  __typename?: 'BrandExportsResponse';
  exports: Array<GqlFilteredCatalogExport>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandExportsSortByEnum {
  completedAt = 'completedAt',
  filename = 'filename',
  name = 'name',
  processedCount = 'processedCount',
  status = 'status',
  userName = 'user_name'
}

export type GqlBrandExportsSortInput = {
  sortBy?: InputMaybe<BrandExportsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum BrandExportsStatusEnum {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'in_progress',
  pending = 'pending'
}

export type GqlBrandFundedDiscount = {
  __typename?: 'BrandFundedDiscount';
  applicationMethod?: Maybe<BrandFundedDiscountApplicationMethod>;
  approvedAt?: Maybe<Scalars['ISODateTime']['output']>;
  approvedByUserId?: Maybe<Scalars['ID']['output']>;
  availableOnline?: Maybe<Scalars['Boolean']['output']>;
  brandFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  brandFilters?: Maybe<Array<Scalars['String']['output']>>;
  brandId: Scalars['ID']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  brandNotes?: Maybe<Scalars['String']['output']>;
  categoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  categoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  code?: Maybe<Scalars['String']['output']>;
  constraints?: Maybe<Array<GqlBrandFundedDiscountConstraint>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdByParty?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  creditsCents?: Maybe<Scalars['Int']['output']>;
  customerGroups?: Maybe<Array<Scalars['String']['output']>>;
  customerSegments?: Maybe<Array<Scalars['String']['output']>>;
  customerTypes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  discountMethod: BrandFundedDiscountDiscountMethod;
  discountValue?: Maybe<Scalars['Int']['output']>;
  distributionDetails?: Maybe<Scalars['JSON']['output']>;
  distributionMethod: BrandFundedDiscountDistributionMethod;
  dposLocationGlobalIds?: Maybe<Array<Scalars['String']['output']>>;
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposLspId: Scalars['Int']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
  effectiveFundingMethodAmountCents?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  fundingAllocationPercent: Scalars['Int']['output'];
  fundingLimitCents?: Maybe<Scalars['Int']['output']>;
  fundingMethod?: Maybe<BrandFundedDiscountFundingMethod>;
  fundingMethodAmountCents?: Maybe<Scalars['Int']['output']>;
  fundingMethodPercent?: Maybe<Scalars['Int']['output']>;
  fundingProgressPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  libraryProductIdExclusions?: Maybe<Array<Scalars['String']['output']>>;
  libraryProductIds?: Maybe<Array<Scalars['String']['output']>>;
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  maximumUsesPerCustomer?: Maybe<Scalars['Int']['output']>;
  maximumUsesTotal?: Maybe<Scalars['Int']['output']>;
  minimumOrderAmountCents?: Maybe<Scalars['Int']['output']>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  onlineName?: Maybe<Scalars['String']['output']>;
  posCategories?: Maybe<Array<GqlBfdPosCategory>>;
  posFilterCriteria?: Maybe<Array<GqlBfdPosFilterCriterion>>;
  posProducts?: Maybe<Array<GqlBfdPosProduct>>;
  promoName: Scalars['String']['output'];
  reportUrl?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['ISODateTime']['output']>;
  retailerNotes?: Maybe<Scalars['String']['output']>;
  rewardApplicationType?: Maybe<BrandFundedDiscountRewardApplicationType>;
  rewardApplyTo?: Maybe<BrandFundedDiscountRewardApplyTo>;
  rewardCartContains?: Maybe<BrandFundedDiscountRewardCartContains>;
  rewardConditionType?: Maybe<BrandFundedDiscountRewardConditionType>;
  rewardConditionValueMax?: Maybe<Scalars['Int']['output']>;
  rewardConditionValueMin?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<GqlSchedule>;
  startDate: Scalars['ISODateTime']['output'];
  status: BrandFundedDiscountStatus;
  statusLastModifiedAt?: Maybe<Scalars['ISODateTime']['output']>;
  subcategoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  subcategoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  totalFundedAmountCents?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export enum BrandFundedDiscountApplicationMethod {
  automatic = 'automatic',
  code = 'code',
  manual = 'manual'
}

export type GqlBrandFundedDiscountConstraint = {
  __typename?: 'BrandFundedDiscountConstraint';
  brandFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  brandFilters?: Maybe<Array<Scalars['String']['output']>>;
  cartContains?: Maybe<BrandFundedDiscountConstraintCartContains>;
  categoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  categoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  conditionType?: Maybe<BrandFundedDiscountConstraintConditionType>;
  conditionValueMax?: Maybe<Scalars['Int']['output']>;
  conditionValueMin?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  includeNonCannabisItems?: Maybe<Scalars['Boolean']['output']>;
  libraryProductIdExclusions?: Maybe<Array<Scalars['String']['output']>>;
  libraryProductIds?: Maybe<Array<Scalars['String']['output']>>;
  requireSameProduct?: Maybe<Scalars['Boolean']['output']>;
  subcategoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  subcategoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export enum BrandFundedDiscountConstraintCartContains {
  atLeast = 'at_least',
  between = 'between',
  every = 'every',
  exactly = 'exactly'
}

export enum BrandFundedDiscountConstraintConditionType {
  totalItems = 'total_items',
  totalSpend = 'total_spend',
  totalWeight = 'total_weight'
}

export type GqlBrandFundedDiscountConstraintInput = {
  brandFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  brandFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  cartContains?: InputMaybe<BrandFundedDiscountConstraintCartContains>;
  categoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  conditionType?: InputMaybe<BrandFundedDiscountConstraintConditionType>;
  conditionValueMax?: InputMaybe<Scalars['Int']['input']>;
  conditionValueMin?: InputMaybe<Scalars['Int']['input']>;
  includeNonCannabisItems?: InputMaybe<Scalars['Boolean']['input']>;
  libraryProductIdExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requireSameProduct?: InputMaybe<Scalars['Boolean']['input']>;
  subcategoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  subcategoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlBrandFundedDiscountContactInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
};

export enum BrandFundedDiscountDiscountMethod {
  amountOff = 'amount_off',
  percentOff = 'percent_off',
  priceToAmountEachItem = 'price_to_amount_each_item',
  priceToAmountTotalAmount = 'price_to_amount_total_amount'
}

export enum BrandFundedDiscountDistributionMethod {
  equalAllocation = 'equal_allocation',
  manualAllocation = 'manual_allocation',
  orderBasedAllocation = 'order_based_allocation'
}

export type GqlBrandFundedDiscountFiltersInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByParty?: InputMaybe<Scalars['String']['input']>;
  discountCampaignId?: InputMaybe<Scalars['ID']['input']>;
  hasCredits?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoCredits?: InputMaybe<Scalars['Boolean']['input']>;
  lspGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<BrandFundedDiscountStatus>>;
};

export enum BrandFundedDiscountFundingMethod {
  dollarsPerApplication = 'dollars_per_application',
  prepaid = 'prepaid',
  registerDiscount = 'register_discount',
  straightPayAgreement = 'straight_pay_agreement',
  wholesaleCost = 'wholesale_cost'
}

export type GqlBrandFundedDiscountImageUpload = {
  __typename?: 'BrandFundedDiscountImageUpload';
  imageUrl: Scalars['String']['output'];
};

export type GqlBrandFundedDiscountImageUploadInput = {
  base64: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type GqlBrandFundedDiscountInput = {
  brandId: Scalars['String']['input'];
  contact?: InputMaybe<GqlBrandFundedDiscountContactInput>;
  discount: GqlDiscountConfigInput;
  dposLocationGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId: Scalars['Int']['input'];
  dposLspName: Scalars['String']['input'];
  dposServerRegion: Scalars['String']['input'];
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlBrandFundedDiscountList = {
  __typename?: 'BrandFundedDiscountList';
  data: Array<GqlBrandFundedDiscountSummary>;
  meta: GqlBrandFundedDiscountMeta;
};

export type GqlBrandFundedDiscountMeta = {
  __typename?: 'BrandFundedDiscountMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlBrandFundedDiscountQualifiedProduct = {
  __typename?: 'BrandFundedDiscountQualifiedProduct';
  brandId: Scalars['String']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandFundedDiscountQualifiedProductList = {
  __typename?: 'BrandFundedDiscountQualifiedProductList';
  data: Array<GqlBrandFundedDiscountQualifiedProduct>;
  meta: GqlBrandFundedDiscountQualifiedProductMeta;
};

export type GqlBrandFundedDiscountQualifiedProductMeta = {
  __typename?: 'BrandFundedDiscountQualifiedProductMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlBrandFundedDiscountQualifiedProductsFiltersInput = {
  excludedBrands?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedSubcategories?: InputMaybe<Array<Scalars['String']['input']>>;
  includedBrands?: InputMaybe<Array<Scalars['String']['input']>>;
  includedCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  includedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  includedSubcategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BrandFundedDiscountQualifiedProductsSortBy {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt'
}

export type GqlBrandFundedDiscountQualifiedProductsSortInput = {
  sortBy?: InputMaybe<BrandFundedDiscountQualifiedProductsSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandFundedDiscountReportDownload = {
  __typename?: 'BrandFundedDiscountReportDownload';
  url: Scalars['String']['output'];
};

export enum BrandFundedDiscountRewardApplicationType {
  differentProducts = 'different_products',
  highestPricedFromRequirements = 'highest_priced_from_requirements',
  lowestPricedFromRequirements = 'lowest_priced_from_requirements',
  sameProducts = 'same_products'
}

export enum BrandFundedDiscountRewardApplyTo {
  allItems = 'all_items',
  highestPrice = 'highest_price',
  lowestPrice = 'lowest_price'
}

export enum BrandFundedDiscountRewardCartContains {
  atLeast = 'at_least',
  between = 'between',
  every = 'every',
  exactly = 'exactly'
}

export enum BrandFundedDiscountRewardConditionType {
  totalItems = 'total_items',
  totalSpend = 'total_spend',
  totalWeight = 'total_weight'
}

export type GqlBrandFundedDiscountScheduleInput = {
  timeRanges: Array<GqlTimeRangeInput>;
};

export enum BrandFundedDiscountSortBy {
  createdAt = 'createdAt',
  endDate = 'endDate',
  promoName = 'promoName',
  startDate = 'startDate',
  status = 'status'
}

export type GqlBrandFundedDiscountSortInput = {
  sortBy?: InputMaybe<BrandFundedDiscountSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum BrandFundedDiscountStatus {
  active = 'active',
  approved = 'approved',
  cancelled = 'cancelled',
  cancelledInProgress = 'cancelled_in_progress',
  completed = 'completed',
  draft = 'draft',
  paused = 'paused',
  pendingApproval = 'pending_approval',
  rejected = 'rejected'
}

export type GqlBrandFundedDiscountSummary = {
  __typename?: 'BrandFundedDiscountSummary';
  applicationMethod?: Maybe<BrandFundedDiscountApplicationMethod>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdByParty?: Maybe<Scalars['String']['output']>;
  creditsCents?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  fundingLimitCents?: Maybe<Scalars['Int']['output']>;
  fundingMethod?: Maybe<BrandFundedDiscountFundingMethod>;
  id: Scalars['ID']['output'];
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  lspName: Scalars['String']['output'];
  promoName: Scalars['String']['output'];
  responseDate?: Maybe<Scalars['ISODateTime']['output']>;
  retailerNotes?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['ISODateTime']['output'];
  status: BrandFundedDiscountStatus;
};

export type GqlBrandFundedDiscountUpdateInput = {
  expectedLastModifiedAt: Scalars['ISODateTime']['input'];
  status: BrandFundedDiscountStatus;
};

export type GqlBrandImportHistory = {
  __typename?: 'BrandImportHistory';
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importLevelError?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryDetail = {
  __typename?: 'BrandImportHistoryDetail';
  brandId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  importLevelError?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<GqlBrandImportHistoryDetailRow>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryDetailFilterInput = {
  status?: InputMaybe<Array<BrandImportHistoryDetailStatusEnum>>;
};

export type GqlBrandImportHistoryDetailResponse = {
  __typename?: 'BrandImportHistoryDetailResponse';
  data: GqlBrandImportHistoryDetail;
  meta?: Maybe<GqlMeta>;
};

export type GqlBrandImportHistoryDetailRow = {
  __typename?: 'BrandImportHistoryDetailRow';
  attributes: GqlBrandImportHistoryDetailRowAttributes;
};

export type GqlBrandImportHistoryDetailRowAttributes = {
  __typename?: 'BrandImportHistoryDetailRowAttributes';
  columnValues?: Maybe<Scalars['JSONObject']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  csvRowNumber: Scalars['Int']['output'];
  importErrors?: Maybe<Array<GqlBrandImportHistoryDetailRowImportError>>;
  libraryProductImportId: Scalars['ID']['output'];
  status?: Maybe<BrandImportHistoryDetailStatusEnum>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlBrandImportHistoryDetailRowImportError = {
  __typename?: 'BrandImportHistoryDetailRowImportError';
  columnName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export enum BrandImportHistoryDetailStatusEnum {
  failed = 'failed',
  imagesProcessed = 'images_processed',
  pending = 'pending',
  success = 'success'
}

export type GqlBrandImportHistoryFailedRowsExport = {
  __typename?: 'BrandImportHistoryFailedRowsExport';
  failedRowsCsvUrl: Scalars['String']['output'];
};

export type GqlBrandImportHistoryFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BrandImportStatusEnum>>;
};

export type GqlBrandImportHistoryResponse = {
  __typename?: 'BrandImportHistoryResponse';
  histories?: Maybe<Array<Maybe<GqlBrandImportHistory>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandImportHistorySortByEnum {
  createdAt = 'createdAt',
  failureCount = 'failureCount',
  name = 'name',
  status = 'status',
  successCount = 'successCount',
  userName = 'user_name'
}

export type GqlBrandImportHistorySortInput = {
  sortBy?: InputMaybe<BrandImportHistorySortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandImportHistoryUploadResponse = {
  __typename?: 'BrandImportHistoryUploadResponse';
  brandId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importLevelError?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<GqlBrandImportHistoryDetailRow>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryUser = {
  __typename?: 'BrandImportHistoryUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum BrandImportStatusEnum {
  allRowsFailed = 'all_rows_failed',
  failed = 'failed',
  imported = 'imported',
  inProgress = 'in_progress',
  partiallyImported = 'partially_imported',
  pending = 'pending'
}

export type GqlBrandInventoryInsights = {
  __typename?: 'BrandInventoryInsights';
  atRiskUnits?: Maybe<Scalars['Float']['output']>;
  avgDiscountPct?: Maybe<Scalars['Float']['output']>;
  avgGrossPrice?: Maybe<Scalars['Float']['output']>;
  avgNetPrice?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use unitsPerDay28d (28-day basis). */
  avgSalesPerDay30d?: Maybe<Scalars['Float']['output']>;
  backstockUnits?: Maybe<Scalars['Float']['output']>;
  daysOnHand?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use sellableDays28d. */
  daysOnMenu30d?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Removed in Round 1; the 30-day value was unreliable. */
  daysSold30d?: Maybe<Scalars['Float']['output']>;
  excessInventoryValue?: Maybe<InventoryOpportunityEnum>;
  gmvOpportunity?: Maybe<InventoryOpportunityEnum>;
  gmvPerWeek?: Maybe<Scalars['Float']['output']>;
  inStockPct?: Maybe<Scalars['Float']['output']>;
  lastRestockDate?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  netSales28d?: Maybe<Scalars['Float']['output']>;
  onFloorUnits?: Maybe<Scalars['Float']['output']>;
  rawDiscountAmount?: Maybe<Scalars['Float']['output']>;
  rawExcessInventoryValue?: Maybe<Scalars['Float']['output']>;
  rawGmvOpportunity?: Maybe<Scalars['Float']['output']>;
  rawGrossSales?: Maybe<Scalars['Float']['output']>;
  sellThroughRate?: Maybe<Scalars['Float']['output']>;
  sellableDays28d?: Maybe<Scalars['Int']['output']>;
  status: InventoryStatusEnum;
  unitsPerDay28d?: Maybe<Scalars['Float']['output']>;
  unitsRemaining?: Maybe<Scalars['Int']['output']>;
  weekOverWeekRevChange?: Maybe<Scalars['Float']['output']>;
};

export type GqlBrandKeyMetric = {
  __typename?: 'BrandKeyMetric';
  changePct: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type GqlBrandKeyMetrics = {
  __typename?: 'BrandKeyMetrics';
  avgUnitPrice: GqlBrandKeyMetric;
  gmv: GqlBrandKeyMetric;
  unitsSold: GqlBrandKeyMetric;
};

export type GqlBrandList = {
  __typename?: 'BrandList';
  brands: Array<Maybe<GqlBrand>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandLocation = {
  __typename?: 'BrandLocation';
  details: GqlBrandLocationDetails;
  insights: GqlBrandRetailerInsights;
  settings: GqlBrandRetailerSettings;
};

export type GqlBrandLocationDetails = {
  __typename?: 'BrandLocationDetails';
  dposLocationGlobalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use dposLocationGlobalId. */
  dposLocationId?: Maybe<Scalars['ID']['output']>;
  dposLocationName: Scalars['String']['output'];
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use dposLspGlobalId. */
  dposLspId?: Maybe<Scalars['ID']['output']>;
  dposLspName: Scalars['String']['output'];
  /** @deprecated Use dposLocationGlobalId. */
  dposServerRegion?: Maybe<Scalars['String']['output']>;
  isoRegionCode: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  subdivision: Scalars['String']['output'];
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandLocationsInsightsSummary = {
  __typename?: 'BrandLocationsInsightsSummary';
  locations: Array<GqlBrandLocation>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandLsp = {
  __typename?: 'BrandLsp';
  details: GqlBrandLspDetails;
  insights: GqlBrandRetailerInsights;
  settings: GqlBrandRetailerSettings;
};

export type GqlBrandLspDetails = {
  __typename?: 'BrandLspDetails';
  brandLspDisplayName?: Maybe<Scalars['String']['output']>;
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use dposLspGlobalId. */
  dposLspId?: Maybe<Scalars['ID']['output']>;
  dposLspName: Scalars['String']['output'];
  /** @deprecated Use dposLspGlobalId. */
  dposServerRegion?: Maybe<Scalars['String']['output']>;
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandLspsInsightsSummary = {
  __typename?: 'BrandLspsInsightsSummary';
  lsps: Array<GqlBrandLsp>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandMarketState = {
  __typename?: 'BrandMarketState';
  metrics: GqlBrandMarketStateMetrics;
  state: GqlBrandMarketStateDetails;
};

export type GqlBrandMarketStateDetails = {
  __typename?: 'BrandMarketStateDetails';
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  subdivision: Scalars['String']['output'];
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandMarketStateMetrics = {
  __typename?: 'BrandMarketStateMetrics';
  accountCount: Scalars['Int']['output'];
  avgGrossPrice?: Maybe<Scalars['Float']['output']>;
  avgNetPrice?: Maybe<Scalars['Float']['output']>;
  doorCount: Scalars['Int']['output'];
  eligibleLocations?: Maybe<Scalars['Int']['output']>;
  marketPenetration?: Maybe<Scalars['Float']['output']>;
  netSales: Scalars['Float']['output'];
  unitsSold: Scalars['Float']['output'];
};

export type GqlBrandMarketsFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum BrandMarketsOverviewSortByEnum {
  accountCount = 'accountCount',
  avgGrossPrice = 'avgGrossPrice',
  avgNetPrice = 'avgNetPrice',
  doorCount = 'doorCount',
  marketPenetration = 'marketPenetration',
  netSales = 'netSales',
  state = 'state',
  unitsSold = 'unitsSold'
}

export type GqlBrandMarketsOverviewSortInput = {
  sortBy?: InputMaybe<BrandMarketsOverviewSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandMarketsOverviewSummary = {
  __typename?: 'BrandMarketsOverviewSummary';
  meta?: Maybe<GqlQueryInfoType>;
  states: Array<GqlBrandMarketState>;
};

export type GqlBrandMenuInvitation = {
  __typename?: 'BrandMenuInvitation';
  createdAt: Scalars['ISODateTime']['output'];
  createdBy: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['ISODateTime']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['ISODateTime']['output']>;
  revokedAt?: Maybe<Scalars['ISODateTime']['output']>;
  secretFingerprint: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlBrandMenuInvitationConnection = {
  __typename?: 'BrandMenuInvitationConnection';
  invitations: Array<GqlBrandMenuInvitation>;
  meta: GqlBrandMenuInvitationListMeta;
};

export type GqlBrandMenuInvitationExpirationInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  type: Scalars['String']['input'];
};

export type GqlBrandMenuInvitationListMeta = {
  __typename?: 'BrandMenuInvitationListMeta';
  totalCount: Scalars['Int']['output'];
};

export enum BrandMergeHistoriesSortByEnum {
  createdAt = 'createdAt',
  revertedAt = 'revertedAt'
}

export type GqlBrandMergeHistory = {
  __typename?: 'BrandMergeHistory';
  createdAt: Scalars['ISODateTime']['output'];
  destinationBrand: GqlBrand;
  destinationBrandId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  revertedAt?: Maybe<Scalars['ISODateTime']['output']>;
  sourceBrand: GqlBrand;
  sourceBrandId: Scalars['ID']['output'];
  user?: Maybe<GqlUsers>;
  userId: Scalars['ID']['output'];
};

export type GqlBrandMergeHistoryList = {
  __typename?: 'BrandMergeHistoryList';
  brandMergeHistories: Array<GqlBrandMergeHistory>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandOverviewLsp = {
  __typename?: 'BrandOverviewLsp';
  details: GqlBrandOverviewLspDetails;
  locationCount: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  settings: GqlBrandOverviewLspSettings;
};

export type GqlBrandOverviewLspDetails = {
  __typename?: 'BrandOverviewLspDetails';
  brandLspDisplayName?: Maybe<Scalars['String']['output']>;
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposLspId: Scalars['String']['output'];
  dposLspImageUrl?: Maybe<Scalars['String']['output']>;
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlBrandOverviewLspSettings = {
  __typename?: 'BrandOverviewLspSettings';
  optInStatus: Scalars['Boolean']['output'];
};

export type GqlBrandOverviewLspsFilterInput = {
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  optInStatus?: InputMaybe<Scalars['Boolean']['input']>;
  sandboxUse?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandOverviewLspsSummary = {
  __typename?: 'BrandOverviewLspsSummary';
  lsps: Array<GqlBrandOverviewLsp>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandPoke = {
  __typename?: 'BrandPoke';
  brandId: Scalars['ID']['output'];
  brandName: Scalars['String']['output'];
  createdAt: Scalars['ISODateTime']['output'];
  lspGlobalId: Scalars['String']['output'];
  status: PokeStatus;
};

export type GqlBrandPortalClaimDismissResponse = {
  __typename?: 'BrandPortalClaimDismissResponse';
  claimedCount?: Maybe<Scalars['Int']['output']>;
  dismissedCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlBrandPortalDefaultContact = {
  __typename?: 'BrandPortalDefaultContact';
  brandId: Scalars['ID']['output'];
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['ISODateTime']['output'];
  feature: BrandPortalDefaultContactFeature;
  id: Scalars['ID']['output'];
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export enum BrandPortalDefaultContactFeature {
  brandFundedDiscounts = 'brand_funded_discounts',
  catalog = 'catalog',
  purchaseOrders = 'purchase_orders'
}

export type GqlBrandPortalNotificationSetting = {
  __typename?: 'BrandPortalNotificationSetting';
  emailEnabled: Scalars['Boolean']['output'];
  eventName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inAppEnabled: Scalars['Boolean']['output'];
};

export type GqlBrandPortalNotificationSettingInput = {
  emailEnabled: Scalars['Boolean']['input'];
  inAppEnabled: Scalars['Boolean']['input'];
  notificationEventId: Scalars['ID']['input'];
};

export type GqlBrandPortalPotencyContent = {
  __typename?: 'BrandPortalPotencyContent';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum BrandPortalProductSearchApprovalStatusFilterEnum {
  approved = 'approved',
  draft = 'draft',
  inReview = 'in_review',
  pending = 'pending',
  rejected = 'rejected'
}

export type GqlBrandPortalProductSearchResponse = {
  __typename?: 'BrandPortalProductSearchResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlBrandPortalProductSearchResult>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandPortalProductSearchResult = {
  __typename?: 'BrandPortalProductSearchResult';
  approvalStatus?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  complianceRegionId: Scalars['ID']['output'];
  createdAt: Scalars['ISODateTime']['output'];
  id: Scalars['ID']['output'];
  menuScore?: Maybe<Scalars['Float']['output']>;
  modelName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum BrandPortalProductSearchSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export type GqlBrandPortalUnclaimedProduct = {
  __typename?: 'BrandPortalUnclaimedProduct';
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlBrandPortalPotencyContent>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  menuScore?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  strainType?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlBrandPortalPotencyContent>;
};

export type GqlBrandPortalUnclaimedProductFilters = {
  category?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandPortalUnclaimedProductsResponse = {
  __typename?: 'BrandPortalUnclaimedProductsResponse';
  meta?: Maybe<GqlQueryInfoType>;
  unclaimedProducts?: Maybe<Array<Maybe<GqlBrandPortalUnclaimedProduct>>>;
};

export type GqlBrandPortalUserNotification = {
  __typename?: 'BrandPortalUserNotification';
  brandId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type GqlBrandProduct = {
  __typename?: 'BrandProduct';
  details: GqlBrandProductDetails;
  insights: GqlBrandInventoryInsights;
};

export type GqlBrandProductDetails = {
  __typename?: 'BrandProductDetails';
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  strainType?: Maybe<Scalars['String']['output']>;
  subBrand?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandProductInsightsSummary = {
  __typename?: 'BrandProductInsightsSummary';
  meta?: Maybe<GqlQueryInfoType>;
  products: Array<GqlBrandProduct>;
};

export type GqlBrandRetailerInsights = {
  __typename?: 'BrandRetailerInsights';
  categoryLowStockAlerts: Scalars['Int']['output'];
  categoryOutOfStockAlerts: Scalars['Int']['output'];
  excessInventoryValue?: Maybe<InventoryOpportunityEnum>;
  expiringStockAlerts: Scalars['Int']['output'];
  gmvOpportunity: InventoryOpportunityEnum;
  lowStockAlerts: Scalars['Int']['output'];
  netSales?: Maybe<InventoryOpportunityEnum>;
  outOfStockAlerts: Scalars['Int']['output'];
  overStockAlerts: Scalars['Int']['output'];
  rawExcessInventoryValue?: Maybe<Scalars['Float']['output']>;
  rawGmvOpportunity?: Maybe<Scalars['Float']['output']>;
  rawNetSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlBrandRetailerSettings = {
  __typename?: 'BrandRetailerSettings';
  optInStatus: Scalars['Boolean']['output'];
  pokeStatus?: Maybe<PokeStatus>;
};

export type GqlBrandSalesTrendSummary = {
  __typename?: 'BrandSalesTrendSummary';
  meta?: Maybe<GqlQueryInfoType>;
  weeks: Array<GqlBrandSalesTrendWeek>;
};

export type GqlBrandSalesTrendWeek = {
  __typename?: 'BrandSalesTrendWeek';
  metrics: GqlBrandSalesTrendWeekMetrics;
  weekStartDate: Scalars['ISODate']['output'];
};

export type GqlBrandSalesTrendWeekMetrics = {
  __typename?: 'BrandSalesTrendWeekMetrics';
  netSales?: Maybe<Scalars['Float']['output']>;
  promoDepth?: Maybe<Scalars['Float']['output']>;
};

export enum BrandSortByEnum {
  description = 'description',
  dispensary = 'dispensary',
  imageUrl = 'imageUrl',
  name = 'name',
  productsCount = 'productsCount',
  score = 'score',
  updatedAt = 'updatedAt'
}

export type GqlBrandSummary = {
  __typename?: 'BrandSummary';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  centsChange?: Maybe<Scalars['Float']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  numProducts?: Maybe<Scalars['Int']['output']>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  percentSales?: Maybe<Scalars['Float']['output']>;
  totalSalesCents?: Maybe<Scalars['Float']['output']>;
};

export type GqlBrandTag = {
  __typename?: 'BrandTag';
  addedBy?: Maybe<Scalars['String']['output']>;
  addedVia: BrandTagAddedVia;
  cannabinoidRatio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: BrandTagKind;
  strainType?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export enum BrandTagAddedVia {
  manual = 'MANUAL',
  suggestion = 'SUGGESTION'
}

export enum BrandTagKind {
  flavor = 'FLAVOR',
  productLine = 'PRODUCT_LINE',
  strainName = 'STRAIN_NAME',
  unclassified = 'UNCLASSIFIED'
}

export type GqlBrandUser = {
  __typename?: 'BrandUser';
  authorizedBrandIds: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  emails: Array<GqlUserEmails>;
  id: Scalars['ID']['output'];
  profile?: Maybe<GqlBrandUserProfile>;
};

export type GqlBrandUserAccount = {
  __typename?: 'BrandUserAccount';
  accessToken?: Maybe<Scalars['String']['output']>;
  emails: Array<GqlUserEmails>;
  id: Scalars['ID']['output'];
  profile?: Maybe<GqlBrandUserProfile>;
};

export type GqlBrandUserFocusedAccount = {
  __typename?: 'BrandUserFocusedAccount';
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use dposLspGlobalId. */
  dposLspId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use dposLspGlobalId. */
  dposServerRegion?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandUserList = {
  __typename?: 'BrandUserList';
  brandUsers: Array<GqlBrandUser>;
  meta?: Maybe<GqlMeta>;
};

export type GqlBrandUserPermissions = {
  __typename?: 'BrandUserPermissions';
  brandAppPermissions?: Maybe<Array<Scalars['String']['output']>>;
  manageAdCampaigns: Scalars['Boolean']['output'];
  manageBrandGroup: Scalars['Boolean']['output'];
  manageBrands: Scalars['Boolean']['output'];
};

export type GqlBrandUserProfile = {
  __typename?: 'BrandUserProfile';
  firstName?: Maybe<Scalars['String']['output']>;
  focusedAccounts?: Maybe<Array<GqlBrandUserFocusedAccount>>;
  lastName?: Maybe<Scalars['String']['output']>;
  parentBrand: GqlBrand;
  parentBrandId: Scalars['ID']['output'];
  permissions?: Maybe<GqlBrandUserPermissions>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum BrandUsersSortBy {
  createdAt = 'created_at'
}

export type GqlBrandsSummaryInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBucket = {
  __typename?: 'Bucket';
  checkedOutAt?: Maybe<Scalars['ISODateTime']['output']>;
  checkedOutBy?: Maybe<GqlUsers>;
  completedReviewsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  createdBy?: Maybe<GqlUsers>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: Array<Maybe<GqlProducts>>;
  productsCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlBucketProduct = {
  __typename?: 'BucketProduct';
  bucketId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  oldProductData?: Maybe<GqlOldProductData>;
  product?: Maybe<GqlProducts>;
  productId?: Maybe<Scalars['ID']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['ID']['output']>;
  reviewedByUser?: Maybe<GqlUsers>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlBucketProductsMeta = {
  __typename?: 'BucketProductsMeta';
  reviewers?: Maybe<Array<Maybe<GqlUsers>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlBucketV2 = {
  __typename?: 'BucketV2';
  checkedOutAt?: Maybe<Scalars['ISODateTime']['output']>;
  checkedOutBy?: Maybe<GqlUsers>;
  completedReviewsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  createdBy?: Maybe<GqlUsers>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productIds: Array<Maybe<Scalars['String']['output']>>;
  productsCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlBulkCreateEnterpriseUsersFailedRow = {
  __typename?: 'BulkCreateEnterpriseUsersFailedRow';
  email?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type GqlBulkCreateEnterpriseUsersResult = {
  __typename?: 'BulkCreateEnterpriseUsersResult';
  createdCount: Scalars['Int']['output'];
  failedRows: Array<GqlBulkCreateEnterpriseUsersFailedRow>;
  success: Scalars['Boolean']['output'];
};

export type GqlBulkCreateUserResult = {
  __typename?: 'BulkCreateUserResult';
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<GqlUsers>;
};

export type GqlBulkLibraryProductStatusUpdateMeta = {
  __typename?: 'BulkLibraryProductStatusUpdateMeta';
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlBulkLibraryProductStatusUpdateResponse = {
  __typename?: 'BulkLibraryProductStatusUpdateResponse';
  meta?: Maybe<GqlBulkLibraryProductStatusUpdateMeta>;
};

export type GqlBulkLibraryProductUpdateMeta = {
  __typename?: 'BulkLibraryProductUpdateMeta';
  jobId?: Maybe<Scalars['String']['output']>;
  statusPath?: Maybe<Scalars['String']['output']>;
};

export type GqlBulkLibraryProductUpdateResponse = {
  __typename?: 'BulkLibraryProductUpdateResponse';
  meta?: Maybe<GqlBulkLibraryProductUpdateMeta>;
};

export type GqlBulkLibraryProductUpdates = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBulkLibraryProductUploadError = {
  __typename?: 'BulkLibraryProductUploadError';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export enum BulkLibraryProductUploadJobStatus {
  complete = 'complete',
  error = 'error',
  pending = 'pending',
  processing = 'processing'
}

export type GqlBulkLibraryProductUploadMetadata = {
  __typename?: 'BulkLibraryProductUploadMetadata';
  errorCount?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlBulkLibraryProductUploadResponse = {
  __typename?: 'BulkLibraryProductUploadResponse';
  jobStatusId: Scalars['ID']['output'];
};

export type GqlBulkLibraryProductUploadStatusResponse = {
  __typename?: 'BulkLibraryProductUploadStatusResponse';
  errors?: Maybe<Array<GqlBulkLibraryProductUploadError>>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<GqlBulkLibraryProductUploadMetadata>;
  status: BulkLibraryProductUploadJobStatus;
  userId: Scalars['ID']['output'];
};

export type GqlBuyItAgainItem = {
  __typename?: 'BuyItAgainItem';
  originalProduct?: Maybe<GqlProducts>;
  product: GqlProducts;
  substitute?: Maybe<GqlBuyItAgainSubstitute>;
  substituteCandidates: Array<GqlProducts>;
};

export type GqlBuyItAgainProducts = {
  __typename?: 'BuyItAgainProducts';
  items: Array<GqlBuyItAgainItem>;
};

export type GqlBuyItAgainSubstitute = {
  __typename?: 'BuyItAgainSubstitute';
  originalProductId: Scalars['String']['output'];
  originalProductName: Scalars['String']['output'];
};

/** Individual Product with buying data for delivery/pickup */
export type GqlBuyingOption = {
  __typename?: 'BuyingOption';
  delivery?: Maybe<GqlDurationEstimateRange>;
  distance?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<GqlDurationEstimateRange>;
  product: GqlProducts;
};

export enum CacheControlScope {
  private = 'PRIVATE',
  public = 'PUBLIC'
}

export type GqlCalculateCheckout = {
  __typename?: 'CalculateCheckout';
  items: Array<GqlCalculateCheckoutItem>;
  priceSummary: GqlPriceSummary;
};

export type GqlCalculateCheckoutInput = {
  dispensaryId: Scalars['String']['input'];
  items: Array<GqlCalculateCheckoutInputItem>;
  orderType: ReservationSlotTypes;
  pricingType: MenuPricingTypes;
};

export type GqlCalculateCheckoutInputItem = {
  option: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GqlCalculateCheckoutItem = {
  __typename?: 'CalculateCheckoutItem';
  basePrice?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<GqlItemDiscounts>;
  errors: Array<Scalars['String']['output']>;
  isDiscounted?: Maybe<Scalars['Boolean']['output']>;
  option: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  taxes?: Maybe<GqlItemTaxes>;
  valid: Scalars['Boolean']['output'];
};

export type GqlCalculationResults = {
  __typename?: 'CalculationResults';
  cartItemPrices?: Maybe<Array<Maybe<GqlCartItem>>>;
  discount?: Maybe<Scalars['Int']['output']>;
  discountGamification?: Maybe<GqlCalculationResults_CartGamification>;
  discountWithoutLoyalty?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Array<Maybe<GqlFees>>>;
  grandTotal?: Maybe<Scalars['Int']['output']>;
  itemTaxes?: Maybe<Array<Maybe<GqlItemTax>>>;
  loyaltyAppliedAsDiscount?: Maybe<Scalars['Float']['output']>;
  loyaltyPointsUsed?: Maybe<Scalars['Int']['output']>;
  originalTotal?: Maybe<Scalars['Int']['output']>;
  posCustomerId?: Maybe<Scalars['Int']['output']>;
  resolvedZoneIds?: Maybe<Array<Scalars['Int']['output']>>;
  rewardValidationErrors?: Maybe<Array<Maybe<GqlRewardValidationError>>>;
  roundedDifference?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['Int']['output']>;
  taxInclusivePricing?: Maybe<Scalars['Boolean']['output']>;
  taxes?: Maybe<Scalars['Int']['output']>;
  totalBottleDepositTax?: Maybe<Scalars['Int']['output']>;
  totalCannabisTax?: Maybe<Scalars['Int']['output']>;
  totalSalesTax?: Maybe<Scalars['Int']['output']>;
};

export type GqlCalculationResults_CartGamification = {
  __typename?: 'CalculationResults_CartGamification';
  gamificationDetails?: Maybe<Array<Maybe<GqlGamificationDetailItem>>>;
};

export type GqlCalculationsInput = {
  cart: Array<GqlCartItemInput>;
  codeRedemptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated 3/12/25: Use ecomUserId instead */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerTypeId: Scalars['Int']['input'];
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryScheduleId?: InputMaybe<Scalars['Int']['input']>;
  deliveryState?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet2?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
  includeGamification?: InputMaybe<Scalars['Boolean']['input']>;
  isDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyPointsApplied?: InputMaybe<Scalars['Float']['input']>;
  payerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  platformType?: InputMaybe<PlatformType>;
  posCustomerId?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<PreOrderType>;
  rewardRedemptions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type GqlCampaignSummary = {
  __typename?: 'CampaignSummary';
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']['output']>;
  conversionPercentage?: Maybe<Scalars['Float']['output']>;
  conversionPercentageUnitChange?: Maybe<Scalars['Float']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type GqlCannabinoid = {
  __typename?: 'Cannabinoid';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Major type of cannabis for a product */
export enum CannabisType {
  highCbd = 'HIGH_CBD',
  hybrid = 'HYBRID',
  indica = 'INDICA',
  nA = 'N_A',
  sativa = 'SATIVA',
  seed = 'SEED'
}

export type GqlCartItem = {
  __typename?: 'CartItem';
  cartPrice?: Maybe<Scalars['Int']['output']>;
  checkoutPrice?: Maybe<Scalars['Int']['output']>;
  discounts?: Maybe<Array<Maybe<GqlDiscount>>>;
  ecommKey?: Maybe<Scalars['String']['output']>;
  /** @deprecated frozen for backward compatibility; use cartPrice */
  menuPrice?: Maybe<Scalars['Int']['output']>;
  pricingTierAdjustment?: Maybe<Scalars['Int']['output']>;
  pricingTierAdjustmentTotal?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  specialCartPrice?: Maybe<Scalars['Int']['output']>;
  specialCheckoutPrice?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  /** @deprecated frozen for backward compatibility; use checkoutPrice */
  summaryPrice?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
  unitWeightGrams?: Maybe<Scalars['Float']['output']>;
};

export type GqlCartItemInput = {
  ecommKey?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  unitWeightGrams?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlCartSummary = {
  __typename?: 'CartSummary';
  createdAt: Scalars['ISODateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<GqlAbandonedCartProduct>>;
  valueInCents: Scalars['Float']['output'];
};

export enum Categories {
  accessories = 'ACCESSORIES',
  apparel = 'APPAREL',
  cbd = 'CBD',
  clones = 'CLONES',
  concentrate = 'CONCENTRATE',
  edible = 'EDIBLE',
  flower = 'FLOWER',
  /** Pain - should really be PRE-ROLLS */
  prerolls = 'PREROLLS',
  seeds = 'SEEDS',
  tincture = 'TINCTURE',
  topicals = 'TOPICALS',
  vaporizers = 'VAPORIZERS'
}

export type GqlCategoriesInput = {
  items?: InputMaybe<Array<InputMaybe<GqlCategoryInput>>>;
  mobileDisplay?: InputMaybe<CategoriesMobileDisplayOption>;
  style?: InputMaybe<RadiusOption>;
  type?: InputMaybe<CategoriesTypeOption>;
};

export enum CategoriesMobileDisplayOption {
  grid = 'GRID',
  row = 'ROW'
}

export enum CategoriesTypeOption {
  compact = 'COMPACT',
  large = 'LARGE',
  stacked = 'STACKED',
  text = 'TEXT'
}

export type GqlCategoryInput = {
  cardDisplayName?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  isOutlet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCategoryLineItem = {
  __typename?: 'CategoryLineItem';
  categoryOption?: Maybe<Scalars['String']['output']>;
  percentOfTotal?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export enum CategoryMenuOrder {
  featuredBrands = 'featuredBrands',
  featuredProducts = 'featuredProducts',
  popular = 'popular',
  potencyHighToLow = 'potencyHighToLow',
  potencyLowToHigh = 'potencyLowToHigh',
  priceHighToLow = 'priceHighToLow',
  priceLowToHigh = 'priceLowToHigh',
  recentlyAdded = 'recentlyAdded',
  relevance = 'relevance'
}

export type GqlCategoryPhoto = {
  __typename?: 'CategoryPhoto';
  category?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
};

export type GqlCategorySubcategories = {
  __typename?: 'CategorySubcategories';
  category: Scalars['String']['output'];
  subcategories: Array<Scalars['String']['output']>;
};

export type GqlCategorySummary = {
  __typename?: 'CategorySummary';
  category?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlChain = {
  __typename?: 'Chain';
  chainId?: Maybe<Scalars['String']['output']>;
  dispensaryCount?: Maybe<Scalars['Int']['output']>;
  dispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlChainDropdownOption = {
  __typename?: 'ChainDropdownOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlChainFilterInput = {
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlChainList = {
  __typename?: 'ChainList';
  chains?: Maybe<Array<Maybe<GqlChain>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlChainPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlChainSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

/**
 * Boolean permission flags surfaced by the chain-wide user-permissions audit
 * (chainUserPermissionsReport / exportChainUserPermissions). Mirrors the subset of
 * Users_permissions relevant to an access review.
 */
export type GqlChainUserPermissionFlags = {
  __typename?: 'ChainUserPermissionFlags';
  allLocations: Scalars['Boolean']['output'];
  analytics: Scalars['Boolean']['output'];
  billing: Scalars['Boolean']['output'];
  customers: Scalars['Boolean']['output'];
  driver: Scalars['Boolean']['output'];
  enterpriseAdmin: Scalars['Boolean']['output'];
  enterpriseSpecials: Scalars['Boolean']['output'];
  menu: Scalars['Boolean']['output'];
  messaging: Scalars['Boolean']['output'];
  orders: Scalars['Boolean']['output'];
  promote: Scalars['Boolean']['output'];
  settings: Scalars['Boolean']['output'];
  users: Scalars['Boolean']['output'];
};

/**
 * A single dispensary user's row in the chain-wide user-permissions audit. locationNames is
 * always empty when hasAllLocations is true (enumerating is meaningless for an all-locations
 * grant); unknownLocationCount counts dispensaryIds on the user's grant that no longer resolve
 * to a dispensary in this chain (stale or cross-chain grants).
 */
export type GqlChainUserPermissionRow = {
  __typename?: 'ChainUserPermissionRow';
  _id: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasAllLocations: Scalars['Boolean']['output'];
  homeLocationName?: Maybe<Scalars['String']['output']>;
  locationCount: Scalars['Int']['output'];
  locationNames: Array<Scalars['String']['output']>;
  permissions: GqlChainUserPermissionFlags;
  phone?: Maybe<Scalars['String']['output']>;
  roleAtDispensary?: Maybe<Scalars['String']['output']>;
  unknownLocationCount: Scalars['Int']['output'];
};

export type GqlChainUserPermissionsExport = {
  __typename?: 'ChainUserPermissionsExport';
  csv: Scalars['String']['output'];
};

export type GqlChangeHistoryObject = {
  __typename?: 'ChangeHistoryObject';
  date?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export enum ChangeRequestActionType {
  createBrand = 'create_brand',
  createProduct = 'create_product',
  deleteProduct = 'delete_product',
  updateBrand = 'update_brand',
  updateProduct = 'update_product'
}

export enum ChannelSources {
  embedded = 'EMBEDDED',
  kiosk = 'KIOSK',
  main = 'MAIN',
  retailerMobile = 'RETAILER_MOBILE'
}

export type GqlCharity = {
  __typename?: 'Charity';
  charitableOrganizationId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  feeDonationId: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl: Scalars['String']['output'];
};

export type GqlChaseHostedProfileCredentials = GqlCheckoutCredentialsBase & {
  __typename?: 'ChaseHostedProfileCredentials';
  adapter: Scalars['String']['output'];
  uID: Scalars['String']['output'];
};

export type GqlCheckPurchaseLimitsCartItem = {
  id: Scalars['String']['input'];
  option: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GqlCheckPurchaseLimitsInput = {
  customerState: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  existingItems: Array<GqlCheckPurchaseLimitsCartItem>;
  idToAdd: Scalars['String']['input'];
  isChangingQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  isMedical?: InputMaybe<Scalars['Boolean']['input']>;
  option: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCheckPurchaseLimitsResult = {
  __typename?: 'CheckPurchaseLimitsResult';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  passesCheck: Scalars['Boolean']['output'];
};

export type GqlCheckout = {
  __typename?: 'Checkout';
  address?: Maybe<GqlCheckoutAddress>;
  dispensaryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<GqlCheckoutItem>;
  orderType: Scalars['String']['output'];
  pricingType: Scalars['String']['output'];
  viewerSecret?: Maybe<Scalars['String']['output']>;
};

export type GqlCheckoutAddress = {
  __typename?: 'CheckoutAddress';
  city?: Maybe<Scalars['String']['output']>;
  deliverable: Scalars['Boolean']['output'];
  formatted?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<GqlCheckoutAddressGeometry>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type GqlCheckoutAddressGeometry = {
  __typename?: 'CheckoutAddressGeometry';
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlCheckoutAddressInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type GqlCheckoutCredentialsBase = {
  adapter: Scalars['String']['output'];
};

export type GqlCheckoutItem = {
  __typename?: 'CheckoutItem';
  checkoutId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  option: Scalars['String']['output'];
  product?: Maybe<GqlProducts>;
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type GqlCityZoneEntry = {
  __typename?: 'CityZoneEntry';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlCityZoneEntryInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum ClaimKioskErrorCode {
  alreadyClaimed = 'ALREADY_CLAIMED',
  notFound = 'NOT_FOUND'
}

export type GqlClaimKioskResult = {
  __typename?: 'ClaimKioskResult';
  errorCode?: Maybe<ClaimKioskErrorCode>;
  kiosk?: Maybe<GqlClaimedKiosk>;
  success: Scalars['Boolean']['output'];
};

/** Intentionally narrow -- never includes the kiosk's code. */
export type GqlClaimedKiosk = {
  __typename?: 'ClaimedKiosk';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GqlCmsAdminTokenVerification = {
  __typename?: 'CmsAdminTokenVerification';
  /** The authenticated admin the presented JWT resolves to. */
  admin: GqlCmsVerifiedAdmin;
  /**
   * The enterprise the admin was verified against. Can be null if the enterprise record
   * could not be loaded (see `enterpriseLookupFailed`) - a null value here does NOT indicate
   * an authorization failure; access control is fully enforced independently of this lookup
   * (either this query returns successfully, or it throws).
   */
  enterprise?: Maybe<GqlEnterprise>;
  /**
   * True if `enterprise` is null because the lookup itself failed (e.g. a transient
   * Armageddon error), as opposed to there being no enterprise to look up. Lets CMS
   * distinguish "verified, but enterprise metadata temporarily unavailable" from any other
   * reason `enterprise` might be null.
   */
  enterpriseLookupFailed: Scalars['Boolean']['output'];
  /** Random string generated by dutchie-api for this verification handshake (64 lowercase hex characters). */
  serverNonce: Scalars['String']['output'];
  /**
   * Hex-encoded HMAC-SHA256 of `<nonce>:<serverNonce>:<admin._id>:<enterpriseId>` (colon-joined,
   * in that order), keyed with the shared secret dutchie-api and CMS both hold. Binding the
   * admin id and enterpriseId (not just the two nonces) means a matching hash also proves this
   * specific admin/enterprise pairing wasn't substituted in transit. Recompute this with the
   * client-side nonce, the returned serverNonce, `admin._id`, the `enterpriseId` you sent, and
   * the shared secret to verify the response's authenticity.
   */
  verificationHash: Scalars['String']['output'];
};

export type GqlCmsContent = {
  __typename?: 'CmsContent';
  data?: Maybe<Scalars['JSONObject']['output']>;
  targeting?: Maybe<Array<GqlCmsSavedTargetingRule>>;
  variantId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/**
 * Result of the auto-save (in-place draft) route `PUT
 * /enterprises/:enterpriseId/websites/:websiteId/content/:modelId/:variantKey`. Mirrors
 * CmsContentVersionResult but adds `created`: false when the latest draft was overwritten in
 * place (the version list did not grow), true when a new draft was appended. `status` is always
 * `draft` here -- this route never publishes -- but reuses CmsContentVersionStatus for schema
 * parity with the publish result.
 *
 * All five fields are non-null because they are all contractually required by the CMS worker's
 * OpenAPI-documented `SaveVariantInPlaceResponse` (variantId, versionId, versionNumber, status,
 * created are all listed under `required`). Faithfully mirroring that contract here is more
 * correct than speculatively loosening nullability for fields the client happens not to read
 * today -- see the client's `.gql` selection set (autosave-cms-content-version.gql), which
 * intentionally selects only the fields it actually consumes (variantId, versionId,
 * versionNumber) so its success/failure path is decoupled from status/created regardless of this
 * type's nullability.
 */
export type GqlCmsContentAutosaveResult = {
  __typename?: 'CmsContentAutosaveResult';
  created: Scalars['Boolean']['output'];
  status: CmsContentVersionStatus;
  variantId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type GqlCmsContentVersion = {
  __typename?: 'CmsContentVersion';
  data?: Maybe<Scalars['JSONObject']['output']>;
  variantId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/** Display-safe subset of `Users` -- no email/phone/permissions. */
export type GqlCmsContentVersionAuthor = {
  __typename?: 'CmsContentVersionAuthor';
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/**
 * Response of the versioning API's `GET /enterprises/:enterpriseId/content/:modelId/:variantKey/versions`
 * history-list endpoint (paginated). Used by editor UI (e.g. the Puck
 * VersionsPlugin) to render a version timeline without fetching each
 * version's full `data` payload.
 */
export type GqlCmsContentVersionList = {
  __typename?: 'CmsContentVersionList';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  variantId: Scalars['String']['output'];
  versions: Array<GqlCmsContentVersionSummary>;
};

export type GqlCmsContentVersionResult = {
  __typename?: 'CmsContentVersionResult';
  status: CmsContentVersionStatus;
  variantId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export enum CmsContentVersionStatus {
  draft = 'draft',
  published = 'published'
}

/** Summary of a single historical version of a CMS content variant. */
export type GqlCmsContentVersionSummary = {
  __typename?: 'CmsContentVersionSummary';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * Author name for `createdBy`. Gated by @adminUserLoader, NOT bare `@loader` -- this query
   * has no auth of its own, so @loader would leak the author's name to any caller. No
   * dispensary scoping (pre-existing gap across this resolver family, not made worse here).
   */
  createdByUser?: Maybe<GqlCmsContentVersionAuthor>;
  publishNote?: Maybe<Scalars['String']['output']>;
  status: CmsContentVersionStatus;
  targeting?: Maybe<Array<GqlCmsSavedTargetingRule>>;
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/**
 * Response of `GET /enterprises/:enterpriseId/content/:modelId/:variantKey/latest`: the variant's
 * latest version regardless of publish status. Distinct from `CmsContent` (which is
 * published-only) by carrying `versionId`/`status` -- the caller needs to know both which
 * version this is and whether it's a draft, since the editor surfaces that in its own UI (e.g. the
 * Versions plugin) rather than silently treating a draft as if it were live content.
 */
export type GqlCmsLatestContent = {
  __typename?: 'CmsLatestContent';
  data?: Maybe<Scalars['JSONObject']['output']>;
  status: CmsContentVersionStatus;
  targeting?: Maybe<Array<GqlCmsSavedTargetingRule>>;
  variantId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/**
 * A single page's metadata, as returned by GET /enterprises/:enterpriseId/pages
 * (list) and GET /enterprises/:enterpriseId/pages/:variantKey (get-one). name and
 * urlPath are real columns on the worker's dedicated `pages` extension table, not
 * values parsed out of `data`.
 */
export type GqlCmsPage = {
  __typename?: 'CmsPage';
  createdAt: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishedVersionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  urlPath: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
  variantKey: Scalars['String']['output'];
};

export type GqlCmsPageList = {
  __typename?: 'CmsPageList';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  pages: Array<GqlCmsPage>;
  total: Scalars['Int']['output'];
};

export type GqlCmsResolvedContent = {
  __typename?: 'CmsResolvedContent';
  data?: Maybe<Scalars['JSONObject']['output']>;
  targeted: Scalars['Boolean']['output'];
  variantId: Scalars['String']['output'];
  variantKey: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type GqlCmsSavedTargetingRule = {
  __typename?: 'CmsSavedTargetingRule';
  conditions: Array<GqlCmsTargetingCondition>;
  isDefault: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  variantId: Scalars['String']['output'];
};

export type GqlCmsSavedTargetingRuleInput = {
  conditions: Array<GqlCmsTargetingConditionInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCmsTargetingCondition = {
  __typename?: 'CmsTargetingCondition';
  attribute: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type GqlCmsTargetingConditionInput = {
  attribute: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type GqlCmsTargetingRule = {
  __typename?: 'CmsTargetingRule';
  conditions: Array<GqlCmsTargetingCondition>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  variantId: Scalars['String']['output'];
};

export type GqlCmsTargetingRuleInput = {
  conditions: Array<GqlCmsTargetingConditionInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  variantId: Scalars['String']['input'];
};

export type GqlCmsTargetingRuleSet = {
  __typename?: 'CmsTargetingRuleSet';
  rules: Array<GqlCmsTargetingRule>;
};

export type GqlCmsVariant = {
  __typename?: 'CmsVariant';
  createdAt: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  publishedVersionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
  variantKey: Scalars['String']['output'];
};

export type GqlCmsVariantList = {
  __typename?: 'CmsVariantList';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  variants: Array<GqlCmsVariant>;
};

/**
 * Minimal, purpose-built admin identity for the CMS verification handshake. Deliberately not
 * the full `IdentityAdmin` type - only the fields CMS needs to make an editing-access
 * decision are included (no Zendesk tokens, dispensary details, etc).
 */
export type GqlCmsVerifiedAdmin = {
  __typename?: 'CmsVerifiedAdmin';
  _id: Scalars['ID']['output'];
  emails: Array<Maybe<GqlUserEmails>>;
  /** The admin's own enterprise, if scoped to one (null for super admins). */
  enterpriseId?: Maybe<Scalars['ID']['output']>;
  profile: GqlCmsVerifiedAdminProfile;
};

export type GqlCmsVerifiedAdminProfile = {
  __typename?: 'CmsVerifiedAdminProfile';
  chainID?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<GqlIdentityAdminProfilePermissions>;
  /** superAdmin | dispensaryUser | user - the primary access-level signal. */
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlCmsWebsite = {
  __typename?: 'CmsWebsite';
  cName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  enterpriseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type GqlCmsWebsiteList = {
  __typename?: 'CmsWebsiteList';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  websites: Array<GqlCmsWebsite>;
};

export type GqlCollection = {
  __typename?: 'Collection';
  allConditions: Scalars['Boolean']['output'];
  audienceConditions?: Maybe<Array<GqlAudienceCondition>>;
  cardBadgeColor?: Maybe<Scalars['String']['output']>;
  cardBadgeEnabled: Scalars['Boolean']['output'];
  cardBadgeTitle?: Maybe<Scalars['String']['output']>;
  cardDisplayName?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Array<CollectionChannel>>;
  conditions: Array<GqlCondition>;
  customCategory?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAccessibleToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isOutlet?: Maybe<Scalars['Boolean']['output']>;
  matchAllAudienceConditions?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use matchAllAudienceConditions instead */
  matchAllSegmentConditions?: Maybe<Scalars['Boolean']['output']>;
  navigationEnabled: Scalars['Boolean']['output'];
  navigationTitle?: Maybe<Scalars['String']['output']>;
  onSaleOnly?: Maybe<Scalars['Boolean']['output']>;
  outletTimerEnabled?: Maybe<Scalars['Boolean']['output']>;
  outletTimerMessage?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  productCount: Scalars['Int']['output'];
  schedule?: Maybe<GqlSchedule>;
  /** @deprecated Use audienceConditions instead */
  segmentConditions?: Maybe<Array<GqlAudienceCondition>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GqlCollectionCardBadge = {
  __typename?: 'CollectionCardBadge';
  color?: Maybe<Scalars['String']['output']>;
  isAccessibleToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum CollectionChannel {
  kiosk = 'KIOSK',
  mobile = 'MOBILE',
  web = 'WEB'
}

export type GqlCollectionPositionsInput = {
  collectionId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCollectionProductCount = {
  __typename?: 'CollectionProductCount';
  id?: Maybe<Scalars['ID']['output']>;
  productCount: Scalars['Int']['output'];
};

export enum CollisionType {
  globalToGlobal = 'globalToGlobal',
  globalToLocal = 'globalToLocal',
  localToGlobal = 'localToGlobal',
  localToLocal = 'localToLocal'
}

export type GqlColorInput = {
  buttonsLinks?: InputMaybe<Scalars['String']['input']>;
  discountTag?: InputMaybe<Scalars['String']['input']>;
  navBar?: InputMaybe<Scalars['String']['input']>;
  productCardButton?: InputMaybe<ProductCardButtonOption>;
  staffPickTag?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use strainTypes instead */
  strainTypeColors?: InputMaybe<GqlStrainTypeColorsInput>;
  strainTypes?: InputMaybe<GqlStrainTypeColorsInput>;
};

export type GqlColorSettings = {
  __typename?: 'ColorSettings';
  linkColor?: Maybe<Scalars['String']['output']>;
  navBarColor?: Maybe<Scalars['String']['output']>;
};

export type GqlColorSettingsInputV2 = {
  linkColor: LinkColor;
  navBarColor: NavBarColor;
};

export type GqlColorSettingsV2 = {
  __typename?: 'ColorSettingsV2';
  linkColor: LinkColor;
  navBarColor: NavBarColor;
};

export type GqlColors = {
  __typename?: 'Colors';
  buttonsLinks?: Maybe<Scalars['String']['output']>;
  discountTag?: Maybe<Scalars['String']['output']>;
  navBar?: Maybe<Scalars['String']['output']>;
  productCardButton?: Maybe<ProductCardButtonOption>;
  staffPickTag?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use strainTypes instead */
  strainTypeColors?: Maybe<GqlStrainTypeColors>;
  strainTypes?: Maybe<GqlStrainTypeColors>;
};

export type GqlCommunicationSettings = {
  __typename?: 'CommunicationSettings';
  optInEmail?: Maybe<Scalars['Boolean']['output']>;
  optInPush?: Maybe<Scalars['Boolean']['output']>;
  optInSMS?: Maybe<Scalars['Boolean']['output']>;
};

export enum ComparisonOperators {
  between = 'between',
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo'
}

export type GqlCompleteAggregatorLinkResponse = {
  __typename?: 'CompleteAggregatorLinkResponse';
  paymentMethods: Array<Maybe<GqlBankAccountPaymentMethod>>;
};

export type GqlConciergeCustomization = {
  __typename?: 'ConciergeCustomization';
  accentColorHex?: Maybe<Scalars['String']['output']>;
  canvasColorHex?: Maybe<Scalars['String']['output']>;
};

export type GqlConciergeInput = {
  accentColorHex?: InputMaybe<Scalars['String']['input']>;
  canvasColorHex?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCondition = {
  __typename?: 'Condition';
  condition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemKey: Scalars['String']['output'];
  itemValue: Scalars['String']['output'];
  productCollectionId: Scalars['String']['output'];
};

export enum ConditionType {
  item = 'ITEM',
  quantity = 'QUANTITY',
  spend = 'SPEND',
  weight = 'WEIGHT'
}

export type GqlConnectProductPreviewResponse = {
  __typename?: 'ConnectProductPreviewResponse';
  previewProduct: GqlPreviewProduct;
};

export enum ConnectionStatus {
  connectionStatusActive = 'CONNECTION_STATUS_ACTIVE',
  connectionStatusError = 'CONNECTION_STATUS_ERROR',
  connectionStatusPendingExpiration = 'CONNECTION_STATUS_PENDING_EXPIRATION',
  connectionStatusRevoked = 'CONNECTION_STATUS_REVOKED',
  connectionStatusUnspecified = 'CONNECTION_STATUS_UNSPECIFIED'
}

export type GqlConsumerDispensaryIntegrations = {
  __typename?: 'ConsumerDispensaryIntegrations';
  alpineiq?: Maybe<GqlDispensaries_Integrations>;
  dutchieposloyalty?: Maybe<GqlDispensaries_Integrations>;
  fyllo?: Maybe<GqlDispensaries_Integrations>;
  leaflogix?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  springbig?: Maybe<GqlDispensaries_Integrations>;
};

export type GqlConsumerProductReview = {
  __typename?: 'ConsumerProductReview';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  dispensaryId: Scalars['String']['output'];
  effects: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  posProductId?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  reviewerFirstName?: Maybe<Scalars['String']['output']>;
  reviewerLastName?: Maybe<Scalars['String']['output']>;
  status: ReviewStatus;
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlConsumerPulseAccess = {
  __typename?: 'ConsumerPulseAccess';
  eligible?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlConsumerStreamCredentials = {
  __typename?: 'ConsumerStreamCredentials';
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type GqlConsumerUser = {
  __typename?: 'ConsumerUser';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<GqlCustomers>>>;
  email?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<GqlConsumerUserProfile>;
};

export type GqlContentChangeRequestAttributes = {
  __typename?: 'ContentChangeRequestAttributes';
  brandId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlContentChangeRequestPotency>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  effects?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  menu_score?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlContentChangeRequestPotency>;
};

export type GqlContentChangeRequestComputedAttributes = {
  __typename?: 'ContentChangeRequestComputedAttributes';
  actionType?: Maybe<ChangeRequestActionType>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['ID']['output']>;
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  complianceRegionId?: Maybe<Scalars['String']['output']>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestFilters = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GqlContentChangeRequestMeta = {
  __typename?: 'ContentChangeRequestMeta';
  filters?: Maybe<GqlContentChangeRequestMetaFilters>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlContentChangeRequestMetaFilterNumber = {
  __typename?: 'ContentChangeRequestMetaFilterNumber';
  label?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlContentChangeRequestMetaFilterText = {
  __typename?: 'ContentChangeRequestMetaFilterText';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestMetaFilters = {
  __typename?: 'ContentChangeRequestMetaFilters';
  approvalStatus?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
  brand?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
  score?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterNumber>>>;
  state?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
};

export type GqlContentChangeRequestPotency = {
  __typename?: 'ContentChangeRequestPotency';
  range?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestSort = {
  sortBy: ContentChangeRequestSortByEnum;
  sortDirection: StringSortDirections;
};

export enum ContentChangeRequestSortByEnum {
  approvalStatus = 'approvalStatus',
  brandName = 'brandName',
  category = 'category',
  connectedCount = 'connectedCount',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  description = 'description',
  name = 'name',
  productName = 'productName',
  score = 'score',
  state = 'state'
}

export type GqlContentChangeRequests = {
  __typename?: 'ContentChangeRequests';
  contentChangeRequests?: Maybe<Array<Maybe<GqlSerializableContentChangeRequest>>>;
  meta?: Maybe<GqlContentChangeRequestMeta>;
};

export type GqlContentStatistics = {
  __typename?: 'ContentStatistics';
  connectedPercentage?: Maybe<Scalars['Float']['output']>;
  menuScore?: Maybe<Scalars['Float']['output']>;
};

export type GqlCopyLibraryProductErrors = {
  __typename?: 'CopyLibraryProductErrors';
  errors?: Maybe<Scalars['String']['output']>;
  state_library_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlCopyLibraryProductMeta = {
  __typename?: 'CopyLibraryProductMeta';
  errors?: Maybe<Array<Maybe<GqlCopyLibraryProductErrors>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlCopyLibraryProductResponse = {
  __typename?: 'CopyLibraryProductResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  meta?: Maybe<GqlCopyLibraryProductMeta>;
};

/** Response from copying assets to locations */
export type GqlCopyToLocationsResponse = {
  __typename?: 'CopyToLocationsResponse';
  alreadyExistsCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Locations that were not written, for example a setting that can only be copied within the same region. */
  skippedLocations?: Maybe<Array<GqlSkippedCopyLocation>>;
  specialNotFoundCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  successCount?: Maybe<Scalars['Int']['output']>;
};

/** A single chain location's comparison result for one copyable setting. */
export type GqlCopyableSettingLocation = {
  __typename?: 'CopyableSettingLocation';
  /** Whether this location may be selected as a sync target in the manage-across-locations modal. */
  canSync: Scalars['Boolean']['output'];
  comparisonStatus: SettingComparisonStatus;
  dispensaryId: Scalars['ID']['output'];
  /** Whether the setting path currently has an explicit (non-absent) value at this location. */
  isSet: Scalars['Boolean']['output'];
  /** True for the dispensary the comparison was requested from. */
  isSource: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Explanation for why the value is unavailable/redacted, when comparisonStatus is UNAVAILABLE. */
  unavailableReason?: Maybe<Scalars['String']['output']>;
  /** Canonical JSON serialization of the location's value, formatted client-side for display. Omitted when unavailable. */
  valueJson?: Maybe<Scalars['String']['output']>;
};

/** Response for copyableSettingLocations: the source-first, name-ordered comparison across a chain. */
export type GqlCopyableSettingLocationsResponse = {
  __typename?: 'CopyableSettingLocationsResponse';
  locations: Array<GqlCopyableSettingLocation>;
  settingPath: Scalars['String']['output'];
  /** The source dispensary's own comparison row (isSource: true), excluded from locations. */
  source: GqlCopyableSettingLocation;
};

export type GqlCopyableSettingsConfig = {
  __typename?: 'CopyableSettingsConfig';
  /** Exact paths (top-level or nested leaves) that are individually copyable. */
  allowedPaths: Array<Scalars['String']['output']>;
  /** Subtree roots - any dotted path at or underneath these profile keys is copyable. */
  allowedPrefixes: Array<Scalars['String']['output']>;
  /** Paths that must never be copied, even under an allowed prefix. */
  deniedPaths: Array<Scalars['String']['output']>;
  /** Keyed embedded arrays (field -> discriminator key), addressed as <field>.<keyValue>. */
  keyedArrays: Scalars['JSONObject']['output'];
  /** Path prefixes only super admins may copy. */
  superAdminOnlyPrefixes: Array<Scalars['String']['output']>;
};

export type GqlCouponList = {
  __typename?: 'CouponList';
  coupons?: Maybe<Array<Maybe<GqlCoupons>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlCouponSummary = {
  __typename?: 'CouponSummary';
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']['output']>;
  averageUsageChangePercentage?: Maybe<Scalars['Float']['output']>;
  couponId?: Maybe<Scalars['String']['output']>;
  couponName?: Maybe<Scalars['String']['output']>;
  currentUsage?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  prevTotalSales?: Maybe<Scalars['Float']['output']>;
  prevUsage?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

export type GqlCouponValidationResponse = {
  __typename?: 'CouponValidationResponse';
  coupon?: Maybe<GqlCoupons>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GqlCouponValueInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCoupon_ApplicableCategoriesInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dollar?: InputMaybe<Scalars['Float']['input']>;
  expDate?: InputMaybe<Scalars['String']['input']>;
  fixedDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlCoupons = {
  __typename?: 'Coupons';
  _id: Scalars['String']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  addedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by percentDiscount || fixedDiscountInCents */
  amount?: Maybe<Scalars['String']['output']>;
  applicableCategories?: Maybe<Array<Maybe<GqlCouponApplicableCategory>>>;
  code?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  expDate?: Maybe<Scalars['String']['output']>;
  fixedDiscountInCents?: Maybe<Scalars['Int']['output']>;
  numAllowedUses?: Maybe<Scalars['Int']['output']>;
  numUses?: Maybe<Scalars['Int']['output']>;
  oneUsePerCustomer?: Maybe<Scalars['Boolean']['output']>;
  percentDiscount?: Maybe<Scalars['Float']['output']>;
  reimbursed?: Maybe<Scalars['Boolean']['output']>;
  restrictions?: Maybe<GqlCouponRestrictions>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlCreateBankAccountResponse = {
  __typename?: 'CreateBankAccountResponse';
  bankAccount?: Maybe<GqlPaymentMethod>;
};

export type GqlCreateBrandMenuInvitationInput = {
  expiration?: InputMaybe<GqlBrandMenuInvitationExpirationInput>;
  label: Scalars['String']['input'];
};

export type GqlCreateBrandMenuInvitationMeta = {
  __typename?: 'CreateBrandMenuInvitationMeta';
  inviteUrl: Scalars['String']['output'];
};

export type GqlCreateBrandMenuInvitationPayload = {
  __typename?: 'CreateBrandMenuInvitationPayload';
  invitation: GqlBrandMenuInvitation;
  meta: GqlCreateBrandMenuInvitationMeta;
};

export type GqlCreateBrandTagInput = {
  addedVia: BrandTagAddedVia;
  cannabinoidRatio?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  kind: BrandTagKind;
  strainType?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type GqlCreateCheckoutInputCartItem = {
  option: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GqlCreateCheckoutInputCustomerInfo = {
  address?: InputMaybe<GqlCheckoutAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateFraudAccountResponse = {
  __typename?: 'CreateFraudAccountResponse';
  success: Scalars['Boolean']['output'];
};

export type GqlCreateFraudInput = {
  name: Scalars['String']['input'];
  paymentMethods: Array<InputMaybe<GqlFraudPaymentMethod>>;
  phone: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GqlCreateInstoreCartUrlResponse = {
  __typename?: 'CreateInstoreCartUrlResponse';
  instoreCartUrl: Scalars['String']['output'];
};

export type GqlCreateMxEnrollmentResponse = {
  __typename?: 'CreateMxEnrollmentResponse';
  billingAddress?: Maybe<GqlBillingAddress>;
  url: Scalars['String']['output'];
};

export type GqlCreateOrUpdateAchReturnResponse = {
  __typename?: 'CreateOrUpdateAchReturnResponse';
  achReturn: GqlAchReturnV2;
};

export type GqlCreateOrUpdateAchReturnResponseV4 = {
  __typename?: 'CreateOrUpdateAchReturnResponseV4';
  achReturn: GqlAchReturnV4;
};

export type GqlCreateOrUpdateAchReturnResponseV5 = {
  __typename?: 'CreateOrUpdateAchReturnResponseV5';
  achReturn: GqlAchReturnV5;
};

export type GqlCreateOrderError = {
  __typename?: 'CreateOrderError';
  extensions?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type GqlCreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  errors?: Maybe<Array<Maybe<GqlCreateOrderError>>>;
  order?: Maybe<GqlOrders>;
  valid: Scalars['Boolean']['output'];
};

export type GqlCreatePosMedUserInput = {
  alcoholUse: Scalars['Boolean']['input'];
  bipolar: Scalars['Boolean']['input'];
  bipolarManager?: InputMaybe<Scalars['String']['input']>;
  bipolarMedications?: InputMaybe<Scalars['String']['input']>;
  bipolarRisk?: InputMaybe<Scalars['Boolean']['input']>;
  bipolarStable?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  currentMedicalCannabisUse: Scalars['Boolean']['input'];
  currentlyBreastfeeding?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth: Scalars['String']['input'];
  diseaseQuestionAnswers?: InputMaybe<Array<Scalars['Int']['input']>>;
  driversLicense: Scalars['String']['input'];
  driversLicensePhoto?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  historyOfSuicide?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalizedOrSurguries: Scalars['Boolean']['input'];
  howOftenAlcohol?: InputMaybe<Scalars['String']['input']>;
  howOftenTobacco?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  listMentalHealthConditions?: InputMaybe<Scalars['String']['input']>;
  listOfAllergies?: InputMaybe<Scalars['String']['input']>;
  listOfMedications?: InputMaybe<Scalars['String']['input']>;
  medAllergies: Scalars['Boolean']['input'];
  medicalCondition: Scalars['String']['input'];
  medicalConditions?: InputMaybe<Array<Scalars['String']['input']>>;
  mentalConditions: Scalars['Boolean']['input'];
  mentalMedications?: InputMaybe<Scalars['String']['input']>;
  opioidsOrLithium: Scalars['Boolean']['input'];
  opioidsOrLithiumDoctor?: InputMaybe<Scalars['String']['input']>;
  opioidsOrLithiumReason?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  physicallyDisabled: Scalars['Boolean']['input'];
  preferredDispensary?: InputMaybe<Scalars['String']['input']>;
  recentHospitalizationReason?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  takingMedications: Scalars['Boolean']['input'];
  tobaccoUse: Scalars['Boolean']['input'];
  unit: Scalars['String']['input'];
  waitingAtDispensary: Scalars['Boolean']['input'];
  zipCode: Scalars['String']['input'];
};

export type GqlCreatePaymentCard = {
  billingPostalCode: Scalars['String']['input'];
  cardholderFirstName?: InputMaybe<Scalars['String']['input']>;
  cardholderLastName?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type GqlCreatePaymentCustomerDetails = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GqlCreatePaymentPayment = {
  __typename?: 'CreatePaymentPayment';
  amount?: Maybe<Scalars['Int']['output']>;
  checkoutToken?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  tipAMount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlCreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  payment: GqlCreatePaymentPayment;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlCreatePointsBoostInput = {
  dispensaryId: Scalars['String']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
  signedUpForLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  signedUpForPbb?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type GqlCreatePrintJobInput = {
  dispensaryId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  printerId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreatePrintJobResponse = {
  __typename?: 'CreatePrintJobResponse';
  printJob: GqlPrintJob;
  success: Scalars['Boolean']['output'];
};

export type GqlCreateRetailerEnrollmentResponse = {
  __typename?: 'CreateRetailerEnrollmentResponse';
  paymentMethod: GqlDutchiePayPaymentMethod;
};

export type GqlCrossingMindsAuthResponse = {
  __typename?: 'CrossingMindsAuthResponse';
  jwtToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type GqlCurbsideArrival = {
  __typename?: 'CurbsideArrival';
  arrivalInformation?: Maybe<Scalars['String']['output']>;
  arrivedAt?: Maybe<Scalars['ISODateTime']['output']>;
  clearedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<GqlOrders>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlCurbsidePickupInput = {
  arrivalInformationInstructions?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSettings?: InputMaybe<GqlAutoConfirmSettingsInput>;
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  creditCardByPhoneCheckoutMessage?: InputMaybe<Scalars['String']['input']>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableCurbsideArrivals?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<GqlNotificationSettingsInput>;
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  pickupReminders?: InputMaybe<GqlPickupRemindersInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlCurbsidePickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'CurbsidePickupOrderingSettings';
  arrivalInformationInstructions?: Maybe<Scalars['String']['output']>;
  autoConfirmSettings?: Maybe<GqlAutoConfirmSettings>;
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  creditCardByPhoneCheckoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableCurbsideArrivals?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  notificationSettings?: Maybe<GqlNotificationSettings>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlCustomCategoryPhoto = {
  __typename?: 'CustomCategoryPhoto';
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum CustomFont {
  exo = 'EXO',
  firaSans = 'FIRA_SANS',
  heebo = 'HEEBO',
  lato = 'LATO',
  matter = 'MATTER',
  merriweather = 'MERRIWEATHER',
  notoSans = 'NOTO_SANS',
  nunito = 'NUNITO',
  proximaNova = 'PROXIMA_NOVA',
  rokkitt = 'ROKKITT',
  volkhov = 'VOLKHOV',
  vollkorn = 'VOLLKORN',
  workSans = 'WORK_SANS'
}

export type GqlCustomMobileMenu = {
  __typename?: 'CustomMobileMenu';
  items: Array<GqlCustomMobileMenuItem>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomMobileMenuItem = {
  __typename?: 'CustomMobileMenuItem';
  items?: Maybe<Array<GqlCustomMobileMenuItem>>;
  label: Scalars['String']['output'];
  openInExternalBrowser?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomNavigation = {
  __typename?: 'CustomNavigation';
  dispensaryId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<GqlCustomNavigationItem>;
  label: Scalars['String']['output'];
};

export type GqlCustomNavigationItem = {
  __typename?: 'CustomNavigationItem';
  connectedId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<GqlCustomNavigationItem>;
  label: Scalars['String']['output'];
  navigationType: CustomNavigationItemType;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomNavigationItemInput = {
  connectedId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<GqlCustomNavigationItemInput>>;
  label: Scalars['String']['input'];
  navigationType: CustomNavigationItemType;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomNavigationItemType {
  brand = 'BRAND',
  category = 'CATEGORY',
  collection = 'COLLECTION',
  link = 'LINK',
  section = 'SECTION'
}

export type GqlCustomerDetailsResponse = {
  __typename?: 'CustomerDetailsResponse';
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  successfulOrderCount: Scalars['Int']['output'];
};

export type GqlCustomerOrder = {
  __typename?: 'CustomerOrder';
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type GqlCustomerSubscription = {
  __typename?: 'CustomerSubscription';
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export enum CustomerType {
  medical = 'medical',
  recreational = 'recreational'
}

export type GqlCustomerUnsubscribe = {
  __typename?: 'CustomerUnsubscribe';
  dispensary?: Maybe<GqlDispensaries>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlCustomers = {
  __typename?: 'Customers';
  _id?: Maybe<Scalars['String']['output']>;
  ageVerified?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numOrders?: Maybe<Scalars['Int']['output']>;
  ordersTotal?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  subscriptions?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  textSubscription?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomersList = {
  __typename?: 'CustomersList';
  customers?: Maybe<Array<Maybe<GqlCustomers>>>;
  meta?: Maybe<GqlMeta>;
};

export type GqlCustomizationProvider = {
  __typename?: 'CustomizationProvider';
  manifestUrl?: Maybe<Scalars['String']['output']>;
  modulePath?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomizedCategories = {
  __typename?: 'CustomizedCategories';
  items?: Maybe<Array<Maybe<GqlCustomizedCategory>>>;
  mobileDisplay?: Maybe<CategoriesMobileDisplayOption>;
  style?: Maybe<RadiusOption>;
  type?: Maybe<CategoriesTypeOption>;
};

export type GqlCustomizedCategory = {
  __typename?: 'CustomizedCategory';
  cardDisplayName?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  collectionId?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  isOutlet?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDateRange = {
  max?: InputMaybe<Scalars['ISODateTime']['input']>;
  min?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlDecagonUserAuth = {
  __typename?: 'DecagonUserAuth';
  epoch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type GqlDeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GqlDeletePageResult = {
  __typename?: 'DeletePageResult';
  deletedTargetingRules: Scalars['Int']['output'];
  deletedVersions: Scalars['Int']['output'];
  variantId: Scalars['String']['output'];
};

export type GqlDeliveryCityZones = {
  __typename?: 'DeliveryCityZones';
  _id?: Maybe<Scalars['String']['output']>;
  cities?: Maybe<Array<Maybe<GqlCityZoneEntry>>>;
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryCityZonesInputV2 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  cities?: InputMaybe<Array<InputMaybe<GqlCityZoneEntryInput>>>;
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDeliveryFeeTiers = {
  __typename?: 'DeliveryFeeTiers';
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  maximumInCents?: Maybe<Scalars['Int']['output']>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryInput = {
  autoConfirmSettings?: InputMaybe<GqlAutoConfirmSettingsInput>;
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  creditCardByPhoneCheckoutMessage?: InputMaybe<Scalars['String']['input']>;
  deliveryCityZones?: InputMaybe<Array<InputMaybe<GqlDeliveryCityZonesInputV2>>>;
  deliveryFeeTiers?: InputMaybe<Array<InputMaybe<GqlFeeTiersInput>>>;
  deliveryMode?: InputMaybe<DeliveryModes>;
  deliveryRadius?: InputMaybe<GqlDeliveryRadiusInput>;
  deliveryZipCodes?: InputMaybe<Array<InputMaybe<GqlDeliveryZipCodesInputV2>>>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<GqlNotificationSettingsInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export enum DeliveryModes {
  cities = 'cities',
  cityLimits = 'cityLimits',
  drawn = 'drawn',
  radius = 'radius',
  zipCode = 'zipCode'
}

export type GqlDeliveryOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'DeliveryOrderingSettings';
  autoConfirmSettings?: Maybe<GqlAutoConfirmSettings>;
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  creditCardByPhoneCheckoutMessage?: Maybe<Scalars['String']['output']>;
  deliveryCityZones?: Maybe<Array<Maybe<GqlDeliveryCityZones>>>;
  deliveryFeeTiers?: Maybe<Array<Maybe<GqlDeliveryFeeTiers>>>;
  deliveryMode?: Maybe<DeliveryModes>;
  deliveryRadius?: Maybe<GqlDeliveryRadius>;
  deliveryZipCodes?: Maybe<Array<Maybe<GqlDeliveryZipCodes>>>;
  deliveryZones?: Maybe<Array<Maybe<GqlDeliveryZones>>>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  notificationSettings?: Maybe<GqlNotificationSettings>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export enum DeliveryPolicy {
  destinationBased = 'destinationBased',
  originBased = 'originBased'
}

export type GqlDeliveryRadius = {
  __typename?: 'DeliveryRadius';
  orderMinimum?: Maybe<GqlOrderMinimum>;
  radiusInMiles?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryRadiusInput = {
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  radiusInMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDeliveryZipCodes = {
  __typename?: 'DeliveryZipCodes';
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GqlDeliveryZipCodesInputV2 = {
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDeliveryZones = {
  __typename?: 'DeliveryZones';
  _id?: Maybe<Scalars['String']['output']>;
  area?: Maybe<GqlPolygon>;
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryZonesInputV2 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<GqlPolygonInput>;
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDetailItem = {
  __typename?: 'DetailItem';
  basePrice?: Maybe<Scalars['Float']['output']>;
  basePriceMult?: Maybe<Scalars['Float']['output']>;
  bogoSavings?: Maybe<GqlBogoSavingsObj>;
  bottleDepositTaxCents?: Maybe<Scalars['Float']['output']>;
  canonicalEffectivePotencyMg?: Maybe<Scalars['Float']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOnSale?: Maybe<Scalars['Boolean']['output']>;
  isVapeTaxed?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  menuBasePrice?: Maybe<Scalars['Float']['output']>;
  menuCannabisTax?: Maybe<Scalars['Float']['output']>;
  menuIndividualPrice?: Maybe<Scalars['Float']['output']>;
  menuPrice?: Maybe<Scalars['Float']['output']>;
  menuSaleAdjustment?: Maybe<Scalars['Float']['output']>;
  menuSalesTax?: Maybe<Scalars['Float']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  posId?: Maybe<Scalars['String']['output']>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  productBrand?: Maybe<Scalars['String']['output']>;
  productBrandId?: Maybe<Scalars['String']['output']>;
  productCategory?: Maybe<Scalars['String']['output']>;
  productSubcategory?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  type?: Maybe<Scalars['String']['output']>;
  weightInGrams?: Maybe<Scalars['Float']['output']>;
  weightInMg?: Maybe<Scalars['Float']['output']>;
  wholesalePrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * A pre-seeded dev/preview sign-in identity exposed by the dev account picker.
 * Only populated when Armageddon's DevLogin is enabled; never includes passwords.
 */
export type GqlDevAccount = {
  __typename?: 'DevAccount';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlDeviceAccessCode = {
  __typename?: 'DeviceAccessCode';
  accessCode: Scalars['String']['output'];
  channel: Scalars['String']['output'];
  channelKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GqlDeviceConnection = {
  __typename?: 'DeviceConnection';
  accessToken: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
};

export type GqlDeviceStatusInput = {
  displayStatus?: InputMaybe<Scalars['String']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DeviceType {
  digitalDisplay = 'digital_display',
  orderTerminal = 'order_terminal'
}

export type GqlDevice_Config = {
  __typename?: 'Device_config';
  getDeliveryOrders?: Maybe<Scalars['Boolean']['output']>;
  getKioskOrders?: Maybe<Scalars['Boolean']['output']>;
  getPickupOrders?: Maybe<Scalars['Boolean']['output']>;
  orderSort?: Maybe<GqlDevice_Config_OrderSort>;
  /** @deprecated Replaced by getPickupOrders, getDeliveryOrders, getKioskOrders */
  orderSource?: Maybe<Scalars['String']['output']>;
};

export type GqlDevice_Config_Input = {
  getDeliveryOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getKioskOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  orderSort?: InputMaybe<GqlDevice_Config_OrderSort_Input>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDevice_Config_OrderSort = {
  __typename?: 'Device_config_orderSort';
  sortBy?: Maybe<Device_OrderSortOptions>;
  sortDirection?: Maybe<StringSortDirections>;
};

export type GqlDevice_Config_OrderSort_Input = {
  sortBy?: InputMaybe<Device_OrderSortOptions>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlDevice_FeatureFlags = {
  __typename?: 'Device_featureFlags';
  enableBatchPrint?: Maybe<Scalars['Boolean']['output']>;
};

export enum Device_OrderSortOptions {
  createdAt = 'createdAt',
  reservation = 'reservation'
}

export type GqlDevices = {
  __typename?: 'Devices';
  _id?: Maybe<Scalars['String']['output']>;
  accessCode?: Maybe<Scalars['String']['output']>;
  autoPrintDevice?: Maybe<Scalars['Boolean']['output']>;
  buildNumber?: Maybe<Scalars['String']['output']>;
  config?: Maybe<GqlDevice_Config>;
  deviceType?: Maybe<DeviceType>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<GqlDevice_FeatureFlags>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  printerConnected?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlDigitalDisplay = {
  __typename?: 'DigitalDisplay';
  assignments: Array<GqlDigitalDisplayAssignment>;
  deviceId: Scalars['ID']['output'];
  orientation: Scalars['String']['output'];
};

export type GqlDigitalDisplayAssignment = {
  __typename?: 'DigitalDisplayAssignment';
  playlistId: Scalars['ID']['output'];
  playlistName?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type GqlDigitalDisplayAssignmentInput = {
  playlistId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type GqlDigitalDisplayBoard = {
  __typename?: 'DigitalDisplayBoard';
  audioEnabled?: Maybe<Scalars['Boolean']['output']>;
  boardItem?: Maybe<GqlDigitalDisplayBoardItem>;
  colorScheme?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  enterpriseId: Scalars['ID']['output'];
  folderIds?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  layout: DigitalDisplayBoardLayout;
  menuColumns?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orientation?: Maybe<DigitalDisplayBoardOrientation>;
  updatedAt: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type GqlDigitalDisplayBoardConnection = {
  __typename?: 'DigitalDisplayBoardConnection';
  items: Array<GqlDigitalDisplayBoard>;
  total: Scalars['Int']['output'];
};

export type GqlDigitalDisplayBoardFolder = {
  __typename?: 'DigitalDisplayBoardFolder';
  boardCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  enterpriseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type GqlDigitalDisplayBoardItem = {
  __typename?: 'DigitalDisplayBoardItem';
  assetId: Scalars['ID']['output'];
  assetUrl?: Maybe<Scalars['String']['output']>;
  contentType: DigitalDisplayBoardItemContentType;
  id: Scalars['ID']['output'];
};

export enum DigitalDisplayBoardItemContentType {
  image = 'IMAGE',
  video = 'VIDEO'
}

export enum DigitalDisplayBoardLayout {
  fullImage = 'FULL_IMAGE',
  fullVideo = 'FULL_VIDEO',
  menu_2X2Grid = 'MENU_2X2_GRID',
  menuAndImage = 'MENU_AND_IMAGE',
  menuCustomGrid = 'MENU_CUSTOM_GRID',
  menuOneColumn = 'MENU_ONE_COLUMN',
  menuThreeColumn = 'MENU_THREE_COLUMN',
  menuTwoColumn = 'MENU_TWO_COLUMN'
}

export enum DigitalDisplayBoardOrientation {
  landscape = 'LANDSCAPE',
  portrait = 'PORTRAIT'
}

export type GqlDigitalDisplayCommandResult = {
  __typename?: 'DigitalDisplayCommandResult';
  deviceId: Scalars['ID']['output'];
};

export type GqlDigitalDisplayDevice = {
  __typename?: 'DigitalDisplayDevice';
  city?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  online: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlDigitalDisplayPlaylist = {
  __typename?: 'DigitalDisplayPlaylist';
  boards: Array<GqlDigitalDisplayPlaylistBoard>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enterpriseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scheduledChange?: Maybe<GqlDigitalDisplayPlaylistScheduledChange>;
  status: DigitalDisplayPlaylistStatus;
  updatedAt: Scalars['String']['output'];
};

export type GqlDigitalDisplayPlaylistBoard = {
  __typename?: 'DigitalDisplayPlaylistBoard';
  board: GqlDigitalDisplayBoard;
  durationSeconds: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type GqlDigitalDisplayPlaylistBoardInput = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};

export type GqlDigitalDisplayPlaylistConnection = {
  __typename?: 'DigitalDisplayPlaylistConnection';
  items: Array<GqlDigitalDisplayPlaylist>;
  total: Scalars['Int']['output'];
};

export type GqlDigitalDisplayPlaylistScheduledChange = {
  __typename?: 'DigitalDisplayPlaylistScheduledChange';
  boards: Array<GqlDigitalDisplayPlaylistBoard>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  playlistStatus?: Maybe<DigitalDisplayPlaylistStatus>;
  scheduledAt: Scalars['String']['output'];
  status: DigitalDisplayPlaylistScheduledChangeStatus;
};

export enum DigitalDisplayPlaylistScheduledChangeStatus {
  applied = 'APPLIED',
  canceled = 'CANCELED',
  failed = 'FAILED',
  pending = 'PENDING'
}

export enum DigitalDisplayPlaylistStatus {
  active = 'ACTIVE',
  archived = 'ARCHIVED',
  draft = 'DRAFT'
}

export type GqlDisconnectBankAccountResponse = {
  __typename?: 'DisconnectBankAccountResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDiscount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Int']['output']>;
  applicationMethod?: Maybe<Scalars['String']['output']>;
  calculationMethod?: Maybe<DiscountCalculationMethod>;
  discountId?: Maybe<Scalars['Int']['output']>;
  isLoyaltyReward?: Maybe<Scalars['Boolean']['output']>;
  isPaymentIncentive?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlDiscountBundle = {
  __typename?: 'DiscountBundle';
  _id?: Maybe<Scalars['String']['output']>;
  applyTo?: Maybe<ApplicationScope>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDiscountBundleInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applyTo?: InputMaybe<ApplicationScope>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DiscountCalculationMethod {
  amount = 'AMOUNT',
  percent = 'PERCENT'
}

export type GqlDiscountCampaign = {
  __typename?: 'DiscountCampaign';
  brandFundedDiscountsCount: Scalars['Int']['output'];
  brandId: Scalars['ID']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  creditsCents: Scalars['Int']['output'];
  detailSummary?: Maybe<GqlDiscountCampaignDetailSummary>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  id: Scalars['ID']['output'];
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reportAvailable: Scalars['Boolean']['output'];
  reportGeneratedAt?: Maybe<Scalars['ISODateTime']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISODateTime']['output']>;
  status: DiscountCampaignStatus;
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlDiscountCampaignCreateInput = {
  contact?: InputMaybe<GqlBrandFundedDiscountContactInput>;
  discount: GqlDiscountConfigInput;
  name: Scalars['String']['input'];
  retailers: Array<GqlDiscountCampaignRetailerInput>;
};

export type GqlDiscountCampaignDetailSummary = {
  __typename?: 'DiscountCampaignDetailSummary';
  activeNoCreditsCount: Scalars['Int']['output'];
  bfdCountsByStatus: Scalars['JSON']['output'];
  totalFundingLimitCents?: Maybe<Scalars['Int']['output']>;
  totalRetailers: Scalars['Int']['output'];
  totalRooftops: Scalars['Int']['output'];
};

export type GqlDiscountCampaignFiltersInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lspGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lspIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<DiscountCampaignStatus>>;
};

export type GqlDiscountCampaignList = {
  __typename?: 'DiscountCampaignList';
  data: Array<GqlDiscountCampaignSummary>;
  meta: GqlDiscountCampaignMeta;
};

export type GqlDiscountCampaignMeta = {
  __typename?: 'DiscountCampaignMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlDiscountCampaignReportDownload = {
  __typename?: 'DiscountCampaignReportDownload';
  url: Scalars['String']['output'];
};

export type GqlDiscountCampaignRetailer = {
  __typename?: 'DiscountCampaignRetailer';
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposLspId: Scalars['Int']['output'];
  dposLspName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type GqlDiscountCampaignRetailerInput = {
  dposLocationGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId: Scalars['Int']['input'];
  dposLspName: Scalars['String']['input'];
  dposServerRegion: Scalars['String']['input'];
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DiscountCampaignSortBy {
  createdAt = 'createdAt',
  creditsCents = 'creditsCents',
  endDate = 'endDate',
  name = 'name',
  startDate = 'startDate',
  status = 'status',
  totalFundingLimitCents = 'totalFundingLimitCents',
  totalRooftops = 'totalRooftops'
}

export type GqlDiscountCampaignSortInput = {
  sortBy?: InputMaybe<DiscountCampaignSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum DiscountCampaignStatus {
  active = 'active',
  ended = 'ended',
  scheduled = 'scheduled'
}

export type GqlDiscountCampaignSummary = {
  __typename?: 'DiscountCampaignSummary';
  brandFundedDiscountsCount: Scalars['Int']['output'];
  brandId: Scalars['ID']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  creditsCents: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  hasPrepaidDiscount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lspNames: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['ISODateTime']['output']>;
  status: DiscountCampaignStatus;
  totalFundingLimitCents?: Maybe<Scalars['Int']['output']>;
  totalRooftops: Scalars['Int']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlDiscountCampaignUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DiscountCampaignStatus>;
};

export type GqlDiscountCategory = {
  __typename?: 'DiscountCategory';
  name: Scalars['String']['output'];
  nonCannabis: Scalars['Boolean']['output'];
};

export type GqlDiscountCategoryList = {
  __typename?: 'DiscountCategoryList';
  categories: Array<GqlDiscountCategory>;
  id: Scalars['ID']['output'];
};

export type GqlDiscountConfigInput = {
  applicationMethod?: InputMaybe<BrandFundedDiscountApplicationMethod>;
  availableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  brandFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  brandFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNotes?: InputMaybe<Scalars['String']['input']>;
  categoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Array<GqlBrandFundedDiscountConstraintInput>>;
  customerGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  customerSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  customerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountMethod: BrandFundedDiscountDiscountMethod;
  discountValue?: InputMaybe<Scalars['Int']['input']>;
  distributionDetails?: InputMaybe<Scalars['JSON']['input']>;
  distributionMethod: BrandFundedDiscountDistributionMethod;
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  fundingAllocationPercent: Scalars['Int']['input'];
  fundingLimitCents?: InputMaybe<Scalars['Int']['input']>;
  fundingMethod?: InputMaybe<BrandFundedDiscountFundingMethod>;
  fundingMethodAmountCents?: InputMaybe<Scalars['Int']['input']>;
  fundingMethodPercent?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  libraryProductIdExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maximumUsesPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  maximumUsesTotal?: InputMaybe<Scalars['Int']['input']>;
  minimumOrderAmountCents?: InputMaybe<Scalars['Int']['input']>;
  minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
  onlineName?: InputMaybe<Scalars['String']['input']>;
  promoName: Scalars['String']['input'];
  rewardApplicationType?: InputMaybe<BrandFundedDiscountRewardApplicationType>;
  rewardApplyTo?: InputMaybe<BrandFundedDiscountRewardApplyTo>;
  rewardCartContains?: InputMaybe<BrandFundedDiscountRewardCartContains>;
  rewardConditionType?: InputMaybe<BrandFundedDiscountRewardConditionType>;
  rewardConditionValueMax?: InputMaybe<Scalars['Int']['input']>;
  rewardConditionValueMin?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<GqlBrandFundedDiscountScheduleInput>;
  startDate: Scalars['ISODateTime']['input'];
  status?: InputMaybe<BrandFundedDiscountStatus>;
  subcategoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  subcategoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlDiscountLoc = {
  __typename?: 'DiscountLoc';
  details: GqlDiscountLocDetails;
};

export type GqlDiscountLocDetails = {
  __typename?: 'DiscountLocDetails';
  dposLocationGlobalId?: Maybe<Scalars['String']['output']>;
  dposLocationId: Scalars['String']['output'];
  dposLocationName: Scalars['String']['output'];
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposLspId: Scalars['String']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlDiscountLsp = {
  __typename?: 'DiscountLsp';
  details: GqlDiscountLspDetails;
  focusedAccount: Scalars['Boolean']['output'];
};

export type GqlDiscountLspDetails = {
  __typename?: 'DiscountLspDetails';
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposLspId: Scalars['ID']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlDiscountRegion = {
  __typename?: 'DiscountRegion';
  country: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  isoRegionCode: Scalars['String']['output'];
  subdivision: Scalars['String']['output'];
  subdivisionName: Scalars['String']['output'];
};

export type GqlDiscountSubcategory = {
  __typename?: 'DiscountSubcategory';
  category: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nonCannabis: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type GqlDiscountSubcategoryList = {
  __typename?: 'DiscountSubcategoryList';
  id: Scalars['ID']['output'];
  subcategories: Array<GqlDiscountSubcategory>;
};

export type GqlDiscountToCart = {
  __typename?: 'DiscountToCart';
  _id?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDiscountToCartInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DiscountType {
  dollarDiscount = 'dollarDiscount',
  percentDiscount = 'percentDiscount',
  targetPrice = 'targetPrice'
}

export type GqlDispensaries = {
  __typename?: 'Dispensaries';
  SpecialLogoImage?: Maybe<Scalars['String']['output']>;
  acceptsCreditCardTips?: Maybe<Scalars['Boolean']['output']>;
  acceptsDutchiePayTips?: Maybe<Scalars['Boolean']['output']>;
  acceptsTips?: Maybe<Scalars['Boolean']['output']>;
  actionEstimates?: Maybe<GqlActionEstimates>;
  activeCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  adSettings?: Maybe<GqlAdSettings>;
  address?: Maybe<Scalars['String']['output']>;
  admins?: Maybe<Array<Maybe<GqlDispensaries_Profile_Admins>>>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  aeropay?: Maybe<Scalars['Boolean']['output']>;
  ageVerificationBannerColor?: Maybe<Scalars['String']['output']>;
  ageVerificationBannerHtml?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  alt36?: Maybe<Scalars['Boolean']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  blockedAddresses?: Maybe<Array<Maybe<GqlBlockedAddress>>>;
  brandedDutchiePayEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use brandedDutchiePayLogoLight */
  brandedDutchiePayLogo?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayLogoDark?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayLogoLight?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use brandedDutchiePayLogoDark */
  brandedDutchiePayWordmark?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  canPay?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  cashOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  cashless?: Maybe<Scalars['Boolean']['output']>;
  categoryLimits?: Maybe<Array<Maybe<GqlDispensaries_CategoryLimits>>>;
  categoryLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  categoryPhotos?: Maybe<Array<Maybe<GqlCategoryPhoto>>>;
  chain?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  check?: Maybe<Scalars['Boolean']['output']>;
  collectionsNavigation?: Maybe<Array<Maybe<GqlCollection>>>;
  /** @deprecated use WebCustomizationSettings.colorSettings - 10/25/22 */
  colorSettings?: Maybe<GqlColorSettings>;
  consumerDispensaryIntegrations?: Maybe<GqlConsumerDispensaryIntegrations>;
  coordinates?: Maybe<GqlDispensaries_Profile_Coordinates>;
  /** @deprecated Use ISO field */
  createdAt?: Maybe<Scalars['String']['output']>;
  createdAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  /** @deprecated Removed support - 4/12/20 */
  creditCard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  creditCardAtDoor?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  creditCardByPhone?: Maybe<Scalars['Boolean']['output']>;
  customCategoryPhotos?: Maybe<Array<Maybe<GqlCustomCategoryPhoto>>>;
  customDomainSettings?: Maybe<GqlDispensaries_Profile_CustomDomain_Settings>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  debitOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated covered by DeliveryOrderingSettings in ordering-settings */
  deliveryArea?: Maybe<GqlPolygon>;
  /** @deprecated used and defined in ordering-settings */
  deliveryFee?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined within hours-settings */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated Fetch delivery info separately instead */
  deliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMin?: Maybe<Scalars['String']['output']>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMode?: Maybe<DeliveryModes>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  dposLspName?: Maybe<Scalars['String']['output']>;
  drivers?: Maybe<Array<Maybe<GqlDispensaries_Profile_Drivers>>>;
  durationEstimateOverrides?: Maybe<GqlDurationEstimates>;
  /** @deprecated defined in hours-settings */
  effectiveHours?: Maybe<GqlEffectiveHours>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmation?: Maybe<Scalars['Boolean']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  embedBackUrl?: Maybe<Scalars['String']['output']>;
  embedSettings?: Maybe<GqlDispensaries_Profile_Embed_Settings>;
  embeddedLogoImage?: Maybe<Scalars['String']['output']>;
  embeddedMenuUrl?: Maybe<Scalars['String']['output']>;
  enabledOrderTypes?: Maybe<GqlEnabledOrderTypes>;
  /** @deprecated Taxes V1 */
  exciseTax?: Maybe<GqlDispensaries_ExciseTax>;
  featureFlags: GqlDispensaries_FeatureFlags;
  featuredBrandsSettings: Array<GqlFeaturedBrandsSetting>;
  featuredProductsSettings: Array<GqlFeaturedProductsSetting>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  /** @deprecated Use ISO field */
  firstActiveAt?: Maybe<Scalars['String']['output']>;
  firstActiveAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  fleetManagementIntegration?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  fullName?: Maybe<Scalars['String']['output']>;
  googleAnalyticsID?: Maybe<Scalars['String']['output']>;
  googleTagManager?: Maybe<GqlDispensaries_GoogleTagManagerConfig>;
  /** @deprecated use storeSettings.requireEmailAddressForGuestCheckout - RTL, 4/28/2021 */
  guestEmailRequired?: Maybe<Scalars['Boolean']['output']>;
  hasMenuIntegration: Scalars['Boolean']['output'];
  hideFromCCT?: Maybe<Scalars['Boolean']['output']>;
  hoursSettings?: Maybe<GqlDispensaryHoursSettings>;
  id: Scalars['String']['output'];
  imageBanners?: Maybe<Array<Maybe<GqlImageBanner>>>;
  includeSalesTaxInMenu?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Taxes V1 */
  inclusiveSalesTax?: Maybe<Scalars['Boolean']['output']>;
  isLibrary?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated defined in ordering-settings as KioskOrderingSettings */
  kioskConfig?: Maybe<GqlDispensaries_KioskConfig>;
  /** @deprecated defined within KioskOrderingSettings in ordering-settings */
  kioskInstructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined within KioskOrderingSettings in ordering-settings */
  kioskOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  linx?: Maybe<Scalars['Boolean']['output']>;
  listImage?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlDispensaries_Profile_Location>;
  logoImage?: Maybe<Scalars['String']['output']>;
  /** @deprecated used and defined in ordering-settings as deliveryRadiusInMiles */
  maxDeliveryDistance?: Maybe<Scalars['Float']['output']>;
  medSubjectToExciseTax?: Maybe<Scalars['Boolean']['output']>;
  medicalDispensary?: Maybe<Scalars['Boolean']['output']>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  menuBannerColor?: Maybe<Scalars['String']['output']>;
  menuBannerHtml?: Maybe<Scalars['String']['output']>;
  menuBannerTextBannerCollapsed?: Maybe<Scalars['Boolean']['output']>;
  menuIntegration?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  menuOrder?: Maybe<Scalars['String']['output']>;
  menuOrderSettings: Array<GqlMenuOrderSetting>;
  menuScore?: Maybe<Scalars['Float']['output']>;
  menuScoresByCategory?: Maybe<Array<Maybe<GqlMenuScore>>>;
  menuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  /** @deprecated Use menuOrderSettings instead */
  menuSortSettings?: Maybe<Array<GqlMenuSortSetting>>;
  menuUrl?: Maybe<Scalars['String']['output']>;
  menuWeights?: Maybe<Scalars['String']['output']>;
  merrcoPublicToken?: Maybe<Scalars['String']['output']>;
  messagingSettings?: Maybe<GqlDispensaries_MessagingSettings>;
  mixAndMatchPricingWeights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * convenience properties used frequently on server and client. Derived based on orderTypesConfig. See serializer for detail
   * @deprecated use OrderTypesConfig.offerAnyPickupService
   */
  offerAnyPickupService?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerCurbsidePickup?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerDriveThruPickup?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerPickup?: Maybe<Scalars['Boolean']['output']>;
  openInfoForDevice?: Maybe<GqlOpenInfoForDevice>;
  orderStatusEmailSettings?: Maybe<GqlOrderStatusEmailSettings>;
  /**
   * nested payment-type-per-order-type data; used in admin settings and checkout
   * @deprecated use OrderTypesConfigV2
   */
  orderTypesConfig?: Maybe<GqlOrderTypesConfig>;
  orderTypesConfigV2?: Maybe<GqlOrderTypesConfigV2>;
  ordersArePaused?: Maybe<Scalars['Boolean']['output']>;
  ordersConfig?: Maybe<GqlDispensaries_OrdersConfig>;
  payByBankManualFinalizationAvailable?: Maybe<Scalars['Boolean']['output']>;
  payByBankPreauthorizationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated legacy payment option */
  payInStore?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  payOnlineHypur?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  payOnlineMerrco?: Maybe<Scalars['Boolean']['output']>;
  paymentFees?: Maybe<Array<Maybe<GqlDispensaries_PaymentFees>>>;
  /** booleans of all payment types the dispo accepts (derived from nested orderTypesConfig data). Existing references to profile-level bools should be changed to reference this list */
  paymentTypesAccepted?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  paytender?: Maybe<Scalars['Boolean']['output']>;
  personalizationSettings?: Maybe<GqlPersonalizationSettings>;
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined in hours-settings */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated defined in ordering-settings */
  pickupMinimum?: Maybe<GqlPickupMinimum>;
  plusSettings?: Maybe<GqlDispensaries_Profile_Plus_Settings>;
  printedMenuSettings?: Maybe<GqlDispensaries_PrintedMenuSettings>;
  printedMenuSettingsV2?: Maybe<Scalars['JSON']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  productCategorySummary?: Maybe<Array<Maybe<GqlCategorySummary>>>;
  recDispensary?: Maybe<Scalars['Boolean']['output']>;
  remoteExtensions?: Maybe<GqlRemoteExtensions>;
  removeMedicalCardFieldsAtCheckout?: Maybe<Scalars['Boolean']['output']>;
  requirePhotoIdForDelivery?: Maybe<Scalars['Boolean']['output']>;
  requirePhotoIdForPickup?: Maybe<Scalars['Boolean']['output']>;
  requiresDriversLicense?: Maybe<Scalars['Boolean']['output']>;
  requiresDriversLicenseExpirationDate?: Maybe<Scalars['Boolean']['output']>;
  requiresDriversLicenseForPickup?: Maybe<Scalars['Boolean']['output']>;
  reservationsAvailableByOrderType?: Maybe<GqlReservationsAvailableByOrderType>;
  retailer: GqlRetailer;
  salesTax?: Maybe<Scalars['Float']['output']>;
  /** @deprecated SEO menu feature removed. */
  seoSettings?: Maybe<GqlSeoSettings>;
  /** @deprecated defined in hours-settings in HoursSettingsForOrderType */
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
  specialsSettings?: Maybe<GqlSpecialsSettings>;
  /** @deprecated Use consumerDispensaryIntegrations.springbig.enabled field */
  springbigEnabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Moved to storeSettings 7/11/2019 */
  stealthMode?: Maybe<Scalars['Boolean']['output']>;
  storeSettings: GqlDispensaries_StoreSettings;
  tags?: Maybe<GqlProductTags>;
  taxCalculationMethod: Scalars['String']['output'];
  taxConfig: GqlDispensaries_TaxConfig;
  temporalLocation?: Maybe<GqlTemporalLocation>;
  /** @deprecated Not possible in aggregations anymore. Use separate query for device lookup. */
  terminals?: Maybe<Array<Maybe<GqlDispensaries_Terminals>>>;
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO field */
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  webCustomizationSettings?: Maybe<GqlWebCustomizationSettings>;
  webCustomizationSettingsV2?: Maybe<GqlWebCustomizationSettingsV2>;
};


export type GqlDispensariesCollectionsNavigationArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<CollectionChannel>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlDispensariesImageBannersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlDispensariesMenuSectionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlDispensariesAdSettingsByMenuVariantResult = {
  __typename?: 'DispensariesAdSettingsByMenuVariantResult';
  adSettings?: Maybe<GqlAdSettings>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensariesPersonalizationSettingsByMenuVariantResult = {
  __typename?: 'DispensariesPersonalizationSettingsByMenuVariantResult';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personalizationSettings?: Maybe<GqlPersonalizationSettings>;
};

export type GqlDispensaries_GoogleTagManagerConfig = {
  __typename?: 'Dispensaries_GoogleTagManagerConfig';
  containerIds?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['JSON']['output']>;
  gtmID?: Maybe<Scalars['String']['output']>;
  serverContainerUrl?: Maybe<Scalars['String']['output']>;
  serverContainerUrls?: Maybe<Scalars['JSON']['output']>;
};

export type GqlDispensaries_TaxConfig = {
  __typename?: 'Dispensaries_TaxConfig';
  calculationMethod: Scalars['String']['output'];
  discountTaxOrder: Scalars['String']['output'];
  taxes: Array<Maybe<GqlDispensaries_TaxConfig_Tax>>;
  version: Scalars['Int']['output'];
};

export type GqlDispensaries_TaxConfig_Tax = {
  __typename?: 'Dispensaries_TaxConfig_Tax';
  applyTo: GqlDispensaries_TaxConfig_Tax_ApplyTo;
  deliveryPolicy?: Maybe<DeliveryPolicy>;
  destinationRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  includeStateSalesTaxInDestinationRate?: Maybe<Scalars['Boolean']['output']>;
  medical: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  potency?: Maybe<PotencyType>;
  potencyRate?: Maybe<Scalars['Float']['output']>;
  rate: Scalars['Float']['output'];
  recreational: Scalars['Boolean']['output'];
  stages: Array<Maybe<GqlDispensaries_TaxConfig_Tax_Stage>>;
  taxBasis?: Maybe<Scalars['String']['output']>;
  type: TaxType;
};

export type GqlDispensaries_TaxConfig_Tax_ApplyTo = {
  __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo';
  hemp: Scalars['Boolean']['output'];
  types: Array<Maybe<Scalars['String']['output']>>;
};

export type GqlDispensaries_TaxConfig_Tax_Stage = {
  __typename?: 'Dispensaries_TaxConfig_Tax_Stage';
  op: Dispensaries_TaxConfig_Tax_Stage_Ops;
  type: Dispensaries_TaxConfig_Tax_Stage_Types;
};

export enum Dispensaries_TaxConfig_Tax_Stage_Ops {
  add = 'add',
  noop = 'noop',
  subtract = 'subtract'
}

export enum Dispensaries_TaxConfig_Tax_Stage_Types {
  checkout = 'checkout',
  menu = 'menu',
  pos = 'pos'
}

export type GqlDispensaries_CategoryLimits = {
  __typename?: 'Dispensaries_categoryLimits';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_DeliveryInfo = {
  __typename?: 'Dispensaries_deliveryInfo';
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  feeVaries?: Maybe<Scalars['Boolean']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  minimumVaries?: Maybe<Scalars['Boolean']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
  withinBounds?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_ExciseTax = {
  __typename?: 'Dispensaries_exciseTax';
  local?: Maybe<Scalars['Float']['output']>;
  medicalLocal?: Maybe<Scalars['Float']['output']>;
  medicalState?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['Float']['output']>;
};

export type GqlDispensaries_FeatureFlags = {
  __typename?: 'Dispensaries_featureFlags';
  /** @deprecated General Availability 2/23/21 */
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated General Availability 7/09/2020 */
  enableArrivals?: Maybe<Scalars['Boolean']['output']>;
  enableMenuImport?: Maybe<Scalars['Boolean']['output']>;
  enableMixAndMatch?: Maybe<Scalars['Boolean']['output']>;
  enableNonTerminalAutoConfirm?: Maybe<Scalars['Boolean']['output']>;
  enablePausedOrders?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated General Availability 2/23/21 */
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  hideDeliveryEstimate?: Maybe<Scalars['Boolean']['output']>;
  hideMyAccount?: Maybe<Scalars['Boolean']['output']>;
  hideStoreHours?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_FleetManagementIntegration_Credentials = {
  __typename?: 'Dispensaries_fleetManagementIntegration_credentials';
  apiKey?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ordersEnabled?: Maybe<Scalars['Boolean']['output']>;
  rewardsProgramPointsBoost?: Maybe<Scalars['Int']['output']>;
};

export type GqlDispensaries_FleetManagementIntegration_Flags = {
  __typename?: 'Dispensaries_fleetManagementIntegration_flags';
  combineDiscounts?: Maybe<Scalars['Boolean']['output']>;
  fleetManagementStatus?: Maybe<Scalars['String']['output']>;
  onfleetStatus?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Integrations = {
  __typename?: 'Dispensaries_integrations';
  adapter?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<GqlDispensaries_FleetManagementIntegration_Credentials>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flags?: Maybe<GqlDispensaries_FleetManagementIntegration_Flags>;
  integrationCategory?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_KioskConfig = {
  __typename?: 'Dispensaries_kioskConfig';
  directedOrders?: Maybe<Scalars['Boolean']['output']>;
  disableFasterCheckout?: Maybe<Scalars['Boolean']['output']>;
  fullNameOnly?: Maybe<Scalars['Boolean']['output']>;
  hideEmailField?: Maybe<Scalars['Boolean']['output']>;
  hidePhoneField?: Maybe<Scalars['Boolean']['output']>;
  notesField?: Maybe<Scalars['Boolean']['output']>;
  phoneRequired?: Maybe<Scalars['Boolean']['output']>;
  showBirthdateField?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_MessagingSettings = {
  __typename?: 'Dispensaries_messagingSettings';
  disablePushReadyForPickup?: Maybe<Scalars['Boolean']['output']>;
  disablePushStartDelivery?: Maybe<Scalars['Boolean']['output']>;
  disableReadyForPickup?: Maybe<Scalars['Boolean']['output']>;
  disableStartDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_OrdersConfig = {
  __typename?: 'Dispensaries_ordersConfig';
  autoClose?: Maybe<Scalars['Boolean']['output']>;
  autoConfirm?: Maybe<Scalars['Boolean']['output']>;
  posItemNames?: Maybe<Scalars['Boolean']['output']>;
  terminalReceiptOptions?: Maybe<GqlTerminalReceiptOptions>;
};

export type GqlDispensaries_PaymentFees = {
  __typename?: 'Dispensaries_paymentFees';
  fee?: Maybe<Scalars['Float']['output']>;
  feeType?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_PrintedMenuSettings = {
  __typename?: 'Dispensaries_printedMenuSettings';
  Branding?: Maybe<GqlPrintedMenuSettings_Branding>;
  Categories?: Maybe<Array<Maybe<GqlPrintedMenuSettings_CategoryEntry>>>;
  FooterText?: Maybe<GqlPrintedMenuSettings_Text>;
  HeaderText?: Maybe<GqlPrintedMenuSettings_Text>;
  MenuType?: Maybe<GqlPrintedMenuSettings_Type>;
  Order?: Maybe<GqlPrintedMenuSettings_Type>;
  PageBreaks?: Maybe<GqlPrintedMenuSettings_PageBreaks>;
  Photos?: Maybe<GqlPrintedMenuSettings_Photos>;
  PricingDisplay?: Maybe<GqlPrintedMenuSettings_PricingDisplay>;
  StrainTypes?: Maybe<Array<Maybe<GqlPrintedMenuSettings_StrainTypesEntry>>>;
};

export type GqlDispensaries_Profile_Admins = {
  __typename?: 'Dispensaries_profile_admins';
  active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Coordinates = {
  __typename?: 'Dispensaries_profile_coordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type GqlDispensaries_Profile_CustomDomain_Settings = {
  __typename?: 'Dispensaries_profile_customDomain_settings';
  /** @deprecated use domain instead */
  cloudflareDomain?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Drivers = {
  __typename?: 'Dispensaries_profile_drivers';
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Embed_Settings = {
  __typename?: 'Dispensaries_profile_embed_settings';
  applyToAllLocations?: Maybe<Scalars['Boolean']['output']>;
  autoGTM?: Maybe<Scalars['Boolean']['output']>;
  autoScroll?: Maybe<Scalars['Boolean']['output']>;
  autoScrollOffset?: Maybe<Scalars['Int']['output']>;
  disablePageLoadsAtTop?: Maybe<Scalars['Boolean']['output']>;
  disableRouting?: Maybe<Scalars['Boolean']['output']>;
  disclaimerText?: Maybe<Scalars['String']['output']>;
  disclaimerTextHtml?: Maybe<Scalars['String']['output']>;
  enableFullScreenEmbeddedCheckout?: Maybe<Scalars['Boolean']['output']>;
  iframeCSS?: Maybe<Scalars['String']['output']>;
  pageCSS?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_FeeTiers = {
  __typename?: 'Dispensaries_profile_feeTiers';
  fee?: Maybe<Scalars['String']['output']>;
  feeType?: Maybe<FeeTypes>;
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDispensaries_Profile_Hours = {
  __typename?: 'Dispensaries_profile_hours';
  Friday?: Maybe<GqlDayBounds>;
  Monday?: Maybe<GqlDayBounds>;
  Saturday?: Maybe<GqlDayBounds>;
  Sunday?: Maybe<GqlDayBounds>;
  Thursday?: Maybe<GqlDayBounds>;
  Tuesday?: Maybe<GqlDayBounds>;
  Wednesday?: Maybe<GqlDayBounds>;
};

export type GqlDispensaries_Profile_Location = {
  __typename?: 'Dispensaries_profile_location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<GqlDispensaries_Profile_Location_Geometry>;
  ln1?: Maybe<Scalars['String']['output']>;
  ln2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Location_Geometry = {
  __typename?: 'Dispensaries_profile_location_geometry';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_MedicalCard = {
  __typename?: 'Dispensaries_profile_medicalCard';
  expirationDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Plus_Settings = {
  __typename?: 'Dispensaries_profile_plus_settings';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  defaultReturnUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_StoreSettings = {
  __typename?: 'Dispensaries_storeSettings';
  /**
   * Controls when the AIQ (Alpine IQ) loyalty rewards flow triggers the SMS PIN send at checkout:
   * 'manual' (only after the customer clicks \"Connect to Loyalty Rewards\") or 'automatic' (on
   * checkout, matching pre-rollout behavior). Only takes effect once
   * pos.customers.aiq-sms-pin-trigger-setting.rollout is on for this dispensary; otherwise the
   * legacy pos.customers.skip-sms-sending.rollout flag continues to govern this behavior. See
   * POS-21141.
   */
  aiqSmsPinTriggerBehavior?: Maybe<Scalars['String']['output']>;
  blockOrderOnMMURAllotmentFailure?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Operational CloudPRNT setting (ECOMM-13006): enables automatic post-order print-job creation
   * (including the deferred kiosk flow) once a printer has been configured and tested. Settable
   * by any settings-authorized dispensary user, but can only be turned on while cloudPrntEnabled
   * is also true (or is being enabled in the same request) -- the mutation rejects the request
   * otherwise.
   */
  cloudPrntAutomaticPrintingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Super-admin-gated CloudPRNT entitlement (ECOMM-13006). Exposes the PRINTERS tab, printer
   * discovery/management, and manual test/reprint jobs. Only settable by a super admin; stripped
   * server-side if set by any other user. Explicitly disabling this also atomically clears
   * cloudPrntAutomaticPrintingEnabled so re-enabling the entitlement later cannot unexpectedly
   * resume automatic printing.
   */
  cloudPrntEnabled?: Maybe<Scalars['Boolean']['output']>;
  collapseProductDescription: Scalars['Boolean']['output'];
  configurablePurchaseLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  customPurchaseLimits?: Maybe<Scalars['JSON']['output']>;
  customTermsText?: Maybe<Scalars['String']['output']>;
  customerMessagingTermsAccepted: Scalars['Boolean']['output'];
  defaultViewStyle: MenuViewStyles;
  disableAIReviewModeration?: Maybe<Scalars['Boolean']['output']>;
  disableGuestCheckout: Scalars['Boolean']['output'];
  disableGuestDOB: Scalars['Boolean']['output'];
  disablePurchaseLimits: Scalars['Boolean']['output'];
  disableSpecialInstructions?: Maybe<Scalars['Boolean']['output']>;
  displayKioskAnonymousCheckoutDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  displayPhoneConfirmation: Scalars['Boolean']['output'];
  dontCombineWeightedProducts: Scalars['Boolean']['output'];
  dontMapSubcategoriesByProductName?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated used and defined in ordering-settings */
  enableAfterHoursOrderingForDelivery: Scalars['Boolean']['output'];
  /** @deprecated used and defined per order type in ordering-settings */
  enableAfterHoursOrderingForPickup: Scalars['Boolean']['output'];
  /**
   * Consumer-facing opt-in to the cart interstitial (consumer.ecomm.cart-interstitial.rollout).
   * Settable by any settings-authorized dispensary user, but only has effect while
   * enableDiscountGamification is also enabled for the store, mirroring the flag's LaunchDarkly
   * prerequisite on growth.ecomm.cart-v2.rollout.
   */
  enableCartInterstitial: Scalars['Boolean']['output'];
  enableConcierge?: Maybe<Scalars['Boolean']['output']>;
  enableCustomTerms?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Super-admin-only opt-in to the Discount Gamification beta, replacing the LaunchDarkly
   * "discount-gamification" segment as the per-store gate for growth.ecomm.cart-v2.rollout and
   * consumer.ecomm.gamification.rollout. Only settable by a super admin; stripped server-side if
   * set by any other user.
   */
  enableDiscountGamification: Scalars['Boolean']['output'];
  enableDutchiePayConsumerSurcharge?: Maybe<Scalars['Boolean']['output']>;
  enableKioskConcierge?: Maybe<Scalars['Boolean']['output']>;
  enableLLxSaleDiscountSync?: Maybe<Scalars['Boolean']['output']>;
  enableLimitPerCustomer: Scalars['Boolean']['output'];
  enableMMURAllotmentCheck?: Maybe<Scalars['Boolean']['output']>;
  enableMixAndMatchPricingForDelivery: Scalars['Boolean']['output'];
  enableMixAndMatchPricingForPickup: Scalars['Boolean']['output'];
  enableOmniauthLoginCheckout?: Maybe<Scalars['Boolean']['output']>;
  enableOrderStatusEmails: Scalars['Boolean']['output'];
  enableOrderTypeTakeoverModal?: Maybe<Scalars['Boolean']['output']>;
  enableOtherLocations?: Maybe<Scalars['Boolean']['output']>;
  enableProductUrgencyMessaging?: Maybe<Scalars['Boolean']['output']>;
  enableRoundToNearestDollar?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated used and defined in ordering-settings */
  enableScheduledOrderingForDelivery: Scalars['Boolean']['output'];
  /** @deprecated used and defined per order type in ordering-settings */
  enableScheduledOrderingForPickup: Scalars['Boolean']['output'];
  enableStorefrontAgeGate: Scalars['Boolean']['output'];
  /** @deprecated Age verification gate feature has been removed */
  hardAgeGateAgeVerification: Scalars['Boolean']['output'];
  hardAgeGateHideMenuContent: Scalars['Boolean']['output'];
  hideAddressFromDutchieMain: Scalars['Boolean']['output'];
  hideCannabinoidDescriptions: Scalars['Boolean']['output'];
  hideCategoryTiles?: Maybe<Scalars['Boolean']['output']>;
  hideDiscountsFromConsumer?: Maybe<Scalars['Boolean']['output']>;
  hideEffects: Scalars['Boolean']['output'];
  hideFilters?: Maybe<Scalars['Boolean']['output']>;
  hideFromMobileApp?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Super-admin-gated setting. When enabled, excludes this store from the /stores/sitemap.xml
   * index and adds noindex/nofollow robots meta tags to every page of its storefront menu, to
   * keep sandbox/test stores out of search engine results. Only settable by a super admin;
   * stripped server-side if set by any other user.
   */
  hideFromSearchEngines?: Maybe<Scalars['Boolean']['output']>;
  hideOutOfStockProducts: Scalars['Boolean']['output'];
  hideRoundingLineItem?: Maybe<Scalars['Boolean']['output']>;
  hideTotalTerpenes?: Maybe<Scalars['Boolean']['output']>;
  isolatedMenus: Scalars['Boolean']['output'];
  keepUncombinedWeights?: Maybe<Scalars['Boolean']['output']>;
  minimumAgeOverrides?: Maybe<GqlMinimumAgeOverrides>;
  priceRangeFilter?: Maybe<GqlPriceRangeFilterSettings>;
  prioritizeStaffPicksInSearchResults: Scalars['Boolean']['output'];
  provideBackInstockEmailNotifications: Scalars['Boolean']['output'];
  quantityLimit: Scalars['Int']['output'];
  quantityLimitMaxAvailable: Scalars['Boolean']['output'];
  requireEmailAddressForGuestCheckout: Scalars['Boolean']['output'];
  requireMedCardFieldsAtCheckout?: Maybe<Scalars['Boolean']['output']>;
  requireMedCardPhotoForDelivery?: Maybe<Scalars['Boolean']['output']>;
  requireMedCardPhotoForPickup?: Maybe<Scalars['Boolean']['output']>;
  requirePaymentMethodSelection?: Maybe<Scalars['Boolean']['output']>;
  requireTermsAcceptance?: Maybe<Scalars['Boolean']['output']>;
  restrictSalesLanguage?: Maybe<Scalars['Boolean']['output']>;
  rewardsIntegrationConfiguration?: Maybe<GqlRewards_Integration_Configuration>;
  showLoyaltyRewards?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer rendered or used */
  showMobileAppSmartBanner?: Maybe<Scalars['Boolean']['output']>;
  showPOSPackageId: Scalars['Boolean']['output'];
  /**
   * Super-admin-gated exception skipping the online age verification (signup and checkout
   * minimum-age check) that applies to the rest of the platform. Only settable by a super admin;
   * stripped server-side if set by any other user.
   */
  skipOnlineAgeVerification: Scalars['Boolean']['output'];
  specialsPage?: Maybe<GqlSpecialsPageSettings>;
  stealthMode: Scalars['Boolean']['output'];
  subscriptions: GqlDispensaries_Subscriptions;
  usePotencyForConcentrateLimits?: Maybe<Scalars['Boolean']['output']>;
  useStandardEquivalentForEdiblesLimits?: Maybe<Scalars['Boolean']['output']>;
  useStateRegulatedImageWatermarks?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_Subscriptions = {
  __typename?: 'Dispensaries_subscriptions';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_SubscriptionsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaries_Terminals = {
  __typename?: 'Dispensaries_terminals';
  _id?: Maybe<Scalars['String']['output']>;
  config?: Maybe<GqlDevice_Config>;
  /** @deprecated Use ISO field */
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  lastSeenAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryAccountManagers = {
  __typename?: 'DispensaryAccountManagers';
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryAdSettings = {
  __typename?: 'DispensaryAdSettings';
  enableAdsForDefault: Scalars['Boolean']['output'];
  enableAdsForEmbedded: Scalars['Boolean']['output'];
  enableAdsForKiosk: Scalars['Boolean']['output'];
  enableAdsForStoreFront: Scalars['Boolean']['output'];
};

export type GqlDispensaryAdSettingsInput = {
  enableAdsForDefault: Scalars['Boolean']['input'];
  enableAdsForEmbedded: Scalars['Boolean']['input'];
  enableAdsForKiosk: Scalars['Boolean']['input'];
  enableAdsForStoreFront: Scalars['Boolean']['input'];
};

export type GqlDispensaryAssetUploadResponse = {
  __typename?: 'DispensaryAssetUploadResponse';
  fileIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlDispensaryCalcsInput = {
  deliveryInfo?: InputMaybe<GqlDispensaryDeliveryInfoInput>;
  dispensaryTimezone?: InputMaybe<Scalars['String']['input']>;
  feeTiers?: InputMaybe<Array<InputMaybe<GqlDispensaryFeeTiersInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<GqlDispensaryLocationInput>;
  mixAndMatchPricingWeights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentFees?: InputMaybe<Array<InputMaybe<GqlDispensaryPaymentFeeInput>>>;
  specialsSettings?: InputMaybe<GqlDispensarySpecialsSettingsInput>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
  taxConfig?: InputMaybe<GqlDispensaryTaxConfigInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useDartDiscountsPath?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryDeliveryInfoInput = {
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  feeVaries?: InputMaybe<Scalars['Boolean']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  minimumVaries?: InputMaybe<Scalars['Boolean']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
  withinBounds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryDropdownOption = {
  __typename?: 'DispensaryDropdownOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryFeeTiersInput = {
  fee?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensaryHoursSettings = {
  __typename?: 'DispensaryHoursSettings';
  curbsidePickup?: Maybe<GqlHoursSettingsForOrderType>;
  delivery?: Maybe<GqlHoursSettingsForOrderType>;
  driveThruPickup?: Maybe<GqlHoursSettingsForOrderType>;
  inStorePickup?: Maybe<GqlHoursSettingsForOrderType>;
};

export type GqlDispensaryLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<GqlGeometryInput>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * cName -> name/address reference row for a single dispensary, used to
 * populate the enterprise-admin bulk-create-users location keyword table.
 */
export type GqlDispensaryLocationKeyword = {
  __typename?: 'DispensaryLocationKeyword';
  address?: Maybe<Scalars['String']['output']>;
  cName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum DispensaryOrderType {
  all = 'All',
  deliveryOnly = 'DeliveryOnly',
  kiosk = 'Kiosk',
  pickupAndDelivery = 'PickupAndDelivery',
  pickupOnly = 'PickupOnly'
}

export type GqlDispensaryPaymentFeeInput = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryPersonalizationSettings = {
  __typename?: 'DispensaryPersonalizationSettings';
  enablePersonalizationForDefault: Scalars['Boolean']['output'];
  enablePersonalizationForEmbedded: Scalars['Boolean']['output'];
  enablePersonalizationForKiosk: Scalars['Boolean']['output'];
  enablePersonalizationForStoreFront: Scalars['Boolean']['output'];
  enableSortByRelevance?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaryPersonalizationSettingsInput = {
  enablePersonalizationForDefault: Scalars['Boolean']['input'];
  enablePersonalizationForEmbedded: Scalars['Boolean']['input'];
  enablePersonalizationForKiosk: Scalars['Boolean']['input'];
  enablePersonalizationForStoreFront: Scalars['Boolean']['input'];
  enableSortByRelevance?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DispensaryRoles {
  complianceAndLegal = 'complianceAndLegal',
  customerSales = 'customerSales',
  customerSupport = 'customerSupport',
  financeAndAccounting = 'financeAndAccounting',
  fulfillmentAndDelivery = 'fulfillmentAndDelivery',
  informationTechnology = 'informationTechnology',
  inventoryManagement = 'inventoryManagement',
  marketingAndPromotions = 'marketingAndPromotions',
  storeOperations = 'storeOperations',
  unknown = 'unknown'
}

export type GqlDispensarySettingsAuditLog = {
  __typename?: 'DispensarySettingsAuditLog';
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorUserId?: Maybe<Scalars['String']['output']>;
  changedFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValues?: Maybe<Scalars['JSON']['output']>;
  priorValues?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensarySettingsAuditLogList = {
  __typename?: 'DispensarySettingsAuditLogList';
  logs?: Maybe<Array<GqlDispensarySettingsAuditLog>>;
  meta?: Maybe<GqlDispensarySettingsAuditLogsMeta>;
};

export type GqlDispensarySettingsAuditLogsMeta = {
  __typename?: 'DispensarySettingsAuditLogsMeta';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DispensarySortByType {
  deliveryEstimate = 'deliveryEstimate',
  deliveryFee = 'deliveryFee',
  deliveryMin = 'deliveryMin',
  distance = 'distance',
  integration = 'integration',
  pickupTime = 'pickupTime',
  terminal = 'terminal'
}

export type GqlDispensarySpecialsSettingsInput = {
  discountBehavior?: InputMaybe<Scalars['String']['input']>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']['input']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryStreamToken = {
  __typename?: 'DispensaryStreamToken';
  dispensaryId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryTaxConfigInput = {
  calculationMethod?: InputMaybe<Scalars['String']['input']>;
  discountTaxOrder?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Array<InputMaybe<GqlTaxConfigTaxInput>>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlDisplayConfig = {
  __typename?: 'DisplayConfig';
  dispensaryId?: Maybe<Scalars['String']['output']>;
  fallback?: Maybe<GqlDisplayConfigFallback>;
  locationId?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  playlists?: Maybe<Array<Maybe<GqlDisplayConfigPlaylist>>>;
  pollIntervalMs?: Maybe<Scalars['Int']['output']>;
  serverTime?: Maybe<Scalars['String']['output']>;
};

export type GqlDisplayConfigFallback = {
  __typename?: 'DisplayConfigFallback';
  logoUrl?: Maybe<Scalars['String']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
};

export type GqlDisplayConfigPendingChange = {
  __typename?: 'DisplayConfigPendingChange';
  activatesAt?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<GqlDisplayConfigPlaylistItem>>>;
};

export type GqlDisplayConfigPlaylist = {
  __typename?: 'DisplayConfigPlaylist';
  id?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<GqlDisplayConfigPlaylistItem>>>;
  name?: Maybe<Scalars['String']['output']>;
  pendingChange?: Maybe<GqlDisplayConfigPendingChange>;
  schedule?: Maybe<GqlDisplayConfigSchedule>;
};

export type GqlDisplayConfigPlaylistItem = {
  __typename?: 'DisplayConfigPlaylistItem';
  audioEnabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  transition?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlDisplayConfigSchedule = {
  __typename?: 'DisplayConfigSchedule';
  daysOfWeek?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlDriveThruPickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'DriveThruPickupOrderingSettings';
  autoConfirmSettings?: Maybe<GqlAutoConfirmSettings>;
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  creditCardByPhoneCheckoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  notificationSettings?: Maybe<GqlNotificationSettings>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlDropdownOption = {
  __typename?: 'DropdownOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDurationEstimateRange = {
  __typename?: 'DurationEstimateRange';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  highInMinutes?: Maybe<Scalars['Float']['output']>;
  lowInMinutes?: Maybe<Scalars['Float']['output']>;
};

export type GqlDurationEstimates = {
  __typename?: 'DurationEstimates';
  delivery?: Maybe<GqlDurationEstimateRange>;
  pickup?: Maybe<GqlDurationEstimateRange>;
};

export type GqlDutchiePay = {
  __typename?: 'DutchiePay';
  preAuth?: Maybe<GqlDutchiePayPreAuth>;
};

export type GqlDutchiePayEnrollment = {
  __typename?: 'DutchiePayEnrollment';
  bankAccounts: Array<Maybe<GqlMxBankAccount>>;
  billingAddress?: Maybe<GqlBillingAddress>;
  enrollment: GqlStatus;
};

export type GqlDutchiePayPaymentMethod = {
  __typename?: 'DutchiePayPaymentMethod';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  entity?: Maybe<GqlEntity>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DutchiePayPaymentMethodType {
  paymentMethodTypeBankAccount = 'PAYMENT_METHOD_TYPE_BANK_ACCOUNT',
  paymentMethodTypeUnspecified = 'PAYMENT_METHOD_TYPE_UNSPECIFIED'
}

export type GqlDutchiePayPreAuth = {
  __typename?: 'DutchiePayPreAuth';
  amount: Scalars['Int']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  callbackUrl: Scalars['String']['output'];
  currency: Scalars['Int']['output'];
  lastDigits?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['String']['output'];
  tipAmount?: Maybe<Scalars['Int']['output']>;
};

export type GqlDutchiePosLoyaltyConfig = {
  __typename?: 'DutchiePosLoyaltyConfig';
  accrualRate?: Maybe<Scalars['Float']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  /** @deprecated use expirationDate on RewardsListV2 instead */
  loyaltyDaysToExpiration?: Maybe<Scalars['Int']['output']>;
  loyaltyExpirationMode?: Maybe<Scalars['Int']['output']>;
  loyaltyRequireOptIn: Scalars['Boolean']['output'];
  loyaltyWidgetEnabledOnMobile?: Maybe<Scalars['Boolean']['output']>;
  loyaltyWidgetEnabledOnWeb?: Maybe<Scalars['Boolean']['output']>;
  maxRedemptionsPerTransaction?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  onlineDescription?: Maybe<Scalars['String']['output']>;
  onlineName?: Maybe<Scalars['String']['output']>;
  onlineRedemptionEnabledOnMobile?: Maybe<Scalars['Boolean']['output']>;
  onlineRedemptionEnabledOnWeb?: Maybe<Scalars['Boolean']['output']>;
  redemptionType?: Maybe<Scalars['String']['output']>;
  referralConfig?: Maybe<GqlDutchieReferralConfig>;
  requireVerifiedPhoneForEnrollmentOnEcomm?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requireVerifiedPhoneForEnrollmentOnEcomm */
  requireVerifiedPhoneForEnrollmentOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requireVerifiedPhoneForEnrollmentOnEcomm */
  requireVerifiedPhoneForEnrollmentOnWeb?: Maybe<Scalars['Boolean']['output']>;
  requireVerifiedPhoneForRedemptionOnEcomm?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requireVerifiedPhoneForRedemptionOnEcomm */
  requireVerifiedPhoneForRedemptionOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requireVerifiedPhoneForRedemptionOnEcomm */
  requireVerifiedPhoneForRedemptionOnWeb?: Maybe<Scalars['Boolean']['output']>;
  tierEarningBasis?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<GqlDutchiePosLoyaltyTier>>>;
  viewDiscountRewards?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDutchiePosLoyaltyTier = {
  __typename?: 'DutchiePosLoyaltyTier';
  accrualRate?: Maybe<Scalars['Float']['output']>;
  badgeColor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  threshold: Scalars['Int']['output'];
};

export type GqlDutchieReferralConfig = {
  __typename?: 'DutchieReferralConfig';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  minimumPurchaseAmount?: Maybe<Scalars['Float']['output']>;
  receiverReward?: Maybe<Scalars['Float']['output']>;
  senderReward?: Maybe<Scalars['Float']['output']>;
};

export type GqlEcommerceAbandonedCartsResponse = {
  __typename?: 'EcommerceAbandonedCartsResponse';
  carts?: Maybe<Array<Maybe<GqlCartSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlEcommerceConversionFunnel = {
  __typename?: 'EcommerceConversionFunnel';
  addedToCart?: Maybe<GqlEcommercePercent>;
  interacted?: Maybe<GqlEcommercePercent>;
  placedOrder?: Maybe<GqlEcommercePercent>;
  visitedCheckout?: Maybe<GqlEcommercePercent>;
  visitedMenu?: Maybe<GqlEcommercePercent>;
};

export type GqlEcommercePercent = {
  __typename?: 'EcommercePercent';
  currentValue?: Maybe<Scalars['Float']['output']>;
  percentOfVisits?: Maybe<Scalars['Float']['output']>;
  unitDifferenceFromLastPeriod?: Maybe<Scalars['Float']['output']>;
};

export type GqlEcommerceValue = {
  __typename?: 'EcommerceValue';
  currentValue?: Maybe<Scalars['Float']['output']>;
  percentDifference?: Maybe<Scalars['Float']['output']>;
};

export enum Effect {
  body = 'BODY',
  calm = 'CALM',
  clearMind = 'CLEAR_MIND',
  comfort = 'COMFORT',
  creative = 'CREATIVE',
  energetic = 'ENERGETIC',
  euphoric = 'EUPHORIC',
  focused = 'FOCUSED',
  happy = 'HAPPY',
  inspired = 'INSPIRED',
  joints = 'JOINTS',
  mind = 'MIND',
  muscles = 'MUSCLES',
  painRelief = 'PAIN_RELIEF',
  relaxed = 'RELAXED',
  skinHealth = 'SKIN_HEALTH',
  sleepy = 'SLEEPY'
}

export type GqlEffectiveHours = {
  __typename?: 'EffectiveHours';
  /** @deprecated new HoursSettingsForOrderType in hours-settings has effective hours per order type */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated new HoursSettingsForOrderType in hours-settings has effective hours per order type */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
};

export type GqlEnabledOrderTypes = {
  __typename?: 'EnabledOrderTypes';
  curbsidePickup?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  driveThruPickup?: Maybe<Scalars['Boolean']['output']>;
  inStorePickup?: Maybe<Scalars['Boolean']['output']>;
  kiosk?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlEnterprise = {
  __typename?: 'Enterprise';
  accountTier?: Maybe<Scalars['String']['output']>;
  billingVersion: Scalars['Int']['output'];
  createdAt: Scalars['ISODateTime']['output'];
  hasDposLoyalty?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  primaryContactId?: Maybe<Scalars['ID']['output']>;
  retailers: Array<GqlRetailer>;
  uniqueName: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
  voiceAiEnabled?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseBrand = {
  __typename?: 'EnterpriseBrand';
  name?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlEnterpriseCategory = {
  __typename?: 'EnterpriseCategory';
  category?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseDispensaryAdSettings = {
  __typename?: 'EnterpriseDispensaryAdSettings';
  adSettings: GqlDispensaryAdSettings;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlEnterpriseDispensaryPersonalizationSettings = {
  __typename?: 'EnterpriseDispensaryPersonalizationSettings';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personalizationSettings: GqlDispensaryPersonalizationSettings;
  status: Scalars['String']['output'];
};

export type GqlEnterpriseDispensaryProduct = {
  __typename?: 'EnterpriseDispensaryProduct';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseDomain = {
  __typename?: 'EnterpriseDomain';
  createdAt?: Maybe<Scalars['String']['output']>;
  domainType: EnterpriseDomainType;
  enterpriseId: Scalars['ID']['output'];
  hostname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationGroupId?: Maybe<Scalars['ID']['output']>;
  sslStatus: EnterpriseDomainSslStatus;
  status: EnterpriseDomainStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseDomainDnsRecord = {
  __typename?: 'EnterpriseDomainDnsRecord';
  name: Scalars['String']['output'];
  recordType: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlEnterpriseDomainEntriDnsRecord = {
  __typename?: 'EnterpriseDomainEntriDnsRecord';
  host: Scalars['String']['output'];
  ttl: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlEnterpriseDomainEntriToken = {
  __typename?: 'EnterpriseDomainEntriToken';
  applicationId: Scalars['String']['output'];
  dnsRecords: Array<GqlEnterpriseDomainEntriDnsRecord>;
  token: Scalars['String']['output'];
};

export type GqlEnterpriseDomainResolution = {
  __typename?: 'EnterpriseDomainResolution';
  defaultDispensaryId?: Maybe<Scalars['ID']['output']>;
  dispensaries: Array<GqlEnterpriseDomainResolutionDispensary>;
  enterpriseId: Scalars['ID']['output'];
  hostname: Scalars['String']['output'];
  websiteId?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseDomainResolutionDispensary = {
  __typename?: 'EnterpriseDomainResolutionDispensary';
  cName?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GqlEnterpriseDomainSetupInstructions = {
  __typename?: 'EnterpriseDomainSetupInstructions';
  records: Array<GqlEnterpriseDomainDnsRecord>;
};

export enum EnterpriseDomainSslStatus {
  active = 'active',
  errored = 'errored',
  pending = 'pending'
}

export enum EnterpriseDomainStatus {
  active = 'active',
  errored = 'errored',
  pending = 'pending',
  verifying = 'verifying'
}

export enum EnterpriseDomainType {
  apex = 'apex',
  subdomain = 'subdomain'
}

export type GqlEnterpriseLoyaltySettings = {
  __typename?: 'EnterpriseLoyaltySettings';
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dposLoyaltyIsoRegionCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseId: Scalars['ID']['output'];
  landingPageUrl?: Maybe<Scalars['String']['output']>;
  loyaltyEnrollmentUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  uniqueName: Scalars['String']['output'];
};

export type GqlEnterpriseLoyaltySettingsInput = {
  dposLoyaltyIsoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlEnterpriseMobileAppSettings = {
  __typename?: 'EnterpriseMobileAppSettings';
  androidAppIcon?: Maybe<Scalars['String']['output']>;
  androidExistingVersion?: Maybe<Scalars['String']['output']>;
  androidExistingVersionCode?: Maybe<Scalars['Int']['output']>;
  androidOrganizationName?: Maybe<Scalars['String']['output']>;
  androidPackageName?: Maybe<Scalars['String']['output']>;
  androidSplashBackgroundColor?: Maybe<Scalars['String']['output']>;
  automaticScreenshotGeneration?: Maybe<Scalars['Boolean']['output']>;
  buildForIpad?: Maybe<Scalars['Boolean']['output']>;
  chain?: Maybe<Scalars['String']['output']>;
  customFonts?: Maybe<Scalars['String']['output']>;
  firebaseProjectId?: Maybe<Scalars['String']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  iosAppIcon?: Maybe<Scalars['String']['output']>;
  iosAppStoreId?: Maybe<Scalars['String']['output']>;
  iosBundleIdentifier?: Maybe<Scalars['String']['output']>;
  iosExistingVersion?: Maybe<Scalars['String']['output']>;
  iosSplashBackgroundColor?: Maybe<Scalars['String']['output']>;
  iosTeamId?: Maybe<Scalars['String']['output']>;
  iosTeamName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shorebirdAppId?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseMobileAppSettingsInput = {
  androidAppIcon?: InputMaybe<Scalars['String']['input']>;
  androidExistingVersion?: InputMaybe<Scalars['String']['input']>;
  androidExistingVersionCode?: InputMaybe<Scalars['Int']['input']>;
  androidOrganizationName?: InputMaybe<Scalars['String']['input']>;
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
  androidSplashBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  automaticScreenshotGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  buildForIpad?: InputMaybe<Scalars['Boolean']['input']>;
  customFonts?: InputMaybe<Scalars['String']['input']>;
  firebaseProjectId?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  iosAppIcon?: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId?: InputMaybe<Scalars['String']['input']>;
  iosBundleIdentifier?: InputMaybe<Scalars['String']['input']>;
  iosExistingVersion?: InputMaybe<Scalars['String']['input']>;
  iosSplashBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  iosTeamId?: InputMaybe<Scalars['String']['input']>;
  iosTeamName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shorebirdAppId?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlEnterpriseProduct = {
  __typename?: 'EnterpriseProduct';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  dispensaryProducts?: Maybe<Array<Maybe<GqlEnterpriseDispensaryProduct>>>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priceSummaries?: Maybe<Array<GqlEnterpriseProductPriceSummary>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseProductPriceSummary = {
  __typename?: 'EnterpriseProductPriceSummary';
  maxMedicalPrice?: Maybe<Scalars['Float']['output']>;
  maxPrice?: Maybe<Scalars['Float']['output']>;
  maxRecPrice?: Maybe<Scalars['Float']['output']>;
  minMedicalPrice?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  minRecPrice?: Maybe<Scalars['Float']['output']>;
  option: Scalars['String']['output'];
};

export type GqlEnterpriseProducts = {
  __typename?: 'EnterpriseProducts';
  brands?: Maybe<Array<Maybe<GqlEnterpriseBrand>>>;
  categories?: Maybe<Array<Maybe<GqlEnterpriseCategory>>>;
  products?: Maybe<Array<Maybe<GqlEnterpriseProduct>>>;
};

export type GqlEnterpriseSpecial = {
  __typename?: 'EnterpriseSpecial';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  applyRewardsToConditions?: Maybe<Scalars['Boolean']['output']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoConditions?: Maybe<Array<Maybe<GqlBogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoRewards?: Maybe<Array<Maybe<GqlBogoRewardItem>>>;
  cipher?: Maybe<Scalars['JSON']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  discountedPrices?: Maybe<Scalars['JSON']['output']>;
  dispensaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  dollarDiscount?: Maybe<Scalars['Boolean']['output']>;
  duplicatedFrom?: Maybe<Scalars['String']['output']>;
  earliestStartStamp?: Maybe<Scalars['ISODateTime']['output']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailSpecial?: Maybe<Scalars['Boolean']['output']>;
  endDay?: Maybe<Scalars['ISODateTime']['output']>;
  endStamp?: Maybe<Scalars['ISODateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  enterpriseSpecialId?: Maybe<Scalars['String']['output']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']['output']>;
  excludedProducts?: Maybe<Array<Maybe<GqlSpecialsExcludedProducts>>>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactiveDispensaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  itemsForAPrice?: Maybe<GqlItemsForAPrice>;
  latestEndStamp?: Maybe<Scalars['ISODateTime']['output']>;
  localTime?: Maybe<Scalars['Boolean']['output']>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  productDiscounts?: Maybe<Scalars['JSON']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productGroupRewards?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recurring?: Maybe<GqlSpecialsRecurring>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use dispensaries instead. 11/11/2021 */
  retailers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  scope?: Maybe<SpecialScopes>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  specialRestrictions?: Maybe<Scalars['JSON']['output']>;
  specialType?: Maybe<SpecialTypes>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  startDay?: Maybe<Scalars['ISODateTime']['output']>;
  startStamp?: Maybe<Scalars['ISODateTime']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlEnterpriseSpecialInputV2 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableToItemsOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  applicationMethod?: InputMaybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: InputMaybe<Scalars['Boolean']['input']>;
  bogoConditionLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoConditions?: InputMaybe<Array<InputMaybe<GqlBogoConditionItemInput>>>;
  bogoRewardLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoRewards?: InputMaybe<Array<InputMaybe<GqlBogoRewardItemInput>>>;
  cipher?: InputMaybe<Scalars['JSON']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  conditionLogicOperator?: InputMaybe<LogicOperator>;
  conditions?: InputMaybe<Array<InputMaybe<GqlV4ConditionInput>>>;
  consumerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  discountBundle?: InputMaybe<GqlDiscountBundleInput>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  discountToCart?: InputMaybe<GqlDiscountToCartInput>;
  discountedPrices?: InputMaybe<Scalars['JSON']['input']>;
  dispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayRank?: InputMaybe<Scalars['Int']['input']>;
  dollarDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['String']['input']>;
  earliestStartStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  editedStartStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<GqlSpecialEmailInput>;
  emailSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  endDay?: InputMaybe<Scalars['String']['input']>;
  endStamp?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  enterpriseSpecialId?: InputMaybe<Scalars['String']['input']>;
  excludeConditionItemsFromRewards?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedProductsInput>>>;
  firstTimeConsumerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  generatedByPOS?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  inactiveDispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inactiveDispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  itemsForAPrice?: InputMaybe<GqlItemsForAPriceInput>;
  latestEndStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  localTime?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyPointsToRedeem?: InputMaybe<Scalars['Int']['input']>;
  manualDefaultApplyTo?: InputMaybe<ManualDefaultApplyTo>;
  menuDisplay?: InputMaybe<GqlSpecialMenuDisplayInput>;
  menuDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  menuDisplayImage?: InputMaybe<Scalars['String']['input']>;
  menuDisplayName?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<OrderType>;
  origin?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  percentDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  productDiscounts?: InputMaybe<Array<InputMaybe<GqlProductDiscount>>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroupRewards?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quantityUsed?: InputMaybe<Scalars['Int']['input']>;
  recurring?: InputMaybe<GqlSpecialsInputRecurring>;
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerCart?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Int']['input']>;
  reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  requireManagerApproval?: InputMaybe<Scalars['Boolean']['input']>;
  rewardLogicOperator?: InputMaybe<LogicOperator>;
  rewards?: InputMaybe<Array<InputMaybe<GqlV4RewardInput>>>;
  saleDiscounts?: InputMaybe<Array<InputMaybe<GqlSaleDiscountInput>>>;
  schedule?: InputMaybe<GqlSpecialScheduleInput>;
  scope?: InputMaybe<SpecialScopes>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialRestrictions?: InputMaybe<Array<InputMaybe<GqlSpecialRestriction>>>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  specialVersion?: InputMaybe<Scalars['Int']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingMode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDay?: InputMaybe<Scalars['String']['input']>;
  startStamp?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SpecialStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  targetPrice?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlEnterpriseSpecialsHistory = {
  __typename?: 'EnterpriseSpecialsHistory';
  enterpriseSpecialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
};

export type GqlEntity = {
  __typename?: 'Entity';
  externalId?: Maybe<Scalars['String']['output']>;
  externalType?: Maybe<EntityTypes>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlEntityLinkingCodeResponse = {
  __typename?: 'EntityLinkingCodeResponse';
  code: Scalars['String']['output'];
};

export enum EntityTypes {
  dispensary = 'Dispensary',
  user = 'User'
}

export type GqlErrorMessage = {
  __typename?: 'ErrorMessage';
  message: Scalars['String']['output'];
};

export type GqlExcludedBogoProduct = {
  __typename?: 'ExcludedBOGOProduct';
  Name?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type GqlExcludedBogoProducts = {
  __typename?: 'ExcludedBOGOProducts';
  conditions?: Maybe<Array<Maybe<GqlExcludedBogoProduct>>>;
  rewards?: Maybe<Array<Maybe<GqlExcludedBogoProduct>>>;
};

export type GqlExclusion = {
  __typename?: 'Exclusion';
  _id?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalBrandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalCategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalSubcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  matchOperator?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<ProductGroup>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightOperator?: Maybe<WeightOperator>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlExclusionInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalSubcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  matchOperator?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<ProductGroup>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightOperator?: InputMaybe<WeightOperator>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlExists = {
  __typename?: 'Exists';
  _id?: Maybe<Scalars['String']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlExport = {
  __typename?: 'Export';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type GqlExportDispensaryUsersPayload = {
  __typename?: 'ExportDispensaryUsersPayload';
  csv: Scalars['String']['output'];
};

export type GqlExportFilteredCatalogFilterInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  stateLibrary?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<LibraryProductStatusEnum>;
  subcategory?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlExportFilteredCatalogResponse = {
  __typename?: 'ExportFilteredCatalogResponse';
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  filters: GqlExportFilteredCatalogResponseFilters;
  name: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  progressPercentage: Scalars['Float']['output'];
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status: ExportFilteredCatalogStatusEnum;
  totalCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlExportFilteredCatalogResponseFilters = {
  __typename?: 'ExportFilteredCatalogResponseFilters';
  brandIds?: Maybe<Array<Scalars['ID']['output']>>;
  category?: Maybe<Array<Scalars['String']['output']>>;
  search?: Maybe<Scalars['String']['output']>;
  stateLibrary?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<LibraryProductStatusEnum>;
  subcategory?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ExportFilteredCatalogStatusEnum {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'inProgress',
  pending = 'pending'
}

export type GqlExtensionData = {
  __typename?: 'ExtensionData';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlExtensionDataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GqlFeaturedBrandsSetting = {
  __typename?: 'FeaturedBrandsSetting';
  brandIds: Array<Scalars['String']['output']>;
  category: Scalars['String']['output'];
};

export type GqlFeaturedProductsSetting = {
  __typename?: 'FeaturedProductsSetting';
  category: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type GqlFeeTiersInput = {
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  maximumInCents?: InputMaybe<Scalars['Int']['input']>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export enum FeeTypes {
  flat = 'flat',
  percent = 'percent'
}

export type GqlFees = {
  __typename?: 'Fees';
  deliveryFee?: Maybe<Scalars['Boolean']['output']>;
  feeAmount?: Maybe<Scalars['Int']['output']>;
  feeItemId?: Maybe<Scalars['Int']['output']>;
  feeName?: Maybe<Scalars['String']['output']>;
  paymentFee?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlFilteredBrandSummaryResponse = {
  __typename?: 'FilteredBrandSummaryResponse';
  brands?: Maybe<Array<Maybe<GqlBrandSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlFilteredCatalogExport = {
  __typename?: 'FilteredCatalogExport';
  brandName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFailed: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  progressPercentage: Scalars['Float']['output'];
  s3Url?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status: BrandExportsStatusEnum;
  totalCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlFilteredEnterpriseSpecials = {
  __typename?: 'FilteredEnterpriseSpecials';
  queryInfo?: Maybe<GqlFilteredSpecialsInfo>;
  specials?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
};

export type GqlFilteredProductSummaryResponse = {
  __typename?: 'FilteredProductSummaryResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  products?: Maybe<Array<Maybe<GqlProductSummary>>>;
};

export type GqlFilteredSpecials = {
  __typename?: 'FilteredSpecials';
  queryInfo?: Maybe<GqlFilteredSpecialsInfo>;
  specials?: Maybe<Array<Maybe<GqlSpecials>>>;
};

export type GqlFilteredSpecialsInfo = {
  __typename?: 'FilteredSpecialsInfo';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlFindLibraryProductsResponse = {
  __typename?: 'FindLibraryProductsResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
};

export type GqlFontInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type GqlFontSettings = {
  __typename?: 'FontSettings';
  family: CustomFont;
};

export type GqlFontSettingsInput = {
  family: CustomFont;
};

export type GqlFonts = {
  __typename?: 'Fonts';
  body?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
};

export type GqlFraudPaymentMethod = {
  paymentType: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type GqlFundRethinkResponse = {
  __typename?: 'FundRethinkResponse';
  redirectUrl: Scalars['String']['output'];
};

export type GqlGamificationDetailItem = {
  __typename?: 'GamificationDetailItem';
  discountId?: Maybe<Scalars['Int']['output']>;
  meetsAllConstraints?: Maybe<Scalars['Boolean']['output']>;
  satisfiers?: Maybe<Array<Maybe<GqlGamificationDetailItem_Satisfier>>>;
};

export type GqlGamificationDetailItem_Satisfier = {
  __typename?: 'GamificationDetailItem_Satisfier';
  minimumThreshold?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<GqlGamificationDetailItem_Satisfiers_Product>>>;
  thresholdMet?: Maybe<Scalars['Boolean']['output']>;
  thresholdType?: Maybe<Scalars['String']['output']>;
};

export type GqlGamificationDetailItem_Satisfiers_Product = {
  __typename?: 'GamificationDetailItem_Satisfiers_Product';
  amount?: Maybe<Scalars['Float']['output']>;
  ecommKey?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
};

export type GqlGenericExportResponse = {
  __typename?: 'GenericExportResponse';
  count?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlGenericResponse = {
  __typename?: 'GenericResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlGeoJson_Features = {
  __typename?: 'GeoJson_features';
  geometry?: Maybe<GqlGeoJson_Geometry>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlGeoJson_FeaturesInput = {
  geometry?: InputMaybe<GqlGeoJson_GeometryInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGeoJson_Geometry = {
  __typename?: 'GeoJson_geometry';
  coordinates?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlGeoJson_GeometryInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGeographicSearchBounds = {
  lat: Scalars['String']['input'];
  lon: Scalars['String']['input'];
  radius: Scalars['String']['input'];
};

export type GqlGeometryInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type GqlGetAchPaymentDetailsResponse = {
  __typename?: 'GetAchPaymentDetailsResponse';
  payment?: Maybe<GqlPayment>;
};

export type GqlGetAchPaymentFraudAssessmentsResponse = {
  __typename?: 'GetAchPaymentFraudAssessmentsResponse';
  assessments: Array<GqlAssessment>;
};

export type GqlGetCollectionProductCountConditionInput = {
  condition: Scalars['String']['input'];
  itemKey: Scalars['String']['input'];
  itemValue: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlGetCollectionProductCountInput = {
  allConditions: Scalars['Boolean']['input'];
  conditions: Array<InputMaybe<GqlGetCollectionProductCountConditionInput>>;
};

export type GqlGetOrderSortInput = {
  desc: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type GqlGetOrderType = {
  __typename?: 'GetOrderType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<GqlOrders>;
};

export type GqlGetPersonalizedProductsInput = {
  dispensaryId: Scalars['String']['input'];
  filter: GqlPersonalizedProductsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlGetPersonalizedProductsV2Input = {
  dispensaryId: Scalars['String']['input'];
  filters: GqlPersonalizedProductsFilterV2;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelName: PersonalizedProductsModelNames;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlGetRawAchBatchFileResponse = {
  __typename?: 'GetRawAchBatchFileResponse';
  data?: Maybe<GqlAchRawBatchFile>;
};

export type GqlGetSortedProductRecommendationsInput = {
  dispensaryId: Scalars['String']['input'];
  filter: GqlPersonalizedProductsFilterV2;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlGetSponsoredBrandInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  filters?: InputMaybe<GqlGetSponsoredResourceFilters>;
  inventoryId: AdInventoryId;
  maximumProducts?: InputMaybe<Scalars['Int']['input']>;
  minimumProducts?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlGetSponsoredProductsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  filters?: InputMaybe<GqlGetSponsoredResourceFilters>;
  inventoryId: SponsoredProductsInventoryId;
  limit: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGetSponsoredProductsPlacementsInput = {
  dispensaryId: Scalars['String']['input'];
  page: SponsoredProductsPlacementsPage;
  uiVariant: Scalars['String']['input'];
};

export type GqlGetSponsoredResourceFilters = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  potencyCbd?: InputMaybe<GqlPotencyRange>;
  potencyThc?: InputMaybe<GqlPotencyRange>;
  strainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGetUserStatusResponse = {
  __typename?: 'GetUserStatusResponse';
  eligible: Scalars['Boolean']['output'];
  incentive?: Maybe<GqlIncentive>;
};

export enum GlobalMenuOrder {
  popular = 'popular',
  potencyHighToLow = 'potencyHighToLow',
  potencyLowToHigh = 'potencyLowToHigh',
  priceHighToLow = 'priceHighToLow',
  priceLowToHigh = 'priceLowToHigh',
  recentlyAdded = 'recentlyAdded',
  relevance = 'relevance'
}

export type GqlGlobalReward = {
  __typename?: 'GlobalReward';
  amountOff?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<DiscountType>;
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  percentDiscount?: Maybe<Scalars['Float']['output']>;
};

export type GqlGlobalRewardInput = {
  amountOff?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountedPrice?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlGlobalThreshold = {
  __typename?: 'GlobalThreshold';
  comparisonOperator?: Maybe<ComparisonOperators>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  thresholdType?: Maybe<GlobalThresholdType>;
  weight?: Maybe<GqlWeight>;
};

export type GqlGlobalThresholdInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  thresholdType?: InputMaybe<GlobalThresholdType>;
  weight?: InputMaybe<GqlWeightInput>;
};

export enum GlobalThresholdType {
  totalPrice = 'TOTAL_PRICE',
  totalQuantity = 'TOTAL_QUANTITY',
  totalWeight = 'TOTAL_WEIGHT'
}

export type GqlGoogleProtobufTimestamp = {
  __typename?: 'GoogleProtobufTimestamp';
  nanos?: Maybe<Scalars['Int']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

export type GqlHealthCheck = {
  __typename?: 'HealthCheck';
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlHoursForOrderType = {
  effectiveHours?: InputMaybe<GqlWeeklyHoursInput>;
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlHoursSettingsForOrderType = {
  __typename?: 'HoursSettingsForOrderType';
  effectiveHours?: Maybe<GqlWeeklyHours>;
  hours?: Maybe<GqlWeeklyHours>;
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
};

export type GqlHoursSettingsForOrderTypeInput = {
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlHoursSettingsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  delivery?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
};

export type GqlHypurDetails = {
  __typename?: 'HypurDetails';
  id: Scalars['String']['output'];
};

export type GqlHypurRedirect = {
  __typename?: 'HypurRedirect';
  url: Scalars['String']['output'];
};

export type GqlHypurToken = {
  __typename?: 'HypurToken';
  accessToken: Scalars['String']['output'];
  embedded: Scalars['Boolean']['output'];
};

export type GqlIpInfo = {
  __typename?: 'IPInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  loc?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlIdImage = {
  __typename?: 'IdImage';
  key?: Maybe<Scalars['String']['output']>;
};

export type GqlIdUrl = {
  __typename?: 'IdUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlIdentityAdmin = {
  __typename?: 'IdentityAdmin';
  _id: Scalars['ID']['output'];
  appPermissionsEnforced?: Maybe<Scalars['Boolean']['output']>;
  assumedSession?: Maybe<GqlAssumedSessionInfo>;
  canAssumeRole?: Maybe<Scalars['Boolean']['output']>;
  chainDispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  emails: Array<Maybe<GqlUserEmails>>;
  enterpriseId?: Maybe<Scalars['ID']['output']>;
  profile: GqlIdentityAdminProfile;
  zendeskSingleSignOnToken?: Maybe<Scalars['String']['output']>;
  zendeskWidgetToken?: Maybe<Scalars['String']['output']>;
};

export type GqlIdentityAdminProfile = {
  __typename?: 'IdentityAdminProfile';
  acceptedTOS?: Maybe<Scalars['ISODateTime']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  audioNotificationsOnNewArrivalsDisabled?: Maybe<Scalars['Boolean']['output']>;
  audioNotificationsOnNewOrdersDisabled?: Maybe<Scalars['Boolean']['output']>;
  browserNotification?: Maybe<Scalars['Boolean']['output']>;
  chainID?: Maybe<Scalars['String']['output']>;
  chainId?: Maybe<Scalars['String']['output']>;
  desktopNotification?: Maybe<Scalars['Boolean']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstViewedTOS?: Maybe<Scalars['ISODateTime']['output']>;
  focusedAccounts?: Maybe<Array<GqlBrandUserFocusedAccount>>;
  fullName?: Maybe<Scalars['String']['output']>;
  isWeeklyReportEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  managedBrandIds?: Maybe<Array<Scalars['ID']['output']>>;
  parentBrandId?: Maybe<Scalars['ID']['output']>;
  permissions?: Maybe<GqlIdentityAdminProfilePermissions>;
  phone?: Maybe<Scalars['String']['output']>;
  roleAtDispensary?: Maybe<DispensaryRoles>;
  streamTokens?: Maybe<Array<Maybe<GqlDispensaryStreamToken>>>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlIdentityAdminProfilePermissions = {
  __typename?: 'IdentityAdminProfilePermissions';
  allLocations: Scalars['Boolean']['output'];
  analytics: Scalars['Boolean']['output'];
  billing: Scalars['Boolean']['output'];
  brandAppPermissions?: Maybe<Array<Scalars['String']['output']>>;
  customers: Scalars['Boolean']['output'];
  dispensaryIds?: Maybe<Array<Scalars['String']['output']>>;
  driver: Scalars['Boolean']['output'];
  editBrandUsers?: Maybe<Scalars['Boolean']['output']>;
  enterpriseAdmin?: Maybe<Scalars['Boolean']['output']>;
  enterpriseSpecials?: Maybe<Scalars['Boolean']['output']>;
  manageAdCampaigns: Scalars['Boolean']['output'];
  manageAds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use manageBrandGroup */
  manageAllBrands?: Maybe<Scalars['Boolean']['output']>;
  manageBrandGroup?: Maybe<Scalars['Boolean']['output']>;
  manageBrands?: Maybe<Scalars['Boolean']['output']>;
  managePersonalization?: Maybe<Scalars['Boolean']['output']>;
  menu: Scalars['Boolean']['output'];
  menuReview?: Maybe<Scalars['Boolean']['output']>;
  messaging: Scalars['Boolean']['output'];
  orders: Scalars['Boolean']['output'];
  promote: Scalars['Boolean']['output'];
  settings: Scalars['Boolean']['output'];
  superMenuReview?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  techSupportFeatures?: Maybe<Scalars['Boolean']['output']>;
  users: Scalars['Boolean']['output'];
};

export type GqlIdentityConsumer = {
  __typename?: 'IdentityConsumer';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  emails: Array<Maybe<GqlUserEmails>>;
  payByBankEnrollmentStatus?: Maybe<GqlShowEnrollmentResponse>;
  profile: GqlIdentityConsumerProfile;
  segmentIds: Array<Scalars['String']['output']>;
};


export type GqlIdentityConsumerSegmentIdsArgs = {
  dispensaryId: Scalars['String']['input'];
};

export type GqlIdentityConsumerProfile = {
  __typename?: 'IdentityConsumerProfile';
  address?: Maybe<GqlConsumerUserProfileAddressType>;
  birthday?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  inStoreEnrollmentCompleted?: Maybe<Scalars['Boolean']['output']>;
  isExternalUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<GqlConsumerUserMedicalCard>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerifiedAt?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlImageBanner = {
  __typename?: 'ImageBanner';
  _id: Scalars['String']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  bannerType?: Maybe<ImageBannerType>;
  connectedId?: Maybe<Scalars['String']['output']>;
  connectedStatus?: Maybe<Scalars['String']['output']>;
  connectedType?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use platforms.link instead */
  link?: Maybe<Scalars['String']['output']>;
  mobileImage: Scalars['String']['output'];
  /** @deprecated Use platforms.openInNewTab instead */
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  platforms?: Maybe<Array<Maybe<GqlImageBannerPlatform>>>;
  position: Scalars['Int']['output'];
  schedule?: Maybe<GqlSchedule>;
};

export type GqlImageBannerPlatform = {
  __typename?: 'ImageBannerPlatform';
  enabled: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  type: ImageBannerPlatformType;
};

export type GqlImageBannerPlatformInput = {
  enabled: Scalars['Boolean']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  type: ImageBannerPlatformType;
};

export enum ImageBannerPlatformType {
  iosMobileApp = 'iosMobileApp',
  kiosk = 'kiosk',
  web = 'web'
}

export enum ImageBannerType {
  category = 'category',
  collection = 'collection',
  link = 'link',
  special = 'special'
}

export enum ImageOrigin {
  admin = 'admin',
  library = 'library',
  pos = 'pos'
}

export enum ImageVariantKeyEnum {
  specialLogoImage = 'SpecialLogoImage',
  bannerImage = 'bannerImage',
  brandedDutchiePayLogoDark = 'brandedDutchiePayLogoDark',
  brandedDutchiePayLogoLight = 'brandedDutchiePayLogoLight',
  embeddedLogoImage = 'embeddedLogoImage',
  listImage = 'listImage',
  logoImage = 'logoImage'
}

export type GqlImgixSettings = {
  __typename?: 'ImgixSettings';
  border?: Maybe<Scalars['String']['output']>;
  fit?: Maybe<ImgixSettings_FitType>;
  mark?: Maybe<Scalars['String']['output']>;
  markpad?: Maybe<Scalars['Int']['output']>;
  markscale?: Maybe<Scalars['Int']['output']>;
};

export enum ImgixSettings_FitType {
  crop = 'crop',
  fill = 'fill',
  fillmax = 'fillmax'
}

export type GqlImportMenuCsvInput = {
  customFieldMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomFieldInput>>>;
  id: Scalars['String']['input'];
  menuImportData?: InputMaybe<Scalars['String']['input']>;
};

export type GqlInStorePickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'InStorePickupOrderingSettings';
  autoConfirmSettings?: Maybe<GqlAutoConfirmSettings>;
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  creditCardByPhoneCheckoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  notificationSettings?: Maybe<GqlNotificationSettings>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlIncentive = {
  __typename?: 'Incentive';
  active: Scalars['Boolean']['output'];
  amountCents: Scalars['Int']['output'];
  cohortName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GqlInsightsFilterInput = {
  dposLocationGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excessStockMax?: InputMaybe<Scalars['Float']['input']>;
  excessStockMin?: InputMaybe<Scalars['Float']['input']>;
  excessValueMax?: InputMaybe<Scalars['Float']['input']>;
  excessValueMin?: InputMaybe<Scalars['Float']['input']>;
  expiringMax?: InputMaybe<Scalars['Float']['input']>;
  expiringMin?: InputMaybe<Scalars['Float']['input']>;
  inventoryLevel?: InputMaybe<InsightsInventoryLevelEnum>;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  lowStockMax?: InputMaybe<Scalars['Float']['input']>;
  lowStockMin?: InputMaybe<Scalars['Float']['input']>;
  lspAccounts?: InputMaybe<Array<GqlLspAccountFilter>>;
  /** Dollar ranges include opted-in rows only; opted-out rows expose tiers. */
  netSalesMax?: InputMaybe<Scalars['Float']['input']>;
  /** Dollar ranges include opted-in rows only; opted-out rows expose tiers. */
  netSalesMin?: InputMaybe<Scalars['Float']['input']>;
  optInStatus?: InputMaybe<Scalars['Boolean']['input']>;
  outOfStockMax?: InputMaybe<Scalars['Float']['input']>;
  outOfStockMin?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Ignored by getBrandLspsOverview - the LSP summary rollup has no
   * per-location revenue aggregate to filter on.
   */
  revenueMax?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Ignored by getBrandLspsOverview - the LSP summary rollup has no
   * per-location revenue aggregate to filter on.
   */
  revenueMin?: InputMaybe<Scalars['Float']['input']>;
};

export enum InsightsInventoryLevelEnum {
  excess = 'excess',
  expiring = 'expiring',
  lowStock = 'low_stock',
  outOfStock = 'out_of_stock'
}

export enum InsightsSortByEnum {
  atRiskUnits = 'atRiskUnits',
  backstockUnits = 'backstockUnits',
  excessOpportunity = 'excessOpportunity',
  expiringStockAlerts = 'expiringStockAlerts',
  gmvOpportunity = 'gmvOpportunity',
  locationName = 'locationName',
  lowStockAlerts = 'lowStockAlerts',
  netSales = 'netSales',
  onFloorUnits = 'onFloorUnits',
  outOfStockAlerts = 'outOfStockAlerts',
  overStockAlerts = 'overStockAlerts',
  retailChainName = 'retailChainName',
  revenueL4w = 'revenueL4w',
  state = 'state'
}

export type GqlInsightsSortInput = {
  sortBy?: InputMaybe<InsightsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlInstoreAnalyticsToken = {
  __typename?: 'InstoreAnalyticsToken';
  instoreAnalyticsTokenId: Scalars['String']['output'];
};

export type GqlInstoreCart = {
  __typename?: 'InstoreCart';
  currency: Scalars['String']['output'];
  discounts?: Maybe<Array<GqlSubtotalItem>>;
  fees?: Maybe<Array<GqlSubtotalItem>>;
  id: Scalars['String']['output'];
  items: Array<GqlInstoreCartItem>;
  subtotalCents: Scalars['Int']['output'];
  taxes: Array<GqlSubtotalItem>;
  tipCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export type GqlInstoreCartDataType = {
  __typename?: 'InstoreCartDataType';
  instoreCart: GqlInstoreCart;
  retailerId: Scalars['String']['output'];
  tippingDisabled: Scalars['Boolean']['output'];
};

export type GqlInstoreCartItem = {
  __typename?: 'InstoreCartItem';
  brandName: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  valueCents: Scalars['Int']['output'];
};

export type GqlIntegrationBackofficeLocation = {
  __typename?: 'IntegrationBackofficeLocation';
  licenseNumber?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  lspId?: Maybe<Scalars['Int']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrations = {
  __typename?: 'Integrations';
  _id?: Maybe<Scalars['String']['output']>;
  adapter?: Maybe<Scalars['String']['output']>;
  backofficeLocation?: Maybe<GqlIntegrationBackofficeLocation>;
  categoryMapping?: Maybe<Array<Maybe<GqlIntegrationsCategoryMapping>>>;
  createdAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  credentials?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated HubSpot ecomm integration has been sunset; always resolves to null */
  crmPipelineMapping?: Maybe<GqlIntegrationsPipelineMapping>;
  /** @deprecated HubSpot ecomm integration has been sunset; always resolves to null */
  crmPropertyMapping?: Maybe<Array<Maybe<GqlIntegrationsPropertyMapping>>>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  failedSyncs?: Maybe<Scalars['Int']['output']>;
  fieldMapping?: Maybe<Array<Maybe<GqlIntegrationsFieldMapping>>>;
  flags?: Maybe<Scalars['JSON']['output']>;
  forceSyncRequestedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  integrationCategory?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  isRunning?: Maybe<Scalars['Boolean']['output']>;
  kioskThresholds?: Maybe<Scalars['JSON']['output']>;
  lastImportedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<GqlIntegrationsMeta>;
  pending?: Maybe<Scalars['Boolean']['output']>;
  syncFailureMessage?: Maybe<Scalars['String']['output']>;
  syncFailureType?: Maybe<Scalars['String']['output']>;
  thresholds?: Maybe<Scalars['JSON']['output']>;
  types?: Maybe<Scalars['JSON']['output']>;
  weights?: Maybe<Scalars['JSON']['output']>;
};

export type GqlIntegrationsAdapterStatus = {
  __typename?: 'IntegrationsAdapterStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<IntegrationsAdapterStatusCode>;
};

export enum IntegrationsAdapterStatusCode {
  degraded = 'DEGRADED',
  down = 'DOWN',
  normal = 'NORMAL'
}

export type GqlIntegrationsCategoryMapping = {
  __typename?: 'IntegrationsCategoryMapping';
  foreignCategory?: Maybe<Scalars['String']['output']>;
  localCategory?: Maybe<Scalars['String']['output']>;
  localSubcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsCustomFieldInput = {
  foreignField?: InputMaybe<Scalars['String']['input']>;
  localField?: InputMaybe<Scalars['String']['input']>;
};

export type GqlIntegrationsCustomTypeInput = {
  foreignCategory?: InputMaybe<Scalars['String']['input']>;
  localCategory?: InputMaybe<Scalars['String']['input']>;
  localSubcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlIntegrationsFieldMapping = {
  __typename?: 'IntegrationsFieldMapping';
  foreignField?: Maybe<Scalars['String']['output']>;
  localField?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsMeta = {
  __typename?: 'IntegrationsMeta';
  custom_types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shopifyFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlIntegrationsPipelineMapping = {
  __typename?: 'IntegrationsPipelineMapping';
  mappings?: Maybe<GqlMappingTypes>;
  pipelineId?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsPropertyMapping = {
  __typename?: 'IntegrationsPropertyMapping';
  foreignProperty?: Maybe<Scalars['String']['output']>;
  localProperty?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsUpdateFieldsInput = {
  customFieldMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomFieldInput>>>;
  id: Scalars['String']['input'];
};

export type GqlIntegrationsUpdateInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlIntegrationsUpdateThresholdsInput = {
  id: Scalars['String']['input'];
  kioskThresholds?: InputMaybe<Scalars['JSON']['input']>;
  thresholds?: InputMaybe<Scalars['JSON']['input']>;
};

export type GqlIntegrationsUpdateTypesInput = {
  customCategoryMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomTypeInput>>>;
  id: Scalars['String']['input'];
};

export enum InternalDataLoaders {
  archivedOrderLoader = 'archivedOrderLoader',
  availableReservationsLoader = 'availableReservationsLoader',
  brandLoader = 'brandLoader',
  bucketProductLoader = 'bucketProductLoader',
  chargebeeCustomerLoader = 'chargebeeCustomerLoader',
  chargebeeInvoiceLoader = 'chargebeeInvoiceLoader',
  chargebeePaymentSourceLoader = 'chargebeePaymentSourceLoader',
  chargebeePlanLoader = 'chargebeePlanLoader',
  chargebeeSubscriptionLoader = 'chargebeeSubscriptionLoader',
  collectionLoader = 'collectionLoader',
  curbsideArrivalByOrderLoader = 'curbsideArrivalByOrderLoader',
  dispensaryBillingLoader = 'dispensaryBillingLoader',
  dispensaryLoader = 'dispensaryLoader',
  integrationsByDispensaryLoader = 'integrationsByDispensaryLoader',
  libraryProductLoader = 'libraryProductLoader',
  orderLoader = 'orderLoader',
  productLoader = 'productLoader',
  strainByTerpeneLoader = 'strainByTerpeneLoader',
  strainLoader = 'strainLoader',
  terpeneByStrainLoader = 'terpeneByStrainLoader',
  userLoader = 'userLoader'
}

export enum InventoryOpportunityEnum {
  high = 'High',
  low = 'Low',
  medium = 'Medium'
}

export type GqlInventoryOverviewFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum InventoryStatusEnum {
  expiring = 'expiring',
  healthy = 'healthy',
  lowStock = 'lowStock',
  outOfStock = 'outOfStock',
  overStock = 'overStock'
}

export type GqlIrlEvent = {
  __typename?: 'IrlEvent';
  description: Scalars['String']['output'];
  hasIncentive: Scalars['Boolean']['output'];
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  irlEventId: Scalars['ID']['output'];
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  optInRequired: Scalars['Boolean']['output'];
  shopNowUrl?: Maybe<Scalars['String']['output']>;
  startDateUtc?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type GqlIrlEventReward = {
  __typename?: 'IrlEventReward';
  description?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  rewardImageUrl?: Maybe<Scalars['String']['output']>;
  rewardName?: Maybe<Scalars['String']['output']>;
  rewardType: IrlEventRewardType;
  shopNowUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GqlIrlEventRewardResponse = {
  __typename?: 'IrlEventRewardResponse';
  primary: GqlIrlEventReward;
};

export enum IrlEventRewardType {
  discount = 'discount',
  loyalty = 'loyalty',
  none = 'none'
}

export enum IrlEventTrackingEvent {
  enrolledLoyalty = 'enrolledLoyalty',
  login = 'login',
  noRewardExistingLoyaltyUser = 'noRewardExistingLoyaltyUser',
  noRewardNewLoyaltyUser = 'noRewardNewLoyaltyUser',
  noRewardNoLoyaltyUser = 'noRewardNoLoyaltyUser',
  open = 'open',
  rewardExistingLoyaltyUser = 'rewardExistingLoyaltyUser',
  rewardNewLoyaltyUser = 'rewardNewLoyaltyUser',
  rewardNoLoyaltyUser = 'rewardNoLoyaltyUser',
  shopNowClicked = 'shopNowClicked',
  signup = 'signup',
  skippedLoyalty = 'skippedLoyalty'
}

export type GqlItemDiscounts = {
  __typename?: 'ItemDiscounts';
  total?: Maybe<Scalars['Int']['output']>;
};

export type GqlItemTax = {
  __typename?: 'ItemTax';
  feeItemId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  showOnCheckout?: Maybe<Scalars['Boolean']['output']>;
  showOnMenu?: Maybe<Scalars['Boolean']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxType?: Maybe<Scalars['String']['output']>;
};

export type GqlItemTaxes = {
  __typename?: 'ItemTaxes';
  cannabis?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GqlItemsForAPrice = {
  __typename?: 'ItemsForAPrice';
  _id?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlItemsForAPriceInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlKioskEntry = {
  __typename?: 'KioskEntry';
  claimedAt?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  destinationTerminal?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type GqlKioskEntryInput = {
  claimedAt?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  destinationTerminal?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastSeenAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GqlKioskInput = {
  anonymousCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousCheckoutMessage?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSettings?: InputMaybe<GqlAutoConfirmSettingsInput>;
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  creditCardByPhoneCheckoutMessage?: InputMaybe<Scalars['String']['input']>;
  directedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  disableFasterCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fullNameOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hideEmailField?: InputMaybe<Scalars['Boolean']['input']>;
  hidePhoneField?: InputMaybe<Scalars['Boolean']['input']>;
  kioskInstructions?: InputMaybe<Scalars['String']['input']>;
  kiosks?: InputMaybe<Array<GqlKioskEntryInput>>;
  notesField?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<GqlNotificationSettingsInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  phoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  screensaverText?: InputMaybe<Scalars['String']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  timeout?: InputMaybe<GqlKioskTimeoutInput>;
  type?: InputMaybe<KioskTypes>;
};

export type GqlKioskOrderingSettings = {
  __typename?: 'KioskOrderingSettings';
  anonymousCheckout?: Maybe<Scalars['Boolean']['output']>;
  anonymousCheckoutMessage?: Maybe<Scalars['String']['output']>;
  autoConfirmSettings?: Maybe<GqlAutoConfirmSettings>;
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  creditCardByPhoneCheckoutMessage?: Maybe<Scalars['String']['output']>;
  directedOrders?: Maybe<Scalars['Boolean']['output']>;
  disableFasterCheckout?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fullNameOnly?: Maybe<Scalars['Boolean']['output']>;
  hideEmailField?: Maybe<Scalars['Boolean']['output']>;
  hidePhoneField?: Maybe<Scalars['Boolean']['output']>;
  kioskInstructions?: Maybe<Scalars['String']['output']>;
  kiosks?: Maybe<Array<GqlKioskEntry>>;
  notesField?: Maybe<Scalars['Boolean']['output']>;
  notificationSettings?: Maybe<GqlNotificationSettings>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  phoneRequired?: Maybe<Scalars['Boolean']['output']>;
  screensaverText?: Maybe<Scalars['String']['output']>;
  showBirthdateField?: Maybe<Scalars['Boolean']['output']>;
  timeout?: Maybe<GqlTimeoutConfig>;
  type?: Maybe<KioskTypes>;
};

/**
 * stillClaimed is three-valued: true (still claimed, no action), false (a live, explicit
 * answer -- the id is unclaimed or no longer exists; the only value that should clear a stored
 * kiosk id), or null (ambiguous -- a DB error occurred; callers must no-op).
 */
export type GqlKioskSeenResult = {
  __typename?: 'KioskSeenResult';
  stillClaimed?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GqlKioskTerminal = {
  __typename?: 'KioskTerminal';
  dispensaryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
};

export type GqlKioskTimeoutInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum KioskTypes {
  basic = 'BASIC',
  pro = 'PRO'
}

export type GqlLatestCompletedTransaction = {
  __typename?: 'LatestCompletedTransaction';
  loyaltyPointsEarned?: Maybe<Scalars['Float']['output']>;
  orderCompletedUtc?: Maybe<Scalars['ISODateTime']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  payByBank?: Maybe<GqlLatestCompletedTransactionPayByBank>;
  shipmentId?: Maybe<Scalars['String']['output']>;
};

export type GqlLatestCompletedTransactionPayByBank = {
  __typename?: 'LatestCompletedTransactionPayByBank';
  accountLast4?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
};

export type GqlLegacyCalculationResults = {
  __typename?: 'LegacyCalculationResults';
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  bottleDepositTaxExistence?: Maybe<GqlTaxExistence>;
  cannabisTax?: Maybe<Scalars['Float']['output']>;
  cannabisTaxExistence?: Maybe<GqlTaxExistence>;
  cartSubtotal?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  details?: Maybe<Array<Maybe<GqlDetailItem>>>;
  lineitems?: Maybe<Array<Maybe<GqlLineItem>>>;
  menuTotal?: Maybe<Scalars['Float']['output']>;
  mixAndMatch?: Maybe<Scalars['Float']['output']>;
  otherFees?: Maybe<Scalars['Float']['output']>;
  paymentFee?: Maybe<Scalars['Int']['output']>;
  paymentIncentives?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  receipt?: Maybe<Scalars['JSON']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  rounding?: Maybe<Scalars['Float']['output']>;
  roundupForCharityAmount?: Maybe<Scalars['Float']['output']>;
  salesTaxExistence?: Maybe<GqlTaxExistence>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tip?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type GqlLegacyCalculationsInput = {
  appliedRewards?: InputMaybe<Array<InputMaybe<GqlAppliedReward>>>;
  bypassCanadaDeliveryTax?: InputMaybe<Scalars['Boolean']['input']>;
  cart?: InputMaybe<Scalars['JSON']['input']>;
  couponValue?: InputMaybe<GqlCouponValueInput>;
  deliveryOption?: InputMaybe<Scalars['String']['input']>;
  dispensary?: InputMaybe<GqlDispensaryCalcsInput>;
  firstTimePBBUser?: InputMaybe<Scalars['Boolean']['input']>;
  manualDiscount?: InputMaybe<Scalars['Float']['input']>;
  medicalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  priceService?: InputMaybe<Scalars['String']['input']>;
  roundupForCharityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tipValue?: InputMaybe<GqlTipValueInput>;
  toMenu?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlLibraryAsset = {
  __typename?: 'LibraryAsset';
  aiGenerated: Scalars['Boolean']['output'];
  contentHash: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  enterpriseId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  folderId?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  type: LibraryAssetType;
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type GqlLibraryAssetConnection = {
  __typename?: 'LibraryAssetConnection';
  items: Array<GqlLibraryAsset>;
  total: Scalars['Int']['output'];
};

export type GqlLibraryAssetFilters = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LibraryAssetType>;
};

export enum LibraryAssetType {
  image = 'image',
  svg = 'svg',
  video = 'video'
}

export type GqlLibraryFolder = {
  __typename?: 'LibraryFolder';
  assetCount: Scalars['Int']['output'];
  enterpriseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type GqlLibraryImportJob = {
  __typename?: 'LibraryImportJob';
  channel: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
};

export type GqlLibraryProduct = {
  __typename?: 'LibraryProduct';
  availableForWholesale?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  cannabinoidRatio?: Maybe<Scalars['String']['output']>;
  cannabinoids?: Maybe<Array<GqlProducts_CannabinoidV2>>;
  caseSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlProductPotency>;
  changeRequests?: Maybe<Array<GqlProductChangeRequest>>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<GqlUsers>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  dosageMg?: Maybe<Scalars['Float']['output']>;
  effects?: Maybe<Scalars['JSON']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<GqlProducts_Images>>>;
  menuScore: Scalars['Float']['output'];
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  msrpCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  packSize?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  productBatchId?: Maybe<Scalars['ID']['output']>;
  productTemplate?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  stateLibrary?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockImage?: Maybe<Scalars['String']['output']>;
  stockImageAliases?: Maybe<Scalars['String']['output']>;
  stockImageCategory?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  suggestedCannabinoidRatio?: Maybe<Scalars['String']['output']>;
  suggestedDosageMg?: Maybe<Scalars['Float']['output']>;
  suggestedPackSize?: Maybe<Scalars['Int']['output']>;
  suggestedStrainName?: Maybe<Scalars['String']['output']>;
  suggestedWeightGrams?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<GqlLibraryProductTag>>;
  terpenes?: Maybe<Array<GqlProducts_Terpene>>;
  thcContent?: Maybe<GqlProductPotency>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<GqlLibraryProductUpdater>;
  updatedByBrand?: Maybe<Scalars['Boolean']['output']>;
  weightGrams?: Maybe<Scalars['Float']['output']>;
  wholesalePriceInCents?: Maybe<Scalars['Int']['output']>;
  wholesaleVariants?: Maybe<Array<GqlWholesaleVariant>>;
};

export type GqlLibraryProductCannabinoidsInputV2 = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cannabinoidId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlLibraryProductChangeImpactCount = {
  __typename?: 'LibraryProductChangeImpactCount';
  count?: Maybe<Scalars['Int']['output']>;
};

export type GqlLibraryProductChangeImpactResponse = {
  __typename?: 'LibraryProductChangeImpactResponse';
  totalCount?: Maybe<GqlLibraryProductChangeImpactCount>;
};

export type GqlLibraryProductLimitPerCustomerInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLibraryProductManualInventoryInput = {
  inventory?: InputMaybe<Scalars['Int']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLibraryProductPotencyInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  unit: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum LibraryProductSortByEnum {
  brandName = 'brandName',
  category = 'category',
  connectedCount = 'connectedCount',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  description = 'description',
  menuScore = 'menuScore',
  name = 'name',
  stateLibrary = 'stateLibrary',
  updatedAt = 'updatedAt'
}

export enum LibraryProductStatusEnum {
  active = 'Active',
  archived = 'Archived',
  inactive = 'Inactive'
}

export type GqlLibraryProductTag = {
  __typename?: 'LibraryProductTag';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: BrandTagKind;
  value: Scalars['String']['output'];
};

export type GqlLibraryProductTerpenesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  terpeneId: Scalars['ID']['input'];
  unit: PotencyUnit;
  value?: InputMaybe<Scalars['Float']['input']>;
  values: Array<InputMaybe<Scalars['Float']['input']>>;
};

export type GqlLibraryProductUpdater = {
  __typename?: 'LibraryProductUpdater';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
};

export type GqlLibraryProducts = {
  __typename?: 'LibraryProducts';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlLibraryStats = {
  __typename?: 'LibraryStats';
  tagCounts: Array<GqlLibraryTagCount>;
  total: Scalars['Int']['output'];
};

export type GqlLibraryTagCount = {
  __typename?: 'LibraryTagCount';
  count: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type GqlLibraryUploadIntent = {
  __typename?: 'LibraryUploadIntent';
  alreadyInLibrary: Scalars['Boolean']['output'];
  alreadyUploaded: Scalars['Boolean']['output'];
  contentHash: Scalars['String']['output'];
  existingAsset?: Maybe<GqlLibraryAsset>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlLineItem = {
  __typename?: 'LineItem';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum LinkColor {
  aqua_1 = 'AQUA_1',
  aqua_2 = 'AQUA_2',
  aqua_3 = 'AQUA_3',
  blue_1 = 'BLUE_1',
  blue_2 = 'BLUE_2',
  blue_3 = 'BLUE_3',
  blue_4 = 'BLUE_4',
  blue_5 = 'BLUE_5',
  green_1 = 'GREEN_1',
  green_2 = 'GREEN_2',
  green_3 = 'GREEN_3',
  green_4 = 'GREEN_4',
  harvestBlue_1 = 'HARVEST_BLUE_1',
  orange_1 = 'ORANGE_1',
  orange_2 = 'ORANGE_2',
  orange_3 = 'ORANGE_3',
  pink_1 = 'PINK_1',
  pink_2 = 'PINK_2',
  purple_1 = 'PURPLE_1',
  purple_2 = 'PURPLE_2',
  purple_3 = 'PURPLE_3',
  purple_4 = 'PURPLE_4',
  red_1 = 'RED_1',
  red_2 = 'RED_2',
  red_3 = 'RED_3'
}

export type GqlListAccountBalancesResponse = {
  __typename?: 'ListAccountBalancesResponse';
  accountBalances: Array<GqlAccountBalance>;
};

export type GqlListAchBatchesResponse = {
  __typename?: 'ListAchBatchesResponse';
  achBatches?: Maybe<Array<GqlAchBatch>>;
};

export type GqlListAchEntriesResponse = {
  __typename?: 'ListAchEntriesResponse';
  achEntries?: Maybe<Array<GqlAchEntry>>;
};

export type GqlListAchEntriesResponseV3 = {
  __typename?: 'ListAchEntriesResponseV3';
  achEntries: Array<GqlAchEntryV2>;
};

export type GqlListAchReturnsResponse = {
  __typename?: 'ListAchReturnsResponse';
  achReturns?: Maybe<Array<GqlAchReturn>>;
};

export type GqlListAchReturnsResponseV3 = {
  __typename?: 'ListAchReturnsResponseV3';
  achReturns: Array<GqlAchReturnV2>;
};

export type GqlListAchReturnsResponseV4 = {
  __typename?: 'ListAchReturnsResponseV4';
  achReturns: Array<GqlAchReturnV4>;
};

export type GqlListAchReturnsResponseV5 = {
  __typename?: 'ListAchReturnsResponseV5';
  achReturns: Array<GqlAchReturnV5>;
};

export enum ListBrandsSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export type GqlListEntitiesResponse = {
  __typename?: 'ListEntitiesResponse';
  entities: Array<GqlEntity>;
};

export enum ListLibraryProductsSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export enum LoaderType {
  hasMany = 'HAS_MANY',
  hasOne = 'HAS_ONE',
  join = 'JOIN'
}

export type GqlLocationGroup = {
  __typename?: 'LocationGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enterpriseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  retailerIds?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlLocationStatsProductOption = {
  __typename?: 'LocationStatsProductOption';
  price: Scalars['Float']['output'];
  weight: Scalars['String']['output'];
};

export type GqlLocationTransferNumber = {
  __typename?: 'LocationTransferNumber';
  retailerId: Scalars['ID']['output'];
  transferPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlLocationTransferNumberInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  retailerId: Scalars['ID']['input'];
};

export enum LogicOperator {
  and = 'AND',
  or = 'OR'
}

export type GqlLoginAdmin = {
  __typename?: 'LoginAdmin';
  accessToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GqlIdentityAdmin>;
};

export type GqlLoginConsumer = {
  __typename?: 'LoginConsumer';
  accessToken?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  transferToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GqlIdentityConsumer>;
};

export type GqlLoyaltyMemberResponse = {
  __typename?: 'LoyaltyMemberResponse';
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  posCustomerId?: Maybe<Scalars['String']['output']>;
};

export type GqlLoyaltyPassDispensaries = {
  __typename?: 'LoyaltyPassDispensaries';
  locGlobalIds: Array<Scalars['String']['output']>;
  locIds: Array<Scalars['Int']['output']>;
  lspGlobalIds: Array<Scalars['String']['output']>;
  lspIds: Array<Scalars['Int']['output']>;
};

export type GqlLoyaltyPassToken = {
  __typename?: 'LoyaltyPassToken';
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type GqlLoyaltyPassUrl = {
  __typename?: 'LoyaltyPassUrl';
  shortUrl?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GqlLspAccount = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId: Scalars['String']['input'];
  dposServerRegion: Scalars['String']['input'];
  sandboxUse?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLspAccountFilter = {
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use dposLspGlobalId. */
  dposLspId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use dposLspGlobalId. */
  dposServerRegion?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLspBrand = {
  __typename?: 'LspBrand';
  brand: GqlBrand;
  insights: GqlLspBrandInsightsLight;
  settings?: Maybe<GqlLspBrandSettings>;
};

export type GqlLspBrandInsightsLight = {
  __typename?: 'LspBrandInsightsLight';
  totalSales: Scalars['Int']['output'];
};

export type GqlLspBrandSearchSort = {
  sortBy: LspBrandSearchSortByEnum;
  sortDirection: StringSortDirections;
};

export enum LspBrandSearchSortByEnum {
  name = 'name'
}

export type GqlLspBrandSettings = {
  __typename?: 'LspBrandSettings';
  createdAt: Scalars['ISODateTime']['output'];
  dataSharingEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlLspBrandSettingsBulkInput = {
  brandId: Scalars['String']['input'];
  settings: GqlLspBrandSettingsInput;
};

export type GqlLspBrandSettingsInput = {
  dataSharingEnabled: Scalars['Boolean']['input'];
};

export type GqlLspBrandsList = {
  __typename?: 'LspBrandsList';
  queryInfo: GqlQueryInfoType;
  results: Array<GqlLspBrand>;
};

export type GqlLspSettingsAuditEntry = {
  __typename?: 'LspSettingsAuditEntry';
  actorEmail?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['JSONObject']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  dposLspGlobalId?: Maybe<Scalars['String']['output']>;
  dposServerLspId?: Maybe<Scalars['Int']['output']>;
  dposServerRegion?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lspName?: Maybe<Scalars['String']['output']>;
  modelType: Scalars['String']['output'];
};

export type GqlLspSettingsAuditLogResponse = {
  __typename?: 'LspSettingsAuditLogResponse';
  auditEntries: Array<GqlLspSettingsAuditEntry>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum LspSettingsAuditLogSortByEnum {
  createdAt = 'createdAt'
}

export type GqlLspSettingsAuditLogSortInput = {
  sortBy?: InputMaybe<LspSettingsAuditLogSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum ManualDefaultApplyTo {
  allitems = 'ALLITEMS',
  distributed = 'DISTRIBUTED',
  justone = 'JUSTONE',
  wholeline = 'WHOLELINE'
}

export type GqlMappingTypes = {
  __typename?: 'MappingTypes';
  abandoned?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['String']['output']>;
  inTransit?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['String']['output']>;
};

export type GqlMarkAchEntryAsReturnedResponse = {
  __typename?: 'MarkAchEntryAsReturnedResponse';
  achReturn: GqlAchReturn;
};

export type GqlMarkAchEntryAsReturnedResponseV3 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV3';
  achReturn: GqlAchReturnV2;
};

export type GqlMarkAchEntryAsReturnedResponseV4 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV4';
  achReturn: GqlAchReturnV4;
};

export type GqlMarkAchEntryAsReturnedResponseV5 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV5';
  achReturn: GqlAchReturnV5;
};

export type GqlMarkBrandPortalUserNotificationsAsReadInput = {
  isRead: Scalars['Boolean']['input'];
  userNotificationIds: Array<Scalars['ID']['input']>;
};

export type GqlMarketingCampaignsResponse = {
  __typename?: 'MarketingCampaignsResponse';
  campaigns?: Maybe<Array<Maybe<GqlCampaignSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlMarketingCouponsResponse = {
  __typename?: 'MarketingCouponsResponse';
  coupons?: Maybe<Array<Maybe<GqlCouponSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlMarketingDataPointsResponse = {
  __typename?: 'MarketingDataPointsResponse';
  marketingRevenue?: Maybe<Array<Maybe<GqlMarketingRevenue>>>;
  totalCampaignsCents?: Maybe<Scalars['Float']['output']>;
  totalCouponsCents?: Maybe<Scalars['Float']['output']>;
  totalRevenueCents?: Maybe<Scalars['Float']['output']>;
  totalSpecialsCents?: Maybe<Scalars['Float']['output']>;
};

export type GqlMarketingRevenue = {
  __typename?: 'MarketingRevenue';
  campaignsCents?: Maybe<Scalars['Float']['output']>;
  couponsCents?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  revenueCents?: Maybe<Scalars['Float']['output']>;
  specialsCents?: Maybe<Scalars['Float']['output']>;
};

export type GqlMarketingSpecialsResponse = {
  __typename?: 'MarketingSpecialsResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  specials?: Maybe<Array<Maybe<GqlSpecialSummary>>>;
};

export type GqlMarketplaceProduct = {
  __typename?: 'MarketplaceProduct';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['ID']['output']>;
  cannabinoids: Array<GqlNamedProductPotency>;
  category: Scalars['String']['output'];
  cbdContent?: Maybe<GqlProductPotency>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  terpenes: Array<GqlNamedProductPotency>;
  thcContent?: Maybe<GqlProductPotency>;
};

export type GqlMarketplaceProductLocation = {
  __typename?: 'MarketplaceProductLocation';
  consumerType?: Maybe<ProductConsumerType>;
  id?: Maybe<Scalars['String']['output']>;
  point: GqlMarketplaceProductLocationGeometry;
};

export type GqlMarketplaceProductLocationGeometry = {
  __typename?: 'MarketplaceProductLocationGeometry';
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
};

export type GqlMarketplaceProductLocationStats = {
  __typename?: 'MarketplaceProductLocationStats';
  marketplaceProduct: GqlMarketplaceProduct;
  nearbyStoreCount: Scalars['Int']['output'];
  options?: Maybe<Array<GqlLocationStatsProductOption>>;
};

export type GqlMarketplaceProductOption = {
  __typename?: 'MarketplaceProductOption';
  price: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type GqlMarketplaceProductSearchResult = {
  __typename?: 'MarketplaceProductSearchResult';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  cbdContent?: Maybe<GqlProductPotency>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<GqlProducts_Images>>>;
  locations: Array<Maybe<GqlMarketplaceProductLocation>>;
  minPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  options: Array<Maybe<GqlMarketplaceProductOption>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stockImage?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlProductPotency>;
  totalTerpenes?: Maybe<GqlProductPotency>;
};

export type GqlMaxReservationSlot = {
  __typename?: 'MaxReservationSlot';
  active?: Maybe<Scalars['Boolean']['output']>;
  currentCount?: Maybe<Scalars['Int']['output']>;
  currentCountsByDate?: Maybe<Scalars['JSONObject']['output']>;
  date?: Maybe<Scalars['ISODate']['output']>;
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  isNextDaySlot?: Maybe<Scalars['Boolean']['output']>;
  maxOrders?: Maybe<Scalars['Int']['output']>;
  recurrence?: Maybe<GqlSlotRecurrence>;
  slotId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlMaxReservationSlotInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currentCount?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['ISODate']['input']>;
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  maxOrders?: InputMaybe<Scalars['Int']['input']>;
  recurrence?: InputMaybe<GqlSlotRecurrenceInput>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMaxReservationSlotsByDay = {
  __typename?: 'MaxReservationSlotsByDay';
  Friday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Monday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Saturday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Sunday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Thursday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Tuesday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Wednesday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
};

export type GqlMaxReservationSlotsByDayInput = {
  Friday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Monday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Saturday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Sunday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Thursday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Tuesday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Wednesday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
};

export type GqlMaxReservationSlotsByOrderType = {
  __typename?: 'MaxReservationSlotsByOrderType';
  curbsidePickup?: Maybe<GqlMaxReservationSlotsGroup>;
  delivery?: Maybe<GqlMaxReservationSlotsGroup>;
  driveThruPickup?: Maybe<GqlMaxReservationSlotsGroup>;
  inStorePickup?: Maybe<GqlMaxReservationSlotsGroup>;
};

export type GqlMaxReservationSlotsGroup = {
  __typename?: 'MaxReservationSlotsGroup';
  maxReservationSlotsByDate?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  maxReservationSlotsByDay?: Maybe<GqlMaxReservationSlotsByDay>;
};

export type GqlMenuCleanup = {
  __typename?: 'MenuCleanup';
  products: Array<Maybe<GqlProducts>>;
  queryInfo: GqlQueryInfoType;
};

export type GqlMenuDesignInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  menuDisplayImage?: InputMaybe<Scalars['String']['input']>;
  menuDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMenuFilterChipsSettings = {
  __typename?: 'MenuFilterChipsSettings';
  showAllItems?: Maybe<Scalars['Boolean']['output']>;
  showBogo?: Maybe<Scalars['Boolean']['output']>;
  showBundles?: Maybe<Scalars['Boolean']['output']>;
  showEndingSoon?: Maybe<Scalars['Boolean']['output']>;
  showEverydayDeals?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlMenuFilterChipsSettingsInput = {
  showAllItems?: InputMaybe<Scalars['Boolean']['input']>;
  showBogo?: InputMaybe<Scalars['Boolean']['input']>;
  showBundles?: InputMaybe<Scalars['Boolean']['input']>;
  showEndingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  showEverydayDeals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlMenuFilterTerpene = {
  __typename?: 'MenuFilterTerpene';
  compound_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  potency_id?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
  unitSymbol: Scalars['String']['output'];
  values: Array<Scalars['Float']['output']>;
};

export type GqlMenuFilters = {
  __typename?: 'MenuFilters';
  brands: Array<Maybe<GqlBrand>>;
  categoriesSubcategories: Array<GqlCategorySubcategories>;
  effects: Array<Maybe<Scalars['String']['output']>>;
  hasProductsOnSpecial?: Maybe<Scalars['Boolean']['output']>;
  strainTypes: Array<Maybe<Scalars['String']['output']>>;
  subcategories: Array<Maybe<Scalars['String']['output']>>;
  terpenes: Array<Maybe<GqlMenuFilterTerpene>>;
  weights: Array<Maybe<Scalars['String']['output']>>;
};

export type GqlMenuOrderSetting = {
  __typename?: 'MenuOrderSetting';
  category: Scalars['String']['output'];
  menuOrder: CategoryMenuOrder;
};

export type GqlMenuScore = {
  __typename?: 'MenuScore';
  category?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlMenuSection = {
  __typename?: 'MenuSection';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionSchedule?: Maybe<GqlSchedule>;
  dispensary: GqlDispensaries;
  dispensaryId: Scalars['String']['output'];
  headingOverride?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<GqlImageBanner>;
  label: Scalars['String']['output'];
  legacyLabel?: Maybe<Scalars['String']['output']>;
  linkLabel: Scalars['String']['output'];
  mobileAppDisplayType?: Maybe<MobileAppProductCollectionDisplayType>;
  mobileAppFlairType?: Maybe<MobileAppFlair>;
  position: Scalars['Int']['output'];
  products?: Maybe<Array<Scalars['ID']['output']>>;
  sectionName?: Maybe<Scalars['String']['output']>;
  sectionType: MenuSectionType;
  sortBy?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export enum MenuSectionType {
  brand = 'BRAND',
  category = 'CATEGORY',
  collection = 'COLLECTION',
  custom = 'CUSTOM',
  image = 'IMAGE',
  offers = 'OFFERS',
  recentlyViewed = 'RECENTLY_VIEWED',
  recommendedForYou = 'RECOMMENDED_FOR_YOU',
  specials = 'SPECIALS',
  staffPicks = 'STAFF_PICKS',
  subcategory = 'SUBCATEGORY',
  topSellers = 'TOP_SELLERS'
}

export type GqlMenuSortSetting = {
  __typename?: 'MenuSortSetting';
  brands?: Maybe<Array<Scalars['String']['output']>>;
  category: Scalars['String']['output'];
  menuOrder: Scalars['String']['output'];
};

export type GqlMenuSortSettingInput = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  category: Scalars['String']['input'];
  menuOrder: Scalars['String']['input'];
};

export enum MenuTypes {
  both = 'both',
  medical = 'medical',
  recreational = 'recreational'
}

export enum MenuViewStyles {
  cards = 'cards',
  list = 'list'
}

export type GqlMenuWipeEvent = {
  __typename?: 'MenuWipeEvent';
  productsWiped: Scalars['Int']['output'];
  wipedAt: Scalars['ISODateTime']['output'];
};

export type GqlMergeLibraryProductsMeta = {
  __typename?: 'MergeLibraryProductsMeta';
  failedSeverIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type GqlMergeLibraryProductsResponse = {
  __typename?: 'MergeLibraryProductsResponse';
  destination?: Maybe<GqlLibraryProduct>;
  meta?: Maybe<GqlMergeLibraryProductsMeta>;
};

export type GqlMeta = {
  __typename?: 'Meta';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlMinimumAgeOverrides = {
  __typename?: 'MinimumAgeOverrides';
  country: Scalars['String']['output'];
  medical?: Maybe<Scalars['Int']['output']>;
  rec?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
};

export type GqlMinimumAgeOverridesInput = {
  country: Scalars['String']['input'];
  medical?: InputMaybe<Scalars['Int']['input']>;
  rec?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
};

export type GqlMobileAppAnalyticsMostVisitedPagesResponse = {
  __typename?: 'MobileAppAnalyticsMostVisitedPagesResponse';
  pages?: Maybe<Array<Maybe<GqlMobileAppMostVisitedPage>>>;
};

export type GqlMobileAppAnalyticsPageViewsResponse = {
  __typename?: 'MobileAppAnalyticsPageViewsResponse';
  daily?: Maybe<Array<Maybe<GqlMobileAppDailyDataPoint>>>;
};

export type GqlMobileAppDailyDataPoint = {
  __typename?: 'MobileAppDailyDataPoint';
  date?: Maybe<Scalars['String']['output']>;
  pageViews?: Maybe<Scalars['Int']['output']>;
  sessions?: Maybe<Scalars['Int']['output']>;
  totalDownloads?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
};

export enum MobileAppFlair {
  angled = 'ANGLED',
  checkerBoard = 'CHECKER_BOARD',
  curved = 'CURVED',
  jagged = 'JAGGED',
  none = 'NONE',
  wavy = 'WAVY'
}

export type GqlMobileAppMostVisitedPage = {
  __typename?: 'MobileAppMostVisitedPage';
  pagePath?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export enum MobileAppProductCollectionDisplayType {
  grid = 'GRID',
  heroCarousel = 'HERO_CAROUSEL',
  scrollableRow = 'SCROLLABLE_ROW'
}

export type GqlMobileCustomization = {
  __typename?: 'MobileCustomization';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundFlair?: Maybe<MobileAppFlair>;
  bottomBarActiveColor?: Maybe<Scalars['String']['output']>;
  bottomBarBackgroundColor?: Maybe<Scalars['String']['output']>;
  bottomBarInactiveColor?: Maybe<Scalars['String']['output']>;
  bottomBarStyle?: Maybe<MobileNavigationStyle>;
  buttonFlair?: Maybe<MobileAppFlair>;
  dividerFlair?: Maybe<MobileAppFlair>;
  headerBackgroundColor?: Maybe<Scalars['String']['output']>;
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  headerImageUrlV2?: Maybe<Scalars['String']['output']>;
  headerNavigationStyle?: Maybe<MobileNavigationStyle>;
  loadingFlair?: Maybe<MobileAppFlair>;
  showTabLabels?: Maybe<Scalars['Boolean']['output']>;
  tabDisplay?: Maybe<GqlMobileCustomizationTabDisplay>;
  tabLabels?: Maybe<GqlMobileCustomizationTabLabels>;
  titleFlair?: Maybe<MobileAppFlair>;
  titleFlairColor?: Maybe<Scalars['String']['output']>;
};

export type GqlMobileCustomizationInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundFlair?: InputMaybe<MobileAppFlair>;
  bottomBarActiveColor?: InputMaybe<Scalars['String']['input']>;
  bottomBarBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  bottomBarInactiveColor?: InputMaybe<Scalars['String']['input']>;
  bottomBarStyle?: InputMaybe<MobileNavigationStyle>;
  buttonFlair?: InputMaybe<MobileAppFlair>;
  dividerFlair?: InputMaybe<MobileAppFlair>;
  headerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  headerImageUrlV2?: InputMaybe<Scalars['String']['input']>;
  headerNavigationStyle?: InputMaybe<MobileNavigationStyle>;
  loadingFlair?: InputMaybe<MobileAppFlair>;
  showTabLabels?: InputMaybe<Scalars['Boolean']['input']>;
  tabDisplay?: InputMaybe<GqlMobileCustomizationTabDisplayInput>;
  tabLabels?: InputMaybe<GqlMobileCustomizationTabLabelsInput>;
  titleFlair?: InputMaybe<MobileAppFlair>;
  titleFlairColor?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMobileCustomizationTabDisplay = {
  __typename?: 'MobileCustomizationTabDisplay';
  showCart?: Maybe<Scalars['Boolean']['output']>;
  showConcierge?: Maybe<Scalars['Boolean']['output']>;
  showLoyalty?: Maybe<Scalars['Boolean']['output']>;
  showPay?: Maybe<Scalars['Boolean']['output']>;
  showSpecials?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlMobileCustomizationTabDisplayInput = {
  showCart?: InputMaybe<Scalars['Boolean']['input']>;
  showConcierge?: InputMaybe<Scalars['Boolean']['input']>;
  showLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  showPay?: InputMaybe<Scalars['Boolean']['input']>;
  showSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlMobileCustomizationTabLabels = {
  __typename?: 'MobileCustomizationTabLabels';
  account?: Maybe<Scalars['String']['output']>;
  cart?: Maybe<Scalars['String']['output']>;
  concierge?: Maybe<Scalars['String']['output']>;
  loyalty?: Maybe<Scalars['String']['output']>;
  more?: Maybe<Scalars['String']['output']>;
  pay?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<Scalars['String']['output']>;
  specials?: Maybe<Scalars['String']['output']>;
};

export type GqlMobileCustomizationTabLabelsInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  cart?: InputMaybe<Scalars['String']['input']>;
  concierge?: InputMaybe<Scalars['String']['input']>;
  loyalty?: InputMaybe<Scalars['String']['input']>;
  more?: InputMaybe<Scalars['String']['input']>;
  pay?: InputMaybe<Scalars['String']['input']>;
  shop?: InputMaybe<Scalars['String']['input']>;
  specials?: InputMaybe<Scalars['String']['input']>;
};

export enum MobileNavigationStyle {
  liquidGlass = 'LIQUID_GLASS',
  platformDefault = 'PLATFORM_DEFAULT',
  solid = 'SOLID'
}

export type GqlModerateProductReviewInput = {
  reviewId: Scalars['String']['input'];
  status: ReviewStatus;
};

export enum Modules {
  fraud = 'fraud',
  incentives = 'incentives',
  paymentProcessing = 'paymentProcessing',
  reporting = 'reporting'
}

export type GqlMonerisCard = {
  __typename?: 'MonerisCard';
  brand?: Maybe<Scalars['String']['output']>;
  lastDigits?: Maybe<Scalars['String']['output']>;
};

export type GqlMonerisDetails = {
  __typename?: 'MonerisDetails';
  card: GqlMonerisCard;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type GqlMonerisHtProfileCredentials = GqlCheckoutCredentialsBase & {
  __typename?: 'MonerisHTProfileCredentials';
  adapter: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
};

export type GqlMonerisTokenizationProfile = {
  __typename?: 'MonerisTokenizationProfile';
  profileId: Scalars['String']['output'];
};

export type GqlMongoProduct = {
  __typename?: 'MongoProduct';
  id: Scalars['ID']['output'];
};

export type GqlMutation = {
  __typename?: 'Mutation';
  acceptBrandAgreement?: Maybe<GqlGenericResponse>;
  acceptBrandPortalTos?: Maybe<GqlGenericResponse>;
  acceptPurchaseOrder: GqlPurchaseOrderDetail;
  acceptTermsOfService?: Maybe<GqlGenericResponse>;
  activateBankAccount?: Maybe<GqlActivateBankAccountResponse>;
  /** @deprecated Use activatePaymentMethodV2 */
  activatePaymentMethod: GqlGenericResponse;
  activatePaymentMethodV2: GqlActivatePaymentMethodResponse;
  activatePrinter: GqlGenericResponse;
  addBlockedAddress?: Maybe<GqlBlockedAddress>;
  addBoardsToDigitalDisplayBoardFolder: GqlDigitalDisplayBoardFolder;
  addCustomerToOrder?: Maybe<GqlOrderUpdated>;
  addDispensaryCustomer?: Maybe<GqlGenericResponse>;
  approveInstoreCart?: Maybe<GqlApproveInstoreCartResponse>;
  archiveDigitalDisplayPlaylist: GqlDigitalDisplayPlaylist;
  archiveOrder?: Maybe<GqlGenericResponse>;
  archiveProduct?: Maybe<GqlProducts>;
  assumeUserRole?: Maybe<GqlLoginAdmin>;
  autosaveCmsContentVersion?: Maybe<GqlCmsContentAutosaveResult>;
  autosavePage?: Maybe<GqlAutosavePageResult>;
  brandPortalSecureUpload?: Maybe<GqlIdImage>;
  /**
   * Bulk-creates NEW dispensary users for an enterprise from a plain-text CSV
   * upload (header: email,fullName,roleAtDispensary,locations — see
   * enterpriseDispensaryLocationKeywords for the cName reference table).
   * CREATE-only — existing users are never modified.
   */
  bulkCreateEnterpriseUsers?: Maybe<GqlBulkCreateEnterpriseUsersResult>;
  bulkCreateLspBrandSettings: Array<Maybe<GqlLspBrandSettings>>;
  bulkCreateUsers: Array<GqlBulkCreateUserResult>;
  bulkEndSpecialsV2?: Maybe<GqlGenericResponse>;
  bulkLibraryProductDelete?: Maybe<GqlGenericResponse>;
  bulkLibraryProductRestore?: Maybe<GqlGenericResponse>;
  bulkLibraryProductUpdate?: Maybe<GqlBulkLibraryProductUpdateResponse>;
  bulkLibraryProductUpload?: Maybe<GqlBulkLibraryProductUploadResponse>;
  bulkUpdateMenuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  cancelDigitalDisplayPlaylistScheduledChange: GqlDigitalDisplayPlaylistScheduledChange;
  changePhoneVerificationNumber?: Maybe<GqlPhoneVerificationSendResult>;
  changeRequestApproveProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestCreateProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestDeleteProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestLockProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestRejectProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestUnlockProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestUpdateProduct?: Maybe<GqlProductChangeRequest>;
  checkInBucketV2?: Maybe<GqlBucket>;
  /** @deprecated Use checkOutBucketV3 mutation */
  checkOutBucketV2: GqlBucket;
  checkOutBucketV3: GqlBucketV2;
  claimBrandPortalProducts?: Maybe<GqlBrandPortalClaimDismissResponse>;
  /**
   * Consumer kiosk device claims an unclaimed PIN, atomically. Intentionally unauthenticated --
   * the consumer kiosk screen is public by design (4-digit code space scoped to one
   * dispensary's kiosks, not globally unique; non-sensitive payload; recoverable via
   * unclaimKiosk). Per-IP rate limited (mirroring verifyLoginCode/sendLoginCode) since the
   * 4-digit code space is otherwise enumerable in seconds by an unauthenticated caller.
   */
  claimKiosk: GqlClaimKioskResult;
  claimPublicContextSessionByPhone?: Maybe<GqlPublicContextSession>;
  clearAdsInspectorEvents: GqlGenericResponse;
  clearAllCurbsideArrivals: GqlGenericResponse;
  clearAllFeatureFlagOverrides?: Maybe<GqlGenericResponse>;
  clearCurbsideArrival: GqlGenericResponse;
  closeBucket: GqlBucket;
  completeAggregatorLink: GqlCompleteAggregatorLinkResponse;
  computeWithPriceCartV2?: Maybe<GqlCalculationResults>;
  connectDeviceV2?: Maybe<GqlDeviceConnection>;
  connectProduct?: Maybe<GqlGenericResponse>;
  connectProductPreview?: Maybe<GqlConnectProductPreviewResponse>;
  consumeDeviceAccessCode?: Maybe<GqlDeviceAccessCode>;
  consumerSignup?: Maybe<GqlLoginConsumer>;
  copyLibraryProduct?: Maybe<GqlCopyLibraryProductResponse>;
  copyToLocations?: Maybe<GqlCopyToLocationsResponse>;
  /** @deprecated Use createAlpineUserV2 */
  createAlpineUser?: Maybe<GqlRewardUserResponse>;
  createAlpineUserV2?: Maybe<GqlRewardUserResponse>;
  createBackInStockSubscription?: Maybe<GqlGenericResponse>;
  createBankAccount?: Maybe<GqlCreateBankAccountResponse>;
  createBrandEnterpriseSettings: Array<GqlBrandEnterpriseSetting>;
  createBrandFundedDiscount: GqlBrandFundedDiscount;
  createBrandMenuInvitation: GqlCreateBrandMenuInvitationPayload;
  createBrandPoke: GqlBrandPoke;
  createBrandTag?: Maybe<GqlBrandTag>;
  createBrandUser?: Maybe<GqlBrandUser>;
  createBrandV2?: Maybe<GqlBrand>;
  createBucketForLibraryItem: GqlBucket;
  /** @deprecated Use createBucketV3 mutation */
  createBucketV2: GqlBucket;
  createBucketV3: GqlBucket;
  createCheckout?: Maybe<GqlCheckout>;
  createCollection: GqlCollection;
  createCouponV2?: Maybe<GqlCoupons>;
  createDeviceAccessCode?: Maybe<GqlDeviceAccessCode>;
  createDigitalDisplayBoard: GqlDigitalDisplayBoard;
  createDigitalDisplayBoardFolder: GqlDigitalDisplayBoardFolder;
  createDigitalDisplayPlaylist: GqlDigitalDisplayPlaylist;
  createDiscountCampaign: GqlDiscountCampaign;
  createDutchiePosLoyaltyMember?: Maybe<GqlRewardUserResponse>;
  createDutchiePosLoyaltyMemberV2?: Maybe<GqlLoyaltyMemberResponse>;
  createEnterpriseDomain: GqlEnterpriseDomain;
  createEnterpriseDutchiePosLoyaltyMember?: Maybe<GqlGenericResponse>;
  createEnterpriseDutchiePosLoyaltyMemberV2?: Maybe<GqlLoyaltyMemberResponse>;
  createEnterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  createEnterpriseSpecialV2?: Maybe<GqlGenericResponse>;
  createFraudAccount?: Maybe<GqlCreateFraudAccountResponse>;
  createInstoreCartUrl?: Maybe<GqlCreateInstoreCartUrlResponse>;
  createIntegration?: Maybe<GqlIntegrations>;
  createLibraryProduct?: Maybe<GqlProducts>;
  createLibraryProductV2?: Maybe<GqlLibraryProduct>;
  createLibraryProductV3?: Maybe<GqlLibraryProduct>;
  createLocationGroup?: Maybe<GqlLocationGroup>;
  createLoyaltyPassToken?: Maybe<GqlLoyaltyPassToken>;
  /** @deprecated Use getLoyaltyPassUrl instead for default client caching */
  createLoyaltyPassUrl?: Maybe<GqlLoyaltyPassUrl>;
  createLspBrandSettings: GqlLspBrandSettings;
  createMenuSection?: Maybe<GqlMenuSection>;
  createMxEnrollment?: Maybe<GqlCreateMxEnrollmentResponse>;
  /** @deprecated Use createOrUpdateAchReturnV5 */
  createOrUpdateAchReturn?: Maybe<GqlCreateOrUpdateAchReturnResponse>;
  createOrUpdateAchReturnV5?: Maybe<GqlCreateOrUpdateAchReturnResponseV5>;
  /** @deprecated Use createOrUpdateAchReturnV5 */
  createOrUpdateAchReturnv4?: Maybe<GqlCreateOrUpdateAchReturnResponseV4>;
  createOrderV2?: Maybe<GqlCreateOrderResponse>;
  createOrderingSuspensionV2?: Maybe<GqlOrderingSuspension>;
  createPOSMedUser?: Maybe<GqlGenericResponse>;
  createPayment?: Maybe<GqlCreatePaymentResponse>;
  createPlusApiKeyV2?: Maybe<GqlPlusApiKey>;
  createPlusEnterpriseApiKey?: Maybe<GqlPlusApiKey>;
  createPointsBoost?: Maybe<GqlGenericResponse>;
  createPrintJob: GqlCreatePrintJobResponse;
  createProduct?: Maybe<GqlProducts>;
  createPublicContextSession?: Maybe<GqlPublicContextSession>;
  createRedemption?: Maybe<GqlRedemption>;
  createReservationSlots?: Maybe<GqlGenericResponse>;
  createRetailerEnrollment?: Maybe<GqlCreateRetailerEnrollmentResponse>;
  createSpecialV3?: Maybe<GqlSpecials>;
  createSpringbigUser?: Maybe<GqlRewardUserResponse>;
  createStrainV2?: Maybe<GqlStrain>;
  createTerpeneV2?: Maybe<GqlTerpene>;
  createUser?: Maybe<GqlUsers>;
  createVoiceAgent?: Maybe<GqlVoiceAgent>;
  crossingMindsLogin?: Maybe<GqlCrossingMindsAuthResponse>;
  deleteAccount: GqlDeleteAccountResponse;
  deleteArchivedProduct?: Maybe<GqlGenericResponse>;
  deleteBackInStockSubscription?: Maybe<GqlGenericResponse>;
  deleteBrand?: Maybe<GqlBrand>;
  deleteBrandPortalDefaultContact: GqlBrandPortalDefaultContact;
  deleteBrandTag?: Maybe<GqlBrandTag>;
  deleteCollection?: Maybe<GqlGenericResponse>;
  deleteCouponV2?: Maybe<GqlGenericResponse>;
  deleteDeviceV2?: Maybe<GqlDevices>;
  deleteDigitalDisplayBoard: GqlDigitalDisplayBoard;
  deleteDigitalDisplayBoardFolder: GqlGenericResponse;
  deleteEnterpriseDomain?: Maybe<GqlEnterpriseDomain>;
  deleteEnterpriseSpecial?: Maybe<GqlGenericResponse>;
  deleteLibraryProduct?: Maybe<GqlLibraryProduct>;
  deleteLocationGroup?: Maybe<GqlLocationGroup>;
  deletePage?: Maybe<GqlDeletePageResult>;
  deletePrinter: GqlGenericResponse;
  deleteReview?: Maybe<GqlGenericResponse>;
  deleteSpecialHours?: Maybe<GqlGenericResponse>;
  deleteSpecialV2?: Maybe<GqlSpecials>;
  deleteStrain?: Maybe<GqlStrain>;
  deleteTerpene?: Maybe<GqlTerpene>;
  deleteUser?: Maybe<GqlUsers>;
  deleteVoiceAgent?: Maybe<GqlVoiceAgent>;
  denyPurchaseOrder: GqlPurchaseOrderDetail;
  destroyMenuSection?: Maybe<GqlGenericResponse>;
  devLoginAdmin?: Maybe<GqlLoginAdmin>;
  devLoginConsumer?: Maybe<GqlLoginConsumer>;
  deviceHeartbeat?: Maybe<GqlGenericResponse>;
  disconnectBankAccount?: Maybe<GqlDisconnectBankAccountResponse>;
  /** Disconnect a dispensary product from its library product & mark the bucket product as disconnected */
  disconnectBucketProduct?: Maybe<GqlGenericResponse>;
  /** Disconnect a product from its library product */
  disconnectProduct?: Maybe<GqlGenericResponse>;
  dismissBrandPortalProducts?: Maybe<GqlBrandPortalClaimDismissResponse>;
  dispensaryDemoRequest?: Maybe<GqlGenericResponse>;
  dispensaryOnboarding?: Maybe<GqlGenericResponse>;
  dispensaryPublishSpecialsPageSettingsToLocations?: Maybe<GqlGenericResponse>;
  dispensaryRemoveFromChain?: Maybe<GqlGenericResponse>;
  dispensaryUpdate?: Maybe<GqlGenericResponse>;
  /** @deprecated Orphaned mutation -- no resolver wired since ENG-30398 (2022); hours are updated via updateHoursSettings. Schema surface retained (deprecated, not deleted) per the deprecate-don't-delete policy; delete in a separate change once drained. */
  dispensaryUpdateHoursSettings?: Maybe<GqlGenericResponse>;
  dispensaryUpdateOptionsSettings?: Maybe<GqlGenericResponse>;
  dispensaryUpdateStatus?: Maybe<GqlGenericResponse>;
  dispensaryUpdateTaxConfiguration?: Maybe<GqlGenericResponse>;
  dispensaryUploadOnboardingAsset?: Maybe<GqlDispensaryAssetUploadResponse>;
  downloadPurchaseOrderCsv: GqlPurchaseOrderCsvDownload;
  downloadPurchaseOrderPdf: GqlPurchaseOrderPdfDownload;
  duplicateDigitalDisplayBoard: GqlDigitalDisplayBoard;
  duplicateDigitalDisplayPlaylist: GqlDigitalDisplayPlaylist;
  emailIntegrationCredentials?: Maybe<GqlGenericResponse>;
  endEnterpriseSpecial?: Maybe<GqlGenericResponse>;
  endOrderingSuspensionV2?: Maybe<GqlOrderingSuspension>;
  endSpecialV2: GqlSpecials;
  enterpriseAssetLibraryCreateFolder: GqlLibraryFolder;
  enterpriseAssetLibraryDeleteAssets: GqlGenericResponse;
  enterpriseAssetLibraryDeleteFolder: GqlGenericResponse;
  enterpriseAssetLibraryFinalizeAsset: GqlLibraryAsset;
  enterpriseAssetLibraryRequestUpload: GqlLibraryUploadIntent;
  enterpriseAssetLibraryStartImport: GqlLibraryImportJob;
  enterpriseAssetLibraryUpdateAsset: GqlLibraryAsset;
  exitAssumedRole?: Maybe<GqlLoginAdmin>;
  expirePlusApiKey?: Maybe<GqlPlusApiKey>;
  expirePlusEnterpriseApiKey?: Maybe<GqlPlusApiKey>;
  exportCouponsSummaries?: Maybe<GqlGenericResponse>;
  exportCustomerReport?: Maybe<GqlGenericExportResponse>;
  exportDispensaryCustomers?: Maybe<GqlGenericResponse>;
  exportFilteredBrandsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCampaignsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCartsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCatalog: GqlExportFilteredCatalogResponse;
  exportFilteredProductSummaries?: Maybe<GqlGenericResponse>;
  exportOrderReport?: Maybe<GqlGenericExportResponse>;
  exportOrders?: Maybe<GqlGenericResponse>;
  exportSpecialsSummaries?: Maybe<GqlGenericResponse>;
  findOrCreateReferralCode?: Maybe<GqlReferralCode>;
  forceDiscountSync?: Maybe<GqlGenericResponse>;
  forceMenuPricingSync?: Maybe<GqlGenericResponse>;
  generateAdminTransferToken?: Maybe<GqlAdminTransferToken>;
  generateDispensaryUserStreamToken?: Maybe<GqlDispensaryStreamToken>;
  generateHypurRedirectV3?: Maybe<GqlHypurRedirect>;
  generateHypurTokenV2?: Maybe<GqlHypurToken>;
  importCustomerCSV?: Maybe<GqlGenericResponse>;
  importDeliveryZipCodes?: Maybe<GqlGenericResponse>;
  importMenuCSV?: Maybe<GqlGenericResponse>;
  importProductReviews?: Maybe<GqlGenericResponse>;
  incrementClicks?: Maybe<GqlGenericResponse>;
  initiatePayByBank?: Maybe<GqlPayByBankResult>;
  /** @deprecated Use integrationsDeleteInArma */
  integrationsDelete?: Maybe<GqlGenericResponse>;
  integrationsDeleteInArma?: Maybe<GqlGenericResponse>;
  integrationsForceSyncInArma?: Maybe<GqlGenericResponse>;
  integrationsSuggestion?: Maybe<GqlGenericResponse>;
  /** @deprecated Use updateIntegration */
  integrationsUpdate?: Maybe<GqlGenericResponse>;
  integrationsUpdateFields?: Maybe<GqlGenericResponse>;
  integrationsUpdateThresholds?: Maybe<GqlGenericResponse>;
  integrationsUpdateTypes?: Maybe<GqlGenericResponse>;
  /** @deprecated Use integrationsWipeMenuInArma */
  integrationsWipeMenu?: Maybe<GqlGenericResponse>;
  integrationsWipeMenuInArma?: Maybe<GqlGenericResponse>;
  /**
   * Liveness ping from an already-claimed kiosk device, unauthenticated like claimKiosk. Also the
   * desync-detection signal: stillClaimed tells the device whether the server still considers it
   * claimed, so a device unclaimed/removed by an admin can reset to the PIN screen.
   */
  kioskSeen: GqlKioskSeenResult;
  libraryProductChangeImpact?: Maybe<GqlProductImpactResponse>;
  libraryProductChangeImpactV3?: Maybe<GqlLibraryProductChangeImpactResponse>;
  logAnalyticsPayload?: Maybe<GqlGenericResponse>;
  loginAdmin?: Maybe<GqlLoginAdmin>;
  loginAdminViaToken?: Maybe<GqlLoginAdmin>;
  loginConsumer?: Maybe<GqlLoginConsumer>;
  logout?: Maybe<GqlGenericResponse>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturned?: Maybe<GqlMarkAchEntryAsReturnedResponse>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturnedV3?: Maybe<GqlMarkAchEntryAsReturnedResponseV3>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturnedV4?: Maybe<GqlMarkAchEntryAsReturnedResponseV4>;
  markAchEntryAsReturnedV5?: Maybe<GqlMarkAchEntryAsReturnedResponseV5>;
  markBrandPortalUserNotificationsAsRead: Array<GqlBrandPortalUserNotification>;
  markCurbsideArrivalArrivedV2: GqlCurbsideArrival;
  markOrderAutoPrinted?: Maybe<GqlGenericResponse>;
  markOrderPOSFailed?: Maybe<GqlOrderUpdated>;
  markOrderPrinted?: Maybe<GqlGenericResponse>;
  markOrdersBatchPrinted?: Maybe<GqlGenericResponse>;
  mergeBrand?: Maybe<GqlBrand>;
  mergeBrands?: Maybe<GqlGenericResponse>;
  mergeLibraryProducts?: Maybe<GqlMergeLibraryProductsResponse>;
  mintEnterpriseDomainEntriToken: GqlEnterpriseDomainEntriToken;
  moderateProductReview?: Maybe<GqlAdminProductReview>;
  notifyInstoreCartOpened?: Maybe<GqlNotifyInstoreCartOpenedResponse>;
  /** @deprecated Use parseAchReturnFileUploadV2 */
  parseAchReturnFileUpload?: Maybe<GqlParseAchReturnFileUploadResponse>;
  parseAchReturnFileUploadV2?: Maybe<GqlParseAchReturnFileUploadResponse>;
  persistCheckout?: Maybe<GqlGenericResponse>;
  persistCheckoutV2?: Maybe<GqlPersistCheckoutResponse>;
  previewReservationSlotStrandings?: Maybe<GqlStrandedReservationsPreview>;
  printOrderOnTerminal?: Maybe<GqlOrderPrinted>;
  provisionVoiceAgentPhoneNumber?: Maybe<GqlVoiceAgent>;
  recordUserAcceptance?: Maybe<GqlRecordUserAcceptanceResponse>;
  rejectReasons: Array<RejectionReasons>;
  removeBlockedAddress?: Maybe<GqlGenericResponse>;
  removeBoardsFromDigitalDisplayBoardFolder: GqlDigitalDisplayBoardFolder;
  removeCategoryMenuOrder: GqlGenericResponse;
  removeConsumerSso?: Maybe<GqlGenericResponse>;
  removeItem?: Maybe<GqlCheckout>;
  reopenOrder?: Maybe<GqlGenericResponse>;
  resetPasswordV2?: Maybe<GqlGenericResponse>;
  /** @deprecated Use createOrUpdateAchReturnV4 */
  respondToAchReturn?: Maybe<GqlRespondToAchReturnResponse>;
  restartDigitalDisplayPlaylist: GqlDigitalDisplayCommandResult;
  reverifyBrandCatalog: GqlReverifyBrandCatalogPayload;
  reversePayment?: Maybe<GqlReversePaymentResponse>;
  reverseSettlement?: Maybe<GqlReverseSettlementResponse>;
  revertBrandMerge?: Maybe<GqlBrandMergeHistory>;
  revokeBrandMenuInvitation: GqlBrandMenuInvitation;
  saveCmsContentVersion?: Maybe<GqlCmsContentVersionResult>;
  saveCmsTargeting?: Maybe<GqlCmsTargetingRuleSet>;
  saveCustomNavigation?: Maybe<GqlCustomNavigation>;
  savePage?: Maybe<GqlSavePageResult>;
  saveReviews?: Maybe<GqlGenericResponse>;
  scheduleDigitalDisplayPlaylistChange: GqlDigitalDisplayPlaylistScheduledChange;
  sendBrandUserPasswordResetEmail?: Maybe<GqlGenericResponse>;
  sendCompleteAccountSetupEmail?: Maybe<GqlGenericResponse>;
  sendLoginCode?: Maybe<GqlGenericResponse>;
  sendPasswordResetEmailV2?: Maybe<GqlGenericResponse>;
  sendPhoneVerificationCode?: Maybe<GqlPhoneVerificationSendResult>;
  /** @deprecated Account verification feature has been sunset. */
  sendVerificationToken?: Maybe<GqlGenericResponse>;
  serverSideCalculations?: Maybe<GqlLegacyCalculationResults>;
  setCategoryFeaturedBrands: GqlGenericResponse;
  setCategoryFeaturedProducts: GqlGenericResponse;
  setCategoryMenuOrder: GqlGenericResponse;
  setDigitalDisplayPlaylists: GqlDigitalDisplay;
  setFeatureFlagOverride?: Maybe<GqlGenericResponse>;
  setGlobalMenuOrder: GqlGenericResponse;
  setPasswordV2?: Maybe<GqlGenericResponse>;
  setViewedTermsOfService?: Maybe<GqlGenericResponse>;
  /** @deprecated Moving to V2 for skip reasons change */
  skipBucketProduct: GqlGenericResponse;
  skipBucketProductV2: GqlGenericResponse;
  sortMenuSections?: Maybe<GqlGenericResponse>;
  speculativeProductUpdate?: Maybe<GqlProducts>;
  startPayByBankFinalization: GqlStartPayByBankFinalizationResult;
  startPreAuthCheck?: Maybe<GqlStartPreAuthCheckResponse>;
  submitConsumerPulseReview?: Maybe<GqlGenericResponse>;
  trackIrlEvent?: Maybe<GqlGenericResponse>;
  trackIrlEventByDispensary?: Maybe<GqlGenericResponse>;
  unarchiveOrder?: Maybe<GqlGenericResponse>;
  /** Admin-authenticated. Clears an existing claim so a kiosk PIN can be re-paired. */
  unclaimKiosk?: Maybe<GqlGenericResponse>;
  unenrollPayByBankUser: GqlUnenrollEnrollmentResponse;
  unsubscribeDispensaryCustomers?: Maybe<GqlGenericResponse>;
  unverifyConsumerUserPhone?: Maybe<GqlGenericResponse>;
  updateAutoPrintDevicesV2?: Maybe<GqlGenericResponse>;
  updateBrandCollision?: Maybe<GqlBrandCollision>;
  updateBrandEnterpriseSetting: GqlBrandEnterpriseSetting;
  updateBrandFundedDiscount: GqlBrandFundedDiscount;
  updateBrandImportHistoryName: GqlBrandImportHistoryDetailResponse;
  updateBrandTag?: Maybe<GqlBrandTag>;
  updateBrandUser?: Maybe<GqlBrandUser>;
  updateBrandUserAccount?: Maybe<GqlBrandUserAccount>;
  updateBrandV2?: Maybe<GqlBrand>;
  updateChainDispensariesImage?: Maybe<GqlGenericResponse>;
  updateChangeRequestCreateProduct?: Maybe<GqlProductChangeRequest>;
  updateChangeRequestUpdateProduct?: Maybe<GqlProductChangeRequest>;
  updateCheckout?: Maybe<GqlCheckout>;
  updateCname?: Maybe<GqlGenericResponse>;
  updateCollection: GqlCollection;
  updateCollectionPositions: Array<GqlCollection>;
  updateConsumerPulseSettings?: Maybe<GqlGenericResponse>;
  updateConsumerUser?: Maybe<GqlGenericResponse>;
  updateCoupon?: Maybe<GqlCoupons>;
  updateCurbsideArrivalV2?: Maybe<GqlCurbsideArrival>;
  updateCustomerCommunicationSettings?: Maybe<GqlPreferenceSettingsResponse>;
  updateCustomerSubscription?: Maybe<GqlGenericResponse>;
  updateDevice?: Maybe<GqlDevices>;
  updateDigitalDisplayBoard: GqlDigitalDisplayBoard;
  updateDigitalDisplayBoardFolder: GqlDigitalDisplayBoardFolder;
  updateDigitalDisplayPlaylist: GqlDigitalDisplayPlaylist;
  /** @deprecated No admin UI has ever called this. Device-mount orientation is not planned to be admin-configurable -- content orientation now lives on the board (DigitalDisplayBoard.orientation) instead. */
  updateDigitalDisplaySettings: GqlDigitalDisplay;
  updateDiscountCampaign: GqlDiscountCampaign;
  updateDispensaryAdSettings?: Maybe<GqlGenericResponse>;
  updateDispensaryCustomer?: Maybe<GqlGenericResponse>;
  updateDispensaryPersonalizationSettings?: Maybe<GqlGenericResponse>;
  updateDispensaryPrintedMenuSettingsV2?: Maybe<GqlGenericResponse>;
  updateDutchiePosLoyaltyMember?: Maybe<GqlGenericResponse>;
  updateEmail?: Maybe<GqlGenericResponse>;
  updateEmailOptInSetting?: Maybe<GqlGenericResponse>;
  updateEmailV2?: Maybe<GqlGenericResponse>;
  updateEnterpriseAdSettings?: Maybe<GqlUpdateEnterpriseAdSettingsResponse>;
  updateEnterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  updateEnterpriseMobileAppSettings?: Maybe<GqlEnterpriseMobileAppSettings>;
  updateEnterprisePersonalizationSettings?: Maybe<GqlUpdateEnterprisePersonalizationSettingsResponse>;
  updateEnterpriseSpecialV2?: Maybe<GqlGenericResponse>;
  updateEnterpriseVoiceAiEnablement: GqlEnterprise;
  updateEnterpriseWebCustomizationSettingsV2?: Maybe<GqlGenericResponse>;
  updateHoursSettings?: Maybe<GqlGenericResponse>;
  updateImageBanners?: Maybe<GqlGenericResponse>;
  updateIntegration?: Maybe<GqlGenericResponse>;
  updateKioskOrderPayment?: Maybe<GqlGenericResponse>;
  updateLibraryProduct?: Maybe<GqlUpdateLibraryProductResponse>;
  updateLocationGroup?: Maybe<GqlLocationGroup>;
  updateMenuSection?: Maybe<GqlMenuSection>;
  updateOrderPayment?: Maybe<GqlGenericResponse>;
  updateOrderStatus?: Maybe<GqlOrders>;
  updateOrderV2?: Maybe<GqlOrders>;
  updateOrderingSettings?: Maybe<GqlGenericResponse>;
  updatePasswordV2?: Maybe<GqlPasswordUpdate>;
  updatePlusOAuthProvider: GqlPlusOAuthProvider;
  updatePrinter: GqlGenericResponse;
  updateProduct?: Maybe<GqlProducts>;
  /** @deprecated Use setCategoryMenuOrder, setCategoryMenuOrderCustom, or setCategoryMenuOrderBrand mutations instead. This mutation has ambiguous behavior and mixes multiple responsibilities. */
  updateProductSort?: Maybe<GqlGenericResponse>;
  updateProductStatus?: Maybe<GqlProducts>;
  updateProfileV2?: Maybe<GqlGenericResponse>;
  updatePublicContextSession?: Maybe<GqlPublicContextSession>;
  updatePushNotificationToken?: Maybe<GqlGenericResponse>;
  updateQuantity?: Maybe<GqlCheckout>;
  updateRemoteExtensions?: Maybe<GqlGenericResponse>;
  updateReservationSlots?: Maybe<GqlGenericResponse>;
  /** @deprecated SEO menu feature removed. */
  updateSeoSettings?: Maybe<GqlGenericResponse>;
  updateSingleDispensaryAdSettings?: Maybe<GqlUpdateSingleDispensaryAdSettingsResponse>;
  updateSingleDispensaryPersonalizationSettings?: Maybe<GqlUpdateSingleDispensaryPersonalizationSettingsResponse>;
  updateSpecialMenuDesign?: Maybe<GqlGenericResponse>;
  updateSpecialV3?: Maybe<GqlSpecials>;
  updateSpecialsSortOrder?: Maybe<GqlGenericResponse>;
  updateStrainV2?: Maybe<GqlStrain>;
  updateTerpeneV2?: Maybe<GqlTerpene>;
  updateTextSetting?: Maybe<GqlGenericResponse>;
  updateUser?: Maybe<GqlUsers>;
  updateUserEmail?: Maybe<GqlGenericResponse>;
  updateUserPermissions?: Maybe<GqlGenericResponse>;
  updateUserRoleV2?: Maybe<GqlGenericResponse>;
  updateVoiceAgent?: Maybe<GqlVoiceAgent>;
  updateWebCustomizationSettings?: Maybe<GqlGenericResponse>;
  updateWebCustomizationSettingsV2?: Maybe<GqlGenericResponse>;
  uploadBrandFundedDiscountImage: GqlBrandFundedDiscountImageUpload;
  uploadCsvImport: GqlBrandImportHistoryUploadResponse;
  uploadImage?: Maybe<GqlImageUrl>;
  uploadSecureImage?: Maybe<GqlIdImage>;
  upsertBrandPortalDefaultContact: GqlBrandPortalDefaultContact;
  upsertBrandPortalNotificationSettings: Array<GqlBrandPortalNotificationSetting>;
  upsertPurchaseOrder: GqlPurchaseOrderDetail;
  /** @deprecated Account verification feature has been sunset. */
  validateVerificationToken?: Maybe<GqlGenericResponse>;
  verifyBucketProducts: GqlGenericResponse;
  verifyEnterpriseDomain: GqlEnterpriseDomain;
  verifyLoginCode?: Maybe<GqlVerifyLoginCodeResponse>;
  verifyPhoneVerificationCode?: Maybe<GqlPhoneVerificationCheckResult>;
};


export type GqlMutationAcceptBrandAgreementArgs = {
  resetToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationAcceptBrandPortalTosArgs = {
  resetToken: Scalars['String']['input'];
};


export type GqlMutationAcceptPurchaseOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationActivateBankAccountArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationActivatePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationActivatePaymentMethodV2Args = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationActivatePrinterArgs = {
  deviceIdentifier: Scalars['String']['input'];
};


export type GqlMutationAddBlockedAddressArgs = {
  address: GqlBlockedAddressInput;
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationAddBoardsToDigitalDisplayBoardFolderArgs = {
  boardIds: Array<Scalars['ID']['input']>;
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationAddCustomerToOrderArgs = {
  input?: InputMaybe<GqlAddCustomerToOrderInput>;
};


export type GqlMutationAddDispensaryCustomerArgs = {
  customer: GqlDispensaryCustomerInput;
};


export type GqlMutationApproveInstoreCartArgs = {
  instoreCartId: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  tipCents: Scalars['Int']['input'];
};


export type GqlMutationArchiveDigitalDisplayPlaylistArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationArchiveOrderArgs = {
  input: GqlArchiveOrderInput;
};


export type GqlMutationArchiveProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationAssumeUserRoleArgs = {
  userId: Scalars['ID']['input'];
};


export type GqlMutationAutosaveCmsContentVersionArgs = {
  data: Scalars['JSONObject']['input'];
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  publishNote?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<Array<GqlCmsSavedTargetingRuleInput>>;
  variantKey: Scalars['String']['input'];
  websiteId: Scalars['String']['input'];
};


export type GqlMutationAutosavePageArgs = {
  data: Scalars['JSONObject']['input'];
  enterpriseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  publishNote?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<Array<GqlCmsSavedTargetingRuleInput>>;
  urlPath: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId: Scalars['String']['input'];
};


export type GqlMutationBrandPortalSecureUploadArgs = {
  brandId: Scalars['ID']['input'];
  encoding?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  mime?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationBulkCreateEnterpriseUsersArgs = {
  chainId: Scalars['String']['input'];
  csv: Scalars['String']['input'];
};


export type GqlMutationBulkCreateLspBrandSettingsArgs = {
  updates: Array<GqlLspBrandSettingsBulkInput>;
};


export type GqlMutationBulkCreateUsersArgs = {
  users: Array<GqlUsersCreateInput>;
};


export type GqlMutationBulkEndSpecialsV2Args = {
  input: GqlEndSpecialsInput;
};


export type GqlMutationBulkLibraryProductDeleteArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlMutationBulkLibraryProductRestoreArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlMutationBulkLibraryProductUpdateArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updates: GqlBulkLibraryProductUpdates;
};


export type GqlMutationBulkLibraryProductUploadArgs = {
  s3Key: Scalars['String']['input'];
};


export type GqlMutationBulkUpdateMenuSectionsArgs = {
  deletes?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispensaryId: Scalars['String']['input'];
  menuSections?: InputMaybe<Array<GqlMenuSectionBulkUpdateInput>>;
};


export type GqlMutationCancelDigitalDisplayPlaylistScheduledChangeArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationChangePhoneVerificationNumberArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};


export type GqlMutationChangeRequestApproveProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationChangeRequestCreateProductArgs = {
  brandId: Scalars['String']['input'];
  complianceRegionId: Scalars['String']['input'];
  contentAttributes: GqlUpdatedLibraryProduct;
};


export type GqlMutationChangeRequestDeleteProductArgs = {
  productId: Scalars['String']['input'];
};


export type GqlMutationChangeRequestLockProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationChangeRequestRejectProductArgs = {
  feedback: Scalars['String']['input'];
  id: Scalars['String']['input'];
  rejectionReasons: Array<RejectionReasons>;
};


export type GqlMutationChangeRequestUnlockProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationChangeRequestUpdateProductArgs = {
  contentAttributes: GqlUpdatedLibraryProduct;
  productId: Scalars['String']['input'];
};


export type GqlMutationCheckInBucketV2Args = {
  uuid: Scalars['String']['input'];
};


export type GqlMutationCheckOutBucketV2Args = {
  bucketId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type GqlMutationCheckOutBucketV3Args = {
  bucketId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type GqlMutationClaimBrandPortalProductsArgs = {
  brandId: Scalars['ID']['input'];
  libraryProductIds: Array<Scalars['ID']['input']>;
};


export type GqlMutationClaimKioskArgs = {
  code: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationClaimPublicContextSessionByPhoneArgs = {
  id: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type GqlMutationClearAdsInspectorEventsArgs = {
  input: GqlAdsInspectorEventsInput;
};


export type GqlMutationClearAllCurbsideArrivalsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationClearCurbsideArrivalArgs = {
  arrivalId: Scalars['String']['input'];
};


export type GqlMutationCloseBucketArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationCompleteAggregatorLinkArgs = {
  aggregator: Scalars['String']['input'];
  aggregatorToken: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  plaid?: InputMaybe<GqlPlaidLinkMetadata>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationComputeWithPriceCartV2Args = {
  input: GqlCalculationsInput;
};


export type GqlMutationConnectDeviceV2Args = {
  connectionToken: Scalars['String']['input'];
};


export type GqlMutationConnectProductArgs = {
  id: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
  omitFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GqlMutationConnectProductPreviewArgs = {
  id: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
};


export type GqlMutationConsumeDeviceAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationConsumerSignupArgs = {
  input: GqlConsumerSignupInput;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCopyLibraryProductArgs = {
  id: Scalars['String']['input'];
  stateLibraryIds: Array<Scalars['String']['input']>;
};


export type GqlMutationCopyToLocationsArgs = {
  dispensaryId: Scalars['String']['input'];
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseId: Scalars['ID']['input'];
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  itemId: Scalars['String']['input'];
  klass: Scalars['String']['input'];
};


export type GqlMutationCreateAlpineUserArgs = {
  acceptedTerms: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  favoriteStore: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  program: Scalars['String']['input'];
};


export type GqlMutationCreateAlpineUserV2Args = {
  acceptedTerms: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  favoriteStore: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  program: Scalars['String']['input'];
};


export type GqlMutationCreateBackInStockSubscriptionArgs = {
  productId: Scalars['String']['input'];
};


export type GqlMutationCreateBankAccountArgs = {
  adapter: Scalars['String']['input'];
  aggregatorToken: Scalars['String']['input'];
  billingAddressId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateBrandEnterpriseSettingsArgs = {
  brandId: Scalars['String']['input'];
  settings: Array<GqlBrandEnterpriseSettingsInput>;
};


export type GqlMutationCreateBrandFundedDiscountArgs = {
  input?: InputMaybe<GqlBrandFundedDiscountInput>;
};


export type GqlMutationCreateBrandMenuInvitationArgs = {
  brandId: Scalars['ID']['input'];
  input: GqlCreateBrandMenuInvitationInput;
};


export type GqlMutationCreateBrandPokeArgs = {
  brandId: Scalars['ID']['input'];
  lspGlobalId: Scalars['String']['input'];
};


export type GqlMutationCreateBrandTagArgs = {
  brandId: Scalars['ID']['input'];
  brandTag: GqlCreateBrandTagInput;
};


export type GqlMutationCreateBrandUserArgs = {
  updates: GqlBrandUserCreateInput;
};


export type GqlMutationCreateBrandV2Args = {
  brand: GqlBrandInput;
};


export type GqlMutationCreateBucketForLibraryItemArgs = {
  libraryItemId: Scalars['ID']['input'];
};


export type GqlMutationCreateBucketV2Args = {
  bucket: GqlCreateBucketInput;
};


export type GqlMutationCreateBucketV3Args = {
  bucket: GqlCreateBucketInputV3;
};


export type GqlMutationCreateCheckoutArgs = {
  cart: Array<GqlCreateCheckoutInputCartItem>;
  dispensaryId: Scalars['String']['input'];
  orderType: ReservationSlotTypes;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  pricingType: CustomerType;
};


export type GqlMutationCreateCollectionArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateCollectionInput;
};


export type GqlMutationCreateCouponV2Args = {
  coupon: GqlCreateCouponInput;
};


export type GqlMutationCreateDeviceAccessCodeArgs = {
  deviceType?: InputMaybe<DeviceType>;
};


export type GqlMutationCreateDigitalDisplayBoardArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  audioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  colorScheme?: InputMaybe<Scalars['JSON']['input']>;
  enterpriseId: Scalars['ID']['input'];
  layout: DigitalDisplayBoardLayout;
  menuColumns?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
};


export type GqlMutationCreateDigitalDisplayBoardFolderArgs = {
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};


export type GqlMutationCreateDigitalDisplayPlaylistArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
};


export type GqlMutationCreateDiscountCampaignArgs = {
  input: GqlDiscountCampaignCreateInput;
};


export type GqlMutationCreateDutchiePosLoyaltyMemberArgs = {
  dispensaryId: Scalars['String']['input'];
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateDutchiePosLoyaltyMemberV2Args = {
  dispensaryId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  useStrictMatching?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateEnterpriseDomainArgs = {
  domainType: EnterpriseDomainType;
  enterpriseId: Scalars['ID']['input'];
  hostname: Scalars['String']['input'];
  locationGroupId?: InputMaybe<Scalars['ID']['input']>;
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateEnterpriseDutchiePosLoyaltyMemberArgs = {
  enterpriseId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  isoRegionCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateEnterpriseDutchiePosLoyaltyMemberV2Args = {
  enterpriseId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  isoRegionCode: Scalars['String']['input'];
  useStrictMatching?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateEnterpriseLoyaltySettingsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateEnterpriseSpecialV2Args = {
  input: GqlEnterpriseSpecialInputV2;
};


export type GqlMutationCreateFraudAccountArgs = {
  payload: GqlCreateFraudInput;
};


export type GqlMutationCreateInstoreCartUrlArgs = {
  checkoutExperience?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type GqlMutationCreateIntegrationArgs = {
  integration: GqlIntegrationsUpdateInput;
};


export type GqlMutationCreateLibraryProductArgs = {
  product: GqlProductCreateInput;
  state: Scalars['String']['input'];
};


export type GqlMutationCreateLibraryProductV2Args = {
  libraryProduct: GqlNewLibraryProduct;
  state: Scalars['String']['input'];
};


export type GqlMutationCreateLibraryProductV3Args = {
  libraryProduct: GqlNewLibraryProductV2;
  state: Scalars['String']['input'];
};


export type GqlMutationCreateLocationGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GqlMutationCreateLoyaltyPassTokenArgs = {
  dispensaryId: Scalars['String']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateLoyaltyPassUrlArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationCreateLspBrandSettingsArgs = {
  brandId: Scalars['String']['input'];
  settings: GqlLspBrandSettingsInput;
};


export type GqlMutationCreateMenuSectionArgs = {
  menuSection: GqlMenuSectionCreateInput;
};


export type GqlMutationCreateMxEnrollmentArgs = {
  billingAddress: GqlBillingAddressInput;
  entityEmail: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  entityType: EntityTypes;
  isMobileApp: Scalars['Boolean']['input'];
};


export type GqlMutationCreateOrUpdateAchReturnArgs = {
  achEntryId: Scalars['String']['input'];
  achReturnId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationCreateOrUpdateAchReturnV5Args = {
  achEntryId: Scalars['String']['input'];
  achReturnId?: InputMaybe<Scalars['String']['input']>;
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationCreateOrUpdateAchReturnv4Args = {
  achEntryId: Scalars['String']['input'];
  achReturnId?: InputMaybe<Scalars['String']['input']>;
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationCreateOrderV2Args = {
  order?: InputMaybe<GqlOrdersCreateInput>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateOrderingSuspensionV2Args = {
  dispensaryId: Scalars['ID']['input'];
};


export type GqlMutationCreatePosMedUserArgs = {
  dispensaryId: Scalars['String']['input'];
  user: GqlCreatePosMedUserInput;
};


export type GqlMutationCreatePaymentArgs = {
  amount: Scalars['Int']['input'];
  card?: InputMaybe<GqlCreatePaymentCard>;
  checkoutToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  customerDetails: GqlCreatePaymentCustomerDetails;
  ecommLocationId: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  tipAmount?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlMutationCreatePlusApiKeyV2Args = {
  dispensaryId: Scalars['String']['input'];
  keyType: PlusApiKeyType;
};


export type GqlMutationCreatePlusEnterpriseApiKeyArgs = {
  enterpriseId: Scalars['String']['input'];
  keyType: PlusApiKeyType;
};


export type GqlMutationCreatePointsBoostArgs = {
  input: GqlCreatePointsBoostInput;
};


export type GqlMutationCreatePrintJobArgs = {
  input: GqlCreatePrintJobInput;
};


export type GqlMutationCreateProductArgs = {
  product?: InputMaybe<GqlProductCreateInput>;
};


export type GqlMutationCreatePublicContextSessionArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationCreateRedemptionArgs = {
  code: Scalars['String']['input'];
  receiverUserId: Scalars['String']['input'];
};


export type GqlMutationCreateReservationSlotsArgs = {
  input: GqlReservationSlotsCreateInput;
};


export type GqlMutationCreateRetailerEnrollmentArgs = {
  accountDetails: GqlAccountDetailsInput;
  billingAddress: GqlBillingAddressInput;
  entityId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  serviceFeeDetails: GqlServiceFeeInput;
};


export type GqlMutationCreateSpecialV3Args = {
  input: GqlSpecialsInputV3;
};


export type GqlMutationCreateSpringbigUserArgs = {
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateStrainV2Args = {
  strain: GqlStrainInput;
};


export type GqlMutationCreateTerpeneV2Args = {
  terpene: GqlTerpeneInput;
};


export type GqlMutationCreateUserArgs = {
  user: GqlUsersCreateInput;
};


export type GqlMutationCreateVoiceAgentArgs = {
  enterpriseId: Scalars['ID']['input'];
  enterprisePrompt?: InputMaybe<Scalars['String']['input']>;
  fallbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  locationGroupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spanishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  superAdminPrompt?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationDeleteArchivedProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteBackInStockSubscriptionArgs = {
  productId: Scalars['String']['input'];
};


export type GqlMutationDeleteBrandArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteBrandPortalDefaultContactArgs = {
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteBrandTagArgs = {
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteCollectionArgs = {
  collectionId: Scalars['String']['input'];
};


export type GqlMutationDeleteCouponV2Args = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteDeviceV2Args = {
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteDigitalDisplayBoardArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteDigitalDisplayBoardFolderArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteEnterpriseDomainArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteEnterpriseSpecialArgs = {
  enterprise_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteLibraryProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteLocationGroupArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationDeletePageArgs = {
  enterpriseId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId: Scalars['String']['input'];
};


export type GqlMutationDeletePrinterArgs = {
  printerId: Scalars['String']['input'];
};


export type GqlMutationDeleteReviewArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteSpecialHoursArgs = {
  dispensaryId: Scalars['String']['input'];
  specialHoursIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationDeleteSpecialV2Args = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteStrainArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteTerpeneArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteUserArgs = {
  user: GqlUsersDeleteInput;
};


export type GqlMutationDeleteVoiceAgentArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationDenyPurchaseOrderArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<GqlPurchaseOrderDecisionInput>;
};


export type GqlMutationDestroyMenuSectionArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type GqlMutationDevLoginAdminArgs = {
  accountId: Scalars['ID']['input'];
};


export type GqlMutationDevLoginConsumerArgs = {
  accountId: Scalars['ID']['input'];
};


export type GqlMutationDeviceHeartbeatArgs = {
  printerConnected?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<GqlDeviceStatusInput>;
  versionNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationDisconnectBankAccountArgs = {
  mxAccountInfo: GqlMxAccountInfo;
};


export type GqlMutationDisconnectBucketProductArgs = {
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type GqlMutationDisconnectProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDismissBrandPortalProductsArgs = {
  brandId: Scalars['ID']['input'];
  libraryProductIds: Array<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationDispensaryDemoRequestArgs = {
  input: GqlDispensaryDemoRequestInput;
};


export type GqlMutationDispensaryOnboardingArgs = {
  input: GqlDispensaryOnboardingInput;
};


export type GqlMutationDispensaryPublishSpecialsPageSettingsToLocationsArgs = {
  input: GqlDispensaryPublishSpecialsPageSettingsInput;
};


export type GqlMutationDispensaryRemoveFromChainArgs = {
  input: GqlDispensaryRemoveFromChainInput;
};


export type GqlMutationDispensaryUpdateArgs = {
  input: GqlDispensaryUpdateInput;
};


export type GqlMutationDispensaryUpdateHoursSettingsArgs = {
  input: GqlDispensaryUpdateHoursSettingsInput;
};


export type GqlMutationDispensaryUpdateOptionsSettingsArgs = {
  input: GqlDispensaryUpdateOptionsSettingsInput;
};


export type GqlMutationDispensaryUpdateStatusArgs = {
  input: GqlDispensaryUpdateStatusInput;
};


export type GqlMutationDispensaryUpdateTaxConfigurationArgs = {
  input?: InputMaybe<GqlDispensaryUpdateInput>;
};


export type GqlMutationDispensaryUploadOnboardingAssetArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationDownloadPurchaseOrderCsvArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDownloadPurchaseOrderPdfArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDuplicateDigitalDisplayBoardArgs = {
  enterpriseId: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type GqlMutationDuplicateDigitalDisplayPlaylistArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationEmailIntegrationCredentialsArgs = {
  input?: InputMaybe<GqlIntegrationCredsInput>;
};


export type GqlMutationEndEnterpriseSpecialArgs = {
  enterprise_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationEndOrderingSuspensionV2Args = {
  dispensaryId: Scalars['ID']['input'];
};


export type GqlMutationEndSpecialV2Args = {
  id: Scalars['String']['input'];
};


export type GqlMutationEnterpriseAssetLibraryCreateFolderArgs = {
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};


export type GqlMutationEnterpriseAssetLibraryDeleteAssetsArgs = {
  enterpriseId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type GqlMutationEnterpriseAssetLibraryDeleteFolderArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationEnterpriseAssetLibraryFinalizeAssetArgs = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  contentHash: Scalars['String']['input'];
  enterpriseId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlMutationEnterpriseAssetLibraryRequestUploadArgs = {
  contentHash: Scalars['String']['input'];
  enterpriseId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
};


export type GqlMutationEnterpriseAssetLibraryStartImportArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlMutationEnterpriseAssetLibraryUpdateAssetArgs = {
  enterpriseId: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlMutationExpirePlusApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationExpirePlusEnterpriseApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationExportCouponsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportCustomerReportArgs = {
  export: GqlExportCustomerReportInput;
};


export type GqlMutationExportDispensaryCustomersArgs = {
  input: GqlCustomerExportInput;
};


export type GqlMutationExportFilteredBrandsSummariesArgs = {
  input: GqlBrandsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCampaignsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCartsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCatalogArgs = {
  filters?: InputMaybe<GqlExportFilteredCatalogFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationExportFilteredProductSummariesArgs = {
  input: GqlProductsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportOrderReportArgs = {
  export: GqlExportOrderReportInput;
};


export type GqlMutationExportOrdersArgs = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type GqlMutationExportSpecialsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationFindOrCreateReferralCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  lspName: Scalars['String']['input'];
  posUniqueId?: InputMaybe<Scalars['String']['input']>;
  senderUserId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationForceDiscountSyncArgs = {
  integration_id: Scalars['String']['input'];
};


export type GqlMutationForceMenuPricingSyncArgs = {
  dispensary_id: Scalars['String']['input'];
};


export type GqlMutationGenerateDispensaryUserStreamTokenArgs = {
  input: GqlDispensaryUserStreamTokenInput;
};


export type GqlMutationGenerateHypurRedirectV3Args = {
  dispensaryId: Scalars['String']['input'];
  embedded: Scalars['Boolean']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  v2?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationGenerateHypurTokenV2Args = {
  code: Scalars['String']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};


export type GqlMutationImportCustomerCsvArgs = {
  CSV: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationImportDeliveryZipCodesArgs = {
  csv: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationImportMenuCsvArgs = {
  input: GqlImportMenuCsvInput;
};


export type GqlMutationImportProductReviewsArgs = {
  csv: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationIncrementClicksArgs = {
  special: GqlIncrementClicksInput;
};


export type GqlMutationInitiatePayByBankArgs = {
  input: GqlInitiatePayByBankInput;
};


export type GqlMutationIntegrationsDeleteArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsDeleteInArmaArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsForceSyncInArmaArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsSuggestionArgs = {
  dispensaryId: Scalars['String']['input'];
  suggestion?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationIntegrationsUpdateArgs = {
  input: GqlIntegrationsUpdateInput;
};


export type GqlMutationIntegrationsUpdateFieldsArgs = {
  input: GqlIntegrationsUpdateFieldsInput;
};


export type GqlMutationIntegrationsUpdateThresholdsArgs = {
  input: GqlIntegrationsUpdateThresholdsInput;
};


export type GqlMutationIntegrationsUpdateTypesArgs = {
  input: GqlIntegrationsUpdateTypesInput;
};


export type GqlMutationIntegrationsWipeMenuArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsWipeMenuInArmaArgs = {
  dispensaryId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
};


export type GqlMutationKioskSeenArgs = {
  dispensaryId: Scalars['String']['input'];
  kioskId: Scalars['String']['input'];
};


export type GqlMutationLibraryProductChangeImpactArgs = {
  product: GqlProductCreateInput;
};


export type GqlMutationLibraryProductChangeImpactV3Args = {
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationLogAnalyticsPayloadArgs = {
  payload: Scalars['JSONObject']['input'];
};


export type GqlMutationLoginAdminArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type GqlMutationLoginAdminViaTokenArgs = {
  transferToken: Scalars['String']['input'];
};


export type GqlMutationLoginConsumerArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationMarkAchEntryAsReturnedArgs = {
  achEntryId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  originalTraceNumber: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
};


export type GqlMutationMarkAchEntryAsReturnedV3Args = {
  achEntryId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationMarkAchEntryAsReturnedV4Args = {
  achEntryId: Scalars['String']['input'];
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationMarkAchEntryAsReturnedV5Args = {
  achEntryId: Scalars['String']['input'];
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationMarkBrandPortalUserNotificationsAsReadArgs = {
  input: GqlMarkBrandPortalUserNotificationsAsReadInput;
};


export type GqlMutationMarkCurbsideArrivalArrivedV2Args = {
  token: Scalars['String']['input'];
};


export type GqlMutationMarkOrderAutoPrintedArgs = {
  input?: InputMaybe<GqlMarkOrderAutoPrintedInput>;
};


export type GqlMutationMarkOrderPosFailedArgs = {
  input?: InputMaybe<GqlMarkOrderPosFailedInput>;
};


export type GqlMutationMarkOrderPrintedArgs = {
  input?: InputMaybe<GqlMarkOrderPrintedInput>;
};


export type GqlMutationMarkOrdersBatchPrintedArgs = {
  input?: InputMaybe<GqlMarkOrdersBatchPrintedInput>;
};


export type GqlMutationMergeBrandArgs = {
  destinationBrandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationMergeBrandsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type GqlMutationMergeLibraryProductsArgs = {
  id: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationMintEnterpriseDomainEntriTokenArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationModerateProductReviewArgs = {
  input: GqlModerateProductReviewInput;
};


export type GqlMutationNotifyInstoreCartOpenedArgs = {
  instoreCart: GqlNotifyInstoreCartOpenedInput;
};


export type GqlMutationParseAchReturnFileUploadArgs = {
  file: Scalars['String']['input'];
};


export type GqlMutationParseAchReturnFileUploadV2Args = {
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type GqlMutationPersistCheckoutArgs = {
  dispensaryId: Scalars['String']['input'];
  order: Scalars['JSON']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationPersistCheckoutV2Args = {
  dispensaryId: Scalars['String']['input'];
  order: Scalars['JSON']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationPreviewReservationSlotStrandingsArgs = {
  input: GqlReservationSlotsCreateInput;
};


export type GqlMutationPrintOrderOnTerminalArgs = {
  input?: InputMaybe<GqlPrintOrderInput>;
};


export type GqlMutationProvisionVoiceAgentPhoneNumberArgs = {
  areaCode: Scalars['String']['input'];
  enterpriseId: Scalars['ID']['input'];
  fallbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type GqlMutationRecordUserAcceptanceArgs = {
  acceptanceDocumentId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  userId: Scalars['String']['input'];
};


export type GqlMutationRemoveBlockedAddressArgs = {
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationRemoveBoardsFromDigitalDisplayBoardFolderArgs = {
  boardIds: Array<Scalars['ID']['input']>;
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationRemoveCategoryMenuOrderArgs = {
  input: GqlRemoveCategoryMenuOrderInput;
};


export type GqlMutationRemoveConsumerSsoArgs = {
  userId: Scalars['ID']['input'];
};


export type GqlMutationRemoveItemArgs = {
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};


export type GqlMutationReopenOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationResetPasswordV2Args = {
  input: GqlResetPasswordInput;
};


export type GqlMutationRespondToAchReturnArgs = {
  achReturnId: Scalars['String']['input'];
  discretionaryData?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  rdfiIdentification?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  secCode?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationRestartDigitalDisplayPlaylistArgs = {
  deviceId: Scalars['ID']['input'];
};


export type GqlMutationReverifyBrandCatalogArgs = {
  brandId: Scalars['ID']['input'];
  input: GqlReverifyBrandCatalogInput;
};


export type GqlMutationReversePaymentArgs = {
  achEntryId: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationReverseSettlementArgs = {
  achEntryId: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationRevertBrandMergeArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationRevokeBrandMenuInvitationArgs = {
  brandId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
};


export type GqlMutationSaveCmsContentVersionArgs = {
  data: Scalars['JSONObject']['input'];
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  publishNote?: InputMaybe<Scalars['String']['input']>;
  status: CmsContentVersionStatus;
  targeting?: InputMaybe<Array<GqlCmsSavedTargetingRuleInput>>;
  variantKey: Scalars['String']['input'];
  websiteId: Scalars['String']['input'];
};


export type GqlMutationSaveCmsTargetingArgs = {
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  rules: Array<GqlCmsTargetingRuleInput>;
  websiteId: Scalars['String']['input'];
};


export type GqlMutationSaveCustomNavigationArgs = {
  input: GqlSaveCustomNavigationInput;
};


export type GqlMutationSavePageArgs = {
  data: Scalars['JSONObject']['input'];
  enterpriseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  publishNote?: InputMaybe<Scalars['String']['input']>;
  status: CmsContentVersionStatus;
  targeting?: InputMaybe<Array<GqlCmsSavedTargetingRuleInput>>;
  urlPath: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId: Scalars['String']['input'];
};


export type GqlMutationSaveReviewsArgs = {
  reviews: Array<GqlProductReviewInput>;
  token: Scalars['String']['input'];
};


export type GqlMutationScheduleDigitalDisplayPlaylistChangeArgs = {
  boards?: InputMaybe<Array<GqlDigitalDisplayPlaylistBoardInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledAt: Scalars['String']['input'];
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
};


export type GqlMutationSendBrandUserPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type GqlMutationSendCompleteAccountSetupEmailArgs = {
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationSendLoginCodeArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationSendPasswordResetEmailV2Args = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type GqlMutationSendPhoneVerificationCodeArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationSendVerificationTokenArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type GqlMutationServerSideCalculationsArgs = {
  input: GqlLegacyCalculationsInput;
};


export type GqlMutationSetCategoryFeaturedBrandsArgs = {
  input: GqlSetCategoryFeaturedBrandsInput;
};


export type GqlMutationSetCategoryFeaturedProductsArgs = {
  input: GqlSetCategoryFeaturedProductsInput;
};


export type GqlMutationSetCategoryMenuOrderArgs = {
  input: GqlSetCategoryMenuOrderInput;
};


export type GqlMutationSetDigitalDisplayPlaylistsArgs = {
  assignments: Array<GqlDigitalDisplayAssignmentInput>;
  deviceId: Scalars['ID']['input'];
};


export type GqlMutationSetFeatureFlagOverrideArgs = {
  overrides: Scalars['JSON']['input'];
};


export type GqlMutationSetGlobalMenuOrderArgs = {
  input: GqlSetGlobalMenuOrderInput;
};


export type GqlMutationSetPasswordV2Args = {
  input: GqlSetPasswordInput;
};


export type GqlMutationSkipBucketProductArgs = {
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type GqlMutationSkipBucketProductV2Args = {
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  skipReasons: Array<SkipReasonEnum>;
};


export type GqlMutationSortMenuSectionsArgs = {
  dispensaryId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};


export type GqlMutationSpeculativeProductUpdateArgs = {
  bucketId: Scalars['String']['input'];
  product?: InputMaybe<GqlProductCreateInput>;
  productId: Scalars['String']['input'];
};


export type GqlMutationStartPayByBankFinalizationArgs = {
  orderId: Scalars['String']['input'];
};


export type GqlMutationStartPreAuthCheckArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationSubmitConsumerPulseReviewArgs = {
  input: GqlSubmitConsumerPulseReviewInput;
};


export type GqlMutationTrackIrlEventArgs = {
  input: GqlTrackIrlEventInput;
};


export type GqlMutationTrackIrlEventByDispensaryArgs = {
  input: GqlTrackIrlEventByDispensaryInput;
};


export type GqlMutationUnarchiveOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationUnclaimKioskArgs = {
  dispensaryId: Scalars['String']['input'];
  kioskId: Scalars['String']['input'];
};


export type GqlMutationUnenrollPayByBankUserArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlMutationUnsubscribeDispensaryCustomersArgs = {
  input: GqlUnsubscribeDispensaryCustomersInput;
};


export type GqlMutationUnverifyConsumerUserPhoneArgs = {
  userId: Scalars['String']['input'];
};


export type GqlMutationUpdateAutoPrintDevicesV2Args = {
  deviceIds: Array<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationUpdateBrandCollisionArgs = {
  brandCollision: GqlBrandCollisionInput;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateBrandEnterpriseSettingArgs = {
  id: Scalars['ID']['input'];
  settings: GqlBrandEnterpriseSettingsInput;
};


export type GqlMutationUpdateBrandFundedDiscountArgs = {
  id: Scalars['ID']['input'];
  input: GqlBrandFundedDiscountUpdateInput;
};


export type GqlMutationUpdateBrandImportHistoryNameArgs = {
  brandId: Scalars['ID']['input'];
  importId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type GqlMutationUpdateBrandTagArgs = {
  brandTag: GqlUpdateBrandTagInput;
  id: Scalars['ID']['input'];
};


export type GqlMutationUpdateBrandUserArgs = {
  id: Scalars['ID']['input'];
  updates: GqlBrandUserUpdateInput;
};


export type GqlMutationUpdateBrandUserAccountArgs = {
  updates: GqlBrandUserUpdateAccountInput;
};


export type GqlMutationUpdateBrandV2Args = {
  brand: GqlBrandInput;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateChainDispensariesImageArgs = {
  dispensaryId: Scalars['String']['input'];
  image_variant_keys?: InputMaybe<Array<ImageVariantKeyEnum>>;
};


export type GqlMutationUpdateChangeRequestCreateProductArgs = {
  complianceRegionId?: InputMaybe<Scalars['String']['input']>;
  contentAttributes?: InputMaybe<GqlUpdatedLibraryProduct>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateChangeRequestUpdateProductArgs = {
  contentAttributes?: InputMaybe<GqlUpdatedLibraryProduct>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateCheckoutArgs = {
  address?: InputMaybe<GqlCheckoutAddressInput>;
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orderType: Scalars['String']['input'];
  pricingType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateCnameArgs = {
  cname: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationUpdateCollectionArgs = {
  collectionId: Scalars['String']['input'];
  input: GqlUpdateCollectionInput;
};


export type GqlMutationUpdateCollectionPositionsArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateCollectionPositionsInput;
};


export type GqlMutationUpdateConsumerPulseSettingsArgs = {
  input: GqlUpdateConsumerPulseSettingsInput;
};


export type GqlMutationUpdateConsumerUserArgs = {
  user: GqlConsumerUserProfileInput;
};


export type GqlMutationUpdateCouponArgs = {
  coupon: GqlUpdateCouponInput;
};


export type GqlMutationUpdateCurbsideArrivalV2Args = {
  arrivalInformation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationUpdateCustomerCommunicationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInPush?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationUpdateCustomerSubscriptionArgs = {
  customerId: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};


export type GqlMutationUpdateDeviceArgs = {
  device: GqlUpdateDeviceInput;
};


export type GqlMutationUpdateDigitalDisplayBoardArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  audioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  colorScheme?: InputMaybe<Scalars['JSON']['input']>;
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  layout?: InputMaybe<DigitalDisplayBoardLayout>;
  menuColumns?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationUpdateDigitalDisplayBoardFolderArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type GqlMutationUpdateDigitalDisplayPlaylistArgs = {
  boards?: InputMaybe<Array<GqlDigitalDisplayPlaylistBoardInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
};


export type GqlMutationUpdateDigitalDisplaySettingsArgs = {
  deviceId: Scalars['ID']['input'];
  orientation: Scalars['String']['input'];
};


export type GqlMutationUpdateDiscountCampaignArgs = {
  id: Scalars['ID']['input'];
  input: GqlDiscountCampaignUpdateInput;
};


export type GqlMutationUpdateDispensaryAdSettingsArgs = {
  input: GqlUpdateDispensaryAdSettingsInput;
};


export type GqlMutationUpdateDispensaryCustomerArgs = {
  customer: GqlDispensaryCustomerInput;
};


export type GqlMutationUpdateDispensaryPersonalizationSettingsArgs = {
  input: GqlUpdateDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateDispensaryPrintedMenuSettingsV2Args = {
  input: GqlUpdateDispensaryPrintedMenuSettingsV2Input;
};


export type GqlMutationUpdateDutchiePosLoyaltyMemberArgs = {
  dispensaryId: Scalars['String']['input'];
  lastAndroidLoginUtc?: InputMaybe<Scalars['String']['input']>;
  lastIosLoginUtc?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type GqlMutationUpdateEmailOptInSettingArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type GqlMutationUpdateEmailV2Args = {
  email: Scalars['String']['input'];
};


export type GqlMutationUpdateEnterpriseAdSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  settings: GqlDispensaryAdSettingsInput;
};


export type GqlMutationUpdateEnterpriseLoyaltySettingsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateEnterpriseMobileAppSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  input?: InputMaybe<GqlEnterpriseMobileAppSettingsInput>;
};


export type GqlMutationUpdateEnterprisePersonalizationSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateEnterpriseSpecialV2Args = {
  id: Scalars['String']['input'];
  input: GqlEnterpriseSpecialInputV2;
};


export type GqlMutationUpdateEnterpriseVoiceAiEnablementArgs = {
  enterpriseId: Scalars['ID']['input'];
  voiceAiEnabled: Scalars['Boolean']['input'];
};


export type GqlMutationUpdateEnterpriseWebCustomizationSettingsV2Args = {
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
};


export type GqlMutationUpdateHoursSettingsArgs = {
  input: GqlHoursSettingsUpdateInput;
};


export type GqlMutationUpdateImageBannersArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateImageBannersInput;
};


export type GqlMutationUpdateIntegrationArgs = {
  integration: GqlIntegrationsUpdateInput;
  integrationId: Scalars['String']['input'];
};


export type GqlMutationUpdateKioskOrderPaymentArgs = {
  input?: InputMaybe<GqlUpdateKioskOrderPaymentInput>;
};


export type GqlMutationUpdateLibraryProductArgs = {
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationUpdateLocationGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GqlMutationUpdateMenuSectionArgs = {
  id: Scalars['ID']['input'];
  menuSection: GqlMenuSectionUpdateInput;
};


export type GqlMutationUpdateOrderPaymentArgs = {
  input?: InputMaybe<GqlUpdateOrderPaymentInput>;
};


export type GqlMutationUpdateOrderStatusArgs = {
  order?: InputMaybe<GqlOrdersStatusUpdateInput>;
};


export type GqlMutationUpdateOrderV2Args = {
  input?: InputMaybe<GqlOrdersCreateInput>;
};


export type GqlMutationUpdateOrderingSettingsArgs = {
  input: GqlOrderingSettingsUpdateInput;
};


export type GqlMutationUpdatePasswordV2Args = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type GqlMutationUpdatePlusOAuthProviderArgs = {
  enterpriseId: Scalars['String']['input'];
  input: GqlPlusOAuthProviderInput;
};


export type GqlMutationUpdatePrinterArgs = {
  input: GqlUpdatePrinterInput;
};


export type GqlMutationUpdateProductArgs = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  omitFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product?: InputMaybe<GqlProductCreateInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateProductSortArgs = {
  input: GqlUpdateProductSortInput;
};


export type GqlMutationUpdateProductStatusArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateProfileV2Args = {
  profile: GqlConsumerUserProfileInput;
};


export type GqlMutationUpdatePublicContextSessionArgs = {
  id: Scalars['String']['input'];
  loginMethodVerified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationUpdatePushNotificationTokenArgs = {
  dispensaryId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationUpdateQuantityArgs = {
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};


export type GqlMutationUpdateRemoteExtensionsArgs = {
  dispensaryId: Scalars['String']['input'];
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  input: GqlUpdateRemoteExtensionsInput;
};


export type GqlMutationUpdateReservationSlotsArgs = {
  input: GqlReservationSlotsUpdateInput;
};


export type GqlMutationUpdateSeoSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateSeoSettingsInput;
};


export type GqlMutationUpdateSingleDispensaryAdSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryAdSettingsInput;
};


export type GqlMutationUpdateSingleDispensaryPersonalizationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateSpecialMenuDesignArgs = {
  id: Scalars['ID']['input'];
  input: GqlMenuDesignInput;
};


export type GqlMutationUpdateSpecialV3Args = {
  id: Scalars['String']['input'];
  input: GqlSpecialsInputV3;
};


export type GqlMutationUpdateSpecialsSortOrderArgs = {
  input: GqlSortOrderInput;
};


export type GqlMutationUpdateStrainV2Args = {
  id: Scalars['String']['input'];
  strain: GqlStrainInput;
};


export type GqlMutationUpdateTerpeneV2Args = {
  id: Scalars['String']['input'];
  terpene: GqlTerpeneInput;
};


export type GqlMutationUpdateTextSettingArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationUpdateUserArgs = {
  user: GqlUsersUpdateInput;
};


export type GqlMutationUpdateUserEmailArgs = {
  currentEmail: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};


export type GqlMutationUpdateUserPermissionsArgs = {
  email: Scalars['String']['input'];
  permission: Scalars['String']['input'];
};


export type GqlMutationUpdateUserRoleV2Args = {
  email: Scalars['String']['input'];
  role: UserRoles;
};


export type GqlMutationUpdateVoiceAgentArgs = {
  enterpriseId: Scalars['ID']['input'];
  enterprisePrompt?: InputMaybe<Scalars['String']['input']>;
  fallbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationGroupId?: InputMaybe<Scalars['ID']['input']>;
  locationTransferNumbers?: InputMaybe<Array<GqlLocationTransferNumberInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spanishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  superAdminPrompt?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateWebCustomizationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsInput;
};


export type GqlMutationUpdateWebCustomizationSettingsV2Args = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
};


export type GqlMutationUploadBrandFundedDiscountImageArgs = {
  imageFile: GqlBrandFundedDiscountImageUploadInput;
};


export type GqlMutationUploadCsvImportArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  csvFile: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};


export type GqlMutationUploadImageArgs = {
  input: GqlImageUploadInput;
};


export type GqlMutationUploadSecureImageArgs = {
  input: GqlImageUploadInput;
};


export type GqlMutationUpsertBrandPortalDefaultContactArgs = {
  input: GqlUpsertBrandPortalDefaultContactInput;
};


export type GqlMutationUpsertBrandPortalNotificationSettingsArgs = {
  input: GqlUpsertBrandPortalNotificationSettingsInput;
};


export type GqlMutationUpsertPurchaseOrderArgs = {
  input: GqlUpsertPurchaseOrderInput;
};


export type GqlMutationValidateVerificationTokenArgs = {
  token: Scalars['String']['input'];
};


export type GqlMutationVerifyBucketProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type GqlMutationVerifyEnterpriseDomainArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationVerifyLoginCodeArgs = {
  code: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationVerifyPhoneVerificationCodeArgs = {
  code: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMxAccountInfo = {
  memberGuid: Scalars['String']['input'];
  userGuid: Scalars['String']['input'];
};

export type GqlMxBankAccount = {
  __typename?: 'MxBankAccount';
  accountAlias: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  bankName: Scalars['String']['output'];
  billingAddressId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  entityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
  mx?: Maybe<GqlMxResponse>;
  status: Scalars['String']['output'];
};

export type GqlMxBankAccounts = {
  __typename?: 'MxBankAccounts';
  bankAccounts?: Maybe<Array<GqlMxBankAccount>>;
};

export type GqlMxMemberVerification = {
  __typename?: 'MxMemberVerification';
  accounts: Array<GqlAccount>;
  identificationComplete: Scalars['Boolean']['output'];
  needsAccountSelection: Scalars['Boolean']['output'];
  needsMfa: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlMxResponse = {
  __typename?: 'MxResponse';
  connectionStatus: Scalars['String']['output'];
  widgetUrl: Scalars['String']['output'];
};

export type GqlNamedProductPotency = {
  __typename?: 'NamedProductPotency';
  name: Scalars['String']['output'];
  range: Array<Scalars['Float']['output']>;
  unit: Scalars['String']['output'];
};

export enum NavBarColor {
  aliceBlue = 'ALICE_BLUE',
  lightBrown = 'LIGHT_BROWN',
  white = 'WHITE',
  whiteSmoke = 'WHITE_SMOKE'
}

export type GqlNewLibraryProduct = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  connectedCount?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlNewLibraryProductV2 = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']['input']>;
  availableForWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  cannabinoidRatio?: InputMaybe<Scalars['String']['input']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  caseSize?: InputMaybe<Scalars['Int']['input']>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  connectedCount?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  dosageMg?: InputMaybe<Scalars['Float']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']['input']>;
  msrpCents?: InputMaybe<Scalars['Int']['input']>;
  packSize?: InputMaybe<Scalars['Int']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stockImage?: InputMaybe<Scalars['String']['input']>;
  stockImageAliases?: InputMaybe<Scalars['String']['input']>;
  stockImageCategory?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightGrams?: InputMaybe<Scalars['Float']['input']>;
  wholesalePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  wholesaleVariants?: InputMaybe<Array<GqlWholesaleVariantInput>>;
};

export type GqlNextServiceForOrderType = {
  closeMoment?: InputMaybe<Scalars['String']['input']>;
  openMoment?: InputMaybe<Scalars['String']['input']>;
  openString?: InputMaybe<Scalars['String']['input']>;
};

export type GqlNotificationSettings = {
  __typename?: 'NotificationSettings';
  email?: Maybe<Scalars['Boolean']['output']>;
  push?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlNotificationSettingsInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlNotifyInstoreCartOpenedInput = {
  cartToken: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlNotifyInstoreCartOpenedResponse = {
  __typename?: 'NotifyInstoreCartOpenedResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOldProductData = {
  __typename?: 'OldProductData';
  CBDContent?: Maybe<GqlProductPotency>;
  Name?: Maybe<Scalars['String']['output']>;
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  THCContent?: Maybe<GqlProductPotency>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlOpenInfoForDevice = {
  __typename?: 'OpenInfoForDevice';
  nextServiceString?: Maybe<Scalars['String']['output']>;
  shouldDeviceDisplayClosed?: Maybe<Scalars['Boolean']['output']>;
  shouldDevicePlayOrderAlert?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOpenInfoForOrderType = {
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  nextService?: InputMaybe<GqlNextServiceForOrderType>;
};

export type GqlOrderEditEvents = {
  __typename?: 'OrderEditEvents';
  agentName?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  byType?: Maybe<Scalars['String']['output']>;
};

export type GqlOrderList = {
  __typename?: 'OrderList';
  orders?: Maybe<Array<Maybe<GqlOrders>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlOrderMinimum = {
  __typename?: 'OrderMinimum';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
};

export type GqlOrderMinimumInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlOrderPrinted = {
  __typename?: 'OrderPrinted';
  printed?: Maybe<Scalars['Boolean']['output']>;
};

export enum OrderQueryStatuses {
  active = 'active',
  all = 'all',
  allIncludingArchived = 'allIncludingArchived',
  archived = 'archived',
  closed = 'closed'
}

export type GqlOrderReservation = {
  __typename?: 'OrderReservation';
  endTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  startTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlOrderReservationInput = {
  endTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlOrderSchedulingDataInput = {
  afterHoursEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  afterHoursInEffect?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  orderTypeHours?: InputMaybe<GqlHoursForOrderType>;
  orderTypeOpenInfo?: InputMaybe<GqlOpenInfoForOrderType>;
  reservationSlots?: InputMaybe<Array<InputMaybe<GqlReservationSlotsForOrderType>>>;
  scheduledOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingOption?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrderStatusEmailSettings = {
  __typename?: 'OrderStatusEmailSettings';
  disableConfirmed?: Maybe<Scalars['Boolean']['output']>;
  disableOutForDelivery?: Maybe<Scalars['Boolean']['output']>;
  disablePaymentError?: Maybe<Scalars['Boolean']['output']>;
  disablePaymentLifecycle?: Maybe<Scalars['Boolean']['output']>;
  disableReadyForPickup?: Maybe<Scalars['Boolean']['output']>;
  disableSubmitted?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrderStatusEvents = {
  __typename?: 'OrderStatusEvents';
  agentName?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  byType?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
};

export enum OrderType {
  delivery = 'delivery',
  kiosk = 'kiosk',
  pickupAll = 'pickup_all',
  pickupCurbside = 'pickup_curbside',
  pickupDrivethru = 'pickup_drivethru',
  pickupInstore = 'pickup_instore'
}

export type GqlOrderTypeConfig = {
  __typename?: 'OrderTypeConfig';
  anonymousCheckout?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  timeout?: Maybe<GqlTimeoutConfig>;
};

export enum OrderTypes {
  all = 'all',
  delivery = 'delivery',
  kiosk = 'kiosk',
  pickup = 'pickup'
}

export type GqlOrderTypesConfig = {
  __typename?: 'OrderTypesConfig';
  curbsidePickup?: Maybe<GqlOrderTypeConfig>;
  delivery?: Maybe<GqlOrderTypeConfig>;
  driveThruPickup?: Maybe<GqlOrderTypeConfig>;
  kiosk?: Maybe<GqlOrderTypeConfig>;
  offerAnyPickupService?: Maybe<Scalars['Boolean']['output']>;
  offerDeliveryService?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<GqlOrderTypeConfig>;
};

export type GqlOrderTypesConfigV2 = {
  __typename?: 'OrderTypesConfigV2';
  curbsidePickup?: Maybe<GqlCurbsidePickupOrderingSettings>;
  delivery?: Maybe<GqlDeliveryOrderingSettings>;
  driveThruPickup?: Maybe<GqlDriveThruPickupOrderingSettings>;
  inStorePickup?: Maybe<GqlInStorePickupOrderingSettings>;
  kiosk?: Maybe<GqlKioskOrderingSettings>;
  offerAnyPickupService?: Maybe<Scalars['Boolean']['output']>;
  offerDeliveryService?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrderUpdated = {
  __typename?: 'OrderUpdated';
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrder_BottleDepositTaxExistence = {
  __typename?: 'Order_bottleDepositTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_CannabisTaxExistence = {
  __typename?: 'Order_cannabisTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_Product = {
  __typename?: 'Order_product';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CBDContent?: Maybe<GqlProductPotency>;
  Image?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Marked for removal */
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  Prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  Status?: Maybe<Scalars['String']['output']>;
  THCContent?: Maybe<GqlProductPotency>;
  _id?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  integrationKey?: Maybe<Scalars['String']['output']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  productName?: Maybe<Scalars['String']['output']>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlOrder_SalesTaxExistence = {
  __typename?: 'Order_salesTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_TaxStages = {
  __typename?: 'Order_taxStages';
  checkout?: Maybe<Scalars['Boolean']['output']>;
  menu?: Maybe<Scalars['Boolean']['output']>;
  pos?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrderingSettingsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlCurbsidePickupInput>;
  delivery?: InputMaybe<GqlDeliveryInput>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlBasicSettingsInput>;
  inStorePickup?: InputMaybe<GqlBasicSettingsInput>;
  kiosk?: InputMaybe<GqlKioskInput>;
};

export type GqlOrderingSuspension = {
  __typename?: 'OrderingSuspension';
  id: Scalars['String']['output'];
};

export type GqlOrders = {
  __typename?: 'Orders';
  apartmentNum?: Maybe<Scalars['String']['output']>;
  appliedRewards?: Maybe<Array<Maybe<GqlReward>>>;
  archivedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  autoClosed?: Maybe<Scalars['Boolean']['output']>;
  autoConfirmed?: Maybe<Scalars['Boolean']['output']>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  bottleDepositTaxExistence?: Maybe<GqlOrder_BottleDepositTaxExistence>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cannabisTax?: Maybe<Scalars['Float']['output']>;
  cannabisTaxExistence?: Maybe<GqlOrder_CannabisTaxExistence>;
  checkoutToken?: Maybe<Scalars['String']['output']>;
  closedByDriver?: Maybe<Scalars['Boolean']['output']>;
  closedByTerminal?: Maybe<Scalars['Boolean']['output']>;
  coupon?: Maybe<GqlCoupons>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  creditTotal?: Maybe<Scalars['String']['output']>;
  curbsideArrivalInfo?: Maybe<GqlCurbsideArrival>;
  customer?: Maybe<GqlOrders_Customer>;
  customerState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by durationEstimates.delivery - 10/04/19 */
  deliveryEstimate?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  deliveryInfo?: Maybe<GqlOrders_DeliveryInfo>;
  deliveryTracking?: Maybe<GqlOrders_DeliveryTracking>;
  deliveryTrackingEnabled?: Maybe<Scalars['Boolean']['output']>;
  destinationTerminal?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlOrders_Dispensary>;
  dispoTimezone?: Maybe<Scalars['String']['output']>;
  driverEmail?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverNumber?: Maybe<Scalars['String']['output']>;
  driversLicense?: Maybe<Scalars['String']['output']>;
  driversLicenseExpirationDate?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationEstimates?: Maybe<GqlDurationEstimates>;
  dutchiePay?: Maybe<GqlDutchiePay>;
  dutchiePayEnabledForOrderType?: Maybe<Scalars['Boolean']['output']>;
  editEvents?: Maybe<Array<Maybe<GqlOrderEditEvents>>>;
  embedded?: Maybe<Scalars['Boolean']['output']>;
  fleetManagementTask?: Maybe<GqlOrders_FleetManagementTask>;
  guestCustomer?: Maybe<GqlOrders_GuestCustomer>;
  hypur?: Maybe<GqlHypurDetails>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHoursOrder?: Maybe<Scalars['Boolean']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isCurbsidePickupOrder?: Maybe<Scalars['Boolean']['output']>;
  isDriveThruPickupOrder?: Maybe<Scalars['Boolean']['output']>;
  isExternalUserOrder?: Maybe<Scalars['Boolean']['output']>;
  isGuestOrder?: Maybe<Scalars['Boolean']['output']>;
  isKioskOrder?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated temporary field to toggle compatibility with outdated clients */
  isPTPOT?: Maybe<Scalars['Boolean']['output']>;
  isPreviewOrder?: Maybe<Scalars['Boolean']['output']>;
  kioskName?: Maybe<Scalars['String']['output']>;
  linx?: Maybe<GqlOrders_Linx>;
  manualDiscount?: Maybe<GqlOrders_ManualDiscount>;
  medicalCard?: Maybe<GqlOrders_MedicalCard>;
  medicalOrder?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mixAndMatch?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  moneris?: Maybe<Array<Maybe<GqlMonerisDetails>>>;
  orderId?: Maybe<Scalars['String']['output']>;
  orders: Array<GqlOrders_Order>;
  originKioskId?: Maybe<Scalars['String']['output']>;
  otherFees?: Maybe<Scalars['Float']['output']>;
  paymentFee?: Maybe<Scalars['Float']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<GqlPaymentDetails>>>;
  paysafe?: Maybe<GqlPaysafeDetails>;
  platformType?: Maybe<PlatformType>;
  pos?: Maybe<GqlOrders_Pos>;
  preOrderType?: Maybe<PreOrderType>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  printCommandsJson?: Maybe<Scalars['JSON']['output']>;
  printCommandsWithLogoJson?: Maybe<Scalars['JSON']['output']>;
  receipt?: Maybe<Scalars['JSONObject']['output']>;
  receiptURL?: Maybe<Scalars['String']['output']>;
  reservation?: Maybe<GqlOrderReservation>;
  reviewRequestEmailSent?: Maybe<Scalars['Boolean']['output']>;
  salesTaxExistence?: Maybe<GqlOrder_SalesTaxExistence>;
  signatureImage?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusEvents?: Maybe<Array<Maybe<GqlOrderStatusEvents>>>;
  statusTimes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtotal?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  termsAccepted?: Maybe<Scalars['Boolean']['output']>;
  tipAmount?: Maybe<Scalars['Float']['output']>;
  tipValue?: Maybe<GqlOrders_TipValue>;
  total?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['String']['output']>;
  updateOrderToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  variantSource?: Maybe<Scalars['String']['output']>;
  voiceCallInfo?: Maybe<GqlVoiceCallInfo>;
};

export type GqlOrders_Pos = {
  __typename?: 'Orders_POS';
  externalID?: Maybe<Scalars['String']['output']>;
  failureAcks?: Maybe<GqlOrders_Pos_FailureLocations>;
  failureReason?: Maybe<Scalars['String']['output']>;
  failureType?: Maybe<Scalars['String']['output']>;
  humanReadableError?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Pos_FailureLocations = {
  __typename?: 'Orders_POS_FailureLocations';
  terminal?: Maybe<Scalars['Boolean']['output']>;
  web?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrders_Customer = {
  __typename?: 'Orders_customer';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<GqlOrders_Customer_Emails>>>;
  profile?: Maybe<GqlOrders_Customer_Profile>;
};

export type GqlOrders_Customer_Emails = {
  __typename?: 'Orders_customer_emails';
  address?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrders_Customer_Profile = {
  __typename?: 'Orders_customer_profile';
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  cart?: Maybe<GqlOrders_Customer_Profile_Cart>;
  coords?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  driversLicense?: Maybe<Scalars['String']['output']>;
  driversLicenseExpirationDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linx?: Maybe<GqlOrders_Customer_Profile_Linx>;
  medicalCard?: Maybe<GqlOrders_MedicalCard>;
  phone?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrders_Customer_Profile_Cart = {
  __typename?: 'Orders_customer_profile_cart';
  orderItems?: Maybe<Array<Maybe<GqlOrders_Customer_Profile_Cart_OrderItems>>>;
};

export type GqlOrders_Customer_Profile_Cart_OrderItems = {
  __typename?: 'Orders_customer_profile_cart_orderItems';
  additionalOption?: Maybe<Scalars['String']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rawOption?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Customer_Profile_Linx = {
  __typename?: 'Orders_customer_profile_linx';
  license?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_DeliveryInfo = {
  __typename?: 'Orders_deliveryInfo';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNum?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryOption?: Maybe<Scalars['Boolean']['output']>;
  lastSearchedAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlOrders_Location>;
  nonDeliveryAddress?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_DeliveryTracking = {
  __typename?: 'Orders_deliveryTracking';
  eta?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Dispensary = {
  __typename?: 'Orders_dispensary';
  _id?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  aeropay?: Maybe<Scalars['Boolean']['output']>;
  alt36?: Maybe<Scalars['Boolean']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  canPay?: Maybe<Scalars['Boolean']['output']>;
  chain?: Maybe<Scalars['String']['output']>;
  check?: Maybe<Scalars['Boolean']['output']>;
  creditCardAtDoor?: Maybe<Scalars['Boolean']['output']>;
  creditCardByPhone?: Maybe<Scalars['Boolean']['output']>;
  customDomainSettings?: Maybe<GqlDispensaries_Profile_CustomDomain_Settings>;
  debitOnly?: Maybe<Scalars['Boolean']['output']>;
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  deliveryMin?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<GqlDispensaries_FeatureFlags>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  linx?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerDelivery?: Maybe<Scalars['Boolean']['output']>;
  ordersConfig?: Maybe<GqlDispensaries_OrdersConfig>;
  payByBankManualFinalizationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated legacy payment option */
  payInStore?: Maybe<Scalars['Boolean']['output']>;
  payOnlineHypur?: Maybe<Scalars['Boolean']['output']>;
  payOnlineMerrco?: Maybe<Scalars['Boolean']['output']>;
  paytender?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  plusSettings?: Maybe<GqlDispensaries_Profile_Plus_Settings>;
  retailer?: Maybe<GqlRetailer>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_FleetManagementTask = {
  __typename?: 'Orders_fleetManagementTask';
  adapter?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  timeCreated?: Maybe<Scalars['String']['output']>;
  timeLastModified?: Maybe<Scalars['String']['output']>;
  trackingURL?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_GuestCustomer = {
  __typename?: 'Orders_guestCustomer';
  birthDay?: Maybe<Scalars['String']['output']>;
  birthMonth?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Linx = {
  __typename?: 'Orders_linx';
  license?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Location = {
  __typename?: 'Orders_location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  ln1?: Maybe<Scalars['String']['output']>;
  ln2?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_ManualDiscount = {
  __typename?: 'Orders_manualDiscount';
  fixedDiscountInCents?: Maybe<Scalars['Int']['output']>;
  percentDiscount?: Maybe<Scalars['Int']['output']>;
};

export type GqlOrders_MedicalCard = {
  __typename?: 'Orders_medicalCard';
  expirationDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Order = {
  __typename?: 'Orders_order';
  additionalOption?: Maybe<Scalars['String']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<GqlOrder_Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rawOption?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_TipValue = {
  __typename?: 'Orders_tipValue';
  dollar?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

/** Outlet collection timer info for displaying countdown on product pages */
export type GqlOutletCollectionInfo = {
  __typename?: 'OutletCollectionInfo';
  /** ISO date string for when the outlet collection ends */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Custom message to display with the timer (e.g., 'Order soon. Outlet closes in') */
  timerMessage?: Maybe<Scalars['String']['output']>;
};

export type GqlParseAchReturnFileUploadResponse = {
  __typename?: 'ParseAchReturnFileUploadResponse';
  data: Array<GqlAchReturnFileUploadResult>;
};

export type GqlPasswordUpdate = {
  __typename?: 'PasswordUpdate';
  accessToken: Scalars['String']['output'];
};

export enum PayByBankFinalizationRejectionReason {
  dposManaged = 'dposManaged',
  featureOff = 'featureOff',
  financialDrift = 'financialDrift',
  incompletePreAuth = 'incompletePreAuth',
  orderInactive = 'orderInactive',
  orderNotFound = 'orderNotFound',
  paymentMismatch = 'paymentMismatch',
  providerUnavailable = 'providerUnavailable',
  unsupportedCurrency = 'unsupportedCurrency',
  unsupportedOrigin = 'unsupportedOrigin',
  unsupportedPaymentState = 'unsupportedPaymentState'
}

export enum PayByBankFinalizationStatus {
  authorized = 'authorized',
  declined = 'declined',
  failed = 'failed',
  ineligible = 'ineligible',
  processing = 'processing',
  successful = 'successful',
  unavailable = 'unavailable'
}

export type GqlPayByBankFinalizationStatusResult = {
  __typename?: 'PayByBankFinalizationStatusResult';
  status: PayByBankFinalizationStatus;
};

export enum PayByBankIneligibleReason {
  alreadyPaid = 'alreadyPaid',
  cartCreationFailed = 'cartCreationFailed',
  customerNotEnrolled = 'customerNotEnrolled',
  dispensaryNotProvisioned = 'dispensaryNotProvisioned',
  featureOff = 'featureOff',
  linkExpired = 'linkExpired',
  orderNotFound = 'orderNotFound'
}

export type GqlPayByBankResult = {
  __typename?: 'PayByBankResult';
  instoreCartUrl?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  reason?: Maybe<PayByBankIneligibleReason>;
};

export type GqlPayment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Int']['output']>;
  checkoutToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  payee?: Maybe<GqlEntity>;
  payer?: Maybe<GqlEntity>;
  paymentMethod?: Maybe<GqlDutchiePayPaymentMethod>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlPaymentCard = {
  __typename?: 'PaymentCard';
  brand?: Maybe<Scalars['String']['output']>;
  lastDigits?: Maybe<Scalars['String']['output']>;
};

export type GqlPaymentDetails = {
  __typename?: 'PaymentDetails';
  card: GqlPaymentCard;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type GqlPaymentMethod = {
  __typename?: 'PaymentMethod';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPaymentRestrictions = {
  __typename?: 'PaymentRestrictions';
  payByBankSignupIncentive?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPaymentRestrictionsInput = {
  payByBankSignupIncentive?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PaymentStatus {
  paymentStatusAuthorized = 'PAYMENT_STATUS_AUTHORIZED',
  paymentStatusAuthorizing = 'PAYMENT_STATUS_AUTHORIZING',
  paymentStatusCancelled = 'PAYMENT_STATUS_CANCELLED',
  paymentStatusCancelling = 'PAYMENT_STATUS_CANCELLING',
  paymentStatusCaptured = 'PAYMENT_STATUS_CAPTURED',
  paymentStatusCapturing = 'PAYMENT_STATUS_CAPTURING',
  paymentStatusDeclined = 'PAYMENT_STATUS_DECLINED',
  paymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  paymentStatusFinalized = 'PAYMENT_STATUS_FINALIZED',
  paymentStatusFinalizing = 'PAYMENT_STATUS_FINALIZING',
  paymentStatusNew = 'PAYMENT_STATUS_NEW',
  paymentStatusRefunded = 'PAYMENT_STATUS_REFUNDED',
  paymentStatusRefunding = 'PAYMENT_STATUS_REFUNDING',
  paymentStatusRefundPending = 'PAYMENT_STATUS_REFUND_PENDING',
  paymentStatusUnspecified = 'PAYMENT_STATUS_UNSPECIFIED'
}

export type GqlPaymentTypeConfig = {
  __typename?: 'PaymentTypeConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  orderTypes?: Maybe<GqlPaymentsOrderTypes>;
  type?: Maybe<PaymentsPaymentType>;
};

export type GqlPaymentTypesConfig = {
  __typename?: 'PaymentTypesConfig';
  aeropay?: Maybe<Scalars['Boolean']['output']>;
  alt36?: Maybe<Scalars['Boolean']['output']>;
  canPay?: Maybe<Scalars['Boolean']['output']>;
  cash?: Maybe<Scalars['Boolean']['output']>;
  check?: Maybe<Scalars['Boolean']['output']>;
  creditCardAtDoor?: Maybe<Scalars['Boolean']['output']>;
  creditCardByPhone?: Maybe<Scalars['Boolean']['output']>;
  debit?: Maybe<Scalars['Boolean']['output']>;
  dutchiePay?: Maybe<Scalars['Boolean']['output']>;
  linx?: Maybe<Scalars['Boolean']['output']>;
  payOnlineChase?: Maybe<Scalars['Boolean']['output']>;
  payOnlineHypur?: Maybe<Scalars['Boolean']['output']>;
  payOnlineMerrco?: Maybe<Scalars['Boolean']['output']>;
  payOnlineMoneris?: Maybe<Scalars['Boolean']['output']>;
  paytender?: Maybe<Scalars['Boolean']['output']>;
  rethinkPay?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPaymentsCheckoutCredentials = GqlChaseHostedProfileCredentials | GqlMonerisHtProfileCredentials;

export type GqlPaymentsIsoDate = {
  nanos?: InputMaybe<Scalars['Int']['input']>;
  seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPaymentsOrderTypes = {
  __typename?: 'PaymentsOrderTypes';
  curbsidePickup?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  driveThruPickup?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
};

export enum PaymentsPaymentType {
  paymentTypeDutchiePay = 'PAYMENT_TYPE_DUTCHIE_PAY',
  paymentTypeRethink = 'PAYMENT_TYPE_RETHINK',
  paymentTypeUnspecified = 'PAYMENT_TYPE_UNSPECIFIED'
}

export type GqlPaysafeAuthorizations = {
  __typename?: 'PaysafeAuthorizations';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlPaysafeCard = {
  __typename?: 'PaysafeCard';
  lastDigits?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPaysafeDetails = {
  __typename?: 'PaysafeDetails';
  authorizations?: Maybe<Array<Maybe<GqlPaysafeAuthorizations>>>;
  card?: Maybe<GqlPaysafeCard>;
  refunds?: Maybe<Array<Maybe<GqlPaysafeRefunds>>>;
  settlements?: Maybe<Array<Maybe<GqlPaysafeSettlements>>>;
};

export type GqlPaysafeRefunds = {
  __typename?: 'PaysafeRefunds';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlPaysafeSettlements = {
  __typename?: 'PaysafeSettlements';
  amount?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlPbbRetryContext = {
  __typename?: 'PbbRetryContext';
  status: PbbRetryContextStatus;
};

export enum PbbRetryContextStatus {
  active = 'active',
  inactive = 'inactive'
}

export type GqlPendingDispensariesResult = {
  __typename?: 'PendingDispensariesResult';
  dispensaries?: Maybe<Array<Maybe<GqlDispensaries>>>;
  meta?: Maybe<GqlMeta>;
};

export type GqlPersistCheckoutResponse = {
  __typename?: 'PersistCheckoutResponse';
  checkoutToken: Scalars['String']['output'];
};

export type GqlPersonalizationSettings = {
  __typename?: 'PersonalizationSettings';
  enablePersonalizationForDefault?: Maybe<Scalars['Boolean']['output']>;
  enablePersonalizationForEmbedded?: Maybe<Scalars['Boolean']['output']>;
  enablePersonalizationForKiosk?: Maybe<Scalars['Boolean']['output']>;
  enablePersonalizationForStoreFront?: Maybe<Scalars['Boolean']['output']>;
  enableSortByRelevance?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPersonalizedProducts = {
  __typename?: 'PersonalizedProducts';
  products: Array<GqlProducts>;
};

export type GqlPersonalizedProductsFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  menuType: ProductMenuTypes;
};

export type GqlPersonalizedProductsFilterV2 = {
  category?: InputMaybe<Scalars['String']['input']>;
  menuType: ProductMenuTypes;
  menuVariant?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonalizedProductsModelNames {
  cartToppers = 'cart_toppers',
  oftenBoughtWith = 'often_bought_with',
  recommendedForYou = 'recommended_for_you',
  relatedItems = 'related_items'
}

export type GqlPhoneVerificationCheckResult = {
  __typename?: 'PhoneVerificationCheckResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlPhoneVerificationSendResult = {
  __typename?: 'PhoneVerificationSendResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  phoneHint?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlPhoneVerificationStatus = {
  __typename?: 'PhoneVerificationStatus';
  hasPhone?: Maybe<Scalars['Boolean']['output']>;
  ownerEmailHint?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlPickupMinimum = {
  __typename?: 'PickupMinimum';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
};

export type GqlPickupMinimumInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPickupReminders = {
  __typename?: 'PickupReminders';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  reminderMessage?: Maybe<Scalars['String']['output']>;
  reminderMinutesAfterReady?: Maybe<Scalars['Int']['output']>;
};

export type GqlPickupRemindersInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  reminderMessage?: InputMaybe<Scalars['String']['input']>;
  reminderMinutesAfterReady?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPlaidLinkAccounts = {
  id: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type GqlPlaidLinkInstitution = {
  institutionId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GqlPlaidLinkMetadata = {
  accounts: Array<InputMaybe<GqlPlaidLinkAccounts>>;
  institution: GqlPlaidLinkInstitution;
  linkSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPlaidLinkStart = {
  __typename?: 'PlaidLinkStart';
  linkToken: Scalars['String']['output'];
};

export enum PlatformType {
  kiosk = 'KIOSK',
  mobile = 'MOBILE',
  onlineMenu = 'ONLINE_MENU'
}

export type GqlPlusApiKey = {
  __typename?: 'PlusApiKey';
  createdAt: Scalars['ISODateTime']['output'];
  fresh: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  keyType: PlusApiKeyType;
  lastRequestAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export enum PlusApiKeyType {
  public = 'PUBLIC',
  secret = 'SECRET'
}

export type GqlPlusOAuthProvider = {
  __typename?: 'PlusOAuthProvider';
  authorizationUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  enterpriseId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  site: Scalars['String']['output'];
  tokenUrl: Scalars['String']['output'];
  userInfoUrl: Scalars['String']['output'];
};

export type GqlPlusOAuthProviderInput = {
  authorizationUrl: Scalars['String']['input'];
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  name: Scalars['String']['input'];
  site: Scalars['String']['input'];
  tokenUrl: Scalars['String']['input'];
  userInfoUrl: Scalars['String']['input'];
};

export enum PokeStatus {
  active = 'active',
  dismissed = 'dismissed'
}

export type GqlPolygon = {
  __typename?: 'Polygon';
  features?: Maybe<Array<Maybe<GqlGeoJson_Features>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPolygonInput = {
  features?: InputMaybe<Array<InputMaybe<GqlGeoJson_FeaturesInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPopularDispensary = {
  __typename?: 'PopularDispensary';
  actionEstimates?: Maybe<GqlActionEstimates>;
  cName?: Maybe<Scalars['String']['output']>;
  /** @deprecated covered by DeliveryOrderingSettings in ordering-settings */
  deliveryArea?: Maybe<GqlPolygon>;
  /** @deprecated used and defined in ordering-settings */
  deliveryFee?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined within hours-settings */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  deliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMin?: Maybe<Scalars['String']['output']>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMode?: Maybe<DeliveryModes>;
  distance?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<GqlDispensaries_FeatureFlags>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  hoursSettings?: Maybe<GqlDispensaryHoursSettings>;
  id?: Maybe<Scalars['String']['output']>;
  listImage?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlDispensaries_Profile_Location>;
  /** @deprecated used and defined in ordering-settings */
  maxDeliveryDistance?: Maybe<Scalars['Int']['output']>;
  medicalDispensary?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated use OrderTypesConfigV2 */
  orderTypesConfig?: Maybe<GqlOrderTypesConfig>;
  orderTypesConfigV2?: Maybe<GqlOrderTypesConfigV2>;
  /** @deprecated defined in hours-settings */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  recDispensary?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated defined within HoursSettingsForOrderType in ordering-settings */
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
  storeSettings?: Maybe<GqlDispensaries_StoreSettings>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlPosFeeConfigItem = {
  __typename?: 'PosFeeConfigItem';
  appliesToAllOrderTypes: Scalars['Boolean']['output'];
  appliesToAllZones: Scalars['Boolean']['output'];
  calculationMethod: Scalars['String']['output'];
  calculationValue: Scalars['Float']['output'];
  deliveryOnly: Scalars['Boolean']['output'];
  feeId: Scalars['Int']['output'];
  feeType: Scalars['String']['output'];
  isAutomatic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderMaximum?: Maybe<Scalars['Float']['output']>;
  orderMinimum?: Maybe<Scalars['Float']['output']>;
  orderTypes: Array<Scalars['String']['output']>;
  taxable: Scalars['Boolean']['output'];
  zones: Array<GqlPosFeeZone>;
};

export type GqlPosFeeZone = {
  __typename?: 'PosFeeZone';
  name: Scalars['String']['output'];
  zoneId: Scalars['Int']['output'];
};

export type GqlPosMedCardInfo = {
  __typename?: 'PosMedCardInfo';
  expirationDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPosOrder = {
  __typename?: 'PosOrder';
  fees?: Maybe<Array<GqlPosOrderFee>>;
  grandTotal: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  items?: Maybe<Array<GqlPosOrderItem>>;
  locationDetails: GqlPosOrderLocationDetails;
  lspId: Scalars['Int']['output'];
  lspLocId: Scalars['Int']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderSource?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  shipmentDeliveredLocal: Scalars['String']['output'];
  subTotal: Scalars['Float']['output'];
  tipAmount: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type GqlPosOrderFee = {
  __typename?: 'PosOrderFee';
  amount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlPosOrderItem = {
  __typename?: 'PosOrderItem';
  brandName?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type GqlPosOrderLocationDetails = {
  __typename?: 'PosOrderLocationDetails';
  city?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type GqlPosOrders = {
  __typename?: 'PosOrders';
  meta?: Maybe<GqlPosOrdersMeta>;
  orders?: Maybe<Array<GqlPosOrder>>;
};

export type GqlPosOrdersMeta = {
  __typename?: 'PosOrdersMeta';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Chemical compound for a Potency -- THC, CBD, and so forth */
export enum PotencyCompound {
  cbd = 'CBD',
  thc = 'THC'
}

/**
 * Search parameters for a Product's Potency. Allows for more complex
 * searching of products based on a Potency range
 */
export type GqlPotencyProductSearch = {
  /** Deprecated: Remove with ticket ENG-14662 */
  compound: PotencyCompound;
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  unit: PotencyUnit;
};

export type GqlPotencyRange = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum PotencyType {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo',
  notApplicable = 'notApplicable'
}

export enum PotencyUnit {
  milligrams = 'MILLIGRAMS',
  milligramsPerGram = 'MILLIGRAMS_PER_GRAM',
  milligramsPerMl = 'MILLIGRAMS_PER_ML',
  percentage = 'PERCENTAGE'
}

export enum PreOrderType {
  curbside = 'CURBSIDE',
  delivery = 'DELIVERY',
  driveThru = 'DRIVE_THRU',
  kiosk = 'KIOSK',
  pickup = 'PICKUP'
}

export type GqlPreferenceSettings = {
  __typename?: 'PreferenceSettings';
  emailAddress?: Maybe<Scalars['String']['output']>;
  optInEmail?: Maybe<Scalars['Boolean']['output']>;
  optInPush?: Maybe<Scalars['Boolean']['output']>;
  optInSMS?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlPreferenceSettingsResponse = {
  __typename?: 'PreferenceSettingsResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPreviewMongoProduct = {
  __typename?: 'PreviewMongoProduct';
  _id?: Maybe<Scalars['String']['output']>;
  additionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<GqlBrand>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlProductPotency>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  duplicatedProductId?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Scalars['JSON']['output']>;
  featured?: Maybe<GqlProducts_Featured>;
  forcedPotencyUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imgixSettings?: Maybe<GqlProducts_ImgixSettings>;
  integrationKey?: Maybe<Scalars['String']['output']>;
  isBelowKioskThreshold?: Maybe<Scalars['Boolean']['output']>;
  isBelowThreshold?: Maybe<Scalars['Boolean']['output']>;
  limitsPerCustomer?: Maybe<Array<Maybe<GqlProducts_LimitPerCustomer>>>;
  manualInventory?: Maybe<Array<Maybe<GqlProducts_ManualInventory>>>;
  matchedLibraryItems?: Maybe<Array<Maybe<GqlProducts_MatchedLibraryItems>>>;
  matchedLibraryItemsConfidence?: Maybe<Scalars['Float']['output']>;
  measurements?: Maybe<GqlProducts_Measurements>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  modifiedAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  nonArmsLength?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsBelowKioskThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsBelowThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  originalPrices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overrides?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pastCNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  posMetaData?: Maybe<GqlProducts_PosMetaData>;
  preCropImage?: Maybe<Scalars['String']['output']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  rawMedicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer reliable with menuType-specific specials 07/26/20 */
  special?: Maybe<Scalars['Boolean']['output']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  speculativeEdits?: Maybe<Array<Maybe<GqlProducts>>>;
  status?: Maybe<Scalars['String']['output']>;
  strain?: Maybe<GqlStrain>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlProductPotency>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByAdminAt?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesalePrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlPreviewProduct = {
  __typename?: 'PreviewProduct';
  appliedLibraryAttributes: GqlPreviewMongoProduct;
  product: GqlPreviewMongoProduct;
  productBatch?: Maybe<GqlProductBatch>;
  productImages: Array<Maybe<GqlProducts_Images>>;
  terpenes: Array<GqlProducts_Terpene>;
};

/**
 * A price bucket (e.g. "Under $10"). min/max are inclusive-lower/exclusive-upper bounds in dollars;
 * either may be null for unbounded.
 */
export type GqlPriceRangeBand = {
  __typename?: 'PriceRangeBand';
  /**
   * Named bandId, not id: band ids are short retailer-editable slugs ("under-10", "10-25", ...)
   * that are NOT globally unique across dispensaries. A field literally named 'id'/'_id' would
   * make Apollo Client's InMemoryCache auto-normalize this type into a global cache entity keyed
   * solely by that value, silently conflating different dispensaries' same-slug bands.
   */
  bandId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type GqlPriceRangeBandInput = {
  bandId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Per-retailer price-range filter config. Empty bands fall back to DEFAULT_PRICE_RANGE_BANDS.
 * enabled: false hides the filter.
 */
export type GqlPriceRangeFilterSettings = {
  __typename?: 'PriceRangeFilterSettings';
  bands?: Maybe<Array<GqlPriceRangeBand>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPriceRangeFilterSettingsInput = {
  bands?: InputMaybe<Array<GqlPriceRangeBandInput>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPriceSummary = {
  __typename?: 'PriceSummary';
  /**
   * Container/bottle deposit, in cents. Included in total, and deliberately excluded from taxes so
   * the value of taxes is unchanged for existing callers. Zero when no line item carries a deposit.
   */
  bottleDeposit: Scalars['Int']['output'];
  discounts: Scalars['Int']['output'];
  fees: Scalars['Int']['output'];
  mixAndMatch: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
  /** Total before taxes, fees, etc. */
  subtotal: Scalars['Int']['output'];
  taxes: Scalars['Int']['output'];
  /** Final total including taxes, fees, etc. */
  total: Scalars['Int']['output'];
};

export enum PrintAction {
  confirm = 'confirm',
  reprint = 'reprint'
}

export type GqlPrintJob = {
  __typename?: 'PrintJob';
  _id: Scalars['String']['output'];
  assignedToPrinterId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  dispensaryId: Scalars['String']['output'];
  printAfter: Scalars['ISODateTime']['output'];
  referenceId: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlPrintedMenuSettings_Branding = {
  __typename?: 'PrintedMenuSettings_Branding';
  applyStoreBranding?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_BrandingInput = {
  applyStoreBranding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_CategoryEntry = {
  __typename?: 'PrintedMenuSettings_CategoryEntry';
  category?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_CategoryEntryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_PageBreaks = {
  __typename?: 'PrintedMenuSettings_PageBreaks';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** True for an explicit choice, false for an automatic default; null preserves legacy saved choices. */
  explicitChoice?: Maybe<Scalars['Boolean']['output']>;
  subcategoryEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_PageBreaksInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** True for an explicit choice, false for an automatic default; omit for legacy clients. */
  explicitChoice?: InputMaybe<Scalars['Boolean']['input']>;
  subcategoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_Photos = {
  __typename?: 'PrintedMenuSettings_Photos';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_PhotosInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_PricingDisplay = {
  __typename?: 'PrintedMenuSettings_PricingDisplay';
  showDiscountBadge?: Maybe<Scalars['Boolean']['output']>;
  showSpecialsOnly?: Maybe<Scalars['Boolean']['output']>;
  showStrikethroughPricing?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_PricingDisplayInput = {
  showDiscountBadge?: InputMaybe<Scalars['Boolean']['input']>;
  showSpecialsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showStrikethroughPricing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_StrainTypesEntry = {
  __typename?: 'PrintedMenuSettings_StrainTypesEntry';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
};

export type GqlPrintedMenuSettings_StrainTypesEntryInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrintedMenuSettings_Text = {
  __typename?: 'PrintedMenuSettings_Text';
  text?: Maybe<Scalars['String']['output']>;
};

export type GqlPrintedMenuSettings_TextInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrintedMenuSettings_Type = {
  __typename?: 'PrintedMenuSettings_Type';
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPrintedMenuSettings_TypeInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrinter = {
  __typename?: 'Printer';
  _id: Scalars['String']['output'];
  adoptedAt?: Maybe<Scalars['ISODateTime']['output']>;
  adoptedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  deviceIdentifier: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  dispensaryId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isRecentlyActive?: Maybe<Scalars['Boolean']['output']>;
  lastError?: Maybe<Scalars['ISODateTime']['output']>;
  lastJobId?: Maybe<Scalars['ISODateTime']['output']>;
  lastPrintAt?: Maybe<Scalars['ISODateTime']['output']>;
  lastSeenAt?: Maybe<Scalars['ISODateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queueConfig?: Maybe<GqlPrinterQueueConfig>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlPrinterQueueConfig = {
  __typename?: 'PrinterQueueConfig';
  orderTypes: Array<Scalars['String']['output']>;
};

export type GqlPrinterQueueConfigInput = {
  orderTypes: Array<Scalars['String']['input']>;
};

export type GqlProductBatch = {
  __typename?: 'ProductBatch';
  active: Scalars['Boolean']['output'];
  digest?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
};

/** Resulting type from getProductBuyingOptions call */
export type GqlProductBuyingOptionsResult = {
  __typename?: 'ProductBuyingOptionsResult';
  buyingOptions: Array<GqlBuyingOption>;
  marketplaceProduct: GqlMarketplaceProduct;
  weightOptions?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ProductCardButtonOption {
  border = 'BORDER',
  icon = 'ICON',
  solid = 'SOLID',
  tinted = 'TINTED'
}

export enum ProductCardDefaultViewOption {
  card = 'CARD',
  list = 'LIST'
}

export type GqlProductCardDisplayOptions = {
  __typename?: 'ProductCardDisplayOptions';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  buttonDisplay?: Maybe<ProductCardButtonOption>;
  potencyColor?: Maybe<Scalars['String']['output']>;
  potencyDisplay?: Maybe<ProductCardPillDisplay>;
  priceColor?: Maybe<Scalars['String']['output']>;
  productNameColor?: Maybe<Scalars['String']['output']>;
  showCollection?: Maybe<Scalars['Boolean']['output']>;
  showDiscountNames?: Maybe<Scalars['Boolean']['output']>;
  showEffects?: Maybe<Scalars['Boolean']['output']>;
  showPotencyDetails?: Maybe<Scalars['Boolean']['output']>;
  showProductWeight?: Maybe<Scalars['Boolean']['output']>;
  showStaffPick?: Maybe<Scalars['Boolean']['output']>;
  showStrainType?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Colors.strainTypes.default instead */
  strainTypeColor?: Maybe<Scalars['String']['output']>;
  strainTypeDisplay?: Maybe<ProductCardPillDisplay>;
  strikethroughPriceColor?: Maybe<Scalars['String']['output']>;
  weightColor?: Maybe<Scalars['String']['output']>;
};

export type GqlProductCardDisplayOptionsInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  buttonDisplay?: InputMaybe<ProductCardButtonOption>;
  potencyColor?: InputMaybe<Scalars['String']['input']>;
  potencyDisplay?: InputMaybe<ProductCardPillDisplay>;
  priceColor?: InputMaybe<Scalars['String']['input']>;
  productNameColor?: InputMaybe<Scalars['String']['input']>;
  showCollection?: InputMaybe<Scalars['Boolean']['input']>;
  showDiscountNames?: InputMaybe<Scalars['Boolean']['input']>;
  showEffects?: InputMaybe<Scalars['Boolean']['input']>;
  showPotencyDetails?: InputMaybe<Scalars['Boolean']['input']>;
  showStaffPick?: InputMaybe<Scalars['Boolean']['input']>;
  showStrainType?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use Colors.strainTypes.default instead */
  strainTypeColor?: InputMaybe<Scalars['String']['input']>;
  strainTypeDisplay?: InputMaybe<ProductCardPillDisplay>;
  strikethroughPriceColor?: InputMaybe<Scalars['String']['input']>;
  weightColor?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductCardPillDisplay {
  border = 'BORDER',
  filled = 'FILLED',
  text = 'TEXT'
}

export type GqlProductCardSpecial = {
  __typename?: 'ProductCardSpecial';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: ProductCardSpecialKind;
  menuType: ProductCardSpecialMenuType;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export enum ProductCardSpecialKind {
  bogo = 'bogo',
  dollarOff = 'dollar_off',
  mixAndMatch = 'mix_and_match',
  percentOff = 'percent_off',
  unknown = 'unknown'
}

export enum ProductCardSpecialMenuType {
  both = 'both',
  medical = 'medical',
  recreational = 'recreational'
}

export enum ProductCardTextAlignmentOption {
  center = 'CENTER',
  left = 'LEFT'
}

export type GqlProductCards = {
  __typename?: 'ProductCards';
  defaultViewLarge?: Maybe<ProductCardDefaultViewOption>;
  defaultViewSmall?: Maybe<ProductCardDefaultViewOption>;
  disableProductCardImageCycling?: Maybe<Scalars['Boolean']['output']>;
  fullWidthImages?: Maybe<Scalars['Boolean']['output']>;
  mobileAppDisplayOptions?: Maybe<GqlProductCardDisplayOptions>;
  showProductWeight?: Maybe<Scalars['Boolean']['output']>;
  textAlignment?: Maybe<ProductCardTextAlignmentOption>;
};

export type GqlProductCardsInput = {
  defaultViewLarge?: InputMaybe<ProductCardDefaultViewOption>;
  defaultViewSmall?: InputMaybe<ProductCardDefaultViewOption>;
  disableProductCardImageCycling?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidthImages?: InputMaybe<Scalars['Boolean']['input']>;
  mobileAppDisplayOptions?: InputMaybe<GqlProductCardDisplayOptionsInput>;
  showProductWeight?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<ProductCardTextAlignmentOption>;
};

/** A Product's Category */
export enum ProductCategory {
  accessories = 'ACCESSORIES',
  allCategories = 'ALL_CATEGORIES',
  apparel = 'APPAREL',
  cbd = 'CBD',
  clones = 'CLONES',
  concentrate = 'CONCENTRATE',
  edible = 'EDIBLE',
  flower = 'FLOWER',
  hide = 'HIDE',
  nA = 'N_A',
  preRolls = 'PRE_ROLLS',
  seeds = 'SEEDS',
  tincture = 'TINCTURE',
  topicals = 'TOPICALS',
  vaporizers = 'VAPORIZERS'
}

export type GqlProductChangeEvent = {
  __typename?: 'ProductChangeEvent';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<GqlUsers>;
  event: ProductChangeEventType;
  id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  newValues?: Maybe<Scalars['JSON']['output']>;
  oldValues?: Maybe<Scalars['JSON']['output']>;
  productId: Scalars['ID']['output'];
  versionId?: Maybe<Scalars['ID']['output']>;
};

export enum ProductChangeEventType {
  brandUpdate = 'brand_update',
  contentTeamCreate = 'content_team_create',
  contentTeamUpdate = 'content_team_update',
  distributedMatchLibrary = 'distributed_match_library',
  engineeringMaintenance = 'engineering_maintenance',
  inventoryUpdate = 'inventory_update',
  libraryConnection = 'library_connection',
  libraryUpdate = 'library_update',
  matchingBrand = 'matching_brand',
  matchingConcentrations = 'matching_concentrations',
  matchingLibrary = 'matching_library',
  matchingStrain = 'matching_strain',
  menuSyncArchive = 'menu_sync_archive',
  menuSyncInsert = 'menu_sync_insert',
  menuSyncUpdate = 'menu_sync_update',
  retailerAdminCreate = 'retailer_admin_create',
  retailerAdminUpdate = 'retailer_admin_update'
}

export type GqlProductChangeRequest = {
  __typename?: 'ProductChangeRequest';
  actionType: ChangeRequestActionType;
  approvalStatus: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['ISODateTime']['output']>;
  authorId: Scalars['ID']['output'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID']['output'];
  complianceRegionId?: Maybe<Scalars['ID']['output']>;
  contentAttributes: GqlLibraryProduct;
  createdAt: Scalars['ISODateTime']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['ISODateTime']['output']>;
  rejectionReasons?: Maybe<Array<RejectionReasons>>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

/** A type that indicates medical or recreational products only */
export enum ProductConsumerType {
  med = 'MED',
  rec = 'REC'
}

export type GqlProductDemandCount = {
  __typename?: 'ProductDemandCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export type GqlProductDiscount = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProductEffect = {
  __typename?: 'ProductEffect';
  name: Scalars['String']['output'];
  power: Scalars['Int']['output'];
};

export type GqlProductFilters = {
  __typename?: 'ProductFilters';
  chainDropdownOptions?: Maybe<Array<Maybe<GqlChainDropdownOption>>>;
  dispensaryDropdownOptions: Array<Maybe<GqlDispensaryDropdownOption>>;
  statesDropdownOptions: Array<Maybe<GqlDropdownOption>>;
};

export enum ProductGroup {
  all = 'all',
  brand = 'brand',
  brands = 'brands',
  categories = 'categories',
  category = 'category',
  individual = 'individual',
  inventoryTags = 'inventory_tags',
  productTags = 'product_tags',
  strains = 'strains',
  vendors = 'vendors'
}

export type GqlProductImpactResponse = {
  __typename?: 'ProductImpactResponse';
  count?: Maybe<Scalars['Int']['output']>;
};

export enum ProductMenuTypes {
  med = 'med',
  rec = 'rec'
}

export type GqlProductOtherLocation = {
  __typename?: 'ProductOtherLocation';
  address?: Maybe<Scalars['String']['output']>;
  cName: Scalars['String']['output'];
  chain?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['ID']['output'];
  /** Straight-line miles from the dispensary being viewed; null if either lacks coordinates. */
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** This location's own copy of the enterprise product. */
  productId: Scalars['ID']['output'];
};

export type GqlProductPotency = {
  __typename?: 'ProductPotency';
  range?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  unit: Scalars['String']['output'];
  /** @deprecated Use range */
  value?: Maybe<Scalars['String']['output']>;
};

/** How much a product is listed for at a Dispensary */
export type GqlProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Float']['output'];
  salesAmount?: Maybe<Scalars['Float']['output']>;
};

export type GqlProductRatingSummary = {
  __typename?: 'ProductRatingSummary';
  aiSummary?: Maybe<Scalars['String']['output']>;
  aiSummaryGeneratedAt?: Maybe<Scalars['ISODateTime']['output']>;
  aiSummaryReviewCount: Scalars['Int']['output'];
  avgRating?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  effectsCounts: Scalars['JSON']['output'];
  fiveStarCount: Scalars['Int']['output'];
  fourStarCount: Scalars['Int']['output'];
  oneStarCount: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  reviewCount: Scalars['Int']['output'];
  threeStarCount: Scalars['Int']['output'];
  twoStarCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlProductRecommendation = {
  __typename?: 'ProductRecommendation';
  clickUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  impressionUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlProductRecommendations = {
  __typename?: 'ProductRecommendations';
  adapter?: Maybe<Scalars['String']['output']>;
  products: Array<GqlProductRecommendation>;
};

export type GqlProductReviewInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<Scalars['String']['input']>>;
  productId: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
};

export type GqlProductReviewStatusResponse = {
  __typename?: 'ProductReviewStatusResponse';
  reviewedProductIds: Array<Scalars['String']['output']>;
};

export type GqlProductReviewTokenResponse = {
  __typename?: 'ProductReviewTokenResponse';
  reviewedProductIds: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type GqlProductReviewsResponse = {
  __typename?: 'ProductReviewsResponse';
  meta?: Maybe<GqlQueryInfoType>;
  productReviews: Array<GqlConsumerProductReview>;
};

export type GqlProductSummary = {
  __typename?: 'ProductSummary';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dollarChange?: Maybe<Scalars['Float']['output']>;
  numSold?: Maybe<Scalars['Int']['output']>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Scalars['Float']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
};

export type GqlProductTag = {
  __typename?: 'ProductTag';
  tagId?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type GqlProductTags = {
  __typename?: 'ProductTags';
  inventoryTags?: Maybe<Array<Maybe<GqlProductTag>>>;
  productTags?: Maybe<Array<Maybe<GqlProductTag>>>;
};

export type GqlProducts = {
  __typename?: 'Products';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Standardize onto CBDContent 12/19/19 */
  CBD?: Maybe<Scalars['String']['output']>;
  CBDContent?: Maybe<GqlProductPotency>;
  Description?: Maybe<Scalars['String']['output']>;
  DispensaryID?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  /** Platform/order-type-specific slice of the POS pricing sync data, resolved post-serialization. Its discounts array carries each applied discount's own calculationMethod (PERCENT/AMOUNT, synced from leaflogix via Armageddon) -- consumers needing one answer per menuType (e.g. which badge format to render) reduce over that list themselves rather than reading a separate pre-aggregated field. */
  POSPricingData?: Maybe<Scalars['JSON']['output']>;
  Prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  Status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Standardize onto THCContent 12/19/19 */
  THC?: Maybe<Scalars['String']['output']>;
  THCContent?: Maybe<GqlProductPotency>;
  _id?: Maybe<Scalars['String']['output']>;
  adTrackers?: Maybe<GqlAdTrackers>;
  adminEdits?: Maybe<Array<Maybe<GqlProducts_AdminEdit>>>;
  avgRating?: Maybe<Scalars['Float']['output']>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<GqlBrand>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  cannabinoidsV2?: Maybe<Array<Maybe<GqlProducts_CannabinoidV2>>>;
  cbdContent?: Maybe<GqlProductPotency>;
  certificateOfAnalysisEnabled?: Maybe<Scalars['Boolean']['output']>;
  collectionCardBadge?: Maybe<GqlCollectionCardBadge>;
  collections?: Maybe<Array<Maybe<GqlProducts_Collection>>>;
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  connectedAt?: Maybe<Scalars['String']['output']>;
  connectedBy?: Maybe<Scalars['String']['output']>;
  connectedByUser?: Maybe<GqlUsers>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  duplicatedProductId?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Scalars['JSON']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<GqlProducts_Featured>;
  forcedPotencyUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<GqlProducts_Images>>;
  imgixSettings?: Maybe<GqlProducts_ImgixSettings>;
  integrationKey?: Maybe<Scalars['String']['output']>;
  isBelowKioskThreshold?: Maybe<Scalars['Boolean']['output']>;
  isBelowThreshold?: Maybe<Scalars['Boolean']['output']>;
  /** Computed prices that a light-mode (variant 2) POS pricing override replaced; null/empty otherwise */
  legacyPricing?: Maybe<GqlProducts_LegacyPricing>;
  libraryProduct?: Maybe<GqlLibraryProduct>;
  libraryProductId?: Maybe<Scalars['String']['output']>;
  libraryProductScore?: Maybe<Scalars['Float']['output']>;
  limitsPerCustomer?: Maybe<Array<Maybe<GqlProducts_LimitPerCustomer>>>;
  manualInventory?: Maybe<Array<Maybe<GqlProducts_ManualInventory>>>;
  matchedLibraryItems?: Maybe<Array<Maybe<GqlProducts_MatchedLibraryItems>>>;
  matchedLibraryItemsConfidence?: Maybe<Scalars['Float']['output']>;
  measurements?: Maybe<GqlProducts_Measurements>;
  medicalDiscountDisplays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  nonArmsLength?: Maybe<Scalars['Boolean']['output']>;
  optionsBelowKioskThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsBelowThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  originalPrices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Outlet collection timer info for displaying countdown on product detail pages */
  outletCollectionInfo?: Maybe<GqlOutletCollectionInfo>;
  overrides?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pastCNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  posDiscountNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  posMetaData?: Maybe<GqlProducts_PosMetaData>;
  /** Whether applyPOSPrices actually overwrote medicalPrices/recPrices (and specials) for this request, per menuType. Authoritative signal for POS-synced pricing -- POSPricingData bucket presence alone does not guarantee an override happened. */
  posSyncedPricingApplied?: Maybe<GqlProducts_PosSyncedPricingApplied>;
  preCropImage?: Maybe<Scalars['String']['output']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  productCardSpecials?: Maybe<Array<GqlProductCardSpecial>>;
  productTemplate?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<ProductsProvider>;
  rawMedicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recDiscountDisplays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer reliable with menuType-specific specials 07/26/20 */
  special?: Maybe<Scalars['Boolean']['output']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  specialIdsPerOption?: Maybe<Array<Maybe<GqlProducts_SpecialIdsPerOption>>>;
  speculativeEdits?: Maybe<Array<Maybe<GqlProducts>>>;
  stockImage?: Maybe<Scalars['String']['output']>;
  stockImageAliases?: Maybe<Scalars['String']['output']>;
  stockImageCategory?: Maybe<Scalars['String']['output']>;
  strain?: Maybe<GqlStrain>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['String']['output']>;
  terpenes?: Maybe<Array<Maybe<GqlProducts_Terpene>>>;
  thcContent?: Maybe<GqlProductPotency>;
  totalTerpenes?: Maybe<GqlProductPotency>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByAdminAt?: Maybe<Scalars['String']['output']>;
  updatedByUser?: Maybe<GqlUsers>;
  /** @deprecated No longer needed. 09/02/25 */
  useBetterPotencyTaxes?: Maybe<Scalars['Boolean']['output']>;
  vapeTaxApplicable?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesalePrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlProductsList = {
  __typename?: 'ProductsList';
  /** @deprecated Use menu filters instead 8/3/23 */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products: Array<Maybe<GqlProducts>>;
  queryInfo: GqlQueryInfoType;
};

export type GqlProductsPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductsProvider {
  crossingMinds = 'crossingMinds',
  dutchie = 'dutchie',
  /** @deprecated Moloco ads removed; retained for deployed clients until consumers are drained */
  moloco = 'moloco',
  sponsored = 'sponsored'
}

export type GqlProductsSalesByCategory = {
  __typename?: 'ProductsSalesByCategory';
  categoryOptions?: Maybe<Array<Maybe<GqlDropdownOption>>>;
  lineItems?: Maybe<Array<Maybe<GqlCategoryLineItem>>>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlProductsSummaryInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  increment?: InputMaybe<Scalars['String']['input']>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  strain?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_CannabinoidInputV2 = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cannabinoidId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlProducts_CannabinoidV2 = {
  __typename?: 'Products_CannabinoidV2';
  active?: Maybe<Scalars['Boolean']['output']>;
  cannabinoid?: Maybe<GqlCannabinoid>;
  cannabinoidId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<PotencyUnit>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_Collection = {
  __typename?: 'Products_Collection';
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_Images = {
  __typename?: 'Products_Images';
  _id?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  origin: ImageOrigin;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  url: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_ImagesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  origin: ImageOrigin;
  updatedAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  url: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_LegacyPricing = {
  __typename?: 'Products_LegacyPricing';
  Prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlProducts_PosMetaData = {
  __typename?: 'Products_POSMetaData';
  activeBatchTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalBrandCatalogBrandId?: Maybe<Scalars['String']['output']>;
  canonicalBrandCatalogProductId?: Maybe<Scalars['String']['output']>;
  canonicalBrandId?: Maybe<Scalars['String']['output']>;
  canonicalBrandName?: Maybe<Scalars['String']['output']>;
  canonicalCategory?: Maybe<Scalars['String']['output']>;
  canonicalCategoryId?: Maybe<Scalars['String']['output']>;
  canonicalEcommCategory?: Maybe<Scalars['String']['output']>;
  canonicalEcommSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canonicalEcommSubcategory?: Maybe<Scalars['String']['output']>;
  canonicalID?: Maybe<Scalars['String']['output']>;
  canonicalImgUrl?: Maybe<Scalars['String']['output']>;
  canonicalLabResultUrl?: Maybe<Scalars['String']['output']>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  canonicalPackageId?: Maybe<Scalars['String']['output']>;
  canonicalProductTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalSKU?: Maybe<Scalars['String']['output']>;
  canonicalStrainId?: Maybe<Scalars['String']['output']>;
  canonicalVendorId?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<GqlProducts_PosMetaData_Children>>>;
  integrationID?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_PosMetaData_Children = {
  __typename?: 'Products_POSMetaData_children';
  activeBatchTags?: Maybe<Array<Maybe<GqlTag>>>;
  /**
   * Per-weight-option cannabinoid/THC/CBD compounds (e.g. \"THC\", \"CBD\", \"THCA\"). Mirrors
   * 'terpenes' above -- Armageddon already writes this into POSMetaData.children[].cannabinoids,
   * it just wasn't exposed over GraphQL yet. ECOMM-13001.
   */
  cannabinoids?: Maybe<Array<Maybe<GqlProducts_PosMetaData_Children_PotencyMeasurement>>>;
  canonicalBrandId?: Maybe<Scalars['String']['output']>;
  canonicalBrandName?: Maybe<Scalars['String']['output']>;
  canonicalCategory?: Maybe<Scalars['String']['output']>;
  canonicalCategoryId?: Maybe<Scalars['String']['output']>;
  canonicalEcommCategory?: Maybe<Scalars['String']['output']>;
  canonicalEcommSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canonicalEcommSubcategory?: Maybe<Scalars['String']['output']>;
  canonicalEffectivePotencyMg?: Maybe<Scalars['Float']['output']>;
  canonicalID?: Maybe<Scalars['String']['output']>;
  canonicalImgUrl?: Maybe<Scalars['String']['output']>;
  canonicalLabResultUrl?: Maybe<Scalars['String']['output']>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  canonicalPackageId?: Maybe<Scalars['String']['output']>;
  canonicalProductTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalSKU?: Maybe<Scalars['String']['output']>;
  canonicalStrainId?: Maybe<Scalars['String']['output']>;
  canonicalVendorId?: Maybe<Scalars['String']['output']>;
  kioskQuantityAvailable?: Maybe<Scalars['Float']['output']>;
  medPrice?: Maybe<Scalars['Float']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  packageQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityAvailable?: Maybe<Scalars['Float']['output']>;
  recEquivalent?: Maybe<GqlProducts_PosMetaData_Children_Equivalent>;
  recPrice?: Maybe<Scalars['Float']['output']>;
  standardEquivalent?: Maybe<GqlProducts_PosMetaData_Children_Equivalent>;
  /**
   * Per-weight-option lab result compounds (e.g. \"Total Terpenes\", individual terpene names) as
   * synced from the POS package/batch backing this specific option -- see
   * MenuIntegration::DutchieProduct#to_hash's mapped_children in Armageddon. Distinct from the
   * product-level Products.terpenes/totalTerpenes fields, which aggregate across every weight
   * option's batch and therefore cannot vary when the shopper switches options. ECOMM-13001.
   */
  terpenes?: Maybe<Array<Maybe<GqlProducts_PosMetaData_Children_PotencyMeasurement>>>;
};

export type GqlProducts_PosMetaData_Children_Equivalent = {
  __typename?: 'Products_POSMetaData_children_equivalent';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * Raw per-option lab result compound as synced from the POS batch for one weight/package option.
 * Mirrors MenuIntegration::Measurements::LabResultMeasurement's {name, unit, values} shape.
 */
export type GqlProducts_PosMetaData_Children_PotencyMeasurement = {
  __typename?: 'Products_POSMetaData_children_potencyMeasurement';
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlProducts_PosMetaData_Children_StandardEquivalent = {
  __typename?: 'Products_POSMetaData_children_standardEquivalent';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_Terpene = {
  __typename?: 'Products_Terpene';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  libraryTerpene?: Maybe<GqlTerpene>;
  name?: Maybe<Scalars['String']['output']>;
  terpeneId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<PotencyUnit>;
  unitSymbol?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_TerpeneInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  terpeneId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type GqlProducts_AdminEdit = {
  __typename?: 'Products_adminEdit';
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type GqlProducts_Featured = {
  __typename?: 'Products_featured';
  current?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_FeaturedInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_ImgixSettings = {
  __typename?: 'Products_imgixSettings';
  productCard?: Maybe<GqlImgixSettings>;
  productModal?: Maybe<GqlImgixSettings>;
};

export type GqlProducts_LimitPerCustomer = {
  __typename?: 'Products_limitPerCustomer';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_LimitPerCustomerInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_ManualInventory = {
  __typename?: 'Products_manualInventory';
  inventory?: Maybe<Scalars['Int']['output']>;
  option?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_ManualInventoryInput = {
  inventory?: InputMaybe<Scalars['Int']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_MatchedLibraryItems = {
  __typename?: 'Products_matchedLibraryItems';
  _id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_Measurement = {
  __typename?: 'Products_measurement';
  unit?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlProducts_Measurements = {
  __typename?: 'Products_measurements';
  netWeight?: Maybe<GqlProducts_Measurement>;
  volume?: Maybe<GqlProducts_Measurement>;
};

/** Per-menuType record of whether applyPOSPrices actually overwrote this product's price arrays for the current request -- true only when a POSPricingData bucket was present AND had a valid menuPrices array. Absent/null fields mean POS-synced pricing was never applied, regardless of whether a POSPricingData bucket happens to be present (it can be stale). */
export type GqlProducts_PosSyncedPricingApplied = {
  __typename?: 'Products_posSyncedPricingApplied';
  medical?: Maybe<Scalars['Boolean']['output']>;
  recreational?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlProducts_PricingTierData = {
  __typename?: 'Products_pricingTierData';
  generatedTiersId?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<GqlProducts_PricingTierData_Tiers>>>;
  tiersId?: Maybe<Scalars['String']['output']>;
  tiersName?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_PricingTierData_Tiers = {
  __typename?: 'Products_pricingTierData_tiers';
  endWeight?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  pricePerGram?: Maybe<Scalars['Float']['output']>;
  startWeight?: Maybe<Scalars['Float']['output']>;
  weightUOM?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_SpecialData = {
  __typename?: 'Products_specialData';
  bogoSpecials?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials>>>;
  /** @deprecated Need to apply more than one special 7/20/20 */
  discount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Need to apply more than one special 7/20/20 */
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  saleSpecials?: Maybe<Array<Maybe<GqlProducts_SpecialData_SaleSpecials>>>;
};

export type GqlProducts_SpecialData_BogoSpecials = {
  __typename?: 'Products_specialData_bogoSpecials';
  applyRewardsToConditions?: Maybe<Scalars['Boolean']['output']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoConditions?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials_BogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoRewards?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials_BogoRewardItem>>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated In favor of stackingBehavior 03/29/22 */
  discountBehavior?: Maybe<Scalars['String']['output']>;
  discountBundle?: Maybe<GqlProducts_SpecialData_BogoSpecials_DiscountBundle>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  endStamp?: Maybe<Scalars['String']['output']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']['output']>;
  excludedProducts?: Maybe<GqlExcludedBogoProducts>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  itemsForAPrice?: Maybe<GqlProducts_SpecialData_BogoSpecials_ItemsForAPrice>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuType?: Maybe<Scalars['String']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  qualifyingConditionOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  qualifyingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  qualifyingRewardOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']['output']>;
  recurringEndDate?: Maybe<Scalars['String']['output']>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  settingsDerivedFrom?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  specialName?: Maybe<Scalars['String']['output']>;
  specialType?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']['output']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 12/03/25 */
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlProducts_SpecialData_BogoSpecials_BogoConditionItem = {
  __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem';
  _id?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<Products_SpecialData_ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlProducts_SpecialData_BogoSpecials_BogoRewardItem = {
  __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem';
  _id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use applicationRules */
  applicationRule?: Maybe<GqlApplicationRule>;
  applicationRules?: Maybe<Array<GqlApplicationRule>>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  dollarDiscount?: Maybe<Scalars['String']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  percentDiscount?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetPrice?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<Products_SpecialData_ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlProducts_SpecialData_BogoSpecials_DiscountBundle = {
  __typename?: 'Products_specialData_bogoSpecials_discountBundle';
  _id?: Maybe<Scalars['String']['output']>;
  applyTo?: Maybe<ApplicationScope>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_SpecialData_BogoSpecials_DiscountToCart = {
  __typename?: 'Products_specialData_bogoSpecials_discountToCart';
  _id?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_SpecialData_BogoSpecials_ItemsForAPrice = {
  __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice';
  _id?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum Products_SpecialData_ComparisonOperators {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo'
}

export type GqlProducts_SpecialData_SaleSpecials = {
  __typename?: 'Products_specialData_saleSpecials';
  createdBy?: Maybe<Scalars['String']['output']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  dollarDiscount?: Maybe<Scalars['Boolean']['output']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  menuType?: Maybe<Scalars['String']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  preOrderType?: Maybe<Array<Maybe<PreOrderType>>>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']['output']>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  settingsDerivedFrom?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  specialName?: Maybe<Scalars['String']['output']>;
  specialRestrictions?: Maybe<Scalars['JSON']['output']>;
  specialType?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']['output']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 12/03/25 */
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlProducts_SpecialIdsPerOption = {
  __typename?: 'Products_specialIdsPerOption';
  conditionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  option?: Maybe<Scalars['String']['output']>;
  rewardIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlProgramResponse = {
  __typename?: 'ProgramResponse';
  rewardRedemption?: Maybe<GqlRewardRedemptionDetails>;
};

export type GqlPromo = {
  __typename?: 'Promo';
  html: Scalars['String']['output'];
  recipient: Scalars['JSON']['output'];
};

export type GqlPublicContextSession = {
  __typename?: 'PublicContextSession';
  accessToken?: Maybe<Scalars['String']['output']>;
  claimedByUserId?: Maybe<Scalars['String']['output']>;
  creatorSecret?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  loginMethodVerified?: Maybe<Scalars['Boolean']['output']>;
  status: PublicContextSessionStatus;
};

export enum PublicContextSessionStatus {
  claimed = 'CLAIMED',
  expired = 'EXPIRED',
  unclaimed = 'UNCLAIMED'
}

export type GqlPurchaseOrder = {
  __typename?: 'PurchaseOrder';
  actualArrivalDate?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByEmail: Array<Scalars['String']['output']>;
  destinationDposLocGlobalId?: Maybe<Scalars['String']['output']>;
  destinationDposLocId?: Maybe<Scalars['Int']['output']>;
  destinationDposLspGlobalId?: Maybe<Scalars['String']['output']>;
  destinationDposLspId?: Maybe<Scalars['Int']['output']>;
  destinationDposServerRegion?: Maybe<Scalars['String']['output']>;
  expectedArrivalDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  items: Scalars['Int']['output'];
  purchaseOrderItems: Array<GqlPurchaseOrderLineItem>;
  purchaseOrderNumber: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  shippingInformation?: Maybe<Scalars['String']['output']>;
  sourceChannel: PurchaseOrderSourceChannel;
  sourceDposLocGlobalId?: Maybe<Scalars['String']['output']>;
  sourceDposLocId?: Maybe<Scalars['Int']['output']>;
  sourceDposLspGlobalId?: Maybe<Scalars['String']['output']>;
  sourceDposLspId?: Maybe<Scalars['Int']['output']>;
  sourceDposServerRegion?: Maybe<Scalars['String']['output']>;
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum PurchaseOrderCatalogSource {
  brand = 'brand',
  retailer = 'retailer'
}

export type GqlPurchaseOrderContactInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
};

export type GqlPurchaseOrderCsvDownload = {
  __typename?: 'PurchaseOrderCsvDownload';
  csvContent: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GqlPurchaseOrderDecisionInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPurchaseOrderDetail = {
  __typename?: 'PurchaseOrderDetail';
  actionRequiredBy?: Maybe<Scalars['String']['output']>;
  actioningPartyEngagedAt?: Maybe<Scalars['String']['output']>;
  actualArrivalDate?: Maybe<Scalars['String']['output']>;
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLineOne?: Maybe<Scalars['String']['output']>;
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  addressRecipientName?: Maybe<Scalars['String']['output']>;
  addressRegion?: Maybe<Scalars['String']['output']>;
  addressZipCode?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  canConfirm?: Maybe<Scalars['Boolean']['output']>;
  canDecide?: Maybe<Scalars['Boolean']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByEmail: Array<Scalars['String']['output']>;
  createdFromPurchaseOrderId?: Maybe<Scalars['String']['output']>;
  currentVersion?: Maybe<Scalars['Int']['output']>;
  decidedAt?: Maybe<Scalars['String']['output']>;
  decisionReason?: Maybe<Scalars['String']['output']>;
  destinationDposLocGlobalId?: Maybe<Scalars['String']['output']>;
  destinationDposLocId?: Maybe<Scalars['Int']['output']>;
  destinationDposLspGlobalId?: Maybe<Scalars['String']['output']>;
  destinationDposLspId?: Maybe<Scalars['Int']['output']>;
  destinationDposServerRegion?: Maybe<Scalars['String']['output']>;
  expectedArrivalDate?: Maybe<Scalars['String']['output']>;
  hasUnresolvedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  items: Scalars['Int']['output'];
  notes: Array<GqlPurchaseOrderNote>;
  purchaseOrderItems: Array<GqlPurchaseOrderItem>;
  purchaseOrderNumber: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  requestedSubtotalInCents: Scalars['Int']['output'];
  requestedTaxInCents: Scalars['Int']['output'];
  responseMode: PurchaseOrderResponseMode;
  retailerContactPhone?: Maybe<Scalars['String']['output']>;
  retailerReference?: Maybe<Scalars['String']['output']>;
  shippingInformation?: Maybe<Scalars['String']['output']>;
  sourceChannel: PurchaseOrderSourceChannel;
  sourceDposLocGlobalId?: Maybe<Scalars['String']['output']>;
  sourceDposLocId?: Maybe<Scalars['Int']['output']>;
  sourceDposLocName: Scalars['String']['output'];
  sourceDposLspGlobalId?: Maybe<Scalars['String']['output']>;
  sourceDposLspId?: Maybe<Scalars['Int']['output']>;
  sourceDposLspName: Scalars['String']['output'];
  sourceDposServerRegion?: Maybe<Scalars['String']['output']>;
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  versions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  viewingVersion?: Maybe<Scalars['Int']['output']>;
};

export type GqlPurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  brandConfirmed: Scalars['Boolean']['output'];
  caseSize?: Maybe<Scalars['Int']['output']>;
  catalogLinkApproved: Scalars['Boolean']['output'];
  catalogLinkRejected: Scalars['Boolean']['output'];
  catalogSource: PurchaseOrderCatalogSource;
  confirmedQuantity: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  hasUnresolvedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  itemStatus: PurchaseOrderItemStatus;
  libraryProductId?: Maybe<Scalars['String']['output']>;
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes: Array<GqlPurchaseOrderNote>;
  originalPurchaseOrderItemId?: Maybe<Scalars['String']['output']>;
  previousState?: Maybe<Scalars['JSON']['output']>;
  purchaseOrderId: Scalars['String']['output'];
  purchaseOrderItemPackages: Array<GqlPurchaseOrderItemPackage>;
  requestedQuantity: Scalars['Int']['output'];
  requestedSubtotalInCents: Scalars['Int']['output'];
  requestedTaxInCents: Scalars['Int']['output'];
  requestedUnitPriceInCents?: Maybe<Scalars['Int']['output']>;
  retailerConfirmed: Scalars['Boolean']['output'];
  retailerMetrcItemName?: Maybe<Scalars['String']['output']>;
  retailerProductCategory?: Maybe<Scalars['String']['output']>;
  retailerProductName?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  suggestedLibraryProductId?: Maybe<Scalars['String']['output']>;
  taxInCents: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  unitPriceInCents: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  variantName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  wholesaleVariantId?: Maybe<Scalars['String']['output']>;
};

export type GqlPurchaseOrderItemPackage = {
  __typename?: 'PurchaseOrderItemPackage';
  createdAt: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
  flowerEquivalent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  manufacturingDate?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['String']['output'];
  packagingDate?: Maybe<Scalars['String']['output']>;
  purchaseOrderItemId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum PurchaseOrderItemStatus {
  confirmed = 'confirmed',
  pending = 'pending',
  rejected = 'rejected',
  substituted = 'substituted'
}

export type GqlPurchaseOrderLineItem = {
  __typename?: 'PurchaseOrderLineItem';
  confirmedQuantity: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  libraryProductId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  purchaseOrderId: Scalars['String']['output'];
  requestedQuantity: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  unitPriceInCents: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type GqlPurchaseOrderList = {
  __typename?: 'PurchaseOrderList';
  data: Array<GqlPurchaseOrderSummary>;
  meta: GqlPurchaseOrderMeta;
};

export type GqlPurchaseOrderMeta = {
  __typename?: 'PurchaseOrderMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlPurchaseOrderNote = {
  __typename?: 'PurchaseOrderNote';
  authorEmail: Scalars['String']['output'];
  authorParty: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notableId: Scalars['String']['output'];
  notableType: Scalars['String']['output'];
};

export type GqlPurchaseOrderPdfDownload = {
  __typename?: 'PurchaseOrderPdfDownload';
  filename: Scalars['String']['output'];
  pdfBase64: Scalars['String']['output'];
};

export enum PurchaseOrderResponseMode {
  brandAcceptOrReject = 'brand_accept_or_reject',
  twoParty = 'two_party'
}

export enum PurchaseOrderSourceChannel {
  dutchiePos = 'dutchie_pos',
  publicBrandMenu = 'public_brand_menu'
}

export enum PurchaseOrderStatus {
  amended = 'amended',
  cancelled = 'cancelled',
  closedReceived = 'closed_received',
  confirmed = 'confirmed',
  openDraft = 'open_draft',
  partiallyConfirmed = 'partially_confirmed',
  pendingManagerApproval = 'pending_manager_approval',
  rejected = 'rejected',
  rejectedByFulfillment = 'rejected_by_fulfillment',
  shipped = 'shipped',
  submitted = 'submitted'
}

export type GqlPurchaseOrderSummary = {
  __typename?: 'PurchaseOrderSummary';
  actionRequiredBy?: Maybe<Scalars['String']['output']>;
  actioningPartyEngagedAt?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByEmail: Array<Scalars['String']['output']>;
  expectedArrivalDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  items: Scalars['Int']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  requestedSubtotalInCents: Scalars['Int']['output'];
  sourceChannel: PurchaseOrderSourceChannel;
  sourceDposLocGlobalId?: Maybe<Scalars['String']['output']>;
  sourceDposLocId?: Maybe<Scalars['Int']['output']>;
  sourceDposLocName: Scalars['String']['output'];
  sourceDposLspGlobalId?: Maybe<Scalars['String']['output']>;
  sourceDposLspId?: Maybe<Scalars['Int']['output']>;
  sourceDposLspName: Scalars['String']['output'];
  sourceDposServerRegion?: Maybe<Scalars['String']['output']>;
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type GqlPurchaseOrdersFilterInput = {
  destinationDposLocGlobalId?: InputMaybe<Scalars['String']['input']>;
  destinationDposLocId?: InputMaybe<Scalars['String']['input']>;
  destinationDposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  destinationDposLspId?: InputMaybe<Scalars['String']['input']>;
  destinationDposServerRegion?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspId?: InputMaybe<Scalars['String']['input']>;
  sourceDposServerRegion?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPurchaseOrdersListFiltersInput = {
  actionRequiredBy?: InputMaybe<Scalars['String']['input']>;
  actioningPartyEngagedAt?: InputMaybe<Scalars['Boolean']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateField?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationDposLocGlobalId?: InputMaybe<Scalars['String']['input']>;
  destinationDposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspId?: InputMaybe<Scalars['String']['input']>;
  sourceDposServerRegion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<PurchaseOrderStatus>>>;
};

export enum PurchaseOrdersSortBy {
  createdAt = 'created_at',
  purchaseOrderNumber = 'purchase_order_number',
  status = 'status',
  updatedAt = 'updated_at'
}

export type GqlPurchaseOrdersSortInput = {
  sortBy?: InputMaybe<PurchaseOrdersSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlPushNotificationHistoryInput = {
  dispensaryCname?: InputMaybe<Scalars['String']['input']>;
  firebaseProjectId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPushNotificationHistoryItem = {
  __typename?: 'PushNotificationHistoryItem';
  body: Scalars['String']['output'];
  dispensaryCname?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type GqlPushNotificationHistoryList = {
  __typename?: 'PushNotificationHistoryList';
  items: Array<GqlPushNotificationHistoryItem>;
  meta: GqlPushNotificationHistoryMeta;
};

export type GqlPushNotificationHistoryMeta = {
  __typename?: 'PushNotificationHistoryMeta';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type GqlQuery = {
  __typename?: 'Query';
  activeDispensaries?: Maybe<GqlActiveDispenariesResult>;
  activeProductsCheck?: Maybe<Array<Maybe<GqlProducts>>>;
  addressResidentialCheck?: Maybe<GqlValidationResponse>;
  archivedProductLookup?: Maybe<Array<Maybe<GqlProducts>>>;
  availableSegments: Array<GqlSegment>;
  brandAgreementStatus?: Maybe<GqlBrandAgreementStatus>;
  brandMenuInvitations: GqlBrandMenuInvitationConnection;
  brandPortalDefaultContacts: Array<GqlBrandPortalDefaultContact>;
  brandPortalNotificationSettings: Array<GqlBrandPortalNotificationSetting>;
  brandPortalProductSearch?: Maybe<GqlBrandPortalProductSearchResponse>;
  brandPortalUserNotifications: Array<GqlBrandPortalUserNotification>;
  brandTags: Array<GqlBrandTag>;
  bulkLibraryProductUpdateStatus?: Maybe<GqlBulkLibraryProductStatusUpdateResponse>;
  bulkLibraryProductUploadStatus?: Maybe<GqlBulkLibraryProductUploadStatusResponse>;
  calculateCheckout?: Maybe<GqlCalculateCheckout>;
  chainDispensariesByStatus?: Maybe<Array<Maybe<GqlDispensaries>>>;
  chainDispensaryIds: Array<Maybe<Scalars['String']['output']>>;
  chainDispensaryNamesAndIds?: Maybe<Array<Maybe<GqlDispensaries>>>;
  /**
   * Chain-wide, read-only audit of every dispensary user's permissions for the given chain --
   * lets a chain admin (e.g. a multi-location operator) see who has access to what across every
   * location without clicking into each user in each location individually. See PF-6420.
   */
  chainUserPermissionsReport: Array<GqlChainUserPermissionRow>;
  changeRequestProduct?: Maybe<GqlProductChangeRequest>;
  checkAgeVerification: GqlAgeVerification;
  checkAllotment?: Maybe<GqlAllotmentInfo>;
  checkPurchaseLimits?: Maybe<GqlCheckPurchaseLimitsResult>;
  cmsContent?: Maybe<GqlCmsContent>;
  cmsContentVersion?: Maybe<GqlCmsContentVersion>;
  cmsContentVersions?: Maybe<GqlCmsContentVersionList>;
  cmsLatestContent?: Maybe<GqlCmsLatestContent>;
  cmsPage?: Maybe<GqlCmsPage>;
  cmsPages?: Maybe<GqlCmsPageList>;
  cmsResolveContent?: Maybe<GqlCmsResolvedContent>;
  cmsResolveWebsiteContent?: Maybe<GqlCmsResolvedContent>;
  cmsTargeting?: Maybe<GqlCmsTargetingRuleSet>;
  cmsVariants?: Maybe<GqlCmsVariantList>;
  /**
   * Server-to-server verification of an admin JWT, used by the CMS (Dutchie Web Studio) service.
   *
   * This is native dutchie-api logic (it calls Armageddon's own `/rest/me_admin` and
   * `/rest/enterprises/:id` REST endpoints) - unlike `cmsContent`/`cmsVariants`/etc, it does
   * NOT proxy to the CMS worker itself. CMS receives the admin's access token directly from
   * the browser (forwarded as a normal Authorization header on this request) and needs to
   * confirm - without trusting the browser - that dutchie-api considers the token valid for
   * `enterpriseId` before it lets that admin edit enterprise-scoped CMS content. The response
   * includes a minimal, purpose-built view of the admin identity (`CmsVerifiedAdmin` -
   * deliberately NOT the full `IdentityAdmin` type, to avoid handing CMS unrelated fields
   * such as Zendesk SSO tokens) and the enterprise it was verified against.
   *
   * Access level is carried on `admin.profile.type` (`"superAdmin"` | `"dispensaryUser"` |
   * `"user"`), `admin.profile.chainID`, and `admin.profile.permissions` - there is no
   * separate access-level field.
   *
   * The caller supplies a random `nonce` (max 256 characters). dutchie-api generates its own
   * `serverNonce` (64 lowercase hex characters) and returns an HMAC-SHA256 `verificationHash`
   * of `nonce`, `serverNonce`, `admin._id`, and `enterpriseId` (colon-joined, in that order:
   * `<nonce>:<serverNonce>:<admin._id>:<enterpriseId>`), keyed with the same shared secret CMS
   * already uses to sign its outbound requests to dutchie-api (CMS_API_KEY). CMS recomputes
   * that HMAC the same way and compares it to `verificationHash`: only a dutchie-api instance
   * that holds the shared secret can produce a matching hash, which is what proves the response
   * actually came from an authoritative server rather than being spoofed or replayed by an
   * intermediary - AND (because the admin id and enterprise id are bound into the hash, not
   * just the two nonces) that the specific admin/enterprise pairing wasn't substituted in
   * transit. Fields outside that bound set (e.g. `admin.profile.permissions`, `enterprise`'s
   * display metadata) are NOT covered by the hash and should be treated as informational only.
   *
   * Gated by the `growth.ecomm.cms-verify-admin-token.rollout` LaunchDarkly flag (defaults to
   * disabled) so this can ship dark until CMS is ready to call it, and be killed instantly
   * without a deploy if needed.
   *
   * Errors (via `extensions.code`):
   * - `SESSION_INVALID` - no authenticated user, or Armageddon has no admin record for them.
   * - `FORBIDDEN` - the rollout flag is disabled, the caller isn't an admin/dispensary user,
   *   or (for non-super-admins) the admin's own `enterpriseId` doesn't match the requested
   *   `enterpriseId`.
   * - `INTERNAL_SERVER_ERROR` - `CMS_API_KEY` isn't configured, or the admin lookup itself
   *   failed (Armageddon outage/timeout) - distinct from `enterpriseLookupFailed`, below,
   *   which does not fail the request.
   */
  cmsVerifyAdminToken?: Maybe<GqlCmsAdminTokenVerification>;
  cmsWebsites?: Maybe<GqlCmsWebsiteList>;
  computeWithPriceCart?: Maybe<GqlCalculationResults>;
  connectNewProductPreview?: Maybe<GqlConnectProductPreviewResponse>;
  consumerLatestCompletedTransaction?: Maybe<GqlLatestCompletedTransaction>;
  consumerPosOrder?: Maybe<GqlPosOrder>;
  consumerPosOrders?: Maybe<GqlPosOrders>;
  contentStatistics?: Maybe<GqlContentStatistics>;
  /**
   * Compares a copyable setting's persisted value at the source dispensary against
   * every other dispensary in the same chain, so the admin "Manage across
   * locations" modal can group locations into Matches/Different and select
   * sync-eligible targets before calling copyToLocations. Backend owns extraction
   * and equality (Dispensaries::CopyableSettingLocations) so this exactly matches
   * copy behavior.
   */
  copyableSettingLocations?: Maybe<GqlCopyableSettingLocationsResponse>;
  /**
   * Registry of dispensary profile setting paths that may be copied between
   * locations via copyToLocations (setting:<path> item ids). Derived from
   * Armageddon's Mongoid schema annotations - the single source of truth the
   * admin UI uses to decide which settings get a copy affordance.
   */
  copyableSettings?: Maybe<GqlCopyableSettingsConfig>;
  createPaymentMethod?: Maybe<GqlMxMemberVerification>;
  /** @deprecated Use getCurbsideArrivals */
  curbsideArrivalsForDispensary?: Maybe<Array<Maybe<GqlCurbsideArrival>>>;
  currentDevice?: Maybe<GqlDevices>;
  customerOrdersEnhanced: Array<GqlCustomerOrder>;
  decagonPbbRetryContext?: Maybe<GqlPbbRetryContext>;
  devAccounts: Array<GqlDevAccount>;
  digitalDisplay: GqlDigitalDisplay;
  digitalDisplayBoard: GqlDigitalDisplayBoard;
  digitalDisplayBoardFolders: Array<GqlDigitalDisplayBoardFolder>;
  digitalDisplayBoards: GqlDigitalDisplayBoardConnection;
  digitalDisplayDevices: Array<GqlDigitalDisplayDevice>;
  digitalDisplayPlaylist: GqlDigitalDisplayPlaylist;
  digitalDisplayPlaylists: GqlDigitalDisplayPlaylistConnection;
  dispensaryCustomers?: Maybe<GqlCustomersList>;
  displayConfig?: Maybe<GqlDisplayConfig>;
  downloadBrandFundedDiscountReport: GqlBrandFundedDiscountReportDownload;
  downloadDiscountCampaignReport: GqlDiscountCampaignReportDownload;
  enterpriseAdSettings: Array<GqlEnterpriseDispensaryAdSettings>;
  enterpriseAssetLibraryAssetUsages: Array<GqlAssetUsage>;
  enterpriseAssetLibraryAssets: GqlLibraryAssetConnection;
  enterpriseAssetLibraryFolders: Array<GqlLibraryFolder>;
  enterpriseAssetLibraryStats: GqlLibraryStats;
  /**
   * Returns the cName -> name/address reference data for every dispensary in
   * the chain, so the enterprise-admin UI can render a lookup table showing
   * which cName keyword to type into the 'locations' column of the
   * bulkCreateEnterpriseUsers CSV upload.
   */
  enterpriseDispensaryLocationKeywords: Array<GqlDispensaryLocationKeyword>;
  enterpriseDomain?: Maybe<GqlEnterpriseDomain>;
  enterpriseDomainResolution?: Maybe<GqlEnterpriseDomainResolution>;
  enterpriseDomainSetupInstructions: GqlEnterpriseDomainSetupInstructions;
  enterpriseDomains: Array<GqlEnterpriseDomain>;
  enterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  enterpriseMobileAppSettings?: Maybe<GqlEnterpriseMobileAppSettings>;
  enterprisePersonalizationSettings: Array<GqlEnterpriseDispensaryPersonalizationSettings>;
  enterpriseProducts?: Maybe<GqlEnterpriseProducts>;
  enterpriseProductsV2?: Maybe<GqlEnterpriseProducts>;
  enterpriseSignupCustomBrandingEnabled: Scalars['Boolean']['output'];
  enterpriseSpecials?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
  enterpriseSpecialsV3?: Maybe<GqlFilteredEnterpriseSpecials>;
  /**
   * CSV export of the same chain-wide user-permissions audit as chainUserPermissionsReport, for
   * chain admins doing SOC-style access reviews themselves -- CSV export was previously locked
   * to Dutchie super admins. See PF-6420.
   */
  exportChainUserPermissions: GqlChainUserPermissionsExport;
  exportDispensaryUsers?: Maybe<GqlExportDispensaryUsersPayload>;
  filteredCoupons?: Maybe<GqlCouponList>;
  filteredDispensaries?: Maybe<Array<Maybe<GqlDispensaries>>>;
  filteredIntegrations?: Maybe<Array<Maybe<GqlIntegrations>>>;
  filteredOrders?: Maybe<GqlOrderList>;
  filteredProducts?: Maybe<GqlProductsList>;
  filteredSpecials?: Maybe<GqlFilteredSpecials>;
  filteredSpecialsV2?: Maybe<GqlFilteredSpecials>;
  filteredStrains?: Maybe<GqlStrainList>;
  /** @deprecated Use getCustomerSubscriptions */
  filteredSubscriptions?: Maybe<Array<Maybe<GqlSubscriptionCustomers>>>;
  filteredTerpenes?: Maybe<Array<Maybe<GqlTerpene>>>;
  filteredUsers?: Maybe<Array<Maybe<GqlUsers>>>;
  findCustomizationProvider?: Maybe<GqlCustomizationProvider>;
  findLibraryProducts?: Maybe<GqlFindLibraryProductsResponse>;
  fundRethink: GqlFundRethinkResponse;
  generateDecagonUserAuth?: Maybe<GqlDecagonUserAuth>;
  geolocate?: Maybe<GqlIpInfo>;
  getAchPaymentDetails?: Maybe<GqlGetAchPaymentDetailsResponse>;
  getAddressBasedDispensaryData?: Maybe<GqlAddressBasedDispensaryDataResult>;
  getAdminProductReviews?: Maybe<GqlAdminProductReviewsResponse>;
  getAdminReviewFilterOptions?: Maybe<GqlAdminReviewFilterOptions>;
  getAdsInspectorEvents: GqlAdsInspectorEvents;
  getBackInStockSubscriptionStatus?: Maybe<GqlBackInStockSubscriptionStatus>;
  /** @deprecated Use listBankAccounts query */
  getBankAccountsV2?: Maybe<GqlBankAccounts>;
  getBfdNotCarriedRetailerPreview: GqlBfdNotCarriedRetailerPreview;
  getBrand?: Maybe<GqlBrand>;
  getBrandAppPermissionCatalog?: Maybe<Array<GqlBrandAppPermission>>;
  getBrandCampaignInsights: Array<GqlBrandCampaignInsight>;
  getBrandCatalogHealth: GqlBrandCatalogHealth;
  getBrandCollisions?: Maybe<GqlBrandCollisionList>;
  getBrandEnterpriseSettings: Array<GqlBrandEnterpriseSetting>;
  getBrandExports: GqlBrandExportsResponse;
  getBrandFundedDiscount?: Maybe<GqlBrandFundedDiscount>;
  getBrandImportHistory: GqlBrandImportHistoryResponse;
  getBrandImportHistoryDetail: GqlBrandImportHistoryDetailResponse;
  getBrandImportHistoryFailedRowsExport: GqlBrandImportHistoryFailedRowsExport;
  getBrandKeyMetricsOverview: GqlBrandKeyMetrics;
  getBrandLocationCategoriesOverview: GqlBrandCategoryInsightsSummary;
  getBrandLocationProductsOverview: GqlBrandProductInsightsSummary;
  getBrandLocationsOverview: GqlBrandLocationsInsightsSummary;
  getBrandLspCategoriesOverview: GqlBrandCategoryInsightsSummary;
  getBrandLspProductsOverview: GqlBrandProductInsightsSummary;
  getBrandLspsOverview: GqlBrandLspsInsightsSummary;
  getBrandMarketsOverview: GqlBrandMarketsOverviewSummary;
  getBrandMergeHistories?: Maybe<GqlBrandMergeHistoryList>;
  getBrandOverviewLsps: GqlBrandOverviewLspsSummary;
  getBrandPortalUnclaimedProducts?: Maybe<GqlBrandPortalUnclaimedProductsResponse>;
  getBrandSalesTrend: GqlBrandSalesTrendSummary;
  getBrandUser?: Maybe<GqlBrandUser>;
  getBrandUsers?: Maybe<GqlBrandUserList>;
  getBrandsV2?: Maybe<Array<Maybe<GqlBrand>>>;
  getBucket: GqlBucket;
  getBuckets: Array<Maybe<GqlBucket>>;
  getBuyItAgainProducts: GqlBuyItAgainProducts;
  getCannabinoids: Array<GqlCannabinoid>;
  getCategoriesListForDiscountRequirements: GqlDiscountCategoryList;
  getChainsV2?: Maybe<GqlChainList>;
  getCheckout?: Maybe<GqlCheckout>;
  getCollection: GqlCollection;
  getCollectionProductCount: GqlCollectionProductCount;
  getCollections: Array<GqlCollection>;
  getCollectionsNavigation: Array<GqlCollection>;
  getConsumerPulseAccess?: Maybe<GqlConsumerPulseAccess>;
  getConsumerStreamToken?: Maybe<GqlConsumerStreamCredentials>;
  getConsumerUser?: Maybe<GqlConsumerUser>;
  getCultivationLinkInventoryAvailability: Array<GqlWholesaleInventoryItem>;
  getCurbsideArrivalByToken?: Maybe<GqlCurbsideArrival>;
  getCurbsideArrivals: Array<GqlCurbsideArrival>;
  /** @deprecated Replaced by getCustomNavigation */
  getCustomMobileMenu?: Maybe<GqlCustomMobileMenu>;
  getCustomNavigation?: Maybe<GqlCustomNavigation>;
  getCustomerCommunicationSettings?: Maybe<GqlCommunicationSettings>;
  getCustomerDetails: GqlCustomerDetailsResponse;
  getCustomerSubscriptions: Array<GqlCustomerSubscription>;
  /** @deprecated Use getAddressBasedDispensaryData instead */
  getDeliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  getDeliveryTrackingTokenForTest?: Maybe<Scalars['String']['output']>;
  getDevices: Array<GqlDevices>;
  getDiscountCampaign?: Maybe<GqlDiscountCampaign>;
  getDiscountCampaignRetailers: Array<GqlDiscountCampaignRetailer>;
  getDispensariesAdSettingsByMenuVariant?: Maybe<Array<GqlDispensariesAdSettingsByMenuVariantResult>>;
  getDispensariesByPersonalizationSettings?: Maybe<Array<GqlDispensariesPersonalizationSettingsByMenuVariantResult>>;
  getDispensaryCharities: Array<GqlCharity>;
  getDispensarySettingsAuditLogs?: Maybe<GqlDispensarySettingsAuditLogList>;
  /** @deprecated Use ShowEnrollment */
  getDutchiePayEnrollment: GqlDutchiePayEnrollment;
  getDutchiePosLoyaltyConfig?: Maybe<GqlDutchiePosLoyaltyConfig>;
  getEcommerceAbandonedCarts?: Maybe<GqlEcommerceAbandonedCartsResponse>;
  /** @deprecated Use getDutchiePayEnrollment */
  getEnrollmentStatus?: Maybe<GqlUserEnrollment>;
  getEnterprise?: Maybe<GqlEnterprise>;
  getEnterpriseByName?: Maybe<Array<Maybe<GqlEnterprise>>>;
  getEnterpriseSpecial?: Maybe<GqlEnterpriseSpecial>;
  getEnterpriseSpecialsHistory?: Maybe<GqlEnterpriseSpecialsHistory>;
  getEntityLinkingCode?: Maybe<GqlEntityLinkingCodeResponse>;
  getExport: GqlExport;
  getFilteredBrandSummaries?: Maybe<GqlFilteredBrandSummaryResponse>;
  getFilteredProductSummaries?: Maybe<GqlFilteredProductSummaryResponse>;
  getInstoreAnalyticsToken?: Maybe<GqlInstoreAnalyticsToken>;
  getInstoreCart?: Maybe<GqlShowInstoreCartResponse>;
  getIrlEvent?: Maybe<GqlIrlEvent>;
  getIrlEventByDispensary?: Maybe<GqlIrlEvent>;
  getIrlEventReward?: Maybe<GqlIrlEventRewardResponse>;
  getIrlEventRewardByDispensary?: Maybe<GqlIrlEventRewardResponse>;
  getKioskTerminals: Array<GqlKioskTerminal>;
  getLibraryProduct?: Maybe<GqlLibraryProduct>;
  getLocsByLspAccount: Array<GqlDiscountLoc>;
  getLocsByLspAccounts: Array<GqlDiscountLoc>;
  getLoyaltyPassUrl?: Maybe<GqlLoyaltyPassUrl>;
  getLspSettingsAuditLog: GqlLspSettingsAuditLogResponse;
  getLspsByIsoRegionCode: Array<GqlDiscountLsp>;
  getLspsByIsoRegionCodeForDiscounts: Array<GqlDiscountLsp>;
  getMarketingCampaigns?: Maybe<GqlMarketingCampaignsResponse>;
  getMarketingCoupons?: Maybe<GqlMarketingCouponsResponse>;
  getMarketingDataPoints?: Maybe<GqlMarketingDataPointsResponse>;
  getMarketingSpecials?: Maybe<GqlMarketingSpecialsResponse>;
  /** get MarketplaceProduct information from a given id */
  getMarketplaceProduct: GqlMarketplaceProduct;
  /** Gets location based stats for a Marketplace Product */
  getMarketplaceProductLocationStats: GqlMarketplaceProductLocationStats;
  getMenuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  getMenuSectionsAdmin?: Maybe<Array<Maybe<GqlMenuSection>>>;
  getMobileAppAnalyticsMostVisitedPages?: Maybe<GqlMobileAppAnalyticsMostVisitedPagesResponse>;
  getMobileAppAnalyticsPageViews?: Maybe<GqlMobileAppAnalyticsPageViewsResponse>;
  getMonerisTokenizationProfile?: Maybe<GqlMonerisTokenizationProfile>;
  /** @deprecated Use getRecommendedProducts. */
  getMostPurchasedProducts?: Maybe<Array<GqlMongoProduct>>;
  getOrder?: Maybe<GqlGetOrderType>;
  getOrderForDelivery?: Maybe<GqlOrders>;
  getOrders?: Maybe<GqlAdminOrderListType>;
  getPayByBankFinalizationStatus: GqlPayByBankFinalizationStatusResult;
  getPaymentStatus: GqlRethinkStatus;
  getPaymentsCheckoutCredentials?: Maybe<GqlPaymentsCheckoutCredentials>;
  getPersonalizedProducts?: Maybe<GqlPersonalizedProducts>;
  getPersonalizedProductsV2?: Maybe<GqlPersonalizedProducts>;
  getPlusApiKeys?: Maybe<Array<GqlPlusApiKey>>;
  getPlusEnterpriseApiKeys?: Maybe<Array<GqlPlusApiKey>>;
  getPlusOAuthProviders: Array<Maybe<GqlPlusOAuthProvider>>;
  getPopularDispensaries: Array<GqlPopularDispensary>;
  getPosFeesConfig: Array<GqlPosFeeConfigItem>;
  getPosMedCardInfo?: Maybe<GqlPosMedCardInfo>;
  getProductBuyingOptions?: Maybe<GqlProductBuyingOptionsResult>;
  getProductDemandCounts?: Maybe<Array<Maybe<GqlProductDemandCount>>>;
  getProductRatingSummary?: Maybe<GqlProductRatingSummary>;
  getProductReviewStatus?: Maybe<GqlProductReviewStatusResponse>;
  getProductReviewToken?: Maybe<GqlProductReviewTokenResponse>;
  getProductReviews?: Maybe<GqlProductReviewsResponse>;
  getProductSalesByCategory?: Maybe<GqlProductsSalesByCategory>;
  getPromo: GqlPromo;
  getPublicContextSession?: Maybe<GqlPublicContextSession>;
  getPurchaseOrder: GqlPurchaseOrderDetail;
  getPurchaseOrders: Array<Maybe<GqlPurchaseOrder>>;
  getRawAchBatchFile?: Maybe<GqlGetRawAchBatchFileResponse>;
  getRecentlyViewedProducts?: Maybe<Array<GqlProducts>>;
  getRecentlyViewedProductsV2?: Maybe<Array<GqlMongoProduct>>;
  getRecommendedProducts: Array<GqlProducts>;
  getRegionsList: Array<GqlDiscountRegion>;
  getRegionsListForDiscounts: Array<GqlDiscountRegion>;
  getRemoteIntegrationValue?: Maybe<Scalars['String']['output']>;
  getReportingBrands: GqlReportingBrands;
  getReservationSlotsByOrderType?: Maybe<GqlMaxReservationSlotsByOrderType>;
  getRetailer?: Maybe<GqlRetailer>;
  getRetailerByDispensaryId?: Maybe<Array<Maybe<GqlRetailer>>>;
  getRetailerEnrollmentStatus?: Maybe<GqlRetailerEnrollment>;
  getRetailersByEnterpriseId?: Maybe<Array<Maybe<GqlRetailer>>>;
  getRewardsV2?: Maybe<GqlRewardsListV2>;
  getSortedProductRecommendations?: Maybe<GqlProductRecommendations>;
  getSpecialGamification?: Maybe<GqlSpecialGamificationList>;
  getSpecialMenuCards?: Maybe<GqlSpecialMenuCardResponse>;
  getSpecialsHistory?: Maybe<GqlSpecialsHistory>;
  getSponsoredBrand?: Maybe<GqlSponsoredBrand>;
  getSponsoredProducts: Array<GqlProducts>;
  getSponsoredProductsPlacements: GqlSponsoredProductsPlacements;
  getStateLibraries: Array<GqlStateLibrary>;
  getStockImage?: Maybe<GqlStockImage>;
  getStrain?: Maybe<GqlStrain>;
  getSubcategoriesListForDiscountRequirements: GqlDiscountSubcategoryList;
  getTerpene?: Maybe<GqlTerpene>;
  getTimezone?: Maybe<GqlGetTimezoneResult>;
  getTopProduct?: Maybe<GqlTopProduct>;
  getTrackedCart?: Maybe<GqlTrackedCart>;
  getTrendingBrands?: Maybe<GqlTrendingBrandsResponse>;
  getUserIncentiveEligibility?: Maybe<GqlGetUserStatusResponse>;
  getUserQuery?: Maybe<GqlUsers>;
  healthCheck?: Maybe<GqlHealthCheck>;
  /** @deprecated Use libraryProductChangeImpactV3 mutation */
  libraryProductChangeImpactV2?: Maybe<GqlLibraryProductChangeImpactResponse>;
  listAccountBalances?: Maybe<GqlListAccountBalancesResponse>;
  listAchBatches?: Maybe<GqlListAchBatchesResponse>;
  /** @deprecated Use listAchEntriesV4 */
  listAchEntries?: Maybe<GqlListAchEntriesResponse>;
  /** @deprecated Use listAchEntriesV4 */
  listAchEntriesV3?: Maybe<GqlListAchEntriesResponseV3>;
  listAchEntriesV4?: Maybe<GqlListAchEntriesResponseV3>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturns?: Maybe<GqlListAchReturnsResponse>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturnsV3?: Maybe<GqlListAchReturnsResponseV3>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturnsV4?: Maybe<GqlListAchReturnsResponseV4>;
  listAchReturnsV5?: Maybe<GqlListAchReturnsResponseV5>;
  /** @deprecated Only used for MX, we no longer use MX */
  listBankAccounts?: Maybe<GqlMxBankAccounts>;
  listBrandEnterpriseSettings: GqlBrandEnterpriseSettingList;
  listBrandFundedDiscountQualifiedProducts: GqlBrandFundedDiscountQualifiedProductList;
  listBrandFundedDiscounts: GqlBrandFundedDiscountList;
  listBrands: GqlBrandList;
  listDiscountCampaigns: GqlDiscountCampaignList;
  listEntities?: Maybe<GqlListEntitiesResponse>;
  listEntityFraudAssessments?: Maybe<GqlGetAchPaymentFraudAssessmentsResponse>;
  listLibraryProducts?: Maybe<GqlLibraryProducts>;
  listLoyaltyPassDispensaries?: Maybe<GqlLoyaltyPassDispensaries>;
  listPurchaseOrders: GqlPurchaseOrderList;
  listRegions: Array<Maybe<GqlRegion>>;
  listRetailerPaymentTypesStatus?: Maybe<GqlRetailerPaymentTypes>;
  listTransactionFraudAssessments?: Maybe<GqlGetAchPaymentFraudAssessmentsResponse>;
  locationGroup?: Maybe<GqlLocationGroup>;
  locationGroups?: Maybe<Array<Maybe<GqlLocationGroup>>>;
  /** @deprecated Use moving to V2 for scope change */
  matchLibraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  matchLibraryProductsV2?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  matchingOrderProducts?: Maybe<Array<Maybe<GqlProducts>>>;
  matchingProducts?: Maybe<Array<Maybe<GqlProducts>>>;
  meAdmin?: Maybe<GqlIdentityAdmin>;
  meConsumer?: Maybe<GqlIdentityConsumer>;
  menuFilters?: Maybe<GqlMenuFilters>;
  menuFiltersV2?: Maybe<GqlMenuFilters>;
  orderReceiptMarkup: Scalars['String']['output'];
  pendingDispensaries?: Maybe<GqlPendingDispensariesResult>;
  /** Returns user-scoped Nudge status after Armageddon authenticates the forwarded access token. */
  phoneVerificationNudgeStatus?: Maybe<GqlPhoneVerificationStatus>;
  phoneVerificationStatus?: Maybe<GqlPhoneVerificationStatus>;
  /**
   * Price-range bands for this dispensary, or DEFAULT_PRICE_RANGE_BANDS when unconfigured.
   * enabled: false means clients should not render the filter.
   */
  priceRangeFilterSettings?: Maybe<GqlPriceRangeFilterSettings>;
  printJob: GqlPrintJob;
  printers: Array<GqlPrinter>;
  productChangeEvents?: Maybe<Array<Maybe<GqlProductChangeEvent>>>;
  productFilters?: Maybe<GqlProductFilters>;
  /**
   * Other locations in the same enterprise that currently stock a given enterprise product,
   * nearest to the dispensary being viewed first. Powers the "Also available at" section on the
   * consumer PDP.
   *
   * Served by Armageddon, which owns both halves of the join: retailers in Postgres, products
   * and dispensaries in Mongo. Resolves to null if that call fails; clients should treat null
   * and an empty list identically, since this section is decoration and must never break a PDP.
   */
  productOtherLocations?: Maybe<Array<GqlProductOtherLocation>>;
  publicDigitalDisplayBoard?: Maybe<GqlDigitalDisplayBoard>;
  pushNotificationHistory: GqlPushNotificationHistoryList;
  recentMenuWipes?: Maybe<Array<Maybe<GqlMenuWipeEvent>>>;
  resolveBrandPortalDefaultContact?: Maybe<GqlBrandPortalDefaultContact>;
  salesOrdersQuery?: Maybe<GqlSalesOrdersQueryResponse>;
  searchBrandOverviewLsps: GqlBrandOverviewLspsSummary;
  searchBrandsV2?: Maybe<GqlBrandList>;
  searchBucketProducts?: Maybe<GqlSearchBucketProductsResponse>;
  searchEnterpriseByName?: Maybe<Array<Maybe<GqlEnterprise>>>;
  searchLibraryProducts?: Maybe<GqlLibraryProducts>;
  searchLspBrands: GqlLspBrandsList;
  searchProductChangeRequests?: Maybe<GqlContentChangeRequests>;
  /** Gets valid filters for Products in the search radius */
  searchProductFilters: Array<GqlSearchProductCategoryFilter>;
  /** Search Products in the marketplace based on a series of filters */
  searchProducts: GqlSearchProductsResult;
  secureImageUrlV2?: Maybe<GqlIdUrl>;
  showEnrollment: GqlShowEnrollmentResponse;
  startAggregatorLinkV2: GqlStartAggregatorLinkV2Response;
  statesWithDispensaries: Array<GqlState>;
  superAdminConsumerUserByEmail?: Maybe<GqlSuperAdminConsumerUser>;
  superAdminCustomers?: Maybe<GqlCustomersList>;
  superProducts?: Maybe<GqlMenuCleanup>;
  testPlusOAuthProviders: GqlTestPlusOAuthProviderResponse;
  unsubscribeCustomerQuery?: Maybe<GqlCustomerUnsubscribe>;
  /** @deprecated To remove */
  userExistsCheck?: Maybe<GqlExists>;
  validateCouponQuery?: Maybe<GqlCouponValidationResponse>;
  validatePasswordResetTokenQuery?: Maybe<GqlValidationResponse>;
  validatePasswordTokenQuery?: Maybe<GqlValidationResponse>;
  verifyMxMember?: Maybe<GqlMxMemberVerification>;
  voiceAgent?: Maybe<GqlVoiceAgent>;
  voiceAgentCall?: Maybe<GqlVoiceAgentCallDetail>;
  voiceAgentCallAnalytics: GqlVoiceAgentCallAnalytics;
  voiceAgentCalls: Array<GqlVoiceAgentCall>;
  voiceAgents?: Maybe<Array<Maybe<GqlVoiceAgent>>>;
};


export type GqlQueryActiveDispensariesArgs = {
  params?: InputMaybe<GqlActiveDispensariesInput>;
};


export type GqlQueryActiveProductsCheckArgs = {
  filter?: InputMaybe<GqlActiveProductsCheckInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryAddressResidentialCheckArgs = {
  input?: InputMaybe<GqlAddressResidentialCheckInput>;
};


export type GqlQueryArchivedProductLookupArgs = {
  cname: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryAvailableSegmentsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryBrandAgreementStatusArgs = {
  resetToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryBrandMenuInvitationsArgs = {
  brandId: Scalars['ID']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryBrandPortalDefaultContactsArgs = {
  brandId: Scalars['ID']['input'];
};


export type GqlQueryBrandPortalNotificationSettingsArgs = {
  brandId: Scalars['ID']['input'];
};


export type GqlQueryBrandPortalProductSearchArgs = {
  filters?: InputMaybe<GqlBrandPortalProductSearchFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlBrandPortalProductSearchSort>;
};


export type GqlQueryBrandTagsArgs = {
  brandId: Scalars['ID']['input'];
  kind?: InputMaybe<BrandTagKind>;
};


export type GqlQueryBulkLibraryProductUpdateStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type GqlQueryBulkLibraryProductUploadStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type GqlQueryCalculateCheckoutArgs = {
  checkout: GqlCalculateCheckoutInput;
};


export type GqlQueryChainDispensariesByStatusArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryChainDispensaryIdsArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryChainDispensaryNamesAndIdsArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryChainUserPermissionsReportArgs = {
  chainId: Scalars['String']['input'];
};


export type GqlQueryChangeRequestProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryCheckAgeVerificationArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryCheckAllotmentArgs = {
  input: GqlAllotmentCheckInput;
};


export type GqlQueryCheckPurchaseLimitsArgs = {
  inputs: GqlCheckPurchaseLimitsInput;
};


export type GqlQueryCmsContentArgs = {
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsContentVersionArgs = {
  enterpriseId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type GqlQueryCmsContentVersionsArgs = {
  enterpriseId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  variantKey: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsLatestContentArgs = {
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsPageArgs = {
  enterpriseId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsPagesArgs = {
  enterpriseId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  urlPath?: InputMaybe<Scalars['String']['input']>;
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsResolveContentArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  urlPath?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsResolveWebsiteContentArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  urlPath?: InputMaybe<Scalars['String']['input']>;
  websiteId: Scalars['String']['input'];
};


export type GqlQueryCmsTargetingArgs = {
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsVariantsArgs = {
  enterpriseId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  websiteId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryCmsVerifyAdminTokenArgs = {
  enterpriseId: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
};


export type GqlQueryCmsWebsitesArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryComputeWithPriceCartArgs = {
  input: GqlCalculationsInput;
};


export type GqlQueryConnectNewProductPreviewArgs = {
  dispensaryId: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
};


export type GqlQueryConsumerLatestCompletedTransactionArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryConsumerPosOrderArgs = {
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlQueryConsumerPosOrdersArgs = {
  dispensaryId: Scalars['String']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryCopyableSettingLocationsArgs = {
  dispensaryId: Scalars['ID']['input'];
  enterpriseId: Scalars['ID']['input'];
  settingPath: Scalars['String']['input'];
};


export type GqlQueryCreatePaymentMethodArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  memberGuid: Scalars['String']['input'];
};


export type GqlQueryCurbsideArrivalsForDispensaryArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryCustomerOrdersEnhancedArgs = {
  customerId: Scalars['String']['input'];
};


export type GqlQueryDigitalDisplayArgs = {
  deviceId: Scalars['ID']['input'];
};


export type GqlQueryDigitalDisplayBoardArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlQueryDigitalDisplayBoardFoldersArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryDigitalDisplayBoardsArgs = {
  enterpriseId: Scalars['ID']['input'];
  folderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  layout?: InputMaybe<DigitalDisplayBoardLayout>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedToPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  menuOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryDigitalDisplayDevicesArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryDigitalDisplayPlaylistArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlQueryDigitalDisplayPlaylistsArgs = {
  enterpriseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedToDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
};


export type GqlQueryDispensaryCustomersArgs = {
  filter?: InputMaybe<GqlCustomersFilterInput>;
  pagination?: InputMaybe<GqlCustomersPaginationInput>;
  sort?: InputMaybe<GqlCustomersSortInput>;
};


export type GqlQueryDownloadBrandFundedDiscountReportArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryDownloadDiscountCampaignReportArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseAdSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseAssetLibraryAssetUsagesArgs = {
  contentHash: Scalars['String']['input'];
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseAssetLibraryAssetsArgs = {
  enterpriseId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlLibraryAssetFilters>;
};


export type GqlQueryEnterpriseAssetLibraryFoldersArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseAssetLibraryStatsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseDispensaryLocationKeywordsArgs = {
  chainId: Scalars['String']['input'];
};


export type GqlQueryEnterpriseDomainArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseDomainResolutionArgs = {
  hostname: Scalars['String']['input'];
};


export type GqlQueryEnterpriseDomainSetupInstructionsArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseDomainsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseLoyaltySettingsArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseMobileAppSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterprisePersonalizationSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseProductsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseProductsV2Args = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseSignupCustomBrandingEnabledArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseSpecialsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseSpecialsV3Args = {
  enterpriseId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlFilteredSpecialsInputV2>;
};


export type GqlQueryExportChainUserPermissionsArgs = {
  chainId: Scalars['String']['input'];
};


export type GqlQueryExportDispensaryUsersArgs = {
  filter?: InputMaybe<GqlUsersFilterInput>;
};


export type GqlQueryFilteredCouponsArgs = {
  filter?: InputMaybe<GqlCouponsFilterInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
};


export type GqlQueryFilteredDispensariesArgs = {
  filter?: InputMaybe<GqlDispensariesFilterInput>;
};


export type GqlQueryFilteredIntegrationsArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryFilteredOrdersArgs = {
  filter?: InputMaybe<GqlOrdersFilterInput>;
  pagination?: InputMaybe<GqlOrdersPaginationInput>;
  sort?: InputMaybe<GqlOrdersSortInput>;
};


export type GqlQueryFilteredProductsArgs = {
  filter?: InputMaybe<GqlProductsFilterInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  showAllSpecialProducts?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryFilteredSpecialsArgs = {
  filter?: InputMaybe<GqlFilteredSpecialsInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryFilteredSpecialsV2Args = {
  filter?: InputMaybe<GqlFilteredSpecialsInput>;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryFilteredStrainsArgs = {
  filter?: InputMaybe<GqlStrainsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlStrainsSortInput>;
};


export type GqlQueryFilteredSubscriptionsArgs = {
  filter?: InputMaybe<GqlSubscriptionsFilterInput>;
};


export type GqlQueryFilteredTerpenesArgs = {
  filter?: InputMaybe<GqlTerpenesFilter>;
  sort?: InputMaybe<GqlTerpenesSort>;
};


export type GqlQueryFilteredUsersArgs = {
  filter?: InputMaybe<GqlUsersFilterInput>;
};


export type GqlQueryFindCustomizationProviderArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryFindLibraryProductsArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryFundRethinkArgs = {
  ecommLocationId: Scalars['String']['input'];
};


export type GqlQueryGetAchPaymentDetailsArgs = {
  paymentId: Scalars['String']['input'];
};


export type GqlQueryGetAddressBasedDispensaryDataArgs = {
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
};


export type GqlQueryGetAdminProductReviewsArgs = {
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReviewStatus>;
};


export type GqlQueryGetAdminReviewFilterOptionsArgs = {
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReviewStatus>;
};


export type GqlQueryGetAdsInspectorEventsArgs = {
  input: GqlAdsInspectorEventsInput;
};


export type GqlQueryGetBackInStockSubscriptionStatusArgs = {
  productId: Scalars['String']['input'];
};


export type GqlQueryGetBankAccountsV2Args = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  paymentMethodIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryGetBfdNotCarriedRetailerPreviewArgs = {
  brandId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetBrandArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetBrandCampaignInsightsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandCampaignInsightsFilterInput>;
};


export type GqlQueryGetBrandCatalogHealthArgs = {
  brandId: Scalars['ID']['input'];
  groupBy: BrandCatalogHealthGroupBy;
};


export type GqlQueryGetBrandCollisionsArgs = {
  filters?: InputMaybe<GqlBrandCollisionFilters>;
  pagination?: InputMaybe<GqlPagination>;
  sort?: InputMaybe<GqlBrandCollisionsSort>;
};


export type GqlQueryGetBrandEnterpriseSettingsArgs = {
  brandId: Scalars['String']['input'];
};


export type GqlQueryGetBrandExportsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<GqlBrandExportsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandExportsSortInput>;
};


export type GqlQueryGetBrandFundedDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetBrandImportHistoryArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<GqlBrandImportHistoryFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandImportHistorySortInput>;
};


export type GqlQueryGetBrandImportHistoryDetailArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandImportHistoryDetailFilterInput>;
  importId: Scalars['ID']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetBrandImportHistoryFailedRowsExportArgs = {
  brandId: Scalars['ID']['input'];
  importId: Scalars['ID']['input'];
};


export type GqlQueryGetBrandKeyMetricsOverviewArgs = {
  brandId: Scalars['ID']['input'];
};


export type GqlQueryGetBrandLocationCategoriesOverviewArgs = {
  brandId: Scalars['ID']['input'];
  dposLocationGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLocationId?: InputMaybe<Scalars['ID']['input']>;
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId?: InputMaybe<Scalars['ID']['input']>;
  dposServerRegion?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GqlInventoryOverviewFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLocationProductsOverviewArgs = {
  brandId: Scalars['ID']['input'];
  dposLocationGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLocationId?: InputMaybe<Scalars['ID']['input']>;
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId?: InputMaybe<Scalars['ID']['input']>;
  dposServerRegion?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GqlInventoryOverviewFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLocationsOverviewArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspCategoriesOverviewArgs = {
  brandId: Scalars['ID']['input'];
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId?: InputMaybe<Scalars['ID']['input']>;
  dposServerRegion?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GqlInventoryOverviewFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspProductsOverviewArgs = {
  brandId: Scalars['ID']['input'];
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  dposLspId?: InputMaybe<Scalars['ID']['input']>;
  dposServerRegion?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GqlInventoryOverviewFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspsOverviewArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandMarketsOverviewArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandMarketsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandMarketsOverviewSortInput>;
};


export type GqlQueryGetBrandMergeHistoriesArgs = {
  filters?: InputMaybe<GqlBrandMergeHistoriesFilters>;
  page?: InputMaybe<GqlBrandMergeHistoriesPagination>;
  sort?: InputMaybe<GqlBrandMergeHistoriesSort>;
};


export type GqlQueryGetBrandOverviewLspsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandOverviewLspsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetBrandPortalUnclaimedProductsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandPortalUnclaimedProductFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetBrandSalesTrendArgs = {
  brandId: Scalars['ID']['input'];
};


export type GqlQueryGetBrandUserArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetBrandUsersArgs = {
  filter?: InputMaybe<GqlBrandUsersFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandUsersSortInput>;
};


export type GqlQueryGetBrandsV2Args = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GqlQueryGetBucketArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetBucketsArgs = {
  sort?: InputMaybe<GqlBrandsSortInput>;
};


export type GqlQueryGetBuyItAgainProductsArgs = {
  dispensaryId: Scalars['String']['input'];
  menuType?: InputMaybe<Scalars['String']['input']>;
  menuVariant?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetChainsV2Args = {
  filter?: InputMaybe<GqlChainFilterInput>;
  pagination?: InputMaybe<GqlChainPaginationInput>;
  sort?: InputMaybe<GqlChainSortInput>;
};


export type GqlQueryGetCheckoutArgs = {
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCollectionArgs = {
  channel?: InputMaybe<CollectionChannel>;
  collectionId: Scalars['String']['input'];
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCollectionProductCountArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlGetCollectionProductCountInput;
};


export type GqlQueryGetCollectionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<CollectionChannel>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCollectionsNavigationArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<CollectionChannel>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryGetConsumerPulseAccessArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetConsumerStreamTokenArgs = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetConsumerUserArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetCultivationLinkInventoryAvailabilityArgs = {
  cultivationLinkId: Scalars['ID']['input'];
};


export type GqlQueryGetCurbsideArrivalByTokenArgs = {
  token: Scalars['String']['input'];
};


export type GqlQueryGetCurbsideArrivalsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCustomMobileMenuArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCustomNavigationArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCustomerCommunicationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlQueryGetDeliveryInfoArgs = {
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
};


export type GqlQueryGetDeliveryTrackingTokenForTestArgs = {
  orderId: Scalars['String']['input'];
};


export type GqlQueryGetDevicesArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetDiscountCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetDiscountCampaignRetailersArgs = {
  filters?: InputMaybe<GqlDiscountCampaignFiltersInput>;
};


export type GqlQueryGetDispensariesAdSettingsByMenuVariantArgs = {
  input: GqlGetDispensariesAdSettingsByMenuVariantInput;
};


export type GqlQueryGetDispensariesByPersonalizationSettingsArgs = {
  input: GqlGetDispensariesByPersonalizationSettingsInput;
};


export type GqlQueryGetDispensaryCharitiesArgs = {
  dispensaryId: Scalars['String']['input'];
  menuType: Scalars['String']['input'];
};


export type GqlQueryGetDispensarySettingsAuditLogsArgs = {
  actorUserId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetDutchiePayEnrollmentArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlQueryGetDutchiePosLoyaltyConfigArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetEcommerceAbandonedCartsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetEnrollmentStatusArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlQueryGetEnterpriseArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseByNameArgs = {
  uniqueName: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseSpecialArgs = {
  enterpriseSpecialId: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseSpecialsHistoryArgs = {
  enterpriseId: Scalars['ID']['input'];
  enterpriseSpecialId: Scalars['ID']['input'];
};


export type GqlQueryGetExportArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetFilteredBrandSummariesArgs = {
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetFilteredProductSummariesArgs = {
  input: GqlProductsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetInstoreCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetIrlEventArgs = {
  enterpriseId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetIrlEventByDispensaryArgs = {
  dispensaryId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
};


export type GqlQueryGetIrlEventRewardArgs = {
  ecommUserId: Scalars['String']['input'];
  enterpriseId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetIrlEventRewardByDispensaryArgs = {
  dispensaryId: Scalars['String']['input'];
  ecommUserId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
};


export type GqlQueryGetKioskTerminalsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetLibraryProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetLocsByLspAccountArgs = {
  lspAccount: GqlLspAccount;
};


export type GqlQueryGetLocsByLspAccountsArgs = {
  lspAccounts: Array<GqlLspAccount>;
};


export type GqlQueryGetLoyaltyPassUrlArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetLspSettingsAuditLogArgs = {
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlLspSettingsAuditLogSortInput>;
};


export type GqlQueryGetLspsByIsoRegionCodeArgs = {
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetLspsByIsoRegionCodeForDiscountsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetMarketingCampaignsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketingCouponsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketingDataPointsArgs = {
  input: GqlAnalyticsInput;
};


export type GqlQueryGetMarketingSpecialsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketplaceProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetMarketplaceProductLocationStatsArgs = {
  bounds: GqlGeographicSearchBounds;
  marketplaceProductId: Scalars['ID']['input'];
};


export type GqlQueryGetMenuSectionsArgs = {
  dispensaryId: Scalars['String']['input'];
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryGetMenuSectionsAdminArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetMobileAppAnalyticsMostVisitedPagesArgs = {
  input: GqlAnalyticsInput;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetMobileAppAnalyticsPageViewsArgs = {
  input: GqlAnalyticsInput;
};


export type GqlQueryGetMonerisTokenizationProfileArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetMostPurchasedProductsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetOrderForDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetOrdersArgs = {
  input: GqlGetOrdersInput;
};


export type GqlQueryGetPayByBankFinalizationStatusArgs = {
  orderId: Scalars['String']['input'];
};


export type GqlQueryGetPaymentStatusArgs = {
  paymentId: Scalars['String']['input'];
};


export type GqlQueryGetPaymentsCheckoutCredentialsArgs = {
  adapter: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetPersonalizedProductsArgs = {
  input: GqlGetPersonalizedProductsInput;
};


export type GqlQueryGetPersonalizedProductsV2Args = {
  input: GqlGetPersonalizedProductsV2Input;
};


export type GqlQueryGetPlusApiKeysArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetPlusEnterpriseApiKeysArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryGetPlusOAuthProvidersArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryGetPopularDispensariesArgs = {
  lat: Scalars['String']['input'];
  lon: Scalars['String']['input'];
};


export type GqlQueryGetPosFeesConfigArgs = {
  dispensaryId: Scalars['String']['input'];
  menuType: Scalars['String']['input'];
};


export type GqlQueryGetPosMedCardInfoArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetProductBuyingOptionsArgs = {
  bounds: GqlGeographicSearchBounds;
  marketplaceProductId: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<StringSortDirections>;
  weights?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryGetProductDemandCountsArgs = {
  dispensaryId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};


export type GqlQueryGetProductRatingSummaryArgs = {
  productId: Scalars['String']['input'];
};


export type GqlQueryGetProductReviewStatusArgs = {
  token: Scalars['String']['input'];
};


export type GqlQueryGetProductReviewTokenArgs = {
  orderId: Scalars['String']['input'];
};


export type GqlQueryGetProductReviewsArgs = {
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetProductSalesByCategoryArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQueryGetPromoArgs = {
  id: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
};


export type GqlQueryGetPublicContextSessionArgs = {
  id: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetPurchaseOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetPurchaseOrdersArgs = {
  filters?: InputMaybe<GqlPurchaseOrdersFilterInput>;
};


export type GqlQueryGetRawAchBatchFileArgs = {
  achBatchId: Scalars['String']['input'];
};


export type GqlQueryGetRecentlyViewedProductsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetRecentlyViewedProductsV2Args = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetRecommendedProductsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetRemoteIntegrationValueArgs = {
  dispensaryId: Scalars['String']['input'];
  key: Scalars['String']['input'];
};


export type GqlQueryGetReportingBrandsArgs = {
  filters?: InputMaybe<GqlReportingBrandsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetReservationSlotsByOrderTypeArgs = {
  dispensaryId: Scalars['ID']['input'];
  reservationType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetRetailerArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetRetailerByDispensaryIdArgs = {
  dispensaryIds: Array<Scalars['ID']['input']>;
};


export type GqlQueryGetRetailerEnrollmentStatusArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlQueryGetRetailersByEnterpriseIdArgs = {
  enterpriseIds: Array<Scalars['ID']['input']>;
};


export type GqlQueryGetRewardsV2Args = {
  cartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetSortedProductRecommendationsArgs = {
  input: GqlGetSortedProductRecommendationsInput;
};


export type GqlQueryGetSpecialGamificationArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GqlQueryGetSpecialMenuCardsArgs = {
  dispensaryId: Scalars['ID']['input'];
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
  menuType: Scalars['String']['input'];
  platformType?: InputMaybe<Scalars['String']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetSpecialsHistoryArgs = {
  specialId: Scalars['ID']['input'];
};


export type GqlQueryGetSponsoredBrandArgs = {
  input: GqlGetSponsoredBrandInput;
};


export type GqlQueryGetSponsoredProductsArgs = {
  input: GqlGetSponsoredProductsInput;
};


export type GqlQueryGetSponsoredProductsPlacementsArgs = {
  input: GqlGetSponsoredProductsPlacementsInput;
};


export type GqlQueryGetStockImageArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetStrainArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetSubcategoriesListForDiscountRequirementsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetTerpeneArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetTimezoneArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  timeStamp?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryGetTopProductArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQueryGetTrackedCartArgs = {
  checkoutToken: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetTrendingBrandsArgs = {
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetUserIncentiveEligibilityArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  totalAmountCents?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryGetUserQueryArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryLibraryProductChangeImpactV2Args = {
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlQueryListAccountBalancesArgs = {
  userId: Scalars['String']['input'];
};


export type GqlQueryListAchBatchesArgs = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  generatedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  generatedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  processedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  processedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryListAchEntriesArgs = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchEntriesV3Args = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryListAchEntriesV4Args = {
  achBatchId?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsArgs = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['String']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsV3Args = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['Int']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsV4Args = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['String']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsV5Args = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['String']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListBankAccountsArgs = {
  aggregator: Scalars['String']['input'];
};


export type GqlQueryListBrandEnterpriseSettingsArgs = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryListBrandFundedDiscountQualifiedProductsArgs = {
  filters?: InputMaybe<GqlBrandFundedDiscountQualifiedProductsFiltersInput>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlBrandFundedDiscountQualifiedProductsSortInput>;
};


export type GqlQueryListBrandFundedDiscountsArgs = {
  filters?: InputMaybe<GqlBrandFundedDiscountFiltersInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandFundedDiscountSortInput>;
};


export type GqlQueryListBrandsArgs = {
  filters?: InputMaybe<GqlListBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlListBrandsSort>;
};


export type GqlQueryListDiscountCampaignsArgs = {
  filters?: InputMaybe<GqlDiscountCampaignFiltersInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlDiscountCampaignSortInput>;
};


export type GqlQueryListEntitiesArgs = {
  externalType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListEntityFraudAssessmentsArgs = {
  externalId: Scalars['String']['input'];
  externalType: Scalars['String']['input'];
};


export type GqlQueryListLibraryProductsArgs = {
  filters?: InputMaybe<GqlListLibraryProductsFilters>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlListLibraryProductsSort>;
};


export type GqlQueryListLoyaltyPassDispensariesArgs = {
  lspGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lspIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type GqlQueryListPurchaseOrdersArgs = {
  filters?: InputMaybe<GqlPurchaseOrdersListFiltersInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlPurchaseOrdersSortInput>;
};


export type GqlQueryListRetailerPaymentTypesStatusArgs = {
  ecommLocationId: Scalars['String']['input'];
};


export type GqlQueryListTransactionFraudAssessmentsArgs = {
  transactionId: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
};


export type GqlQueryLocationGroupArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlQueryLocationGroupsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryMatchLibraryProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMatchLibraryProductsV2Args = {
  brand?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMatchingOrderProductsArgs = {
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMatchingProductsArgs = {
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productLibraryState?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMenuFiltersArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  pricingType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMenuFiltersV2Args = {
  category?: InputMaybe<Scalars['String']['input']>;
  checkMinSpendOffers?: InputMaybe<Scalars['Boolean']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  hasProductsOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  pricingType?: InputMaybe<MenuPricingTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
  showAllSpecialProducts?: InputMaybe<Scalars['Boolean']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryOrderReceiptMarkupArgs = {
  dispensaryId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type GqlQueryPendingDispensariesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSortInput>;
};


export type GqlQueryPhoneVerificationNudgeStatusArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryPhoneVerificationStatusArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryPriceRangeFilterSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryPrintJobArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryPrintersArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryProductChangeEventsArgs = {
  productId: Scalars['ID']['input'];
};


export type GqlQueryProductOtherLocationsArgs = {
  enterpriseId: Scalars['ID']['input'];
  enterpriseProductId: Scalars['ID']['input'];
  excludeDispensaryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryPublicDigitalDisplayBoardArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryPushNotificationHistoryArgs = {
  input: GqlPushNotificationHistoryInput;
};


export type GqlQueryRecentMenuWipesArgs = {
  dispensaryId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryResolveBrandPortalDefaultContactArgs = {
  brandId: Scalars['ID']['input'];
  feature: BrandPortalDefaultContactFeature;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQuerySalesOrdersQueryArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQuerySearchBrandOverviewLspsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandOverviewLspsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search: Scalars['String']['input'];
};


export type GqlQuerySearchBrandsV2Args = {
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
};


export type GqlQuerySearchBucketProductsArgs = {
  filter?: InputMaybe<GqlSearchBucketProductFilter>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlSearchBucketProductSort>;
};


export type GqlQuerySearchEnterpriseByNameArgs = {
  keyword: Scalars['String']['input'];
};


export type GqlQuerySearchLibraryProductsArgs = {
  filters?: InputMaybe<GqlSearchLibraryProductsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchLibraryProductsSort>;
};


export type GqlQuerySearchLspBrandsArgs = {
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlLspBrandSearchSort>;
};


export type GqlQuerySearchProductChangeRequestsArgs = {
  filters?: InputMaybe<GqlContentChangeRequestFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlContentChangeRequestSort>;
};


export type GqlQuerySearchProductFiltersArgs = {
  bounds: GqlGeographicSearchBounds;
};


export type GqlQuerySearchProductsArgs = {
  filters: GqlSearchProductsInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<StringSortDirections>;
};


export type GqlQuerySecureImageUrlV2Args = {
  id: Scalars['String']['input'];
};


export type GqlQueryStartAggregatorLinkV2Args = {
  aggregator: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
  oauthRedirectUri?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};


export type GqlQuerySuperAdminConsumerUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type GqlQuerySuperAdminCustomersArgs = {
  filter?: InputMaybe<GqlSuperAdminCustomersFilter>;
  pagination?: InputMaybe<GqlCustomersPaginationInput>;
  sort?: InputMaybe<GqlCustomersSortInput>;
};


export type GqlQuerySuperProductsArgs = {
  filter?: InputMaybe<GqlSuperProductsInput>;
};


export type GqlQueryTestPlusOAuthProvidersArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryUnsubscribeCustomerQueryArgs = {
  customerId: Scalars['String']['input'];
};


export type GqlQueryUserExistsCheckArgs = {
  input?: InputMaybe<GqlUserIdExistsInput>;
};


export type GqlQueryValidateCouponQueryArgs = {
  code: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  isReapplying?: InputMaybe<Scalars['Boolean']['input']>;
  orderSubtotalInCents: Scalars['Int']['input'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<GqlCouponValidationProductInput>>>;
};


export type GqlQueryValidatePasswordResetTokenQueryArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryValidatePasswordTokenQueryArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryVerifyMxMemberArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  memberGuid: Scalars['String']['input'];
};


export type GqlQueryVoiceAgentArgs = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type GqlQueryVoiceAgentCallArgs = {
  assistantId: Scalars['ID']['input'];
  callId: Scalars['ID']['input'];
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryVoiceAgentCallAnalyticsArgs = {
  assistantId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryVoiceAgentCallsArgs = {
  assistantId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryVoiceAgentsArgs = {
  enterpriseId: Scalars['ID']['input'];
};

export type GqlRadius = {
  __typename?: 'Radius';
  default?: Maybe<RadiusOption>;
};

export type GqlRadiusInput = {
  default?: InputMaybe<RadiusOption>;
};

export enum RadiusOption {
  rounded = 'ROUNDED',
  roundedRectangle = 'ROUNDED_RECTANGLE',
  square = 'SQUARE'
}

export enum RangeBehaviors {
  betweenXAndY = 'BETWEEN_X_AND_Y',
  everyX = 'EVERY_X',
  fromXToY = 'FROM_X_TO_Y'
}

export type GqlRecordUserAcceptanceResponse = {
  __typename?: 'RecordUserAcceptanceResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum RecurrenceFrequency {
  weekly = 'weekly'
}

export type GqlRedemption = {
  __typename?: 'Redemption';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lspId?: Maybe<Scalars['String']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  receiverUserId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlRedemptionInput = {
  dispensaryId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  program: Scalars['String']['input'];
  rewardId: Scalars['String']['input'];
  rewardType: Scalars['String']['input'];
};

export type GqlReferralCode = {
  __typename?: 'ReferralCode';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  receiverPoints?: Maybe<Scalars['String']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  senderEcommId?: Maybe<Scalars['String']['output']>;
  senderPoints?: Maybe<Scalars['String']['output']>;
  senderPosUniqueId?: Maybe<Scalars['String']['output']>;
};

export type GqlRegion = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subdivision?: Maybe<Scalars['String']['output']>;
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export enum RejectionReasons {
  compliance = 'compliance',
  incompleteInfo = 'incomplete_info',
  photoGuidelines = 'photo_guidelines'
}

export type GqlRemoteExtensions = {
  __typename?: 'RemoteExtensions';
  builderKey?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<GqlRemoteExtensionsConfiguration>;
};

export type GqlRemoteExtensionsConfiguration = {
  __typename?: 'RemoteExtensionsConfiguration';
  extensionData?: Maybe<Array<GqlExtensionData>>;
  manifestUrl?: Maybe<Scalars['String']['output']>;
  modulePath?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type GqlRemoteExtensionsInput = {
  extensionData?: InputMaybe<Array<GqlExtensionDataInput>>;
  manifestUrl: Scalars['String']['input'];
  modulePath: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

export type GqlRemoveCategoryMenuOrderInput = {
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};

export type GqlReportingBrand = {
  __typename?: 'ReportingBrand';
  brandId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentBrandId?: Maybe<Scalars['ID']['output']>;
};

export type GqlReportingBrands = {
  __typename?: 'ReportingBrands';
  brands: Array<GqlReportingBrand>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlReportingBrandsFilterInput = {
  parentBrandsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlReservationConfig = {
  __typename?: 'ReservationConfig';
  /** @deprecated replaced by reservationsAvailableByOrderType */
  delivery?: Maybe<GqlReservationOptionsForOrderType>;
  /** @deprecated replaced by orderTypesConfigV2 */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated replaced by reservationsAvailableByOrderType */
  pickup?: Maybe<GqlReservationOptionsForOrderType>;
};

export type GqlReservationConfigInput = {
  delivery?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pickup?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlReservationOptionsForOrderType = {
  __typename?: 'ReservationOptionsForOrderType';
  advancedDayOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  advancedDayOrderingLimit?: Maybe<Scalars['Int']['output']>;
  incrementInMinutes?: Maybe<Scalars['Int']['output']>;
  maxReservationSlotsByDate?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  maxReservationSlotsByDay?: Maybe<GqlMaxReservationSlotsByDay>;
  nextAvailableInMinutes?: Maybe<Scalars['Int']['output']>;
  orderLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  sameDayDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlReservationOptionsForOrderTypeInput = {
  advancedDayOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  advancedDayOrderingLimit?: InputMaybe<Scalars['Int']['input']>;
  customTimeSlotsByDay?: InputMaybe<GqlScheduledOrderingCustomTimeSlotsByDayInput>;
  hideClosedDays?: InputMaybe<Scalars['Boolean']['input']>;
  incrementInMinutes: Scalars['Int']['input'];
  maxReservationSlotsByDate?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  maxReservationSlotsByDay?: InputMaybe<GqlMaxReservationSlotsByDayInput>;
  nextAvailableInMinutes: Scalars['Int']['input'];
  orderLimitsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sameDayDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slotMode?: InputMaybe<ScheduledOrderingSlotMode>;
};

export enum ReservationSlotTypes {
  all = 'all',
  curbsidePickup = 'curbsidePickup',
  delivery = 'delivery',
  driveThruPickup = 'driveThruPickup',
  inStorePickup = 'inStorePickup'
}

export type GqlReservationSlotsCreateInput = {
  curbsidePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  delivery?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  orderType?: InputMaybe<ReservationSlotTypes>;
  timezone: Scalars['String']['input'];
};

export type GqlReservationSlotsForOrderType = {
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelPrefix?: InputMaybe<Scalars['String']['input']>;
  reservation?: InputMaybe<GqlReservationsAvailableForOrderType>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlReservationSlotsInfoForOrderTypeInput = {
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlReservationSlotsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  delivery?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  listOfReservationSlots?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  orderType?: InputMaybe<ReservationSlotTypes>;
  timezone: Scalars['String']['input'];
};

export type GqlReservationsAvailable = {
  __typename?: 'ReservationsAvailable';
  active?: Maybe<Scalars['Boolean']['output']>;
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  endTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
  isNextDaySlot?: Maybe<Scalars['Boolean']['output']>;
  quantityRemaining?: Maybe<Scalars['Int']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  startTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlReservationsAvailableByOrderType = {
  __typename?: 'ReservationsAvailableByOrderType';
  curbsidePickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  delivery?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  driveThruPickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  inStorePickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  /** @deprecated replaced by inStorePickup via rollout.use-updated-ordering-configurations */
  pickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
};

export type GqlReservationsAvailableForOrderType = {
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  endTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  quantityRemaining?: InputMaybe<Scalars['Int']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlRespondToAchReturnResponse = {
  __typename?: 'RespondToAchReturnResponse';
  achReturnResponse: GqlAchReturnResponse;
};

export enum RestMethods {
  del = 'del',
  get = 'get',
  patch = 'patch',
  post = 'post',
  postMultipart = 'postMultipart',
  put = 'put'
}

export enum RestService {
  armageddon = 'armageddon',
  cms = 'cms'
}

export type GqlRestriction = {
  discountType?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum RestrictionType {
  all = 'ALL',
  brand = 'BRAND',
  category = 'CATEGORY',
  inventoryTag = 'INVENTORY_TAG',
  product = 'PRODUCT',
  productTag = 'PRODUCT_TAG',
  strain = 'STRAIN',
  subcategory = 'SUBCATEGORY',
  vendor = 'VENDOR',
  weight = 'WEIGHT'
}

export type GqlRetailer = {
  __typename?: 'Retailer';
  accountTier?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  assignedToBillingGroup?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensaryId: Scalars['ID']['output'];
  enterprise?: Maybe<GqlEnterprise>;
  enterpriseId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  medLicense?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profile: GqlRetailerProfile;
  recLicense?: Maybe<Scalars['Boolean']['output']>;
  status: RetailerStatus;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlRetailerEnrollment = {
  __typename?: 'RetailerEnrollment';
  enrollment?: Maybe<GqlStatus>;
};

export type GqlRetailerPaymentTypes = {
  __typename?: 'RetailerPaymentTypes';
  paymentTypes: Array<Maybe<GqlPaymentTypeConfig>>;
};

export type GqlRetailerProfile = {
  __typename?: 'RetailerProfile';
  location?: Maybe<GqlRetailerProfileLocation>;
  medicalDispensary?: Maybe<Scalars['Boolean']['output']>;
  recDispensary?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlRetailerProfileLocation = {
  __typename?: 'RetailerProfileLocation';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum RetailerStatus {
  archived = 'archived',
  closed = 'closed',
  open = 'open',
  pending = 'pending'
}

export type GqlRethinkStatus = {
  __typename?: 'RethinkStatus';
  status: RethinkStatuses;
};

export enum RethinkStatuses {
  authorized = 'authorized',
  authorizing = 'authorizing',
  cancelled = 'cancelled',
  cancelling = 'cancelling',
  captured = 'captured',
  capturing = 'capturing',
  declined = 'declined',
  failed = 'failed',
  finalized = 'finalized',
  finalizing = 'finalizing',
  new = 'new',
  refundPending = 'refund_pending',
  refunded = 'refunded',
  refunding = 'refunding'
}

export type GqlReverifyBrandCatalogInput = {
  attestedProductCount: Scalars['Int']['input'];
  confirmed: Scalars['Boolean']['input'];
  idempotencyKey: Scalars['ID']['input'];
};

export type GqlReverifyBrandCatalogPayload = {
  __typename?: 'ReverifyBrandCatalogPayload';
  verification: GqlBrandCatalogVerification;
};

export type GqlReversePaymentResponse = {
  __typename?: 'ReversePaymentResponse';
  achReversal: GqlAchReversal;
};

export type GqlReverseSettlementResponse = {
  __typename?: 'ReverseSettlementResponse';
  achReversal: GqlAchReversal;
};

export enum ReviewStatus {
  approved = 'approved',
  needsReview = 'needs_review',
  pending = 'pending',
  rejected = 'rejected'
}

export type GqlReward = {
  __typename?: 'Reward';
  available?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  /** @deprecated using costV2 to change from Int to Float */
  cost?: Maybe<Scalars['Int']['output']>;
  costV2?: Maybe<Scalars['Float']['output']>;
  discountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  redemptionAttempts?: Maybe<Array<Maybe<GqlRewardRedemptionResponse>>>;
  rewardType?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['String']['input']>;
  discountId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rewardType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RewardRedeemBy {
  dutchie = 'Dutchie',
  pos = 'POS'
}

export type GqlRewardRedemptionDetails = {
  __typename?: 'RewardRedemptionDetails';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardRedemptionResponse = {
  __typename?: 'RewardRedemptionResponse';
  programResponse?: Maybe<GqlProgramResponse>;
  redeemBy?: Maybe<RewardRedeemBy>;
  status?: Maybe<RewardStatus>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum RewardStatus {
  pending = 'pending',
  redeemed = 'redeemed'
}

export enum RewardType {
  bundle = 'bundle',
  discountBundle = 'discountBundle',
  discountToCart = 'discountToCart',
  item = 'item',
  itemsForADiscount = 'itemsForADiscount',
  itemsForAPrice = 'itemsForAPrice'
}

export type GqlRewardUserResponse = {
  __typename?: 'RewardUserResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  wallet?: Maybe<GqlRewardsListV2>;
};

export type GqlRewardV2 = {
  __typename?: 'RewardV2';
  allowStacking?: Maybe<Scalars['Boolean']['output']>;
  available: Scalars['Boolean']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  /** @deprecated using costV2 to change from Int to Float */
  cost: Scalars['Int']['output'];
  costV2: Scalars['Float']['output'];
  discountId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  isRedeemableOnline?: Maybe<Scalars['Boolean']['output']>;
  operator: Scalars['String']['output'];
  redemptionAttempts?: Maybe<Array<Maybe<GqlRewardRedemptionResponse>>>;
  rewardType: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlRewardValidationError = {
  __typename?: 'RewardValidationError';
  discountCode?: Maybe<Scalars['String']['output']>;
  discountId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardsActivity = {
  __typename?: 'RewardsActivity';
  comment?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  isAdjustment?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  transactionDateUtc?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardsIntegrationConfigurationInput = {
  rewardsProgramDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayEnrollment?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlRewardsList = {
  __typename?: 'RewardsList';
  auth?: Maybe<GqlUserAuthInfo>;
  balance?: Maybe<Scalars['String']['output']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  rewardBrand?: Maybe<Scalars['String']['output']>;
  rewards: Array<Maybe<GqlReward>>;
  userHasWallet?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlRewardsListV2 = {
  __typename?: 'RewardsListV2';
  auth?: Maybe<GqlUserAuthInfo>;
  balance: Scalars['String']['output'];
  currentYearTierBalance?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  isRevokedFromReferralProgram?: Maybe<Scalars['Boolean']['output']>;
  posCustomerId?: Maybe<Scalars['String']['output']>;
  posUniqueId?: Maybe<Scalars['String']['output']>;
  rewardBrand: Scalars['String']['output'];
  rewards: Array<Maybe<GqlRewardV2>>;
  rewardsActivity?: Maybe<Array<Maybe<GqlRewardsActivity>>>;
  soonestExpirationDate?: Maybe<Scalars['String']['output']>;
  soonestExpiringBalance?: Maybe<Scalars['Float']['output']>;
  tierId?: Maybe<Scalars['Int']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  userHasWallet: Scalars['Boolean']['output'];
};

export type GqlRewards_Integration_Configuration = {
  __typename?: 'Rewards_integration_configuration';
  rewardsProgramDisplayDescription?: Maybe<Scalars['String']['output']>;
  rewardsProgramDisplayEnrollment?: Maybe<Scalars['String']['output']>;
  rewardsProgramDisplayName?: Maybe<Scalars['String']['output']>;
};

export type GqlRewards_Integration_ConfigurationInput = {
  rewardsProgramDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayEnrollment?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSaleDiscount = {
  __typename?: 'SaleDiscount';
  _id?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<DiscountType>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  globalBrandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalCategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalSubcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  productGroup?: Maybe<ProductGroup>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightOperator?: Maybe<WeightOperator>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlSaleDiscountInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  globalBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalSubcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']['input']>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlSaveCustomNavigationInput = {
  dispensaryId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  items: Array<GqlCustomNavigationItemInput>;
  label: Scalars['String']['input'];
  targetDispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlSavePageResult = {
  __typename?: 'SavePageResult';
  status: CmsContentVersionStatus;
  variantId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type GqlSchedule = {
  __typename?: 'Schedule';
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  id: Scalars['ID']['output'];
  startDate: Scalars['ISODateTime']['output'];
  timeRanges?: Maybe<Array<GqlTimeRange>>;
};

export type GqlScheduleInput = {
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISODateTime']['input'];
  timeRanges?: InputMaybe<Array<GqlTimeRangeInput>>;
};

export type GqlScheduledOrderingConfigV2 = {
  __typename?: 'ScheduledOrderingConfigV2';
  advancedDayOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  advancedDayOrderingLimit?: Maybe<Scalars['Int']['output']>;
  customTimeSlotsByDay?: Maybe<GqlScheduledOrderingCustomTimeSlotsByDay>;
  hideClosedDays?: Maybe<Scalars['Boolean']['output']>;
  incrementInMinutes?: Maybe<Scalars['Int']['output']>;
  nextAvailableInMinutes?: Maybe<Scalars['Int']['output']>;
  orderLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  sameDayDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  slotMode?: Maybe<ScheduledOrderingSlotMode>;
};

export type GqlScheduledOrderingCustomTimeSlot = {
  __typename?: 'ScheduledOrderingCustomTimeSlot';
  dayOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlScheduledOrderingCustomTimeSlotInput = {
  dayOffset?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlScheduledOrderingCustomTimeSlotsByDay = {
  __typename?: 'ScheduledOrderingCustomTimeSlotsByDay';
  Friday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
  Monday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
  Saturday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
  Sunday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
  Thursday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
  Tuesday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
  Wednesday?: Maybe<Array<Maybe<GqlScheduledOrderingCustomTimeSlot>>>;
};

export type GqlScheduledOrderingCustomTimeSlotsByDayInput = {
  Friday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
  Monday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
  Saturday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
  Sunday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
  Thursday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
  Tuesday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
  Wednesday?: InputMaybe<Array<InputMaybe<GqlScheduledOrderingCustomTimeSlotInput>>>;
};

export enum ScheduledOrderingSlotMode {
  custom = 'custom',
  fixed = 'fixed'
}

export type GqlSearchBucketProductFilter = {
  endTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  reviewedBy?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  verified?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSearchBucketProductSort = {
  sortBy: SearchBucketProductSortByEnum;
  sortDirection: StringSortDirections;
};

export enum SearchBucketProductSortByEnum {
  reviewedAt = 'reviewedAt'
}

export type GqlSearchBucketProductsResponse = {
  __typename?: 'SearchBucketProductsResponse';
  bucketProducts?: Maybe<Array<Maybe<GqlBucketProduct>>>;
  meta?: Maybe<GqlBucketProductsMeta>;
};

export type GqlSearchProductCategoryFilter = {
  __typename?: 'SearchProductCategoryFilter';
  brands?: Maybe<Array<GqlSearchProductFilterBrand>>;
  category: ProductCategory;
  consumerTypes?: Maybe<Array<ProductConsumerType>>;
  src: Scalars['String']['output'];
  strainTypes?: Maybe<Array<Scalars['String']['output']>>;
  subcategories?: Maybe<Array<Scalars['String']['output']>>;
  weights?: Maybe<Array<Scalars['String']['output']>>;
};

export type GqlSearchProductFilterBrand = {
  __typename?: 'SearchProductFilterBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input object for the searchProducts query */
export type GqlSearchProductsInput = {
  bounds: GqlGeographicSearchBounds;
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cannabisTypes?: InputMaybe<Array<CannabisType>>;
  categories: Array<ProductCategory>;
  cbdPotency?: InputMaybe<GqlPotencyProductSearch>;
  consumerType?: InputMaybe<ProductConsumerType>;
  effects?: InputMaybe<Array<Effect>>;
  /** Deprecated: Remove with ticket ENG-14662. This field does nothing. Use cbdPotency and thcPotency instead. */
  potency?: InputMaybe<GqlPotencyProductSearch>;
  subcategories?: InputMaybe<Array<Scalars['String']['input']>>;
  thcPotency?: InputMaybe<GqlPotencyProductSearch>;
  weights?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlSearchProductsMetaResult = {
  __typename?: 'SearchProductsMetaResult';
  page?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Output from the searchProducts query */
export type GqlSearchProductsResult = {
  __typename?: 'SearchProductsResult';
  /** List of products found */
  marketplaceProducts?: Maybe<Array<GqlMarketplaceProductSearchResult>>;
  meta?: Maybe<GqlSearchProductsMetaResult>;
};

export type GqlSegment = {
  __typename?: 'Segment';
  audienceCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Deprecated: SEO menu feature removed. */
export type GqlSeoSettings = {
  __typename?: 'SeoSettings';
  enabled: Scalars['Boolean']['output'];
};

export type GqlSerializableContentChangeRequest = {
  __typename?: 'SerializableContentChangeRequest';
  actionType: ChangeRequestActionType;
  approvalStatus: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['ISODateTime']['output']>;
  authorId: Scalars['ID']['output'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID']['output'];
  complianceRegionId?: Maybe<Scalars['ID']['output']>;
  computedAttributes?: Maybe<GqlContentChangeRequestComputedAttributes>;
  contentAttributes?: Maybe<GqlContentChangeRequestAttributes>;
  createdAt: Scalars['ISODateTime']['output'];
  createdBy?: Maybe<GqlUsers>;
  dispensary?: Maybe<GqlDispensaries>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<GqlLibraryProduct>;
  productId?: Maybe<Scalars['ID']['output']>;
  rejectedAt?: Maybe<Scalars['ISODateTime']['output']>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlServiceFeeInput = {
  currency: Scalars['String']['input'];
  flatFeeCents?: InputMaybe<Scalars['Int']['input']>;
  percentageFee?: InputMaybe<Scalars['Float']['input']>;
};

export enum Services {
  acceptancesService = 'AcceptancesService',
  accountBalancesService = 'AccountBalancesService',
  achBatchesService = 'AchBatchesService',
  achEntriesService = 'AchEntriesService',
  achReturnReportsService = 'AchReturnReportsService',
  achReturnsService = 'AchReturnsService',
  achReversalsService = 'AchReversalsService',
  bankAccountsService = 'BankAccountsService',
  billingAddressesService = 'BillingAddressesService',
  customersService = 'CustomersService',
  eligibilityService = 'EligibilityService',
  enrollmentsService = 'EnrollmentsService',
  entitiesService = 'EntitiesService',
  entityLinkingsService = 'EntityLinkingsService',
  fraudAssessmentsService = 'FraudAssessmentsService',
  fraudEventsService = 'FraudEventsService',
  instoreAnalyticsTokensService = 'InstoreAnalyticsTokensService',
  instoreCartsService = 'InstoreCartsService',
  messageProxyService = 'MessageProxyService',
  paymentMethodsService = 'PaymentMethodsService',
  paymentsService = 'PaymentsService',
  preAuthsService = 'PreAuthsService',
  registrationService = 'RegistrationService',
  retailerEnrollmentsService = 'RetailerEnrollmentsService',
  retailerPaymentTypesService = 'RetailerPaymentTypesService',
  walletsService = 'WalletsService',
  widgetUrlService = 'WidgetUrlService'
}

export type GqlSetCategoryFeaturedBrandsInput = {
  brandIds: Array<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};

export type GqlSetCategoryFeaturedProductsInput = {
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type GqlSetCategoryMenuOrderInput = {
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  menuOrder: CategoryMenuOrder;
};

export type GqlSetGlobalMenuOrderInput = {
  dispensaryId: Scalars['String']['input'];
  menuOrder: GlobalMenuOrder;
};

/** How a location's persisted value for the setting compares to the source dispensary's. */
export enum SettingComparisonStatus {
  /** The location's value differs from the source's value (including one being unset). */
  different = 'DIFFERENT',
  /** The location's value canonically equals the source's value. */
  matches = 'MATCHES',
  /** The value could not be read or compared for this location (redacted server-side). */
  unavailable = 'UNAVAILABLE'
}

export type GqlSharedSalesInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  customerType?: InputMaybe<CustomerType>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  menuVariant?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<OrderType>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type GqlShowEnrollmentResponse = {
  __typename?: 'ShowEnrollmentResponse';
  enrollmentStatus: StatusTypes;
  paymentMethods: Array<Maybe<GqlBankAccountPaymentMethod>>;
  requiresAggregatorMigration?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlShowInstoreCartResponse = {
  __typename?: 'ShowInstoreCartResponse';
  instoreCartData?: Maybe<GqlInstoreCartDataType>;
};

export enum SkipReasonEnum {
  combinedWeights = 'COMBINED_WEIGHTS',
  conflictingData = 'CONFLICTING_DATA',
  insufficientData = 'INSUFFICIENT_DATA',
  libraryGap = 'LIBRARY_GAP',
  libraryGapWithTemplate = 'LIBRARY_GAP_WITH_TEMPLATE',
  other = 'OTHER'
}

export type GqlSkippedCopyLocation = {
  __typename?: 'SkippedCopyLocation';
  dispensaryId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type GqlSlotRecurrence = {
  __typename?: 'SlotRecurrence';
  anchorDate?: Maybe<Scalars['ISODate']['output']>;
  daysOfWeek?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  frequency?: Maybe<RecurrenceFrequency>;
  interval?: Maybe<Scalars['Int']['output']>;
};

export type GqlSlotRecurrenceInput = {
  anchorDate: Scalars['ISODate']['input'];
  daysOfWeek: Array<Scalars['Int']['input']>;
  frequency: RecurrenceFrequency;
  interval: Scalars['Int']['input'];
};

export enum SortByOptions {
  sourceBrandProductsCount = 'sourceBrandProductsCount',
  targetBrandProductsCount = 'targetBrandProductsCount'
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type GqlSortOrderInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GqlSpecialSortOrder>>>;
};

export type GqlSortProductProxy = {
  DispensaryID: Scalars['String']['input'];
  _id: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export type GqlSpecialApplicableCategory = {
  __typename?: 'SpecialApplicableCategory';
  category?: Maybe<Scalars['String']['output']>;
  subcategories?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SpecialApplicationMethodTypes {
  automatic = 'AUTOMATIC',
  byAlpineiq = 'BY_ALPINEIQ',
  byCode = 'BY_CODE',
  byFyllo = 'BY_FYLLO',
  bySpringbig = 'BY_SPRINGBIG',
  manual = 'MANUAL'
}

export type GqlSpecialEmail = {
  __typename?: 'SpecialEmail';
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialEmailInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialGamificationList = {
  __typename?: 'SpecialGamificationList';
  gamificationThresholds?: Maybe<Array<Maybe<GqlGamificationDetailItem>>>;
};

export type GqlSpecialHours = {
  __typename?: 'SpecialHours';
  endDate: Scalars['String']['output'];
  hoursPerDay?: Maybe<Array<Maybe<GqlSpecialHoursDay>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type GqlSpecialHoursDay = {
  __typename?: 'SpecialHoursDay';
  date: Scalars['String']['output'];
  /** @deprecated new SpecialHoursDay in hours-settings is order type agnostic */
  deliveryHours: GqlDayBounds;
  hours: GqlDayBounds;
  /** @deprecated new SpecialHoursDay in hours-settings is order type agnostic */
  pickupHours: GqlDayBounds;
};

export type GqlSpecialHoursSettingsDayInput = {
  date: Scalars['String']['input'];
  hours: GqlDayBoundsInput;
};

export type GqlSpecialHoursSettingsInput = {
  endDate: Scalars['String']['input'];
  hoursPerDay?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsDayInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GqlSpecialMenuCard = {
  __typename?: 'SpecialMenuCard';
  _id?: Maybe<Scalars['String']['output']>;
  applicableCategories?: Maybe<Array<GqlSpecialApplicableCategory>>;
  applicablePreOrderTypes?: Maybe<Array<PreOrderType>>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  endStamp?: Maybe<Scalars['String']['output']>;
  isBundledDiscount?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  posDiscountId?: Maybe<Scalars['String']['output']>;
  recurringSchedule?: Maybe<GqlSpecialRecurringSchedule>;
  specialType?: Maybe<Scalars['String']['output']>;
  startStamp?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialMenuCardResponse = {
  __typename?: 'SpecialMenuCardResponse';
  menuCards?: Maybe<Array<Maybe<GqlSpecialMenuCard>>>;
};

export type GqlSpecialMenuDisplay = {
  __typename?: 'SpecialMenuDisplay';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialMenuDisplayInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum SpecialMenuType {
  both = 'BOTH',
  medical = 'MEDICAL',
  recreational = 'RECREATIONAL'
}

export type GqlSpecialRecurringSchedule = {
  __typename?: 'SpecialRecurringSchedule';
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialRestriction = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<GqlRestriction>;
};

export type GqlSpecialRestrictions = {
  __typename?: 'SpecialRestrictions';
  key: Scalars['String']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<Scalars['String']['output']>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlSpecialRestrictionsInput = {
  key: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialSchedule = {
  __typename?: 'SpecialSchedule';
  days?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  endStamp?: Maybe<Scalars['ISODateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startStamp?: Maybe<Scalars['ISODateTime']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialScheduleInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  endStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum SpecialScopes {
  enterprise = 'enterprise',
  retailer = 'retailer'
}

export enum SpecialSortKey {
  email = 'EMAIL',
  endStamp = 'END_STAMP',
  name = 'NAME',
  specialType = 'SPECIAL_TYPE',
  startStamp = 'START_STAMP'
}

export type GqlSpecialSortOrder = {
  _id?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Int']['input']>;
};

export enum SpecialSource {
  dutchie = 'DUTCHIE',
  pos = 'POS'
}

export enum SpecialStatus {
  active = 'ACTIVE',
  archived = 'ARCHIVED'
}

export type GqlSpecialSummary = {
  __typename?: 'SpecialSummary';
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']['output']>;
  clickThroughPercentage?: Maybe<Scalars['Float']['output']>;
  conversionChangePercentage?: Maybe<Scalars['Float']['output']>;
  conversionPercentage?: Maybe<Scalars['Float']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  emailSent?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum SpecialTemporalStatus {
  past = 'PAST',
  presentOrFuture = 'PRESENT_OR_FUTURE'
}

export enum SpecialType {
  coupon = 'COUPON',
  offer = 'OFFER',
  sale = 'SALE'
}

export enum SpecialTypes {
  bogo = 'bogo',
  sale = 'sale'
}

export type GqlSpecials = {
  __typename?: 'Specials';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  applicableToItemsOnSpecial?: Maybe<Scalars['Boolean']['output']>;
  applicationMethod?: Maybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: Maybe<Scalars['Boolean']['output']>;
  applyToNoGroups?: Maybe<Scalars['Boolean']['output']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoConditions?: Maybe<Array<Maybe<GqlBogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoRewards?: Maybe<Array<Maybe<GqlBogoRewardItem>>>;
  clicks?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  conditionLogicOperator?: Maybe<LogicOperator>;
  conditions?: Maybe<Array<Maybe<GqlV4Condition>>>;
  consumerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  consumerTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  discountBundle?: Maybe<GqlDiscountBundle>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  discountedPrices?: Maybe<Scalars['JSON']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  dollarDiscount?: Maybe<Scalars['Boolean']['output']>;
  duplicatedFrom?: Maybe<Scalars['String']['output']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<GqlSpecialEmail>;
  emailSpecial?: Maybe<Scalars['Boolean']['output']>;
  endDay?: Maybe<Scalars['String']['output']>;
  endStamp?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  endedBy?: Maybe<Scalars['String']['output']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']['output']>;
  excludedProducts?: Maybe<Array<Maybe<GqlSpecialsExcludedProducts>>>;
  firstTimeConsumerOnly?: Maybe<Scalars['Boolean']['output']>;
  generatedByPOS?: Maybe<Scalars['Boolean']['output']>;
  globalApplicationRules?: Maybe<Array<Maybe<GqlApplicationRule>>>;
  globalConditionThresholds?: Maybe<Array<Maybe<GqlGlobalThreshold>>>;
  globalReward?: Maybe<GqlGlobalReward>;
  globalRewardThresholds?: Maybe<Array<Maybe<GqlGlobalThreshold>>>;
  heading?: Maybe<Scalars['String']['output']>;
  inactiveDispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isAvailableOnline?: Maybe<Scalars['Boolean']['output']>;
  isBrandFunded?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  itemsForAPrice?: Maybe<GqlItemsForAPrice>;
  loyaltyPointsToRedeem?: Maybe<Scalars['Int']['output']>;
  manualDefaultApplyTo?: Maybe<ManualDefaultApplyTo>;
  menuDisplay?: Maybe<GqlSpecialMenuDisplay>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuType?: Maybe<Scalars['String']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<OrderType>;
  origin?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  platformType?: Maybe<Array<Maybe<PlatformType>>>;
  preOrderType?: Maybe<Array<Maybe<PreOrderType>>>;
  productDiscounts?: Maybe<Scalars['JSON']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productGroupRewards?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quantityUsed?: Maybe<Scalars['Int']['output']>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']['output']>;
  recurring?: Maybe<GqlSpecialsRecurring>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerCart?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']['output']>;
  reimbursed?: Maybe<Scalars['Boolean']['output']>;
  requireManagerApproval?: Maybe<Scalars['Boolean']['output']>;
  rewardLogicOperator?: Maybe<LogicOperator>;
  rewards?: Maybe<Array<Maybe<GqlV4Reward>>>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  schedule?: Maybe<GqlSpecialSchedule>;
  scope?: Maybe<SpecialScopes>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use _id instead 5/21/2021 */
  specialId?: Maybe<Scalars['String']['output']>;
  specialRestrictions?: Maybe<Scalars['JSON']['output']>;
  specialType?: Maybe<SpecialTypes>;
  specialVersion?: Maybe<Scalars['Int']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startDay?: Maybe<Scalars['String']['output']>;
  startStamp?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SpecialStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<Scalars['Boolean']['output']>;
  totalAllowedUses?: Maybe<Scalars['Int']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']['output']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 12/03/25 */
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']['output']>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlSpecialsExcludedBogo = {
  __typename?: 'SpecialsExcludedBOGO';
  Name?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialsExcludedBogoInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  _id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialsExcludedProducts = {
  __typename?: 'SpecialsExcludedProducts';
  Name?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<GqlSpecialsExcludedBogo>>>;
  key?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Maybe<GqlSpecialsExcludedBogo>>>;
};

export type GqlSpecialsExcludedProductsInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  _id?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedBogoInput>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedBogoInput>>>;
};

export type GqlSpecialsHistory = {
  __typename?: 'SpecialsHistory';
  id?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<Maybe<GqlSpecials>>>;
};

export type GqlSpecialsInputV3 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableToItemsOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  applicationMethod?: InputMaybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: InputMaybe<Scalars['Boolean']['input']>;
  applyToNoGroups?: InputMaybe<Scalars['Boolean']['input']>;
  bogoConditionLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoConditions?: InputMaybe<Array<InputMaybe<GqlBogoConditionItemInput>>>;
  bogoRewardLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoRewards?: InputMaybe<Array<InputMaybe<GqlBogoRewardItemInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  conditionLogicOperator?: InputMaybe<LogicOperator>;
  conditions?: InputMaybe<Array<InputMaybe<GqlV4ConditionInput>>>;
  consumerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  directPOSProductIdMapping?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  discountBundle?: InputMaybe<GqlDiscountBundleInput>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  discountToCart?: InputMaybe<GqlDiscountToCartInput>;
  discountedPrices?: InputMaybe<Scalars['JSON']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Int']['input']>;
  dollarDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['String']['input']>;
  editedStartStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<GqlSpecialEmailInput>;
  emailSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  endDay?: InputMaybe<Scalars['String']['input']>;
  endStamp?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  endedBy?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  excludeConditionItemsFromRewards?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedProductsInput>>>;
  firstTimeConsumerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  generatedByPOS?: InputMaybe<Scalars['Boolean']['input']>;
  globalApplicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  globalConditionThresholds?: InputMaybe<Array<InputMaybe<GqlGlobalThresholdInput>>>;
  globalReward?: InputMaybe<GqlGlobalRewardInput>;
  globalRewardThresholds?: InputMaybe<Array<InputMaybe<GqlGlobalThresholdInput>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  inactiveDispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  itemsForAPrice?: InputMaybe<GqlItemsForAPriceInput>;
  loyaltyPointsToRedeem?: InputMaybe<Scalars['Int']['input']>;
  manualDefaultApplyTo?: InputMaybe<ManualDefaultApplyTo>;
  menuDisplay?: InputMaybe<GqlSpecialMenuDisplayInput>;
  menuDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  menuDisplayImage?: InputMaybe<Scalars['String']['input']>;
  menuDisplayName?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  minorVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<OrderType>;
  origin?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  paymentRestrictions?: InputMaybe<GqlPaymentRestrictionsInput>;
  percentDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  platformType?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  preOrderType?: InputMaybe<Array<InputMaybe<PreOrderType>>>;
  productDiscounts?: InputMaybe<Array<InputMaybe<GqlProductDiscount>>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroupRewards?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quantityUsed?: InputMaybe<Scalars['Int']['input']>;
  rawPOSWeightMapping?: InputMaybe<Scalars['Boolean']['input']>;
  recurring?: InputMaybe<GqlSpecialsInputRecurring>;
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerCart?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Int']['input']>;
  requireManagerApproval?: InputMaybe<Scalars['Boolean']['input']>;
  rewardLogicOperator?: InputMaybe<LogicOperator>;
  rewards?: InputMaybe<Array<InputMaybe<GqlV4RewardInput>>>;
  saleDiscounts?: InputMaybe<Array<InputMaybe<GqlSaleDiscountInput>>>;
  schedule?: InputMaybe<GqlSpecialScheduleInput>;
  scope?: InputMaybe<SpecialScopes>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialRestrictions?: InputMaybe<Array<InputMaybe<GqlSpecialRestriction>>>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  specialVersion?: InputMaybe<Scalars['Int']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingMode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDay?: InputMaybe<Scalars['String']['input']>;
  startStamp?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  targetPrice?: InputMaybe<Scalars['Boolean']['input']>;
  totalAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlSpecialsPageSettings = {
  __typename?: 'SpecialsPageSettings';
  /** @deprecated Specials filter chips removed from the redesigned specials page - ECOMM-12457 2026-08-05 */
  menuFilterChips?: Maybe<GqlMenuFilterChipsSettings>;
  showCategoryTiles?: Maybe<Scalars['Boolean']['output']>;
  showSpecialDuration?: Maybe<Scalars['Boolean']['output']>;
  showSpecialsRedesign?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlSpecialsRecurring = {
  __typename?: 'SpecialsRecurring';
  days?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  setEndDate?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialsSettings = {
  __typename?: 'SpecialsSettings';
  discountBehavior?: Maybe<Scalars['String']['output']>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  enableIndividualDiscountStacking?: Maybe<Scalars['Boolean']['output']>;
  enableIndividualSpecialPrecedence?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Moved to storeSettings.specialsPage 2026-07-28 */
  menuFilterChips?: Maybe<GqlMenuFilterChipsSettings>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  /** @deprecated Moved to storeSettings.specialsPage 2026-07-28 */
  showCategoryTiles?: Maybe<Scalars['Boolean']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialsSettingsInput = {
  discountBehavior?: InputMaybe<Scalars['String']['input']>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']['input']>;
  menuFilterChips?: InputMaybe<GqlMenuFilterChipsSettingsInput>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  showCategoryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSponsoredBrand = {
  __typename?: 'SponsoredBrand';
  campaignId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<GqlProducts>;
  trackers: GqlAdTrackers;
};

export type GqlSponsoredProduct = {
  __typename?: 'SponsoredProduct';
  product: GqlProducts;
  trackers: GqlAdTrackers;
};

export enum SponsoredProductsInventoryId {
  cartTopperProductAuc = 'cart_topper_product_auc',
  categoryProductAuc = 'category_product_auc',
  pdpProductAuc = 'pdp_product_auc',
  searchProductAuc = 'search_product_auc'
}

export type GqlSponsoredProductsPlacements = {
  __typename?: 'SponsoredProductsPlacements';
  placements: Array<Scalars['Int']['output']>;
};

export enum SponsoredProductsPlacementsPage {
  category = 'category',
  search = 'search'
}

export enum StackingBehavior {
  compounding = 'COMPOUNDING',
  cumulative = 'CUMULATIVE',
  prohibited = 'PROHIBITED'
}

export type GqlStartAggregatorLinkV2Response = {
  __typename?: 'StartAggregatorLinkV2Response';
  aerosync?: Maybe<GqlAeroSyncLinkStart>;
  plaid?: Maybe<GqlPlaidLinkStart>;
};

export type GqlStartPayByBankFinalizationResult = {
  __typename?: 'StartPayByBankFinalizationResult';
  reason?: Maybe<PayByBankFinalizationRejectionReason>;
  status: PayByBankFinalizationStatus;
};

export type GqlStartPreAuthCheckResponse = {
  __typename?: 'StartPreAuthCheckResponse';
  channelName?: Maybe<Scalars['String']['output']>;
  checkId?: Maybe<Scalars['String']['output']>;
  status: StartPreAuthCheckResponseStatus;
};

export enum StartPreAuthCheckResponseStatus {
  statusFailed = 'STATUS_FAILED',
  statusPending = 'STATUS_PENDING',
  statusReady = 'STATUS_READY',
  statusUnspecified = 'STATUS_UNSPECIFIED'
}

export type GqlState = {
  __typename?: 'State';
  cities: Array<Maybe<Scalars['String']['output']>>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlStateLibrary = {
  __typename?: 'StateLibrary';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GqlStatus = {
  __typename?: 'Status';
  mx?: Maybe<GqlMxResponse>;
  status: StatusTypes;
};

export enum StatusTypes {
  statusAcceptTerms = 'STATUS_ACCEPT_TERMS',
  statusAccountDisconnected = 'STATUS_ACCOUNT_DISCONNECTED',
  statusAccountPending = 'STATUS_ACCOUNT_PENDING',
  statusAggregatorError = 'STATUS_AGGREGATOR_ERROR',
  statusEnrolled = 'STATUS_ENROLLED',
  statusNoAccount = 'STATUS_NO_ACCOUNT',
  statusUnenrolled = 'STATUS_UNENROLLED',
  statusUnspecified = 'STATUS_UNSPECIFIED'
}

export type GqlStockImage = {
  __typename?: 'StockImage';
  aliasOrder?: Maybe<Scalars['Int']['output']>;
  aliasRegex?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type GqlStrain = {
  __typename?: 'Strain';
  /** @deprecated Use id */
  _id?: Maybe<Scalars['String']['output']>;
  aromas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  potentialHealthBenefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratio?: Maybe<Scalars['String']['output']>;
  terpenes?: Maybe<Array<Maybe<GqlTerpene>>>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlStrainLabels = {
  __typename?: 'StrainLabels';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlStrainList = {
  __typename?: 'StrainList';
  queryInfo?: Maybe<GqlQueryInfoType>;
  strains?: Maybe<Array<Maybe<GqlStrain>>>;
};

export enum StrainSortByEnum {
  description = 'description',
  effects = 'effects',
  imageUrl = 'imageUrl',
  name = 'name',
  potentialHealthBenefits = 'potentialHealthBenefits'
}

export type GqlStrainTypeColors = {
  __typename?: 'StrainTypeColors';
  cbd?: Maybe<Scalars['String']['output']>;
  cbg?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
  highCBD?: Maybe<Scalars['String']['output']>;
  hybrid?: Maybe<Scalars['String']['output']>;
  indica?: Maybe<Scalars['String']['output']>;
  indicaHybrid?: Maybe<Scalars['String']['output']>;
  sativa?: Maybe<Scalars['String']['output']>;
  sativaHybrid?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
  thc?: Maybe<Scalars['String']['output']>;
};

export type GqlStrainTypeColorsInput = {
  cbd?: InputMaybe<Scalars['String']['input']>;
  cbg?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['String']['input']>;
  highCBD?: InputMaybe<Scalars['String']['input']>;
  hybrid?: InputMaybe<Scalars['String']['input']>;
  indica?: InputMaybe<Scalars['String']['input']>;
  indicaHybrid?: InputMaybe<Scalars['String']['input']>;
  sativa?: InputMaybe<Scalars['String']['input']>;
  sativaHybrid?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
  thc?: InputMaybe<Scalars['String']['input']>;
};

export type GqlStrandedReservationsPreview = {
  __typename?: 'StrandedReservationsPreview';
  strandedCount: Scalars['Int']['output'];
};

export enum StringSortDirections {
  asc = 'asc',
  desc = 'desc'
}

export type GqlSubmitConsumerPulseReviewInput = {
  dispensaryId: Scalars['String']['input'];
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
  externalReviewId: Scalars['String']['input'];
  quickResponses?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewText?: InputMaybe<Scalars['String']['input']>;
  reviewerName?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['String']['input'];
};

export type GqlSubscriptionCustomers = {
  __typename?: 'SubscriptionCustomers';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dateAdded?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numOrders?: Maybe<Scalars['Float']['output']>;
  orderTotal?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  textSubscription?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlSubscriptionsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlSubtotalItem = {
  __typename?: 'SubtotalItem';
  name: Scalars['String']['output'];
  valueCents: Scalars['Int']['output'];
};

/**
 * Minimal consumer identity returned to Super Admin user management. Deliberately
 * excludes phone, birthday, address, customer relationships, and other PII.
 */
export type GqlSuperAdminConsumerUser = {
  __typename?: 'SuperAdminConsumerUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSso: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ssoProvider?: Maybe<Scalars['String']['output']>;
};

export type GqlTag = {
  __typename?: 'Tag';
  tagId?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type GqlTaxApplyToInput = {
  hemp?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlTaxConfigTaxInput = {
  applyTo?: InputMaybe<GqlTaxApplyToInput>;
  deliveryPolicy?: InputMaybe<Scalars['String']['input']>;
  destinationRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeStateSalesTaxInDestinationRate?: InputMaybe<Scalars['Boolean']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  potency?: InputMaybe<Scalars['String']['input']>;
  potencyRate?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  recreational?: InputMaybe<Scalars['Boolean']['input']>;
  stages?: InputMaybe<Array<InputMaybe<GqlTaxStageInput>>>;
  taxBasis?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlTaxExistence = {
  __typename?: 'TaxExistence';
  med?: Maybe<GqlTaxExistenceInside>;
  rec?: Maybe<GqlTaxExistenceInside>;
};

export type GqlTaxExistenceInside = {
  __typename?: 'TaxExistenceInside';
  checkout?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
};

export type GqlTaxStageInput = {
  op?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum TaxType {
  bottleDeposit = 'bottleDeposit',
  cannabis = 'cannabis',
  sales = 'sales'
}

export type GqlTemporalLocation = {
  __typename?: 'TemporalLocation';
  coordinates?: Maybe<Scalars['JSONObject']['output']>;
  lastUpdatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  nearbyEnabled?: Maybe<Scalars['Boolean']['output']>;
  onDuty?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlTerminalReceiptOptions = {
  __typename?: 'TerminalReceiptOptions';
  birthdate?: Maybe<Scalars['Boolean']['output']>;
  customerNameOption?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['Boolean']['output']>;
  disableSocialImpact?: Maybe<Scalars['Boolean']['output']>;
  enableSurveyQrCode?: Maybe<Scalars['Boolean']['output']>;
  groupLineItemsBy?: Maybe<Scalars['String']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
  potencyInfo?: Maybe<Scalars['Boolean']['output']>;
  sortLineItemsBy?: Maybe<Scalars['String']['output']>;
};

export type GqlTerpene = {
  __typename?: 'Terpene';
  aliasList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aromas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  potentialHealthBenefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strains: Array<Maybe<GqlStrain>>;
  unitSymbol?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlTestPlusOAuthProviderResponse = {
  __typename?: 'TestPlusOAuthProviderResponse';
  success: Scalars['Boolean']['output'];
};

export type GqlTextTransformInput = {
  buttons?: InputMaybe<TextTransformOption>;
  links?: InputMaybe<TextTransformOption>;
  tags?: InputMaybe<TextTransformOption>;
};

export enum TextTransformOption {
  lower = 'LOWER',
  sentence = 'SENTENCE',
  title = 'TITLE',
  upper = 'UPPER'
}

export type GqlTextTransforms = {
  __typename?: 'TextTransforms';
  buttons?: Maybe<TextTransformOption>;
  links?: Maybe<TextTransformOption>;
  tags?: Maybe<TextTransformOption>;
};

export type GqlThreshold = {
  __typename?: 'Threshold';
  comparisonOperator?: Maybe<ComparisonOperators>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  thresholdType?: Maybe<ThresholdType>;
  weight?: Maybe<GqlWeight>;
};

export type GqlThresholdInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  thresholdType?: InputMaybe<ThresholdType>;
  weight?: InputMaybe<GqlWeightInput>;
};

export enum ThresholdType {
  price = 'PRICE',
  quantity = 'QUANTITY',
  totalPrice = 'TOTAL_PRICE',
  totalQuantity = 'TOTAL_QUANTITY',
  totalWeight = 'TOTAL_WEIGHT',
  weight = 'WEIGHT'
}

export type GqlTimeRange = {
  __typename?: 'TimeRange';
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
};

export type GqlTimeRangeInput = {
  dayOfWeek: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type GqlTimeoutConfig = {
  __typename?: 'TimeoutConfig';
  duration?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlTipValueInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlTopProduct = {
  __typename?: 'TopProduct';
  product?: Maybe<GqlProducts>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type GqlTotalQuantity = {
  __typename?: 'TotalQuantity';
  enabled: Scalars['Boolean']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalQuantityInput = {
  enabled: Scalars['Boolean']['input'];
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityOperator: ComparisonOperators;
};

export type GqlTotalSpend = {
  __typename?: 'TotalSpend';
  enabled: Scalars['Boolean']['output'];
  maximumSpend?: Maybe<Scalars['Float']['output']>;
  minimumSpend?: Maybe<Scalars['Float']['output']>;
  spendOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalSpendInput = {
  enabled: Scalars['Boolean']['input'];
  maximumSpend?: InputMaybe<Scalars['Float']['input']>;
  minimumSpend: Scalars['Float']['input'];
  spendOperator: ComparisonOperators;
};

export type GqlTotalWeight = {
  __typename?: 'TotalWeight';
  enabled: Scalars['Boolean']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalWeightInput = {
  enabled: Scalars['Boolean']['input'];
  weight: Scalars['String']['input'];
  weightOperator: ComparisonOperators;
};

export type GqlTrackIrlEventByDispensaryInput = {
  dispensaryId: Scalars['String']['input'];
  ecommUserId?: InputMaybe<Scalars['String']['input']>;
  event: IrlEventTrackingEvent;
  irlEventId: Scalars['ID']['input'];
  userCookie: Scalars['String']['input'];
};

export type GqlTrackIrlEventInput = {
  ecommUserId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['String']['input'];
  event: IrlEventTrackingEvent;
  irlEventId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
  userCookie: Scalars['String']['input'];
};

export type GqlTrackedCart = {
  __typename?: 'TrackedCart';
  createdAt?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  order?: Maybe<Scalars['JSON']['output']>;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlTrending = {
  __typename?: 'Trending';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  dollarHistoryThisPeriod?: Maybe<Array<Maybe<GqlChangeHistoryObject>>>;
  percentChangeFromLastPeriod?: Maybe<Scalars['Float']['output']>;
};

export type GqlTrendingBrandsResponse = {
  __typename?: 'TrendingBrandsResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  trending?: Maybe<Array<Maybe<GqlTrending>>>;
};

export type GqlUnenrollEnrollmentResponse = {
  __typename?: 'UnenrollEnrollmentResponse';
  success: Scalars['Boolean']['output'];
};

export enum UnitOfMeasure {
  grams = 'grams',
  items = 'items',
  kilograms = 'kilograms',
  milligrams = 'milligrams',
  milliliters = 'milliliters',
  ounces = 'ounces',
  pounds = 'pounds'
}

export type GqlUpdateBrandTagInput = {
  cannabinoidRatio?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateCollectionInput = {
  allConditions: Scalars['Boolean']['input'];
  audienceConditions?: InputMaybe<Array<GqlAudienceConditionInput>>;
  cardBadgeColor?: InputMaybe<Scalars['String']['input']>;
  cardBadgeEnabled: Scalars['Boolean']['input'];
  cardBadgeTitle?: InputMaybe<Scalars['String']['input']>;
  cardDisplayName?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Array<CollectionChannel>>;
  conditions: Array<InputMaybe<GqlUpdateConditionInput>>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isOutlet?: InputMaybe<Scalars['Boolean']['input']>;
  matchAllAudienceConditions?: InputMaybe<Scalars['Boolean']['input']>;
  navigationEnabled: Scalars['Boolean']['input'];
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  onSaleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  outletTimerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outletTimerMessage?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<GqlScheduleInput>;
  title: Scalars['String']['input'];
};

export type GqlUpdateCollectionPositionsInput = {
  productCollections: Array<GqlCollectionPositionsInput>;
};

export type GqlUpdateConditionInput = {
  condition: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  itemKey: Scalars['String']['input'];
  itemValue: Scalars['String']['input'];
  productCollectionId: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlUpdateConsumerPulseSettingsInput = {
  dispensaryId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type GqlUpdateEnterpriseAdSettingsResponse = {
  __typename?: 'UpdateEnterpriseAdSettingsResponse';
  adSettings: GqlDispensaryAdSettings;
};

export type GqlUpdateEnterprisePersonalizationSettingsResponse = {
  __typename?: 'UpdateEnterprisePersonalizationSettingsResponse';
  personalizationSettings: GqlDispensaryPersonalizationSettings;
};

export type GqlUpdateImageBannerInput = {
  _id: Scalars['String']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  bannerType?: InputMaybe<ImageBannerType>;
  connectedId?: InputMaybe<Scalars['String']['input']>;
  connectedStatus?: InputMaybe<Scalars['String']['input']>;
  connectedType?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use platforms.link instead */
  link?: InputMaybe<Scalars['String']['input']>;
  mobileImage: Scalars['String']['input'];
  /** @deprecated Use platforms.openInNewTab instead */
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<GqlImageBannerPlatformInput>>>;
  position: Scalars['Int']['input'];
  schedule?: InputMaybe<GqlScheduleInput>;
};

export type GqlUpdateImageBannersInput = {
  imageBanners: Array<InputMaybe<GqlUpdateImageBannerInput>>;
};

export type GqlUpdateLibraryProductResponse = {
  __typename?: 'UpdateLibraryProductResponse';
  libraryProduct?: Maybe<GqlLibraryProduct>;
};

export type GqlUpdatePrinterInput = {
  deviceIdentifier: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queueConfig?: InputMaybe<GqlPrinterQueueConfigInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateRemoteExtensionsInput = {
  builderKey?: InputMaybe<Scalars['String']['input']>;
  theme: GqlRemoteExtensionsInput;
};

/** Deprecated: SEO menu feature removed. */
export type GqlUpdateSeoSettingsInput = {
  enabled: Scalars['Boolean']['input'];
};

export type GqlUpdateSingleDispensaryAdSettingsResponse = {
  __typename?: 'UpdateSingleDispensaryAdSettingsResponse';
  adSettings?: Maybe<GqlDispensaryAdSettings>;
  id: Scalars['String']['output'];
};

export type GqlUpdateSingleDispensaryPersonalizationSettingsResponse = {
  __typename?: 'UpdateSingleDispensaryPersonalizationSettingsResponse';
  id: Scalars['String']['output'];
  personalizationSettings?: Maybe<GqlDispensaryPersonalizationSettings>;
};

export type GqlUpdateWebCustomizationSettingsInput = {
  colorSettings: GqlColorSettingsInputV2;
  fontSettings: GqlFontSettingsInput;
};

export type GqlUpdateWebCustomizationSettingsV2Input = {
  categories?: InputMaybe<GqlCategoriesInput>;
  colors?: InputMaybe<GqlColorInput>;
  concierge?: InputMaybe<GqlConciergeInput>;
  fonts?: InputMaybe<GqlFontInput>;
  mobile?: InputMaybe<GqlMobileCustomizationInput>;
  productCards?: InputMaybe<GqlProductCardsInput>;
  radius?: InputMaybe<GqlRadiusInput>;
  textTransforms?: InputMaybe<GqlTextTransformInput>;
};

export type GqlUpdatedLibraryProduct = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DispensaryID?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  _id?: InputMaybe<Scalars['String']['input']>;
  availableForWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  cannabinoidRatio?: InputMaybe<Scalars['String']['input']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  caseSize?: InputMaybe<Scalars['Int']['input']>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  complianceRegionId?: InputMaybe<Scalars['String']['input']>;
  connectedCount?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  dosageMg?: InputMaybe<Scalars['Float']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']['input']>;
  msrpCents?: InputMaybe<Scalars['Int']['input']>;
  packSize?: InputMaybe<Scalars['Int']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stockImage?: InputMaybe<Scalars['String']['input']>;
  stockImageAliases?: InputMaybe<Scalars['String']['input']>;
  stockImageCategory?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightGrams?: InputMaybe<Scalars['Float']['input']>;
  wholesalePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  wholesaleVariants?: InputMaybe<Array<GqlWholesaleVariantInput>>;
};

export type GqlUpsertBrandPortalDefaultContactInput = {
  brandId: Scalars['ID']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  feature: BrandPortalDefaultContactFeature;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpsertBrandPortalNotificationSettingsInput = {
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  brandId: Scalars['ID']['input'];
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  settings: Array<GqlBrandPortalNotificationSettingInput>;
};

export type GqlUpsertPurchaseOrderInput = {
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<GqlPurchaseOrderContactInput>;
  destinationDposLocGlobalId?: InputMaybe<Scalars['String']['input']>;
  destinationDposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  expectedArrivalDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<GqlUpsertPurchaseOrderNoteInput>>;
  purchaseOrderItems?: InputMaybe<Array<GqlUpsertPurchaseOrderItemInput>>;
  shippingInformation?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocId?: InputMaybe<Scalars['Int']['input']>;
  sourceDposLocName?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspId?: InputMaybe<Scalars['Int']['input']>;
  sourceDposLspName?: InputMaybe<Scalars['String']['input']>;
  sourceDposServerRegion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PurchaseOrderStatus>;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUpsertPurchaseOrderItemInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  catalogSource?: InputMaybe<Scalars['String']['input']>;
  confirmedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemStatus?: InputMaybe<PurchaseOrderItemStatus>;
  libraryProductId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<GqlUpsertPurchaseOrderNoteInput>>;
  requestedQuantity?: InputMaybe<Scalars['Int']['input']>;
  retailerProductName?: InputMaybe<Scalars['String']['input']>;
  substituteLibraryProductId?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  unitPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  variantName?: InputMaybe<Scalars['String']['input']>;
  wholesaleVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpsertPurchaseOrderNoteInput = {
  authorEmail: Scalars['String']['input'];
  authorParty: Scalars['String']['input'];
  content: Scalars['String']['input'];
  notableId?: InputMaybe<Scalars['String']['input']>;
  notableType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUserAuthInfo = {
  __typename?: 'UserAuthInfo';
  authTextMessageSent?: Maybe<Scalars['Boolean']['output']>;
  incorrectPinProvided?: Maybe<Scalars['Boolean']['output']>;
  pinConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlUserEmails = {
  __typename?: 'UserEmails';
  address: Scalars['String']['output'];
  lastVerifiedAt?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlUserEnrollment = {
  __typename?: 'UserEnrollment';
  bankAccounts: Array<GqlBankAccount>;
  enrollment?: Maybe<GqlStatus>;
};

export enum UserRoles {
  super = 'SUPER',
  user = 'USER'
}

export type GqlUsers = {
  __typename?: 'Users';
  _id?: Maybe<Scalars['String']['output']>;
  audioNotificationsOnNewArrivalsDisabled?: Maybe<Scalars['Boolean']['output']>;
  audioNotificationsOnNewOrdersDisabled?: Maybe<Scalars['Boolean']['output']>;
  chainID?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  isWeeklyReportEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<GqlUsers_Permissions>;
  phone?: Maybe<Scalars['String']['output']>;
  roleAtDispensary?: Maybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlUsers_Permissions = {
  __typename?: 'Users_permissions';
  allLocations?: Maybe<Scalars['Boolean']['output']>;
  analytics?: Maybe<Scalars['Boolean']['output']>;
  billing?: Maybe<Scalars['Boolean']['output']>;
  customers?: Maybe<Scalars['Boolean']['output']>;
  dispensaryIds?: Maybe<Array<Scalars['String']['output']>>;
  driver?: Maybe<Scalars['Boolean']['output']>;
  enterpriseAdmin?: Maybe<Scalars['Boolean']['output']>;
  enterpriseSpecials?: Maybe<Scalars['Boolean']['output']>;
  menu?: Maybe<Scalars['Boolean']['output']>;
  menuReview?: Maybe<Scalars['Boolean']['output']>;
  messaging?: Maybe<Scalars['Boolean']['output']>;
  orders?: Maybe<Scalars['Boolean']['output']>;
  promote?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['Boolean']['output']>;
  superMenuReview?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlValidationResponse = {
  __typename?: 'ValidationResponse';
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlVerifyLoginCodeResponse = {
  __typename?: 'VerifyLoginCodeResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  transferToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GqlIdentityConsumer>;
};

export enum Versions {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
  v4 = 'v4'
}

export type GqlVoiceAgent = {
  __typename?: 'VoiceAgent';
  enterprisePrompt?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fallbackPhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationGroupId: Scalars['ID']['output'];
  locationTransferNumbers?: Maybe<Array<GqlLocationTransferNumber>>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberStatus?: Maybe<Scalars['String']['output']>;
  phoneOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  spanishEnabled?: Maybe<Scalars['Boolean']['output']>;
  superAdminPrompt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlVoiceAgentCall = {
  __typename?: 'VoiceAgentCall';
  assistantId?: Maybe<Scalars['String']['output']>;
  assistantPhone: Scalars['String']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  endedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successEvaluation?: Maybe<Scalars['String']['output']>;
};

export type GqlVoiceAgentCallAnalytics = {
  __typename?: 'VoiceAgentCallAnalytics';
  assistantId: Scalars['ID']['output'];
  averageDurationSeconds: Scalars['Int']['output'];
  dailyCallVolume: Array<GqlVoiceAgentDailyCallVolume>;
  days: Scalars['Int']['output'];
  endReasonDistribution: Array<GqlVoiceAgentEndReasonCount>;
  id: Scalars['ID']['output'];
  successRate: Scalars['Float']['output'];
  totalCalls: Scalars['Int']['output'];
  totalMinutes: Scalars['Int']['output'];
};

export type GqlVoiceAgentCallDetail = {
  __typename?: 'VoiceAgentCallDetail';
  assistantId?: Maybe<Scalars['String']['output']>;
  assistantPhone: Scalars['String']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  endedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  structuredData?: Maybe<Scalars['JSON']['output']>;
  successEvaluation?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  transcript: Array<GqlVoiceAgentCallTranscriptTurn>;
};

export type GqlVoiceAgentCallTranscriptTurn = {
  __typename?: 'VoiceAgentCallTranscriptTurn';
  message: Scalars['String']['output'];
  role: Scalars['String']['output'];
  time?: Maybe<Scalars['String']['output']>;
};

export type GqlVoiceAgentDailyCallVolume = {
  __typename?: 'VoiceAgentDailyCallVolume';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type GqlVoiceAgentEndReasonCount = {
  __typename?: 'VoiceAgentEndReasonCount';
  count: Scalars['Int']['output'];
  endedReason?: Maybe<Scalars['String']['output']>;
};

export type GqlVoiceCallInfo = {
  __typename?: 'VoiceCallInfo';
  assistantId?: Maybe<Scalars['String']['output']>;
  callId?: Maybe<Scalars['String']['output']>;
};

export type GqlVoiceCallInfoInput = {
  assistantId?: InputMaybe<Scalars['String']['input']>;
  callId: Scalars['String']['input'];
};

export type GqlWebCustomizationSettings = {
  __typename?: 'WebCustomizationSettings';
  colorSettings: GqlColorSettingsV2;
  fontSettings: GqlFontSettings;
};

export type GqlWebCustomizationSettingsV2 = {
  __typename?: 'WebCustomizationSettingsV2';
  categories?: Maybe<GqlCustomizedCategories>;
  colors?: Maybe<GqlColors>;
  concierge?: Maybe<GqlConciergeCustomization>;
  fonts?: Maybe<GqlFonts>;
  mobile?: Maybe<GqlMobileCustomization>;
  productCards?: Maybe<GqlProductCards>;
  radius?: Maybe<GqlRadius>;
  textTransforms?: Maybe<GqlTextTransforms>;
};

export type GqlWeeklyHours = {
  __typename?: 'WeeklyHours';
  Friday?: Maybe<GqlDayBounds>;
  Monday?: Maybe<GqlDayBounds>;
  Saturday?: Maybe<GqlDayBounds>;
  Sunday?: Maybe<GqlDayBounds>;
  Thursday?: Maybe<GqlDayBounds>;
  Tuesday?: Maybe<GqlDayBounds>;
  Wednesday?: Maybe<GqlDayBounds>;
};

export type GqlWeeklyHoursInput = {
  Friday?: InputMaybe<GqlDayBoundsInput>;
  Monday?: InputMaybe<GqlDayBoundsInput>;
  Saturday?: InputMaybe<GqlDayBoundsInput>;
  Sunday?: InputMaybe<GqlDayBoundsInput>;
  Thursday?: InputMaybe<GqlDayBoundsInput>;
  Tuesday?: InputMaybe<GqlDayBoundsInput>;
  Wednesday?: InputMaybe<GqlDayBoundsInput>;
};

export type GqlWeight = {
  __typename?: 'Weight';
  amount?: Maybe<Scalars['Float']['output']>;
  weightUom?: Maybe<WeightUom>;
};

export type GqlWeightInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  weightUom?: InputMaybe<WeightUom>;
};

export enum WeightOperator {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo'
}

export enum WeightUom {
  g = 'G',
  gc = 'GC',
  mg = 'MG',
  oz = 'OZ'
}

export type GqlWholesaleInventoryItem = {
  __typename?: 'WholesaleInventoryItem';
  availableQuantity: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type GqlWholesaleVariant = {
  __typename?: 'WholesaleVariant';
  availableForWholesale?: Maybe<Scalars['Boolean']['output']>;
  caseSize?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  maxOrderQty?: Maybe<Scalars['Int']['output']>;
  minOrderQty?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceInCents: Scalars['Int']['output'];
  uom: Scalars['String']['output'];
};

export type GqlWholesaleVariantInput = {
  availableForWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  caseSize?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxOrderQty?: InputMaybe<Scalars['Int']['input']>;
  minOrderQty?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceInCents: Scalars['Int']['input'];
  uom: Scalars['String']['input'];
};

export type GqlActiveDispensariesInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<DispensaryOrderType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GqlActiveProductsCheckInput = {
  bypassThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isKiosk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlAddCustomerToOrderInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlAddressResidentialCheckInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GqlArchiveOrderInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  otherReasonText?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Orders_CancellationReasonIDs>;
  shouldNotifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlBrandCollisionFilters = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandNameQuery?: InputMaybe<Scalars['String']['input']>;
  collisionType?: InputMaybe<CollisionType>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandCollisionInput = {
  isAllowed: Scalars['Boolean']['input'];
};

export type GqlBrandCollisionsSort = {
  sortBy?: InputMaybe<SortByOptions>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GqlBrandEnterpriseSettingsInput = {
  adsEnabled: Scalars['Boolean']['input'];
  enterpriseId: Scalars['String']['input'];
};

export type GqlBrandInput = {
  aliasList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandMergeHistoriesFilters = {
  destinationBrandId?: InputMaybe<Scalars['String']['input']>;
  destinationDispensaryId?: InputMaybe<Scalars['String']['input']>;
  reverted?: InputMaybe<Scalars['Boolean']['input']>;
  sourceBrandId?: InputMaybe<Scalars['String']['input']>;
  sourceDispensaryId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandMergeHistoriesPagination = {
  number?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlBrandMergeHistoriesSort = {
  sortBy?: InputMaybe<BrandMergeHistoriesSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandPortalProductSearchFilters = {
  approvalStatus?: InputMaybe<BrandPortalProductSearchApprovalStatusFilterEnum>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  complianceRegion?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlBrandPortalProductSearchSort = {
  sortBy?: InputMaybe<BrandPortalProductSearchSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandUserCreateInput = {
  brandAppPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  manageAdCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrandGroup?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrands?: InputMaybe<Scalars['Boolean']['input']>;
  managedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentBrandId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
};

export type GqlBrandUserFocusedAccountInput = {
  dposLspGlobalId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use dposLspGlobalId. */
  dposLspId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use dposLspGlobalId. */
  dposServerRegion?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandUserUpdateAccountInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type GqlBrandUserUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brandAppPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  focusedAccounts?: InputMaybe<Array<GqlBrandUserFocusedAccountInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  manageAdCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrandGroup?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrands?: InputMaybe<Scalars['Boolean']['input']>;
  managedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandUsersFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandUsersSortInput = {
  sortBy?: InputMaybe<BrandUsersSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandsSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlCategoryPhotoInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
};

export type GqlColorSettingsInput = {
  linkColor?: InputMaybe<Scalars['String']['input']>;
  navBarColor?: InputMaybe<Scalars['String']['input']>;
};

export type GqlConsumerSignupDataInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  embedded: Scalars['Boolean']['input'];
  kioskPhoneOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlConsumerSignupInput = {
  data: GqlConsumerSignupDataInput;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profile: GqlConsumerSignupProfileInput;
};

export type GqlConsumerSignupMedicalCardInput = {
  expirationDate: Scalars['String']['input'];
  number: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type GqlConsumerSignupProfileInput = {
  address?: InputMaybe<GqlConsumerUserProfileAddress>;
  birthday: Scalars['String']['input'];
  driversLicense?: InputMaybe<Scalars['String']['input']>;
  driversLicenseExpirationDate?: InputMaybe<Scalars['String']['input']>;
  emailNotifications: Scalars['Boolean']['input'];
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  medicalCard?: InputMaybe<GqlConsumerSignupMedicalCardInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  textNotifications: Scalars['Boolean']['input'];
};

export type GqlConsumerUserMedicalCard = {
  __typename?: 'consumerUserMedicalCard';
  expirationDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlConsumerUserMedicalCardInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GqlConsumerUserProfile = {
  __typename?: 'consumerUserProfile';
  birthday?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<GqlConsumerUserMedicalCard>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerifiedAt?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlConsumerUserProfileAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlConsumerUserProfileAddressType = {
  __typename?: 'consumerUserProfileAddressType';
  city?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  ln1?: Maybe<Scalars['String']['output']>;
  ln2?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlConsumerUserProfileInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<GqlConsumerUserProfileAddress>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  driversLicense?: InputMaybe<Scalars['String']['input']>;
  driversLicenseExpirationDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inStoreEnrollmentCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicalCard?: InputMaybe<GqlConsumerUserMedicalCardInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCopuonApplicableCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCouponApplicableCategory = {
  __typename?: 'couponApplicableCategory';
  category?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlCouponRestrictions = {
  __typename?: 'couponRestrictions';
  minimumPurchase?: Maybe<Scalars['Boolean']['output']>;
  minimumPurchaseInCents?: Maybe<Scalars['Int']['output']>;
  noSpecials?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlCouponRestrictionsInput = {
  minimumPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPurchaseInCents?: InputMaybe<Scalars['Int']['input']>;
  noSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCouponValidationProductInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCoupon_ApplicableCategoriesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCouponsFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlApplicableCategoryInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCouponsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCouponsSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlCreateBucketInput = {
  brandIds?: Array<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  connectionStatus?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryStatus?: InputMaybe<Scalars['String']['input']>;
  minimumConfidenceScore?: InputMaybe<Scalars['Int']['input']>;
  reviewStatus?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  thresholdFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateBucketInputV3 = {
  brandIds?: Array<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  connectionStatus?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryStatus?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  thresholdFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateCouponInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addedDate: Scalars['String']['input'];
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCopuonApplicableCategoryInput>>>;
  code: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  expDate: Scalars['String']['input'];
  fixedDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  numAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  numUses?: InputMaybe<Scalars['Int']['input']>;
  oneUsePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
};

export type GqlCustomCategoryPhotoInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCustomerExportInput = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  subscriptionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCustomerUpdateInput = {
  _id: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCustomersFilterInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCustomersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCustomersSortInput = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDayBounds = {
  __typename?: 'dayBounds';
  active?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type GqlDayBoundsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDeliveryZipCodesInput = {
  fee?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDeliveryZonesInput = {
  area?: InputMaybe<GqlPolygonInput>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensariesFilterInput = {
  acceptsCreditCardsDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsCreditCardsPickup?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsDutchiePay?: InputMaybe<Scalars['Boolean']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  cName?: InputMaybe<Scalars['String']['input']>;
  cNameOrID?: InputMaybe<Scalars['String']['input']>;
  chain?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  creditCards?: InputMaybe<Scalars['Boolean']['input']>;
  deliversToAddress?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryAddress?: InputMaybe<GqlDispensaryLocationInput>;
  destinationTaxState?: InputMaybe<Scalars['String']['input']>;
  destinationTaxZipcode?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  freeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  getIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  hostDomain?: InputMaybe<Scalars['String']['input']>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  includeStealthMode?: InputMaybe<Scalars['Boolean']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  nearLat?: InputMaybe<Scalars['Float']['input']>;
  nearLng?: InputMaybe<Scalars['Float']['input']>;
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  offerCurbsidePickup?: InputMaybe<Scalars['Boolean']['input']>;
  offerDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  offerPickup?: InputMaybe<Scalars['Boolean']['input']>;
  openForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  openForDeliveryRightNow?: InputMaybe<Scalars['Boolean']['input']>;
  openNowForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  openNowForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  recreational?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<DispensarySortByType>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryCustomerInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  ageVerified?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  textSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryDemoRequestInput = {
  dispensaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactFirstName?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactLastName?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactName?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  dispensaryPos?: InputMaybe<Scalars['String']['input']>;
  dispensaryState?: InputMaybe<Scalars['String']['input']>;
  dispensaryType?: InputMaybe<Scalars['String']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
};

export type GqlDispensaryFeatureFlagOptions = {
  enableArrivals?: InputMaybe<Scalars['Boolean']['input']>;
  enableMenuImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatch?: InputMaybe<Scalars['Boolean']['input']>;
  enableNonTerminalAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  enablePausedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  hideDeliveryEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hideStoreHours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryMessagingSettingsInput = {
  disablePushReadyForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  disablePushStartDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  disableReadyForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  disableStartDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryOnboardingInput = {
  dispensaryContactMethod?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactMethodValue?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactName?: InputMaybe<Scalars['String']['input']>;
  dispensaryDelivery?: InputMaybe<Scalars['String']['input']>;
  dispensaryLogo?: InputMaybe<Scalars['String']['input']>;
  dispensaryLogoFileId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  dispensaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dispensaryPhoto?: InputMaybe<Scalars['String']['input']>;
  dispensaryPhotoFileId?: InputMaybe<Scalars['String']['input']>;
  dispensaryPos?: InputMaybe<Scalars['String']['input']>;
  dispensaryPosOther?: InputMaybe<Scalars['String']['input']>;
  dispensarySocialEquityEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryState?: InputMaybe<Scalars['String']['input']>;
  dispensaryTypeMedical?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryTypeRecreational?: InputMaybe<Scalars['Boolean']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
};

export type GqlDispensaryPublishSpecialsPageSettingsInput = {
  dispensaryIds: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  specialsPage: GqlDispensarySpecialsPageSettingsOptions;
};

export type GqlDispensaryRemoveFromChainInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensarySpecialsPageSettingsOptions = {
  /** @deprecated Specials filter chips removed from the redesigned specials page - ECOMM-12457 2026-08-05 */
  menuFilterChips?: InputMaybe<GqlMenuFilterChipsSettingsInput>;
  showCategoryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  showSpecialDuration?: InputMaybe<Scalars['Boolean']['input']>;
  showSpecialsRedesign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryStoreSettingsOptions = {
  aiqSmsPinTriggerBehavior?: InputMaybe<Scalars['String']['input']>;
  blockOrderOnMMURAllotmentFailure?: InputMaybe<Scalars['Boolean']['input']>;
  cloudPrntAutomaticPrintingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cloudPrntEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  collapseProductDescription?: InputMaybe<Scalars['Boolean']['input']>;
  configurablePurchaseLimitsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customPurchaseLimits?: InputMaybe<Scalars['JSON']['input']>;
  customTermsText?: InputMaybe<Scalars['String']['input']>;
  defaultViewStyle?: InputMaybe<Scalars['Boolean']['input']>;
  disableAIReviewModeration?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']['input']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']['input']>;
  disableSpecialInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']['input']>;
  enableCartInterstitial?: InputMaybe<Scalars['Boolean']['input']>;
  enableConcierge?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomTerms?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscountGamification?: InputMaybe<Scalars['Boolean']['input']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']['input']>;
  enableKioskConcierge?: InputMaybe<Scalars['Boolean']['input']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  enableMMURAllotmentCheck?: InputMaybe<Scalars['Boolean']['input']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enableOrderTypeTakeoverModal?: InputMaybe<Scalars['Boolean']['input']>;
  enableOtherLocations?: InputMaybe<Scalars['Boolean']['input']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']['input']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Age verification gate feature has been removed */
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']['input']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']['input']>;
  hideCannabinoidDescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hideCategoryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  hideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSearchEngines?: InputMaybe<Scalars['Boolean']['input']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']['input']>;
  hideTotalTerpenes?: InputMaybe<Scalars['Boolean']['input']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']['input']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAgeOverrides?: InputMaybe<GqlMinimumAgeOverridesInput>;
  priceRangeFilter?: InputMaybe<GqlPriceRangeFilterSettingsInput>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']['input']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLimit?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requirePaymentMethodSelection?: InputMaybe<Scalars['Boolean']['input']>;
  requireTermsAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  restrictSalesLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer rendered or used */
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']['input']>;
  skipOnlineAgeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  specialsPage?: InputMaybe<GqlDispensarySpecialsPageSettingsOptions>;
  stealthMode?: InputMaybe<Scalars['Boolean']['input']>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStateRegulatedImageWatermarks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateCategoryLimits = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateCustomDomainSettings = {
  cloudflareDomain?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateEmbedSettings = {
  applyToAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  autoGTM?: InputMaybe<Scalars['Boolean']['input']>;
  autoScroll?: InputMaybe<Scalars['Boolean']['input']>;
  autoScrollOffset?: InputMaybe<Scalars['Int']['input']>;
  disablePageLoadsAtTop?: InputMaybe<Scalars['Boolean']['input']>;
  disableRouting?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimerText?: InputMaybe<Scalars['String']['input']>;
  disclaimerTextHtml?: InputMaybe<Scalars['String']['input']>;
  enableFullScreenEmbeddedCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  iframeCSS?: InputMaybe<Scalars['String']['input']>;
  pageCSS?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateExciseTax = {
  local?: InputMaybe<Scalars['Float']['input']>;
  medicalLocal?: InputMaybe<Scalars['Float']['input']>;
  medicalState?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensaryUpdateFeatureFlags = {
  /** @deprecated now defined per order type within BaseOrderingSettings */
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now defined per pickup order type within BaseOrderingSettings */
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated defined within CurbsidePickupOrderingSettings in ordering-settings */
  enableArrivals?: InputMaybe<Scalars['Boolean']['input']>;
  enableMenuImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatch?: InputMaybe<Scalars['Boolean']['input']>;
  enableNonTerminalAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  enablePausedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now defined per order type within BaseOrderingSettings */
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  hideDeliveryEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hideStoreHours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateFeeTiers = {
  fee?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensaryUpdateHours = {
  Friday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Monday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Saturday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Sunday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Thursday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Tuesday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Wednesday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
};

export type GqlDispensaryUpdateHoursDay = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateHoursSettingsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<GqlDispensaryUpdateHoursSettingsProfileInput>;
};

export type GqlDispensaryUpdateHoursSettingsProfileInput = {
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHours>;
  pickupHours?: InputMaybe<GqlDispensaryUpdateHours>;
  reservationConfig?: InputMaybe<GqlReservationConfigInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursInput>>>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
};

export type GqlDispensaryUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<GqlDispensaryUpdateProfileInput>;
};

export type GqlDispensaryUpdateKioskConfig = {
  anonymousCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  directedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  fullNameOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hideEmailField?: InputMaybe<Scalars['Boolean']['input']>;
  hidePhoneField?: InputMaybe<Scalars['Boolean']['input']>;
  notesField?: InputMaybe<Scalars['Boolean']['input']>;
  phoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateOptionsSettings = {
  acceptsCreditCardTips?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsDutchiePayTips?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsTips?: InputMaybe<Scalars['Boolean']['input']>;
  embedSettings?: InputMaybe<GqlDispensaryUpdateEmbedSettings>;
  featureFlags?: InputMaybe<GqlDispensaryFeatureFlagOptions>;
  messagingSettings?: InputMaybe<GqlDispensaryMessagingSettingsInput>;
  orderStatusEmailSettings?: InputMaybe<GqlOrderStatusEmailSettingsInput>;
  ordersConfig?: InputMaybe<GqlDispensaryUpdateOrdersConfig>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  removeMedicalCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicense?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicenseExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicenseForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  storeSettings?: InputMaybe<GqlDispensaryStoreSettingsOptions>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateOptionsSettingsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  updatedSettings?: InputMaybe<GqlDispensaryUpdateOptionsSettings>;
};

export type GqlDispensaryUpdateOrderTypeConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
};

export type GqlDispensaryUpdateOrderTypesConfig = {
  curbsidePickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  delivery?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  driveThruPickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  kiosk?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  pickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
};

export type GqlDispensaryUpdateOrdersConfig = {
  autoClose?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  posItemNames?: InputMaybe<Scalars['Boolean']['input']>;
  terminalReceiptOptions?: InputMaybe<GqlDispensaryUpdateTerminalReceiptOptions>;
};

export type GqlDispensaryUpdatePaymentFees = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdatePaymentTypeConfig = {
  aeropay?: InputMaybe<Scalars['Boolean']['input']>;
  alt36?: InputMaybe<Scalars['Boolean']['input']>;
  canPay?: InputMaybe<Scalars['Boolean']['input']>;
  cash?: InputMaybe<Scalars['Boolean']['input']>;
  check?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardAtDoor?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardByPhone?: InputMaybe<Scalars['Boolean']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  dutchiePay?: InputMaybe<Scalars['Boolean']['input']>;
  linx?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineChase?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineHypur?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineMerrco?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineMoneris?: InputMaybe<Scalars['Boolean']['input']>;
  paytender?: InputMaybe<Scalars['Boolean']['input']>;
  rethinkPay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdatePlusSettings = {
  checkoutUrl?: InputMaybe<Scalars['String']['input']>;
  defaultReturnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateProfileInput = {
  SpecialLogoImage?: InputMaybe<Scalars['String']['input']>;
  acceptsDutchiePayTips?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsTips?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  aeropay?: InputMaybe<Scalars['Boolean']['input']>;
  ageVerificationBannerColor?: InputMaybe<Scalars['String']['input']>;
  ageVerificationBannerHtml?: InputMaybe<Scalars['String']['input']>;
  alt36?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  brandedDutchiePayEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brandedDutchiePayLogoDark?: InputMaybe<Scalars['String']['input']>;
  brandedDutchiePayLogoLight?: InputMaybe<Scalars['String']['input']>;
  brandedDutchiePayName?: InputMaybe<Scalars['String']['input']>;
  canPay?: InputMaybe<Scalars['Boolean']['input']>;
  cashOnly?: InputMaybe<Scalars['Boolean']['input']>;
  cashless?: InputMaybe<Scalars['Boolean']['input']>;
  categoryLimits?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateCategoryLimits>>>;
  categoryLimitsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  categoryPhotos?: InputMaybe<Array<InputMaybe<GqlCategoryPhotoInput>>>;
  chain?: InputMaybe<Scalars['String']['input']>;
  check?: InputMaybe<Scalars['Boolean']['input']>;
  colorSettings?: InputMaybe<GqlColorSettingsInput>;
  creditCardAtDoor?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardByPhone?: InputMaybe<Scalars['Boolean']['input']>;
  customCategoryPhotos?: InputMaybe<Array<InputMaybe<GqlCustomCategoryPhotoInput>>>;
  customDomainSettings?: InputMaybe<GqlDispensaryUpdateCustomDomainSettings>;
  debitOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHours>;
  deliveryMin?: InputMaybe<Scalars['String']['input']>;
  deliveryMode?: InputMaybe<DeliveryModes>;
  deliveryZipCodes?: InputMaybe<Array<InputMaybe<GqlDeliveryZipCodesInput>>>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationEstimateOverrides?: InputMaybe<GqlDurationEstimatesInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  embedBackUrl?: InputMaybe<Scalars['String']['input']>;
  embedSettings?: InputMaybe<GqlDispensaryUpdateEmbedSettings>;
  embeddedLogoImage?: InputMaybe<Scalars['String']['input']>;
  embeddedMenuUrl?: InputMaybe<Scalars['String']['input']>;
  exciseTax?: InputMaybe<GqlDispensaryUpdateExciseTax>;
  exclusiveExciseTax?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<GqlDispensaryUpdateFeatureFlags>;
  feeTiers?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateFeeTiers>>>;
  hideFromCCT?: InputMaybe<Scalars['Boolean']['input']>;
  hypur?: InputMaybe<Scalars['Boolean']['input']>;
  includeSalesTaxInMenu?: InputMaybe<Scalars['Boolean']['input']>;
  inclusiveSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated defined in ordering-settings in KioskOrderingSettings */
  kioskConfig?: InputMaybe<GqlDispensaryUpdateKioskConfig>;
  /** @deprecated set as notes field in KioskOrderingSettings */
  kioskInstructions?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated defined in ordering-settings within KioskOrderingSettings */
  kioskOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linx?: InputMaybe<Scalars['Boolean']['input']>;
  listImage?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<Scalars['String']['input']>;
  maxDeliveryDistance?: InputMaybe<Scalars['Float']['input']>;
  medSubjectToExciseTax?: InputMaybe<Scalars['Boolean']['input']>;
  medicalDispensary?: InputMaybe<Scalars['Boolean']['input']>;
  menuBannerColor?: InputMaybe<Scalars['String']['input']>;
  menuBannerHtml?: InputMaybe<Scalars['String']['input']>;
  menuBannerTextBannerCollapsed?: InputMaybe<Scalars['Boolean']['input']>;
  menuOrder?: InputMaybe<Scalars['String']['input']>;
  menuUrl?: InputMaybe<Scalars['String']['input']>;
  menuWeights?: InputMaybe<Scalars['String']['input']>;
  messagingSettings?: InputMaybe<GqlDispensaryMessagingSettingsInput>;
  mixAndMatchPricingWeights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerCurbsidePickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerDriveThruPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  orderTypesConfig?: InputMaybe<GqlDispensaryUpdateOrderTypesConfig>;
  ordersConfig?: InputMaybe<GqlDispensaryUpdateOrdersConfig>;
  payInStore?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineHypur?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineMerrco?: InputMaybe<Scalars['Boolean']['input']>;
  paymentFees?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdatePaymentFees>>>;
  paytender?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  pickupHours?: InputMaybe<GqlDispensaryUpdateHours>;
  /** @deprecated moved to OrderMinimumInput */
  pickupMinimum?: InputMaybe<GqlPickupMinimumInput>;
  plusSettings?: InputMaybe<GqlDispensaryUpdatePlusSettings>;
  printedMenuSettings?: InputMaybe<GqlPrintedMenuSettingsInput>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  recDispensary?: InputMaybe<Scalars['Boolean']['input']>;
  removeMedicalCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicense?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicenseExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicenseForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to ReservationSlotsUpdateInput */
  reservationConfig?: InputMaybe<GqlReservationConfigInput>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursInput>>>;
  specialsSettings?: InputMaybe<GqlSpecialsSettingsInput>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
  taxCalculationMethod?: InputMaybe<Scalars['String']['input']>;
  taxConfig?: InputMaybe<GqlDispensaryUpdateTaxConfig>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateStatusInput = {
  dispensaryId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type GqlDispensaryUpdateStoreSettings = {
  aiqSmsPinTriggerBehavior?: InputMaybe<Scalars['String']['input']>;
  blockOrderOnMMURAllotmentFailure?: InputMaybe<Scalars['Boolean']['input']>;
  cloudPrntAutomaticPrintingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cloudPrntEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  collapseProductDescription?: InputMaybe<Scalars['Boolean']['input']>;
  configurablePurchaseLimitsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customPurchaseLimits?: InputMaybe<Scalars['JSON']['input']>;
  customTermsText?: InputMaybe<Scalars['String']['input']>;
  customerMessagingTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  defaultViewStyle?: InputMaybe<MenuViewStyles>;
  disableAIReviewModeration?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']['input']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']['input']>;
  disableSpecialInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableAfterHoursOrderingForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enableCartInterstitial?: InputMaybe<Scalars['Boolean']['input']>;
  enableConcierge?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomTerms?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscountGamification?: InputMaybe<Scalars['Boolean']['input']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']['input']>;
  enableKioskConcierge?: InputMaybe<Scalars['Boolean']['input']>;
  enableLLxSaleDiscountSync?: InputMaybe<Scalars['Boolean']['input']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  enableMMURAllotmentCheck?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatchPricingForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatchPricingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enableOrderTypeTakeoverModal?: InputMaybe<Scalars['Boolean']['input']>;
  enableOtherLocations?: InputMaybe<Scalars['Boolean']['input']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableScheduledOrderingForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableScheduledOrderingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Age verification gate feature has been removed */
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']['input']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']['input']>;
  hideCannabinoidDescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hideCategoryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  hideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSearchEngines?: InputMaybe<Scalars['Boolean']['input']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']['input']>;
  hideTotalTerpenes?: InputMaybe<Scalars['Boolean']['input']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']['input']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAgeOverrides?: InputMaybe<GqlMinimumAgeOverridesInput>;
  priceRangeFilter?: InputMaybe<GqlPriceRangeFilterSettingsInput>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']['input']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLimit?: InputMaybe<Scalars['Int']['input']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requirePaymentMethodSelection?: InputMaybe<Scalars['Boolean']['input']>;
  requireTermsAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  restrictSalesLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  rewardsIntegrationConfiguration?: InputMaybe<GqlRewards_Integration_ConfigurationInput>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer rendered or used */
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']['input']>;
  skipOnlineAgeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  specialsPage?: InputMaybe<GqlDispensarySpecialsPageSettingsOptions>;
  stealthMode?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptions?: InputMaybe<GqlDispensaries_SubscriptionsInput>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStateRegulatedImageWatermarks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateTaxConfig = {
  calculationMethod?: InputMaybe<Scalars['String']['input']>;
  discountTaxOrder?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateTaxConfigTaxes>>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlDispensaryUpdateTaxConfigTaxApplyTo = {
  hemp?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlDispensaryUpdateTaxConfigTaxStage = {
  op?: InputMaybe<Dispensaries_TaxConfig_Tax_Stage_Ops>;
  type?: InputMaybe<Dispensaries_TaxConfig_Tax_Stage_Types>;
};

export type GqlDispensaryUpdateTaxConfigTaxes = {
  applyTo?: InputMaybe<GqlDispensaryUpdateTaxConfigTaxApplyTo>;
  deliveryPolicy?: InputMaybe<DeliveryPolicy>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeStateSalesTaxInDestinationRate?: InputMaybe<Scalars['Boolean']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  potency?: InputMaybe<PotencyType>;
  potencyRate?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  recreational?: InputMaybe<Scalars['Boolean']['input']>;
  stages?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateTaxConfigTaxStage>>>;
  taxBasis?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaxType>;
};

export type GqlDispensaryUpdateTerminalReceiptOptions = {
  birthdate?: InputMaybe<Scalars['Boolean']['input']>;
  customerNameOption?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  disableSocialImpact?: InputMaybe<Scalars['Boolean']['input']>;
  enableSurveyQrCode?: InputMaybe<Scalars['Boolean']['input']>;
  groupLineItemsBy?: InputMaybe<Scalars['String']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  potencyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  sortLineItemsBy?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUserStreamTokenInput = {
  dispensaryId: Scalars['String']['input'];
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDurationEstimateRangeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  highInMinutes?: InputMaybe<Scalars['Int']['input']>;
  lowInMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlDurationEstimatesInput = {
  delivery?: InputMaybe<GqlDurationEstimateRangeInput>;
  pickup?: InputMaybe<GqlDurationEstimateRangeInput>;
};

export type GqlEndSpecialsInput = {
  dispensaryId: Scalars['String']['input'];
  ids: Array<InputMaybe<Scalars['String']['input']>>;
  source?: InputMaybe<SpecialSource>;
  triggeredByIntegration: Scalars['Boolean']['input'];
};

export type GqlExportCustomerReportInput = {
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  lastOrder?: InputMaybe<Scalars['String']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlExportOrderReportInput = {
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['ISODate']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISODate']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlFeeDonationInput = {
  feeDonationId: Scalars['Int']['input'];
};

export type GqlFilteredSpecialsInput = {
  current?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  excludeSourcePOS?: InputMaybe<Scalars['Boolean']['input']>;
  past?: InputMaybe<Scalars['Boolean']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<Scalars['String']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sortInput?: InputMaybe<GqlSpecialsSortInput>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlFilteredSpecialsInputV2 = {
  pageInput?: InputMaybe<GqlSpecialsPageInput>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sortInput?: InputMaybe<Array<InputMaybe<GqlSpecialsSortInputV2>>>;
  source?: InputMaybe<SpecialSource>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<SpecialTemporalStatus>;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlGetDeliveryInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGetDispensariesAdSettingsByMenuVariantInput = {
  adsEnabledMenuVariant: Scalars['String']['input'];
};

export type GqlGetDispensariesByPersonalizationSettingsInput = {
  personalizationEnabledMenuVariant: Scalars['String']['input'];
};

export type GqlGetOrdersInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<GqlDateRange>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderTypes>;
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<GqlGetOrderSortInput>;
  status?: InputMaybe<OrderQueryStatuses>;
};

export type GqlGetTimezoneResult = {
  __typename?: 'getTimezoneResult';
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlGuestCustomerInput = {
  birthDay?: InputMaybe<Scalars['String']['input']>;
  birthMonth?: InputMaybe<Scalars['String']['input']>;
  birthYear?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  termsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlImageUploadInput = {
  image?: InputMaybe<Scalars['String']['input']>;
};

export type GqlImageUrl = {
  __typename?: 'imageUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlIncrementClicksInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
};

export type GqlInitiatePayByBankInput = {
  orderId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  updateOrderToken: Scalars['String']['input'];
};

export type GqlIntegrationCredsInput = {
  adHoc1?: InputMaybe<Scalars['String']['input']>;
  dispensary?: InputMaybe<Scalars['String']['input']>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type GqlListBrandsFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlListBrandsSort = {
  sortBy?: InputMaybe<ListBrandsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlListLibraryProductsFilters = {
  status: LibraryProductStatusEnum;
};

export type GqlListLibraryProductsSort = {
  sortBy?: InputMaybe<ListLibraryProductsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMarkOrderAutoPrintedInput = {
  autoPrintSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMarkOrderPosFailedInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMarkOrderPrintedInput = {
  action?: InputMaybe<PrintAction>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  durationInMs?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  printId?: InputMaybe<Scalars['String']['input']>;
  printerPreviouslyConnected?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlMarkOrdersBatchPrintedInput = {
  action?: InputMaybe<PrintAction>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMedicalCardInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum MenuPricingTypes {
  med = 'med',
  rec = 'rec'
}

export type GqlMenuSectionBulkUpdateInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId: Scalars['String']['input'];
  headingOverride?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<GqlUpdateImageBannerInput>;
  mobileAppDisplayType?: InputMaybe<MobileAppProductCollectionDisplayType>;
  mobileAppFlairType?: InputMaybe<MobileAppFlair>;
  position: Scalars['Int']['input'];
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  sectionType: MenuSectionType;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMenuSectionCreateInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId: Scalars['String']['input'];
  headingOverride?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<GqlUpdateImageBannerInput>;
  mobileAppDisplayType?: InputMaybe<MobileAppProductCollectionDisplayType>;
  mobileAppFlairType?: InputMaybe<MobileAppFlair>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  sectionType: MenuSectionType;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMenuSectionUpdateInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  headingOverride?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<GqlUpdateImageBannerInput>;
  mobileAppDisplayType?: InputMaybe<MobileAppProductCollectionDisplayType>;
  mobileAppFlairType?: InputMaybe<MobileAppFlair>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  sectionType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMonerisInput = {
  bin?: InputMaybe<Scalars['String']['input']>;
  cardToken?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrderStatusEmailSettingsInput = {
  disableConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  disableOutForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaymentError?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaymentLifecycle?: InputMaybe<Scalars['Boolean']['input']>;
  disableReadyForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  disableSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderStatuses {
  closed = 'closed',
  confirmed = 'confirmed',
  inTransit = 'inTransit',
  open = 'open'
}

export type GqlOrdersCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  appliedRewards?: InputMaybe<Array<InputMaybe<GqlRewardInput>>>;
  bypassCanadaDeliveryTax?: InputMaybe<Scalars['Boolean']['input']>;
  channelSource?: InputMaybe<ChannelSources>;
  checkoutId?: InputMaybe<Scalars['String']['input']>;
  checkoutToken?: InputMaybe<Scalars['String']['input']>;
  considerPayerForIncentives?: InputMaybe<Scalars['Boolean']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  customerState?: InputMaybe<Scalars['String']['input']>;
  deliveryOption: Scalars['Boolean']['input'];
  destinationTerminal?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverNumber?: InputMaybe<Scalars['String']['input']>;
  driversLicense?: InputMaybe<Scalars['String']['input']>;
  driversLicenseExpirationDate?: InputMaybe<Scalars['String']['input']>;
  dutchiePaySessionToken?: InputMaybe<Scalars['String']['input']>;
  embedded?: InputMaybe<Scalars['Boolean']['input']>;
  expectedTotal?: InputMaybe<Scalars['Float']['input']>;
  feeDonations?: InputMaybe<Array<GqlFeeDonationInput>>;
  guestCustomer?: InputMaybe<GqlGuestCustomerInput>;
  hypurAccessToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  isAfterHoursOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCurbsidePickupOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isDriveThruPickupOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isGuestOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskPhoneOnlySignup?: InputMaybe<Scalars['Boolean']['input']>;
  isPTPOT?: InputMaybe<Scalars['Boolean']['input']>;
  isPreviewOrder?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GqlLocationInput>;
  loyaltyPointsApplied?: InputMaybe<Scalars['Float']['input']>;
  manualDiscount?: InputMaybe<GqlUpdateCouponInput>;
  medicalCard?: InputMaybe<GqlMedicalCardInput>;
  medicalOrder: Scalars['Boolean']['input'];
  mixAndMatch?: InputMaybe<Scalars['Float']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  monerisInput?: InputMaybe<GqlMonerisInput>;
  originKioskId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paysafeInput?: InputMaybe<GqlPaysafeInput>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<PlatformType>;
  posCustomerId?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<PreOrderType>;
  products: Array<GqlProductsInput>;
  reservation?: InputMaybe<GqlOrderReservationInput>;
  reservationType?: InputMaybe<Scalars['String']['input']>;
  rewardPin?: InputMaybe<Scalars['String']['input']>;
  roundupForCharityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  saveGuestInfo?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingData?: InputMaybe<GqlOrderSchedulingDataInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  tip?: InputMaybe<Array<InputMaybe<GqlTipInput>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  utmData?: InputMaybe<GqlUtmDataInput>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  variantSource?: InputMaybe<Scalars['String']['input']>;
  voiceCallInfo?: InputMaybe<GqlVoiceCallInfoInput>;
};

export type GqlOrdersFilterInput = {
  destinationTerminal?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  getDeliveryOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getKioskOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<OrderStatuses>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrdersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlOrdersSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: StringSortDirections;
};

export type GqlOrdersStatusUpdateInput = {
  closedByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  driverEmail?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  noNotification?: InputMaybe<Scalars['Boolean']['input']>;
  noText?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
};

export enum Orders_CancellationReasonIDs {
  badinfo = 'BADINFO',
  cancelled = 'CANCELLED',
  complianceviolation = 'COMPLIANCEVIOLATION',
  noidentification = 'NOIDENTIFICATION',
  nopayment = 'NOPAYMENT',
  nopickup = 'NOPICKUP',
  other = 'OTHER',
  soldout = 'SOLDOUT'
}

export type GqlPagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
};

export type GqlPaysafeInput = {
  token?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPermissionsInput = {
  allLocations?: InputMaybe<Scalars['Boolean']['input']>;
  analytics?: InputMaybe<Scalars['Boolean']['input']>;
  billing?: InputMaybe<Scalars['Boolean']['input']>;
  customers?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driver?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  menu?: InputMaybe<Scalars['Boolean']['input']>;
  menuReview?: InputMaybe<Scalars['Boolean']['input']>;
  messaging?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Scalars['Boolean']['input']>;
  promote?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['Boolean']['input']>;
  superMenuReview?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  users?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPriceRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlPrintOrderInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrintedMenuSettingsInput = {
  Branding?: InputMaybe<GqlPrintedMenuSettings_BrandingInput>;
  Categories?: InputMaybe<Array<InputMaybe<GqlPrintedMenuSettings_CategoryEntryInput>>>;
  FooterText?: InputMaybe<GqlPrintedMenuSettings_TextInput>;
  HeaderText?: InputMaybe<GqlPrintedMenuSettings_TextInput>;
  MenuType?: InputMaybe<GqlPrintedMenuSettings_TypeInput>;
  Order?: InputMaybe<GqlPrintedMenuSettings_TypeInput>;
  PageBreaks?: InputMaybe<GqlPrintedMenuSettings_PageBreaksInput>;
  Photos?: InputMaybe<GqlPrintedMenuSettings_PhotosInput>;
  PricingDisplay?: InputMaybe<GqlPrintedMenuSettings_PricingDisplayInput>;
  StrainTypes?: InputMaybe<Array<InputMaybe<GqlPrintedMenuSettings_StrainTypesEntryInput>>>;
};

export type GqlProductCreateInput = {
  AdditionalOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlProductsPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DispensaryID?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlProductsPotencyInput>;
  _id?: InputMaybe<Scalars['String']['input']>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandDescription?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  cName?: InputMaybe<Scalars['String']['input']>;
  cannabinoidsV2?: InputMaybe<Array<InputMaybe<GqlProducts_CannabinoidInputV2>>>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  featured?: InputMaybe<GqlProducts_FeaturedInput>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<InputMaybe<GqlProducts_LimitPerCustomerInput>>>;
  manualInventory?: InputMaybe<Array<InputMaybe<GqlProducts_ManualInventoryInput>>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  medicalSpecialPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  originalPrices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overrides?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pastCNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preCropImage?: InputMaybe<Scalars['String']['input']>;
  qaRejectionReason?: InputMaybe<Scalars['String']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  recSpecialPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  score?: InputMaybe<Scalars['Float']['input']>;
  special?: InputMaybe<Scalars['Boolean']['input']>;
  stockImage?: InputMaybe<Scalars['String']['input']>;
  stockImageAliases?: InputMaybe<Scalars['String']['input']>;
  stockImageCategory?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<InputMaybe<GqlProducts_TerpeneInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum ProductsFilterByOption {
  highCbd = 'highCBD',
  highPotency = 'highPotency',
  newProducts = 'newProducts'
}

export type GqlProductsFilterInput = {
  CBDContent?: InputMaybe<GqlProductsPotencyInput>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlProductsPotencyInput>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bypassKioskThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  bypassSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  bypassThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  cName?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  /**
   * URL-normalized effect names (lowercase, separators stripped). Products match when
   * their effects object carries the effect with a positive value. Combined effects are
   * OR'd together, matching the marketplace's previous client-side filter semantics.
   */
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedStrainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterBy?: InputMaybe<ProductsFilterByOption>;
  ignoreQuantityThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultSort?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minRating?: InputMaybe<Scalars['Float']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Products whose effective (special-if-active, else standard) price for the displayed option
   * falls within [min, max). Either bound may be omitted.
   */
  priceRange?: InputMaybe<GqlPriceRangeInput>;
  pricingType?: InputMaybe<MenuPricingTypes>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  removeProductsBelowOptionThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  sponsoredProductsInventoryId?: InputMaybe<SponsoredProductsInventoryId>;
  sponsoredProductsLimit?: InputMaybe<Scalars['Int']['input']>;
  staffPicks?: InputMaybe<Scalars['Boolean']['input']>;
  strainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terpenes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlProductsInput = {
  AdditionalOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  additionalOption?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
  rawOption?: InputMaybe<Scalars['String']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  special?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProductsPotencyInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  unit: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlQueryInfoType = {
  __typename?: 'queryInfoType';
  perPage?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type GqlResetPasswordInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSalesOrdersQueryResponse = {
  __typename?: 'salesOrdersQueryResponse';
  ordersByDate?: Maybe<Array<Maybe<GqlAnalyticsOrdersByDate>>>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  revenueChange?: Maybe<Scalars['Float']['output']>;
  totalOrders?: Maybe<Scalars['Float']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlSearchBrandsFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  hasCollisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  localAndGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  missingDescription?: InputMaybe<Scalars['Boolean']['input']>;
  missingLogo?: InputMaybe<Scalars['Boolean']['input']>;
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
};

export type GqlSearchBrandsSort = {
  sortBy: BrandSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSearchLibraryProductsFilters = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['ISODateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['ISODateTime']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  stateLibrary?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LibraryProductStatusEnum>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByBrand?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlSearchLibraryProductsSort = {
  sortBy: LibraryProductSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSetPasswordInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['Int']['input'];
};

export type GqlSpecialHoursDayInput = {
  date: Scalars['String']['input'];
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  pickupHours?: InputMaybe<GqlDispensaryUpdateHoursDay>;
};

export type GqlSpecialHoursInput = {
  endDate: Scalars['String']['input'];
  hoursPerDay?: InputMaybe<Array<InputMaybe<GqlSpecialHoursDayInput>>>;
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GqlSpecialsInputRecurring = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  setEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialsPageInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlSpecialsSortInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};

export type GqlSpecialsSortInputV2 = {
  direction: Scalars['Int']['input'];
  key: SpecialSortKey;
};

export type GqlStrainInput = {
  aromas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  potentialHealthBenefits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ratio?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlStrainsFilterInput = {
  missingDescription?: InputMaybe<Scalars['Boolean']['input']>;
  missingImage?: InputMaybe<Scalars['Boolean']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlStrainsSortInput = {
  sortBy: StrainSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSubscriptionsFilterInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSuperAdminCustomersFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSuperProductsInput = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  connectionStatus: Scalars['String']['input'];
  dispensaryID?: InputMaybe<Scalars['String']['input']>;
  dispensaryState?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  productStatus: Scalars['String']['input'];
  reviewed?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  thresholdFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GqlTerpeneInput = {
  aliasList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aromas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  potentialHealthBenefits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlTerpenesFilter = {
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlTerpenesSort = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlTipInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlUnsubscribeDispensaryCustomersInput = {
  _id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispensaryId: Scalars['String']['input'];
};

export type GqlUpdateCouponInput = {
  _id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCopuonApplicableCategoryInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  expDate?: InputMaybe<Scalars['String']['input']>;
  fixedDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  numAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  numUses?: InputMaybe<Scalars['Int']['input']>;
  oneUsePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlUpdateDeviceInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<GqlDevice_Config_Input>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateDispensaryAdSettingsInput = {
  adsEnabledMenuVariant: Scalars['String']['input'];
  disableGroup: Array<InputMaybe<Scalars['String']['input']>>;
  enableGroup: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GqlUpdateDispensaryPersonalizationSettingsInput = {
  disableGroup: Array<InputMaybe<Scalars['String']['input']>>;
  enableGroup: Array<InputMaybe<Scalars['String']['input']>>;
  personalizationEnabledMenuVariant: Scalars['String']['input'];
};

export type GqlUpdateDispensaryPrintedMenuSettingsV2Input = {
  id: Scalars['String']['input'];
  settings: Scalars['JSON']['input'];
};

export type GqlUpdateKioskOrderPaymentInput = {
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  tipCents?: InputMaybe<Scalars['Int']['input']>;
  updateOrderToken: Scalars['String']['input'];
};

export type GqlUpdateOrderPaymentInput = {
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  tipCents?: InputMaybe<Scalars['Int']['input']>;
  updateOrderToken: Scalars['String']['input'];
};

export type GqlUpdateProductSortInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuOrder?: InputMaybe<Scalars['String']['input']>;
  menuSortSetting?: InputMaybe<GqlMenuSortSettingInput>;
  sortProductProxies?: InputMaybe<Array<InputMaybe<GqlSortProductProxy>>>;
};

export type GqlUpdateSingleDispensaryAdSettingsInput = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryAdSettingsInput;
};

export type GqlUpdateSingleDispensaryPersonalizationSettingsInput = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};

export type GqlUserIdExistsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUsersCreateInput = {
  chain?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  legacyChain?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<GqlPermissionsInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUsersDeleteInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUsersFilterInput = {
  chainID?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Scalars['Boolean']['input']>;
  superadmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUsersUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  audioNotificationsOnNewArrivalsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  audioNotificationsOnNewOrdersDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  browserNotification?: InputMaybe<Scalars['Boolean']['input']>;
  chain?: InputMaybe<Scalars['String']['input']>;
  desktopNotification?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isWeeklyReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  legacyChain?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<GqlPermissionsInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUtmDataInput = {
  dtm_campaign?: InputMaybe<Scalars['String']['input']>;
  dtm_content?: InputMaybe<Scalars['String']['input']>;
  dtm_medium?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type GqlV4Condition = {
  __typename?: 'v4Condition';
  conditionType?: Maybe<ConditionType>;
  exclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  groupBySku?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeCannabis?: Maybe<Scalars['Boolean']['output']>;
  inclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  thresholds?: Maybe<Array<Maybe<GqlThreshold>>>;
};

export type GqlV4ConditionInput = {
  conditionType?: InputMaybe<ConditionType>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  groupBySku?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeCannabis?: InputMaybe<Scalars['Boolean']['input']>;
  inclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  thresholds?: InputMaybe<Array<InputMaybe<GqlThresholdInput>>>;
};

export type GqlV4Restriction = {
  __typename?: 'v4Restriction';
  brandId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inventoryTag?: Maybe<Scalars['String']['output']>;
  matchOperator?: Maybe<Scalars['String']['output']>;
  pricingTierId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productTag?: Maybe<Scalars['String']['output']>;
  restrictionType?: Maybe<RestrictionType>;
  strainId?: Maybe<Scalars['String']['output']>;
  subcategoryId?: Maybe<Scalars['String']['output']>;
  subcategoryName?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<GqlWeight>;
};

export type GqlV4RestrictionInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inventoryTag?: InputMaybe<Scalars['String']['input']>;
  matchOperator?: InputMaybe<Scalars['String']['input']>;
  pricingTierId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productTag?: InputMaybe<Scalars['String']['input']>;
  restrictionType?: InputMaybe<RestrictionType>;
  strainId?: InputMaybe<Scalars['String']['input']>;
  subcategoryId?: InputMaybe<Scalars['String']['input']>;
  subcategoryName?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<GqlWeightInput>;
};

export type GqlV4Reward = {
  __typename?: 'v4Reward';
  amountOff?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<DiscountType>;
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  exclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  groupBySku?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeNonCannabis?: Maybe<Scalars['Boolean']['output']>;
  inclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  percentDiscount?: Maybe<Scalars['Float']['output']>;
  rangeBehavior?: Maybe<RangeBehaviors>;
  rewardType?: Maybe<RewardType>;
  thresholds?: Maybe<Array<Maybe<GqlThreshold>>>;
};

export type GqlV4RewardInput = {
  amountOff?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountedPrice?: InputMaybe<Scalars['Int']['input']>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  groupBySku?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeNonCannabis?: InputMaybe<Scalars['Boolean']['input']>;
  inclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  rangeBehavior?: InputMaybe<RangeBehaviors>;
  rewardType?: InputMaybe<RewardType>;
  thresholds?: InputMaybe<Array<InputMaybe<GqlThresholdInput>>>;
};

export type GqlV4Special = {
  __typename?: 'v4Special';
  allowedUsesPerUser?: Maybe<Scalars['Int']['output']>;
  applicableToItemsOnSpecial?: Maybe<Scalars['Boolean']['output']>;
  applicationMethod?: Maybe<SpecialApplicationMethodTypes>;
  cipher?: Maybe<Scalars['JSON']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  conditionLogicOperator?: Maybe<LogicOperator>;
  conditions?: Maybe<Array<Maybe<GqlV4Condition>>>;
  consumerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  dispensaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<GqlSpecialEmail>;
  endedAt?: Maybe<Scalars['ISODateTime']['output']>;
  endedBy?: Maybe<Scalars['String']['output']>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  enterpriseSpecialId?: Maybe<Scalars['String']['output']>;
  firstTimeConsumerOnly?: Maybe<Scalars['Boolean']['output']>;
  generatedByPOS?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactiveDispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isAvailableOnline?: Maybe<Scalars['Boolean']['output']>;
  loyaltyPointsToRedeem?: Maybe<Scalars['Int']['output']>;
  manualDefaultApplyTo?: Maybe<ManualDefaultApplyTo>;
  menuDisplay?: Maybe<GqlSpecialMenuDisplay>;
  menuType?: Maybe<SpecialMenuType>;
  name?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<OrderType>;
  origin?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  quantityUsed?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerCart?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']['output']>;
  reimbursed?: Maybe<Scalars['Boolean']['output']>;
  requireManagerApproval?: Maybe<Scalars['Boolean']['output']>;
  rewardLogicOperator?: Maybe<LogicOperator>;
  rewards?: Maybe<Array<Maybe<GqlV4Reward>>>;
  schedule?: Maybe<GqlSpecialSchedule>;
  scope?: Maybe<Scalars['String']['output']>;
  specialType?: Maybe<SpecialType>;
  specialVersion?: Maybe<Scalars['Int']['output']>;
  stackingBehavior?: Maybe<StackingBehavior>;
  status?: Maybe<SpecialStatus>;
  totalAllowedUses?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlBrandDispensaryFragmentFragment = { __typename?: 'Brand', dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null };

export type GqlBrandFragmentForDropdownFragment = { __typename?: 'Brand', _id: string, id: string, name: string, imageUrl?: string | null };

export type GqlBrandFragmentFragment = { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null };

export type GqlCreateBrandMutationVariables = Exact<{
  brand: GqlBrandInput;
}>;


export type GqlCreateBrandMutation = { __typename?: 'Mutation', createBrandV2?: { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null } | null };

export type GqlDeleteBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteBrandMutation = { __typename?: 'Mutation', deleteBrand?: { __typename?: 'Brand', _id: string } | null };

export type GqlUpdateBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
  brand: GqlBrandInput;
}>;


export type GqlUpdateBrandMutation = { __typename?: 'Mutation', updateBrandV2?: { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null } | null };

export type GqlBrandsForDropdownQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  localAndGlobal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlBrandsForDropdownQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', isGlobal: boolean, _id: string, id: string, name: string, imageUrl?: string | null } | null> } | null };

export type GqlGetBrandRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetBrandRegionsQuery = { __typename?: 'Query', listRegions: Array<{ __typename?: 'Region', id: string, code: string, country: string, subdivision?: string | null, countryName?: string | null, subdivisionName?: string | null } | null> };

export type GqlGetBrandQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetBrandQuery = { __typename?: 'Query', getBrand?: { __typename?: 'Brand', isGlobal: boolean, source?: string | null, creatorUserId?: string | null, parentBrandId?: string | null, _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null, regions?: Array<{ __typename?: 'Region', id: string, code: string, country: string, subdivision?: string | null, countryName?: string | null, subdivisionName?: string | null }> | null, dispensary?: { __typename?: 'Dispensaries', name?: string | null, id: string } | null, enterprise?: { __typename?: 'Enterprise', id: string, name: string } | null } | null };

export type GqlSuperBrandsIndexQueryVariables = Exact<{
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
}>;


export type GqlSuperBrandsIndexQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null } | null>, queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlBucketListFragmentFragment = { __typename?: 'Bucket', checkedOutAt?: any | null, completedReviewsCount?: number | null, id: string, name: string, productsCount: number, teamName: string, createdBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type GqlComputeWithPriceCartV2MutationVariables = Exact<{
  priceCartInput: GqlCalculationsInput;
}>;


export type GqlComputeWithPriceCartV2Mutation = { __typename?: 'Mutation', computeWithPriceCartV2?: { __typename?: 'CalculationResults', subTotal?: number | null, taxes?: number | null, discount?: number | null, originalTotal?: number | null, roundedDifference?: number | null, grandTotal?: number | null, loyaltyPointsUsed?: number | null, totalSalesTax?: number | null, totalCannabisTax?: number | null, totalBottleDepositTax?: number | null, taxInclusivePricing?: boolean | null, loyaltyAppliedAsDiscount?: number | null, discountWithoutLoyalty?: number | null, posCustomerId?: number | null, resolvedZoneIds?: Array<number> | null, itemTaxes?: Array<{ __typename?: 'ItemTax', taxAmount?: number | null, taxType?: string | null, productId?: number | null, feeItemId?: number | null, showOnMenu?: boolean | null, showOnCheckout?: boolean | null } | null> | null, cartItemPrices?: Array<{ __typename?: 'CartItem', productName?: string | null, productId?: number | null, quantity?: number | null, subtotal?: number | null, unitPrice?: number | null, pricingTierAdjustment?: number | null, pricingTierAdjustmentTotal?: number | null, summaryPrice?: number | null, menuPrice?: number | null, cartPrice?: number | null, checkoutPrice?: number | null, specialCartPrice?: number | null, specialCheckoutPrice?: number | null, tax?: number | null, unitWeightGrams?: number | null, productType?: string | null, ecommKey?: string | null, discounts?: Array<{ __typename?: 'Discount', name?: string | null, amount?: number | null, discountId?: number | null, applicationMethod?: string | null, calculationMethod?: DiscountCalculationMethod | null, isLoyaltyReward?: boolean | null, isPaymentIncentive?: boolean | null, isRestricted?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null } | null> | null } | null> | null, fees?: Array<{ __typename?: 'Fees', feeItemId?: number | null, feeAmount?: number | null, feeName?: string | null, deliveryFee?: boolean | null, paymentFee?: boolean | null } | null> | null, rewardValidationErrors?: Array<{ __typename?: 'RewardValidationError', discountCode?: string | null, discountId?: number | null, message?: string | null } | null> | null, discountGamification?: { __typename?: 'CalculationResults_CartGamification', gamificationDetails?: Array<{ __typename?: 'GamificationDetailItem', discountId?: number | null, meetsAllConstraints?: boolean | null, satisfiers?: Array<{ __typename?: 'GamificationDetailItem_Satisfier', thresholdMet?: boolean | null, thresholdType?: string | null, minimumThreshold?: number | null, products?: Array<{ __typename?: 'GamificationDetailItem_Satisfiers_Product', productId?: number | null, ecommKey?: string | null, amount?: number | null } | null> | null } | null> | null } | null> | null } | null } | null };

export type GqlServerSideCalculationsMutationVariables = Exact<{
  input: GqlLegacyCalculationsInput;
}>;


export type GqlServerSideCalculationsMutation = { __typename?: 'Mutation', serverSideCalculations?: { __typename?: 'LegacyCalculationResults', bottleDepositTaxCents?: number | null, cannabisTax?: number | null, cartSubtotal?: number | null, credit?: number | null, deliveryFee?: number | null, menuTotal?: number | null, mixAndMatch?: number | null, otherFees?: number | null, paymentFee?: number | null, paymentIncentives?: Array<any | null> | null, reward?: number | null, rounding?: number | null, roundupForCharityAmount?: number | null, subtotal?: number | null, tax?: number | null, tip?: number | null, total?: number | null, receipt?: any | null, details?: Array<{ __typename?: 'DetailItem', basePrice?: number | null, basePriceMult?: number | null, bottleDepositTaxCents?: number | null, canonicalEffectivePotencyMg?: number | null, enterpriseProductId?: string | null, id?: string | null, isOnSale?: boolean | null, isVapeTaxed?: boolean | null, key?: string | null, menuBasePrice?: number | null, menuCannabisTax?: number | null, menuIndividualPrice?: number | null, menuSaleAdjustment?: number | null, menuPrice?: number | null, menuSalesTax?: number | null, option?: string | null, posId?: string | null, productBrand?: string | null, productBrandId?: string | null, productCategory?: string | null, productSubcategory?: string | null, quantity?: number | null, type?: string | null, weightInGrams?: number | null, weightInMg?: number | null, wholesalePrice?: number | null, bogoSavings?: { __typename?: 'BogoSavingsObj', displayAsPercentDiscount?: boolean | null, isDiscountToCartReward?: boolean | null, menuBogoDiscount?: string | null, total?: number | null, individual?: Array<{ __typename?: 'BogoSavings_Individual', conditionQuantity?: number | null, discountAmount?: number | null, discountStacking?: boolean | null, displayAsPercentDiscount?: boolean | null, isDiscountToCartReward?: boolean | null, maxApplicable?: number | null, nonStackingBehavior?: string | null, specialId?: string | null, stackingBehavior?: string | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', endWeight?: number | null, price?: number | null, pricePerGram?: number | null, startWeight?: number | null, weightUOM?: string | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, discountBehavior?: string | null, discountPrecedence?: string | null, discountStacking?: boolean | null, endStamp?: string | null, excludeConditionItemsFromRewards?: boolean | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, rawPOSWeightMapping?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, percentDiscount?: string | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, targetPrice?: string | null, vendorIds?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, discountType?: string | null, enabled?: boolean | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, percentDiscount?: boolean | null, rawPOSWeightMapping?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, bottleDepositTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null, cannabisTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null, lineitems?: Array<{ __typename?: 'LineItem', type?: string | null, value?: number | null } | null> | null, salesTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null } | null };

export type GqlComputeWithPriceCartQueryVariables = Exact<{
  priceCartInput: GqlCalculationsInput;
}>;


export type GqlComputeWithPriceCartQuery = { __typename?: 'Query', computeWithPriceCart?: { __typename?: 'CalculationResults', subTotal?: number | null, taxes?: number | null, discount?: number | null, originalTotal?: number | null, roundedDifference?: number | null, grandTotal?: number | null, loyaltyPointsUsed?: number | null, totalSalesTax?: number | null, totalCannabisTax?: number | null, totalBottleDepositTax?: number | null, taxInclusivePricing?: boolean | null, loyaltyAppliedAsDiscount?: number | null, discountWithoutLoyalty?: number | null, posCustomerId?: number | null, resolvedZoneIds?: Array<number> | null, itemTaxes?: Array<{ __typename?: 'ItemTax', taxAmount?: number | null, taxType?: string | null, productId?: number | null, feeItemId?: number | null, showOnMenu?: boolean | null, showOnCheckout?: boolean | null } | null> | null, cartItemPrices?: Array<{ __typename?: 'CartItem', productName?: string | null, productId?: number | null, quantity?: number | null, subtotal?: number | null, unitPrice?: number | null, pricingTierAdjustment?: number | null, pricingTierAdjustmentTotal?: number | null, summaryPrice?: number | null, menuPrice?: number | null, cartPrice?: number | null, checkoutPrice?: number | null, specialCartPrice?: number | null, specialCheckoutPrice?: number | null, tax?: number | null, unitWeightGrams?: number | null, productType?: string | null, discounts?: Array<{ __typename?: 'Discount', name?: string | null, amount?: number | null, discountId?: number | null, applicationMethod?: string | null, calculationMethod?: DiscountCalculationMethod | null, isLoyaltyReward?: boolean | null, isPaymentIncentive?: boolean | null } | null> | null } | null> | null, fees?: Array<{ __typename?: 'Fees', feeItemId?: number | null, feeAmount?: number | null, feeName?: string | null, deliveryFee?: boolean | null, paymentFee?: boolean | null } | null> | null, rewardValidationErrors?: Array<{ __typename?: 'RewardValidationError', discountCode?: string | null, discountId?: number | null, message?: string | null } | null> | null } | null };

export type GqlGetCannabinoidsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCannabinoidsQuery = { __typename?: 'Query', getCannabinoids: Array<{ __typename?: 'Cannabinoid', name: string, id: string }> };

export type GqlCouponFragmentFragment = { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null };

export type GqlCreateCouponV2MutationVariables = Exact<{
  input: GqlCreateCouponInput;
}>;


export type GqlCreateCouponV2Mutation = { __typename?: 'Mutation', createCouponV2?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null };

export type GqlDeleteCouponV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteCouponV2Mutation = { __typename?: 'Mutation', deleteCouponV2?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlUpdateCouponMutationVariables = Exact<{
  input: GqlUpdateCouponInput;
}>;


export type GqlUpdateCouponMutation = { __typename?: 'Mutation', updateCoupon?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null };

export type GqlFilteredCouponsQueryVariables = Exact<{
  filter?: InputMaybe<GqlCouponsFilterInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
}>;


export type GqlFilteredCouponsQuery = { __typename?: 'Query', filteredCoupons?: { __typename?: 'CouponList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, coupons?: Array<{ __typename?: 'Coupons', dispensary?: string | null, reimbursed?: boolean | null, _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null> | null } | null };

export type GqlClearAllCurbsideArrivalsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlClearAllCurbsideArrivalsMutation = { __typename?: 'Mutation', clearAllCurbsideArrivals: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlClearCurbsideArrivalMutationVariables = Exact<{
  arrivalId: Scalars['String']['input'];
}>;


export type GqlClearCurbsideArrivalMutation = { __typename?: 'Mutation', clearCurbsideArrival: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlMarkCurbsideArrivalArrivedV2MutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GqlMarkCurbsideArrivalArrivedV2Mutation = { __typename?: 'Mutation', markCurbsideArrivalArrivedV2: { __typename?: 'CurbsideArrival', id?: string | null } };

export type GqlUpdateCurbsideArrivalV2MutationVariables = Exact<{
  token: Scalars['String']['input'];
  arrivalInformation: Scalars['String']['input'];
}>;


export type GqlUpdateCurbsideArrivalV2Mutation = { __typename?: 'Mutation', updateCurbsideArrivalV2?: { __typename?: 'CurbsideArrival', id?: string | null } | null };

export type GqlGetCurbsideArrivalByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GqlGetCurbsideArrivalByTokenQuery = { __typename?: 'Query', getCurbsideArrivalByToken?: { __typename?: 'CurbsideArrival', id?: string | null, arrivalInformation?: string | null, arrivedAt?: any | null, clearedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, dispensary?: { __typename?: 'Dispensaries', id: string, phone?: string | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', arrivalInformationInstructions?: string | null } | null } | null } | null } | null };

export type GqlGetCurbsideArrivalsForBannerQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetCurbsideArrivalsForBannerQuery = { __typename?: 'Query', getCurbsideArrivals: Array<{ __typename?: 'CurbsideArrival', id?: string | null }> };

export type GqlGetCurbsideArrivalsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetCurbsideArrivalsQuery = { __typename?: 'Query', getCurbsideArrivals: Array<{ __typename?: 'CurbsideArrival', id?: string | null, arrivalInformation?: string | null, arrivedAt?: any | null, clearedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, order?: { __typename?: 'Orders', id?: string | null, orderId?: string | null, customer?: { __typename?: 'Orders_customer', profile?: { __typename?: 'Orders_customer_profile', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null }> };

export type GqlUpdateCustomerSubscriptionMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
}>;


export type GqlUpdateCustomerSubscriptionMutation = { __typename?: 'Mutation', updateCustomerSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGenerateDecagonUserAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGenerateDecagonUserAuthQuery = { __typename?: 'Query', generateDecagonUserAuth?: { __typename?: 'DecagonUserAuth', signature?: string | null, epoch?: number | null } | null };

export type GqlDeviceFragmentFragment = { __typename?: 'Devices', _id?: string | null, accessCode?: string | null, autoPrintDevice?: boolean | null, buildNumber?: string | null, deviceType?: DeviceType | null, dispensaryId?: string | null, lastSeenAt?: string | null, nickname?: string | null, online?: boolean | null, printerConnected?: boolean | null, updatedAt?: string | null, versionNumber?: string | null, config?: { __typename?: 'Device_config', getDeliveryOrders?: boolean | null, getKioskOrders?: boolean | null, getPickupOrders?: boolean | null, orderSource?: string | null } | null };

export type GqlGetDevicesQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetDevicesQuery = { __typename?: 'Query', getDevices: Array<{ __typename?: 'Devices', _id?: string | null, accessCode?: string | null, autoPrintDevice?: boolean | null, buildNumber?: string | null, deviceType?: DeviceType | null, dispensaryId?: string | null, lastSeenAt?: string | null, nickname?: string | null, online?: boolean | null, printerConnected?: boolean | null, updatedAt?: string | null, versionNumber?: string | null, config?: { __typename?: 'Device_config', getDeliveryOrders?: boolean | null, getKioskOrders?: boolean | null, getPickupOrders?: boolean | null, orderSource?: string | null } | null }> };

export type GqlGetKioskTerminalsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetKioskTerminalsQuery = { __typename?: 'Query', getKioskTerminals: Array<{ __typename?: 'KioskTerminal', id: string, dispensaryId: string, nickname?: string | null }> };

export type GqlBaseDispensaryFragmentFragment = { __typename?: 'Dispensaries', id: string, distance?: number | null, name?: string | null, cName?: string | null, timezone?: string | null, phone?: string | null, address?: string | null, description?: string | null, dposLspName?: string | null, status?: string | null, chain?: string | null, offerAnyPickupService?: boolean | null, offerPickup?: boolean | null, offerCurbsidePickup?: boolean | null, offerDelivery?: boolean | null, listImage?: string | null, bannerImage?: string | null, logoImage?: string | null, embeddedLogoImage?: string | null, embeddedMenuUrl?: string | null, SpecialLogoImage?: string | null, brandedDutchiePayEnabled?: boolean | null, brandedDutchiePayName?: string | null, brandedDutchiePayLogoLight?: string | null, brandedDutchiePayLogoDark?: string | null, payByBankPreauthorizationAvailable?: boolean | null, embedBackUrl?: string | null, alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, creditCardByPhone?: boolean | null, debitOnly?: boolean | null, cashless?: boolean | null, createdAtISO?: any | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, recDispensary?: boolean | null, medicalDispensary?: boolean | null, maxDeliveryDistance?: number | null, mixAndMatchPricingWeights?: Array<string | null> | null, acceptsTips?: boolean | null, acceptsDutchiePayTips?: boolean | null, acceptsCreditCardTips?: boolean | null, requiresDriversLicense?: boolean | null, requiresDriversLicenseForPickup?: boolean | null, requiresDriversLicenseExpirationDate?: boolean | null, requirePhotoIdForDelivery?: boolean | null, requirePhotoIdForPickup?: boolean | null, removeMedicalCardFieldsAtCheckout?: boolean | null, menuOrder?: string | null, email?: string | null, emailConfirmation?: boolean | null, kioskOrderingEnabled?: boolean | null, categoryLimitsEnabled?: boolean | null, updatedAt?: string | null, updatedAtISO?: any | null, ordersArePaused?: boolean | null, ageVerificationBannerHtml?: string | null, ageVerificationBannerColor?: string | null, menuBannerHtml?: string | null, menuBannerColor?: string | null, menuBannerTextBannerCollapsed?: boolean | null, menuUrl?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null, plusSettings?: { __typename?: 'Dispensaries_profile_plus_settings', checkoutUrl?: string | null, defaultReturnUrl?: string | null } | null, location?: { __typename?: 'Dispensaries_profile_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipcode?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null } | null } | null, temporalLocation?: { __typename?: 'TemporalLocation', lastUpdatedAt?: any | null, coordinates?: any | null, onDuty?: boolean | null, nearbyEnabled?: boolean | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, categoryPhotos?: Array<{ __typename?: 'CategoryPhoto', src?: string | null, category?: string | null } | null> | null, customCategoryPhotos?: Array<{ __typename?: 'CustomCategoryPhoto', url?: string | null, category?: string | null, collectionId?: string | null } | null> | null, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, embedSettings?: { __typename?: 'Dispensaries_profile_embed_settings', disclaimerTextHtml?: string | null, disablePageLoadsAtTop?: boolean | null, enableFullScreenEmbeddedCheckout?: boolean | null, autoGTM?: boolean | null, privacyPolicyUrl?: string | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, feeType?: FeeTypes | null, max?: string | null, min?: string | null, percentFee?: number | null } | null> | null, menuOrderSettings: Array<{ __typename?: 'MenuOrderSetting', category: string, menuOrder: CategoryMenuOrder }>, menuSortSettings?: Array<{ __typename?: 'MenuSortSetting', brands?: Array<string> | null, category: string, menuOrder: string }> | null, actionEstimates?: { __typename?: 'ActionEstimates', pickup?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null } | null, delivery?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null, deliveryTimeInMinutes?: number | null } | null } | null, durationEstimateOverrides?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, paymentFees?: Array<{ __typename?: 'Dispensaries_paymentFees', fee?: number | null, feeType?: string | null, paymentType?: string | null } | null> | null, kioskConfig?: { __typename?: 'Dispensaries_kioskConfig', fullNameOnly?: boolean | null, phoneRequired?: boolean | null, notesField?: boolean | null, directedOrders?: boolean | null, hidePhoneField?: boolean | null, hideEmailField?: boolean | null, showBirthdateField?: boolean | null, disableFasterCheckout?: boolean | null, type?: string | null } | null, categoryLimits?: Array<{ __typename?: 'Dispensaries_categoryLimits', name?: string | null, value?: string | null } | null> | null, specialsSettings?: { __typename?: 'SpecialsSettings', discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, enableIndividualSpecialPrecedence?: boolean | null, enableIndividualDiscountStacking?: boolean | null, stackingBehavior?: string | null, nonStackingBehavior?: string | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', isolatedMenus: boolean, customerMessagingTermsAccepted: boolean, showPOSPackageId: boolean, defaultViewStyle: MenuViewStyles, disablePurchaseLimits: boolean, configurablePurchaseLimitsEnabled?: boolean | null, customPurchaseLimits?: any | null, disableGuestDOB: boolean, displayPhoneConfirmation: boolean, displayKioskAnonymousCheckoutDisclaimer?: boolean | null, enableDutchiePayConsumerSurcharge?: boolean | null, requireEmailAddressForGuestCheckout: boolean, requireMedCardPhotoForPickup?: boolean | null, requireMedCardFieldsAtCheckout?: boolean | null, hideAddressFromDutchieMain: boolean, hideFromMobileApp?: boolean | null, hideFromSearchEngines?: boolean | null, requireMedCardPhotoForDelivery?: boolean | null, enableMMURAllotmentCheck?: boolean | null, blockOrderOnMMURAllotmentFailure?: boolean | null, cloudPrntEnabled?: boolean | null, cloudPrntAutomaticPrintingEnabled?: boolean | null, enableAfterHoursOrderingForPickup: boolean, enableAfterHoursOrderingForDelivery: boolean, enableLLxSaleDiscountSync?: boolean | null, enableMixAndMatchPricingForPickup: boolean, enableMixAndMatchPricingForDelivery: boolean, enableOtherLocations?: boolean | null, enableProductUrgencyMessaging?: boolean | null, enableScheduledOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean, enableLimitPerCustomer: boolean, quantityLimit: number, quantityLimitMaxAvailable: boolean, enableOrderStatusEmails: boolean, enableOrderTypeTakeoverModal?: boolean | null, enableStorefrontAgeGate: boolean, skipOnlineAgeVerification: boolean, enableDiscountGamification: boolean, enableCartInterstitial: boolean, hardAgeGateHideMenuContent: boolean, collapseProductDescription: boolean, disableGuestCheckout: boolean, requirePaymentMethodSelection?: boolean | null, requireTermsAcceptance?: boolean | null, enableConcierge?: boolean | null, enableKioskConcierge?: boolean | null, enableCustomTerms?: boolean | null, customTermsText?: string | null, stealthMode: boolean, disableAIReviewModeration?: boolean | null, dontCombineWeightedProducts: boolean, keepUncombinedWeights?: boolean | null, dontMapSubcategoriesByProductName?: boolean | null, prioritizeStaffPicksInSearchResults: boolean, provideBackInstockEmailNotifications: boolean, hideCannabinoidDescriptions: boolean, hideEffects: boolean, hideFilters?: boolean | null, hideTotalTerpenes?: boolean | null, hideOutOfStockProducts: boolean, showLoyaltyRewards?: boolean | null, aiqSmsPinTriggerBehavior?: string | null, hideDiscountsFromConsumer?: boolean | null, hideCategoryTiles?: boolean | null, restrictSalesLanguage?: boolean | null, usePotencyForConcentrateLimits?: boolean | null, useStandardEquivalentForEdiblesLimits?: boolean | null, useStateRegulatedImageWatermarks?: boolean | null, enableOmniauthLoginCheckout?: boolean | null, disableSpecialInstructions?: boolean | null, enableRoundToNearestDollar?: boolean | null, hideRoundingLineItem?: boolean | null, minimumAgeOverrides?: { __typename?: 'MinimumAgeOverrides', country: string, region: string, medical?: number | null, rec?: number | null } | null, subscriptions: { __typename?: 'Dispensaries_subscriptions', enabled?: boolean | null }, rewardsIntegrationConfiguration?: { __typename?: 'Rewards_integration_configuration', rewardsProgramDisplayDescription?: string | null, rewardsProgramDisplayEnrollment?: string | null, rewardsProgramDisplayName?: string | null } | null, specialsPage?: { __typename?: 'SpecialsPageSettings', showSpecialsRedesign?: boolean | null, showCategoryTiles?: boolean | null, showSpecialDuration?: boolean | null } | null }, featureFlags: { __typename?: 'Dispensaries_featureFlags', enableAfterHoursOrdering?: boolean | null, enableArrivals?: boolean | null, enableMenuImport?: boolean | null, enableMixAndMatch?: boolean | null, enableNonTerminalAutoConfirm?: boolean | null, enablePausedOrders?: boolean | null, enableScheduledOrdering?: boolean | null, hideDeliveryEstimate?: boolean | null, hideMyAccount?: boolean | null, hideStoreHours?: boolean | null }, colorSettings?: { __typename?: 'ColorSettings', linkColor?: string | null, navBarColor?: string | null } | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, pickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, curbsidePickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, driveThruPickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, kiosk?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null } | null, paymentTypesAccepted?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_CurbsidePickupOrderingSettings_Fragment = { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_DeliveryOrderingSettings_Fragment = { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_DriveThruPickupOrderingSettings_Fragment = { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_InStorePickupOrderingSettings_Fragment = { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

export type GqlBaseOrderingSettingsFragmentFragment = GqlBaseOrderingSettingsFragment_CurbsidePickupOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_DeliveryOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_DriveThruPickupOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_InStorePickupOrderingSettings_Fragment;

export type GqlCurbsidePickupOrderingSettingsFragmentFragment = { __typename?: 'CurbsidePickupOrderingSettings', enableCurbsideArrivals?: boolean | null, arrivalInformationInstructions?: string | null, enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, notificationSettings?: { __typename?: 'NotificationSettings', sms?: boolean | null, email?: boolean | null, push?: boolean | null } | null, autoConfirmSettings?: { __typename?: 'AutoConfirmSettings', enabled?: boolean | null, autoClose?: boolean | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

export type GqlDeliveryOrderingSettingsFragmentFragment = { __typename?: 'DeliveryOrderingSettings', deliveryMode?: DeliveryModes | null, enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, deliveryFeeTiers?: Array<{ __typename?: 'DeliveryFeeTiers', feeInCents?: number | null, maximumInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null } | null> | null, deliveryRadius?: { __typename?: 'DeliveryRadius', radiusInMiles?: number | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null } | null, deliveryZipCodes?: Array<{ __typename?: 'DeliveryZipCodes', zipCode?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null } | null> | null, deliveryCityZones?: Array<{ __typename?: 'DeliveryCityZones', _id?: string | null, name?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null, cities?: Array<{ __typename?: 'CityZoneEntry', city?: string | null, state?: string | null } | null> | null } | null> | null, notificationSettings?: { __typename?: 'NotificationSettings', sms?: boolean | null, email?: boolean | null, push?: boolean | null } | null, autoConfirmSettings?: { __typename?: 'AutoConfirmSettings', enabled?: boolean | null, autoClose?: boolean | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

export type GqlDeliveryZonesFragmentFragment = { __typename?: 'DeliveryOrderingSettings', deliveryZones?: Array<{ __typename?: 'DeliveryZones', _id?: string | null, name?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null, area?: { __typename?: 'Polygon', type?: string | null, features?: Array<{ __typename?: 'GeoJson_features', type?: string | null, geometry?: { __typename?: 'GeoJson_geometry', type?: string | null, coordinates?: any | null } | null } | null> | null } | null } | null> | null };

export type GqlDriveThruPickupOrderingSettingsFragmentFragment = { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, notificationSettings?: { __typename?: 'NotificationSettings', sms?: boolean | null, email?: boolean | null, push?: boolean | null } | null, autoConfirmSettings?: { __typename?: 'AutoConfirmSettings', enabled?: boolean | null, autoClose?: boolean | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

export type GqlHourSetFragmentFragment = { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null };

export type GqlHoursForDayFragment = { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null };

export type GqlHoursSettingsForOrderTypeFragmentFragment = { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null };

export type GqlInStorePickupOrderingSettingsFragmentFragment = { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, notificationSettings?: { __typename?: 'NotificationSettings', sms?: boolean | null, email?: boolean | null, push?: boolean | null } | null, autoConfirmSettings?: { __typename?: 'AutoConfirmSettings', enabled?: boolean | null, autoClose?: boolean | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null, hideClosedDays?: boolean | null } | null };

export type GqlKioskOrderingSettingsFragmentFragment = { __typename?: 'KioskOrderingSettings', enabled?: boolean | null, enableAfterHoursOrdering?: boolean | null, fullNameOnly?: boolean | null, phoneRequired?: boolean | null, notesField?: boolean | null, directedOrders?: boolean | null, hideEmailField?: boolean | null, hidePhoneField?: boolean | null, showBirthdateField?: boolean | null, anonymousCheckout?: boolean | null, disableFasterCheckout?: boolean | null, kioskInstructions?: string | null, checkoutMessage?: string | null, anonymousCheckoutMessage?: string | null, creditCardByPhoneCheckoutMessage?: string | null, screensaverText?: string | null, type?: KioskTypes | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, timeout?: { __typename?: 'TimeoutConfig', enabled?: boolean | null, duration?: number | null } | null, notificationSettings?: { __typename?: 'NotificationSettings', sms?: boolean | null, email?: boolean | null, push?: boolean | null } | null, autoConfirmSettings?: { __typename?: 'AutoConfirmSettings', enabled?: boolean | null, autoClose?: boolean | null } | null, kiosks?: Array<{ __typename?: 'KioskEntry', id: string, name: string, destinationTerminal?: string | null }> | null };

export type GqlMaxReservationSlotFragmentFragment = { __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null };

export type GqlMaxReservationSlotsByDayFragmentFragment = { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null };

export type GqlMenuSectionFragmentFragment = { __typename?: 'MenuSection', id: string, brandId?: string | null, category?: string | null, headingOverride?: string | null, label: string, legacyLabel?: string | null, linkLabel: string, position: number, subcategory?: string | null, sectionType: MenuSectionType, products?: Array<string> | null, collectionId?: string | null, sortBy?: string | null, image?: { __typename?: 'ImageBanner', _id: string, image: string, mobileImage: string, alt?: string | null, position: number, platforms?: Array<{ __typename?: 'ImageBannerPlatform', enabled: boolean, link?: string | null, openInNewTab?: boolean | null, type: ImageBannerPlatformType } | null> | null } | null, collectionSchedule?: { __typename?: 'Schedule', startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, startTime: string, endTime: string }> | null } | null };

export type GqlPaymentTypesFragmentFragment = { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null };

export type GqlScheduledOrderingConfigFragmentFragment = { __typename?: 'ReservationOptionsForOrderType', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null };

export type GqlSpecialHoursDayFragmentFragment = { __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } };

export type GqlSpecialHoursFragmentFragment = { __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null };

export type GqlTaxPropertiesFragment = { __typename?: 'Dispensaries_TaxConfig_Tax', id: string, type: TaxType, name: string, rate: number, potencyRate?: number | null, potency?: PotencyType | null, medical: boolean, recreational: boolean, taxBasis?: string | null, order?: number | null, deliveryPolicy?: DeliveryPolicy | null, includeStateSalesTaxInDestinationRate?: boolean | null, stages: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax_Stage', op: Dispensaries_TaxConfig_Tax_Stage_Ops, type: Dispensaries_TaxConfig_Tax_Stage_Types } | null>, applyTo: { __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo', types: Array<string | null>, hemp: boolean } };

export type GqlWeeklyHoursFragmentFragment = { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null };

export type GqlDispensaryOnboardingMutationVariables = Exact<{
  input: GqlDispensaryOnboardingInput;
}>;


export type GqlDispensaryOnboardingMutation = { __typename?: 'Mutation', dispensaryOnboarding?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDispensaryUploadOnboardingAssetMutationVariables = Exact<{
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GqlDispensaryUploadOnboardingAssetMutation = { __typename?: 'Mutation', dispensaryUploadOnboardingAsset?: { __typename?: 'DispensaryAssetUploadResponse', fileIds?: Array<string | null> | null } | null };

export type GqlGetAddressBasedDispensaryDataQueryVariables = Exact<{
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
}>;


export type GqlGetAddressBasedDispensaryDataQuery = { __typename?: 'Query', getAddressBasedDispensaryData?: { __typename?: 'AddressBasedDispensaryDataResult', deliveryInfo: { __typename?: 'Dispensaries_deliveryInfo', deliveryAreaId?: string | null, withinBounds?: boolean | null, fee?: number | null, feeType?: FeeTypes | null, percentFee?: number | null, minimum?: number | null, feeVaries?: boolean | null, minimumVaries?: boolean | null }, taxes?: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax', destinationRate?: number | null, id: string, type: TaxType, name: string, rate: number, potencyRate?: number | null, potency?: PotencyType | null, medical: boolean, recreational: boolean, taxBasis?: string | null, order?: number | null, deliveryPolicy?: DeliveryPolicy | null, includeStateSalesTaxInDestinationRate?: boolean | null, stages: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax_Stage', op: Dispensaries_TaxConfig_Tax_Stage_Ops, type: Dispensaries_TaxConfig_Tax_Stage_Types } | null>, applyTo: { __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo', types: Array<string | null>, hemp: boolean } }> | null } | null };

export type GqlDispensarySearchQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlDispensarySearchQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, recDispensary?: boolean | null, medicalDispensary?: boolean | null, offerPickup?: boolean | null, offerCurbsidePickup?: boolean | null, offerAnyPickupService?: boolean | null, offerDelivery?: boolean | null, listImage?: string | null, distance?: number | null, maxDeliveryDistance?: number | null, timezone?: string | null, location?: { __typename?: 'Dispensaries_profile_location', city?: string | null, county?: string | null, ln1?: string | null, ln2?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null, type?: string | null } | null } | null, actionEstimates?: { __typename?: 'ActionEstimates', delivery?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null, deliveryTimeInMinutes?: number | null } | null, pickup?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null } | null } | null, durationEstimateOverrides?: { __typename?: 'DurationEstimates', pickup?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null, delivery?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', enableAfterHoursOrderingForPickup: boolean, enableAfterHoursOrderingForDelivery: boolean, enableScheduledOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean }, featureFlags: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null }, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, deliveryInfo?: { __typename?: 'Dispensaries_deliveryInfo', withinBounds?: boolean | null, fee?: number | null, minimum?: number | null, feeVaries?: boolean | null, minimumVaries?: boolean | null, feeType?: FeeTypes | null, percentFee?: number | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, feeType?: FeeTypes | null, max?: string | null, min?: string | null, percentFee?: number | null } | null> | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, pickupHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null }, deliveryHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null } } | null> | null } | null> | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, pickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, curbsidePickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, driveThruPickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, kiosk?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null } | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, inStorePickup?: { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, driveThruPickup?: { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, delivery?: { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null } | null, hoursSettings?: { __typename?: 'DispensaryHoursSettings', inStorePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, curbsidePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, driveThruPickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, delivery?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null } | null, enabledOrderTypes?: { __typename?: 'EnabledOrderTypes', pickup?: boolean | null, inStorePickup?: boolean | null, curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, delivery?: boolean | null, kiosk?: boolean | null } | null, paymentTypesAccepted?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null> | null };

export type GqlCopyToLocationsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  klass: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  enableAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlCopyToLocationsMutation = { __typename?: 'Mutation', copyToLocations?: { __typename?: 'CopyToLocationsResponse', success: boolean, message?: string | null, successCount?: number | null, alreadyExistsCount?: number | null, specialNotFoundCount?: number | null, skippedLocations?: Array<{ __typename?: 'SkippedCopyLocation', dispensaryId: string, reason: string }> | null } | null };

export type GqlCreateEnterpriseLoyaltySettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateEnterpriseLoyaltySettingsMutation = { __typename?: 'Mutation', createEnterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, dposLoyaltyIsoRegionCodes?: Array<string | null> | null, description?: string | null, displayName?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null } | null };

export type GqlUpdateEnterpriseLoyaltySettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateEnterpriseLoyaltySettingsMutation = { __typename?: 'Mutation', updateEnterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, dposLoyaltyIsoRegionCodes?: Array<string | null> | null, description?: string | null, displayName?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null } | null };

export type GqlUpdateEnterpriseMobileAppSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  input?: InputMaybe<GqlEnterpriseMobileAppSettingsInput>;
}>;


export type GqlUpdateEnterpriseMobileAppSettingsMutation = { __typename?: 'Mutation', updateEnterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidExistingVersion?: string | null, androidExistingVersionCode?: number | null, androidOrganizationName?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, automaticScreenshotGeneration?: boolean | null, buildForIpad?: boolean | null, firebaseProjectId?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosExistingVersion?: string | null, iosSplashBackgroundColor?: string | null, iosTeamId?: string | null, iosTeamName?: string | null, name?: string | null, shortName?: string | null } | null };

export type GqlEnterpriseLoyaltySettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseLoyaltySettingsQuery = { __typename?: 'Query', enterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', description?: string | null, displayName?: string | null, enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, dposLoyaltyIsoRegionCodes?: Array<string | null> | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null } | null };

export type GqlEnterpriseMobileAppSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseMobileAppSettingsQuery = { __typename?: 'Query', enterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosSplashBackgroundColor?: string | null } | null };

export type GqlAdminEnterpriseMobileAppSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlAdminEnterpriseMobileAppSettingsQuery = { __typename?: 'Query', enterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidExistingVersion?: string | null, androidExistingVersionCode?: number | null, androidOrganizationName?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, automaticScreenshotGeneration?: boolean | null, buildForIpad?: boolean | null, firebaseProjectId?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosExistingVersion?: string | null, iosSplashBackgroundColor?: string | null, iosTeamId?: string | null, iosTeamName?: string | null, name?: string | null, shortName?: string | null } | null };

export type GqlGeolocateConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGeolocateConsumerQuery = { __typename?: 'Query', geolocate?: { __typename?: 'IPInfo', ip?: string | null, hostname?: string | null, city?: string | null, region?: string | null, country?: string | null, loc?: string | null, org?: string | null, postal?: string | null, timezone?: string | null } | null };

export type GqlGenerateHypurTokenV2MutationVariables = Exact<{
  code: Scalars['String']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
}>;


export type GqlGenerateHypurTokenV2Mutation = { __typename?: 'Mutation', generateHypurTokenV2?: { __typename?: 'HypurToken', accessToken: string, embedded: boolean } | null };

export type GqlCreateLibraryProductV2MutationVariables = Exact<{
  libraryProduct: GqlNewLibraryProduct;
  state: Scalars['String']['input'];
}>;


export type GqlCreateLibraryProductV2Mutation = { __typename?: 'Mutation', createLibraryProductV2?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlCreateLibraryProductV3MutationVariables = Exact<{
  libraryProduct: GqlNewLibraryProductV2;
  state: Scalars['String']['input'];
}>;


export type GqlCreateLibraryProductV3Mutation = { __typename?: 'Mutation', createLibraryProductV3?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlMatchLibraryProductsV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GqlMatchLibraryProductsV2Query = { __typename?: 'Query', matchLibraryProductsV2?: Array<{ __typename?: 'LibraryProduct', id: string, category?: string | null, image?: string | null, name: string, price: number, productTemplate?: boolean | null, stockImage?: string | null, strainType?: string | null, subcategory?: string | null, brand?: { __typename?: 'Brand', id: string, name: string, imageUrl?: string | null } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, active: boolean, origin: ImageOrigin } | null> | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null> | null };

export type GqlMatchLibraryProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlMatchLibraryProductsQuery = { __typename?: 'Query', matchLibraryProducts?: Array<{ __typename?: 'LibraryProduct', id: string, category?: string | null, image?: string | null, name: string, price: number, strainType?: string | null, subcategory?: string | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null> | null };

export type GqlAddressResidentialCheckQueryVariables = Exact<{
  input: GqlAddressResidentialCheckInput;
}>;


export type GqlAddressResidentialCheckQuery = { __typename?: 'Query', addressResidentialCheck?: { __typename?: 'ValidationResponse', isValid?: boolean | null } | null };

export type GqlHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlHealthCheckQuery = { __typename?: 'Query', healthCheck?: { __typename?: 'HealthCheck', status?: string | null } | null };

export type GqlResetPasswordV2MutationVariables = Exact<{
  input: GqlResetPasswordInput;
}>;


export type GqlResetPasswordV2Mutation = { __typename?: 'Mutation', resetPasswordV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendBrandUserPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GqlSendBrandUserPasswordResetEmailMutation = { __typename?: 'Mutation', sendBrandUserPasswordResetEmail?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendCompleteAccountSetupEmailMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlSendCompleteAccountSetupEmailMutation = { __typename?: 'Mutation', sendCompleteAccountSetupEmail?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendPasswordResetEmailV2MutationVariables = Exact<{
  email: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlSendPasswordResetEmailV2Mutation = { __typename?: 'Mutation', sendPasswordResetEmailV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSetPasswordV2MutationVariables = Exact<{
  input: GqlSetPasswordInput;
}>;


export type GqlSetPasswordV2Mutation = { __typename?: 'Mutation', setPasswordV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdatePasswordV2MutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type GqlUpdatePasswordV2Mutation = { __typename?: 'Mutation', updatePasswordV2?: { __typename?: 'PasswordUpdate', accessToken: string } | null };

export type GqlGetPaymentsCheckoutCredentialsQueryVariables = Exact<{
  adapter: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetPaymentsCheckoutCredentialsQuery = { __typename?: 'Query', getPaymentsCheckoutCredentials?: { __typename?: 'ChaseHostedProfileCredentials', uID: string } | { __typename?: 'MonerisHTProfileCredentials', profileId: string } | null };

export type GqlGetMonerisTokenizationProfileQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetMonerisTokenizationProfileQuery = { __typename?: 'Query', getMonerisTokenizationProfile?: { __typename?: 'MonerisTokenizationProfile', profileId: string } | null };

export type GqlGetCustomerCommunicationSettingsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GqlGetCustomerCommunicationSettingsQuery = { __typename?: 'Query', getCustomerCommunicationSettings?: { __typename?: 'CommunicationSettings', optInEmail?: boolean | null, optInSMS?: boolean | null, optInPush?: boolean | null } | null };

export type GqlUpdateCustomerCommunicationSettingsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  optInPush?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlUpdateCustomerCommunicationSettingsMutation = { __typename?: 'Mutation', updateCustomerCommunicationSettings?: { __typename?: 'PreferenceSettingsResponse', success?: boolean | null } | null };

export type GqlArchivedProductLookupQueryVariables = Exact<{
  cname: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlArchivedProductLookupQuery = { __typename?: 'Query', archivedProductLookup?: Array<{ __typename?: 'Products', effects?: any | null, description?: string | null, descriptionHtml?: string | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, avgRating?: number | null, reviewCount?: number | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, posDiscountNames?: Array<string | null> | null, POSPricingData?: any | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, subcategories?: Array<string | null> | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, productCardSpecials?: Array<{ __typename?: 'ProductCardSpecial', id: string, name: string, description?: string | null, startDate?: string | null, endDate?: string | null, kind: ProductCardSpecialKind, menuType: ProductCardSpecialMenuType }> | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, legacyPricing?: { __typename?: 'Products_LegacyPricing', medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, Prices?: Array<number | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> | null };

export type GqlConsumerBaseProductFragmentFragment = { __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, avgRating?: number | null, reviewCount?: number | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, posDiscountNames?: Array<string | null> | null, POSPricingData?: any | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, subcategories?: Array<string | null> | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, productCardSpecials?: Array<{ __typename?: 'ProductCardSpecial', id: string, name: string, description?: string | null, startDate?: string | null, endDate?: string | null, kind: ProductCardSpecialKind, menuType: ProductCardSpecialMenuType }> | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, legacyPricing?: { __typename?: 'Products_LegacyPricing', medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, Prices?: Array<number | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null };

export type GqlConsumerSponsoredProductFragmentFragment = { __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, avgRating?: number | null, reviewCount?: number | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, posDiscountNames?: Array<string | null> | null, POSPricingData?: any | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, subcategories?: Array<string | null> | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, productCardSpecials?: Array<{ __typename?: 'ProductCardSpecial', id: string, name: string, description?: string | null, startDate?: string | null, endDate?: string | null, kind: ProductCardSpecialKind, menuType: ProductCardSpecialMenuType }> | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, legacyPricing?: { __typename?: 'Products_LegacyPricing', medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, Prices?: Array<number | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null };

export type GqlFilteredProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlFilteredProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', effects?: any | null, provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, avgRating?: number | null, reviewCount?: number | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, posDiscountNames?: Array<string | null> | null, POSPricingData?: any | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, subcategories?: Array<string | null> | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string } | null } | null> | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, productCardSpecials?: Array<{ __typename?: 'ProductCardSpecial', id: string, name: string, description?: string | null, startDate?: string | null, endDate?: string | null, kind: ProductCardSpecialKind, menuType: ProductCardSpecialMenuType }> | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, legacyPricing?: { __typename?: 'Products_LegacyPricing', medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, Prices?: Array<number | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null>, queryInfo: { __typename?: 'queryInfoType', totalCount?: number | null, totalPages?: number | null } } | null };

export type GqlIndividualFilteredProductQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlIndividualFilteredProductQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', effects?: any | null, description?: string | null, descriptionHtml?: string | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, avgRating?: number | null, reviewCount?: number | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, posDiscountNames?: Array<string | null> | null, POSPricingData?: any | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, subcategories?: Array<string | null> | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, terpenes?: Array<{ __typename?: 'Products_POSMetaData_children_potencyMeasurement', name?: string | null, unit?: string | null, values?: Array<number | null> | null } | null> | null, cannabinoids?: Array<{ __typename?: 'Products_POSMetaData_children_potencyMeasurement', name?: string | null, unit?: string | null, values?: Array<number | null> | null } | null> | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null } | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, terpenes?: Array<{ __typename?: 'Products_Terpene', id?: string | null, terpeneId?: string | null, unit?: PotencyUnit | null, unitSymbol?: string | null, value?: number | null, libraryTerpene?: { __typename?: 'Terpene', aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, name?: string | null } | null } | null> | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string, description?: string | null } | null } | null> | null, outletCollectionInfo?: { __typename?: 'OutletCollectionInfo', timerMessage?: string | null, endDate?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, productCardSpecials?: Array<{ __typename?: 'ProductCardSpecial', id: string, name: string, description?: string | null, startDate?: string | null, endDate?: string | null, kind: ProductCardSpecialKind, menuType: ProductCardSpecialMenuType }> | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, legacyPricing?: { __typename?: 'Products_LegacyPricing', medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, Prices?: Array<number | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> } | null };

export type GqlPosMetaDataFragmentFragment = { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null };

export type GqlCreateRedemptionMutationVariables = Exact<{
  code: Scalars['String']['input'];
  receiverUserId: Scalars['String']['input'];
}>;


export type GqlCreateRedemptionMutation = { __typename?: 'Mutation', createRedemption?: { __typename?: 'Redemption', id?: string | null, code?: string | null, receiverUserId?: string | null, lspName?: string | null, lspId?: string | null, status?: string | null } | null };

export type GqlFindOrCreateReferralCodeMutationVariables = Exact<{
  lspName: Scalars['String']['input'];
  senderUserId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  posUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlFindOrCreateReferralCodeMutation = { __typename?: 'Mutation', findOrCreateReferralCode?: { __typename?: 'ReferralCode', code?: string | null, id?: string | null, lspName?: string | null, senderEcommId?: string | null, senderPosUniqueId?: string | null, senderPoints?: string | null, receiverPoints?: string | null, learnMoreUrl?: string | null, referralUrl?: string | null } | null };

export type GqlCreateAlpineUserV2MutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  program: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  favoriteStore: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  acceptedTerms: Scalars['Boolean']['input'];
}>;


export type GqlCreateAlpineUserV2Mutation = { __typename?: 'Mutation', createAlpineUserV2?: { __typename?: 'RewardUserResponse', success?: boolean | null, wallet?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, costV2: number, value: string, rewardType: string } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null } | null } | null };

export type GqlCreateAlpineUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  program: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  favoriteStore: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  acceptedTerms: Scalars['Boolean']['input'];
}>;


export type GqlCreateAlpineUserMutation = { __typename?: 'Mutation', createAlpineUser?: { __typename?: 'RewardUserResponse', success?: boolean | null, wallet?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, costV2: number, value: string, rewardType: string } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null } | null } | null };

export type GqlCreateDutchiePosLoyaltyMemberV2MutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  useStrictMatching?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlCreateDutchiePosLoyaltyMemberV2Mutation = { __typename?: 'Mutation', createDutchiePosLoyaltyMemberV2?: { __typename?: 'LoyaltyMemberResponse', posCustomerId?: string | null, isLoyaltyMember?: boolean | null } | null };

export type GqlCreateDutchiePosLoyaltyMemberMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', createDutchiePosLoyaltyMember?: { __typename?: 'RewardUserResponse', success?: boolean | null } | null };

export type GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  useStrictMatching?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation = { __typename?: 'Mutation', createEnterpriseDutchiePosLoyaltyMemberV2?: { __typename?: 'LoyaltyMemberResponse', posCustomerId?: string | null, isLoyaltyMember?: boolean | null } | null };

export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', createEnterpriseDutchiePosLoyaltyMember?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlCreateSpringbigUserMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GqlCreateSpringbigUserMutation = { __typename?: 'Mutation', createSpringbigUser?: { __typename?: 'RewardUserResponse', success?: boolean | null } | null };

export type GqlUpdateDutchiePosLoyaltyMemberMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  lastAndroidLoginUtc?: InputMaybe<Scalars['String']['input']>;
  lastIosLoginUtc?: InputMaybe<Scalars['String']['input']>;
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', updateDutchiePosLoyaltyMember?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetDutchiePosLoyaltyConfigQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetDutchiePosLoyaltyConfigQuery = { __typename?: 'Query', getDutchiePosLoyaltyConfig?: { __typename?: 'DutchiePosLoyaltyConfig', loyaltyRequireOptIn: boolean, isEnabled: boolean, loyaltyExpirationMode?: number | null, onlineName?: string | null, onlineDescription?: string | null, tierEarningBasis?: string | null, redemptionType?: string | null, mode?: string | null, dispensaryId?: string | null, loyaltyWidgetEnabledOnWeb?: boolean | null, loyaltyWidgetEnabledOnMobile?: boolean | null, onlineRedemptionEnabledOnWeb?: boolean | null, onlineRedemptionEnabledOnMobile?: boolean | null, viewDiscountRewards?: boolean | null, maxRedemptionsPerTransaction?: number | null, accrualRate?: number | null, requireVerifiedPhoneForEnrollmentOnEcomm?: boolean | null, requireVerifiedPhoneForRedemptionOnEcomm?: boolean | null, tiers?: Array<{ __typename?: 'DutchiePosLoyaltyTier', id: number, name: string, threshold: number, badgeColor: string, accrualRate?: number | null } | null> | null, referralConfig?: { __typename?: 'DutchieReferralConfig', isEnabled?: boolean | null, learnMoreUrl?: string | null, senderReward?: number | null, receiverReward?: number | null, minimumPurchaseAmount?: number | null } | null } | null };

export type GqlGetLoyaltyPassUrlQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetLoyaltyPassUrlQuery = { __typename?: 'Query', getLoyaltyPassUrl?: { __typename?: 'LoyaltyPassUrl', url: string, shortUrl?: string | null } | null };

export type GqlGetRewardsV2QueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  cartSubtotal?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GqlGetRewardsV2Query = { __typename?: 'Query', getRewardsV2?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, isLoyaltyMember?: boolean | null, currentYearTierBalance?: string | null, expirationDate?: string | null, soonestExpiringBalance?: number | null, soonestExpirationDate?: string | null, tierName?: string | null, tierId?: number | null, posCustomerId?: string | null, posUniqueId?: string | null, isRevokedFromReferralProgram?: boolean | null, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, costV2: number, value: string, rewardType: string, discountId?: number | null, brand?: string | null, isRedeemableOnline?: boolean | null, isEligible?: boolean | null, allowStacking?: boolean | null } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null, rewardsActivity?: Array<{ __typename?: 'RewardsActivity', lspName?: string | null, location?: string | null, customerId?: string | null, transactionType?: string | null, transactionDateUtc?: string | null, points?: number | null, comment?: string | null, orderType?: string | null, isAdjustment?: boolean | null, totalPaid?: number | null, expirationDate?: string | null } | null> | null } | null };

export type GqlScheduleFieldsFragment = { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null };

export type GqlBulkEndSpecialsV2MutationVariables = Exact<{
  input: GqlEndSpecialsInput;
}>;


export type GqlBulkEndSpecialsV2Mutation = { __typename?: 'Mutation', bulkEndSpecialsV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateEnterpriseSpecialV2MutationVariables = Exact<{
  input: GqlEnterpriseSpecialInputV2;
}>;


export type GqlCreateEnterpriseSpecialV2Mutation = { __typename?: 'Mutation', createEnterpriseSpecialV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateSpecialV3MutationVariables = Exact<{
  input: GqlSpecialsInputV3;
}>;


export type GqlCreateSpecialV3Mutation = { __typename?: 'Mutation', createSpecialV3?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlDeleteEnterpriseSpecialMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GqlDeleteEnterpriseSpecialMutation = { __typename?: 'Mutation', deleteEnterpriseSpecial?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlDeleteSpecialV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteSpecialV2Mutation = { __typename?: 'Mutation', deleteSpecialV2?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlEndEnterpriseSpecialMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GqlEndEnterpriseSpecialMutation = { __typename?: 'Mutation', endEnterpriseSpecial?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlEndSpecialV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlEndSpecialV2Mutation = { __typename?: 'Mutation', endSpecialV2: { __typename?: 'Specials', _id?: string | null } };

export type GqlIncrementSpecialClicksMutationVariables = Exact<{
  input: GqlIncrementClicksInput;
}>;


export type GqlIncrementSpecialClicksMutation = { __typename?: 'Mutation', incrementClicks?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateEnterpriseSpecialV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlEnterpriseSpecialInputV2;
}>;


export type GqlUpdateEnterpriseSpecialV2Mutation = { __typename?: 'Mutation', updateEnterpriseSpecialV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateSpecialV3MutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlSpecialsInputV3;
}>;


export type GqlUpdateSpecialV3Mutation = { __typename?: 'Mutation', updateSpecialV3?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlUpdateSpecialsSortOrderMutationVariables = Exact<{
  input: GqlSortOrderInput;
}>;


export type GqlUpdateSpecialsSortOrderMutation = { __typename?: 'Mutation', updateSpecialsSortOrder?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlEnterpriseSpecialsV3QueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlFilteredSpecialsInputV2>;
}>;


export type GqlEnterpriseSpecialsV3Query = { __typename?: 'Query', enterpriseSpecialsV3?: { __typename?: 'FilteredEnterpriseSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, complete?: boolean | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, displayRank?: number | null, earliestStartStamp?: any | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, isRecurring?: boolean | null, latestEndStamp?: any | null, localTime?: boolean | null, menuDisplayDescription?: string | null, menuDisplayName?: string | null, menuDisplayImage?: string | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, dispensaries?: Array<string | null> | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlEnterpriseSpecialsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseSpecialsQuery = { __typename?: 'Query', enterpriseSpecials?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, isRecurring?: boolean | null, localTime?: boolean | null, menuDisplayDescription?: string | null, menuDisplayName?: string | null, menuDisplayImage?: string | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, dispensaries?: Array<string | null> | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, requiresSingleSku?: boolean | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null };

export type GqlFilteredSpecialsV2QueryVariables = Exact<{
  specialsFilter: GqlFilteredSpecialsInput;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlFilteredSpecialsV2Query = { __typename?: 'Query', filteredSpecialsV2?: { __typename?: 'FilteredSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, nonStackingBehavior?: string | null, platformType?: Array<PlatformType | null> | null, preOrderType?: Array<PreOrderType | null> | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'DiscountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlFilteredSpecialsQueryVariables = Exact<{
  specialsFilter: GqlFilteredSpecialsInput;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlFilteredSpecialsQuery = { __typename?: 'Query', filteredSpecials?: { __typename?: 'FilteredSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, nonStackingBehavior?: string | null, platformType?: Array<PlatformType | null> | null, preOrderType?: Array<PreOrderType | null> | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, parentId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, requiresSingleSku?: boolean | null, targetPrice?: string | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'DiscountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlGetSpecialGamificationQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GqlGetSpecialGamificationQuery = { __typename?: 'Query', getSpecialGamification?: { __typename?: 'SpecialGamificationList', gamificationThresholds?: Array<{ __typename?: 'GamificationDetailItem', discountId?: number | null, satisfiers?: Array<{ __typename?: 'GamificationDetailItem_Satisfier', thresholdType?: string | null, minimumThreshold?: number | null } | null> | null } | null> | null } | null };

export type GqlGetSpecialMenuCardsQueryVariables = Exact<{
  dispensaryId: Scalars['ID']['input'];
  menuType: Scalars['String']['input'];
  specialId?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetSpecialMenuCardsQuery = { __typename?: 'Query', getSpecialMenuCards?: { __typename?: 'SpecialMenuCardResponse', menuCards?: Array<{ __typename?: 'SpecialMenuCard', _id?: string | null, applicablePreOrderTypes?: Array<PreOrderType> | null, displayRank?: number | null, endStamp?: string | null, isBundledDiscount?: boolean | null, isRestricted?: boolean | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null, menuDisplayName?: string | null, posDiscountId?: string | null, parentId?: string | null, specialType?: string | null, startStamp?: string | null, applicableCategories?: Array<{ __typename?: 'SpecialApplicableCategory', category?: string | null, subcategories?: Array<string> | null }> | null, recurringSchedule?: { __typename?: 'SpecialRecurringSchedule', startTime?: string | null, endTime?: string | null } | null } | null> | null } | null };

export type GqlGetStockImageQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetStockImageQuery = { __typename?: 'Query', getStockImage?: { __typename?: 'StockImage', url: string } | null };

export type GqlCreateStrainV2MutationVariables = Exact<{
  input: GqlStrainInput;
}>;


export type GqlCreateStrainV2Mutation = { __typename?: 'Mutation', createStrainV2?: { __typename?: 'Strain', id: string } | null };

export type GqlDeleteStrainMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteStrainMutation = { __typename?: 'Mutation', deleteStrain?: { __typename?: 'Strain', id: string } | null };

export type GqlUpdateStrainV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlStrainInput;
}>;


export type GqlUpdateStrainV2Mutation = { __typename?: 'Mutation', updateStrainV2?: { __typename?: 'Strain', id: string } | null };

export type GqlFilteredStrainsQueryVariables = Exact<{
  filter?: InputMaybe<GqlStrainsFilterInput>;
  sort?: InputMaybe<GqlStrainsSortInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
}>;


export type GqlFilteredStrainsQuery = { __typename?: 'Query', filteredStrains?: { __typename?: 'StrainList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, strains?: Array<{ __typename?: 'Strain', description?: string | null, effects?: Array<string | null> | null, id: string, imageUrl?: string | null, name?: string | null, potentialHealthBenefits?: Array<string | null> | null } | null> | null } | null };

export type GqlGetStrainQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetStrainQuery = { __typename?: 'Query', getStrain?: { __typename?: 'Strain', aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, imageUrl?: string | null, labels?: Array<string | null> | null, name?: string | null, potentialHealthBenefits?: Array<string | null> | null, ratio?: string | null, terpenes?: Array<{ __typename?: 'Terpene', id: string, name?: string | null } | null> | null } | null };

export type GqlGetCustomerSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCustomerSubscriptionsQuery = { __typename?: 'Query', getCustomerSubscriptions: Array<{ __typename?: 'CustomerSubscription', dispensaryId?: string | null, dispensaryName?: string | null, emailOptIn?: boolean | null, emailSubscription?: boolean | null, id: string }> };

export type GqlGetUnsubscribeDispensaryQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GqlGetUnsubscribeDispensaryQuery = { __typename?: 'Query', unsubscribeCustomerQuery?: { __typename?: 'CustomerUnsubscribe', subscribed?: boolean | null, dispensary?: { __typename?: 'Dispensaries', name?: string | null, logoImage?: string | null } | null } | null };

export type GqlTerpeneFragmentFragment = { __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null };

export type GqlCreateTerpeneMutationVariables = Exact<{
  terpene: GqlTerpeneInput;
}>;


export type GqlCreateTerpeneMutation = { __typename?: 'Mutation', createTerpeneV2?: { __typename?: 'Terpene', id: string } | null };

export type GqlDeleteTerpeneMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteTerpeneMutation = { __typename?: 'Mutation', deleteTerpene?: { __typename?: 'Terpene', id: string } | null };

export type GqlUpdateTerpeneMutationVariables = Exact<{
  id: Scalars['String']['input'];
  terpene: GqlTerpeneInput;
}>;


export type GqlUpdateTerpeneMutation = { __typename?: 'Mutation', updateTerpeneV2?: { __typename?: 'Terpene', id: string } | null };

export type GqlFilteredTerpenesQueryVariables = Exact<{
  filter?: InputMaybe<GqlTerpenesFilter>;
  sort?: InputMaybe<GqlTerpenesSort>;
}>;


export type GqlFilteredTerpenesQuery = { __typename?: 'Query', filteredTerpenes?: Array<{ __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null, strains: Array<{ __typename?: 'Strain', _id?: string | null } | null> } | null> | null };

export type GqlGetTerpeneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetTerpeneQuery = { __typename?: 'Query', getTerpene?: { __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null } | null };

export type GqlAdminIdentityFragmentFragment = { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null };

export type GqlConsumerUserFragmentFragment = { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null };

export type GqlConsumerSignupMutationVariables = Exact<{
  input: GqlConsumerSignupInput;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlConsumerSignupMutation = { __typename?: 'Mutation', consumerSignup?: { __typename?: 'LoginConsumer', accessToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlCreateUserMutationVariables = Exact<{
  input: GqlUsersCreateInput;
}>;


export type GqlCreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'Users', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, chainID?: string | null, createdAt?: string | null, createdBy?: string | null, dispensaryId?: string | null, email?: string | null, fullName?: string | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, permissions?: { __typename?: 'Users_permissions', allLocations?: boolean | null, analytics?: boolean | null, billing?: boolean | null, customers?: boolean | null, dispensaryIds?: Array<string> | null, driver?: boolean | null, enterpriseAdmin?: boolean | null, menu?: boolean | null, menuReview?: boolean | null, orders?: boolean | null, promote?: boolean | null, settings?: boolean | null, superMenuReview?: boolean | null, users?: boolean | null } | null } | null };

export type GqlDeleteUserMutationVariables = Exact<{
  input: GqlUsersDeleteInput;
}>;


export type GqlDeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'Users', fullName?: string | null } | null };

export type GqlDevLoginAdminMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GqlDevLoginAdminMutation = { __typename?: 'Mutation', devLoginAdmin?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlDevLoginConsumerMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GqlDevLoginConsumerMutation = { __typename?: 'Mutation', devLoginConsumer?: { __typename?: 'LoginConsumer', accessToken?: string | null, transferToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlGenerateAdminTransferTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GqlGenerateAdminTransferTokenMutation = { __typename?: 'Mutation', generateAdminTransferToken?: { __typename?: 'AdminTransferToken', transferToken: string } | null };

export type GqlLoginAdminViaTokenMutationVariables = Exact<{
  transferToken: Scalars['String']['input'];
}>;


export type GqlLoginAdminViaTokenMutation = { __typename?: 'Mutation', loginAdminViaToken?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlLoginAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type GqlLoginAdminMutation = { __typename?: 'Mutation', loginAdmin?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlLoginConsumerMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlLoginConsumerMutation = { __typename?: 'Mutation', loginConsumer?: { __typename?: 'LoginConsumer', accessToken?: string | null, transferToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type GqlLogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendLoginCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlSendLoginCodeMutation = { __typename?: 'Mutation', sendLoginCode?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateUserMutationVariables = Exact<{
  input: GqlUsersUpdateInput;
}>;


export type GqlUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'Users', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, chainID?: string | null, createdAt?: string | null, createdBy?: string | null, dispensaryId?: string | null, email?: string | null, fullName?: string | null, isWeeklyReportEnabled?: boolean | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, permissions?: { __typename?: 'Users_permissions', allLocations?: boolean | null, analytics?: boolean | null, billing?: boolean | null, customers?: boolean | null, dispensaryIds?: Array<string> | null, driver?: boolean | null, enterpriseAdmin?: boolean | null, menu?: boolean | null, menuReview?: boolean | null, orders?: boolean | null, promote?: boolean | null, settings?: boolean | null, superMenuReview?: boolean | null, users?: boolean | null } | null } | null };

export type GqlVerifyLoginCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlVerifyLoginCodeMutation = { __typename?: 'Mutation', verifyLoginCode?: { __typename?: 'VerifyLoginCodeResponse', accessToken?: string | null, transferToken?: string | null, isNewUser?: boolean | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlDevAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlDevAccountsQuery = { __typename?: 'Query', devAccounts: Array<{ __typename?: 'DevAccount', id: string, email?: string | null, type?: string | null, label?: string | null }> };

export type GqlMeConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMeConsumerQuery = { __typename?: 'Query', meConsumer?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null };

export type GqlAnalyticsBrandsQueryQueryVariables = Exact<{
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsBrandsQueryQuery = { __typename?: 'Query', getFilteredBrandSummaries?: { __typename?: 'FilteredBrandSummaryResponse', brands?: Array<{ __typename?: 'BrandSummary', brandId?: string | null, brandName?: string | null, numProducts?: number | null, percentSales?: number | null, totalSalesCents?: number | null, percentChange?: number | null, centsChange?: number | null } | null> | null, meta?: { __typename?: 'AnalyticsMeta', totalCount?: number | null } | null } | null };

export type GqlAnalyticsExportBrandsMutationMutationVariables = Exact<{
  input: GqlBrandsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsExportBrandsMutationMutation = { __typename?: 'Mutation', exportFilteredBrandsSummaries?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetTrendingBrandsQueryQueryVariables = Exact<{
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlGetTrendingBrandsQueryQuery = { __typename?: 'Query', getTrendingBrands?: { __typename?: 'TrendingBrandsResponse', trending?: Array<{ __typename?: 'Trending', brandId?: string | null, brandName?: string | null, percentChangeFromLastPeriod?: number | null, dollarHistoryThisPeriod?: Array<{ __typename?: 'ChangeHistoryObject', date?: string | null, totalSales?: number | null } | null> | null } | null> | null } | null };

export type GqlGetDeliveryHeatmapOrdersQueryVariables = Exact<{
  input: GqlGetOrdersInput;
}>;


export type GqlGetDeliveryHeatmapOrdersQuery = { __typename?: 'Query', getOrders?: { __typename?: 'AdminOrderListType', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, orders?: Array<{ __typename?: 'AdminOrderType', _id: string, location?: { __typename?: 'Orders_location', lat?: number | null, lng?: number | null } | null, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', location?: { __typename?: 'Orders_location', lat?: number | null, lng?: number | null } | null } | null } | null> | null } | null };

export type GqlAnalyticsAbandonedCartsQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsAbandonedCartsQueryQuery = { __typename?: 'Query', getEcommerceAbandonedCarts?: { __typename?: 'EcommerceAbandonedCartsResponse', carts?: Array<{ __typename?: 'CartSummary', id: string, createdAt: any, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, valueInCents: number, products?: Array<{ __typename?: 'AbandonedCartProduct', name?: string | null, quantity?: number | null }> | null } | null> | null, meta?: { __typename?: 'AnalyticsMeta', totalCount?: number | null } | null } | null };

export type GqlAnalyticsExportCartsMutationMutationVariables = Exact<{
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsExportCartsMutationMutation = { __typename?: 'Mutation', exportFilteredCartsSummaries?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlAnalyticsMarketingCampaignsQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsMarketingCampaignsQueryQuery = { __typename?: 'Query', getMarketingCampaigns?: { __typename?: 'MarketingCampaignsResponse', campaigns?: Array<{ __typename?: 'CampaignSummary', utmCampaign?: string | null, utmSource?: string | null, utmMedium?: string | null, conversionPercentage?: number | null, conversionPercentageUnitChange?: number | null, averageOrderValue?: number | null, averageOrderValueChangePercentage?: number | null, totalSales?: number | null } | null> | null, meta?: { __typename?: 'AnalyticsMeta', totalCount?: number | null } | null } | null };

export type GqlAnalyticsMarketingCouponQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsMarketingCouponQueryQuery = { __typename?: 'Query', getMarketingCoupons?: { __typename?: 'MarketingCouponsResponse', coupons?: Array<{ __typename?: 'CouponSummary', couponId?: string | null, couponName?: string | null, revenue?: number | null, prevTotalSales?: number | null, currentUsage?: number | null, prevUsage?: number | null, averageOrderValue?: number | null, averageOrderValueChangePercentage?: number | null, averageUsageChangePercentage?: number | null, discount?: string | null } | null> | null, meta?: { __typename?: 'AnalyticsMeta', totalCount?: number | null } | null } | null };

export type GqlAnalyticsMarketingDataPointsQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
}>;


export type GqlAnalyticsMarketingDataPointsQueryQuery = { __typename?: 'Query', getMarketingDataPoints?: { __typename?: 'MarketingDataPointsResponse', totalCampaignsCents?: number | null, totalSpecialsCents?: number | null, totalCouponsCents?: number | null, marketingRevenue?: Array<{ __typename?: 'MarketingRevenue', date?: string | null, specialsCents?: number | null, couponsCents?: number | null } | null> | null } | null };

export type GqlAnalyticsExportCampaignsMutationMutationVariables = Exact<{
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsExportCampaignsMutationMutation = { __typename?: 'Mutation', exportFilteredCampaignsSummaries?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlAnalyticsExportCouponsMutationMutationVariables = Exact<{
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsExportCouponsMutationMutation = { __typename?: 'Mutation', exportCouponsSummaries?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlAnalyticsExportSpecialsMutationMutationVariables = Exact<{
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsExportSpecialsMutationMutation = { __typename?: 'Mutation', exportSpecialsSummaries?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlAnalyticsMarketingSpecialsQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsMarketingSpecialsQueryQuery = { __typename?: 'Query', getMarketingSpecials?: { __typename?: 'MarketingSpecialsResponse', specials?: Array<{ __typename?: 'SpecialSummary', specialId?: string | null, dispensaryId?: string | null, name?: string | null, type?: string | null, emailSent?: string | null, clickThroughPercentage?: number | null, conversionPercentage?: number | null, conversionChangePercentage?: number | null, averageOrderValue?: number | null, averageOrderValueChangePercentage?: number | null, totalSales?: number | null } | null> | null, meta?: { __typename?: 'AnalyticsMeta', totalCount?: number | null } | null } | null };

export type GqlAnalyticsMobileAppMostVisitedPagesQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlAnalyticsMobileAppMostVisitedPagesQueryQuery = { __typename?: 'Query', getMobileAppAnalyticsMostVisitedPages?: { __typename?: 'MobileAppAnalyticsMostVisitedPagesResponse', pages?: Array<{ __typename?: 'MobileAppMostVisitedPage', pagePath?: string | null, users?: number | null, views?: number | null } | null> | null } | null };

export type GqlAnalyticsMobileAppPageViewsQueryQueryVariables = Exact<{
  input: GqlAnalyticsInput;
}>;


export type GqlAnalyticsMobileAppPageViewsQueryQuery = { __typename?: 'Query', getMobileAppAnalyticsPageViews?: { __typename?: 'MobileAppAnalyticsPageViewsResponse', daily?: Array<{ __typename?: 'MobileAppDailyDataPoint', date?: string | null, pageViews?: number | null, sessions?: number | null, totalDownloads?: number | null, users?: number | null } | null> | null } | null };

export type GqlAnalyticsExportProductsMutationMutationVariables = Exact<{
  input: GqlProductsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsExportProductsMutationMutation = { __typename?: 'Mutation', exportFilteredProductSummaries?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlAnalyticsProductsQueryQueryVariables = Exact<{
  input: GqlProductsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
}>;


export type GqlAnalyticsProductsQueryQuery = { __typename?: 'Query', getFilteredProductSummaries?: { __typename?: 'FilteredProductSummaryResponse', products?: Array<{ __typename?: 'ProductSummary', productId?: string | null, productName?: string | null, brandId?: string | null, brandName?: string | null, category?: string | null, strainType?: string | null, sales?: number | null, percentChange?: number | null, dollarChange?: number | null, dispensaryId?: string | null, numSold?: number | null } | null> | null, meta?: { __typename?: 'AnalyticsMeta', totalCount?: number | null } | null } | null };

export type GqlSalesOrdersQueryQueryVariables = Exact<{
  input: GqlSharedSalesInput;
}>;


export type GqlSalesOrdersQueryQuery = { __typename?: 'Query', salesOrdersQuery?: { __typename?: 'salesOrdersQueryResponse', totalOrders?: number | null, totalSales?: number | null, revenueChange?: number | null, percentChange?: number | null, ordersByDate?: Array<{ __typename?: 'AnalyticsOrdersByDate', date?: string | null, totalOrders?: number | null, totalSales?: number | null } | null> | null } | null };

export type GqlGetProductSalesByCategoryQueryVariables = Exact<{
  input: GqlSharedSalesInput;
}>;


export type GqlGetProductSalesByCategoryQuery = { __typename?: 'Query', getProductSalesByCategory?: { __typename?: 'ProductsSalesByCategory', totalSales?: number | null, categoryOptions?: Array<{ __typename?: 'DropdownOption', key?: string | null, label?: string | null, value?: string | null } | null> | null, lineItems?: Array<{ __typename?: 'CategoryLineItem', price?: number | null, productType?: string | null, categoryOption?: string | null, totalSales?: number | null, percentOfTotal?: number | null } | null> | null } | null };

export type GqlGetTopProductQueryVariables = Exact<{
  input: GqlSharedSalesInput;
}>;


export type GqlGetTopProductQuery = { __typename?: 'Query', getTopProduct?: { __typename?: 'TopProduct', total?: number | null, product?: { __typename?: 'Products', brandId?: string | null, brandLogo?: string | null, Image?: string | null, Name?: string | null, stockImage?: string | null, strainType?: string | null, type?: string | null, brand?: { __typename?: 'Brand', id: string, name: string, imageUrl?: string | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean }> | null } | null } | null };

export type GqlCreateDispensaryBrandMutationVariables = Exact<{
  name: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlCreateDispensaryBrandMutation = { __typename?: 'Mutation', createBrandV2?: { __typename?: 'Brand', id: string, name: string } | null };

export type GqlCopyableSettingLocationsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  dispensaryId: Scalars['ID']['input'];
  settingPath: Scalars['String']['input'];
}>;


export type GqlCopyableSettingLocationsQuery = { __typename?: 'Query', copyableSettingLocations?: { __typename?: 'CopyableSettingLocationsResponse', settingPath: string, source: { __typename?: 'CopyableSettingLocation', dispensaryId: string, name: string, isSource: boolean, isSet: boolean, valueJson?: string | null, comparisonStatus: SettingComparisonStatus, canSync: boolean, unavailableReason?: string | null }, locations: Array<{ __typename?: 'CopyableSettingLocation', dispensaryId: string, name: string, isSource: boolean, isSet: boolean, valueJson?: string | null, comparisonStatus: SettingComparisonStatus, canSync: boolean, unavailableReason?: string | null }> } | null };

export type GqlCopyableSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlCopyableSettingsQuery = { __typename?: 'Query', copyableSettings?: { __typename?: 'CopyableSettingsConfig', allowedPrefixes: Array<string>, allowedPaths: Array<string>, keyedArrays: any, deniedPaths: Array<string>, superAdminOnlyPrefixes: Array<string> } | null };

export type GqlBrandsForDropdownByIdsQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GqlBrandsForDropdownByIdsQuery = { __typename?: 'Query', getBrandsV2?: Array<{ __typename?: 'Brand', _id: string, id: string, name: string, imageUrl?: string | null } | null> | null };

export type GqlGetMenuFiltersQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetMenuFiltersQuery = { __typename?: 'Query', menuFiltersV2?: { __typename?: 'MenuFilters', strainTypes: Array<string | null>, weights: Array<string | null>, effects: Array<string | null>, brands: Array<{ __typename?: 'Brand', id: string, name: string } | null>, categoriesSubcategories: Array<{ __typename?: 'CategorySubcategories', category: string, subcategories: Array<string> }> } | null };

export type GqlGetCollectionsProductsQueryVariables = Exact<{
  filter: GqlProductsFilterInput;
}>;


export type GqlGetCollectionsProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', Name?: string | null, id?: string | null, type?: string | null, subcategory?: string | null, Status?: string | null } | null> } | null };

export type GqlGetCollectionsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlGetCollectionsQuery = { __typename?: 'Query', getCollections: Array<{ __typename?: 'Collection', id: string, slug: string, dispensaryId: string, title: string, description?: string | null, allConditions: boolean, productCount: number, position?: number | null, image?: string | null, cardImage?: string | null, cardBadgeColor?: string | null, cardBadgeEnabled: boolean, cardBadgeTitle?: string | null, cardDisplayName?: string | null, navigationEnabled: boolean, navigationTitle?: string | null, channels?: Array<CollectionChannel> | null, customCategory?: boolean | null, isOutlet?: boolean | null, outletTimerEnabled?: boolean | null, outletTimerMessage?: string | null, enabled?: boolean | null, isActive?: boolean | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null, onSaleOnly?: boolean | null, matchAllAudienceConditions?: boolean | null, conditions: Array<{ __typename?: 'Condition', id: string, condition: string, itemKey: string, itemValue: string, productCollectionId: string }>, schedule?: { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null } | null, audienceConditions?: Array<{ __typename?: 'AudienceCondition', segmentId: string }> | null }> };

export type GqlGetCollectionQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlGetCollectionQuery = { __typename?: 'Query', getCollection: { __typename?: 'Collection', id: string, slug: string, dispensaryId: string, title: string, description?: string | null, allConditions: boolean, productCount: number, position?: number | null, image?: string | null, cardImage?: string | null, cardBadgeColor?: string | null, cardBadgeEnabled: boolean, cardBadgeTitle?: string | null, cardDisplayName?: string | null, navigationEnabled: boolean, navigationTitle?: string | null, channels?: Array<CollectionChannel> | null, customCategory?: boolean | null, isOutlet?: boolean | null, outletTimerEnabled?: boolean | null, outletTimerMessage?: string | null, enabled?: boolean | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null, onSaleOnly?: boolean | null, matchAllAudienceConditions?: boolean | null, conditions: Array<{ __typename?: 'Condition', id: string, condition: string, itemKey: string, itemValue: string, productCollectionId: string }>, schedule?: { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null } | null, audienceConditions?: Array<{ __typename?: 'AudienceCondition', segmentId: string }> | null } };

export type GqlGetCollectionsNavigationQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlGetCollectionsNavigationQuery = { __typename?: 'Query', getCollectionsNavigation: Array<{ __typename?: 'Collection', id: string, customCategory?: boolean | null, enabled?: boolean | null, isActive?: boolean | null, schedule?: { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null } | null }> };

export type GqlCreateCollectionMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateCollectionInput;
}>;


export type GqlCreateCollectionMutation = { __typename?: 'Mutation', createCollection: { __typename?: 'Collection', id: string, slug: string, dispensaryId: string, title: string, description?: string | null, allConditions: boolean, productCount: number, image?: string | null, cardImage?: string | null, cardBadgeColor?: string | null, cardBadgeEnabled: boolean, cardBadgeTitle?: string | null, cardDisplayName?: string | null, navigationEnabled: boolean, navigationTitle?: string | null, channels?: Array<CollectionChannel> | null, customCategory?: boolean | null, isOutlet?: boolean | null, outletTimerEnabled?: boolean | null, outletTimerMessage?: string | null, enabled?: boolean | null, isActive?: boolean | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null, onSaleOnly?: boolean | null, matchAllAudienceConditions?: boolean | null, conditions: Array<{ __typename?: 'Condition', id: string, condition: string, itemKey: string, itemValue: string, productCollectionId: string }>, schedule?: { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null } | null, audienceConditions?: Array<{ __typename?: 'AudienceCondition', segmentId: string }> | null } };

export type GqlUpdateCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  input: GqlUpdateCollectionInput;
}>;


export type GqlUpdateCollectionMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'Collection', id: string, slug: string, dispensaryId: string, title: string, description?: string | null, allConditions: boolean, productCount: number, image?: string | null, cardImage?: string | null, cardBadgeColor?: string | null, cardBadgeEnabled: boolean, cardBadgeTitle?: string | null, cardDisplayName?: string | null, navigationEnabled: boolean, navigationTitle?: string | null, channels?: Array<CollectionChannel> | null, customCategory?: boolean | null, isOutlet?: boolean | null, outletTimerEnabled?: boolean | null, outletTimerMessage?: string | null, enabled?: boolean | null, isActive?: boolean | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null, onSaleOnly?: boolean | null, matchAllAudienceConditions?: boolean | null, conditions: Array<{ __typename?: 'Condition', id: string, condition: string, itemKey: string, itemValue: string, productCollectionId: string }>, schedule?: { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null } | null, audienceConditions?: Array<{ __typename?: 'AudienceCondition', segmentId: string }> | null } };

export type GqlUpdateCollectionPositionsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateCollectionPositionsInput;
}>;


export type GqlUpdateCollectionPositionsMutation = { __typename?: 'Mutation', updateCollectionPositions: Array<{ __typename?: 'Collection', id: string, position?: number | null }> };

export type GqlDeleteCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
}>;


export type GqlDeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlGetCollectionProductCountQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  input: GqlGetCollectionProductCountInput;
}>;


export type GqlGetCollectionProductCountQuery = { __typename?: 'Query', getCollectionProductCount: { __typename?: 'CollectionProductCount', id?: string | null, productCount: number } };

export type GqlAvailableSegmentsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlAvailableSegmentsQuery = { __typename?: 'Query', availableSegments: Array<{ __typename?: 'Segment', id: string, name: string, audienceCount: number }> };

export type GqlGetCarouselProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
}>;


export type GqlGetCarouselProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, avgRating?: number | null, reviewCount?: number | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, posDiscountNames?: Array<string | null> | null, POSPricingData?: any | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, subcategories?: Array<string | null> | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, productCardSpecials?: Array<{ __typename?: 'ProductCardSpecial', id: string, name: string, description?: string | null, startDate?: string | null, endDate?: string | null, kind: ProductCardSpecialKind, menuType: ProductCardSpecialMenuType }> | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, legacyPricing?: { __typename?: 'Products_LegacyPricing', medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, Prices?: Array<number | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> } | null };

export type GqlGetCustomNavigationQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetCustomNavigationQuery = { __typename?: 'Query', getCustomNavigation?: { __typename?: 'CustomNavigation', dispensaryId: string, enabled: boolean, id: string, label: string, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null }> }> }> }> } | null };

export type GqlSaveCustomNavigationMutationVariables = Exact<{
  input: GqlSaveCustomNavigationInput;
}>;


export type GqlSaveCustomNavigationMutation = { __typename?: 'Mutation', saveCustomNavigation?: { __typename?: 'CustomNavigation', dispensaryId: string, id: string, label: string, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null, items: Array<{ __typename?: 'CustomNavigationItem', connectedId?: string | null, id: string, label: string, navigationType: CustomNavigationItemType, openInNewTab?: boolean | null, position: number, url?: string | null }> }> }> }> } | null };

export type GqlGetMenuCustomizationQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetMenuCustomizationQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', menuBannerHtml?: string | null, menuBannerColor?: string | null, menuBannerTextBannerCollapsed?: boolean | null, ageVerificationBannerHtml?: string | null, ageVerificationBannerColor?: string | null, webCustomizationSettings?: { __typename?: 'WebCustomizationSettings', colorSettings: { __typename?: 'ColorSettingsV2', navBarColor: NavBarColor, linkColor: LinkColor }, fontSettings: { __typename?: 'FontSettings', family: CustomFont } } | null, webCustomizationSettingsV2?: { __typename?: 'WebCustomizationSettingsV2', colors?: { __typename?: 'Colors', navBar?: string | null, buttonsLinks?: string | null, staffPickTag?: string | null, discountTag?: string | null, productCardButton?: ProductCardButtonOption | null, strainTypes?: { __typename?: 'StrainTypeColors', cbd?: string | null, cbg?: string | null, default?: string | null, highCBD?: string | null, hybrid?: string | null, indica?: string | null, indicaHybrid?: string | null, sativa?: string | null, sativaHybrid?: string | null, seed?: string | null, thc?: string | null } | null } | null, fonts?: { __typename?: 'Fonts', heading?: string | null, body?: string | null } | null, mobile?: { __typename?: 'MobileCustomization', backgroundColor?: string | null, backgroundFlair?: MobileAppFlair | null, buttonFlair?: MobileAppFlair | null, dividerFlair?: MobileAppFlair | null, loadingFlair?: MobileAppFlair | null, headerBackgroundColor?: string | null, headerImageUrl?: string | null, headerImageUrlV2?: string | null, bottomBarActiveColor?: string | null, bottomBarBackgroundColor?: string | null, bottomBarInactiveColor?: string | null, bottomBarStyle?: MobileNavigationStyle | null, headerNavigationStyle?: MobileNavigationStyle | null, showTabLabels?: boolean | null, titleFlair?: MobileAppFlair | null, titleFlairColor?: string | null, tabDisplay?: { __typename?: 'MobileCustomizationTabDisplay', showCart?: boolean | null, showConcierge?: boolean | null, showLoyalty?: boolean | null, showPay?: boolean | null, showSpecials?: boolean | null } | null, tabLabels?: { __typename?: 'MobileCustomizationTabLabels', account?: string | null, cart?: string | null, concierge?: string | null, loyalty?: string | null, more?: string | null, pay?: string | null, shop?: string | null, specials?: string | null } | null } | null, textTransforms?: { __typename?: 'TextTransforms', buttons?: TextTransformOption | null, links?: TextTransformOption | null, tags?: TextTransformOption | null } | null, radius?: { __typename?: 'Radius', default?: RadiusOption | null } | null, categories?: { __typename?: 'CustomizedCategories', type?: CategoriesTypeOption | null, style?: RadiusOption | null, mobileDisplay?: CategoriesMobileDisplayOption | null, items?: Array<{ __typename?: 'CustomizedCategory', category: string, image: string, collectionId?: string | null, cardImage?: string | null, cardDisplayName?: string | null, isOutlet?: boolean | null } | null> | null } | null, productCards?: { __typename?: 'ProductCards', defaultViewLarge?: ProductCardDefaultViewOption | null, defaultViewSmall?: ProductCardDefaultViewOption | null, fullWidthImages?: boolean | null, showProductWeight?: boolean | null, textAlignment?: ProductCardTextAlignmentOption | null, disableProductCardImageCycling?: boolean | null, mobileAppDisplayOptions?: { __typename?: 'ProductCardDisplayOptions', backgroundColor?: string | null, brandColor?: string | null, buttonDisplay?: ProductCardButtonOption | null, potencyColor?: string | null, potencyDisplay?: ProductCardPillDisplay | null, priceColor?: string | null, productNameColor?: string | null, showCollection?: boolean | null, showDiscountNames?: boolean | null, showEffects?: boolean | null, showPotencyDetails?: boolean | null, showProductWeight?: boolean | null, showStaffPick?: boolean | null, showStrainType?: boolean | null, strainTypeDisplay?: ProductCardPillDisplay | null, strikethroughPriceColor?: string | null, weightColor?: string | null } | null } | null, concierge?: { __typename?: 'ConciergeCustomization', accentColorHex?: string | null, canvasColorHex?: string | null } | null } | null, embedSettings?: { __typename?: 'Dispensaries_profile_embed_settings', disclaimerTextHtml?: string | null } | null, categoryPhotos?: Array<{ __typename?: 'CategoryPhoto', src?: string | null, category?: string | null } | null> | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null } | null, imageBanners?: Array<{ __typename?: 'ImageBanner', _id: string, image: string, mobileImage: string, alt?: string | null, link?: string | null, openInNewTab?: boolean | null, bannerType?: ImageBannerType | null, connectedId?: string | null, connectedType?: string | null, position: number, isActive?: boolean | null, platforms?: Array<{ __typename?: 'ImageBannerPlatform', enabled: boolean, link?: string | null, openInNewTab?: boolean | null, type: ImageBannerPlatformType } | null> | null, schedule?: { __typename?: 'Schedule', id: string, startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', dayOfWeek: number, startTime: string, endTime: string }> | null } | null } | null> | null, remoteExtensions?: { __typename?: 'RemoteExtensions', theme?: { __typename?: 'RemoteExtensionsConfiguration', manifestUrl?: string | null, modulePath?: string | null, scope?: string | null, extensionData?: Array<{ __typename?: 'ExtensionData', key: string, value: string }> | null } | null } | null } | null> | null, getCollections: Array<{ __typename?: 'Collection', id: string, title: string, image?: string | null, cardImage?: string | null, cardDisplayName?: string | null, customCategory?: boolean | null, isOutlet?: boolean | null }> };

export type GqlUpdateMenuCustomizationMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  menuBannerHtml?: InputMaybe<Scalars['String']['input']>;
  menuBannerColor?: InputMaybe<Scalars['String']['input']>;
  menuBannerTextBannerCollapsed?: InputMaybe<Scalars['Boolean']['input']>;
  ageVerificationBannerHtml?: InputMaybe<Scalars['String']['input']>;
  ageVerificationBannerColor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateMenuCustomizationMutation = { __typename?: 'Mutation', dispensaryUpdate?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateWebCustomizationSettingsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsInput;
}>;


export type GqlUpdateWebCustomizationSettingsMutation = { __typename?: 'Mutation', updateWebCustomizationSettings?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateWebCustomizationSettingsV2MutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
}>;


export type GqlUpdateWebCustomizationSettingsV2Mutation = { __typename?: 'Mutation', updateWebCustomizationSettingsV2?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateEnterpriseWebCustomizationSettingsV2MutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlUpdateEnterpriseWebCustomizationSettingsV2Mutation = { __typename?: 'Mutation', updateEnterpriseWebCustomizationSettingsV2?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateRemoteExtensionsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  input: GqlUpdateRemoteExtensionsInput;
}>;


export type GqlUpdateRemoteExtensionsMutation = { __typename?: 'Mutation', updateRemoteExtensions?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateImageBannersMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateImageBannersInput;
}>;


export type GqlUpdateImageBannersMutation = { __typename?: 'Mutation', updateImageBanners?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateMenuSectionsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  menuSections?: InputMaybe<Array<GqlMenuSectionBulkUpdateInput> | GqlMenuSectionBulkUpdateInput>;
  deletes?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GqlUpdateMenuSectionsMutation = { __typename?: 'Mutation', bulkUpdateMenuSections?: Array<{ __typename?: 'MenuSection', id: string } | null> | null };

export type GqlGetCollectionsForEmbedQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetCollectionsForEmbedQuery = { __typename?: 'Query', getCollections: Array<{ __typename?: 'Collection', id: string, title: string, enabled?: boolean | null }> };

export type GqlGetMenuSectionsForEmbedQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetMenuSectionsForEmbedQuery = { __typename?: 'Query', getMenuSectionsAdmin?: Array<{ __typename?: 'MenuSection', id: string, label: string, sectionType: MenuSectionType, collectionId?: string | null } | null> | null };

export type GqlCreateMenuSectionMutationVariables = Exact<{
  menuSection: GqlMenuSectionCreateInput;
}>;


export type GqlCreateMenuSectionMutation = { __typename?: 'Mutation', createMenuSection?: { __typename?: 'MenuSection', id: string } | null };

export type GqlDestroyMenuSectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlDestroyMenuSectionMutation = { __typename?: 'Mutation', destroyMenuSection?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlGetMenuSectionProductsAdminQueryVariables = Exact<{
  filter: GqlProductsFilterInput;
}>;


export type GqlGetMenuSectionProductsAdminQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', Name?: string | null, _id?: string | null, id?: string | null, type?: string | null, subcategory?: string | null, special?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, collections?: Array<{ __typename?: 'Products_Collection', id?: string | null } | null> | null, featured?: { __typename?: 'Products_featured', current?: boolean | null } | null } | null> } | null };

export type GqlGetMenuSectionsAdminQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetMenuSectionsAdminQuery = { __typename?: 'Query', getMenuSectionsAdmin?: Array<{ __typename?: 'MenuSection', brandId?: string | null, category?: string | null, id: string, headingOverride?: string | null, label: string, legacyLabel?: string | null, linkLabel: string, position: number, subcategory?: string | null, sectionType: MenuSectionType, sectionName?: string | null, products?: Array<string> | null, collectionId?: string | null, sortBy?: string | null, mobileAppDisplayType?: MobileAppProductCollectionDisplayType | null, mobileAppFlairType?: MobileAppFlair | null, image?: { __typename?: 'ImageBanner', _id: string, image: string, mobileImage: string, alt?: string | null, link?: string | null, openInNewTab?: boolean | null, position: number, platforms?: Array<{ __typename?: 'ImageBannerPlatform', enabled: boolean, link?: string | null, openInNewTab?: boolean | null, type: ImageBannerPlatformType } | null> | null } | null, collectionSchedule?: { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null } | null } | null> | null };

export type GqlSortMenuSectionsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GqlSortMenuSectionsMutation = { __typename?: 'Mutation', sortMenuSections?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateMenuSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  menuSection: GqlMenuSectionUpdateInput;
}>;


export type GqlUpdateMenuSectionMutation = { __typename?: 'Mutation', updateMenuSection?: { __typename?: 'MenuSection', id: string } | null };

export type GqlAdminIndexProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlAdminIndexProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, brandName?: string | null, CBD?: string | null, Description?: string | null, DispensaryID?: string | null, duplicatedProductId?: string | null, effects?: any | null, medicalOnly?: boolean | null, Name?: string | null, Options?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, medicalPrices?: Array<number | null> | null, Prices?: Array<number | null> | null, score?: number | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, updatedAt?: any | null, THC?: string | null, type?: string | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, forcedPotencyUnit?: string | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, active: boolean }> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string } | null } | null> | null } | null>, queryInfo: { __typename?: 'queryInfoType', totalCount?: number | null } } | null };

export type GqlDisconnectProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDisconnectProductMutation = { __typename?: 'Mutation', disconnectProduct?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSetGlobalMenuOrderMutationVariables = Exact<{
  input: GqlSetGlobalMenuOrderInput;
}>;


export type GqlSetGlobalMenuOrderMutation = { __typename?: 'Mutation', setGlobalMenuOrder: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlSetCategoryMenuOrderMutationVariables = Exact<{
  input: GqlSetCategoryMenuOrderInput;
}>;


export type GqlSetCategoryMenuOrderMutation = { __typename?: 'Mutation', setCategoryMenuOrder: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlRemoveCategoryMenuOrderMutationVariables = Exact<{
  input: GqlRemoveCategoryMenuOrderInput;
}>;


export type GqlRemoveCategoryMenuOrderMutation = { __typename?: 'Mutation', removeCategoryMenuOrder: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlSetCategoryFeaturedProductsMutationVariables = Exact<{
  input: GqlSetCategoryFeaturedProductsInput;
}>;


export type GqlSetCategoryFeaturedProductsMutation = { __typename?: 'Mutation', setCategoryFeaturedProducts: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlSetCategoryFeaturedBrandsMutationVariables = Exact<{
  input: GqlSetCategoryFeaturedBrandsInput;
}>;


export type GqlSetCategoryFeaturedBrandsMutation = { __typename?: 'Mutation', setCategoryFeaturedBrands: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlUpdateProductStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateProductStatusMutation = { __typename?: 'Mutation', updateProductStatus?: { __typename?: 'Products', _id?: string | null, id?: string | null, Status?: string | null } | null };

export type GqlDeleteArchivedProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteArchivedProductMutation = { __typename?: 'Mutation', deleteArchivedProduct?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlAdminMenuFiltersQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  pricingType?: InputMaybe<MenuPricingTypes>;
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlAdminMenuFiltersQuery = { __typename?: 'Query', menuFiltersV2?: { __typename?: 'MenuFilters', strainTypes: Array<string | null>, brands: Array<{ __typename?: 'Brand', id: string, name: string } | null>, categoriesSubcategories: Array<{ __typename?: 'CategorySubcategories', category: string, subcategories: Array<string> }> } | null };

export type GqlGetOrdersForMessagingQueryVariables = Exact<{
  input: GqlGetOrdersInput;
}>;


export type GqlGetOrdersForMessagingQuery = { __typename?: 'Query', getOrders?: { __typename?: 'AdminOrderListType', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, orders?: Array<{ __typename?: 'AdminOrderType', createdAt?: any | null, customerId?: string | null, customerEmail?: string | null, customerName?: string | null, customerPhone?: string | null, dispensaryId?: string | null, _id: string, orderId?: string | null, status?: string | null } | null> | null } | null };

export type GqlCreateOrderingSuspensionV2MutationVariables = Exact<{
  dispensaryId: Scalars['ID']['input'];
}>;


export type GqlCreateOrderingSuspensionV2Mutation = { __typename?: 'Mutation', createOrderingSuspensionV2?: { __typename?: 'OrderingSuspension', id: string } | null };

export type GqlEndOrderingSuspensionV2MutationVariables = Exact<{
  dispensaryId: Scalars['ID']['input'];
}>;


export type GqlEndOrderingSuspensionV2Mutation = { __typename?: 'Mutation', endOrderingSuspensionV2?: { __typename?: 'OrderingSuspension', id: string } | null };

export type GqlGetOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'GetOrderType', archived?: boolean | null, order?: { __typename?: 'Orders', createdAt?: string | null, credit?: number | null, deliveryFee?: number | null, driversLicense?: string | null, id?: string | null, mixAndMatch?: number | null, medicalOrder?: boolean | null, otherFees?: number | null, orderId?: string | null, specialInstructions?: string | null, status?: string | null, statusTimes?: Array<string | null> | null, taxAmount?: number | null, cannabisTax?: number | null, bottleDepositTaxCents?: number | null, tipAmount?: number | null, paymentFee?: number | null, paymentMethod?: string | null, subtotal?: string | null, totalCost?: string | null, isAfterHoursOrder?: boolean | null, isAnonymous?: boolean | null, isGuestOrder?: boolean | null, isPreviewOrder?: boolean | null, isKioskOrder?: boolean | null, originKioskId?: string | null, kioskName?: string | null, isCurbsidePickupOrder?: boolean | null, isDriveThruPickupOrder?: boolean | null, terminal?: string | null, autoConfirmed?: boolean | null, autoClosed?: boolean | null, driverName?: string | null, driverNumber?: string | null, isArchived?: boolean | null, archivedBy?: string | null, archivedAtISO?: any | null, cancellationReason?: string | null, updatedAt?: string | null, receipt?: any | null, coupon?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, percentDiscount?: number | null, fixedDiscountInCents?: number | null, code?: string | null, dispensary?: string | null, expDate?: string | null, numAllowedUses?: number | null, numUses?: number | null, usedBy?: Array<string | null> | null } | null, manualDiscount?: { __typename?: 'Orders_manualDiscount', fixedDiscountInCents?: number | null, percentDiscount?: number | null } | null, curbsideArrivalInfo?: { __typename?: 'CurbsideArrival', arrivalInformation?: string | null } | null, dispensary?: { __typename?: 'Orders_dispensary', _id?: string | null, name?: string | null, cName?: string | null, phone?: string | null, logoImage?: string | null, address?: string | null, timezone?: string | null, payByBankManualFinalizationAvailable?: boolean | null, featureFlags?: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null } | null, retailer?: { __typename?: 'Retailer', enterpriseId?: string | null } | null } | null, customer?: { __typename?: 'Orders_customer', _id?: string | null, emails?: Array<{ __typename?: 'Orders_customer_emails', address?: string | null } | null> | null, profile?: { __typename?: 'Orders_customer_profile', driversLicense?: string | null, photoId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthday?: string | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null } | null } | null, pos?: { __typename?: 'Orders_POS', name?: string | null, externalID?: string | null, failureType?: string | null, failureReason?: string | null, humanReadableError?: string | null, failureAcks?: { __typename?: 'Orders_POS_FailureLocations', web?: boolean | null, terminal?: boolean | null } | null } | null, fleetManagementTask?: { __typename?: 'Orders_fleetManagementTask', adapter?: string | null, id?: string | null } | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthMonth?: string | null, birthDay?: string | null, birthYear?: string | null, photoId?: string | null } | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null, orders: Array<{ __typename?: 'Orders_order', basePrice?: number | null, option?: string | null, price?: number | null, additionalOption?: string | null, quantity?: number | null, product?: { __typename?: 'Order_product', _id?: string | null, Name?: string | null, Image?: string | null, strainType?: string | null, type?: string | null, subcategory?: string | null, Options?: Array<string | null> | null, brandId?: string | null, brandName?: string | null, AdditionalOptions?: Array<string | null> | null, Prices?: Array<number | null> | null, preTaxRecPrices?: Array<number | null> | null, preTaxMedPrices?: Array<number | null> | null, brand?: { __typename?: 'Brand', _id: string, name: string } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, value?: string | null, range?: Array<number | null> | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, value?: string | null, range?: Array<number | null> | null } | null } | null }>, statusEvents?: Array<{ __typename?: 'OrderStatusEvents', event?: string | null, at?: string | null, by?: string | null, byType?: string | null, agentName?: string | null } | null> | null, dutchiePay?: { __typename?: 'DutchiePay', preAuth?: { __typename?: 'DutchiePayPreAuth', paymentId: string } | null } | null, voiceCallInfo?: { __typename?: 'VoiceCallInfo', callId?: string | null, assistantId?: string | null } | null, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null, location?: { __typename?: 'Orders_location', lat?: number | null, lng?: number | null, ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | null, editEvents?: Array<{ __typename?: 'OrderEditEvents', at?: string | null, by?: string | null, byType?: string | null, agentName?: string | null } | null> | null, hypur?: { __typename?: 'HypurDetails', id: string } | null, paysafe?: { __typename?: 'PaysafeDetails', card?: { __typename?: 'PaysafeCard', type?: string | null, lastDigits?: string | null } | null, authorizations?: Array<{ __typename?: 'PaysafeAuthorizations', id?: string | null, amount?: string | null } | null> | null, settlements?: Array<{ __typename?: 'PaysafeSettlements', id?: string | null, amount?: string | null, cancelled?: boolean | null } | null> | null, refunds?: Array<{ __typename?: 'PaysafeRefunds', id?: string | null, amount?: string | null } | null> | null } | null, moneris?: Array<{ __typename?: 'MonerisDetails', id: string, status: string, transactionNumber: string, card: { __typename?: 'MonerisCard', brand?: string | null, lastDigits?: string | null } } | null> | null, appliedRewards?: Array<{ __typename?: 'Reward', copy?: string | null, value?: string | null, operator?: string | null, brand?: string | null, redemptionAttempts?: Array<{ __typename?: 'RewardRedemptionResponse', status?: RewardStatus | null, redeemBy?: RewardRedeemBy | null, programResponse?: { __typename?: 'ProgramResponse', rewardRedemption?: { __typename?: 'RewardRedemptionDetails', id?: number | null, createdAt?: string | null, name?: string | null, description?: string | null } | null } | null } | null> | null } | null> | null, reservation?: { __typename?: 'OrderReservation', startTimeISO?: any | null, endTimeISO?: any | null } | null } | null } | null };

export type GqlGetPayByBankFinalizationStatusForAdminQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type GqlGetPayByBankFinalizationStatusForAdminQuery = { __typename?: 'Query', getPayByBankFinalizationStatus: { __typename?: 'PayByBankFinalizationStatusResult', status: PayByBankFinalizationStatus } };

export type GqlStartPayByBankFinalizationForAdminMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type GqlStartPayByBankFinalizationForAdminMutation = { __typename?: 'Mutation', startPayByBankFinalization: { __typename?: 'StartPayByBankFinalizationResult', status: PayByBankFinalizationStatus } };

export type GqlCreatePrintJobMutationVariables = Exact<{
  input: GqlCreatePrintJobInput;
}>;


export type GqlCreatePrintJobMutation = { __typename?: 'Mutation', createPrintJob: { __typename?: 'CreatePrintJobResponse', success: boolean, printJob: { __typename?: 'PrintJob', _id: string, referenceId: string, dispensaryId: string, printAfter: any, assignedToPrinterId?: string | null, createdAt: any, updatedAt: any } } };

export type GqlFilteredCouponsForDispensaryAdminQueryVariables = Exact<{
  filter?: InputMaybe<GqlCouponsFilterInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
}>;


export type GqlFilteredCouponsForDispensaryAdminQuery = { __typename?: 'Query', filteredCoupons?: { __typename?: 'CouponList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, coupons?: Array<{ __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensary?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, reimbursed?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null> | null } | null };

export type GqlEnterpriseSpecialDataFragment = { __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, complete?: boolean | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, dispensaries?: Array<string | null> | null, duplicatedFrom?: string | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, id?: string | null, inactiveDispensaries?: Array<string | null> | null, isRecurring?: boolean | null, localTime?: boolean | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, specialType?: SpecialTypes | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, displayRank?: boolean | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weight?: string | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, quantity?: number | null, targetPrice?: string | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null };

export type GqlSpecialDataFragment = { __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productTags?: Array<string> | null, productIds?: Array<string | null> | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, targetPrice?: string | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null };

export type GqlAdminEnterpriseProductsV2QueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlAdminEnterpriseProductsV2Query = { __typename?: 'Query', enterpriseProductsV2?: { __typename?: 'EnterpriseProducts', products?: Array<{ __typename?: 'EnterpriseProduct', brandId?: string | null, brandName?: string | null, enterpriseProductId?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, name?: string | null, options?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, subcategory?: string | null, type?: string | null, dispensaryProducts?: Array<{ __typename?: 'EnterpriseDispensaryProduct', brandId?: string | null, brandName?: string | null, dispensaryId?: string | null, id?: string | null, status?: string | null, enterpriseProductId?: string | null } | null> | null, priceSummaries?: Array<{ __typename?: 'EnterpriseProductPriceSummary', maxMedicalPrice?: number | null, maxPrice?: number | null, maxRecPrice?: number | null, minMedicalPrice?: number | null, minPrice?: number | null, minRecPrice?: number | null, option: string }> | null } | null> | null } | null };

export type GqlGetEnterpriseSpecialQueryVariables = Exact<{
  enterpriseSpecialId: Scalars['ID']['input'];
}>;


export type GqlGetEnterpriseSpecialQuery = { __typename?: 'Query', getEnterpriseSpecial?: { __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, complete?: boolean | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, dispensaries?: Array<string | null> | null, displayRank?: number | null, dollarDiscount?: boolean | null, duplicatedFrom?: string | null, earliestStartStamp?: any | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, inactiveDispensaries?: Array<string | null> | null, isRecurring?: boolean | null, latestEndStamp?: any | null, localTime?: boolean | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, specialType?: SpecialTypes | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weight?: string | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, targetPrice?: string | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null } | null };

export type GqlAdminSpecialsProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlAdminSpecialsProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', _id?: string | null, brandDescription?: string | null, brandId?: string | null, brandName?: string | null, DispensaryID?: string | null, enterpriseProductId?: string | null, id?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, Name?: string | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, Status?: string | null, subcategory?: string | null, type?: string | null, updatedAt?: any | null, brand?: { __typename?: 'Brand', _id: string, id: string, description?: string | null, name: string } | null } | null> } | null };

export type GqlUpdateSpecialMenuDesignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GqlMenuDesignInput;
}>;


export type GqlUpdateSpecialMenuDesignMutation = { __typename?: 'Mutation', updateSpecialMenuDesign?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlGetEnterpriseSpecialsHistoryQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  enterpriseSpecialId: Scalars['ID']['input'];
}>;


export type GqlGetEnterpriseSpecialsHistoryQuery = { __typename?: 'Query', getEnterpriseSpecialsHistory?: { __typename?: 'EnterpriseSpecialsHistory', id?: string | null, enterpriseSpecialId?: string | null, versions?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, complete?: boolean | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, dispensaries?: Array<string | null> | null, duplicatedFrom?: string | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, id?: string | null, inactiveDispensaries?: Array<string | null> | null, isRecurring?: boolean | null, localTime?: boolean | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, specialType?: SpecialTypes | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, displayRank?: boolean | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weight?: string | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, quantity?: number | null, targetPrice?: string | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlForceDiscountSyncMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type GqlForceDiscountSyncMutation = { __typename?: 'Mutation', forceDiscountSync?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlGetSpecialsHistoryQueryVariables = Exact<{
  specialId: Scalars['ID']['input'];
}>;


export type GqlGetSpecialsHistoryQuery = { __typename?: 'Query', getSpecialsHistory?: { __typename?: 'SpecialsHistory', id?: string | null, versions?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productTags?: Array<string> | null, productIds?: Array<string | null> | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, targetPrice?: string | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlUpdateSingleDispensaryAdSettingsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryAdSettingsInput;
}>;


export type GqlUpdateSingleDispensaryAdSettingsMutation = { __typename?: 'Mutation', updateSingleDispensaryAdSettings?: { __typename?: 'UpdateSingleDispensaryAdSettingsResponse', id: string, adSettings?: { __typename?: 'DispensaryAdSettings', enableAdsForDefault: boolean, enableAdsForEmbedded: boolean, enableAdsForKiosk: boolean, enableAdsForStoreFront: boolean } | null } | null };

export type GqlUpdateSingleDispensaryPersonalizationSettingsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
}>;


export type GqlUpdateSingleDispensaryPersonalizationSettingsMutation = { __typename?: 'Mutation', updateSingleDispensaryPersonalizationSettings?: { __typename?: 'UpdateSingleDispensaryPersonalizationSettingsResponse', id: string, personalizationSettings?: { __typename?: 'DispensaryPersonalizationSettings', enablePersonalizationForDefault: boolean, enablePersonalizationForEmbedded: boolean, enablePersonalizationForKiosk: boolean, enablePersonalizationForStoreFront: boolean, enableSortByRelevance?: boolean | null } | null } | null };

export type GqlCreatePlusApiKeyV2MutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  keyType: PlusApiKeyType;
}>;


export type GqlCreatePlusApiKeyV2Mutation = { __typename?: 'Mutation', createPlusApiKeyV2?: { __typename?: 'PlusApiKey', id: string } | null };

export type GqlCreatePlusEnterpriseApiKeyMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  keyType: PlusApiKeyType;
}>;


export type GqlCreatePlusEnterpriseApiKeyMutation = { __typename?: 'Mutation', createPlusEnterpriseApiKey?: { __typename?: 'PlusApiKey', id: string } | null };

export type GqlExpirePlusApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlExpirePlusApiKeyMutation = { __typename?: 'Mutation', expirePlusApiKey?: { __typename?: 'PlusApiKey', id: string } | null };

export type GqlExpirePlusEnterpriseApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlExpirePlusEnterpriseApiKeyMutation = { __typename?: 'Mutation', expirePlusEnterpriseApiKey?: { __typename?: 'PlusApiKey', id: string } | null };

export type GqlGetEnterpriseIdForApiKeysQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlGetEnterpriseIdForApiKeysQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', retailer: { __typename?: 'Retailer', enterpriseId?: string | null } } | null> | null };

export type GqlGetPlusApiKeysQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetPlusApiKeysQuery = { __typename?: 'Query', getPlusApiKeys?: Array<{ __typename?: 'PlusApiKey', createdAt: any, fresh: boolean, id: string, key: string, keyType: PlusApiKeyType, lastRequestAt?: any | null }> | null };

export type GqlGetPlusEnterpriseApiKeysQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
}>;


export type GqlGetPlusEnterpriseApiKeysQuery = { __typename?: 'Query', getPlusEnterpriseApiKeys?: Array<{ __typename?: 'PlusApiKey', createdAt: any, fresh: boolean, id: string, key: string, keyType: PlusApiKeyType, lastRequestAt?: any | null }> | null };

export type GqlGetDispensarySettingsAuditLogsQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetDispensarySettingsAuditLogsQuery = { __typename?: 'Query', getDispensarySettingsAuditLogs?: { __typename?: 'DispensarySettingsAuditLogList', logs?: Array<{ __typename?: 'DispensarySettingsAuditLog', id?: string | null, dispensaryId?: string | null, source?: string | null, actorEmail?: string | null, actorUserId?: string | null, changedFields?: Array<string | null> | null, priorValues?: any | null, newValues?: any | null, createdAt?: any | null }> | null, meta?: { __typename?: 'DispensarySettingsAuditLogsMeta', totalCount?: number | null } | null } | null };

export type GqlDeleteDeviceV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GqlDeleteDeviceV2Mutation = { __typename?: 'Mutation', deleteDeviceV2?: { __typename?: 'Devices', _id?: string | null } | null };

export type GqlConsumeDeviceAccessCodeMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlConsumeDeviceAccessCodeMutation = { __typename?: 'Mutation', consumeDeviceAccessCode?: { __typename?: 'DeviceAccessCode', accessCode: string, channel: string, channelKey: string } | null };

export type GqlUpdateAutoPrintDevicesV2MutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GqlUpdateAutoPrintDevicesV2Mutation = { __typename?: 'Mutation', updateAutoPrintDevicesV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateReservationSlotsMutationVariables = Exact<{
  input: GqlReservationSlotsCreateInput;
}>;


export type GqlCreateReservationSlotsMutation = { __typename?: 'Mutation', createReservationSlots?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeleteSpecialHoursMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  specialHoursIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlDeleteSpecialHoursMutation = { __typename?: 'Mutation', deleteSpecialHours?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlUpdateHoursSettingsMutationVariables = Exact<{
  input: GqlHoursSettingsUpdateInput;
}>;


export type GqlUpdateHoursSettingsMutation = { __typename?: 'Mutation', updateHoursSettings?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlForceMenuPricingSyncMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlForceMenuPricingSyncMutation = { __typename?: 'Mutation', forceMenuPricingSync?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlIntegrationsDeleteInArmaMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type GqlIntegrationsDeleteInArmaMutation = { __typename?: 'Mutation', integrationsDeleteInArma?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlIntegrationsWipeMenuInArmaMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
}>;


export type GqlIntegrationsWipeMenuInArmaMutation = { __typename?: 'Mutation', integrationsWipeMenuInArma?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlGetConsumerPulseAccessQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetConsumerPulseAccessQuery = { __typename?: 'Query', getConsumerPulseAccess?: { __typename?: 'ConsumerPulseAccess', eligible?: boolean | null, enabled?: boolean | null } | null };

export type GqlUpdateConsumerPulseSettingsMutationVariables = Exact<{
  input: GqlUpdateConsumerPulseSettingsInput;
}>;


export type GqlUpdateConsumerPulseSettingsMutation = { __typename?: 'Mutation', updateConsumerPulseSettings?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlAddBlockedAddressMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  address: GqlBlockedAddressInput;
}>;


export type GqlAddBlockedAddressMutation = { __typename?: 'Mutation', addBlockedAddress?: { __typename?: 'BlockedAddress', id: string, address?: string | null, note?: string | null, createdAt?: any | null } | null };

export type GqlRemoveBlockedAddressMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GqlRemoveBlockedAddressMutation = { __typename?: 'Mutation', removeBlockedAddress?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlReservationSlotsByOrderTypeQueryVariables = Exact<{
  dispensaryId: Scalars['ID']['input'];
  reservationType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlReservationSlotsByOrderTypeQuery = { __typename?: 'Query', getReservationSlotsByOrderType?: { __typename?: 'MaxReservationSlotsByOrderType', inStorePickup?: { __typename?: 'MaxReservationSlotsGroup', maxReservationSlotsByDay?: { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, maxReservationSlotsByDate?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, curbsidePickup?: { __typename?: 'MaxReservationSlotsGroup', maxReservationSlotsByDay?: { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, maxReservationSlotsByDate?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, driveThruPickup?: { __typename?: 'MaxReservationSlotsGroup', maxReservationSlotsByDay?: { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, maxReservationSlotsByDate?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, delivery?: { __typename?: 'MaxReservationSlotsGroup', maxReservationSlotsByDay?: { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null, maxReservationSlotsByDate?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, currentCountsByDate?: any | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null, recurrence?: { __typename?: 'SlotRecurrence', frequency?: RecurrenceFrequency | null, interval?: number | null, anchorDate?: any | null, daysOfWeek?: Array<number | null> | null } | null } | null> | null } | null } | null };

export type GqlGetRetailerEnrollmentStatusQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
}>;


export type GqlGetRetailerEnrollmentStatusQuery = { __typename?: 'Query', getRetailerEnrollmentStatus?: { __typename?: 'RetailerEnrollment', enrollment?: { __typename?: 'Status', status: StatusTypes } | null } | null };

export type GqlUnclaimKioskMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  kioskId: Scalars['String']['input'];
}>;


export type GqlUnclaimKioskMutation = { __typename?: 'Mutation', unclaimKiosk?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlListRetailerPaymentTypesStatusQueryVariables = Exact<{
  ecommLocationId: Scalars['String']['input'];
}>;


export type GqlListRetailerPaymentTypesStatusQuery = { __typename?: 'Query', listRetailerPaymentTypesStatus?: { __typename?: 'RetailerPaymentTypes', paymentTypes: Array<{ __typename?: 'PaymentTypeConfig', enabled?: boolean | null, type?: PaymentsPaymentType | null, orderTypes?: { __typename?: 'PaymentsOrderTypes', curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, pickup?: boolean | null, delivery?: boolean | null } | null } | null> } | null };

export type GqlPreviewReservationSlotStrandingsMutationVariables = Exact<{
  input: GqlReservationSlotsCreateInput;
}>;


export type GqlPreviewReservationSlotStrandingsMutation = { __typename?: 'Mutation', previewReservationSlotStrandings?: { __typename?: 'StrandedReservationsPreview', strandedCount: number } | null };

export type GqlUpdateOrderingSettingsMutationVariables = Exact<{
  input: GqlOrderingSettingsUpdateInput;
}>;


export type GqlUpdateOrderingSettingsMutation = { __typename?: 'Mutation', updateOrderingSettings?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlUpdateReservationSlotsMutationVariables = Exact<{
  input: GqlReservationSlotsUpdateInput;
}>;


export type GqlUpdateReservationSlotsMutation = { __typename?: 'Mutation', updateReservationSlots?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlActivatePrinterMutationVariables = Exact<{
  deviceIdentifier: Scalars['String']['input'];
}>;


export type GqlActivatePrinterMutation = { __typename?: 'Mutation', activatePrinter: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlDeletePrinterMutationVariables = Exact<{
  printerId: Scalars['String']['input'];
}>;


export type GqlDeletePrinterMutation = { __typename?: 'Mutation', deletePrinter: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlGetPrintersQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetPrintersQuery = { __typename?: 'Query', printers: Array<{ __typename?: 'Printer', _id: string, name?: string | null, status: string, deviceType: string, deviceIdentifier: string, adoptedAt?: any | null, adoptedBy?: string | null, lastSeenAt?: any | null, lastPrintAt?: any | null, lastJobId?: any | null, isRecentlyActive?: boolean | null, error?: string | null, queueConfig?: { __typename?: 'PrinterQueueConfig', orderTypes: Array<string> } | null }> };

export type GqlUpdatePrinterMutationVariables = Exact<{
  input: GqlUpdatePrinterInput;
}>;


export type GqlUpdatePrinterMutation = { __typename?: 'Mutation', updatePrinter: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlBulkCreateUsersMutationVariables = Exact<{
  input: Array<GqlUsersCreateInput> | GqlUsersCreateInput;
}>;


export type GqlBulkCreateUsersMutation = { __typename?: 'Mutation', bulkCreateUsers: Array<{ __typename?: 'BulkCreateUserResult', email?: string | null, success: boolean, error?: string | null, user?: { __typename?: 'Users', _id?: string | null, fullName?: string | null, email?: string | null } | null }> };

export type GqlGetEnterpriseAssetsQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlGetEnterpriseAssetsQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, address?: string | null, logoImage?: string | null, embeddedLogoImage?: string | null, SpecialLogoImage?: string | null, listImage?: string | null, bannerImage?: string | null, menuBannerHtml?: string | null, menuBannerColor?: string | null, menuBannerTextBannerCollapsed?: boolean | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null, city?: string | null } | null, categoryPhotos?: Array<{ __typename?: 'CategoryPhoto', src?: string | null, category?: string | null } | null> | null, webCustomizationSettingsV2?: { __typename?: 'WebCustomizationSettingsV2', categories?: { __typename?: 'CustomizedCategories', items?: Array<{ __typename?: 'CustomizedCategory', category: string, image: string } | null> | null } | null } | null, imageBanners?: Array<{ __typename?: 'ImageBanner', _id: string, image: string, mobileImage: string, alt?: string | null, link?: string | null, openInNewTab?: boolean | null, bannerType?: ImageBannerType | null, connectedId?: string | null, connectedType?: string | null, position: number, isActive?: boolean | null, platforms?: Array<{ __typename?: 'ImageBannerPlatform', enabled: boolean, link?: string | null, openInNewTab?: boolean | null, type: ImageBannerPlatformType } | null> | null, schedule?: { __typename?: 'Schedule', id: string, startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', dayOfWeek: number, startTime: string, endTime: string }> | null } | null } | null> | null } | null> | null };

export type GqlGetEnterpriseLegalDisclaimersQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlGetEnterpriseLegalDisclaimersQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null, city?: string | null } | null, embedSettings?: { __typename?: 'Dispensaries_profile_embed_settings', disclaimerTextHtml?: string | null } | null } | null> | null };

export type GqlEnterpriseAssetLibraryAssetUsagesQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  contentHash: Scalars['String']['input'];
}>;


export type GqlEnterpriseAssetLibraryAssetUsagesQuery = { __typename?: 'Query', enterpriseAssetLibraryAssetUsages: Array<{ __typename?: 'AssetUsage', usageType: string, dispensaryId: string, dispensaryName: string, label: string, field: string, url: string }> };

export type GqlEnterpriseAssetLibraryAssetsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlLibraryAssetFilters>;
}>;


export type GqlEnterpriseAssetLibraryAssetsQuery = { __typename?: 'Query', enterpriseAssetLibraryAssets: { __typename?: 'LibraryAssetConnection', total: number, items: Array<{ __typename?: 'LibraryAsset', id: string, enterpriseId: string, name: string, fileName: string, contentHash: string, url: string, type: LibraryAssetType, mimeType: string, width?: number | null, height?: number | null, fileSize: number, folderId?: string | null, tags: Array<string>, createdAt: string, updatedAt: string, createdBy?: string | null, aiGenerated: boolean }> } };

export type GqlEnterpriseAssetLibraryCreateFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlEnterpriseAssetLibraryCreateFolderMutation = { __typename?: 'Mutation', enterpriseAssetLibraryCreateFolder: { __typename?: 'LibraryFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, assetCount: number } };

export type GqlEnterpriseAssetLibraryDeleteAssetsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GqlEnterpriseAssetLibraryDeleteAssetsMutation = { __typename?: 'Mutation', enterpriseAssetLibraryDeleteAssets: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlEnterpriseAssetLibraryDeleteFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlEnterpriseAssetLibraryDeleteFolderMutation = { __typename?: 'Mutation', enterpriseAssetLibraryDeleteFolder: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } };

export type GqlEnterpriseAssetLibraryFinalizeAssetMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  contentHash: Scalars['String']['input'];
  name: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlEnterpriseAssetLibraryFinalizeAssetMutation = { __typename?: 'Mutation', enterpriseAssetLibraryFinalizeAsset: { __typename?: 'LibraryAsset', id: string, enterpriseId: string, name: string, fileName: string, contentHash: string, url: string, type: LibraryAssetType, mimeType: string, width?: number | null, height?: number | null, fileSize: number, folderId?: string | null, tags: Array<string>, createdAt: string, updatedAt: string, createdBy?: string | null, aiGenerated: boolean } };

export type GqlEnterpriseAssetLibraryFoldersQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseAssetLibraryFoldersQuery = { __typename?: 'Query', enterpriseAssetLibraryFolders: Array<{ __typename?: 'LibraryFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, assetCount: number }> };

export type GqlEnterpriseAssetLibraryRequestUploadMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  contentHash: Scalars['String']['input'];
}>;


export type GqlEnterpriseAssetLibraryRequestUploadMutation = { __typename?: 'Mutation', enterpriseAssetLibraryRequestUpload: { __typename?: 'LibraryUploadIntent', uploadUrl?: string | null, contentHash: string, alreadyUploaded: boolean, alreadyInLibrary: boolean, expiresAt?: string | null, existingAsset?: { __typename?: 'LibraryAsset', id: string, enterpriseId: string, name: string, fileName: string, contentHash: string, url: string, type: LibraryAssetType, mimeType: string, width?: number | null, height?: number | null, fileSize: number, folderId?: string | null, tags: Array<string>, createdAt: string, updatedAt: string, createdBy?: string | null, aiGenerated: boolean } | null } };

export type GqlEnterpriseAssetLibraryStartImportMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseAssetLibraryStartImportMutation = { __typename?: 'Mutation', enterpriseAssetLibraryStartImport: { __typename?: 'LibraryImportJob', jobId: string, channel: string } };

export type GqlEnterpriseAssetLibraryStatsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseAssetLibraryStatsQuery = { __typename?: 'Query', enterpriseAssetLibraryStats: { __typename?: 'LibraryStats', total: number, tagCounts: Array<{ __typename?: 'LibraryTagCount', tag: string, count: number }> } };

export type GqlEnterpriseAssetLibraryUpdateAssetMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlEnterpriseAssetLibraryUpdateAssetMutation = { __typename?: 'Mutation', enterpriseAssetLibraryUpdateAsset: { __typename?: 'LibraryAsset', id: string, enterpriseId: string, name: string, fileName: string, contentHash: string, url: string, type: LibraryAssetType, mimeType: string, width?: number | null, height?: number | null, fileSize: number, folderId?: string | null, tags: Array<string>, createdAt: string, updatedAt: string, createdBy?: string | null, aiGenerated: boolean } };

export type GqlDigitalDisplayBoardFolderFieldsFragment = { __typename?: 'DigitalDisplayBoardFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, boardCount: number };

export type GqlGetBoardFoldersQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetBoardFoldersQuery = { __typename?: 'Query', digitalDisplayBoardFolders: Array<{ __typename?: 'DigitalDisplayBoardFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, boardCount: number }> };

export type GqlGetDigitalDisplayBoardsTotalQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetDigitalDisplayBoardsTotalQuery = { __typename?: 'Query', digitalDisplayBoards: { __typename?: 'DigitalDisplayBoardConnection', total: number } };

export type GqlCreateBoardFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlCreateBoardFolderMutation = { __typename?: 'Mutation', createDigitalDisplayBoardFolder: { __typename?: 'DigitalDisplayBoardFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, boardCount: number } };

export type GqlRenameBoardFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type GqlRenameBoardFolderMutation = { __typename?: 'Mutation', updateDigitalDisplayBoardFolder: { __typename?: 'DigitalDisplayBoardFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, boardCount: number } };

export type GqlDeleteBoardFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlDeleteBoardFolderMutation = { __typename?: 'Mutation', deleteDigitalDisplayBoardFolder: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlAddBoardsToBoardFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  boardIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GqlAddBoardsToBoardFolderMutation = { __typename?: 'Mutation', addBoardsToDigitalDisplayBoardFolder: { __typename?: 'DigitalDisplayBoardFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, boardCount: number } };

export type GqlRemoveBoardsFromBoardFolderMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  boardIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GqlRemoveBoardsFromBoardFolderMutation = { __typename?: 'Mutation', removeBoardsFromDigitalDisplayBoardFolder: { __typename?: 'DigitalDisplayBoardFolder', id: string, enterpriseId: string, name: string, parentId?: string | null, boardCount: number } };

export type GqlDigitalDisplayBoardFieldsFragment = { __typename?: 'DigitalDisplayBoard', id: string, enterpriseId: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, audioEnabled?: boolean | null, visible: boolean, folderIds?: Array<string> | null, createdAt: string, updatedAt: string, boardItem?: { __typename?: 'DigitalDisplayBoardItem', id: string, assetId: string, assetUrl?: string | null, contentType: DigitalDisplayBoardItemContentType } | null };

export type GqlGetDigitalDisplayBoardsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  menuOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  layout?: InputMaybe<DigitalDisplayBoardLayout>;
  linkedToPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  folderIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GqlGetDigitalDisplayBoardsQuery = { __typename?: 'Query', digitalDisplayBoards: { __typename?: 'DigitalDisplayBoardConnection', total: number, items: Array<{ __typename?: 'DigitalDisplayBoard', id: string, enterpriseId: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, audioEnabled?: boolean | null, visible: boolean, folderIds?: Array<string> | null, createdAt: string, updatedAt: string, boardItem?: { __typename?: 'DigitalDisplayBoardItem', id: string, assetId: string, assetUrl?: string | null, contentType: DigitalDisplayBoardItemContentType } | null }> } };

export type GqlGetDigitalDisplayBoardQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlGetDigitalDisplayBoardQuery = { __typename?: 'Query', digitalDisplayBoard: { __typename?: 'DigitalDisplayBoard', id: string, enterpriseId: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, audioEnabled?: boolean | null, visible: boolean, folderIds?: Array<string> | null, createdAt: string, updatedAt: string, boardItem?: { __typename?: 'DigitalDisplayBoardItem', id: string, assetId: string, assetUrl?: string | null, contentType: DigitalDisplayBoardItemContentType } | null } };

export type GqlCreateDigitalDisplayBoardMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  layout: DigitalDisplayBoardLayout;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  colorScheme?: InputMaybe<Scalars['JSON']['input']>;
  menuColumns?: InputMaybe<Scalars['JSON']['input']>;
  audioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlCreateDigitalDisplayBoardMutation = { __typename?: 'Mutation', createDigitalDisplayBoard: { __typename?: 'DigitalDisplayBoard', id: string, enterpriseId: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, audioEnabled?: boolean | null, visible: boolean, folderIds?: Array<string> | null, createdAt: string, updatedAt: string, boardItem?: { __typename?: 'DigitalDisplayBoardItem', id: string, assetId: string, assetUrl?: string | null, contentType: DigitalDisplayBoardItemContentType } | null } };

export type GqlUpdateDigitalDisplayBoardMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<DigitalDisplayBoardLayout>;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  colorScheme?: InputMaybe<Scalars['JSON']['input']>;
  menuColumns?: InputMaybe<Scalars['JSON']['input']>;
  audioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlUpdateDigitalDisplayBoardMutation = { __typename?: 'Mutation', updateDigitalDisplayBoard: { __typename?: 'DigitalDisplayBoard', id: string, enterpriseId: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, audioEnabled?: boolean | null, visible: boolean, folderIds?: Array<string> | null, createdAt: string, updatedAt: string, boardItem?: { __typename?: 'DigitalDisplayBoardItem', id: string, assetId: string, assetUrl?: string | null, contentType: DigitalDisplayBoardItemContentType } | null } };

export type GqlDeleteDigitalDisplayBoardMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlDeleteDigitalDisplayBoardMutation = { __typename?: 'Mutation', deleteDigitalDisplayBoard: { __typename?: 'DigitalDisplayBoard', id: string } };

export type GqlDuplicateDigitalDisplayBoardMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlDuplicateDigitalDisplayBoardMutation = { __typename?: 'Mutation', duplicateDigitalDisplayBoard: { __typename?: 'DigitalDisplayBoard', id: string, enterpriseId: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, audioEnabled?: boolean | null, visible: boolean, folderIds?: Array<string> | null, createdAt: string, updatedAt: string, boardItem?: { __typename?: 'DigitalDisplayBoardItem', id: string, assetId: string, assetUrl?: string | null, contentType: DigitalDisplayBoardItemContentType } | null } };

export type GqlMenuBoardEnterpriseDispensariesQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlMenuBoardEnterpriseDispensariesQuery = { __typename?: 'Query', chainDispensaryNamesAndIds?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null } | null> | null };

export type GqlGetDigitalDisplayDevicesQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetDigitalDisplayDevicesQuery = { __typename?: 'Query', digitalDisplayDevices: Array<{ __typename?: 'DigitalDisplayDevice', id: string, name?: string | null, dispensaryId?: string | null, dispensaryName?: string | null, state?: string | null, city?: string | null, online: boolean, lastSeenAt?: string | null }> };

export type GqlGetDigitalDisplayQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;


export type GqlGetDigitalDisplayQuery = { __typename?: 'Query', digitalDisplay: { __typename?: 'DigitalDisplay', deviceId: string, orientation: string, assignments: Array<{ __typename?: 'DigitalDisplayAssignment', playlistId: string, playlistName?: string | null, position: number }> } };

export type GqlSetDigitalDisplayPlaylistsMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  assignments: Array<GqlDigitalDisplayAssignmentInput> | GqlDigitalDisplayAssignmentInput;
}>;


export type GqlSetDigitalDisplayPlaylistsMutation = { __typename?: 'Mutation', setDigitalDisplayPlaylists: { __typename?: 'DigitalDisplay', deviceId: string, orientation: string, assignments: Array<{ __typename?: 'DigitalDisplayAssignment', playlistId: string, playlistName?: string | null, position: number }> } };

export type GqlUpdateDigitalDisplaySettingsMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  orientation: Scalars['String']['input'];
}>;


export type GqlUpdateDigitalDisplaySettingsMutation = { __typename?: 'Mutation', updateDigitalDisplaySettings: { __typename?: 'DigitalDisplay', deviceId: string, orientation: string, assignments: Array<{ __typename?: 'DigitalDisplayAssignment', playlistId: string, playlistName?: string | null, position: number }> } };

export type GqlRestartDigitalDisplayPlaylistMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;


export type GqlRestartDigitalDisplayPlaylistMutation = { __typename?: 'Mutation', restartDigitalDisplayPlaylist: { __typename?: 'DigitalDisplayCommandResult', deviceId: string } };

export type GqlMenuBoardPreviewMenuFiltersQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlMenuBoardPreviewMenuFiltersQuery = { __typename?: 'Query', menuFiltersV2?: { __typename?: 'MenuFilters', brands: Array<{ __typename?: 'Brand', id: string, name: string } | null>, categoriesSubcategories: Array<{ __typename?: 'CategorySubcategories', category: string, subcategories: Array<string> }> } | null };

export type GqlMenuBoardPreviewProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlMenuBoardPreviewProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, Name?: string | null, brandLogo?: string | null, brandName?: string | null, type?: string | null, strainType?: string | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, recPrices?: Array<number | null> | null, special?: boolean | null, recSpecialPrices?: Array<number | null> | null, Image?: string | null, brand?: { __typename?: 'Brand', imageUrl?: string | null, name: string } | null, THCContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, CBDContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, totalTerpenes?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, images?: Array<{ __typename?: 'Products_Images', url: string, active: boolean }> | null } | null> } | null };

export type GqlGetDigitalDisplayPlaylistsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<DigitalDisplayBoardOrientation>;
  linkedToDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetDigitalDisplayPlaylistsQuery = { __typename?: 'Query', digitalDisplayPlaylists: { __typename?: 'DigitalDisplayPlaylistConnection', total: number, items: Array<{ __typename?: 'DigitalDisplayPlaylist', id: string, enterpriseId: string, name: string, description?: string | null, status: DigitalDisplayPlaylistStatus, createdAt: string, updatedAt: string, boards: Array<{ __typename?: 'DigitalDisplayPlaylistBoard', durationSeconds: number, position: number, board: { __typename?: 'DigitalDisplayBoard', id: string, orientation?: DigitalDisplayBoardOrientation | null } }>, scheduledChange?: { __typename?: 'DigitalDisplayPlaylistScheduledChange', id: string, scheduledAt: string, status: DigitalDisplayPlaylistScheduledChangeStatus } | null }> } };

export type GqlGetDigitalDisplayPlaylistQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlGetDigitalDisplayPlaylistQuery = { __typename?: 'Query', digitalDisplayPlaylist: { __typename?: 'DigitalDisplayPlaylist', id: string, enterpriseId: string, name: string, description?: string | null, status: DigitalDisplayPlaylistStatus, createdAt: string, updatedAt: string, boards: Array<{ __typename?: 'DigitalDisplayPlaylistBoard', durationSeconds: number, position: number, board: { __typename?: 'DigitalDisplayBoard', id: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, visible: boolean, boardItem?: { __typename?: 'DigitalDisplayBoardItem', assetId: string, assetUrl?: string | null } | null } }>, scheduledChange?: { __typename?: 'DigitalDisplayPlaylistScheduledChange', id: string, scheduledAt: string, status: DigitalDisplayPlaylistScheduledChangeStatus, name?: string | null, description?: string | null, playlistStatus?: DigitalDisplayPlaylistStatus | null, boards: Array<{ __typename?: 'DigitalDisplayPlaylistBoard', durationSeconds: number, position: number, board: { __typename?: 'DigitalDisplayBoard', id: string, name: string, layout: DigitalDisplayBoardLayout, orientation?: DigitalDisplayBoardOrientation | null, colorScheme?: any | null, menuColumns?: any | null, visible: boolean, boardItem?: { __typename?: 'DigitalDisplayBoardItem', assetId: string, assetUrl?: string | null } | null } }> } | null } };

export type GqlCreateDigitalDisplayPlaylistMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
}>;


export type GqlCreateDigitalDisplayPlaylistMutation = { __typename?: 'Mutation', createDigitalDisplayPlaylist: { __typename?: 'DigitalDisplayPlaylist', id: string } };

export type GqlUpdateDigitalDisplayPlaylistMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
  boards?: InputMaybe<Array<GqlDigitalDisplayPlaylistBoardInput> | GqlDigitalDisplayPlaylistBoardInput>;
}>;


export type GqlUpdateDigitalDisplayPlaylistMutation = { __typename?: 'Mutation', updateDigitalDisplayPlaylist: { __typename?: 'DigitalDisplayPlaylist', id: string } };

export type GqlDuplicateDigitalDisplayPlaylistMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlDuplicateDigitalDisplayPlaylistMutation = { __typename?: 'Mutation', duplicateDigitalDisplayPlaylist: { __typename?: 'DigitalDisplayPlaylist', id: string } };

export type GqlArchiveDigitalDisplayPlaylistMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlArchiveDigitalDisplayPlaylistMutation = { __typename?: 'Mutation', archiveDigitalDisplayPlaylist: { __typename?: 'DigitalDisplayPlaylist', id: string, status: DigitalDisplayPlaylistStatus } };

export type GqlScheduleDigitalDisplayPlaylistChangeMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  scheduledAt: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalDisplayPlaylistStatus>;
  boards?: InputMaybe<Array<GqlDigitalDisplayPlaylistBoardInput> | GqlDigitalDisplayPlaylistBoardInput>;
}>;


export type GqlScheduleDigitalDisplayPlaylistChangeMutation = { __typename?: 'Mutation', scheduleDigitalDisplayPlaylistChange: { __typename?: 'DigitalDisplayPlaylistScheduledChange', id: string, scheduledAt: string, status: DigitalDisplayPlaylistScheduledChangeStatus } };

export type GqlCancelDigitalDisplayPlaylistScheduledChangeMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlCancelDigitalDisplayPlaylistScheduledChangeMutation = { __typename?: 'Mutation', cancelDigitalDisplayPlaylistScheduledChange: { __typename?: 'DigitalDisplayPlaylistScheduledChange', id: string, status: DigitalDisplayPlaylistScheduledChangeStatus } };

export type GqlGetRetailersByEnterpriseIdQueryVariables = Exact<{
  enterpriseIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GqlGetRetailersByEnterpriseIdQuery = { __typename?: 'Query', getRetailersByEnterpriseId?: Array<{ __typename?: 'Retailer', dispensaryId: string, name: string, profile: { __typename?: 'RetailerProfile', medicalDispensary?: boolean | null, recDispensary?: boolean | null, location?: { __typename?: 'RetailerProfileLocation', city?: string | null, state?: string | null } | null } } | null> | null };

export type GqlGetEnterpriseQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetEnterpriseQuery = { __typename?: 'Query', getEnterprise?: { __typename?: 'Enterprise', id: string, hasDposLoyalty?: boolean | null, voiceAiEnabled?: boolean | null, uniqueName: string } | null };

export type GqlEnterpriseWebsiteDomainsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseWebsiteDomainsQuery = { __typename?: 'Query', enterpriseDomains: Array<{ __typename?: 'EnterpriseDomain', id: string, hostname: string, websiteId?: string | null }> };

export type GqlGetLocationGroupsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetLocationGroupsQuery = { __typename?: 'Query', locationGroups?: Array<{ __typename?: 'LocationGroup', id: string, name: string, description?: string | null, enterpriseId: string, retailerIds?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GqlGetLocationGroupQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlGetLocationGroupQuery = { __typename?: 'Query', locationGroup?: { __typename?: 'LocationGroup', id: string, name: string, description?: string | null, enterpriseId: string, retailerIds?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GqlCreateLocationGroupMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GqlCreateLocationGroupMutation = { __typename?: 'Mutation', createLocationGroup?: { __typename?: 'LocationGroup', id: string, name: string, description?: string | null, retailerIds?: Array<string> | null } | null };

export type GqlUpdateLocationGroupMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GqlUpdateLocationGroupMutation = { __typename?: 'Mutation', updateLocationGroup?: { __typename?: 'LocationGroup', id: string, name: string, description?: string | null, retailerIds?: Array<string> | null } | null };

export type GqlDeleteLocationGroupMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlDeleteLocationGroupMutation = { __typename?: 'Mutation', deleteLocationGroup?: { __typename?: 'LocationGroup', id: string } | null };

export type GqlGetEnterpriseDispensariesQueryVariables = Exact<{
  chainId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetEnterpriseDispensariesQuery = { __typename?: 'Query', chainDispensaryNamesAndIds?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, address?: string | null, location?: { __typename?: 'Dispensaries_profile_location', city?: string | null, state?: string | null } | null, retailer: { __typename?: 'Retailer', id: string } } | null> | null };

export type GqlGetEnterpriseBrandOrderQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlGetEnterpriseBrandOrderQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null, city?: string | null } | null, featuredBrandsSettings: Array<{ __typename?: 'FeaturedBrandsSetting', category: string, brandIds: Array<string> }> } | null> | null };

export type GqlGetEnterpriseMenuSortingQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlGetEnterpriseMenuSortingQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, menuOrder?: string | null, activeCategories?: Array<string | null> | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null, city?: string | null } | null, menuOrderSettings: Array<{ __typename?: 'MenuOrderSetting', category: string, menuOrder: CategoryMenuOrder }> } | null> | null };

export type GqlGetEnterpriseSpecialsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetEnterpriseSpecialsQuery = { __typename?: 'Query', enterpriseSpecials?: Array<{ __typename?: 'EnterpriseSpecial', active?: boolean | null, complete?: boolean | null, createdAt?: any | null, dispensaryId?: string | null, endDay?: any | null, endStamp?: any | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, id?: string | null, inactiveDispensaries?: Array<string | null> | null, isRecurring?: boolean | null, localTime?: boolean | null, name?: string | null, scope?: SpecialScopes | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, timezone?: string | null, updatedAt?: string | null, version?: number | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null } | null> | null };

export type GqlImportProductReviewsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  csv: Scalars['String']['input'];
}>;


export type GqlImportProductReviewsMutation = { __typename?: 'Mutation', importProductReviews?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlAdminProductReviewFieldsFragment = { __typename?: 'AdminProductReview', id: string, productId: string, orderId: string, userId: string, dispensaryId: string, posProductId?: string | null, reviewerDisplayName?: string | null, rating: number, effects: Array<string>, body?: string | null, status: ReviewStatus, aiFlagReason?: string | null, moderatedBy?: string | null, moderatedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'Users', firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null } | null };

export type GqlGetAdminProductReviewsQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['String']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<ReviewStatus>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetAdminProductReviewsQuery = { __typename?: 'Query', getAdminProductReviews?: { __typename?: 'AdminProductReviewsResponse', productReviews: Array<{ __typename?: 'AdminProductReview', id: string, productId: string, orderId: string, userId: string, dispensaryId: string, posProductId?: string | null, reviewerDisplayName?: string | null, rating: number, effects: Array<string>, body?: string | null, status: ReviewStatus, aiFlagReason?: string | null, moderatedBy?: string | null, moderatedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'Users', firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null } | null }>, meta?: { __typename?: 'queryInfoType', totalCount?: number | null, totalPages?: number | null, perPage?: number | null } | null } | null };

export type GqlGetAdminReviewFilterOptionsQueryVariables = Exact<{
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<ReviewStatus>;
  startDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetAdminReviewFilterOptionsQuery = { __typename?: 'Query', getAdminReviewFilterOptions?: { __typename?: 'AdminReviewFilterOptions', productIds: Array<string>, dispensaryIds: Array<string> } | null };

export type GqlGetReviewProductNamesQueryVariables = Exact<{
  filter: GqlProductsFilterInput;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetReviewProductNamesQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, Name?: string | null } | null> } | null };

export type GqlModerateProductReviewMutationVariables = Exact<{
  input: GqlModerateProductReviewInput;
}>;


export type GqlModerateProductReviewMutation = { __typename?: 'Mutation', moderateProductReview?: { __typename?: 'AdminProductReview', id: string, productId: string, orderId: string, userId: string, dispensaryId: string, posProductId?: string | null, reviewerDisplayName?: string | null, rating: number, effects: Array<string>, body?: string | null, status: ReviewStatus, aiFlagReason?: string | null, moderatedBy?: string | null, moderatedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'Users', firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null } | null } | null };

export type GqlDeleteReviewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteReviewMutation = { __typename?: 'Mutation', deleteReview?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlEnterpriseAdSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseAdSettingsQuery = { __typename?: 'Query', enterpriseAdSettings: Array<{ __typename?: 'EnterpriseDispensaryAdSettings', id: string, name: string, status: string, adSettings: { __typename?: 'DispensaryAdSettings', enableAdsForDefault: boolean, enableAdsForEmbedded: boolean, enableAdsForKiosk: boolean, enableAdsForStoreFront: boolean } }> };

export type GqlEnterprisePersonalizationSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterprisePersonalizationSettingsQuery = { __typename?: 'Query', enterprisePersonalizationSettings: Array<{ __typename?: 'EnterpriseDispensaryPersonalizationSettings', id: string, name: string, status: string, personalizationSettings: { __typename?: 'DispensaryPersonalizationSettings', enablePersonalizationForDefault: boolean, enablePersonalizationForEmbedded: boolean, enablePersonalizationForKiosk: boolean, enablePersonalizationForStoreFront: boolean, enableSortByRelevance?: boolean | null } }> };

export type GqlUpdateEnterpriseAdSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  settings: GqlDispensaryAdSettingsInput;
}>;


export type GqlUpdateEnterpriseAdSettingsMutation = { __typename?: 'Mutation', updateEnterpriseAdSettings?: { __typename?: 'UpdateEnterpriseAdSettingsResponse', adSettings: { __typename?: 'DispensaryAdSettings', enableAdsForDefault: boolean, enableAdsForEmbedded: boolean, enableAdsForKiosk: boolean, enableAdsForStoreFront: boolean } } | null };

export type GqlUpdateEnterprisePersonalizationSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
}>;


export type GqlUpdateEnterprisePersonalizationSettingsMutation = { __typename?: 'Mutation', updateEnterprisePersonalizationSettings?: { __typename?: 'UpdateEnterprisePersonalizationSettingsResponse', personalizationSettings: { __typename?: 'DispensaryPersonalizationSettings', enablePersonalizationForDefault: boolean, enablePersonalizationForEmbedded: boolean, enablePersonalizationForKiosk: boolean, enablePersonalizationForStoreFront: boolean, enableSortByRelevance?: boolean | null } } | null };

export type GqlGetPlusOAuthProvidersQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
}>;


export type GqlGetPlusOAuthProvidersQuery = { __typename?: 'Query', getPlusOAuthProviders: Array<{ __typename?: 'PlusOAuthProvider', authorizationUrl: string, clientId: string, enterpriseId: string, id: string, name: string, site: string, tokenUrl: string, userInfoUrl: string } | null> };

export type GqlUpdatePlusOAuthProviderMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  input: GqlPlusOAuthProviderInput;
}>;


export type GqlUpdatePlusOAuthProviderMutation = { __typename?: 'Mutation', updatePlusOAuthProvider: { __typename?: 'PlusOAuthProvider', authorizationUrl: string, clientId: string, enterpriseId: string, id: string, name: string, site: string, tokenUrl: string, userInfoUrl: string } };

export type GqlCreateEnterpriseDomainMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  hostname: Scalars['String']['input'];
  domainType: EnterpriseDomainType;
  websiteId: Scalars['String']['input'];
  locationGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GqlCreateEnterpriseDomainMutation = { __typename?: 'Mutation', createEnterpriseDomain: { __typename?: 'EnterpriseDomain', id: string, hostname: string, domainType: EnterpriseDomainType, status: EnterpriseDomainStatus, sslStatus: EnterpriseDomainSslStatus } };

export type GqlDeleteEnterpriseDomainMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlDeleteEnterpriseDomainMutation = { __typename?: 'Mutation', deleteEnterpriseDomain?: { __typename?: 'EnterpriseDomain', id: string } | null };

export type GqlEnterpriseDomainSetupInstructionsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlEnterpriseDomainSetupInstructionsQuery = { __typename?: 'Query', enterpriseDomainSetupInstructions: { __typename?: 'EnterpriseDomainSetupInstructions', records: Array<{ __typename?: 'EnterpriseDomainDnsRecord', recordType: string, name: string, value: string }> } };

export type GqlEnterpriseDomainsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseDomainsQuery = { __typename?: 'Query', enterpriseDomains: Array<{ __typename?: 'EnterpriseDomain', id: string, hostname: string, domainType: EnterpriseDomainType, status: EnterpriseDomainStatus, sslStatus: EnterpriseDomainSslStatus }> };

export type GqlMintEnterpriseDomainEntriTokenMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlMintEnterpriseDomainEntriTokenMutation = { __typename?: 'Mutation', mintEnterpriseDomainEntriToken: { __typename?: 'EnterpriseDomainEntriToken', token: string, applicationId: string, dnsRecords: Array<{ __typename?: 'EnterpriseDomainEntriDnsRecord', type: string, host: string, value: string, ttl: number }> } };

export type GqlVerifyEnterpriseDomainMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlVerifyEnterpriseDomainMutation = { __typename?: 'Mutation', verifyEnterpriseDomain: { __typename?: 'EnterpriseDomain', id: string, hostname: string, domainType: EnterpriseDomainType, status: EnterpriseDomainStatus, sslStatus: EnterpriseDomainSslStatus } };

export type GqlUpdateEnterpriseVoiceAiEnablementMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  voiceAiEnabled: Scalars['Boolean']['input'];
}>;


export type GqlUpdateEnterpriseVoiceAiEnablementMutation = { __typename?: 'Mutation', updateEnterpriseVoiceAiEnablement: { __typename?: 'Enterprise', id: string, voiceAiEnabled?: boolean | null } };

export type GqlEnterpriseCustomDomainForEnrollmentQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlEnterpriseCustomDomainForEnrollmentQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, embeddedMenuUrl?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null } | null> | null };

export type GqlChainUserPermissionsReportQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlChainUserPermissionsReportQuery = { __typename?: 'Query', chainUserPermissionsReport: Array<{ __typename?: 'ChainUserPermissionRow', _id: string, email?: string | null, fullName?: string | null, phone?: string | null, roleAtDispensary?: string | null, homeLocationName?: string | null, hasAllLocations: boolean, locationNames: Array<string>, locationCount: number, unknownLocationCount: number, permissions: { __typename?: 'ChainUserPermissionFlags', allLocations: boolean, analytics: boolean, billing: boolean, customers: boolean, driver: boolean, enterpriseAdmin: boolean, enterpriseSpecials: boolean, menu: boolean, messaging: boolean, orders: boolean, promote: boolean, settings: boolean, users: boolean } }> };

export type GqlExportChainUserPermissionsQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlExportChainUserPermissionsQuery = { __typename?: 'Query', exportChainUserPermissions: { __typename?: 'ChainUserPermissionsExport', csv: string } };

export type GqlEnterpriseDispensaryLocationKeywordsQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlEnterpriseDispensaryLocationKeywordsQuery = { __typename?: 'Query', enterpriseDispensaryLocationKeywords: Array<{ __typename?: 'DispensaryLocationKeyword', cName: string, name: string, address?: string | null }> };

export type GqlBulkCreateEnterpriseUsersMutationVariables = Exact<{
  chainId: Scalars['String']['input'];
  csv: Scalars['String']['input'];
}>;


export type GqlBulkCreateEnterpriseUsersMutation = { __typename?: 'Mutation', bulkCreateEnterpriseUsers?: { __typename?: 'BulkCreateEnterpriseUsersResult', success: boolean, createdCount: number, failedRows: Array<{ __typename?: 'BulkCreateEnterpriseUsersFailedRow', row: number, email?: string | null, reason: string }> } | null };

export type GqlGetVoiceAgentsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlGetVoiceAgentsQuery = { __typename?: 'Query', voiceAgents?: Array<{ __typename?: 'VoiceAgent', id: string, name: string, phoneNumber?: string | null, phoneNumberStatus?: string | null, fallbackPhoneNumber?: string | null, externalId?: string | null, locationGroupId: string, enterprisePrompt?: string | null, superAdminPrompt?: string | null, spanishEnabled?: boolean | null, phoneOrderingEnabled?: boolean | null, updatedAt?: string | null, locationTransferNumbers?: Array<{ __typename?: 'LocationTransferNumber', retailerId: string, transferPhoneNumber?: string | null }> | null } | null> | null };

export type GqlGetVoiceAgentQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlGetVoiceAgentQuery = { __typename?: 'Query', voiceAgent?: { __typename?: 'VoiceAgent', id: string, name: string, phoneNumber?: string | null, phoneNumberStatus?: string | null, fallbackPhoneNumber?: string | null, externalId?: string | null, locationGroupId: string, enterprisePrompt?: string | null, superAdminPrompt?: string | null, spanishEnabled?: boolean | null, phoneOrderingEnabled?: boolean | null, updatedAt?: string | null, locationTransferNumbers?: Array<{ __typename?: 'LocationTransferNumber', retailerId: string, transferPhoneNumber?: string | null }> | null } | null };

export type GqlCreateVoiceAgentMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  locationGroupId: Scalars['ID']['input'];
  fallbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  enterprisePrompt?: InputMaybe<Scalars['String']['input']>;
  superAdminPrompt?: InputMaybe<Scalars['String']['input']>;
  spanishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlCreateVoiceAgentMutation = { __typename?: 'Mutation', createVoiceAgent?: { __typename?: 'VoiceAgent', id: string, name: string, phoneNumber?: string | null, fallbackPhoneNumber?: string | null, locationGroupId: string, enterprisePrompt?: string | null, superAdminPrompt?: string | null, spanishEnabled?: boolean | null, phoneOrderingEnabled?: boolean | null } | null };

export type GqlUpdateVoiceAgentMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  locationGroupId?: InputMaybe<Scalars['ID']['input']>;
  fallbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  enterprisePrompt?: InputMaybe<Scalars['String']['input']>;
  superAdminPrompt?: InputMaybe<Scalars['String']['input']>;
  spanishEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationTransferNumbers?: InputMaybe<Array<GqlLocationTransferNumberInput> | GqlLocationTransferNumberInput>;
}>;


export type GqlUpdateVoiceAgentMutation = { __typename?: 'Mutation', updateVoiceAgent?: { __typename?: 'VoiceAgent', id: string, name: string, phoneNumber?: string | null, phoneNumberStatus?: string | null, fallbackPhoneNumber?: string | null, locationGroupId: string, enterprisePrompt?: string | null, superAdminPrompt?: string | null, spanishEnabled?: boolean | null, phoneOrderingEnabled?: boolean | null, updatedAt?: string | null, locationTransferNumbers?: Array<{ __typename?: 'LocationTransferNumber', retailerId: string, transferPhoneNumber?: string | null }> | null } | null };

export type GqlDeleteVoiceAgentMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GqlDeleteVoiceAgentMutation = { __typename?: 'Mutation', deleteVoiceAgent?: { __typename?: 'VoiceAgent', id: string } | null };

export type GqlProvisionVoiceAgentPhoneNumberMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  areaCode: Scalars['String']['input'];
  fallbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlProvisionVoiceAgentPhoneNumberMutation = { __typename?: 'Mutation', provisionVoiceAgentPhoneNumber?: { __typename?: 'VoiceAgent', id: string, phoneNumber?: string | null, phoneNumberStatus?: string | null, fallbackPhoneNumber?: string | null } | null };

export type GqlGetVoiceAgentCallsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  assistantId: Scalars['ID']['input'];
  days: Scalars['Int']['input'];
}>;


export type GqlGetVoiceAgentCallsQuery = { __typename?: 'Query', voiceAgentCalls: Array<{ __typename?: 'VoiceAgentCall', id: string, status?: string | null, endedReason?: string | null, createdAt?: string | null, startedAt?: string | null, endedAt?: string | null, durationSeconds?: number | null, customerPhone?: string | null, assistantPhone: string, cost?: number | null, successEvaluation?: string | null }> };

export type GqlGetVoiceAgentCallQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  assistantId: Scalars['ID']['input'];
  callId: Scalars['ID']['input'];
}>;


export type GqlGetVoiceAgentCallQuery = { __typename?: 'Query', voiceAgentCall?: { __typename?: 'VoiceAgentCallDetail', id: string, status?: string | null, endedReason?: string | null, createdAt?: string | null, startedAt?: string | null, endedAt?: string | null, durationSeconds?: number | null, customerPhone?: string | null, assistantPhone: string, cost?: number | null, successEvaluation?: string | null, summary?: string | null, structuredData?: any | null, recordingUrl?: string | null, transcript: Array<{ __typename?: 'VoiceAgentCallTranscriptTurn', role: string, message: string, time?: string | null }> } | null };

export type GqlGetVoiceAgentCallAnalyticsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  assistantId: Scalars['ID']['input'];
  days: Scalars['Int']['input'];
}>;


export type GqlGetVoiceAgentCallAnalyticsQuery = { __typename?: 'Query', voiceAgentCallAnalytics: { __typename?: 'VoiceAgentCallAnalytics', id: string, days: number, totalCalls: number, totalMinutes: number, averageDurationSeconds: number, successRate: number, dailyCallVolume: Array<{ __typename?: 'VoiceAgentDailyCallVolume', date: string, count: number }>, endReasonDistribution: Array<{ __typename?: 'VoiceAgentEndReasonCount', endedReason?: string | null, count: number }> } };

export type GqlWebStudioChainDispensariesQueryVariables = Exact<{
  chainId: Scalars['String']['input'];
}>;


export type GqlWebStudioChainDispensariesQuery = { __typename?: 'Query', chainDispensaryNamesAndIds?: Array<{ __typename?: 'Dispensaries', id: string, cName?: string | null } | null> | null };

export type GqlWebStudioWebsiteThemeQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlWebStudioWebsiteThemeQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', webCustomizationSettingsV2?: { __typename?: 'WebCustomizationSettingsV2', colors?: { __typename?: 'Colors', navBar?: string | null, buttonsLinks?: string | null, productCardButton?: ProductCardButtonOption | null, staffPickTag?: string | null, discountTag?: string | null, strainTypes?: { __typename?: 'StrainTypeColors', indica?: string | null, sativa?: string | null, hybrid?: string | null } | null } | null, fonts?: { __typename?: 'Fonts', heading?: string | null, body?: string | null } | null } | null } | null> | null };

export type GqlGetCmsWebsiteQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
}>;


export type GqlGetCmsWebsiteQuery = { __typename?: 'Query', cmsWebsites?: { __typename?: 'CmsWebsiteList', websites: Array<{ __typename?: 'CmsWebsite', id: string, name: string, cName: string }> } | null };

export type GqlGetCmsVariantsQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetCmsVariantsQuery = { __typename?: 'Query', cmsVariants?: { __typename?: 'CmsVariantList', variants: Array<{ __typename?: 'CmsVariant', variantId: string, variantKey: string, publishedVersionId?: string | null, isDefault: boolean, createdAt: string, updatedAt: string }> } | null };

export type GqlGetCmsContentForPublishQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetCmsContentForPublishQuery = { __typename?: 'Query', cmsContent?: { __typename?: 'CmsContent', data?: any | null } | null };

export type GqlPublishCmsVariantMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  data: Scalars['JSONObject']['input'];
  websiteId: Scalars['String']['input'];
}>;


export type GqlPublishCmsVariantMutation = { __typename?: 'Mutation', saveCmsContentVersion?: { __typename?: 'CmsContentVersionResult', status: CmsContentVersionStatus } | null };

export type GqlGetCmsPagesQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  websiteId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetCmsPagesQuery = { __typename?: 'Query', cmsPages?: { __typename?: 'CmsPageList', pages: Array<{ __typename?: 'CmsPage', variantId: string, variantKey: string, name: string, urlPath: string, publishedVersionId?: string | null, isDefault: boolean, createdAt: string, updatedAt: string }> } | null };

export type GqlPublishCmsPageMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  websiteId: Scalars['String']['input'];
  variantKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  urlPath: Scalars['String']['input'];
  data: Scalars['JSONObject']['input'];
}>;


export type GqlPublishCmsPageMutation = { __typename?: 'Mutation', savePage?: { __typename?: 'SavePageResult', status: CmsContentVersionStatus } | null };

export type GqlGetEnterpriseByNameQueryVariables = Exact<{
  uniqueName: Scalars['ID']['input'];
}>;


export type GqlGetEnterpriseByNameQuery = { __typename?: 'Query', getEnterpriseByName?: Array<{ __typename?: 'Enterprise', id: string, uniqueName: string } | null> | null };

export type GqlPrintedMenuBrandingColorsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlPrintedMenuBrandingColorsQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', webCustomizationSettingsV2?: { __typename?: 'WebCustomizationSettingsV2', colors?: { __typename?: 'Colors', navBar?: string | null, buttonsLinks?: string | null, staffPickTag?: string | null, discountTag?: string | null } | null } | null } | null> | null };

export type GqlAdminPrintedMenuProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlAdminPrintedMenuProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Name?: string | null, Prices?: Array<number | null> | null, Options?: Array<string | null> | null, medicalOnly?: boolean | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, medicalPrices?: Array<number | null> | null, Image?: string | null, stockImage?: string | null, special?: boolean | null, recSpecialPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, brandId?: string | null, brandName?: string | null, brandLogo?: string | null, Status?: string | null, type?: string | null, subcategory?: string | null, strainType?: string | null, updatedAt?: any | null, createdAt?: string | null, CBD?: string | null, THC?: string | null, weight?: number | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, origin: ImageOrigin, url: string, active: boolean }> | null, specialData?: { __typename?: 'Products_specialData', discount?: number | null, percentDiscount?: boolean | null, bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: number | null, dollarDiscount?: boolean | null, menuType?: string | null, minorVersion?: number | null, percentDiscount?: boolean | null, specialName?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingMode?: string | null, eligibleProductOptions?: Array<string | null> | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, posSyncedPricingApplied?: { __typename?: 'Products_posSyncedPricingApplied', medical?: boolean | null, recreational?: boolean | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null } | null, brand?: { __typename?: 'Brand', id: string, name: string, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null>, queryInfo: { __typename?: 'queryInfoType', totalCount?: number | null } } | null };

export type GqlGetExportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetExportQuery = { __typename?: 'Query', getExport: { __typename?: 'Export', url: string } };

export type GqlMeAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMeAdminQuery = { __typename?: 'Query', meAdmin?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, chainDispensaryIds?: Array<string | null> | null, enterpriseId?: string | null, zendeskWidgetToken?: string | null, zendeskSingleSignOnToken?: string | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, dispensary?: { __typename?: 'Dispensaries', chain?: string | null, embeddedMenuUrl?: string | null, id: string, name?: string | null, phone?: string | null, status?: string | null, tier?: string | null, timezone?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null, location?: { __typename?: 'Dispensaries_profile_location', city?: string | null, state?: string | null, country?: string | null, zipcode?: string | null } | null } | null, profile: { __typename?: 'IdentityAdminProfile', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, isWeeklyReportEnabled?: boolean | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, firstViewedTOS?: any | null, acceptedTOS?: any | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, dispensaryIds?: Array<string> | null, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, messaging: boolean, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null, techSupportFeatures?: boolean | null } | null, streamTokens?: Array<{ __typename?: 'DispensaryStreamToken', dispensaryId?: string | null, token?: string | null } | null> | null } } | null };

export type GqlGetOrdersQueryVariables = Exact<{
  input: GqlGetOrdersInput;
}>;


export type GqlGetOrdersQuery = { __typename?: 'Query', getOrders?: { __typename?: 'AdminOrderListType', orders?: Array<{ __typename?: 'AdminOrderType', createdAt?: any | null, customerId?: string | null, customerEmail?: string | null, customerName?: string | null, customerPhone?: string | null, firstName?: string | null, lastName?: string | null, delivery?: boolean | null, dispensaryId?: string | null, dispensaryName?: string | null, dispoTimezone?: string | null, deliveryOption?: boolean | null, duration?: number | null, effectiveStatus?: string | null, orderId?: string | null, orderType?: string | null, status?: string | null, reopened?: boolean | null, totalCost?: number | null, isAnonymous?: boolean | null, isKioskOrder?: boolean | null, originKioskId?: string | null, kioskName?: string | null, isAfterHoursOrder?: boolean | null, _id: string, durationEstimates?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null } | null, voiceCallInfo?: { __typename?: 'VoiceCallInfo', callId?: string | null, assistantId?: string | null } | null, fleetManagementTask?: { __typename?: 'Orders_fleetManagementTask', id?: string | null, adapter?: string | null } | null, pos?: { __typename?: 'Orders_POS', externalID?: string | null, failureReason?: string | null, failureType?: string | null, humanReadableError?: string | null, name?: string | null, failureAcks?: { __typename?: 'Orders_POS_FailureLocations', terminal?: boolean | null, web?: boolean | null } | null } | null, reservation?: { __typename?: 'OrderReservation', startTimeISO?: any | null, endTimeISO?: any | null } | null } | null> | null } | null };

export type GqlRevertBrandMergeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlRevertBrandMergeMutation = { __typename?: 'Mutation', revertBrandMerge?: { __typename?: 'BrandMergeHistory', id: string } | null };

export type GqlBrandMergeHistoryIndexQueryVariables = Exact<{
  filters?: InputMaybe<GqlBrandMergeHistoriesFilters>;
  page?: InputMaybe<GqlBrandMergeHistoriesPagination>;
  sort?: InputMaybe<GqlBrandMergeHistoriesSort>;
}>;


export type GqlBrandMergeHistoryIndexQuery = { __typename?: 'Query', getBrandMergeHistories?: { __typename?: 'BrandMergeHistoryList', brandMergeHistories: Array<{ __typename?: 'BrandMergeHistory', id: string, createdAt: any, revertedAt?: any | null, sourceBrand: { __typename?: 'Brand', id: string, name: string, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null }, destinationBrand: { __typename?: 'Brand', id: string, name: string, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null }, user?: { __typename?: 'Users', email?: string | null } | null }>, queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlMergeBrandsMutationVariables = Exact<{
  collisionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GqlMergeBrandsMutation = { __typename?: 'Mutation', mergeBrands?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetActiveDispensariesQueryVariables = Exact<{
  params?: InputMaybe<GqlActiveDispensariesInput>;
}>;


export type GqlGetActiveDispensariesQuery = { __typename?: 'Query', activeDispensaries?: { __typename?: 'ActiveDispenariesResult', dispensaries?: Array<{ __typename?: 'ActiveDispensaries', _id?: string | null, profile?: { __typename?: 'ActiveDispensariesProfile', name?: string | null } | null } | null> | null } | null };

export type GqlGetBrandCollisionsQueryVariables = Exact<{
  filters?: InputMaybe<GqlBrandCollisionFilters>;
  sort?: InputMaybe<GqlBrandCollisionsSort>;
  pagination?: InputMaybe<GqlPagination>;
}>;


export type GqlGetBrandCollisionsQuery = { __typename?: 'Query', getBrandCollisions?: { __typename?: 'BrandCollisionList', brandCollisions: Array<{ __typename?: 'BrandCollision', createdAt?: any | null, id: string, isAllowed: boolean, firstBrand: { __typename?: 'Brand', id: string, name: string, productsCount: number, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null }, secondBrand: { __typename?: 'Brand', id: string, name: string, productsCount: number, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null } }>, queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlGetFilteredDispensariesQueryVariables = Exact<{
  filter?: InputMaybe<GqlDispensariesFilterInput>;
}>;


export type GqlGetFilteredDispensariesQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null } | null> | null };

export type GqlMergeBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
  destinationBrandId: Scalars['String']['input'];
}>;


export type GqlMergeBrandMutation = { __typename?: 'Mutation', mergeBrand?: { __typename?: 'Brand', id: string } | null };

export type GqlUpdateBrandCollisionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlBrandCollisionInput;
}>;


export type GqlUpdateBrandCollisionMutation = { __typename?: 'Mutation', updateBrandCollision?: { __typename?: 'BrandCollision', id: string } | null };

export type GqlBrandMergeToolIndexQueryVariables = Exact<{
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
}>;


export type GqlBrandMergeToolIndexQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', id: string, brandCollisions?: Array<{ __typename?: 'BrandCollision', createdAt?: any | null, id: string, isAllowed: boolean, firstBrand: { __typename?: 'Brand', id: string, name: string, productsCount: number, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null }, secondBrand: { __typename?: 'Brand', id: string, name: string, productsCount: number, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null } }> | null } | null>, queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlSearchEnterpriseByNameQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
}>;


export type GqlSearchEnterpriseByNameQuery = { __typename?: 'Query', searchEnterpriseByName?: Array<{ __typename?: 'Enterprise', id: string, name: string } | null> | null };

export type GqlVerifyBucketProductsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GqlVerifyBucketProductsMutation = { __typename?: 'Mutation', verifyBucketProducts: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } };

export type GqlGetBulkBucketProductReviewQueryVariables = Exact<{
  pagination: GqlPaginationInput;
  filter?: InputMaybe<GqlSearchBucketProductFilter>;
  sort?: InputMaybe<GqlSearchBucketProductSort>;
}>;


export type GqlGetBulkBucketProductReviewQuery = { __typename?: 'Query', searchBucketProducts?: { __typename?: 'SearchBucketProductsResponse', bucketProducts?: Array<{ __typename?: 'BucketProduct', id?: string | null, reviewedAt?: string | null, verified?: boolean | null, reviewedByUser?: { __typename?: 'Users', _id?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null } | null, product?: { __typename?: 'Products', Status?: string | null, DispensaryID?: string | null, id?: string | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, libraryProduct?: { __typename?: 'LibraryProduct', category?: string | null, name: string, brand?: { __typename?: 'Brand', name: string } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null, oldProductData?: { __typename?: 'OldProductData', Name?: string | null, brandId?: string | null, brandName?: string | null, type?: string | null, subcategory?: string | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, brand?: { __typename?: 'Brand', name: string } | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null } | null } | null> | null, meta?: { __typename?: 'BucketProductsMeta', totalCount?: number | null, reviewers?: Array<{ __typename?: 'Users', _id?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null } | null> | null } | null } | null };

export type GqlAdminContentBaseProductFragmentFragment = { __typename?: 'Products', id?: string | null, _id?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, CBD?: string | null, connectedAt?: string | null, connectedBy?: string | null, createdAt?: string | null, dateCreated?: string | null, Description?: string | null, descriptionHtml?: string | null, DispensaryID?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, enterpriseProductId?: string | null, Image?: string | null, integrationKey?: string | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Name?: string | null, Options?: Array<string | null> | null, originalPrices?: Array<string | null> | null, overrides?: Array<string | null> | null, preCropImage?: string | null, Prices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, rawPrices?: Array<number | null> | null, rawMedicalPrices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, reviewedAt?: string | null, reviewedBy?: string | null, score?: number | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, syncedAt?: string | null, updatedAt?: any | null, updatedBy?: string | null, THC?: string | null, type?: string | null, weight?: number | null, isBelowThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, brandLogo?: string | null, brandDescription?: string | null, cName?: string | null, brandId?: string | null, brand?: { __typename?: 'Brand', _id: string, id: string, name: string } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null }> | null, imgixSettings?: { __typename?: 'Products_imgixSettings', productCard?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null, productModal?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', discount?: number | null, percentDiscount?: boolean | null, bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, quantity?: number | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: number | null, dollarDiscount?: boolean | null, menuType?: string | null, minorVersion?: number | null, percentDiscount?: boolean | null, specialName?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null, adminEdits?: Array<{ __typename?: 'Products_adminEdit', updatedAt: string, updatedBy: string } | null> | null };

export type GqlCheckInBucketV2MutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type GqlCheckInBucketV2Mutation = { __typename?: 'Mutation', checkInBucketV2?: { __typename?: 'Bucket', id: string } | null };

export type GqlCheckOutBucketV2MutationVariables = Exact<{
  bucketId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
}>;


export type GqlCheckOutBucketV2Mutation = { __typename?: 'Mutation', checkOutBucketV2: { __typename?: 'Bucket', completedReviewsCount?: number | null, checkedOutAt?: any | null, id: string, name: string, productsCount: number, teamName: string, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null, products: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, CBD?: string | null, connectedAt?: string | null, connectedBy?: string | null, createdAt?: string | null, dateCreated?: string | null, Description?: string | null, descriptionHtml?: string | null, DispensaryID?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, enterpriseProductId?: string | null, Image?: string | null, integrationKey?: string | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Name?: string | null, Options?: Array<string | null> | null, originalPrices?: Array<string | null> | null, overrides?: Array<string | null> | null, preCropImage?: string | null, Prices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, rawPrices?: Array<number | null> | null, rawMedicalPrices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, reviewedAt?: string | null, reviewedBy?: string | null, score?: number | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, syncedAt?: string | null, updatedAt?: any | null, updatedBy?: string | null, THC?: string | null, type?: string | null, weight?: number | null, isBelowThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, brandLogo?: string | null, brandDescription?: string | null, cName?: string | null, brandId?: string | null, brand?: { __typename?: 'Brand', _id: string, id: string, name: string } | null, matchedLibraryItems?: Array<{ __typename?: 'Products_matchedLibraryItems', _id?: string | null, name?: string | null, score?: number | null } | null> | null, dispensary?: { __typename?: 'Dispensaries', id: string, medicalDispensary?: boolean | null, medicalOnly?: boolean | null, name?: string | null, recDispensary?: boolean | null, timezone?: string | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', isolatedMenus: boolean } } | null, libraryProduct?: { __typename?: 'LibraryProduct', id: string, name: string } | null, speculativeEdits?: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, CBD?: string | null, connectedAt?: string | null, connectedBy?: string | null, createdAt?: string | null, dateCreated?: string | null, Description?: string | null, descriptionHtml?: string | null, DispensaryID?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, enterpriseProductId?: string | null, Image?: string | null, integrationKey?: string | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Name?: string | null, Options?: Array<string | null> | null, originalPrices?: Array<string | null> | null, overrides?: Array<string | null> | null, preCropImage?: string | null, Prices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, rawPrices?: Array<number | null> | null, rawMedicalPrices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, reviewedAt?: string | null, reviewedBy?: string | null, score?: number | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, syncedAt?: string | null, updatedAt?: any | null, updatedBy?: string | null, THC?: string | null, type?: string | null, weight?: number | null, isBelowThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, brandLogo?: string | null, brandDescription?: string | null, cName?: string | null, brandId?: string | null, brand?: { __typename?: 'Brand', _id: string, id: string, name: string } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null }> | null, imgixSettings?: { __typename?: 'Products_imgixSettings', productCard?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null, productModal?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', discount?: number | null, percentDiscount?: boolean | null, bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, quantity?: number | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: number | null, dollarDiscount?: boolean | null, menuType?: string | null, minorVersion?: number | null, percentDiscount?: boolean | null, specialName?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null, adminEdits?: Array<{ __typename?: 'Products_adminEdit', updatedAt: string, updatedBy: string } | null> | null } | null> | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null }> | null, imgixSettings?: { __typename?: 'Products_imgixSettings', productCard?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null, productModal?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', discount?: number | null, percentDiscount?: boolean | null, bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, quantity?: number | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: number | null, dollarDiscount?: boolean | null, menuType?: string | null, minorVersion?: number | null, percentDiscount?: boolean | null, specialName?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null, adminEdits?: Array<{ __typename?: 'Products_adminEdit', updatedAt: string, updatedBy: string } | null> | null } | null> } };

export type GqlCheckOutBucketV3MutationVariables = Exact<{
  bucketId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
}>;


export type GqlCheckOutBucketV3Mutation = { __typename?: 'Mutation', checkOutBucketV3: { __typename?: 'BucketV2', completedReviewsCount?: number | null, checkedOutAt?: any | null, id: string, name: string, productIds: Array<string | null>, productsCount: number, teamName: string, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type GqlCloseBucketMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlCloseBucketMutation = { __typename?: 'Mutation', closeBucket: { __typename?: 'Bucket', id: string } };

export type GqlConnectProductPreviewMutationVariables = Exact<{
  id: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
}>;


export type GqlConnectProductPreviewMutation = { __typename?: 'Mutation', connectProductPreview?: { __typename?: 'ConnectProductPreviewResponse', previewProduct: { __typename?: 'PreviewProduct', product: { __typename?: 'PreviewMongoProduct', _id?: string | null, id?: string | null, additionalOptions?: Array<string | null> | null, brandId?: string | null, brandLogo?: string | null, brandName?: string | null, cName?: string | null, description?: string | null, descriptionHtml?: string | null, dispensaryId?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, image?: string | null, integrationKey?: string | null, isBelowKioskThreshold?: boolean | null, isBelowThreshold?: boolean | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, name?: string | null, options?: Array<string | null> | null, overrides?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, strainType?: string | null, status?: string | null, subcategory?: string | null, type?: string | null, weight?: number | null, brand?: { __typename?: 'Brand', id: string, imageUrl?: string | null, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, matchedLibraryItems?: Array<{ __typename?: 'Products_matchedLibraryItems', _id?: string | null } | null> | null, posMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null }, productImages: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null } | null>, productBatch?: { __typename?: 'ProductBatch', id?: string | null } | null, terpenes: Array<{ __typename?: 'Products_Terpene', id?: string | null, terpeneId?: string | null, name?: string | null, unit?: PotencyUnit | null, active?: boolean | null }>, appliedLibraryAttributes: { __typename?: 'PreviewMongoProduct', additionalOptions?: Array<string | null> | null, brandId?: string | null, brandLogo?: string | null, brandName?: string | null, cName?: string | null, description?: string | null, descriptionHtml?: string | null, dispensaryId?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, image?: string | null, integrationKey?: string | null, isBelowKioskThreshold?: boolean | null, isBelowThreshold?: boolean | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, modifiedAttributes?: Array<string | null> | null, name?: string | null, options?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, strainType?: string | null, status?: string | null, subcategory?: string | null, type?: string | null, weight?: number | null, brand?: { __typename?: 'Brand', id: string, imageUrl?: string | null, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, matchedLibraryItems?: Array<{ __typename?: 'Products_matchedLibraryItems', _id?: string | null } | null> | null, posMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null } } } | null };

export type GqlCreateBucketV2MutationVariables = Exact<{
  bucket: GqlCreateBucketInput;
}>;


export type GqlCreateBucketV2Mutation = { __typename?: 'Mutation', createBucketV2: { __typename?: 'Bucket', id: string } };

export type GqlCreateBucketV3MutationVariables = Exact<{
  bucket: GqlCreateBucketInputV3;
}>;


export type GqlCreateBucketV3Mutation = { __typename?: 'Mutation', createBucketV3: { __typename?: 'Bucket', id: string } };

export type GqlDisconnectBucketProductMutationVariables = Exact<{
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type GqlDisconnectBucketProductMutation = { __typename?: 'Mutation', disconnectBucketProduct?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSkipBucketProductV2MutationVariables = Exact<{
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  skipReasons: Array<SkipReasonEnum> | SkipReasonEnum;
}>;


export type GqlSkipBucketProductV2Mutation = { __typename?: 'Mutation', skipBucketProductV2: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } };

export type GqlSkipBucketProductMutationVariables = Exact<{
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type GqlSkipBucketProductMutation = { __typename?: 'Mutation', skipBucketProduct: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } };

export type GqlConnectNewProductPreviewQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
}>;


export type GqlConnectNewProductPreviewQuery = { __typename?: 'Query', connectNewProductPreview?: { __typename?: 'ConnectProductPreviewResponse', previewProduct: { __typename?: 'PreviewProduct', product: { __typename?: 'PreviewMongoProduct', _id?: string | null, id?: string | null, additionalOptions?: Array<string | null> | null, brandId?: string | null, brandLogo?: string | null, brandName?: string | null, cName?: string | null, description?: string | null, descriptionHtml?: string | null, dispensaryId?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, image?: string | null, integrationKey?: string | null, isBelowKioskThreshold?: boolean | null, isBelowThreshold?: boolean | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, name?: string | null, options?: Array<string | null> | null, overrides?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, strainType?: string | null, status?: string | null, subcategory?: string | null, type?: string | null, weight?: number | null, brand?: { __typename?: 'Brand', id: string, imageUrl?: string | null, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, matchedLibraryItems?: Array<{ __typename?: 'Products_matchedLibraryItems', _id?: string | null } | null> | null, posMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null }, productImages: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null } | null>, productBatch?: { __typename?: 'ProductBatch', id?: string | null } | null, terpenes: Array<{ __typename?: 'Products_Terpene', id?: string | null, terpeneId?: string | null, name?: string | null, unit?: PotencyUnit | null, active?: boolean | null }>, appliedLibraryAttributes: { __typename?: 'PreviewMongoProduct', additionalOptions?: Array<string | null> | null, brandId?: string | null, brandLogo?: string | null, brandName?: string | null, cName?: string | null, description?: string | null, descriptionHtml?: string | null, dispensaryId?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, image?: string | null, integrationKey?: string | null, isBelowKioskThreshold?: boolean | null, isBelowThreshold?: boolean | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, modifiedAttributes?: Array<string | null> | null, name?: string | null, options?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, strainType?: string | null, status?: string | null, subcategory?: string | null, type?: string | null, weight?: number | null, brand?: { __typename?: 'Brand', id: string, imageUrl?: string | null, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null, matchedLibraryItems?: Array<{ __typename?: 'Products_matchedLibraryItems', _id?: string | null } | null> | null, posMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', range?: Array<number | null> | null, unit: string } | null } } } | null };

export type GqlContentStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlContentStatisticsQuery = { __typename?: 'Query', contentStatistics?: { __typename?: 'ContentStatistics', connectedPercentage?: number | null, menuScore?: number | null } | null };

export type GqlGetBucketsQueryVariables = Exact<{
  sort?: InputMaybe<GqlBrandsSortInput>;
}>;


export type GqlGetBucketsQuery = { __typename?: 'Query', getBuckets: Array<{ __typename?: 'Bucket', checkedOutAt?: any | null, completedReviewsCount?: number | null, id: string, name: string, productsCount: number, teamName: string, createdBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> };

export type GqlGetProductQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
}>;


export type GqlGetProductQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, CBD?: string | null, connectedAt?: string | null, connectedBy?: string | null, createdAt?: string | null, dateCreated?: string | null, Description?: string | null, descriptionHtml?: string | null, DispensaryID?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, enterpriseProductId?: string | null, Image?: string | null, integrationKey?: string | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Name?: string | null, Options?: Array<string | null> | null, originalPrices?: Array<string | null> | null, overrides?: Array<string | null> | null, preCropImage?: string | null, Prices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, rawPrices?: Array<number | null> | null, rawMedicalPrices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, reviewedAt?: string | null, reviewedBy?: string | null, score?: number | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, syncedAt?: string | null, updatedAt?: any | null, updatedBy?: string | null, THC?: string | null, type?: string | null, weight?: number | null, isBelowThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, brandLogo?: string | null, brandDescription?: string | null, cName?: string | null, brandId?: string | null, brand?: { __typename?: 'Brand', _id: string, id: string, name: string } | null, matchedLibraryItems?: Array<{ __typename?: 'Products_matchedLibraryItems', _id?: string | null, name?: string | null, score?: number | null } | null> | null, dispensary?: { __typename?: 'Dispensaries', id: string, medicalDispensary?: boolean | null, medicalOnly?: boolean | null, name?: string | null, recDispensary?: boolean | null, timezone?: string | null, location?: { __typename?: 'Dispensaries_profile_location', state?: string | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', isolatedMenus: boolean } } | null, libraryProduct?: { __typename?: 'LibraryProduct', id: string, name: string } | null, speculativeEdits?: Array<{ __typename?: 'Products', id?: string | null, _id?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, CBD?: string | null, connectedAt?: string | null, connectedBy?: string | null, createdAt?: string | null, dateCreated?: string | null, Description?: string | null, descriptionHtml?: string | null, DispensaryID?: string | null, dispensaryName?: string | null, duplicatedProductId?: string | null, effects?: any | null, enterpriseProductId?: string | null, Image?: string | null, integrationKey?: string | null, matchedLibraryItemsConfidence?: number | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Name?: string | null, Options?: Array<string | null> | null, originalPrices?: Array<string | null> | null, overrides?: Array<string | null> | null, preCropImage?: string | null, Prices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, rawPrices?: Array<number | null> | null, rawMedicalPrices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, reviewedAt?: string | null, reviewedBy?: string | null, score?: number | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, syncedAt?: string | null, updatedAt?: any | null, updatedBy?: string | null, THC?: string | null, type?: string | null, weight?: number | null, isBelowThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, brandLogo?: string | null, brandDescription?: string | null, cName?: string | null, brandId?: string | null, brand?: { __typename?: 'Brand', _id: string, id: string, name: string } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null }> | null, imgixSettings?: { __typename?: 'Products_imgixSettings', productCard?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null, productModal?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', discount?: number | null, percentDiscount?: boolean | null, bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, quantity?: number | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: number | null, dollarDiscount?: boolean | null, menuType?: string | null, minorVersion?: number | null, percentDiscount?: boolean | null, specialName?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null, adminEdits?: Array<{ __typename?: 'Products_adminEdit', updatedAt: string, updatedBy: string } | null> | null } | null> | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, origin: ImageOrigin, active: boolean, label?: string | null, description?: string | null }> | null, imgixSettings?: { __typename?: 'Products_imgixSettings', productCard?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null, productModal?: { __typename?: 'ImgixSettings', border?: string | null, mark?: string | null, markscale?: number | null, markpad?: number | null, fit?: ImgixSettings_FitType | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null, tagName?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', discount?: number | null, percentDiscount?: boolean | null, bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, quantity?: number | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: number | null, dollarDiscount?: boolean | null, menuType?: string | null, minorVersion?: number | null, percentDiscount?: boolean | null, specialName?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null, adminEdits?: Array<{ __typename?: 'Products_adminEdit', updatedAt: string, updatedBy: string } | null> | null } | null> } | null };

export type GqlRefreshBucketQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlRefreshBucketQuery = { __typename?: 'Query', getBucket: { __typename?: 'Bucket', checkedOutAt?: any | null, completedReviewsCount?: number | null, id: string, name: string, productsCount: number, teamName: string, createdBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type GqlCopyLibraryProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  stateLibraryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GqlCopyLibraryProductMutation = { __typename?: 'Mutation', copyLibraryProduct?: { __typename?: 'CopyLibraryProductResponse', libraryProducts?: Array<{ __typename?: 'LibraryProduct', dispensaryId: string } | null> | null, meta?: { __typename?: 'CopyLibraryProductMeta', errors?: Array<{ __typename?: 'CopyLibraryProductErrors', type?: string | null, errors?: string | null, state_library_id?: string | null } | null> | null } | null } | null };

export type GqlCreateBucketForLibraryItemMutationVariables = Exact<{
  libraryItemId: Scalars['ID']['input'];
}>;


export type GqlCreateBucketForLibraryItemMutation = { __typename?: 'Mutation', createBucketForLibraryItem: { __typename?: 'Bucket', id: string } };

export type GqlDeleteLibraryProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteLibraryProductMutation = { __typename?: 'Mutation', deleteLibraryProduct?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlUpdateLibraryProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
}>;


export type GqlUpdateLibraryProductMutation = { __typename?: 'Mutation', updateLibraryProduct?: { __typename?: 'UpdateLibraryProductResponse', libraryProduct?: { __typename?: 'LibraryProduct', dispensaryId: string } | null } | null };

export type GqlFindLibraryProductsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlFindLibraryProductsQuery = { __typename?: 'Query', findLibraryProducts?: { __typename?: 'FindLibraryProductsResponse', libraryProducts?: Array<{ __typename?: 'LibraryProduct', dispensaryId: string } | null> | null } | null };

export type GqlGetLibraryProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetLibraryProductQuery = { __typename?: 'Query', getLibraryProduct?: { __typename?: 'LibraryProduct', id: string, category?: string | null, cannabinoidRatio?: string | null, connectedCount?: number | null, description?: string | null, descriptionHtml?: string | null, dispensaryId: string, dosageMg?: number | null, effects?: any | null, gtin?: string | null, image?: string | null, name: string, options?: Array<string | null> | null, packSize?: number | null, prices?: Array<number | null> | null, productTemplate?: boolean | null, sku?: string | null, strainType?: string | null, stockImage?: string | null, subcategory?: string | null, productBatchId?: string | null, suggestedCannabinoidRatio?: string | null, suggestedDosageMg?: number | null, suggestedPackSize?: number | null, suggestedWeightGrams?: number | null, weightGrams?: number | null, brand?: { __typename?: 'Brand', id: string, name: string, isGlobal: boolean, _id: string } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, active: boolean, origin: ImageOrigin } | null> | null, cannabinoids?: Array<{ __typename?: 'Products_CannabinoidV2', cannabinoidId?: string | null, unit?: PotencyUnit | null, value?: number | null, active?: boolean | null, cannabinoid?: { __typename?: 'Cannabinoid', id: string, description?: string | null, name: string } | null }> | null, terpenes?: Array<{ __typename?: 'Products_Terpene', name?: string | null, id?: string | null, terpeneId?: string | null, unit?: PotencyUnit | null, value?: number | null, active?: boolean | null, libraryTerpene?: { __typename?: 'Terpene', name?: string | null } | null }> | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null };

export type GqlGetLibraryProductChangeEventsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GqlGetLibraryProductChangeEventsQuery = { __typename?: 'Query', productChangeEvents?: Array<{ __typename?: 'ProductChangeEvent', id?: string | null, createdAt?: string | null, createdBy?: string | null, event: ProductChangeEventType, metadata?: any | null, newValues?: any | null, oldValues?: any | null, productId: string, versionId?: string | null, createdByUser?: { __typename?: 'Users', firstName?: string | null, lastName?: string | null, fullName?: string | null } | null } | null> | null };

export type GqlStateLibrariesIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlStateLibrariesIndexQuery = { __typename?: 'Query', getStateLibraries: Array<{ __typename?: 'StateLibrary', id: string, name: string, state: string }> };

export type GqlLibraryProductChangeImpactV2QueryVariables = Exact<{
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
}>;


export type GqlLibraryProductChangeImpactV2Query = { __typename?: 'Query', libraryProductChangeImpactV2?: { __typename?: 'LibraryProductChangeImpactResponse', totalCount?: { __typename?: 'LibraryProductChangeImpactCount', count?: number | null } | null } | null };

export type GqlLibraryProductChangeImpactV3MutationVariables = Exact<{
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
}>;


export type GqlLibraryProductChangeImpactV3Mutation = { __typename?: 'Mutation', libraryProductChangeImpactV3?: { __typename?: 'LibraryProductChangeImpactResponse', totalCount?: { __typename?: 'LibraryProductChangeImpactCount', count?: number | null } | null } | null };

export type GqlLibraryProductsIndexQueryVariables = Exact<{
  filters?: InputMaybe<GqlSearchLibraryProductsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchLibraryProductsSort>;
}>;


export type GqlLibraryProductsIndexQuery = { __typename?: 'Query', searchLibraryProducts?: { __typename?: 'LibraryProducts', libraryProducts?: Array<{ __typename?: 'LibraryProduct', category?: string | null, connectedCount?: number | null, createdAt?: any | null, description?: string | null, dispensaryId: string, id: string, menuScore: number, name: string, subcategory?: string | null, updatedAt?: any | null, updatedByBrand?: boolean | null, brand?: { __typename?: 'Brand', id: string, isGlobal: boolean, name: string } | null, createdBy?: { __typename?: 'Users', firstName?: string | null, fullName?: string | null, lastName?: string | null } | null } | null> | null, meta?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlProductFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlProductFiltersQuery = { __typename?: 'Query', productFilters?: { __typename?: 'ProductFilters', dispensaryDropdownOptions: Array<{ __typename?: 'DispensaryDropdownOption', key?: string | null, label?: string | null, state?: string | null, status?: string | null, value?: string | null } | null>, chainDropdownOptions?: Array<{ __typename?: 'ChainDropdownOption', key?: string | null, label?: string | null, value?: string | null } | null> | null, statesDropdownOptions: Array<{ __typename?: 'DropdownOption', key?: string | null, label?: string | null, value?: string | null } | null> } | null };

export type GqlSuperProductsQueryVariables = Exact<{
  filter: GqlSuperProductsInput;
}>;


export type GqlSuperProductsQuery = { __typename?: 'Query', superProducts?: { __typename?: 'MenuCleanup', products: Array<{ __typename?: 'Products', _id?: string | null, id?: string | null, brandId?: string | null, brandName?: string | null, DispensaryID?: string | null, matchedLibraryItemsConfidence?: number | null, Name?: string | null, score?: number | null, strainType?: string | null, type?: string | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null } | null>, queryInfo: { __typename?: 'queryInfoType', totalCount?: number | null } } | null };

export type GqlGetUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetUserQuery = { __typename?: 'Query', getConsumerUser?: { __typename?: 'ConsumerUser', _id?: string | null, email?: string | null, profile?: { __typename?: 'consumerUserProfile', phone?: string | null, phoneVerifiedAt?: string | null, textNotifications?: boolean | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null } | null, customers?: Array<{ __typename?: 'Customers', _id?: string | null, emailSubscription?: boolean | null, dispensaryName?: string | null } | null> | null } | null };

export type GqlDispensaryUpdateStatusMutationVariables = Exact<{
  input: GqlDispensaryUpdateStatusInput;
}>;


export type GqlDispensaryUpdateStatusMutation = { __typename?: 'Mutation', dispensaryUpdateStatus?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlPendingDispensariesQueryVariables = Exact<{
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSortInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlPendingDispensariesQuery = { __typename?: 'Query', pendingDispensaries?: { __typename?: 'PendingDispensariesResult', dispensaries?: Array<{ __typename?: 'Dispensaries', createdAtISO?: any | null, id: string, name?: string | null, phone?: string | null } | null> | null, meta?: { __typename?: 'Meta', totalCount?: number | null } | null } | null };

export type GqlSuperGetOrdersQueryVariables = Exact<{
  input: GqlGetOrdersInput;
}>;


export type GqlSuperGetOrdersQuery = { __typename?: 'Query', getOrders?: { __typename?: 'AdminOrderListType', orders?: Array<{ __typename?: 'AdminOrderType', _id: string, createdAt?: any | null, customerId?: string | null, customerName?: string | null, delivery?: boolean | null, dispensaryId?: string | null, dispensaryName?: string | null, dispoTimezone?: string | null, duration?: number | null, isAnonymous?: boolean | null, isAfterHoursOrder?: boolean | null, isKioskOrder?: boolean | null, orderId?: string | null, status?: string | null, totalCost?: number | null, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null } | null, durationEstimates?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', highInMinutes?: number | null, lowInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', highInMinutes?: number | null, lowInMinutes?: number | null } | null } | null } | null> | null } | null };

export type GqlUpdateChainDispensariesImageMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  imageVariantKey: ImageVariantKeyEnum;
}>;


export type GqlUpdateChainDispensariesImageMutation = { __typename?: 'Mutation', updateChainDispensariesImage?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlSuperAdminsTableQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlSuperAdminsTableQuery = { __typename?: 'Query', filteredUsers?: Array<{ __typename?: 'Users', _id?: string | null, email?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null, permissions?: { __typename?: 'Users_permissions', menuReview?: boolean | null, superMenuReview?: boolean | null } | null } | null> | null };

export type GqlGetDispensariesAdSettingsByMenuVariantQueryVariables = Exact<{
  input: GqlGetDispensariesAdSettingsByMenuVariantInput;
}>;


export type GqlGetDispensariesAdSettingsByMenuVariantQuery = { __typename?: 'Query', getDispensariesAdSettingsByMenuVariant?: Array<{ __typename?: 'DispensariesAdSettingsByMenuVariantResult', id: string, name?: string | null, adSettings?: { __typename?: 'AdSettings', enableAdsForDefault?: boolean | null, enableAdsForEmbedded?: boolean | null, enableAdsForKiosk?: boolean | null, enableAdsForStoreFront?: boolean | null } | null }> | null };

export type GqlUpdateDispensaryAdSettingsMutationVariables = Exact<{
  input: GqlUpdateDispensaryAdSettingsInput;
}>;


export type GqlUpdateDispensaryAdSettingsMutation = { __typename?: 'Mutation', updateDispensaryAdSettings?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlImportCustomerCsvMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  CSV: Scalars['String']['input'];
}>;


export type GqlImportCustomerCsvMutation = { __typename?: 'Mutation', importCustomerCSV?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlImportDeliveryZipCodesMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  csv: Scalars['String']['input'];
}>;


export type GqlImportDeliveryZipCodesMutation = { __typename?: 'Mutation', importDeliveryZipCodes?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlGetDispensariesByPersonalizationSettingsQueryVariables = Exact<{
  input: GqlGetDispensariesByPersonalizationSettingsInput;
}>;


export type GqlGetDispensariesByPersonalizationSettingsQuery = { __typename?: 'Query', getDispensariesByPersonalizationSettings?: Array<{ __typename?: 'DispensariesPersonalizationSettingsByMenuVariantResult', id: string, name?: string | null, personalizationSettings?: { __typename?: 'PersonalizationSettings', enablePersonalizationForDefault?: boolean | null, enablePersonalizationForEmbedded?: boolean | null, enablePersonalizationForKiosk?: boolean | null, enablePersonalizationForStoreFront?: boolean | null } | null }> | null };

export type GqlUpdateDispensaryPersonalizationSettingsMutationVariables = Exact<{
  input: GqlUpdateDispensaryPersonalizationSettingsInput;
}>;


export type GqlUpdateDispensaryPersonalizationSettingsMutation = { __typename?: 'Mutation', updateDispensaryPersonalizationSettings?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateCnameMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  cname: Scalars['String']['input'];
}>;


export type GqlUpdateCnameMutation = { __typename?: 'Mutation', updateCname?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateUserEmailMutationVariables = Exact<{
  currentEmail: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
}>;


export type GqlUpdateUserEmailMutation = { __typename?: 'Mutation', updateUserEmail?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateUserPermissionsMutationVariables = Exact<{
  email: Scalars['String']['input'];
  permission: Scalars['String']['input'];
}>;


export type GqlUpdateUserPermissionsMutation = { __typename?: 'Mutation', updateUserPermissions?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateUserRoleV2MutationVariables = Exact<{
  email: Scalars['String']['input'];
  role: UserRoles;
}>;


export type GqlUpdateUserRoleV2Mutation = { __typename?: 'Mutation', updateUserRoleV2?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlSuperAdminConsumerUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GqlSuperAdminConsumerUserByEmailQuery = { __typename?: 'Query', superAdminConsumerUserByEmail?: { __typename?: 'SuperAdminConsumerUser', id: string, name?: string | null, email: string, isSso: boolean, ssoProvider?: string | null } | null };

export type GqlRemoveConsumerSsoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GqlRemoveConsumerSsoMutation = { __typename?: 'Mutation', removeConsumerSso?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export const BrandDispensaryFragmentFragmentDoc = gql`
    fragment brandDispensaryFragment on Brand {
  dispensary {
    id
    name
  }
}
    `;
export const BrandFragmentForDropdownFragmentDoc = gql`
    fragment brandFragmentForDropdown on Brand {
  _id
  id
  name
  imageUrl
}
    `;
export const BrandFragmentFragmentDoc = gql`
    fragment brandFragment on Brand {
  _id
  aliasList
  companyEmail
  createdAt
  description
  id
  imageUrl
  libraryProductsCount
  name
  productsCount
  updatedAt
  websiteUrl
}
    `;
export const BucketListFragmentFragmentDoc = gql`
    fragment bucketListFragment on Bucket {
  createdBy {
    _id
    firstName
    lastName
  }
  checkedOutAt
  checkedOutBy {
    _id
    firstName
    lastName
  }
  completedReviewsCount
  id
  name
  productsCount
  teamName
}
    `;
export const CouponFragmentFragmentDoc = gql`
    fragment couponFragment on Coupons {
  _id
  active
  addedDate
  applicableCategories {
    category
    subcategory
  }
  code
  dispensaryId
  expDate
  fixedDiscountInCents
  numAllowedUses
  numUses
  percentDiscount
  oneUsePerCustomer
  restrictions {
    minimumPurchase
    minimumPurchaseInCents
    noSpecials
  }
  usedBy
}
    `;
export const DeviceFragmentFragmentDoc = gql`
    fragment deviceFragment on Devices {
  _id
  accessCode
  autoPrintDevice
  buildNumber
  config {
    getDeliveryOrders
    getKioskOrders
    getPickupOrders
    orderSource
  }
  deviceType
  dispensaryId
  lastSeenAt
  nickname
  online
  printerConnected
  updatedAt
  versionNumber
}
    `;
export const HourSetFragmentFragmentDoc = gql`
    fragment hourSetFragment on Dispensaries_profile_hours {
  Monday {
    active
    end
    start
  }
  Tuesday {
    active
    end
    start
  }
  Wednesday {
    active
    end
    start
  }
  Thursday {
    active
    end
    start
  }
  Friday {
    active
    end
    start
  }
  Saturday {
    active
    end
    start
  }
  Sunday {
    active
    end
    start
  }
}
    `;
export const PaymentTypesFragmentFragmentDoc = gql`
    fragment paymentTypesFragment on PaymentTypesConfig {
  alt36
  check
  creditCardAtDoor
  payOnlineChase
  payOnlineHypur
  payOnlineMerrco
  payOnlineMoneris
  creditCardByPhone
  debit
  dutchiePay
  rethinkPay
  cash
  linx
  canPay
  paytender
  aeropay
}
    `;
export const BaseDispensaryFragmentFragmentDoc = gql`
    fragment baseDispensaryFragment on Dispensaries {
  id
  customDomainSettings {
    domain
  }
  plusSettings {
    checkoutUrl
    defaultReturnUrl
  }
  distance
  name
  cName
  timezone
  phone
  address
  description
  dposLspName
  status
  chain
  location {
    ln1
    ln2
    city
    state
    country
    zipcode
    geometry {
      coordinates
    }
  }
  temporalLocation {
    lastUpdatedAt
    coordinates
    onDuty
    nearbyEnabled
  }
  deliveryHours {
    ...hourSetFragment
  }
  pickupHours {
    ...hourSetFragment
  }
  categoryPhotos {
    src
    category
  }
  customCategoryPhotos {
    url
    category
    collectionId
  }
  effectiveHours {
    deliveryHours {
      ...hourSetFragment
    }
    pickupHours {
      ...hourSetFragment
    }
  }
  offerAnyPickupService
  offerPickup
  offerCurbsidePickup
  offerDelivery
  listImage
  bannerImage
  logoImage
  embeddedLogoImage
  embeddedMenuUrl
  SpecialLogoImage
  brandedDutchiePayEnabled
  brandedDutchiePayName
  brandedDutchiePayLogoLight
  brandedDutchiePayLogoDark
  payByBankPreauthorizationAvailable
  embedBackUrl
  embedSettings {
    disclaimerTextHtml
    disablePageLoadsAtTop
    enableFullScreenEmbeddedCheckout
    autoGTM
    privacyPolicyUrl
  }
  alt36
  check
  creditCardAtDoor
  payOnlineHypur
  payOnlineMerrco
  creditCardByPhone
  debitOnly
  cashless
  createdAtISO
  linx
  canPay
  paytender
  aeropay
  recDispensary
  medicalDispensary
  maxDeliveryDistance
  mixAndMatchPricingWeights
  feeTiers {
    fee
    feeType
    max
    min
    percentFee
  }
  acceptsTips
  acceptsDutchiePayTips
  acceptsCreditCardTips
  requiresDriversLicense
  requiresDriversLicenseForPickup
  requiresDriversLicenseExpirationDate
  requirePhotoIdForDelivery
  requirePhotoIdForPickup
  removeMedicalCardFieldsAtCheckout
  menuOrder
  menuOrderSettings {
    category
    menuOrder
  }
  menuSortSettings {
    brands
    category
    menuOrder
  }
  email
  emailConfirmation
  actionEstimates {
    pickup {
      readyInMinutes
      rangeInMinutes
    }
    delivery {
      readyInMinutes
      rangeInMinutes
      deliveryTimeInMinutes
    }
  }
  durationEstimateOverrides {
    delivery {
      enabled
      lowInMinutes
      highInMinutes
    }
    pickup {
      enabled
      lowInMinutes
      highInMinutes
    }
  }
  paymentFees {
    fee
    feeType
    paymentType
  }
  kioskOrderingEnabled
  kioskConfig {
    fullNameOnly
    phoneRequired
    notesField
    directedOrders
    hidePhoneField
    hideEmailField
    showBirthdateField
    disableFasterCheckout
    type
  }
  categoryLimits {
    name
    value
  }
  categoryLimitsEnabled
  specialsSettings {
    discountBehavior
    discountStacking
    discountPrecedence
    enableIndividualSpecialPrecedence
    enableIndividualDiscountStacking
    stackingBehavior
    nonStackingBehavior
  }
  storeSettings {
    isolatedMenus
    customerMessagingTermsAccepted
    showPOSPackageId
    defaultViewStyle
    disablePurchaseLimits
    configurablePurchaseLimitsEnabled
    customPurchaseLimits
    minimumAgeOverrides {
      country
      region
      medical
      rec
    }
    disableGuestDOB
    displayPhoneConfirmation
    displayKioskAnonymousCheckoutDisclaimer
    enableDutchiePayConsumerSurcharge
    requireEmailAddressForGuestCheckout
    requireMedCardPhotoForPickup
    requireMedCardFieldsAtCheckout
    hideAddressFromDutchieMain
    hideFromMobileApp
    hideFromSearchEngines
    requireMedCardPhotoForDelivery
    enableMMURAllotmentCheck
    blockOrderOnMMURAllotmentFailure
    cloudPrntEnabled
    cloudPrntAutomaticPrintingEnabled
    enableAfterHoursOrderingForPickup
    enableAfterHoursOrderingForDelivery
    enableLLxSaleDiscountSync
    enableMixAndMatchPricingForPickup
    enableMixAndMatchPricingForDelivery
    enableOtherLocations
    enableProductUrgencyMessaging
    enableScheduledOrderingForPickup
    enableScheduledOrderingForDelivery
    enableLimitPerCustomer
    quantityLimit
    quantityLimitMaxAvailable
    enableOrderStatusEmails
    enableOrderTypeTakeoverModal
    enableStorefrontAgeGate
    skipOnlineAgeVerification
    enableDiscountGamification
    enableCartInterstitial
    hardAgeGateHideMenuContent
    collapseProductDescription
    disableGuestCheckout
    requirePaymentMethodSelection
    requireTermsAcceptance
    enableConcierge
    enableKioskConcierge
    enableCustomTerms
    customTermsText
    stealthMode
    disableAIReviewModeration
    dontCombineWeightedProducts
    keepUncombinedWeights
    dontMapSubcategoriesByProductName
    prioritizeStaffPicksInSearchResults
    provideBackInstockEmailNotifications
    hideCannabinoidDescriptions
    hideEffects
    hideFilters
    hideTotalTerpenes
    hideOutOfStockProducts
    showLoyaltyRewards
    aiqSmsPinTriggerBehavior
    hideDiscountsFromConsumer
    hideCategoryTiles
    restrictSalesLanguage
    usePotencyForConcentrateLimits
    useStandardEquivalentForEdiblesLimits
    useStateRegulatedImageWatermarks
    enableOmniauthLoginCheckout
    disableSpecialInstructions
    subscriptions {
      enabled
    }
    rewardsIntegrationConfiguration {
      rewardsProgramDisplayDescription
      rewardsProgramDisplayEnrollment
      rewardsProgramDisplayName
    }
    enableRoundToNearestDollar
    hideRoundingLineItem
    specialsPage {
      showSpecialsRedesign
      showCategoryTiles
      showSpecialDuration
    }
  }
  featureFlags {
    enableAfterHoursOrdering
    enableArrivals
    enableMenuImport
    enableMixAndMatch
    enableNonTerminalAutoConfirm
    enablePausedOrders
    enableScheduledOrdering
    hideDeliveryEstimate
    hideMyAccount
    hideStoreHours
  }
  updatedAt
  updatedAtISO
  ordersArePaused
  ageVerificationBannerHtml
  ageVerificationBannerColor
  menuBannerHtml
  menuBannerColor
  menuBannerTextBannerCollapsed
  menuUrl
  privacyPolicyUrl
  termsAndConditionsUrl
  colorSettings {
    linkColor
    navBarColor
  }
  orderTypesConfig {
    pickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    curbsidePickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    driveThruPickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    delivery {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    kiosk {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    offerAnyPickupService
    offerDeliveryService
  }
  paymentTypesAccepted {
    alt36
    check
    creditCardAtDoor
    payOnlineChase
    payOnlineHypur
    payOnlineMerrco
    payOnlineMoneris
    creditCardByPhone
    debit
    dutchiePay
    rethinkPay
    cash
    linx
    canPay
    paytender
    aeropay
  }
}
    ${HourSetFragmentFragmentDoc}
${PaymentTypesFragmentFragmentDoc}`;
export const BaseOrderingSettingsFragmentFragmentDoc = gql`
    fragment baseOrderingSettingsFragment on BaseOrderingSettings {
  enableASAPOrdering
  enableScheduledOrdering
  enableAfterHoursOrdering
  checkoutMessage
  creditCardByPhoneCheckoutMessage
  paymentTypes {
    ...paymentTypesFragment
  }
  scheduledOrderingConfigV2 {
    advancedDayOrderingEnabled
    sameDayDeliveryEnabled
    advancedDayOrderingLimit
    incrementInMinutes
    nextAvailableInMinutes
    orderLimitsEnabled
    hideClosedDays
  }
}
    ${PaymentTypesFragmentFragmentDoc}`;
export const CurbsidePickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment curbsidePickupOrderingSettingsFragment on CurbsidePickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  enableCurbsideArrivals
  arrivalInformationInstructions
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
  notificationSettings {
    sms
    email
    push
  }
  autoConfirmSettings {
    enabled
    autoClose
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const DeliveryOrderingSettingsFragmentFragmentDoc = gql`
    fragment deliveryOrderingSettingsFragment on DeliveryOrderingSettings {
  ...baseOrderingSettingsFragment
  deliveryFeeTiers {
    feeInCents
    maximumInCents
    minimumInCents
    feeType
    percentFee
  }
  deliveryMode
  deliveryRadius {
    orderMinimum {
      enabled
      minimumInCents
    }
    radiusInMiles
  }
  deliveryZipCodes {
    zipCode
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
  deliveryCityZones {
    _id
    name
    cities {
      city
      state
    }
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
  notificationSettings {
    sms
    email
    push
  }
  autoConfirmSettings {
    enabled
    autoClose
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const DeliveryZonesFragmentFragmentDoc = gql`
    fragment deliveryZonesFragment on DeliveryOrderingSettings {
  deliveryZones {
    _id
    name
    area {
      type
      features {
        type
        geometry {
          type
          coordinates
        }
      }
    }
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
}
    `;
export const DriveThruPickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment driveThruPickupOrderingSettingsFragment on DriveThruPickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
  notificationSettings {
    sms
    email
    push
  }
  autoConfirmSettings {
    enabled
    autoClose
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const HoursForDayFragmentDoc = gql`
    fragment hoursForDay on dayBounds {
  active
  end
  start
}
    `;
export const WeeklyHoursFragmentFragmentDoc = gql`
    fragment weeklyHoursFragment on WeeklyHours {
  Friday {
    ...hoursForDay
  }
  Monday {
    ...hoursForDay
  }
  Saturday {
    ...hoursForDay
  }
  Sunday {
    ...hoursForDay
  }
  Thursday {
    ...hoursForDay
  }
  Tuesday {
    ...hoursForDay
  }
  Wednesday {
    ...hoursForDay
  }
}
    ${HoursForDayFragmentDoc}`;
export const SpecialHoursDayFragmentFragmentDoc = gql`
    fragment specialHoursDayFragment on SpecialHoursDay {
  date
  hours {
    ...hoursForDay
  }
}
    ${HoursForDayFragmentDoc}`;
export const SpecialHoursFragmentFragmentDoc = gql`
    fragment specialHoursFragment on SpecialHours {
  id
  name
  startDate
  endDate
  hoursPerDay {
    ...specialHoursDayFragment
  }
}
    ${SpecialHoursDayFragmentFragmentDoc}`;
export const HoursSettingsForOrderTypeFragmentFragmentDoc = gql`
    fragment hoursSettingsForOrderTypeFragment on HoursSettingsForOrderType {
  hours {
    ...weeklyHoursFragment
  }
  specialHours {
    ...specialHoursFragment
  }
}
    ${WeeklyHoursFragmentFragmentDoc}
${SpecialHoursFragmentFragmentDoc}`;
export const InStorePickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment inStorePickupOrderingSettingsFragment on InStorePickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
  notificationSettings {
    sms
    email
    push
  }
  autoConfirmSettings {
    enabled
    autoClose
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const KioskOrderingSettingsFragmentFragmentDoc = gql`
    fragment kioskOrderingSettingsFragment on KioskOrderingSettings {
  enabled
  enableAfterHoursOrdering
  fullNameOnly
  phoneRequired
  notesField
  directedOrders
  hideEmailField
  hidePhoneField
  showBirthdateField
  anonymousCheckout
  disableFasterCheckout
  kioskInstructions
  checkoutMessage
  anonymousCheckoutMessage
  creditCardByPhoneCheckoutMessage
  screensaverText
  type
  paymentTypes {
    ...paymentTypesFragment
  }
  timeout {
    enabled
    duration
  }
  notificationSettings {
    sms
    email
    push
  }
  autoConfirmSettings {
    enabled
    autoClose
  }
  kiosks {
    id
    name
    destinationTerminal
  }
}
    ${PaymentTypesFragmentFragmentDoc}`;
export const MaxReservationSlotFragmentFragmentDoc = gql`
    fragment maxReservationSlotFragment on MaxReservationSlot {
  active
  currentCount
  currentCountsByDate
  date
  startTime
  endTime
  maxOrders
  deliveryAreaId
  slotId
  isNextDaySlot
  recurrence {
    frequency
    interval
    anchorDate
    daysOfWeek
  }
}
    `;
export const MaxReservationSlotsByDayFragmentFragmentDoc = gql`
    fragment maxReservationSlotsByDayFragment on MaxReservationSlotsByDay {
  Monday {
    ...maxReservationSlotFragment
  }
  Tuesday {
    ...maxReservationSlotFragment
  }
  Wednesday {
    ...maxReservationSlotFragment
  }
  Thursday {
    ...maxReservationSlotFragment
  }
  Friday {
    ...maxReservationSlotFragment
  }
  Saturday {
    ...maxReservationSlotFragment
  }
  Sunday {
    ...maxReservationSlotFragment
  }
}
    ${MaxReservationSlotFragmentFragmentDoc}`;
export const MenuSectionFragmentFragmentDoc = gql`
    fragment menuSectionFragment on MenuSection {
  id
  brandId
  category
  image {
    _id
    image
    mobileImage
    alt
    platforms {
      enabled
      link
      openInNewTab
      type
    }
    position
  }
  headingOverride
  label
  legacyLabel
  linkLabel
  position
  subcategory
  sectionType
  products
  collectionId
  sortBy
  collectionSchedule {
    startDate
    endDate
    timeRanges {
      id
      dayOfWeek
      startTime
      endTime
    }
  }
}
    `;
export const ScheduledOrderingConfigFragmentFragmentDoc = gql`
    fragment scheduledOrderingConfigFragment on ReservationOptionsForOrderType {
  advancedDayOrderingEnabled
  sameDayDeliveryEnabled
  advancedDayOrderingLimit
  incrementInMinutes
  nextAvailableInMinutes
  orderLimitsEnabled
}
    `;
export const TaxPropertiesFragmentDoc = gql`
    fragment taxProperties on Dispensaries_TaxConfig_Tax {
  id
  type
  name
  rate
  potencyRate
  potency
  medical
  recreational
  taxBasis
  stages {
    op
    type
  }
  applyTo {
    types
    hemp
  }
  order
  deliveryPolicy
  includeStateSalesTaxInDestinationRate
}
    `;
export const PosMetaDataFragmentFragmentDoc = gql`
    fragment POSMetaDataFragment on Products_POSMetaData {
  activeBatchTags {
    tagId
    tagName
  }
  canonicalBrandId
  canonicalBrandName
  canonicalCategory
  canonicalCategoryId
  canonicalID
  canonicalPackageId
  canonicalImgUrl
  canonicalLabResultUrl
  canonicalName
  canonicalProductTags {
    tagId
    tagName
  }
  canonicalSKU
  canonicalStrainId
  canonicalVendorId
  children {
    activeBatchTags {
      tagId
    }
    canonicalBrandId
    canonicalBrandName
    canonicalCategory
    canonicalCategoryId
    canonicalEffectivePotencyMg
    canonicalID
    canonicalPackageId
    canonicalImgUrl
    canonicalLabResultUrl
    canonicalName
    canonicalSKU
    canonicalProductTags {
      tagId
    }
    canonicalStrainId
    canonicalVendorId
    kioskQuantityAvailable
    medPrice
    option
    packageQuantity
    price
    quantity
    quantityAvailable
    recEquivalent {
      value
      unit
    }
    recPrice
    standardEquivalent {
      value
      unit
    }
  }
  integrationID
}
    `;
export const ConsumerBaseProductFragmentFragmentDoc = gql`
    fragment consumerBaseProductFragment on Products {
  _id
  id
  AdditionalOptions
  avgRating
  reviewCount
  duplicatedProductId
  libraryProductId
  libraryProductScore
  brand {
    id
    name
    parentBrandId
    imageUrl
  }
  brandId
  brandName
  CBD
  CBDContent {
    unit
    range
  }
  certificateOfAnalysisEnabled
  collectionCardBadge {
    color
    title
    isAccessibleToCurrentUser
    isExclusive
  }
  comingSoon
  createdAt
  updatedAt
  DispensaryID
  enterpriseProductId
  Image
  images {
    url
    description
    active
  }
  measurements {
    netWeight {
      unit
      values
    }
    volume {
      unit
      values
    }
  }
  medicalOnly
  medicalPrices
  medicalSpecialPrices
  wholesalePrices
  Name
  nonArmsLength
  Options
  limitsPerCustomer {
    key
    value
  }
  manualInventory {
    option
    inventory
  }
  POSMetaData {
    ...POSMetaDataFragment
  }
  posDiscountNames
  POSPricingData
  productCardSpecials {
    id
    name
    description
    startDate
    endDate
    kind
    menuType
  }
  posSyncedPricingApplied {
    medical
    recreational
  }
  legacyPricing {
    medicalPrices
    medicalSpecialPrices
    recPrices
    recSpecialPrices
    Prices
  }
  Prices
  pricingTierData {
    generatedTiersId
    tiersId
    tiersName
    tiers {
      startWeight
      endWeight
      price
      pricePerGram
      weightUOM
    }
  }
  specialIdsPerOption {
    option
    conditionIds
    rewardIds
  }
  rawOptions
  recOnly
  recPrices
  recSpecialPrices
  special
  specialData {
    bogoSpecials {
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        selectedCategoriesAndSubcategories
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        discountAmount
        discountType
        dollarDiscount
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        selectedCategoriesAndSubcategories
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      discountStacking
      discountPrecedence
      endStamp
      excludedProducts {
        conditions {
          _id
          key
          Name
        }
        rewards {
          _id
          key
          Name
        }
      }
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      menuDisplayName
      menuType
      minorVersion
      nonStackingBehavior
      payByBankIncentiveEnabled
      paymentRestrictions {
        payByBankSignupIncentive
      }
      recurringEndDate
      redemptionLimit
      settingsDerivedFrom
      specialId
      specialName
      specialType
      stackingBehavior
      stackingMode
      sourceId
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      version
      qualifyingOptions
      qualifyingConditionOptions
      qualifyingRewardOptions
    }
    saleSpecials {
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discount
      discountStacking
      dollarDiscount
      eligibleProductOptions
      menuType
      minorVersion
      nonStackingBehavior
      payByBankIncentiveEnabled
      paymentRestrictions {
        payByBankSignupIncentive
      }
      percentDiscount
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      settingsDerivedFrom
      source
      sourceId
      specialId
      specialName
      specialType
      specialRestrictions
      stackingBehavior
      stackingMode
      targetPrice
      version
    }
  }
  Status
  strainType
  subcategory
  subcategories
  THC
  THCContent {
    unit
    range
  }
  totalTerpenes {
    unit
    range
  }
  type
  vapeTaxApplicable
  weight
  featured {
    current
    startTime
    endTime
  }
  isBelowThreshold
  isBelowKioskThreshold
  optionsBelowThreshold
  optionsBelowKioskThreshold
  cName
  pastCNames
  brandLogo
  bottleDepositTaxCents
}
    ${PosMetaDataFragmentFragmentDoc}`;
export const ConsumerSponsoredProductFragmentFragmentDoc = gql`
    fragment consumerSponsoredProductFragment on Products {
  ...consumerBaseProductFragment
  adTrackers {
    clickUrl
    impressionUrl
  }
  provider
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on Schedule {
  endDate
  id
  startDate
  timeRanges {
    id
    dayOfWeek
    endTime
    startTime
  }
}
    `;
export const TerpeneFragmentFragmentDoc = gql`
    fragment TerpeneFragment on Terpene {
  aliasList
  aromas
  description
  effects
  id
  name
  unitSymbol
  potentialHealthBenefits
}
    `;
export const AdminIdentityFragmentFragmentDoc = gql`
    fragment adminIdentityFragment on LoginAdmin {
  accessToken
  user {
    _id
    createdAt
    emails {
      address
    }
    profile {
      browserNotification
      chainID
      desktopNotification
      dispensaryId
      emailNotifications
      emailOptIn
      firstName
      fullName
      lastName
      permissions {
        allLocations
        billing
        analytics
        customers
        driver
        enterpriseAdmin
        enterpriseSpecials
        manageAds
        managePersonalization
        menu
        menuReview
        superMenuReview
        orders
        promote
        settings
        users
        tasks
      }
      phone
      type
    }
  }
}
    `;
export const ConsumerUserFragmentFragmentDoc = gql`
    fragment consumerUserFragment on IdentityConsumer {
  _id
  createdAt
  emails {
    address
    verified
    lastVerifiedAt
  }
  profile {
    address {
      city
      lat
      ln1
      ln2
      lng
      state
      zipcode
    }
    birthday
    emailNotifications
    emailOptIn
    firstName
    lastName
    medicalCard {
      expirationDate
      number
      state
      photo
    }
    phone
    phoneVerifiedAt
    textNotifications
    type
    photoId
    isExternalUser
    inStoreEnrollmentCompleted
  }
  payByBankEnrollmentStatus {
    enrollmentStatus
    requiresAggregatorMigration
    paymentMethods {
      id
      status
      type
      bankAccountDetails {
        accountAlias
        bankName
        lastDigits
        status
        aggregator
        expiresAt
        billingAddressId
        financialInstitutionLogo
      }
    }
  }
}
    `;
export const EnterpriseSpecialDataFragmentDoc = gql`
    fragment enterpriseSpecialData on EnterpriseSpecial {
  _id
  active
  menuDisplayName
  menuDisplayDescription
  menuDisplayImage
  applyRewardsToConditions
  excludeConditionItemsFromRewards
  bogoConditionLogicOperator
  bogoConditions {
    _id
    brandId
    brandIds
    brandName
    brandNames
    categoryIds
    categoryName
    categoryNames
    inventoryTags
    enterpriseProductIds
    exclusions {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      enterpriseProductIds
      matchOperator
      productGroup
      productIds
      subcategoryIds
      subcategoryNames
      inventoryTags
      weights
      weightOperator
    }
    productGroup
    productId
    productIds
    quantity
    subcategoryIds
    subcategoryNames
    inventoryTags
    weight
    weightOperator
  }
  bogoRewardLogicOperator
  bogoRewards {
    _id
    brandId
    brandIds
    brandName
    brandNames
    categoryIds
    categoryName
    categoryNames
    inventoryTags
    dollarDiscount
    enterpriseProductIds
    exclusions {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      enterpriseProductIds
      matchOperator
      productGroup
      productIds
      subcategoryIds
      subcategoryNames
      inventoryTags
      weights
      weightOperator
    }
    productGroup
    productId
    productIds
    percentDiscount
    quantity
    targetPrice
    subcategoryIds
    subcategoryNames
    inventoryTags
    weight
  }
  cipher
  clicks
  complete
  createdAt
  createdBy
  description
  descriptionHtml
  discount
  discountedPrices
  discountToCart {
    _id
    enabled
    discountType
    value
  }
  discountPrecedence
  discountStacking
  dispensaryId
  dispensaries
  displayRank: dollarDiscount
  duplicatedFrom
  emailSpecial
  endDay
  endStamp
  endTime
  enterpriseId
  enterpriseSpecialId
  excludedProducts {
    _id
    Name
    key
    conditions {
      _id
      Name
      key
    }
    rewards {
      _id
      Name
      key
    }
  }
  heading
  id
  inactiveDispensaries
  isRecurring
  itemsForAPrice {
    _id
    enabled
    value
  }
  localTime
  menuType
  name
  percentDiscount
  productDiscounts
  productGroup
  productGroupRewards
  products
  recurring {
    days
    endDate
    endTime
    setEndDate
    startTime
  }
  redemptionLimit
  saleDiscounts {
    _id
    brandIds
    brandNames
    categoryIds
    categoryNames
    inventoryTags
    discountAmount
    discountType
    enterpriseProductIds
    exclusions {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      enterpriseProductIds
      matchOperator
      productGroup
      productIds
      subcategoryIds
      subcategoryNames
      inventoryTags
      weights
      weightOperator
    }
    productGroup
    productIds
    subcategoryIds
    subcategoryNames
    inventoryTags
    weights
    weightOperator
  }
  scope
  source
  sourceId
  specialRestrictions
  stackingBehavior
  stackingMode
  startDay
  startStamp
  startTime
  specialType
  subject
  targetPrice
  timezone
  totalQuantity {
    enabled
    maxQuantity
    quantity
    quantityOperator
  }
  totalWeight {
    enabled
    weight
    weightOperator
  }
  totalSpend {
    enabled
    maximumSpend
    minimumSpend
    spendOperator
  }
  updatedAt
  updatedBy
  version
}
    `;
export const SpecialDataFragmentDoc = gql`
    fragment specialData on Specials {
  _id
  active
  applyRewardsToConditions
  menuDisplayName
  menuDisplayDescription
  bogoConditionLogicOperator
  menuDisplayImage
  bogoConditions {
    _id
    brandId
    brandIds
    brandName
    brandNames
    categoryIds
    categoryName
    categoryNames
    enterpriseProductIds
    exclusions {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      enterpriseProductIds
      inventoryTags
      matchOperator
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      weights
      weightOperator
    }
    inventoryTags
    productGroup
    productId
    productTags
    productIds
    quantity
    subcategoryIds
    subcategoryNames
    strainIds
    vendorIds
    weight
    weightOperator
  }
  bogoRewardLogicOperator
  bogoRewards {
    _id
    brandId
    brandIds
    brandName
    brandNames
    categoryIds
    categoryName
    categoryNames
    dollarDiscount
    enterpriseProductIds
    exclusions {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      enterpriseProductIds
      inventoryTags
      matchOperator
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      weights
      weightOperator
    }
    inventoryTags
    productGroup
    productId
    productIds
    percentDiscount
    productTags
    quantity
    targetPrice
    subcategoryIds
    subcategoryNames
    strainIds
    vendorIds
    weight
  }
  clicks
  createdAt
  createdBy
  directPOSProductIdMapping
  rawPOSWeightMapping
  description
  descriptionHtml
  discount
  discountedPrices
  discountPrecedence
  discountStacking
  discountToCart {
    _id
    enabled
    discountType
    value
  }
  dispensaryId
  displayRank
  emailSpecial
  endDay
  endStamp
  endTime
  excludedProducts {
    _id
    Name
    key
    conditions {
      _id
      Name
      key
    }
    rewards {
      _id
      Name
      key
    }
  }
  heading
  isRecurring
  itemsForAPrice {
    _id
    enabled
    value
  }
  menuType
  minorVersion
  name
  paymentRestrictions {
    payByBankSignupIncentive
  }
  percentDiscount
  productDiscounts
  productGroup
  productGroupRewards
  products
  recurring {
    days
    endDate
    endTime
    setEndDate
    startTime
  }
  redemptionLimit
  saleDiscounts {
    _id
    brandIds
    brandNames
    categoryIds
    categoryNames
    discountAmount
    discountType
    enterpriseProductIds
    exclusions {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      enterpriseProductIds
      inventoryTags
      matchOperator
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      weights
      weightOperator
    }
    inventoryTags
    productGroup
    productIds
    productTags
    subcategoryIds
    subcategoryNames
    strainIds
    vendorIds
    weights
    weightOperator
  }
  scope
  source
  sourceId
  specialId
  specialRestrictions
  specialType
  stackingBehavior
  stackingMode
  startDate
  startDay
  startStamp
  startTime
  subject
  targetPrice
  totalQuantity {
    enabled
    maxQuantity
    quantity
    quantityOperator
  }
  totalWeight {
    enabled
    weight
    weightOperator
  }
  totalSpend {
    enabled
    maximumSpend
    minimumSpend
    spendOperator
  }
  updatedAt
  updatedBy
  version
}
    `;
export const DigitalDisplayBoardFolderFieldsFragmentDoc = gql`
    fragment DigitalDisplayBoardFolderFields on DigitalDisplayBoardFolder {
  id
  enterpriseId
  name
  parentId
  boardCount
}
    `;
export const DigitalDisplayBoardFieldsFragmentDoc = gql`
    fragment DigitalDisplayBoardFields on DigitalDisplayBoard {
  id
  enterpriseId
  name
  layout
  orientation
  colorScheme
  menuColumns
  audioEnabled
  visible
  folderIds
  createdAt
  updatedAt
  boardItem {
    id
    assetId
    assetUrl
    contentType
  }
}
    `;
export const AdminProductReviewFieldsFragmentDoc = gql`
    fragment AdminProductReviewFields on AdminProductReview {
  id
  productId
  orderId
  userId
  dispensaryId
  posProductId
  reviewerDisplayName
  rating
  effects
  body
  status
  aiFlagReason
  moderatedBy
  moderatedAt
  createdAt
  updatedAt
  user {
    firstName
    lastName
    fullName
    email
  }
}
    `;
export const AdminContentBaseProductFragmentFragmentDoc = gql`
    fragment adminContentBaseProductFragment on Products {
  id
  _id
  AdditionalOptions
  brand {
    _id
    id
    name
  }
  brandName
  CBD
  CBDContent {
    unit
    range
  }
  connectedAt
  connectedBy
  createdAt
  dateCreated
  Description
  descriptionHtml
  DispensaryID
  dispensaryName
  duplicatedProductId
  effects
  enterpriseProductId
  Image
  images {
    _id
    url
    origin
    active
    label
    description
  }
  imgixSettings {
    productCard {
      border
      mark
      markscale
      markpad
      fit
    }
    productModal {
      border
      mark
      markscale
      markpad
      fit
    }
  }
  integrationKey
  matchedLibraryItemsConfidence
  medicalOnly
  medicalPrices
  medicalSpecialPrices
  Name
  Options
  limitsPerCustomer {
    key
    value
  }
  manualInventory {
    option
    inventory
  }
  originalPrices
  overrides
  POSMetaData {
    ...POSMetaDataFragment
  }
  preCropImage
  Prices
  wholesalePrices
  rawOptions
  rawPrices
  rawMedicalPrices
  recOnly
  recPrices
  recSpecialPrices
  reviewedAt
  reviewedBy
  score
  special
  specialData {
    bogoSpecials {
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        quantity
        weight
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        percentDiscount
        quantity
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        targetPrice
        weight
      }
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      endStamp
      excludedProducts {
        conditions {
          _id
          key
          Name
        }
        rewards {
          _id
          key
          Name
        }
      }
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      paymentRestrictions {
        payByBankSignupIncentive
      }
      recurringEndDate
      redemptionLimit
      specialId
      specialName
      specialType
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
    }
    saleSpecials {
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      dollarDiscount
      menuType
      minorVersion
      percentDiscount
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      specialName
      paymentRestrictions {
        payByBankSignupIncentive
      }
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingMode
      targetPrice
      version
    }
    discount
    percentDiscount
  }
  Status
  strainType
  subcategory
  syncedAt
  updatedAt
  updatedBy
  THC
  THCContent {
    unit
    range
  }
  type
  weight
  featured {
    current
    startTime
    endTime
  }
  isBelowThreshold
  optionsBelowThreshold
  adminEdits {
    updatedAt
    updatedBy
  }
  brandLogo
  brandDescription
  cName
  brandId
}
    ${PosMetaDataFragmentFragmentDoc}`;
export const CreateBrandDocument = gql`
    mutation CreateBrand($brand: brandInput!) {
  createBrandV2(brand: $brand) {
    ...brandFragment
  }
}
    ${BrandFragmentFragmentDoc}`;
export type GqlCreateBrandMutationFn = Apollo.MutationFunction<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<GqlCreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: String!) {
  deleteBrand(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteBrandMutationFn = Apollo.MutationFunction<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<GqlDeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($id: String!, $brand: brandInput!) {
  updateBrandV2(id: $id, brand: $brand) {
    ...brandFragment
  }
}
    ${BrandFragmentFragmentDoc}`;
export type GqlUpdateBrandMutationFn = Apollo.MutationFunction<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<GqlUpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>;
export const BrandsForDropdownDocument = gql`
    query BrandsForDropdown($dispensaryId: String, $searchString: String, $limit: Int, $parentBrandId: ID, $hasParent: Boolean, $localAndGlobal: Boolean) {
  searchBrandsV2(
    filters: {dispensaryId: $dispensaryId, parentBrandId: $parentBrandId, hasParent: $hasParent, localAndGlobal: $localAndGlobal}
    pagination: {limit: $limit, offset: 0}
    search: $searchString
    sort: {sortBy: score, sortDirection: desc}
  ) {
    brands {
      ...brandFragmentForDropdown
      isGlobal
    }
  }
}
    ${BrandFragmentForDropdownFragmentDoc}`;

/**
 * __useBrandsForDropdownQuery__
 *
 * To run a query within a React component, call `useBrandsForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsForDropdownQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      parentBrandId: // value for 'parentBrandId'
 *      hasParent: // value for 'hasParent'
 *      localAndGlobal: // value for 'localAndGlobal'
 *   },
 * });
 */
export function useBrandsForDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>(BrandsForDropdownDocument, options);
      }
export function useBrandsForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>(BrandsForDropdownDocument, options);
        }
export type BrandsForDropdownQueryHookResult = ReturnType<typeof useBrandsForDropdownQuery>;
export type BrandsForDropdownLazyQueryHookResult = ReturnType<typeof useBrandsForDropdownLazyQuery>;
export type BrandsForDropdownQueryResult = Apollo.QueryResult<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>;
export const GetBrandRegionsDocument = gql`
    query GetBrandRegions {
  listRegions {
    id
    code
    country
    subdivision
    countryName
    subdivisionName
  }
}
    `;

/**
 * __useGetBrandRegionsQuery__
 *
 * To run a query within a React component, call `useGetBrandRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>(GetBrandRegionsDocument, options);
      }
export function useGetBrandRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>(GetBrandRegionsDocument, options);
        }
export type GetBrandRegionsQueryHookResult = ReturnType<typeof useGetBrandRegionsQuery>;
export type GetBrandRegionsLazyQueryHookResult = ReturnType<typeof useGetBrandRegionsLazyQuery>;
export type GetBrandRegionsQueryResult = Apollo.QueryResult<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>;
export const GetBrandDocument = gql`
    query GetBrand($id: String!) {
  getBrand(id: $id) {
    ...brandFragment
    isGlobal
    regions {
      id
      code
      country
      subdivision
      countryName
      subdivisionName
    }
    source
    creatorUserId
    dispensary {
      name
      id
    }
    parentBrandId
    enterprise {
      id
      name
    }
  }
}
    ${BrandFragmentFragmentDoc}`;

/**
 * __useGetBrandQuery__
 *
 * To run a query within a React component, call `useGetBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandQuery(baseOptions: Apollo.QueryHookOptions<GqlGetBrandQuery, GqlGetBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBrandQuery, GqlGetBrandQueryVariables>(GetBrandDocument, options);
      }
export function useGetBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBrandQuery, GqlGetBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBrandQuery, GqlGetBrandQueryVariables>(GetBrandDocument, options);
        }
export type GetBrandQueryHookResult = ReturnType<typeof useGetBrandQuery>;
export type GetBrandLazyQueryHookResult = ReturnType<typeof useGetBrandLazyQuery>;
export type GetBrandQueryResult = Apollo.QueryResult<GqlGetBrandQuery, GqlGetBrandQueryVariables>;
export const SuperBrandsIndexDocument = gql`
    query SuperBrandsIndex($filters: searchBrandsFilters, $pagination: paginationInput, $search: String, $sort: searchBrandsSort) {
  searchBrandsV2(
    filters: $filters
    pagination: $pagination
    search: $search
    sort: $sort
  ) {
    brands {
      ...brandFragment
      ...brandDispensaryFragment
    }
    queryInfo {
      totalCount
    }
  }
}
    ${BrandFragmentFragmentDoc}
${BrandDispensaryFragmentFragmentDoc}`;

/**
 * __useSuperBrandsIndexQuery__
 *
 * To run a query within a React component, call `useSuperBrandsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperBrandsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperBrandsIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSuperBrandsIndexQuery(baseOptions?: Apollo.QueryHookOptions<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>(SuperBrandsIndexDocument, options);
      }
export function useSuperBrandsIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>(SuperBrandsIndexDocument, options);
        }
export type SuperBrandsIndexQueryHookResult = ReturnType<typeof useSuperBrandsIndexQuery>;
export type SuperBrandsIndexLazyQueryHookResult = ReturnType<typeof useSuperBrandsIndexLazyQuery>;
export type SuperBrandsIndexQueryResult = Apollo.QueryResult<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>;
export const ComputeWithPriceCartV2Document = gql`
    mutation ComputeWithPriceCartV2($priceCartInput: CalculationsInput!) {
  computeWithPriceCartV2(input: $priceCartInput) {
    itemTaxes {
      taxAmount
      taxType
      productId
      feeItemId
      showOnMenu
      showOnCheckout
    }
    cartItemPrices {
      productName
      productId
      quantity
      subtotal
      unitPrice
      pricingTierAdjustment
      pricingTierAdjustmentTotal
      summaryPrice
      menuPrice
      cartPrice
      checkoutPrice
      specialCartPrice
      specialCheckoutPrice
      discounts {
        name
        amount
        discountId
        applicationMethod
        calculationMethod
        isLoyaltyReward
        isPaymentIncentive
        isRestricted
        menuDisplayName
        menuDisplayDescription
        menuDisplayImage
      }
      tax
      unitWeightGrams
      productType
      ecommKey
    }
    fees {
      feeItemId
      feeAmount
      feeName
      deliveryFee
      paymentFee
    }
    subTotal
    taxes
    discount
    originalTotal
    roundedDifference
    grandTotal
    loyaltyPointsUsed
    rewardValidationErrors {
      discountCode
      discountId
      message
    }
    totalSalesTax
    totalCannabisTax
    totalBottleDepositTax
    taxInclusivePricing
    loyaltyAppliedAsDiscount
    discountWithoutLoyalty
    posCustomerId
    discountGamification {
      gamificationDetails {
        discountId
        meetsAllConstraints
        satisfiers {
          thresholdMet
          thresholdType
          minimumThreshold
          products {
            productId
            ecommKey
            amount
          }
        }
      }
    }
    resolvedZoneIds
  }
}
    `;
export type GqlComputeWithPriceCartV2MutationFn = Apollo.MutationFunction<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>;

/**
 * __useComputeWithPriceCartV2Mutation__
 *
 * To run a mutation, you first call `useComputeWithPriceCartV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeWithPriceCartV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeWithPriceCartV2Mutation, { data, loading, error }] = useComputeWithPriceCartV2Mutation({
 *   variables: {
 *      priceCartInput: // value for 'priceCartInput'
 *   },
 * });
 */
export function useComputeWithPriceCartV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>(ComputeWithPriceCartV2Document, options);
      }
export type ComputeWithPriceCartV2MutationHookResult = ReturnType<typeof useComputeWithPriceCartV2Mutation>;
export type ComputeWithPriceCartV2MutationResult = Apollo.MutationResult<GqlComputeWithPriceCartV2Mutation>;
export type ComputeWithPriceCartV2MutationOptions = Apollo.BaseMutationOptions<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>;
export const ServerSideCalculationsDocument = gql`
    mutation serverSideCalculations($input: LegacyCalculationsInput!) {
  serverSideCalculations(input: $input) {
    bottleDepositTaxCents
    cannabisTax
    cartSubtotal
    credit
    deliveryFee
    menuTotal
    mixAndMatch
    otherFees
    paymentFee
    paymentIncentives
    reward
    rounding
    roundupForCharityAmount
    subtotal
    tax
    tip
    total
    details {
      basePrice
      basePriceMult
      bogoSavings {
        displayAsPercentDiscount
        individual {
          conditionQuantity
          discountAmount
          discountStacking
          displayAsPercentDiscount
          isDiscountToCartReward
          maxApplicable
          nonStackingBehavior
          specialId
          stackingBehavior
        }
        isDiscountToCartReward
        menuBogoDiscount
        total
      }
      bottleDepositTaxCents
      canonicalEffectivePotencyMg
      enterpriseProductId
      id
      isOnSale
      isVapeTaxed
      key
      menuBasePrice
      menuCannabisTax
      menuIndividualPrice
      menuSaleAdjustment
      menuPrice
      menuSalesTax
      option
      posId
      productBrand
      productBrandId
      productCategory
      productSubcategory
      quantity
      type
      weightInGrams
      weightInMg
      wholesalePrice
      pricingTierData {
        generatedTiersId
        tiersId
        tiersName
        tiers {
          endWeight
          price
          pricePerGram
          startWeight
          weightUOM
        }
      }
      specialData {
        bogoSpecials {
          applyRewardsToConditions
          bogoConditionLogicOperator
          bogoConditions {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            productGroup
            productId
            productIds
            productTags
            quantity
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weight
            weightOperator
          }
          bogoRewardLogicOperator
          bogoRewards {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            dollarDiscount
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            percentDiscount
            productGroup
            productId
            productIds
            productTags
            quantity
            strainIds
            subcategoryIds
            subcategoryNames
            targetPrice
            vendorIds
            weight
          }
          createdBy
          directPOSProductIdMapping
          discountBehavior
          discountBundle {
            _id
            applyTo
            discountType
            enabled
            limit
            value
          }
          discountPrecedence
          discountStacking
          discountToCart {
            _id
            discountType
            enabled
            value
          }
          endStamp
          excludeConditionItemsFromRewards
          excludedProducts {
            conditions {
              _id
              Name
              key
            }
            rewards {
              _id
              Name
              key
            }
          }
          isRecurring
          itemsForAPrice {
            _id
            enabled
            value
          }
          menuType
          minorVersion
          nonStackingBehavior
          paymentRestrictions {
            payByBankSignupIncentive
          }
          rawPOSWeightMapping
          recurringEndDate
          redemptionLimit
          specialId
          specialName
          specialType
          stackingBehavior
          totalQuantity {
            enabled
            maxQuantity
            quantity
            quantityOperator
          }
          totalSpend {
            enabled
            maximumSpend
            minimumSpend
            spendOperator
          }
          totalWeight {
            enabled
            weight
            weightOperator
          }
          version
        }
        saleSpecials {
          createdBy
          directPOSProductIdMapping
          discount
          discountStacking
          dollarDiscount
          eligibleProductOptions
          menuType
          minorVersion
          nonStackingBehavior
          paymentRestrictions {
            payByBankSignupIncentive
          }
          percentDiscount
          rawPOSWeightMapping
          saleDiscounts {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            discountAmount
            discountType
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            productGroup
            productIds
            productTags
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weightOperator
            weights
          }
          source
          sourceId
          specialId
          specialName
          specialRestrictions
          specialType
          stackingBehavior
          stackingMode
          targetPrice
          version
        }
      }
    }
    bottleDepositTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
    cannabisTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
    lineitems {
      type
      value
    }
    receipt
    salesTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
  }
}
    `;
export type GqlServerSideCalculationsMutationFn = Apollo.MutationFunction<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>;

/**
 * __useServerSideCalculationsMutation__
 *
 * To run a mutation, you first call `useServerSideCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerSideCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverSideCalculationsMutation, { data, loading, error }] = useServerSideCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServerSideCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>(ServerSideCalculationsDocument, options);
      }
export type ServerSideCalculationsMutationHookResult = ReturnType<typeof useServerSideCalculationsMutation>;
export type ServerSideCalculationsMutationResult = Apollo.MutationResult<GqlServerSideCalculationsMutation>;
export type ServerSideCalculationsMutationOptions = Apollo.BaseMutationOptions<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>;
export const ComputeWithPriceCartDocument = gql`
    query ComputeWithPriceCart($priceCartInput: CalculationsInput!) {
  computeWithPriceCart(input: $priceCartInput) {
    itemTaxes {
      taxAmount
      taxType
      productId
      feeItemId
      showOnMenu
      showOnCheckout
    }
    cartItemPrices {
      productName
      productId
      quantity
      subtotal
      unitPrice
      pricingTierAdjustment
      pricingTierAdjustmentTotal
      summaryPrice
      menuPrice
      cartPrice
      checkoutPrice
      specialCartPrice
      specialCheckoutPrice
      discounts {
        name
        amount
        discountId
        applicationMethod
        calculationMethod
        isLoyaltyReward
        isPaymentIncentive
      }
      tax
      unitWeightGrams
      productType
    }
    fees {
      feeItemId
      feeAmount
      feeName
      deliveryFee
      paymentFee
    }
    subTotal
    taxes
    discount
    originalTotal
    roundedDifference
    grandTotal
    loyaltyPointsUsed
    rewardValidationErrors {
      discountCode
      discountId
      message
    }
    totalSalesTax
    totalCannabisTax
    totalBottleDepositTax
    taxInclusivePricing
    loyaltyAppliedAsDiscount
    discountWithoutLoyalty
    posCustomerId
    resolvedZoneIds
  }
}
    `;

/**
 * __useComputeWithPriceCartQuery__
 *
 * To run a query within a React component, call `useComputeWithPriceCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeWithPriceCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeWithPriceCartQuery({
 *   variables: {
 *      priceCartInput: // value for 'priceCartInput'
 *   },
 * });
 */
export function useComputeWithPriceCartQuery(baseOptions: Apollo.QueryHookOptions<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>(ComputeWithPriceCartDocument, options);
      }
export function useComputeWithPriceCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>(ComputeWithPriceCartDocument, options);
        }
export type ComputeWithPriceCartQueryHookResult = ReturnType<typeof useComputeWithPriceCartQuery>;
export type ComputeWithPriceCartLazyQueryHookResult = ReturnType<typeof useComputeWithPriceCartLazyQuery>;
export type ComputeWithPriceCartQueryResult = Apollo.QueryResult<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>;
export const GetCannabinoidsDocument = gql`
    query GetCannabinoids {
  getCannabinoids {
    name
    id
  }
}
    `;

/**
 * __useGetCannabinoidsQuery__
 *
 * To run a query within a React component, call `useGetCannabinoidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCannabinoidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCannabinoidsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCannabinoidsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>(GetCannabinoidsDocument, options);
      }
export function useGetCannabinoidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>(GetCannabinoidsDocument, options);
        }
export type GetCannabinoidsQueryHookResult = ReturnType<typeof useGetCannabinoidsQuery>;
export type GetCannabinoidsLazyQueryHookResult = ReturnType<typeof useGetCannabinoidsLazyQuery>;
export type GetCannabinoidsQueryResult = Apollo.QueryResult<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>;
export const CreateCouponV2Document = gql`
    mutation CreateCouponV2($input: createCouponInput!) {
  createCouponV2(coupon: $input) {
    ...couponFragment
  }
}
    ${CouponFragmentFragmentDoc}`;
export type GqlCreateCouponV2MutationFn = Apollo.MutationFunction<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>;

/**
 * __useCreateCouponV2Mutation__
 *
 * To run a mutation, you first call `useCreateCouponV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponV2Mutation, { data, loading, error }] = useCreateCouponV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>(CreateCouponV2Document, options);
      }
export type CreateCouponV2MutationHookResult = ReturnType<typeof useCreateCouponV2Mutation>;
export type CreateCouponV2MutationResult = Apollo.MutationResult<GqlCreateCouponV2Mutation>;
export type CreateCouponV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>;
export const DeleteCouponV2Document = gql`
    mutation DeleteCouponV2($id: String!) {
  deleteCouponV2(id: $id) {
    success
  }
}
    `;
export type GqlDeleteCouponV2MutationFn = Apollo.MutationFunction<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>;

/**
 * __useDeleteCouponV2Mutation__
 *
 * To run a mutation, you first call `useDeleteCouponV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponV2Mutation, { data, loading, error }] = useDeleteCouponV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>(DeleteCouponV2Document, options);
      }
export type DeleteCouponV2MutationHookResult = ReturnType<typeof useDeleteCouponV2Mutation>;
export type DeleteCouponV2MutationResult = Apollo.MutationResult<GqlDeleteCouponV2Mutation>;
export type DeleteCouponV2MutationOptions = Apollo.BaseMutationOptions<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>;
export const UpdateCouponDocument = gql`
    mutation UpdateCoupon($input: updateCouponInput!) {
  updateCoupon(coupon: $input) {
    ...couponFragment
  }
}
    ${CouponFragmentFragmentDoc}`;
export type GqlUpdateCouponMutationFn = Apollo.MutationFunction<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>;

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponMutation, { data, loading, error }] = useUpdateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>(UpdateCouponDocument, options);
      }
export type UpdateCouponMutationHookResult = ReturnType<typeof useUpdateCouponMutation>;
export type UpdateCouponMutationResult = Apollo.MutationResult<GqlUpdateCouponMutation>;
export type UpdateCouponMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>;
export const FilteredCouponsDocument = gql`
    query FilteredCoupons($filter: couponsFilterInput, $sort: couponsSortInput, $pagination: couponsPaginationInput) {
  filteredCoupons(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    coupons {
      ...couponFragment
      dispensary
      reimbursed
    }
  }
}
    ${CouponFragmentFragmentDoc}`;

/**
 * __useFilteredCouponsQuery__
 *
 * To run a query within a React component, call `useFilteredCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCouponsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredCouponsQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>(FilteredCouponsDocument, options);
      }
export function useFilteredCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>(FilteredCouponsDocument, options);
        }
export type FilteredCouponsQueryHookResult = ReturnType<typeof useFilteredCouponsQuery>;
export type FilteredCouponsLazyQueryHookResult = ReturnType<typeof useFilteredCouponsLazyQuery>;
export type FilteredCouponsQueryResult = Apollo.QueryResult<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>;
export const ClearAllCurbsideArrivalsDocument = gql`
    mutation ClearAllCurbsideArrivals($dispensaryId: String!) {
  clearAllCurbsideArrivals(dispensaryId: $dispensaryId) {
    success
  }
}
    `;
export type GqlClearAllCurbsideArrivalsMutationFn = Apollo.MutationFunction<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>;

/**
 * __useClearAllCurbsideArrivalsMutation__
 *
 * To run a mutation, you first call `useClearAllCurbsideArrivalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllCurbsideArrivalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllCurbsideArrivalsMutation, { data, loading, error }] = useClearAllCurbsideArrivalsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useClearAllCurbsideArrivalsMutation(baseOptions?: Apollo.MutationHookOptions<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>(ClearAllCurbsideArrivalsDocument, options);
      }
export type ClearAllCurbsideArrivalsMutationHookResult = ReturnType<typeof useClearAllCurbsideArrivalsMutation>;
export type ClearAllCurbsideArrivalsMutationResult = Apollo.MutationResult<GqlClearAllCurbsideArrivalsMutation>;
export type ClearAllCurbsideArrivalsMutationOptions = Apollo.BaseMutationOptions<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>;
export const ClearCurbsideArrivalDocument = gql`
    mutation ClearCurbsideArrival($arrivalId: String!) {
  clearCurbsideArrival(arrivalId: $arrivalId) {
    success
  }
}
    `;
export type GqlClearCurbsideArrivalMutationFn = Apollo.MutationFunction<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>;

/**
 * __useClearCurbsideArrivalMutation__
 *
 * To run a mutation, you first call `useClearCurbsideArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCurbsideArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCurbsideArrivalMutation, { data, loading, error }] = useClearCurbsideArrivalMutation({
 *   variables: {
 *      arrivalId: // value for 'arrivalId'
 *   },
 * });
 */
export function useClearCurbsideArrivalMutation(baseOptions?: Apollo.MutationHookOptions<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>(ClearCurbsideArrivalDocument, options);
      }
export type ClearCurbsideArrivalMutationHookResult = ReturnType<typeof useClearCurbsideArrivalMutation>;
export type ClearCurbsideArrivalMutationResult = Apollo.MutationResult<GqlClearCurbsideArrivalMutation>;
export type ClearCurbsideArrivalMutationOptions = Apollo.BaseMutationOptions<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>;
export const MarkCurbsideArrivalArrivedV2Document = gql`
    mutation MarkCurbsideArrivalArrivedV2($token: String!) {
  markCurbsideArrivalArrivedV2(token: $token) {
    id
  }
}
    `;
export type GqlMarkCurbsideArrivalArrivedV2MutationFn = Apollo.MutationFunction<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>;

/**
 * __useMarkCurbsideArrivalArrivedV2Mutation__
 *
 * To run a mutation, you first call `useMarkCurbsideArrivalArrivedV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCurbsideArrivalArrivedV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCurbsideArrivalArrivedV2Mutation, { data, loading, error }] = useMarkCurbsideArrivalArrivedV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMarkCurbsideArrivalArrivedV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>(MarkCurbsideArrivalArrivedV2Document, options);
      }
export type MarkCurbsideArrivalArrivedV2MutationHookResult = ReturnType<typeof useMarkCurbsideArrivalArrivedV2Mutation>;
export type MarkCurbsideArrivalArrivedV2MutationResult = Apollo.MutationResult<GqlMarkCurbsideArrivalArrivedV2Mutation>;
export type MarkCurbsideArrivalArrivedV2MutationOptions = Apollo.BaseMutationOptions<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>;
export const UpdateCurbsideArrivalV2Document = gql`
    mutation UpdateCurbsideArrivalV2($token: String!, $arrivalInformation: String!) {
  updateCurbsideArrivalV2(token: $token, arrivalInformation: $arrivalInformation) {
    id
  }
}
    `;
export type GqlUpdateCurbsideArrivalV2MutationFn = Apollo.MutationFunction<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>;

/**
 * __useUpdateCurbsideArrivalV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCurbsideArrivalV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurbsideArrivalV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurbsideArrivalV2Mutation, { data, loading, error }] = useUpdateCurbsideArrivalV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *      arrivalInformation: // value for 'arrivalInformation'
 *   },
 * });
 */
export function useUpdateCurbsideArrivalV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>(UpdateCurbsideArrivalV2Document, options);
      }
export type UpdateCurbsideArrivalV2MutationHookResult = ReturnType<typeof useUpdateCurbsideArrivalV2Mutation>;
export type UpdateCurbsideArrivalV2MutationResult = Apollo.MutationResult<GqlUpdateCurbsideArrivalV2Mutation>;
export type UpdateCurbsideArrivalV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>;
export const GetCurbsideArrivalByTokenDocument = gql`
    query GetCurbsideArrivalByToken($token: String!) {
  getCurbsideArrivalByToken(token: $token) {
    id
    dispensary {
      id
      phone
      orderTypesConfigV2 {
        curbsidePickup {
          arrivalInformationInstructions
        }
      }
    }
    arrivalInformation
    arrivedAt
    clearedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCurbsideArrivalByTokenQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetCurbsideArrivalByTokenQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>(GetCurbsideArrivalByTokenDocument, options);
      }
export function useGetCurbsideArrivalByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>(GetCurbsideArrivalByTokenDocument, options);
        }
export type GetCurbsideArrivalByTokenQueryHookResult = ReturnType<typeof useGetCurbsideArrivalByTokenQuery>;
export type GetCurbsideArrivalByTokenLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalByTokenLazyQuery>;
export type GetCurbsideArrivalByTokenQueryResult = Apollo.QueryResult<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>;
export const GetCurbsideArrivalsForBannerDocument = gql`
    query GetCurbsideArrivalsForBanner($dispensaryId: String!) {
  getCurbsideArrivals(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useGetCurbsideArrivalsForBannerQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalsForBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalsForBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalsForBannerQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCurbsideArrivalsForBannerQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>(GetCurbsideArrivalsForBannerDocument, options);
      }
export function useGetCurbsideArrivalsForBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>(GetCurbsideArrivalsForBannerDocument, options);
        }
export type GetCurbsideArrivalsForBannerQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsForBannerQuery>;
export type GetCurbsideArrivalsForBannerLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsForBannerLazyQuery>;
export type GetCurbsideArrivalsForBannerQueryResult = Apollo.QueryResult<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>;
export const GetCurbsideArrivalsDocument = gql`
    query GetCurbsideArrivals($dispensaryId: String!) {
  getCurbsideArrivals(dispensaryId: $dispensaryId) {
    id
    order {
      id
      orderId
      customer {
        profile {
          firstName
          lastName
          phone
        }
      }
      guestCustomer {
        firstName
        lastName
        phone
      }
    }
    arrivalInformation
    arrivedAt
    clearedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCurbsideArrivalsQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCurbsideArrivalsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>(GetCurbsideArrivalsDocument, options);
      }
export function useGetCurbsideArrivalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>(GetCurbsideArrivalsDocument, options);
        }
export type GetCurbsideArrivalsQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsQuery>;
export type GetCurbsideArrivalsLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsLazyQuery>;
export type GetCurbsideArrivalsQueryResult = Apollo.QueryResult<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>;
export const UpdateCustomerSubscriptionDocument = gql`
    mutation UpdateCustomerSubscription($customerId: String!, $subscribed: Boolean!) {
  updateCustomerSubscription(customerId: $customerId, subscribed: $subscribed) {
    success
  }
}
    `;
export type GqlUpdateCustomerSubscriptionMutationFn = Apollo.MutationFunction<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>;

/**
 * __useUpdateCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSubscriptionMutation, { data, loading, error }] = useUpdateCustomerSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscribed: // value for 'subscribed'
 *   },
 * });
 */
export function useUpdateCustomerSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>(UpdateCustomerSubscriptionDocument, options);
      }
export type UpdateCustomerSubscriptionMutationHookResult = ReturnType<typeof useUpdateCustomerSubscriptionMutation>;
export type UpdateCustomerSubscriptionMutationResult = Apollo.MutationResult<GqlUpdateCustomerSubscriptionMutation>;
export type UpdateCustomerSubscriptionMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>;
export const GenerateDecagonUserAuthDocument = gql`
    query generateDecagonUserAuth {
  generateDecagonUserAuth {
    signature
    epoch
  }
}
    `;

/**
 * __useGenerateDecagonUserAuthQuery__
 *
 * To run a query within a React component, call `useGenerateDecagonUserAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateDecagonUserAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateDecagonUserAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateDecagonUserAuthQuery(baseOptions?: Apollo.QueryHookOptions<GqlGenerateDecagonUserAuthQuery, GqlGenerateDecagonUserAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGenerateDecagonUserAuthQuery, GqlGenerateDecagonUserAuthQueryVariables>(GenerateDecagonUserAuthDocument, options);
      }
export function useGenerateDecagonUserAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGenerateDecagonUserAuthQuery, GqlGenerateDecagonUserAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGenerateDecagonUserAuthQuery, GqlGenerateDecagonUserAuthQueryVariables>(GenerateDecagonUserAuthDocument, options);
        }
export type GenerateDecagonUserAuthQueryHookResult = ReturnType<typeof useGenerateDecagonUserAuthQuery>;
export type GenerateDecagonUserAuthLazyQueryHookResult = ReturnType<typeof useGenerateDecagonUserAuthLazyQuery>;
export type GenerateDecagonUserAuthQueryResult = Apollo.QueryResult<GqlGenerateDecagonUserAuthQuery, GqlGenerateDecagonUserAuthQueryVariables>;
export const GetDevicesDocument = gql`
    query GetDevices($dispensaryId: String!) {
  getDevices(dispensaryId: $dispensaryId) {
    ...deviceFragment
  }
}
    ${DeviceFragmentFragmentDoc}`;

/**
 * __useGetDevicesQuery__
 *
 * To run a query within a React component, call `useGetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetDevicesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>(GetDevicesDocument, options);
      }
export function useGetDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>(GetDevicesDocument, options);
        }
export type GetDevicesQueryHookResult = ReturnType<typeof useGetDevicesQuery>;
export type GetDevicesLazyQueryHookResult = ReturnType<typeof useGetDevicesLazyQuery>;
export type GetDevicesQueryResult = Apollo.QueryResult<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>;
export const GetKioskTerminalsDocument = gql`
    query GetKioskTerminals($dispensaryId: String!) {
  getKioskTerminals(dispensaryId: $dispensaryId) {
    id
    dispensaryId
    nickname
  }
}
    `;

/**
 * __useGetKioskTerminalsQuery__
 *
 * To run a query within a React component, call `useGetKioskTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKioskTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKioskTerminalsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetKioskTerminalsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>(GetKioskTerminalsDocument, options);
      }
export function useGetKioskTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>(GetKioskTerminalsDocument, options);
        }
export type GetKioskTerminalsQueryHookResult = ReturnType<typeof useGetKioskTerminalsQuery>;
export type GetKioskTerminalsLazyQueryHookResult = ReturnType<typeof useGetKioskTerminalsLazyQuery>;
export type GetKioskTerminalsQueryResult = Apollo.QueryResult<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>;
export const DispensaryOnboardingDocument = gql`
    mutation DispensaryOnboarding($input: dispensaryOnboardingInput!) {
  dispensaryOnboarding(input: $input) {
    success
  }
}
    `;
export type GqlDispensaryOnboardingMutationFn = Apollo.MutationFunction<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>;

/**
 * __useDispensaryOnboardingMutation__
 *
 * To run a mutation, you first call `useDispensaryOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryOnboardingMutation, { data, loading, error }] = useDispensaryOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispensaryOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>(DispensaryOnboardingDocument, options);
      }
export type DispensaryOnboardingMutationHookResult = ReturnType<typeof useDispensaryOnboardingMutation>;
export type DispensaryOnboardingMutationResult = Apollo.MutationResult<GqlDispensaryOnboardingMutation>;
export type DispensaryOnboardingMutationOptions = Apollo.BaseMutationOptions<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>;
export const DispensaryUploadOnboardingAssetDocument = gql`
    mutation DispensaryUploadOnboardingAsset($data: String!, $fileName: String!) {
  dispensaryUploadOnboardingAsset(data: $data, fileName: $fileName) {
    fileIds
  }
}
    `;
export type GqlDispensaryUploadOnboardingAssetMutationFn = Apollo.MutationFunction<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>;

/**
 * __useDispensaryUploadOnboardingAssetMutation__
 *
 * To run a mutation, you first call `useDispensaryUploadOnboardingAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryUploadOnboardingAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryUploadOnboardingAssetMutation, { data, loading, error }] = useDispensaryUploadOnboardingAssetMutation({
 *   variables: {
 *      data: // value for 'data'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDispensaryUploadOnboardingAssetMutation(baseOptions?: Apollo.MutationHookOptions<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>(DispensaryUploadOnboardingAssetDocument, options);
      }
export type DispensaryUploadOnboardingAssetMutationHookResult = ReturnType<typeof useDispensaryUploadOnboardingAssetMutation>;
export type DispensaryUploadOnboardingAssetMutationResult = Apollo.MutationResult<GqlDispensaryUploadOnboardingAssetMutation>;
export type DispensaryUploadOnboardingAssetMutationOptions = Apollo.BaseMutationOptions<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>;
export const GetAddressBasedDispensaryDataDocument = gql`
    query GetAddressBasedDispensaryData($input: getDeliveryInfoInput) {
  getAddressBasedDispensaryData(input: $input) {
    deliveryInfo {
      deliveryAreaId
      withinBounds
      fee
      feeType
      percentFee
      minimum
      feeVaries
      minimumVaries
    }
    taxes {
      ...taxProperties
      destinationRate
    }
  }
}
    ${TaxPropertiesFragmentDoc}`;

/**
 * __useGetAddressBasedDispensaryDataQuery__
 *
 * To run a query within a React component, call `useGetAddressBasedDispensaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressBasedDispensaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressBasedDispensaryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAddressBasedDispensaryDataQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>(GetAddressBasedDispensaryDataDocument, options);
      }
export function useGetAddressBasedDispensaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>(GetAddressBasedDispensaryDataDocument, options);
        }
export type GetAddressBasedDispensaryDataQueryHookResult = ReturnType<typeof useGetAddressBasedDispensaryDataQuery>;
export type GetAddressBasedDispensaryDataLazyQueryHookResult = ReturnType<typeof useGetAddressBasedDispensaryDataLazyQuery>;
export type GetAddressBasedDispensaryDataQueryResult = Apollo.QueryResult<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>;
export const DispensarySearchDocument = gql`
    query DispensarySearch($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    cName
    status
    recDispensary
    medicalDispensary
    offerPickup
    offerCurbsidePickup
    offerAnyPickupService
    offerDelivery
    listImage
    location {
      city
      county
      geometry {
        coordinates
        type
      }
      ln1
      ln2
      state
      zipcode
      country
    }
    actionEstimates {
      delivery {
        readyInMinutes
        rangeInMinutes
        deliveryTimeInMinutes
      }
      pickup {
        readyInMinutes
        rangeInMinutes
      }
    }
    durationEstimateOverrides {
      pickup {
        enabled
        lowInMinutes
        highInMinutes
      }
      delivery {
        enabled
        lowInMinutes
        highInMinutes
      }
    }
    storeSettings {
      enableAfterHoursOrderingForPickup
      enableAfterHoursOrderingForDelivery
      enableScheduledOrderingForPickup
      enableScheduledOrderingForDelivery
    }
    featureFlags {
      hideDeliveryEstimate
    }
    effectiveHours {
      deliveryHours {
        ...hourSetFragment
      }
      pickupHours {
        ...hourSetFragment
      }
    }
    deliveryHours {
      ...hourSetFragment
    }
    deliveryInfo {
      withinBounds
      fee
      minimum
      feeVaries
      minimumVaries
      feeType
      percentFee
    }
    feeTiers {
      fee
      feeType
      max
      min
      percentFee
    }
    pickupHours {
      ...hourSetFragment
    }
    specialHours {
      name
      startDate
      endDate
      hoursPerDay {
        date
        pickupHours {
          active
          start
          end
        }
        deliveryHours {
          active
          start
          end
        }
      }
    }
    distance
    maxDeliveryDistance
    timezone
    orderTypesConfig {
      pickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      curbsidePickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      driveThruPickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      delivery {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      kiosk {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      offerAnyPickupService
      offerDeliveryService
    }
    orderTypesConfigV2 {
      inStorePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      curbsidePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      driveThruPickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      delivery {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      offerAnyPickupService
      offerDeliveryService
    }
    hoursSettings {
      inStorePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      curbsidePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      driveThruPickup {
        ...hoursSettingsForOrderTypeFragment
      }
      delivery {
        ...hoursSettingsForOrderTypeFragment
      }
    }
    enabledOrderTypes {
      pickup
      inStorePickup
      curbsidePickup
      driveThruPickup
      delivery
      kiosk
    }
    paymentTypesAccepted {
      alt36
      check
      creditCardAtDoor
      payOnlineChase
      payOnlineHypur
      payOnlineMerrco
      payOnlineMoneris
      creditCardByPhone
      debit
      cash
      linx
      canPay
      paytender
      aeropay
      dutchiePay
      rethinkPay
    }
  }
}
    ${HourSetFragmentFragmentDoc}
${HoursSettingsForOrderTypeFragmentFragmentDoc}`;

/**
 * __useDispensarySearchQuery__
 *
 * To run a query within a React component, call `useDispensarySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispensarySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispensarySearchQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useDispensarySearchQuery(baseOptions: Apollo.QueryHookOptions<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>(DispensarySearchDocument, options);
      }
export function useDispensarySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>(DispensarySearchDocument, options);
        }
export type DispensarySearchQueryHookResult = ReturnType<typeof useDispensarySearchQuery>;
export type DispensarySearchLazyQueryHookResult = ReturnType<typeof useDispensarySearchLazyQuery>;
export type DispensarySearchQueryResult = Apollo.QueryResult<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>;
export const CopyToLocationsDocument = gql`
    mutation CopyToLocations($enterpriseId: ID!, $klass: String!, $dispensaryId: String!, $itemId: String!, $enableAllLocations: Boolean, $dispensaryIds: [String!], $isoRegionCodes: [String!]) {
  copyToLocations(
    enterpriseId: $enterpriseId
    klass: $klass
    dispensaryId: $dispensaryId
    itemId: $itemId
    enableAllLocations: $enableAllLocations
    dispensaryIds: $dispensaryIds
    isoRegionCodes: $isoRegionCodes
  ) {
    success
    message
    successCount
    alreadyExistsCount
    specialNotFoundCount
    skippedLocations {
      dispensaryId
      reason
    }
  }
}
    `;
export type GqlCopyToLocationsMutationFn = Apollo.MutationFunction<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>;

/**
 * __useCopyToLocationsMutation__
 *
 * To run a mutation, you first call `useCopyToLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyToLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyToLocationsMutation, { data, loading, error }] = useCopyToLocationsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      klass: // value for 'klass'
 *      dispensaryId: // value for 'dispensaryId'
 *      itemId: // value for 'itemId'
 *      enableAllLocations: // value for 'enableAllLocations'
 *      dispensaryIds: // value for 'dispensaryIds'
 *      isoRegionCodes: // value for 'isoRegionCodes'
 *   },
 * });
 */
export function useCopyToLocationsMutation(baseOptions?: Apollo.MutationHookOptions<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>(CopyToLocationsDocument, options);
      }
export type CopyToLocationsMutationHookResult = ReturnType<typeof useCopyToLocationsMutation>;
export type CopyToLocationsMutationResult = Apollo.MutationResult<GqlCopyToLocationsMutation>;
export type CopyToLocationsMutationOptions = Apollo.BaseMutationOptions<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>;
export const CreateEnterpriseLoyaltySettingsDocument = gql`
    mutation CreateEnterpriseLoyaltySettings($enterpriseId: ID!, $landingPageUrl: String, $loyaltyEnrollmentUrl: String, $privacyPolicyUrl: String, $termsAndConditionsUrl: String) {
  createEnterpriseLoyaltySettings(
    enterpriseId: $enterpriseId
    landingPageUrl: $landingPageUrl
    loyaltyEnrollmentUrl: $loyaltyEnrollmentUrl
    privacyPolicyUrl: $privacyPolicyUrl
    termsAndConditionsUrl: $termsAndConditionsUrl
  ) {
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    dposLoyaltyIsoRegionCodes
    description
    displayName
    privacyPolicyUrl
    termsAndConditionsUrl
  }
}
    `;
export type GqlCreateEnterpriseLoyaltySettingsMutationFn = Apollo.MutationFunction<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>;

/**
 * __useCreateEnterpriseLoyaltySettingsMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseLoyaltySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseLoyaltySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseLoyaltySettingsMutation, { data, loading, error }] = useCreateEnterpriseLoyaltySettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      landingPageUrl: // value for 'landingPageUrl'
 *      loyaltyEnrollmentUrl: // value for 'loyaltyEnrollmentUrl'
 *      privacyPolicyUrl: // value for 'privacyPolicyUrl'
 *      termsAndConditionsUrl: // value for 'termsAndConditionsUrl'
 *   },
 * });
 */
export function useCreateEnterpriseLoyaltySettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>(CreateEnterpriseLoyaltySettingsDocument, options);
      }
export type CreateEnterpriseLoyaltySettingsMutationHookResult = ReturnType<typeof useCreateEnterpriseLoyaltySettingsMutation>;
export type CreateEnterpriseLoyaltySettingsMutationResult = Apollo.MutationResult<GqlCreateEnterpriseLoyaltySettingsMutation>;
export type CreateEnterpriseLoyaltySettingsMutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>;
export const UpdateEnterpriseLoyaltySettingsDocument = gql`
    mutation UpdateEnterpriseLoyaltySettings($enterpriseId: ID!, $landingPageUrl: String, $loyaltyEnrollmentUrl: String, $description: String, $displayName: String, $privacyPolicyUrl: String, $termsAndConditionsUrl: String) {
  updateEnterpriseLoyaltySettings(
    enterpriseId: $enterpriseId
    landingPageUrl: $landingPageUrl
    loyaltyEnrollmentUrl: $loyaltyEnrollmentUrl
    description: $description
    displayName: $displayName
    privacyPolicyUrl: $privacyPolicyUrl
    termsAndConditionsUrl: $termsAndConditionsUrl
  ) {
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    dposLoyaltyIsoRegionCodes
    description
    displayName
    privacyPolicyUrl
    termsAndConditionsUrl
  }
}
    `;
export type GqlUpdateEnterpriseLoyaltySettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>;

/**
 * __useUpdateEnterpriseLoyaltySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseLoyaltySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseLoyaltySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseLoyaltySettingsMutation, { data, loading, error }] = useUpdateEnterpriseLoyaltySettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      landingPageUrl: // value for 'landingPageUrl'
 *      loyaltyEnrollmentUrl: // value for 'loyaltyEnrollmentUrl'
 *      description: // value for 'description'
 *      displayName: // value for 'displayName'
 *      privacyPolicyUrl: // value for 'privacyPolicyUrl'
 *      termsAndConditionsUrl: // value for 'termsAndConditionsUrl'
 *   },
 * });
 */
export function useUpdateEnterpriseLoyaltySettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>(UpdateEnterpriseLoyaltySettingsDocument, options);
      }
export type UpdateEnterpriseLoyaltySettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseLoyaltySettingsMutation>;
export type UpdateEnterpriseLoyaltySettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseLoyaltySettingsMutation>;
export type UpdateEnterpriseLoyaltySettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>;
export const UpdateEnterpriseMobileAppSettingsDocument = gql`
    mutation UpdateEnterpriseMobileAppSettings($enterpriseId: ID!, $input: EnterpriseMobileAppSettingsInput) {
  updateEnterpriseMobileAppSettings(enterpriseId: $enterpriseId, input: $input) {
    androidAppIcon
    androidExistingVersion
    androidExistingVersionCode
    androidOrganizationName
    androidPackageName
    androidSplashBackgroundColor
    automaticScreenshotGeneration
    buildForIpad
    firebaseProjectId
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosExistingVersion
    iosSplashBackgroundColor
    iosTeamId
    iosTeamName
    name
    shortName
  }
}
    `;
export type GqlUpdateEnterpriseMobileAppSettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>;

/**
 * __useUpdateEnterpriseMobileAppSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseMobileAppSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseMobileAppSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseMobileAppSettingsMutation, { data, loading, error }] = useUpdateEnterpriseMobileAppSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseMobileAppSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>(UpdateEnterpriseMobileAppSettingsDocument, options);
      }
export type UpdateEnterpriseMobileAppSettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseMobileAppSettingsMutation>;
export type UpdateEnterpriseMobileAppSettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseMobileAppSettingsMutation>;
export type UpdateEnterpriseMobileAppSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>;
export const EnterpriseLoyaltySettingsDocument = gql`
    query EnterpriseLoyaltySettings($enterpriseId: ID!) {
  enterpriseLoyaltySettings(id: $enterpriseId) {
    description
    displayName
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    dposLoyaltyIsoRegionCodes
    description
    displayName
    privacyPolicyUrl
    termsAndConditionsUrl
  }
}
    `;

/**
 * __useEnterpriseLoyaltySettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseLoyaltySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseLoyaltySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseLoyaltySettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseLoyaltySettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>(EnterpriseLoyaltySettingsDocument, options);
      }
export function useEnterpriseLoyaltySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>(EnterpriseLoyaltySettingsDocument, options);
        }
export type EnterpriseLoyaltySettingsQueryHookResult = ReturnType<typeof useEnterpriseLoyaltySettingsQuery>;
export type EnterpriseLoyaltySettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseLoyaltySettingsLazyQuery>;
export type EnterpriseLoyaltySettingsQueryResult = Apollo.QueryResult<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>;
export const EnterpriseMobileAppSettingsDocument = gql`
    query EnterpriseMobileAppSettings($enterpriseId: ID!) {
  enterpriseMobileAppSettings(enterpriseId: $enterpriseId) {
    androidAppIcon
    androidPackageName
    androidSplashBackgroundColor
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosSplashBackgroundColor
  }
}
    `;

/**
 * __useEnterpriseMobileAppSettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseMobileAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseMobileAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseMobileAppSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseMobileAppSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>(EnterpriseMobileAppSettingsDocument, options);
      }
export function useEnterpriseMobileAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>(EnterpriseMobileAppSettingsDocument, options);
        }
export type EnterpriseMobileAppSettingsQueryHookResult = ReturnType<typeof useEnterpriseMobileAppSettingsQuery>;
export type EnterpriseMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseMobileAppSettingsLazyQuery>;
export type EnterpriseMobileAppSettingsQueryResult = Apollo.QueryResult<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>;
export const AdminEnterpriseMobileAppSettingsDocument = gql`
    query AdminEnterpriseMobileAppSettings($enterpriseId: ID!) {
  enterpriseMobileAppSettings(enterpriseId: $enterpriseId) {
    androidAppIcon
    androidExistingVersion
    androidExistingVersionCode
    androidOrganizationName
    androidPackageName
    androidSplashBackgroundColor
    automaticScreenshotGeneration
    buildForIpad
    firebaseProjectId
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosExistingVersion
    iosSplashBackgroundColor
    iosTeamId
    iosTeamName
    name
    shortName
  }
}
    `;

/**
 * __useAdminEnterpriseMobileAppSettingsQuery__
 *
 * To run a query within a React component, call `useAdminEnterpriseMobileAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEnterpriseMobileAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEnterpriseMobileAppSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useAdminEnterpriseMobileAppSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>(AdminEnterpriseMobileAppSettingsDocument, options);
      }
export function useAdminEnterpriseMobileAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>(AdminEnterpriseMobileAppSettingsDocument, options);
        }
export type AdminEnterpriseMobileAppSettingsQueryHookResult = ReturnType<typeof useAdminEnterpriseMobileAppSettingsQuery>;
export type AdminEnterpriseMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useAdminEnterpriseMobileAppSettingsLazyQuery>;
export type AdminEnterpriseMobileAppSettingsQueryResult = Apollo.QueryResult<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>;
export const GeolocateConsumerDocument = gql`
    query GeolocateConsumer {
  geolocate {
    ip
    hostname
    city
    region
    country
    loc
    org
    postal
    timezone
  }
}
    `;

/**
 * __useGeolocateConsumerQuery__
 *
 * To run a query within a React component, call `useGeolocateConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeolocateConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeolocateConsumerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeolocateConsumerQuery(baseOptions?: Apollo.QueryHookOptions<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>(GeolocateConsumerDocument, options);
      }
export function useGeolocateConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>(GeolocateConsumerDocument, options);
        }
export type GeolocateConsumerQueryHookResult = ReturnType<typeof useGeolocateConsumerQuery>;
export type GeolocateConsumerLazyQueryHookResult = ReturnType<typeof useGeolocateConsumerLazyQuery>;
export type GeolocateConsumerQueryResult = Apollo.QueryResult<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>;
export const GenerateHypurTokenV2Document = gql`
    mutation GenerateHypurTokenV2($code: String!, $hostname: String, $state: String!) {
  generateHypurTokenV2(code: $code, hostname: $hostname, state: $state) {
    accessToken
    embedded
  }
}
    `;
export type GqlGenerateHypurTokenV2MutationFn = Apollo.MutationFunction<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>;

/**
 * __useGenerateHypurTokenV2Mutation__
 *
 * To run a mutation, you first call `useGenerateHypurTokenV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHypurTokenV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHypurTokenV2Mutation, { data, loading, error }] = useGenerateHypurTokenV2Mutation({
 *   variables: {
 *      code: // value for 'code'
 *      hostname: // value for 'hostname'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGenerateHypurTokenV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>(GenerateHypurTokenV2Document, options);
      }
export type GenerateHypurTokenV2MutationHookResult = ReturnType<typeof useGenerateHypurTokenV2Mutation>;
export type GenerateHypurTokenV2MutationResult = Apollo.MutationResult<GqlGenerateHypurTokenV2Mutation>;
export type GenerateHypurTokenV2MutationOptions = Apollo.BaseMutationOptions<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>;
export const CreateLibraryProductV2Document = gql`
    mutation CreateLibraryProductV2($libraryProduct: NewLibraryProduct!, $state: String!) {
  createLibraryProductV2(libraryProduct: $libraryProduct, state: $state) {
    id
  }
}
    `;
export type GqlCreateLibraryProductV2MutationFn = Apollo.MutationFunction<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>;

/**
 * __useCreateLibraryProductV2Mutation__
 *
 * To run a mutation, you first call `useCreateLibraryProductV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryProductV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryProductV2Mutation, { data, loading, error }] = useCreateLibraryProductV2Mutation({
 *   variables: {
 *      libraryProduct: // value for 'libraryProduct'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateLibraryProductV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>(CreateLibraryProductV2Document, options);
      }
export type CreateLibraryProductV2MutationHookResult = ReturnType<typeof useCreateLibraryProductV2Mutation>;
export type CreateLibraryProductV2MutationResult = Apollo.MutationResult<GqlCreateLibraryProductV2Mutation>;
export type CreateLibraryProductV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>;
export const CreateLibraryProductV3Document = gql`
    mutation CreateLibraryProductV3($libraryProduct: NewLibraryProductV2!, $state: String!) {
  createLibraryProductV3(libraryProduct: $libraryProduct, state: $state) {
    id
  }
}
    `;
export type GqlCreateLibraryProductV3MutationFn = Apollo.MutationFunction<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>;

/**
 * __useCreateLibraryProductV3Mutation__
 *
 * To run a mutation, you first call `useCreateLibraryProductV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryProductV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryProductV3Mutation, { data, loading, error }] = useCreateLibraryProductV3Mutation({
 *   variables: {
 *      libraryProduct: // value for 'libraryProduct'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateLibraryProductV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>(CreateLibraryProductV3Document, options);
      }
export type CreateLibraryProductV3MutationHookResult = ReturnType<typeof useCreateLibraryProductV3Mutation>;
export type CreateLibraryProductV3MutationResult = Apollo.MutationResult<GqlCreateLibraryProductV3Mutation>;
export type CreateLibraryProductV3MutationOptions = Apollo.BaseMutationOptions<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>;
export const MatchLibraryProductsV2Document = gql`
    query MatchLibraryProductsV2($limit: Int, $name: String!, $state: String!, $category: String, $subcategory: String, $brandIds: [String], $brand: String, $scopes: [String]) {
  matchLibraryProductsV2(
    limit: $limit
    name: $name
    state: $state
    category: $category
    subcategory: $subcategory
    brandIds: $brandIds
    brand: $brand
    scopes: $scopes
  ) {
    id
    brand {
      id
      name
      imageUrl
    }
    category
    cbdContent {
      unit
      range
    }
    image
    images {
      _id
      url
      active
      origin
    }
    name
    price
    productTemplate
    stockImage
    strainType
    subcategory
    thcContent {
      unit
      range
    }
  }
}
    `;

/**
 * __useMatchLibraryProductsV2Query__
 *
 * To run a query within a React component, call `useMatchLibraryProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useMatchLibraryProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchLibraryProductsV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      brandIds: // value for 'brandIds'
 *      brand: // value for 'brand'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useMatchLibraryProductsV2Query(baseOptions: Apollo.QueryHookOptions<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>(MatchLibraryProductsV2Document, options);
      }
export function useMatchLibraryProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>(MatchLibraryProductsV2Document, options);
        }
export type MatchLibraryProductsV2QueryHookResult = ReturnType<typeof useMatchLibraryProductsV2Query>;
export type MatchLibraryProductsV2LazyQueryHookResult = ReturnType<typeof useMatchLibraryProductsV2LazyQuery>;
export type MatchLibraryProductsV2QueryResult = Apollo.QueryResult<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>;
export const MatchLibraryProductsDocument = gql`
    query MatchLibraryProducts($limit: Int, $name: String!, $state: String!, $category: String, $subcategory: String, $brandIds: [String], $brand: String, $productTemplate: Boolean) {
  matchLibraryProducts(
    limit: $limit
    name: $name
    state: $state
    category: $category
    subcategory: $subcategory
    brandIds: $brandIds
    brand: $brand
    productTemplate: $productTemplate
  ) {
    id
    brand {
      id
      name
    }
    category
    cbdContent {
      unit
      range
    }
    image
    name
    price
    strainType
    subcategory
    thcContent {
      unit
      range
    }
  }
}
    `;

/**
 * __useMatchLibraryProductsQuery__
 *
 * To run a query within a React component, call `useMatchLibraryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchLibraryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchLibraryProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      brandIds: // value for 'brandIds'
 *      brand: // value for 'brand'
 *      productTemplate: // value for 'productTemplate'
 *   },
 * });
 */
export function useMatchLibraryProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>(MatchLibraryProductsDocument, options);
      }
export function useMatchLibraryProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>(MatchLibraryProductsDocument, options);
        }
export type MatchLibraryProductsQueryHookResult = ReturnType<typeof useMatchLibraryProductsQuery>;
export type MatchLibraryProductsLazyQueryHookResult = ReturnType<typeof useMatchLibraryProductsLazyQuery>;
export type MatchLibraryProductsQueryResult = Apollo.QueryResult<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>;
export const AddressResidentialCheckDocument = gql`
    query AddressResidentialCheck($input: addressResidentialCheckInput!) {
  addressResidentialCheck(input: $input) {
    isValid
  }
}
    `;

/**
 * __useAddressResidentialCheckQuery__
 *
 * To run a query within a React component, call `useAddressResidentialCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressResidentialCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressResidentialCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressResidentialCheckQuery(baseOptions: Apollo.QueryHookOptions<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>(AddressResidentialCheckDocument, options);
      }
export function useAddressResidentialCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>(AddressResidentialCheckDocument, options);
        }
export type AddressResidentialCheckQueryHookResult = ReturnType<typeof useAddressResidentialCheckQuery>;
export type AddressResidentialCheckLazyQueryHookResult = ReturnType<typeof useAddressResidentialCheckLazyQuery>;
export type AddressResidentialCheckQueryResult = Apollo.QueryResult<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>;
export const HealthCheckDocument = gql`
    query HealthCheck {
  healthCheck {
    status
  }
}
    `;

/**
 * __useHealthCheckQuery__
 *
 * To run a query within a React component, call `useHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>(HealthCheckDocument, options);
      }
export function useHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>(HealthCheckDocument, options);
        }
export type HealthCheckQueryHookResult = ReturnType<typeof useHealthCheckQuery>;
export type HealthCheckLazyQueryHookResult = ReturnType<typeof useHealthCheckLazyQuery>;
export type HealthCheckQueryResult = Apollo.QueryResult<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>;
export const ResetPasswordV2Document = gql`
    mutation ResetPasswordV2($input: resetPasswordInput!) {
  resetPasswordV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlResetPasswordV2MutationFn = Apollo.MutationFunction<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>;

/**
 * __useResetPasswordV2Mutation__
 *
 * To run a mutation, you first call `useResetPasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordV2Mutation, { data, loading, error }] = useResetPasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>(ResetPasswordV2Document, options);
      }
export type ResetPasswordV2MutationHookResult = ReturnType<typeof useResetPasswordV2Mutation>;
export type ResetPasswordV2MutationResult = Apollo.MutationResult<GqlResetPasswordV2Mutation>;
export type ResetPasswordV2MutationOptions = Apollo.BaseMutationOptions<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>;
export const SendBrandUserPasswordResetEmailDocument = gql`
    mutation SendBrandUserPasswordResetEmail($email: String!) {
  sendBrandUserPasswordResetEmail(email: $email) {
    message
    success
  }
}
    `;
export type GqlSendBrandUserPasswordResetEmailMutationFn = Apollo.MutationFunction<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>;

/**
 * __useSendBrandUserPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendBrandUserPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBrandUserPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBrandUserPasswordResetEmailMutation, { data, loading, error }] = useSendBrandUserPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendBrandUserPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>(SendBrandUserPasswordResetEmailDocument, options);
      }
export type SendBrandUserPasswordResetEmailMutationHookResult = ReturnType<typeof useSendBrandUserPasswordResetEmailMutation>;
export type SendBrandUserPasswordResetEmailMutationResult = Apollo.MutationResult<GqlSendBrandUserPasswordResetEmailMutation>;
export type SendBrandUserPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>;
export const SendCompleteAccountSetupEmailDocument = gql`
    mutation SendCompleteAccountSetupEmail($dispensaryId: String!, $email: String!, $orderId: String) {
  sendCompleteAccountSetupEmail(
    dispensaryId: $dispensaryId
    email: $email
    orderId: $orderId
  ) {
    message
    success
  }
}
    `;
export type GqlSendCompleteAccountSetupEmailMutationFn = Apollo.MutationFunction<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>;

/**
 * __useSendCompleteAccountSetupEmailMutation__
 *
 * To run a mutation, you first call `useSendCompleteAccountSetupEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCompleteAccountSetupEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCompleteAccountSetupEmailMutation, { data, loading, error }] = useSendCompleteAccountSetupEmailMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      email: // value for 'email'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendCompleteAccountSetupEmailMutation(baseOptions?: Apollo.MutationHookOptions<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>(SendCompleteAccountSetupEmailDocument, options);
      }
export type SendCompleteAccountSetupEmailMutationHookResult = ReturnType<typeof useSendCompleteAccountSetupEmailMutation>;
export type SendCompleteAccountSetupEmailMutationResult = Apollo.MutationResult<GqlSendCompleteAccountSetupEmailMutation>;
export type SendCompleteAccountSetupEmailMutationOptions = Apollo.BaseMutationOptions<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>;
export const SendPasswordResetEmailV2Document = gql`
    mutation SendPasswordResetEmailV2($email: String!, $dispensaryId: String) {
  sendPasswordResetEmailV2(email: $email, dispensaryId: $dispensaryId) {
    message
    success
  }
}
    `;
export type GqlSendPasswordResetEmailV2MutationFn = Apollo.MutationFunction<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>;

/**
 * __useSendPasswordResetEmailV2Mutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailV2Mutation, { data, loading, error }] = useSendPasswordResetEmailV2Mutation({
 *   variables: {
 *      email: // value for 'email'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useSendPasswordResetEmailV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>(SendPasswordResetEmailV2Document, options);
      }
export type SendPasswordResetEmailV2MutationHookResult = ReturnType<typeof useSendPasswordResetEmailV2Mutation>;
export type SendPasswordResetEmailV2MutationResult = Apollo.MutationResult<GqlSendPasswordResetEmailV2Mutation>;
export type SendPasswordResetEmailV2MutationOptions = Apollo.BaseMutationOptions<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>;
export const SetPasswordV2Document = gql`
    mutation SetPasswordV2($input: setPasswordInput!) {
  setPasswordV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlSetPasswordV2MutationFn = Apollo.MutationFunction<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>;

/**
 * __useSetPasswordV2Mutation__
 *
 * To run a mutation, you first call `useSetPasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordV2Mutation, { data, loading, error }] = useSetPasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>(SetPasswordV2Document, options);
      }
export type SetPasswordV2MutationHookResult = ReturnType<typeof useSetPasswordV2Mutation>;
export type SetPasswordV2MutationResult = Apollo.MutationResult<GqlSetPasswordV2Mutation>;
export type SetPasswordV2MutationOptions = Apollo.BaseMutationOptions<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>;
export const UpdatePasswordV2Document = gql`
    mutation UpdatePasswordV2($oldPassword: String!, $newPassword: String!) {
  updatePasswordV2(oldPassword: $oldPassword, newPassword: $newPassword) {
    accessToken
  }
}
    `;
export type GqlUpdatePasswordV2MutationFn = Apollo.MutationFunction<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>;

/**
 * __useUpdatePasswordV2Mutation__
 *
 * To run a mutation, you first call `useUpdatePasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordV2Mutation, { data, loading, error }] = useUpdatePasswordV2Mutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>(UpdatePasswordV2Document, options);
      }
export type UpdatePasswordV2MutationHookResult = ReturnType<typeof useUpdatePasswordV2Mutation>;
export type UpdatePasswordV2MutationResult = Apollo.MutationResult<GqlUpdatePasswordV2Mutation>;
export type UpdatePasswordV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>;
export const GetPaymentsCheckoutCredentialsDocument = gql`
    query GetPaymentsCheckoutCredentials($adapter: String!, $dispensaryId: String!) {
  getPaymentsCheckoutCredentials(adapter: $adapter, dispensaryId: $dispensaryId) {
    ... on ChaseHostedProfileCredentials {
      uID
    }
    ... on MonerisHTProfileCredentials {
      profileId
    }
  }
}
    `;

/**
 * __useGetPaymentsCheckoutCredentialsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsCheckoutCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsCheckoutCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsCheckoutCredentialsQuery({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPaymentsCheckoutCredentialsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>(GetPaymentsCheckoutCredentialsDocument, options);
      }
export function useGetPaymentsCheckoutCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>(GetPaymentsCheckoutCredentialsDocument, options);
        }
export type GetPaymentsCheckoutCredentialsQueryHookResult = ReturnType<typeof useGetPaymentsCheckoutCredentialsQuery>;
export type GetPaymentsCheckoutCredentialsLazyQueryHookResult = ReturnType<typeof useGetPaymentsCheckoutCredentialsLazyQuery>;
export type GetPaymentsCheckoutCredentialsQueryResult = Apollo.QueryResult<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>;
export const GetMonerisTokenizationProfileDocument = gql`
    query GetMonerisTokenizationProfile($dispensaryId: String!) {
  getMonerisTokenizationProfile(dispensaryId: $dispensaryId) {
    profileId
  }
}
    `;

/**
 * __useGetMonerisTokenizationProfileQuery__
 *
 * To run a query within a React component, call `useGetMonerisTokenizationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonerisTokenizationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonerisTokenizationProfileQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMonerisTokenizationProfileQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>(GetMonerisTokenizationProfileDocument, options);
      }
export function useGetMonerisTokenizationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>(GetMonerisTokenizationProfileDocument, options);
        }
export type GetMonerisTokenizationProfileQueryHookResult = ReturnType<typeof useGetMonerisTokenizationProfileQuery>;
export type GetMonerisTokenizationProfileLazyQueryHookResult = ReturnType<typeof useGetMonerisTokenizationProfileLazyQuery>;
export type GetMonerisTokenizationProfileQueryResult = Apollo.QueryResult<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>;
export const GetCustomerCommunicationSettingsDocument = gql`
    query GetCustomerCommunicationSettings($dispensaryId: String!, $userId: String!) {
  getCustomerCommunicationSettings(dispensaryId: $dispensaryId, userId: $userId) {
    optInEmail
    optInSMS
    optInPush
  }
}
    `;

/**
 * __useGetCustomerCommunicationSettingsQuery__
 *
 * To run a query within a React component, call `useGetCustomerCommunicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCommunicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCommunicationSettingsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCustomerCommunicationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>(GetCustomerCommunicationSettingsDocument, options);
      }
export function useGetCustomerCommunicationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>(GetCustomerCommunicationSettingsDocument, options);
        }
export type GetCustomerCommunicationSettingsQueryHookResult = ReturnType<typeof useGetCustomerCommunicationSettingsQuery>;
export type GetCustomerCommunicationSettingsLazyQueryHookResult = ReturnType<typeof useGetCustomerCommunicationSettingsLazyQuery>;
export type GetCustomerCommunicationSettingsQueryResult = Apollo.QueryResult<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>;
export const UpdateCustomerCommunicationSettingsDocument = gql`
    mutation UpdateCustomerCommunicationSettings($dispensaryId: String!, $userId: String!, $optInEmail: Boolean, $optInSMS: Boolean, $optInPush: Boolean) {
  updateCustomerCommunicationSettings(
    dispensaryId: $dispensaryId
    userId: $userId
    optInEmail: $optInEmail
    optInSMS: $optInSMS
    optInPush: $optInPush
  ) {
    success
  }
}
    `;
export type GqlUpdateCustomerCommunicationSettingsMutationFn = Apollo.MutationFunction<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>;

/**
 * __useUpdateCustomerCommunicationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerCommunicationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerCommunicationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerCommunicationSettingsMutation, { data, loading, error }] = useUpdateCustomerCommunicationSettingsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      optInEmail: // value for 'optInEmail'
 *      optInSMS: // value for 'optInSMS'
 *      optInPush: // value for 'optInPush'
 *   },
 * });
 */
export function useUpdateCustomerCommunicationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>(UpdateCustomerCommunicationSettingsDocument, options);
      }
export type UpdateCustomerCommunicationSettingsMutationHookResult = ReturnType<typeof useUpdateCustomerCommunicationSettingsMutation>;
export type UpdateCustomerCommunicationSettingsMutationResult = Apollo.MutationResult<GqlUpdateCustomerCommunicationSettingsMutation>;
export type UpdateCustomerCommunicationSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>;
export const ArchivedProductLookupDocument = gql`
    query ArchivedProductLookup($cname: String!, $dispensaryId: String!) {
  archivedProductLookup(cname: $cname, dispensaryId: $dispensaryId) {
    ...consumerBaseProductFragment
    brand {
      id
      _id
      description
      imageUrl
      name
    }
    effects
    description
    descriptionHtml
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useArchivedProductLookupQuery__
 *
 * To run a query within a React component, call `useArchivedProductLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedProductLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedProductLookupQuery({
 *   variables: {
 *      cname: // value for 'cname'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useArchivedProductLookupQuery(baseOptions: Apollo.QueryHookOptions<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>(ArchivedProductLookupDocument, options);
      }
export function useArchivedProductLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>(ArchivedProductLookupDocument, options);
        }
export type ArchivedProductLookupQueryHookResult = ReturnType<typeof useArchivedProductLookupQuery>;
export type ArchivedProductLookupLazyQueryHookResult = ReturnType<typeof useArchivedProductLookupLazyQuery>;
export type ArchivedProductLookupQueryResult = Apollo.QueryResult<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>;
export const FilteredProductsDocument = gql`
    query FilteredProducts($productsFilter: productsFilterInput!, $useCache: Boolean, $page: Int, $perPage: Int, $includeEnterpriseSpecials: Boolean = false) {
  filteredProducts(
    filter: $productsFilter
    useCache: $useCache
    page: $page
    perPage: $perPage
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    products {
      ...consumerBaseProductFragment
      brand {
        id
        _id
        description
        imageUrl
        name
      }
      effects
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
        }
      }
      provider
    }
    queryInfo {
      totalCount
      totalPages
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useFilteredProductsQuery__
 *
 * To run a query within a React component, call `useFilteredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      useCache: // value for 'useCache'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useFilteredProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>(FilteredProductsDocument, options);
      }
export function useFilteredProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>(FilteredProductsDocument, options);
        }
export type FilteredProductsQueryHookResult = ReturnType<typeof useFilteredProductsQuery>;
export type FilteredProductsLazyQueryHookResult = ReturnType<typeof useFilteredProductsLazyQuery>;
export type FilteredProductsQueryResult = Apollo.QueryResult<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>;
export const IndividualFilteredProductDocument = gql`
    query IndividualFilteredProduct($productsFilter: productsFilterInput!, $useCache: Boolean, $includeEnterpriseSpecials: Boolean = false) {
  filteredProducts(
    filter: $productsFilter
    useCache: $useCache
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    products {
      ...consumerBaseProductFragment
      POSMetaData {
        children {
          terpenes {
            name
            unit
            values
          }
          cannabinoids {
            name
            unit
            values
          }
        }
      }
      brand {
        id
        _id
        description
        imageUrl
        name
      }
      terpenes {
        id
        libraryTerpene {
          aromas
          description
          effects
          name
        }
        terpeneId
        unit
        unitSymbol
        value
      }
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
          description
        }
      }
      effects
      description
      descriptionHtml
      outletCollectionInfo {
        timerMessage
        endDate
      }
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useIndividualFilteredProductQuery__
 *
 * To run a query within a React component, call `useIndividualFilteredProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualFilteredProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualFilteredProductQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      useCache: // value for 'useCache'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useIndividualFilteredProductQuery(baseOptions: Apollo.QueryHookOptions<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>(IndividualFilteredProductDocument, options);
      }
export function useIndividualFilteredProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>(IndividualFilteredProductDocument, options);
        }
export type IndividualFilteredProductQueryHookResult = ReturnType<typeof useIndividualFilteredProductQuery>;
export type IndividualFilteredProductLazyQueryHookResult = ReturnType<typeof useIndividualFilteredProductLazyQuery>;
export type IndividualFilteredProductQueryResult = Apollo.QueryResult<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>;
export const CreateRedemptionDocument = gql`
    mutation CreateRedemption($code: String!, $receiverUserId: String!) {
  createRedemption(code: $code, receiverUserId: $receiverUserId) {
    id
    code
    receiverUserId
    lspName
    lspId
    status
  }
}
    `;
export type GqlCreateRedemptionMutationFn = Apollo.MutationFunction<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>;

/**
 * __useCreateRedemptionMutation__
 *
 * To run a mutation, you first call `useCreateRedemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRedemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRedemptionMutation, { data, loading, error }] = useCreateRedemptionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      receiverUserId: // value for 'receiverUserId'
 *   },
 * });
 */
export function useCreateRedemptionMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>(CreateRedemptionDocument, options);
      }
export type CreateRedemptionMutationHookResult = ReturnType<typeof useCreateRedemptionMutation>;
export type CreateRedemptionMutationResult = Apollo.MutationResult<GqlCreateRedemptionMutation>;
export type CreateRedemptionMutationOptions = Apollo.BaseMutationOptions<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>;
export const FindOrCreateReferralCodeDocument = gql`
    mutation FindOrCreateReferralCode($lspName: String!, $senderUserId: String, $dispensaryId: String!, $code: String, $posUniqueId: String) {
  findOrCreateReferralCode(
    lspName: $lspName
    senderUserId: $senderUserId
    dispensaryId: $dispensaryId
    code: $code
    posUniqueId: $posUniqueId
  ) {
    code
    id
    lspName
    senderEcommId
    senderPosUniqueId
    senderPoints
    receiverPoints
    learnMoreUrl
    referralUrl
  }
}
    `;
export type GqlFindOrCreateReferralCodeMutationFn = Apollo.MutationFunction<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>;

/**
 * __useFindOrCreateReferralCodeMutation__
 *
 * To run a mutation, you first call `useFindOrCreateReferralCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateReferralCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateReferralCodeMutation, { data, loading, error }] = useFindOrCreateReferralCodeMutation({
 *   variables: {
 *      lspName: // value for 'lspName'
 *      senderUserId: // value for 'senderUserId'
 *      dispensaryId: // value for 'dispensaryId'
 *      code: // value for 'code'
 *      posUniqueId: // value for 'posUniqueId'
 *   },
 * });
 */
export function useFindOrCreateReferralCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>(FindOrCreateReferralCodeDocument, options);
      }
export type FindOrCreateReferralCodeMutationHookResult = ReturnType<typeof useFindOrCreateReferralCodeMutation>;
export type FindOrCreateReferralCodeMutationResult = Apollo.MutationResult<GqlFindOrCreateReferralCodeMutation>;
export type FindOrCreateReferralCodeMutationOptions = Apollo.BaseMutationOptions<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>;
export const CreateAlpineUserV2Document = gql`
    mutation CreateAlpineUserV2($firstName: String, $lastName: String, $address: String, $email: String, $program: String!, $dispensaryId: String!, $favoriteStore: String!, $phoneNumber: String!, $acceptedTerms: Boolean!) {
  createAlpineUserV2(
    firstName: $firstName
    lastName: $lastName
    address: $address
    email: $email
    program: $program
    dispensaryId: $dispensaryId
    favoriteStore: $favoriteStore
    phoneNumber: $phoneNumber
    acceptedTerms: $acceptedTerms
  ) {
    success
    wallet {
      balance
      rewardBrand
      rewards {
        id
        copy
        available
        operator
        cost
        costV2
        value
        rewardType
      }
      userHasWallet
      auth {
        pinConfirmed
        incorrectPinProvided
        authTextMessageSent
      }
    }
  }
}
    `;
export type GqlCreateAlpineUserV2MutationFn = Apollo.MutationFunction<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>;

/**
 * __useCreateAlpineUserV2Mutation__
 *
 * To run a mutation, you first call `useCreateAlpineUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlpineUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlpineUserV2Mutation, { data, loading, error }] = useCreateAlpineUserV2Mutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      program: // value for 'program'
 *      dispensaryId: // value for 'dispensaryId'
 *      favoriteStore: // value for 'favoriteStore'
 *      phoneNumber: // value for 'phoneNumber'
 *      acceptedTerms: // value for 'acceptedTerms'
 *   },
 * });
 */
export function useCreateAlpineUserV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>(CreateAlpineUserV2Document, options);
      }
export type CreateAlpineUserV2MutationHookResult = ReturnType<typeof useCreateAlpineUserV2Mutation>;
export type CreateAlpineUserV2MutationResult = Apollo.MutationResult<GqlCreateAlpineUserV2Mutation>;
export type CreateAlpineUserV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>;
export const CreateAlpineUserDocument = gql`
    mutation CreateAlpineUser($firstName: String, $lastName: String, $address: String, $email: String, $program: String!, $dispensaryId: String!, $favoriteStore: String!, $phoneNumber: String!, $acceptedTerms: Boolean!) {
  createAlpineUser(
    firstName: $firstName
    lastName: $lastName
    address: $address
    email: $email
    program: $program
    dispensaryId: $dispensaryId
    favoriteStore: $favoriteStore
    phoneNumber: $phoneNumber
    acceptedTerms: $acceptedTerms
  ) {
    success
    wallet {
      balance
      rewardBrand
      rewards {
        id
        copy
        available
        operator
        cost
        costV2
        value
        rewardType
      }
      userHasWallet
      auth {
        pinConfirmed
        incorrectPinProvided
        authTextMessageSent
      }
    }
  }
}
    `;
export type GqlCreateAlpineUserMutationFn = Apollo.MutationFunction<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>;

/**
 * __useCreateAlpineUserMutation__
 *
 * To run a mutation, you first call `useCreateAlpineUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlpineUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlpineUserMutation, { data, loading, error }] = useCreateAlpineUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      program: // value for 'program'
 *      dispensaryId: // value for 'dispensaryId'
 *      favoriteStore: // value for 'favoriteStore'
 *      phoneNumber: // value for 'phoneNumber'
 *      acceptedTerms: // value for 'acceptedTerms'
 *   },
 * });
 */
export function useCreateAlpineUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>(CreateAlpineUserDocument, options);
      }
export type CreateAlpineUserMutationHookResult = ReturnType<typeof useCreateAlpineUserMutation>;
export type CreateAlpineUserMutationResult = Apollo.MutationResult<GqlCreateAlpineUserMutation>;
export type CreateAlpineUserMutationOptions = Apollo.BaseMutationOptions<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>;
export const CreateDutchiePosLoyaltyMemberV2Document = gql`
    mutation CreateDutchiePosLoyaltyMemberV2($dispensaryId: String!, $userId: String!, $isLoyaltyMember: Boolean, $senderUniqueId: String, $useStrictMatching: Boolean) {
  createDutchiePosLoyaltyMemberV2(
    dispensaryId: $dispensaryId
    userId: $userId
    isLoyaltyMember: $isLoyaltyMember
    senderUniqueId: $senderUniqueId
    useStrictMatching: $useStrictMatching
  ) {
    posCustomerId
    isLoyaltyMember
  }
}
    `;
export type GqlCreateDutchiePosLoyaltyMemberV2MutationFn = Apollo.MutationFunction<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>;

/**
 * __useCreateDutchiePosLoyaltyMemberV2Mutation__
 *
 * To run a mutation, you first call `useCreateDutchiePosLoyaltyMemberV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDutchiePosLoyaltyMemberV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDutchiePosLoyaltyMemberV2Mutation, { data, loading, error }] = useCreateDutchiePosLoyaltyMemberV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      isLoyaltyMember: // value for 'isLoyaltyMember'
 *      senderUniqueId: // value for 'senderUniqueId'
 *      useStrictMatching: // value for 'useStrictMatching'
 *   },
 * });
 */
export function useCreateDutchiePosLoyaltyMemberV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>(CreateDutchiePosLoyaltyMemberV2Document, options);
      }
export type CreateDutchiePosLoyaltyMemberV2MutationHookResult = ReturnType<typeof useCreateDutchiePosLoyaltyMemberV2Mutation>;
export type CreateDutchiePosLoyaltyMemberV2MutationResult = Apollo.MutationResult<GqlCreateDutchiePosLoyaltyMemberV2Mutation>;
export type CreateDutchiePosLoyaltyMemberV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>;
export const CreateDutchiePosLoyaltyMemberDocument = gql`
    mutation CreateDutchiePosLoyaltyMember($dispensaryId: String!, $userId: String!, $senderUniqueId: String) {
  createDutchiePosLoyaltyMember(
    dispensaryId: $dispensaryId
    userId: $userId
    senderUniqueId: $senderUniqueId
  ) {
    success
  }
}
    `;
export type GqlCreateDutchiePosLoyaltyMemberMutationFn = Apollo.MutationFunction<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useCreateDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useCreateDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      senderUniqueId: // value for 'senderUniqueId'
 *   },
 * });
 */
export function useCreateDutchiePosLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>(CreateDutchiePosLoyaltyMemberDocument, options);
      }
export type CreateDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateDutchiePosLoyaltyMemberMutation>;
export type CreateDutchiePosLoyaltyMemberMutationResult = Apollo.MutationResult<GqlCreateDutchiePosLoyaltyMemberMutation>;
export type CreateDutchiePosLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>;
export const CreateEnterpriseDutchiePosLoyaltyMemberV2Document = gql`
    mutation CreateEnterpriseDutchiePosLoyaltyMemberV2($enterpriseId: String!, $userId: String!, $isoRegionCode: String!, $isLoyaltyMember: Boolean, $useStrictMatching: Boolean) {
  createEnterpriseDutchiePosLoyaltyMemberV2(
    enterpriseId: $enterpriseId
    userId: $userId
    isoRegionCode: $isoRegionCode
    isLoyaltyMember: $isLoyaltyMember
    useStrictMatching: $useStrictMatching
  ) {
    posCustomerId
    isLoyaltyMember
  }
}
    `;
export type GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationFn = Apollo.MutationFunction<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>;

/**
 * __useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseDutchiePosLoyaltyMemberV2Mutation, { data, loading, error }] = useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      userId: // value for 'userId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      isLoyaltyMember: // value for 'isLoyaltyMember'
 *      useStrictMatching: // value for 'useStrictMatching'
 *   },
 * });
 */
export function useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>(CreateEnterpriseDutchiePosLoyaltyMemberV2Document, options);
      }
export type CreateEnterpriseDutchiePosLoyaltyMemberV2MutationHookResult = ReturnType<typeof useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberV2MutationResult = Apollo.MutationResult<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>;
export const CreateEnterpriseDutchiePosLoyaltyMemberDocument = gql`
    mutation CreateEnterpriseDutchiePosLoyaltyMember($enterpriseId: String!, $userId: String!, $isoRegionCode: String!, $isLoyaltyMember: Boolean) {
  createEnterpriseDutchiePosLoyaltyMember(
    enterpriseId: $enterpriseId
    userId: $userId
    isoRegionCode: $isoRegionCode
    isLoyaltyMember: $isLoyaltyMember
  ) {
    success
    message
  }
}
    `;
export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationFn = Apollo.MutationFunction<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useCreateEnterpriseDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useCreateEnterpriseDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      userId: // value for 'userId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      isLoyaltyMember: // value for 'isLoyaltyMember'
 *   },
 * });
 */
export function useCreateEnterpriseDutchiePosLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>(CreateEnterpriseDutchiePosLoyaltyMemberDocument, options);
      }
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateEnterpriseDutchiePosLoyaltyMemberMutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationResult = Apollo.MutationResult<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>;
export const CreateSpringbigUserDocument = gql`
    mutation CreateSpringbigUser($dispensaryId: String!, $userId: String!) {
  createSpringbigUser(dispensaryId: $dispensaryId, userId: $userId) {
    success
  }
}
    `;
export type GqlCreateSpringbigUserMutationFn = Apollo.MutationFunction<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>;

/**
 * __useCreateSpringbigUserMutation__
 *
 * To run a mutation, you first call `useCreateSpringbigUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpringbigUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpringbigUserMutation, { data, loading, error }] = useCreateSpringbigUserMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSpringbigUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>(CreateSpringbigUserDocument, options);
      }
export type CreateSpringbigUserMutationHookResult = ReturnType<typeof useCreateSpringbigUserMutation>;
export type CreateSpringbigUserMutationResult = Apollo.MutationResult<GqlCreateSpringbigUserMutation>;
export type CreateSpringbigUserMutationOptions = Apollo.BaseMutationOptions<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>;
export const UpdateDutchiePosLoyaltyMemberDocument = gql`
    mutation UpdateDutchiePosLoyaltyMember($dispensaryId: String!, $userId: String!, $phone: String!, $lastAndroidLoginUtc: String, $lastIosLoginUtc: String, $senderUniqueId: String) {
  updateDutchiePosLoyaltyMember(
    dispensaryId: $dispensaryId
    userId: $userId
    phone: $phone
    lastAndroidLoginUtc: $lastAndroidLoginUtc
    lastIosLoginUtc: $lastIosLoginUtc
    senderUniqueId: $senderUniqueId
  ) {
    success
  }
}
    `;
export type GqlUpdateDutchiePosLoyaltyMemberMutationFn = Apollo.MutationFunction<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useUpdateDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useUpdateDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useUpdateDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      phone: // value for 'phone'
 *      lastAndroidLoginUtc: // value for 'lastAndroidLoginUtc'
 *      lastIosLoginUtc: // value for 'lastIosLoginUtc'
 *      senderUniqueId: // value for 'senderUniqueId'
 *   },
 * });
 */
export function useUpdateDutchiePosLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>(UpdateDutchiePosLoyaltyMemberDocument, options);
      }
export type UpdateDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useUpdateDutchiePosLoyaltyMemberMutation>;
export type UpdateDutchiePosLoyaltyMemberMutationResult = Apollo.MutationResult<GqlUpdateDutchiePosLoyaltyMemberMutation>;
export type UpdateDutchiePosLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>;
export const GetDutchiePosLoyaltyConfigDocument = gql`
    query GetDutchiePosLoyaltyConfig($dispensaryId: String, $enterpriseId: String, $isoRegionCode: String) {
  getDutchiePosLoyaltyConfig(
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
  ) {
    loyaltyRequireOptIn
    isEnabled
    loyaltyExpirationMode
    onlineName
    onlineDescription
    tierEarningBasis
    redemptionType
    mode
    tiers {
      id
      name
      threshold
      badgeColor
      accrualRate
    }
    referralConfig {
      isEnabled
      learnMoreUrl
      senderReward
      receiverReward
      minimumPurchaseAmount
    }
    dispensaryId
    loyaltyWidgetEnabledOnWeb
    loyaltyWidgetEnabledOnMobile
    onlineRedemptionEnabledOnWeb
    onlineRedemptionEnabledOnMobile
    viewDiscountRewards
    maxRedemptionsPerTransaction
    accrualRate
    requireVerifiedPhoneForEnrollmentOnEcomm
    requireVerifiedPhoneForRedemptionOnEcomm
  }
}
    `;

/**
 * __useGetDutchiePosLoyaltyConfigQuery__
 *
 * To run a query within a React component, call `useGetDutchiePosLoyaltyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDutchiePosLoyaltyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDutchiePosLoyaltyConfigQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *   },
 * });
 */
export function useGetDutchiePosLoyaltyConfigQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>(GetDutchiePosLoyaltyConfigDocument, options);
      }
export function useGetDutchiePosLoyaltyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>(GetDutchiePosLoyaltyConfigDocument, options);
        }
export type GetDutchiePosLoyaltyConfigQueryHookResult = ReturnType<typeof useGetDutchiePosLoyaltyConfigQuery>;
export type GetDutchiePosLoyaltyConfigLazyQueryHookResult = ReturnType<typeof useGetDutchiePosLoyaltyConfigLazyQuery>;
export type GetDutchiePosLoyaltyConfigQueryResult = Apollo.QueryResult<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>;
export const GetLoyaltyPassUrlDocument = gql`
    query GetLoyaltyPassUrl($dispensaryId: String!) {
  getLoyaltyPassUrl(dispensaryId: $dispensaryId) {
    url
    shortUrl
  }
}
    `;

/**
 * __useGetLoyaltyPassUrlQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyPassUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyPassUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyPassUrlQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetLoyaltyPassUrlQuery(baseOptions: Apollo.QueryHookOptions<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>(GetLoyaltyPassUrlDocument, options);
      }
export function useGetLoyaltyPassUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>(GetLoyaltyPassUrlDocument, options);
        }
export type GetLoyaltyPassUrlQueryHookResult = ReturnType<typeof useGetLoyaltyPassUrlQuery>;
export type GetLoyaltyPassUrlLazyQueryHookResult = ReturnType<typeof useGetLoyaltyPassUrlLazyQuery>;
export type GetLoyaltyPassUrlQueryResult = Apollo.QueryResult<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>;
export const GetRewardsV2Document = gql`
    query GetRewardsV2($phoneNumber: String!, $dispensaryId: String, $enterpriseId: String, $isoRegionCode: String, $dob: String, $pin: String, $customerId: String, $cartSubtotal: Float) {
  getRewardsV2(
    phoneNumber: $phoneNumber
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
    dob: $dob
    pin: $pin
    customerId: $customerId
    cartSubtotal: $cartSubtotal
  ) {
    balance
    rewards {
      id
      copy
      available
      operator
      cost
      costV2
      value
      rewardType
      discountId
      brand
      isRedeemableOnline
      isEligible
      allowStacking
    }
    rewardBrand
    userHasWallet
    isLoyaltyMember
    currentYearTierBalance
    expirationDate
    soonestExpiringBalance
    soonestExpirationDate
    tierName
    tierId
    auth {
      pinConfirmed
      incorrectPinProvided
      authTextMessageSent
    }
    rewardsActivity {
      lspName
      location
      customerId
      transactionType
      transactionDateUtc
      points
      comment
      orderType
      isAdjustment
      totalPaid
      expirationDate
    }
    posCustomerId
    posUniqueId
    isRevokedFromReferralProgram
  }
}
    `;

/**
 * __useGetRewardsV2Query__
 *
 * To run a query within a React component, call `useGetRewardsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsV2Query({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      dob: // value for 'dob'
 *      pin: // value for 'pin'
 *      customerId: // value for 'customerId'
 *      cartSubtotal: // value for 'cartSubtotal'
 *   },
 * });
 */
export function useGetRewardsV2Query(baseOptions: Apollo.QueryHookOptions<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>(GetRewardsV2Document, options);
      }
export function useGetRewardsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>(GetRewardsV2Document, options);
        }
export type GetRewardsV2QueryHookResult = ReturnType<typeof useGetRewardsV2Query>;
export type GetRewardsV2LazyQueryHookResult = ReturnType<typeof useGetRewardsV2LazyQuery>;
export type GetRewardsV2QueryResult = Apollo.QueryResult<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>;
export const BulkEndSpecialsV2Document = gql`
    mutation BulkEndSpecialsV2($input: endSpecialsInput!) {
  bulkEndSpecialsV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlBulkEndSpecialsV2MutationFn = Apollo.MutationFunction<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>;

/**
 * __useBulkEndSpecialsV2Mutation__
 *
 * To run a mutation, you first call `useBulkEndSpecialsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEndSpecialsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEndSpecialsV2Mutation, { data, loading, error }] = useBulkEndSpecialsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEndSpecialsV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>(BulkEndSpecialsV2Document, options);
      }
export type BulkEndSpecialsV2MutationHookResult = ReturnType<typeof useBulkEndSpecialsV2Mutation>;
export type BulkEndSpecialsV2MutationResult = Apollo.MutationResult<GqlBulkEndSpecialsV2Mutation>;
export type BulkEndSpecialsV2MutationOptions = Apollo.BaseMutationOptions<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>;
export const CreateEnterpriseSpecialV2Document = gql`
    mutation CreateEnterpriseSpecialV2($input: EnterpriseSpecialInputV2!) {
  createEnterpriseSpecialV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlCreateEnterpriseSpecialV2MutationFn = Apollo.MutationFunction<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>;

/**
 * __useCreateEnterpriseSpecialV2Mutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseSpecialV2Mutation, { data, loading, error }] = useCreateEnterpriseSpecialV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>(CreateEnterpriseSpecialV2Document, options);
      }
export type CreateEnterpriseSpecialV2MutationHookResult = ReturnType<typeof useCreateEnterpriseSpecialV2Mutation>;
export type CreateEnterpriseSpecialV2MutationResult = Apollo.MutationResult<GqlCreateEnterpriseSpecialV2Mutation>;
export type CreateEnterpriseSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>;
export const CreateSpecialV3Document = gql`
    mutation CreateSpecialV3($input: SpecialsInputV3!) {
  createSpecialV3(input: $input) {
    _id
  }
}
    `;
export type GqlCreateSpecialV3MutationFn = Apollo.MutationFunction<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>;

/**
 * __useCreateSpecialV3Mutation__
 *
 * To run a mutation, you first call `useCreateSpecialV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialV3Mutation, { data, loading, error }] = useCreateSpecialV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpecialV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>(CreateSpecialV3Document, options);
      }
export type CreateSpecialV3MutationHookResult = ReturnType<typeof useCreateSpecialV3Mutation>;
export type CreateSpecialV3MutationResult = Apollo.MutationResult<GqlCreateSpecialV3Mutation>;
export type CreateSpecialV3MutationOptions = Apollo.BaseMutationOptions<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>;
export const DeleteEnterpriseSpecialDocument = gql`
    mutation DeleteEnterpriseSpecial($enterpriseId: String!, $id: String!) {
  deleteEnterpriseSpecial(enterprise_id: $enterpriseId, id: $id) {
    message
    success
  }
}
    `;
export type GqlDeleteEnterpriseSpecialMutationFn = Apollo.MutationFunction<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>;

/**
 * __useDeleteEnterpriseSpecialMutation__
 *
 * To run a mutation, you first call `useDeleteEnterpriseSpecialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnterpriseSpecialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnterpriseSpecialMutation, { data, loading, error }] = useDeleteEnterpriseSpecialMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnterpriseSpecialMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>(DeleteEnterpriseSpecialDocument, options);
      }
export type DeleteEnterpriseSpecialMutationHookResult = ReturnType<typeof useDeleteEnterpriseSpecialMutation>;
export type DeleteEnterpriseSpecialMutationResult = Apollo.MutationResult<GqlDeleteEnterpriseSpecialMutation>;
export type DeleteEnterpriseSpecialMutationOptions = Apollo.BaseMutationOptions<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>;
export const DeleteSpecialV2Document = gql`
    mutation DeleteSpecialV2($id: String!) {
  deleteSpecialV2(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteSpecialV2MutationFn = Apollo.MutationFunction<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>;

/**
 * __useDeleteSpecialV2Mutation__
 *
 * To run a mutation, you first call `useDeleteSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialV2Mutation, { data, loading, error }] = useDeleteSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>(DeleteSpecialV2Document, options);
      }
export type DeleteSpecialV2MutationHookResult = ReturnType<typeof useDeleteSpecialV2Mutation>;
export type DeleteSpecialV2MutationResult = Apollo.MutationResult<GqlDeleteSpecialV2Mutation>;
export type DeleteSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>;
export const EndEnterpriseSpecialDocument = gql`
    mutation EndEnterpriseSpecial($enterpriseId: String!, $id: String!) {
  endEnterpriseSpecial(enterprise_id: $enterpriseId, id: $id) {
    success
    message
  }
}
    `;
export type GqlEndEnterpriseSpecialMutationFn = Apollo.MutationFunction<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>;

/**
 * __useEndEnterpriseSpecialMutation__
 *
 * To run a mutation, you first call `useEndEnterpriseSpecialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndEnterpriseSpecialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endEnterpriseSpecialMutation, { data, loading, error }] = useEndEnterpriseSpecialMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndEnterpriseSpecialMutation(baseOptions?: Apollo.MutationHookOptions<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>(EndEnterpriseSpecialDocument, options);
      }
export type EndEnterpriseSpecialMutationHookResult = ReturnType<typeof useEndEnterpriseSpecialMutation>;
export type EndEnterpriseSpecialMutationResult = Apollo.MutationResult<GqlEndEnterpriseSpecialMutation>;
export type EndEnterpriseSpecialMutationOptions = Apollo.BaseMutationOptions<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>;
export const EndSpecialV2Document = gql`
    mutation EndSpecialV2($id: String!) {
  endSpecialV2(id: $id) {
    _id
  }
}
    `;
export type GqlEndSpecialV2MutationFn = Apollo.MutationFunction<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>;

/**
 * __useEndSpecialV2Mutation__
 *
 * To run a mutation, you first call `useEndSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endSpecialV2Mutation, { data, loading, error }] = useEndSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>(EndSpecialV2Document, options);
      }
export type EndSpecialV2MutationHookResult = ReturnType<typeof useEndSpecialV2Mutation>;
export type EndSpecialV2MutationResult = Apollo.MutationResult<GqlEndSpecialV2Mutation>;
export type EndSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>;
export const IncrementSpecialClicksDocument = gql`
    mutation IncrementSpecialClicks($input: incrementClicksInput!) {
  incrementClicks(special: $input) {
    message
    success
  }
}
    `;
export type GqlIncrementSpecialClicksMutationFn = Apollo.MutationFunction<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>;

/**
 * __useIncrementSpecialClicksMutation__
 *
 * To run a mutation, you first call `useIncrementSpecialClicksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementSpecialClicksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementSpecialClicksMutation, { data, loading, error }] = useIncrementSpecialClicksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncrementSpecialClicksMutation(baseOptions?: Apollo.MutationHookOptions<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>(IncrementSpecialClicksDocument, options);
      }
export type IncrementSpecialClicksMutationHookResult = ReturnType<typeof useIncrementSpecialClicksMutation>;
export type IncrementSpecialClicksMutationResult = Apollo.MutationResult<GqlIncrementSpecialClicksMutation>;
export type IncrementSpecialClicksMutationOptions = Apollo.BaseMutationOptions<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>;
export const UpdateEnterpriseSpecialV2Document = gql`
    mutation UpdateEnterpriseSpecialV2($id: String!, $input: EnterpriseSpecialInputV2!) {
  updateEnterpriseSpecialV2(id: $id, input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateEnterpriseSpecialV2MutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>;

/**
 * __useUpdateEnterpriseSpecialV2Mutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseSpecialV2Mutation, { data, loading, error }] = useUpdateEnterpriseSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>(UpdateEnterpriseSpecialV2Document, options);
      }
export type UpdateEnterpriseSpecialV2MutationHookResult = ReturnType<typeof useUpdateEnterpriseSpecialV2Mutation>;
export type UpdateEnterpriseSpecialV2MutationResult = Apollo.MutationResult<GqlUpdateEnterpriseSpecialV2Mutation>;
export type UpdateEnterpriseSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>;
export const UpdateSpecialV3Document = gql`
    mutation UpdateSpecialV3($id: String!, $input: SpecialsInputV3!) {
  updateSpecialV3(id: $id, input: $input) {
    _id
  }
}
    `;
export type GqlUpdateSpecialV3MutationFn = Apollo.MutationFunction<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>;

/**
 * __useUpdateSpecialV3Mutation__
 *
 * To run a mutation, you first call `useUpdateSpecialV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialV3Mutation, { data, loading, error }] = useUpdateSpecialV3Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>(UpdateSpecialV3Document, options);
      }
export type UpdateSpecialV3MutationHookResult = ReturnType<typeof useUpdateSpecialV3Mutation>;
export type UpdateSpecialV3MutationResult = Apollo.MutationResult<GqlUpdateSpecialV3Mutation>;
export type UpdateSpecialV3MutationOptions = Apollo.BaseMutationOptions<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>;
export const UpdateSpecialsSortOrderDocument = gql`
    mutation UpdateSpecialsSortOrder($input: SortOrderInput!) {
  updateSpecialsSortOrder(input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateSpecialsSortOrderMutationFn = Apollo.MutationFunction<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>;

/**
 * __useUpdateSpecialsSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialsSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialsSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialsSortOrderMutation, { data, loading, error }] = useUpdateSpecialsSortOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialsSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>(UpdateSpecialsSortOrderDocument, options);
      }
export type UpdateSpecialsSortOrderMutationHookResult = ReturnType<typeof useUpdateSpecialsSortOrderMutation>;
export type UpdateSpecialsSortOrderMutationResult = Apollo.MutationResult<GqlUpdateSpecialsSortOrderMutation>;
export type UpdateSpecialsSortOrderMutationOptions = Apollo.BaseMutationOptions<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>;
export const EnterpriseSpecialsV3Document = gql`
    query EnterpriseSpecialsV3($enterpriseId: ID!, $filter: filteredSpecialsInputV2) {
  enterpriseSpecialsV3(enterpriseId: $enterpriseId, filter: $filter) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          productTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      cipher
      clicks
      complete
      createdAt
      createdBy
      description
      descriptionHtml
      discount
      discountedPrices
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      displayRank
      earliestStartStamp
      emailSpecial
      endDay
      endStamp
      endTime
      enterpriseId
      enterpriseSpecialId
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      latestEndStamp
      localTime
      menuDisplayDescription
      menuDisplayName
      menuDisplayImage
      menuType
      name
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      dispensaries
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialRestrictions
      specialType
      startDay
      startStamp
      startTime
      subject
      targetPrice
      timezone
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useEnterpriseSpecialsV3Query__
 *
 * To run a query within a React component, call `useEnterpriseSpecialsV3Query` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseSpecialsV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseSpecialsV3Query({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEnterpriseSpecialsV3Query(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>(EnterpriseSpecialsV3Document, options);
      }
export function useEnterpriseSpecialsV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>(EnterpriseSpecialsV3Document, options);
        }
export type EnterpriseSpecialsV3QueryHookResult = ReturnType<typeof useEnterpriseSpecialsV3Query>;
export type EnterpriseSpecialsV3LazyQueryHookResult = ReturnType<typeof useEnterpriseSpecialsV3LazyQuery>;
export type EnterpriseSpecialsV3QueryResult = Apollo.QueryResult<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>;
export const EnterpriseSpecialsDocument = gql`
    query EnterpriseSpecials($enterpriseId: ID!) {
  enterpriseSpecials(enterpriseId: $enterpriseId) {
    _id
    active
    applyRewardsToConditions
    excludeConditionItemsFromRewards
    bogoConditionLogicOperator
    bogoConditions {
      _id
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productId
      productIds
      productTags
      quantity
      requiresSingleSku
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      weight
      weights
      weightOperator
    }
    bogoRewardLogicOperator
    bogoRewards {
      _id
      applicationRules {
        _id
        comparisonOperator
        quantity
        applicationType
      }
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      dollarDiscount
      discountAmount
      discountType
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productId
      productIds
      productTags
      percentDiscount
      productTags
      quantity
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      requiresSingleSku
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      weight
      weights
      weightOperator
    }
    cipher
    clicks
    createdAt
    createdBy
    description
    descriptionHtml
    discount
    discountedPrices
    discountToCart {
      _id
      enabled
      discountType
      value
    }
    displayRank
    emailSpecial
    endDay
    endStamp
    endTime
    enterpriseId
    enterpriseSpecialId
    excludedProducts {
      _id
      Name
      key
      conditions {
        _id
        Name
        key
      }
      rewards {
        _id
        Name
        key
      }
    }
    heading
    isRecurring
    itemsForAPrice {
      _id
      enabled
      value
    }
    localTime
    menuDisplayDescription
    menuDisplayName
    menuDisplayImage
    menuType
    name
    percentDiscount
    productDiscounts
    productGroup
    productGroupRewards
    products
    recurring {
      days
      endDate
      endTime
      setEndDate
      startTime
    }
    redemptionLimit
    dispensaries
    saleDiscounts {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      discountAmount
      discountType
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      weights
      weightOperator
    }
    scope
    source
    sourceId
    specialRestrictions
    specialType
    startDay
    startStamp
    startTime
    subject
    targetPrice
    timezone
    totalQuantity {
      enabled
      maxQuantity
      quantity
      quantityOperator
    }
    totalWeight {
      enabled
      weight
      weightOperator
    }
    totalSpend {
      enabled
      maximumSpend
      minimumSpend
      spendOperator
    }
    updatedAt
    updatedBy
    version
  }
}
    `;

/**
 * __useEnterpriseSpecialsQuery__
 *
 * To run a query within a React component, call `useEnterpriseSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseSpecialsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseSpecialsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>(EnterpriseSpecialsDocument, options);
      }
export function useEnterpriseSpecialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>(EnterpriseSpecialsDocument, options);
        }
export type EnterpriseSpecialsQueryHookResult = ReturnType<typeof useEnterpriseSpecialsQuery>;
export type EnterpriseSpecialsLazyQueryHookResult = ReturnType<typeof useEnterpriseSpecialsLazyQuery>;
export type EnterpriseSpecialsQueryResult = Apollo.QueryResult<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>;
export const FilteredSpecialsV2Document = gql`
    query FilteredSpecialsV2($specialsFilter: filteredSpecialsInput!, $translateSpecialsToV3: Boolean = false) {
  filteredSpecialsV2(
    filter: $specialsFilter
    translateSpecialsToV3: $translateSpecialsToV3
  ) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      menuDisplayName
      menuDisplayDescription
      bogoConditionLogicOperator
      menuDisplayImage
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      clicks
      createdAt
      createdBy
      description
      descriptionHtml
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      discountedPrices
      discountPrecedence
      discountStacking
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      dispensaryId
      displayRank
      emailSpecial
      endDay
      endStamp
      endTime
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      minorVersion
      name
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      platformType
      preOrderType
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      startDate
      startDay
      startStamp
      startTime
      subject
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useFilteredSpecialsV2Query__
 *
 * To run a query within a React component, call `useFilteredSpecialsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSpecialsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSpecialsV2Query({
 *   variables: {
 *      specialsFilter: // value for 'specialsFilter'
 *      translateSpecialsToV3: // value for 'translateSpecialsToV3'
 *   },
 * });
 */
export function useFilteredSpecialsV2Query(baseOptions: Apollo.QueryHookOptions<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>(FilteredSpecialsV2Document, options);
      }
export function useFilteredSpecialsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>(FilteredSpecialsV2Document, options);
        }
export type FilteredSpecialsV2QueryHookResult = ReturnType<typeof useFilteredSpecialsV2Query>;
export type FilteredSpecialsV2LazyQueryHookResult = ReturnType<typeof useFilteredSpecialsV2LazyQuery>;
export type FilteredSpecialsV2QueryResult = Apollo.QueryResult<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>;
export const FilteredSpecialsDocument = gql`
    query FilteredSpecials($specialsFilter: filteredSpecialsInput!, $includeEnterpriseSpecials: Boolean = false) {
  filteredSpecials(
    filter: $specialsFilter
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      menuDisplayName
      menuDisplayDescription
      bogoConditionLogicOperator
      menuDisplayImage
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          inventoryTags
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          inventoryTags
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        percentDiscount
        quantity
        strainIds
        subcategoryIds
        subcategoryNames
        requiresSingleSku
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        vendorIds
        weight
        weights
        weightOperator
      }
      clicks
      createdAt
      createdBy
      description
      descriptionHtml
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      discountedPrices
      discountPrecedence
      discountStacking
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      dispensaryId
      displayRank
      emailSpecial
      endDay
      endStamp
      endTime
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      minorVersion
      name
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      platformType
      preOrderType
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        inventoryTags
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      parentId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      startDate
      startDay
      startStamp
      startTime
      subject
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useFilteredSpecialsQuery__
 *
 * To run a query within a React component, call `useFilteredSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSpecialsQuery({
 *   variables: {
 *      specialsFilter: // value for 'specialsFilter'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useFilteredSpecialsQuery(baseOptions: Apollo.QueryHookOptions<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>(FilteredSpecialsDocument, options);
      }
export function useFilteredSpecialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>(FilteredSpecialsDocument, options);
        }
export type FilteredSpecialsQueryHookResult = ReturnType<typeof useFilteredSpecialsQuery>;
export type FilteredSpecialsLazyQueryHookResult = ReturnType<typeof useFilteredSpecialsLazyQuery>;
export type FilteredSpecialsQueryResult = Apollo.QueryResult<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>;
export const GetSpecialGamificationDocument = gql`
    query GetSpecialGamification($dispensaryId: String, $menuType: String, $specialIds: [String]) {
  getSpecialGamification(
    dispensaryId: $dispensaryId
    menuType: $menuType
    specialIds: $specialIds
  ) {
    gamificationThresholds {
      discountId
      satisfiers {
        thresholdType
        minimumThreshold
      }
    }
  }
}
    `;

/**
 * __useGetSpecialGamificationQuery__
 *
 * To run a query within a React component, call `useGetSpecialGamificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialGamificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialGamificationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *      specialIds: // value for 'specialIds'
 *   },
 * });
 */
export function useGetSpecialGamificationQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>(GetSpecialGamificationDocument, options);
      }
export function useGetSpecialGamificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>(GetSpecialGamificationDocument, options);
        }
export type GetSpecialGamificationQueryHookResult = ReturnType<typeof useGetSpecialGamificationQuery>;
export type GetSpecialGamificationLazyQueryHookResult = ReturnType<typeof useGetSpecialGamificationLazyQuery>;
export type GetSpecialGamificationQueryResult = Apollo.QueryResult<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>;
export const GetSpecialMenuCardsDocument = gql`
    query GetSpecialMenuCards($dispensaryId: ID!, $menuType: String!, $specialId: String, $platformType: String, $ecomUserId: String) {
  getSpecialMenuCards(
    dispensaryId: $dispensaryId
    menuType: $menuType
    specialId: $specialId
    platformType: $platformType
    ecomUserId: $ecomUserId
  ) {
    menuCards {
      _id
      applicableCategories {
        category
        subcategories
      }
      applicablePreOrderTypes
      displayRank
      endStamp
      isBundledDiscount
      isRestricted
      menuDisplayDescription
      menuDisplayImage
      menuDisplayName
      posDiscountId
      parentId
      recurringSchedule {
        startTime
        endTime
      }
      specialType
      startStamp
    }
  }
}
    `;

/**
 * __useGetSpecialMenuCardsQuery__
 *
 * To run a query within a React component, call `useGetSpecialMenuCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialMenuCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialMenuCardsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *      specialId: // value for 'specialId'
 *      platformType: // value for 'platformType'
 *      ecomUserId: // value for 'ecomUserId'
 *   },
 * });
 */
export function useGetSpecialMenuCardsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>(GetSpecialMenuCardsDocument, options);
      }
export function useGetSpecialMenuCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>(GetSpecialMenuCardsDocument, options);
        }
export type GetSpecialMenuCardsQueryHookResult = ReturnType<typeof useGetSpecialMenuCardsQuery>;
export type GetSpecialMenuCardsLazyQueryHookResult = ReturnType<typeof useGetSpecialMenuCardsLazyQuery>;
export type GetSpecialMenuCardsQueryResult = Apollo.QueryResult<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>;
export const GetStockImageDocument = gql`
    query getStockImage($category: String, $productName: String) {
  getStockImage(category: $category, productName: $productName) {
    url
  }
}
    `;

/**
 * __useGetStockImageQuery__
 *
 * To run a query within a React component, call `useGetStockImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockImageQuery({
 *   variables: {
 *      category: // value for 'category'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useGetStockImageQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>(GetStockImageDocument, options);
      }
export function useGetStockImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>(GetStockImageDocument, options);
        }
export type GetStockImageQueryHookResult = ReturnType<typeof useGetStockImageQuery>;
export type GetStockImageLazyQueryHookResult = ReturnType<typeof useGetStockImageLazyQuery>;
export type GetStockImageQueryResult = Apollo.QueryResult<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>;
export const CreateStrainV2Document = gql`
    mutation CreateStrainV2($input: strainInput!) {
  createStrainV2(strain: $input) {
    id
  }
}
    `;
export type GqlCreateStrainV2MutationFn = Apollo.MutationFunction<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>;

/**
 * __useCreateStrainV2Mutation__
 *
 * To run a mutation, you first call `useCreateStrainV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrainV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrainV2Mutation, { data, loading, error }] = useCreateStrainV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStrainV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>(CreateStrainV2Document, options);
      }
export type CreateStrainV2MutationHookResult = ReturnType<typeof useCreateStrainV2Mutation>;
export type CreateStrainV2MutationResult = Apollo.MutationResult<GqlCreateStrainV2Mutation>;
export type CreateStrainV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>;
export const DeleteStrainDocument = gql`
    mutation DeleteStrain($id: String!) {
  deleteStrain(id: $id) {
    id
  }
}
    `;
export type GqlDeleteStrainMutationFn = Apollo.MutationFunction<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>;

/**
 * __useDeleteStrainMutation__
 *
 * To run a mutation, you first call `useDeleteStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStrainMutation, { data, loading, error }] = useDeleteStrainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStrainMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>(DeleteStrainDocument, options);
      }
export type DeleteStrainMutationHookResult = ReturnType<typeof useDeleteStrainMutation>;
export type DeleteStrainMutationResult = Apollo.MutationResult<GqlDeleteStrainMutation>;
export type DeleteStrainMutationOptions = Apollo.BaseMutationOptions<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>;
export const UpdateStrainV2Document = gql`
    mutation UpdateStrainV2($id: String!, $input: strainInput!) {
  updateStrainV2(id: $id, strain: $input) {
    id
  }
}
    `;
export type GqlUpdateStrainV2MutationFn = Apollo.MutationFunction<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>;

/**
 * __useUpdateStrainV2Mutation__
 *
 * To run a mutation, you first call `useUpdateStrainV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStrainV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStrainV2Mutation, { data, loading, error }] = useUpdateStrainV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStrainV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>(UpdateStrainV2Document, options);
      }
export type UpdateStrainV2MutationHookResult = ReturnType<typeof useUpdateStrainV2Mutation>;
export type UpdateStrainV2MutationResult = Apollo.MutationResult<GqlUpdateStrainV2Mutation>;
export type UpdateStrainV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>;
export const FilteredStrainsDocument = gql`
    query FilteredStrains($filter: strainsFilterInput, $sort: strainsSortInput, $pagination: paginationInput) {
  filteredStrains(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    strains {
      description
      effects
      id
      imageUrl
      name
      potentialHealthBenefits
    }
  }
}
    `;

/**
 * __useFilteredStrainsQuery__
 *
 * To run a query within a React component, call `useFilteredStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredStrainsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredStrainsQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>(FilteredStrainsDocument, options);
      }
export function useFilteredStrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>(FilteredStrainsDocument, options);
        }
export type FilteredStrainsQueryHookResult = ReturnType<typeof useFilteredStrainsQuery>;
export type FilteredStrainsLazyQueryHookResult = ReturnType<typeof useFilteredStrainsLazyQuery>;
export type FilteredStrainsQueryResult = Apollo.QueryResult<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>;
export const GetStrainDocument = gql`
    query GetStrain($id: String!) {
  getStrain(id: $id) {
    aromas
    description
    effects
    id
    imageUrl
    labels
    name
    potentialHealthBenefits
    ratio
    terpenes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStrainQuery__
 *
 * To run a query within a React component, call `useGetStrainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStrainQuery(baseOptions: Apollo.QueryHookOptions<GqlGetStrainQuery, GqlGetStrainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetStrainQuery, GqlGetStrainQueryVariables>(GetStrainDocument, options);
      }
export function useGetStrainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetStrainQuery, GqlGetStrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetStrainQuery, GqlGetStrainQueryVariables>(GetStrainDocument, options);
        }
export type GetStrainQueryHookResult = ReturnType<typeof useGetStrainQuery>;
export type GetStrainLazyQueryHookResult = ReturnType<typeof useGetStrainLazyQuery>;
export type GetStrainQueryResult = Apollo.QueryResult<GqlGetStrainQuery, GqlGetStrainQueryVariables>;
export const GetCustomerSubscriptionsDocument = gql`
    query GetCustomerSubscriptions {
  getCustomerSubscriptions {
    dispensaryId
    dispensaryName
    emailOptIn
    emailSubscription
    id
  }
}
    `;

/**
 * __useGetCustomerSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetCustomerSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>(GetCustomerSubscriptionsDocument, options);
      }
export function useGetCustomerSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>(GetCustomerSubscriptionsDocument, options);
        }
export type GetCustomerSubscriptionsQueryHookResult = ReturnType<typeof useGetCustomerSubscriptionsQuery>;
export type GetCustomerSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetCustomerSubscriptionsLazyQuery>;
export type GetCustomerSubscriptionsQueryResult = Apollo.QueryResult<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>;
export const GetUnsubscribeDispensaryDocument = gql`
    query GetUnsubscribeDispensary($customerId: String!) {
  unsubscribeCustomerQuery(customerId: $customerId) {
    subscribed
    dispensary {
      name
      logoImage
    }
  }
}
    `;

/**
 * __useGetUnsubscribeDispensaryQuery__
 *
 * To run a query within a React component, call `useGetUnsubscribeDispensaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnsubscribeDispensaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnsubscribeDispensaryQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetUnsubscribeDispensaryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>(GetUnsubscribeDispensaryDocument, options);
      }
export function useGetUnsubscribeDispensaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>(GetUnsubscribeDispensaryDocument, options);
        }
export type GetUnsubscribeDispensaryQueryHookResult = ReturnType<typeof useGetUnsubscribeDispensaryQuery>;
export type GetUnsubscribeDispensaryLazyQueryHookResult = ReturnType<typeof useGetUnsubscribeDispensaryLazyQuery>;
export type GetUnsubscribeDispensaryQueryResult = Apollo.QueryResult<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>;
export const CreateTerpeneDocument = gql`
    mutation CreateTerpene($terpene: terpeneInput!) {
  createTerpeneV2(terpene: $terpene) {
    id
  }
}
    `;
export type GqlCreateTerpeneMutationFn = Apollo.MutationFunction<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>;

/**
 * __useCreateTerpeneMutation__
 *
 * To run a mutation, you first call `useCreateTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerpeneMutation, { data, loading, error }] = useCreateTerpeneMutation({
 *   variables: {
 *      terpene: // value for 'terpene'
 *   },
 * });
 */
export function useCreateTerpeneMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>(CreateTerpeneDocument, options);
      }
export type CreateTerpeneMutationHookResult = ReturnType<typeof useCreateTerpeneMutation>;
export type CreateTerpeneMutationResult = Apollo.MutationResult<GqlCreateTerpeneMutation>;
export type CreateTerpeneMutationOptions = Apollo.BaseMutationOptions<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>;
export const DeleteTerpeneDocument = gql`
    mutation DeleteTerpene($id: String!) {
  deleteTerpene(id: $id) {
    id
  }
}
    `;
export type GqlDeleteTerpeneMutationFn = Apollo.MutationFunction<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>;

/**
 * __useDeleteTerpeneMutation__
 *
 * To run a mutation, you first call `useDeleteTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTerpeneMutation, { data, loading, error }] = useDeleteTerpeneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTerpeneMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>(DeleteTerpeneDocument, options);
      }
export type DeleteTerpeneMutationHookResult = ReturnType<typeof useDeleteTerpeneMutation>;
export type DeleteTerpeneMutationResult = Apollo.MutationResult<GqlDeleteTerpeneMutation>;
export type DeleteTerpeneMutationOptions = Apollo.BaseMutationOptions<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>;
export const UpdateTerpeneDocument = gql`
    mutation UpdateTerpene($id: String!, $terpene: terpeneInput!) {
  updateTerpeneV2(id: $id, terpene: $terpene) {
    id
  }
}
    `;
export type GqlUpdateTerpeneMutationFn = Apollo.MutationFunction<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>;

/**
 * __useUpdateTerpeneMutation__
 *
 * To run a mutation, you first call `useUpdateTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerpeneMutation, { data, loading, error }] = useUpdateTerpeneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      terpene: // value for 'terpene'
 *   },
 * });
 */
export function useUpdateTerpeneMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>(UpdateTerpeneDocument, options);
      }
export type UpdateTerpeneMutationHookResult = ReturnType<typeof useUpdateTerpeneMutation>;
export type UpdateTerpeneMutationResult = Apollo.MutationResult<GqlUpdateTerpeneMutation>;
export type UpdateTerpeneMutationOptions = Apollo.BaseMutationOptions<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>;
export const FilteredTerpenesDocument = gql`
    query FilteredTerpenes($filter: terpenesFilter, $sort: terpenesSort) {
  filteredTerpenes(filter: $filter, sort: $sort) {
    ...TerpeneFragment
    strains {
      _id
    }
  }
}
    ${TerpeneFragmentFragmentDoc}`;

/**
 * __useFilteredTerpenesQuery__
 *
 * To run a query within a React component, call `useFilteredTerpenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTerpenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTerpenesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFilteredTerpenesQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>(FilteredTerpenesDocument, options);
      }
export function useFilteredTerpenesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>(FilteredTerpenesDocument, options);
        }
export type FilteredTerpenesQueryHookResult = ReturnType<typeof useFilteredTerpenesQuery>;
export type FilteredTerpenesLazyQueryHookResult = ReturnType<typeof useFilteredTerpenesLazyQuery>;
export type FilteredTerpenesQueryResult = Apollo.QueryResult<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>;
export const GetTerpeneDocument = gql`
    query GetTerpene($id: String!) {
  getTerpene(id: $id) {
    ...TerpeneFragment
  }
}
    ${TerpeneFragmentFragmentDoc}`;

/**
 * __useGetTerpeneQuery__
 *
 * To run a query within a React component, call `useGetTerpeneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerpeneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerpeneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTerpeneQuery(baseOptions: Apollo.QueryHookOptions<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>(GetTerpeneDocument, options);
      }
export function useGetTerpeneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>(GetTerpeneDocument, options);
        }
export type GetTerpeneQueryHookResult = ReturnType<typeof useGetTerpeneQuery>;
export type GetTerpeneLazyQueryHookResult = ReturnType<typeof useGetTerpeneLazyQuery>;
export type GetTerpeneQueryResult = Apollo.QueryResult<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>;
export const ConsumerSignupDocument = gql`
    mutation ConsumerSignup($input: consumerSignupInput!, $turnstileToken: String, $publicContextSessionId: String) {
  consumerSignup(
    input: $input
    turnstileToken: $turnstileToken
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlConsumerSignupMutationFn = Apollo.MutationFunction<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>;

/**
 * __useConsumerSignupMutation__
 *
 * To run a mutation, you first call `useConsumerSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSignupMutation, { data, loading, error }] = useConsumerSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      turnstileToken: // value for 'turnstileToken'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useConsumerSignupMutation(baseOptions?: Apollo.MutationHookOptions<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>(ConsumerSignupDocument, options);
      }
export type ConsumerSignupMutationHookResult = ReturnType<typeof useConsumerSignupMutation>;
export type ConsumerSignupMutationResult = Apollo.MutationResult<GqlConsumerSignupMutation>;
export type ConsumerSignupMutationOptions = Apollo.BaseMutationOptions<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: usersCreateInput!) {
  createUser(user: $input) {
    audioNotificationsOnNewArrivalsDisabled
    audioNotificationsOnNewOrdersDisabled
    chainID
    createdAt
    createdBy
    dispensaryId
    email
    fullName
    permissions {
      allLocations
      analytics
      billing
      customers
      dispensaryIds
      driver
      enterpriseAdmin
      menu
      menuReview
      orders
      promote
      settings
      superMenuReview
      users
    }
    phone
    roleAtDispensary
    type
  }
}
    `;
export type GqlCreateUserMutationFn = Apollo.MutationFunction<GqlCreateUserMutation, GqlCreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateUserMutation, GqlCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateUserMutation, GqlCreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<GqlCreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<GqlCreateUserMutation, GqlCreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($input: usersDeleteInput!) {
  deleteUser(user: $input) {
    fullName
  }
}
    `;
export type GqlDeleteUserMutationFn = Apollo.MutationFunction<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<GqlDeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>;
export const DevLoginAdminDocument = gql`
    mutation DevLoginAdmin($accountId: ID!) {
  devLoginAdmin(accountId: $accountId) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlDevLoginAdminMutationFn = Apollo.MutationFunction<GqlDevLoginAdminMutation, GqlDevLoginAdminMutationVariables>;

/**
 * __useDevLoginAdminMutation__
 *
 * To run a mutation, you first call `useDevLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devLoginAdminMutation, { data, loading, error }] = useDevLoginAdminMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDevLoginAdminMutation(baseOptions?: Apollo.MutationHookOptions<GqlDevLoginAdminMutation, GqlDevLoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDevLoginAdminMutation, GqlDevLoginAdminMutationVariables>(DevLoginAdminDocument, options);
      }
export type DevLoginAdminMutationHookResult = ReturnType<typeof useDevLoginAdminMutation>;
export type DevLoginAdminMutationResult = Apollo.MutationResult<GqlDevLoginAdminMutation>;
export type DevLoginAdminMutationOptions = Apollo.BaseMutationOptions<GqlDevLoginAdminMutation, GqlDevLoginAdminMutationVariables>;
export const DevLoginConsumerDocument = gql`
    mutation DevLoginConsumer($accountId: ID!) {
  devLoginConsumer(accountId: $accountId) {
    accessToken
    transferToken
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlDevLoginConsumerMutationFn = Apollo.MutationFunction<GqlDevLoginConsumerMutation, GqlDevLoginConsumerMutationVariables>;

/**
 * __useDevLoginConsumerMutation__
 *
 * To run a mutation, you first call `useDevLoginConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevLoginConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devLoginConsumerMutation, { data, loading, error }] = useDevLoginConsumerMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDevLoginConsumerMutation(baseOptions?: Apollo.MutationHookOptions<GqlDevLoginConsumerMutation, GqlDevLoginConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDevLoginConsumerMutation, GqlDevLoginConsumerMutationVariables>(DevLoginConsumerDocument, options);
      }
export type DevLoginConsumerMutationHookResult = ReturnType<typeof useDevLoginConsumerMutation>;
export type DevLoginConsumerMutationResult = Apollo.MutationResult<GqlDevLoginConsumerMutation>;
export type DevLoginConsumerMutationOptions = Apollo.BaseMutationOptions<GqlDevLoginConsumerMutation, GqlDevLoginConsumerMutationVariables>;
export const GenerateAdminTransferTokenDocument = gql`
    mutation GenerateAdminTransferToken {
  generateAdminTransferToken {
    transferToken
  }
}
    `;
export type GqlGenerateAdminTransferTokenMutationFn = Apollo.MutationFunction<GqlGenerateAdminTransferTokenMutation, GqlGenerateAdminTransferTokenMutationVariables>;

/**
 * __useGenerateAdminTransferTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAdminTransferTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAdminTransferTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAdminTransferTokenMutation, { data, loading, error }] = useGenerateAdminTransferTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateAdminTransferTokenMutation(baseOptions?: Apollo.MutationHookOptions<GqlGenerateAdminTransferTokenMutation, GqlGenerateAdminTransferTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlGenerateAdminTransferTokenMutation, GqlGenerateAdminTransferTokenMutationVariables>(GenerateAdminTransferTokenDocument, options);
      }
export type GenerateAdminTransferTokenMutationHookResult = ReturnType<typeof useGenerateAdminTransferTokenMutation>;
export type GenerateAdminTransferTokenMutationResult = Apollo.MutationResult<GqlGenerateAdminTransferTokenMutation>;
export type GenerateAdminTransferTokenMutationOptions = Apollo.BaseMutationOptions<GqlGenerateAdminTransferTokenMutation, GqlGenerateAdminTransferTokenMutationVariables>;
export const LoginAdminViaTokenDocument = gql`
    mutation LoginAdminViaToken($transferToken: String!) {
  loginAdminViaToken(transferToken: $transferToken) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlLoginAdminViaTokenMutationFn = Apollo.MutationFunction<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>;

/**
 * __useLoginAdminViaTokenMutation__
 *
 * To run a mutation, you first call `useLoginAdminViaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminViaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminViaTokenMutation, { data, loading, error }] = useLoginAdminViaTokenMutation({
 *   variables: {
 *      transferToken: // value for 'transferToken'
 *   },
 * });
 */
export function useLoginAdminViaTokenMutation(baseOptions?: Apollo.MutationHookOptions<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>(LoginAdminViaTokenDocument, options);
      }
export type LoginAdminViaTokenMutationHookResult = ReturnType<typeof useLoginAdminViaTokenMutation>;
export type LoginAdminViaTokenMutationResult = Apollo.MutationResult<GqlLoginAdminViaTokenMutation>;
export type LoginAdminViaTokenMutationOptions = Apollo.BaseMutationOptions<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>;
export const LoginAdminDocument = gql`
    mutation LoginAdmin($email: String!, $password: String!) {
  loginAdmin(email: $email, password: $password) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlLoginAdminMutationFn = Apollo.MutationFunction<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>;

/**
 * __useLoginAdminMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutation, { data, loading, error }] = useLoginAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutation(baseOptions?: Apollo.MutationHookOptions<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>(LoginAdminDocument, options);
      }
export type LoginAdminMutationHookResult = ReturnType<typeof useLoginAdminMutation>;
export type LoginAdminMutationResult = Apollo.MutationResult<GqlLoginAdminMutation>;
export type LoginAdminMutationOptions = Apollo.BaseMutationOptions<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>;
export const LoginConsumerDocument = gql`
    mutation LoginConsumer($email: String!, $password: String!, $turnstileToken: String, $dispensaryId: String, $publicContextSessionId: String) {
  loginConsumer(
    email: $email
    password: $password
    turnstileToken: $turnstileToken
    dispensaryId: $dispensaryId
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    transferToken
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlLoginConsumerMutationFn = Apollo.MutationFunction<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>;

/**
 * __useLoginConsumerMutation__
 *
 * To run a mutation, you first call `useLoginConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginConsumerMutation, { data, loading, error }] = useLoginConsumerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      turnstileToken: // value for 'turnstileToken'
 *      dispensaryId: // value for 'dispensaryId'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useLoginConsumerMutation(baseOptions?: Apollo.MutationHookOptions<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>(LoginConsumerDocument, options);
      }
export type LoginConsumerMutationHookResult = ReturnType<typeof useLoginConsumerMutation>;
export type LoginConsumerMutationResult = Apollo.MutationResult<GqlLoginConsumerMutation>;
export type LoginConsumerMutationOptions = Apollo.BaseMutationOptions<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    message
    success
  }
}
    `;
export type GqlLogoutMutationFn = Apollo.MutationFunction<GqlLogoutMutation, GqlLogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<GqlLogoutMutation, GqlLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLogoutMutation, GqlLogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<GqlLogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<GqlLogoutMutation, GqlLogoutMutationVariables>;
export const SendLoginCodeDocument = gql`
    mutation SendLoginCode($email: String!, $dispensaryId: String, $turnstileToken: String) {
  sendLoginCode(
    email: $email
    dispensaryId: $dispensaryId
    turnstileToken: $turnstileToken
  ) {
    success
    message
  }
}
    `;
export type GqlSendLoginCodeMutationFn = Apollo.MutationFunction<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>;

/**
 * __useSendLoginCodeMutation__
 *
 * To run a mutation, you first call `useSendLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLoginCodeMutation, { data, loading, error }] = useSendLoginCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      dispensaryId: // value for 'dispensaryId'
 *      turnstileToken: // value for 'turnstileToken'
 *   },
 * });
 */
export function useSendLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>(SendLoginCodeDocument, options);
      }
export type SendLoginCodeMutationHookResult = ReturnType<typeof useSendLoginCodeMutation>;
export type SendLoginCodeMutationResult = Apollo.MutationResult<GqlSendLoginCodeMutation>;
export type SendLoginCodeMutationOptions = Apollo.BaseMutationOptions<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: usersUpdateInput!) {
  updateUser(user: $input) {
    audioNotificationsOnNewArrivalsDisabled
    audioNotificationsOnNewOrdersDisabled
    chainID
    createdAt
    createdBy
    dispensaryId
    email
    fullName
    isWeeklyReportEnabled
    permissions {
      allLocations
      analytics
      billing
      customers
      dispensaryIds
      driver
      enterpriseAdmin
      menu
      menuReview
      orders
      promote
      settings
      superMenuReview
      users
    }
    phone
    roleAtDispensary
    type
  }
}
    `;
export type GqlUpdateUserMutationFn = Apollo.MutationFunction<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<GqlUpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>;
export const VerifyLoginCodeDocument = gql`
    mutation VerifyLoginCode($email: String!, $code: String!, $dispensaryId: String, $publicContextSessionId: String) {
  verifyLoginCode(
    email: $email
    code: $code
    dispensaryId: $dispensaryId
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    transferToken
    isNewUser
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlVerifyLoginCodeMutationFn = Apollo.MutationFunction<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>;

/**
 * __useVerifyLoginCodeMutation__
 *
 * To run a mutation, you first call `useVerifyLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyLoginCodeMutation, { data, loading, error }] = useVerifyLoginCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *      dispensaryId: // value for 'dispensaryId'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useVerifyLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>(VerifyLoginCodeDocument, options);
      }
export type VerifyLoginCodeMutationHookResult = ReturnType<typeof useVerifyLoginCodeMutation>;
export type VerifyLoginCodeMutationResult = Apollo.MutationResult<GqlVerifyLoginCodeMutation>;
export type VerifyLoginCodeMutationOptions = Apollo.BaseMutationOptions<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>;
export const DevAccountsDocument = gql`
    query DevAccounts {
  devAccounts {
    id
    email
    type
    label
  }
}
    `;

/**
 * __useDevAccountsQuery__
 *
 * To run a query within a React component, call `useDevAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GqlDevAccountsQuery, GqlDevAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDevAccountsQuery, GqlDevAccountsQueryVariables>(DevAccountsDocument, options);
      }
export function useDevAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDevAccountsQuery, GqlDevAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDevAccountsQuery, GqlDevAccountsQueryVariables>(DevAccountsDocument, options);
        }
export type DevAccountsQueryHookResult = ReturnType<typeof useDevAccountsQuery>;
export type DevAccountsLazyQueryHookResult = ReturnType<typeof useDevAccountsLazyQuery>;
export type DevAccountsQueryResult = Apollo.QueryResult<GqlDevAccountsQuery, GqlDevAccountsQueryVariables>;
export const MeConsumerDocument = gql`
    query MeConsumer {
  meConsumer {
    ...consumerUserFragment
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;

/**
 * __useMeConsumerQuery__
 *
 * To run a query within a React component, call `useMeConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeConsumerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeConsumerQuery(baseOptions?: Apollo.QueryHookOptions<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>(MeConsumerDocument, options);
      }
export function useMeConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>(MeConsumerDocument, options);
        }
export type MeConsumerQueryHookResult = ReturnType<typeof useMeConsumerQuery>;
export type MeConsumerLazyQueryHookResult = ReturnType<typeof useMeConsumerLazyQuery>;
export type MeConsumerQueryResult = Apollo.QueryResult<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>;
export const AnalyticsBrandsQueryDocument = gql`
    query AnalyticsBrandsQuery($input: BrandsSummaryInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getFilteredBrandSummaries(input: $input, pagination: $pagination, sort: $sort) {
    brands {
      brandId
      brandName
      numProducts
      percentSales
      totalSalesCents
      percentChange
      centsChange
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useAnalyticsBrandsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsBrandsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsBrandsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsBrandsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsBrandsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsBrandsQueryQuery, GqlAnalyticsBrandsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsBrandsQueryQuery, GqlAnalyticsBrandsQueryQueryVariables>(AnalyticsBrandsQueryDocument, options);
      }
export function useAnalyticsBrandsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsBrandsQueryQuery, GqlAnalyticsBrandsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsBrandsQueryQuery, GqlAnalyticsBrandsQueryQueryVariables>(AnalyticsBrandsQueryDocument, options);
        }
export type AnalyticsBrandsQueryQueryHookResult = ReturnType<typeof useAnalyticsBrandsQueryQuery>;
export type AnalyticsBrandsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsBrandsQueryLazyQuery>;
export type AnalyticsBrandsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsBrandsQueryQuery, GqlAnalyticsBrandsQueryQueryVariables>;
export const AnalyticsExportBrandsMutationDocument = gql`
    mutation AnalyticsExportBrandsMutation($input: BrandsSummaryInput!, $sort: AnalyticsSort) {
  exportFilteredBrandsSummaries(input: $input, sort: $sort) {
    success
  }
}
    `;
export type GqlAnalyticsExportBrandsMutationMutationFn = Apollo.MutationFunction<GqlAnalyticsExportBrandsMutationMutation, GqlAnalyticsExportBrandsMutationMutationVariables>;

/**
 * __useAnalyticsExportBrandsMutationMutation__
 *
 * To run a mutation, you first call `useAnalyticsExportBrandsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExportBrandsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsExportBrandsMutationMutation, { data, loading, error }] = useAnalyticsExportBrandsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsExportBrandsMutationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAnalyticsExportBrandsMutationMutation, GqlAnalyticsExportBrandsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAnalyticsExportBrandsMutationMutation, GqlAnalyticsExportBrandsMutationMutationVariables>(AnalyticsExportBrandsMutationDocument, options);
      }
export type AnalyticsExportBrandsMutationMutationHookResult = ReturnType<typeof useAnalyticsExportBrandsMutationMutation>;
export type AnalyticsExportBrandsMutationMutationResult = Apollo.MutationResult<GqlAnalyticsExportBrandsMutationMutation>;
export type AnalyticsExportBrandsMutationMutationOptions = Apollo.BaseMutationOptions<GqlAnalyticsExportBrandsMutationMutation, GqlAnalyticsExportBrandsMutationMutationVariables>;
export const GetTrendingBrandsQueryDocument = gql`
    query GetTrendingBrandsQuery($input: BrandsSummaryInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getTrendingBrands(input: $input, pagination: $pagination, sort: $sort) {
    trending {
      brandId
      brandName
      percentChangeFromLastPeriod
      dollarHistoryThisPeriod {
        date
        totalSales
      }
    }
  }
}
    `;

/**
 * __useGetTrendingBrandsQueryQuery__
 *
 * To run a query within a React component, call `useGetTrendingBrandsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingBrandsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingBrandsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTrendingBrandsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetTrendingBrandsQueryQuery, GqlGetTrendingBrandsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetTrendingBrandsQueryQuery, GqlGetTrendingBrandsQueryQueryVariables>(GetTrendingBrandsQueryDocument, options);
      }
export function useGetTrendingBrandsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetTrendingBrandsQueryQuery, GqlGetTrendingBrandsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetTrendingBrandsQueryQuery, GqlGetTrendingBrandsQueryQueryVariables>(GetTrendingBrandsQueryDocument, options);
        }
export type GetTrendingBrandsQueryQueryHookResult = ReturnType<typeof useGetTrendingBrandsQueryQuery>;
export type GetTrendingBrandsQueryLazyQueryHookResult = ReturnType<typeof useGetTrendingBrandsQueryLazyQuery>;
export type GetTrendingBrandsQueryQueryResult = Apollo.QueryResult<GqlGetTrendingBrandsQueryQuery, GqlGetTrendingBrandsQueryQueryVariables>;
export const GetDeliveryHeatmapOrdersDocument = gql`
    query GetDeliveryHeatmapOrders($input: getOrdersInput!) {
  getOrders(input: $input) {
    queryInfo {
      totalCount
    }
    orders {
      _id
      location {
        lat
        lng
      }
      deliveryInfo {
        location {
          lat
          lng
        }
      }
    }
  }
}
    `;

/**
 * __useGetDeliveryHeatmapOrdersQuery__
 *
 * To run a query within a React component, call `useGetDeliveryHeatmapOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryHeatmapOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryHeatmapOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDeliveryHeatmapOrdersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDeliveryHeatmapOrdersQuery, GqlGetDeliveryHeatmapOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDeliveryHeatmapOrdersQuery, GqlGetDeliveryHeatmapOrdersQueryVariables>(GetDeliveryHeatmapOrdersDocument, options);
      }
export function useGetDeliveryHeatmapOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDeliveryHeatmapOrdersQuery, GqlGetDeliveryHeatmapOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDeliveryHeatmapOrdersQuery, GqlGetDeliveryHeatmapOrdersQueryVariables>(GetDeliveryHeatmapOrdersDocument, options);
        }
export type GetDeliveryHeatmapOrdersQueryHookResult = ReturnType<typeof useGetDeliveryHeatmapOrdersQuery>;
export type GetDeliveryHeatmapOrdersLazyQueryHookResult = ReturnType<typeof useGetDeliveryHeatmapOrdersLazyQuery>;
export type GetDeliveryHeatmapOrdersQueryResult = Apollo.QueryResult<GqlGetDeliveryHeatmapOrdersQuery, GqlGetDeliveryHeatmapOrdersQueryVariables>;
export const AnalyticsAbandonedCartsQueryDocument = gql`
    query AnalyticsAbandonedCartsQuery($input: AnalyticsInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getEcommerceAbandonedCarts(input: $input, pagination: $pagination, sort: $sort) {
    carts {
      id
      createdAt
      firstName
      lastName
      email
      phone
      valueInCents
      products {
        name
        quantity
      }
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useAnalyticsAbandonedCartsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsAbandonedCartsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsAbandonedCartsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsAbandonedCartsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsAbandonedCartsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsAbandonedCartsQueryQuery, GqlAnalyticsAbandonedCartsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsAbandonedCartsQueryQuery, GqlAnalyticsAbandonedCartsQueryQueryVariables>(AnalyticsAbandonedCartsQueryDocument, options);
      }
export function useAnalyticsAbandonedCartsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsAbandonedCartsQueryQuery, GqlAnalyticsAbandonedCartsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsAbandonedCartsQueryQuery, GqlAnalyticsAbandonedCartsQueryQueryVariables>(AnalyticsAbandonedCartsQueryDocument, options);
        }
export type AnalyticsAbandonedCartsQueryQueryHookResult = ReturnType<typeof useAnalyticsAbandonedCartsQueryQuery>;
export type AnalyticsAbandonedCartsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsAbandonedCartsQueryLazyQuery>;
export type AnalyticsAbandonedCartsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsAbandonedCartsQueryQuery, GqlAnalyticsAbandonedCartsQueryQueryVariables>;
export const AnalyticsExportCartsMutationDocument = gql`
    mutation AnalyticsExportCartsMutation($input: AnalyticsInput!, $sort: AnalyticsSort) {
  exportFilteredCartsSummaries(input: $input, sort: $sort) {
    success
  }
}
    `;
export type GqlAnalyticsExportCartsMutationMutationFn = Apollo.MutationFunction<GqlAnalyticsExportCartsMutationMutation, GqlAnalyticsExportCartsMutationMutationVariables>;

/**
 * __useAnalyticsExportCartsMutationMutation__
 *
 * To run a mutation, you first call `useAnalyticsExportCartsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExportCartsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsExportCartsMutationMutation, { data, loading, error }] = useAnalyticsExportCartsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsExportCartsMutationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAnalyticsExportCartsMutationMutation, GqlAnalyticsExportCartsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAnalyticsExportCartsMutationMutation, GqlAnalyticsExportCartsMutationMutationVariables>(AnalyticsExportCartsMutationDocument, options);
      }
export type AnalyticsExportCartsMutationMutationHookResult = ReturnType<typeof useAnalyticsExportCartsMutationMutation>;
export type AnalyticsExportCartsMutationMutationResult = Apollo.MutationResult<GqlAnalyticsExportCartsMutationMutation>;
export type AnalyticsExportCartsMutationMutationOptions = Apollo.BaseMutationOptions<GqlAnalyticsExportCartsMutationMutation, GqlAnalyticsExportCartsMutationMutationVariables>;
export const AnalyticsMarketingCampaignsQueryDocument = gql`
    query AnalyticsMarketingCampaignsQuery($input: AnalyticsInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getMarketingCampaigns(input: $input, pagination: $pagination, sort: $sort) {
    campaigns {
      utmCampaign
      utmSource
      utmMedium
      conversionPercentage
      conversionPercentageUnitChange
      averageOrderValue
      averageOrderValueChangePercentage
      totalSales
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useAnalyticsMarketingCampaignsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsMarketingCampaignsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMarketingCampaignsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMarketingCampaignsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsMarketingCampaignsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsMarketingCampaignsQueryQuery, GqlAnalyticsMarketingCampaignsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsMarketingCampaignsQueryQuery, GqlAnalyticsMarketingCampaignsQueryQueryVariables>(AnalyticsMarketingCampaignsQueryDocument, options);
      }
export function useAnalyticsMarketingCampaignsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsMarketingCampaignsQueryQuery, GqlAnalyticsMarketingCampaignsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsMarketingCampaignsQueryQuery, GqlAnalyticsMarketingCampaignsQueryQueryVariables>(AnalyticsMarketingCampaignsQueryDocument, options);
        }
export type AnalyticsMarketingCampaignsQueryQueryHookResult = ReturnType<typeof useAnalyticsMarketingCampaignsQueryQuery>;
export type AnalyticsMarketingCampaignsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsMarketingCampaignsQueryLazyQuery>;
export type AnalyticsMarketingCampaignsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsMarketingCampaignsQueryQuery, GqlAnalyticsMarketingCampaignsQueryQueryVariables>;
export const AnalyticsMarketingCouponQueryDocument = gql`
    query AnalyticsMarketingCouponQuery($input: AnalyticsInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getMarketingCoupons(input: $input, pagination: $pagination, sort: $sort) {
    coupons {
      couponId
      couponName
      revenue
      prevTotalSales
      currentUsage
      prevUsage
      averageOrderValue
      averageOrderValueChangePercentage
      averageUsageChangePercentage
      discount
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useAnalyticsMarketingCouponQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsMarketingCouponQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMarketingCouponQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMarketingCouponQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsMarketingCouponQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsMarketingCouponQueryQuery, GqlAnalyticsMarketingCouponQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsMarketingCouponQueryQuery, GqlAnalyticsMarketingCouponQueryQueryVariables>(AnalyticsMarketingCouponQueryDocument, options);
      }
export function useAnalyticsMarketingCouponQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsMarketingCouponQueryQuery, GqlAnalyticsMarketingCouponQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsMarketingCouponQueryQuery, GqlAnalyticsMarketingCouponQueryQueryVariables>(AnalyticsMarketingCouponQueryDocument, options);
        }
export type AnalyticsMarketingCouponQueryQueryHookResult = ReturnType<typeof useAnalyticsMarketingCouponQueryQuery>;
export type AnalyticsMarketingCouponQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsMarketingCouponQueryLazyQuery>;
export type AnalyticsMarketingCouponQueryQueryResult = Apollo.QueryResult<GqlAnalyticsMarketingCouponQueryQuery, GqlAnalyticsMarketingCouponQueryQueryVariables>;
export const AnalyticsMarketingDataPointsQueryDocument = gql`
    query AnalyticsMarketingDataPointsQuery($input: AnalyticsInput!) {
  getMarketingDataPoints(input: $input) {
    totalCampaignsCents
    totalSpecialsCents
    totalCouponsCents
    marketingRevenue {
      date
      specialsCents
      couponsCents
    }
  }
}
    `;

/**
 * __useAnalyticsMarketingDataPointsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsMarketingDataPointsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMarketingDataPointsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMarketingDataPointsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsMarketingDataPointsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsMarketingDataPointsQueryQuery, GqlAnalyticsMarketingDataPointsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsMarketingDataPointsQueryQuery, GqlAnalyticsMarketingDataPointsQueryQueryVariables>(AnalyticsMarketingDataPointsQueryDocument, options);
      }
export function useAnalyticsMarketingDataPointsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsMarketingDataPointsQueryQuery, GqlAnalyticsMarketingDataPointsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsMarketingDataPointsQueryQuery, GqlAnalyticsMarketingDataPointsQueryQueryVariables>(AnalyticsMarketingDataPointsQueryDocument, options);
        }
export type AnalyticsMarketingDataPointsQueryQueryHookResult = ReturnType<typeof useAnalyticsMarketingDataPointsQueryQuery>;
export type AnalyticsMarketingDataPointsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsMarketingDataPointsQueryLazyQuery>;
export type AnalyticsMarketingDataPointsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsMarketingDataPointsQueryQuery, GqlAnalyticsMarketingDataPointsQueryQueryVariables>;
export const AnalyticsExportCampaignsMutationDocument = gql`
    mutation AnalyticsExportCampaignsMutation($input: AnalyticsInput!, $sort: AnalyticsSort) {
  exportFilteredCampaignsSummaries(input: $input, sort: $sort) {
    success
  }
}
    `;
export type GqlAnalyticsExportCampaignsMutationMutationFn = Apollo.MutationFunction<GqlAnalyticsExportCampaignsMutationMutation, GqlAnalyticsExportCampaignsMutationMutationVariables>;

/**
 * __useAnalyticsExportCampaignsMutationMutation__
 *
 * To run a mutation, you first call `useAnalyticsExportCampaignsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExportCampaignsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsExportCampaignsMutationMutation, { data, loading, error }] = useAnalyticsExportCampaignsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsExportCampaignsMutationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAnalyticsExportCampaignsMutationMutation, GqlAnalyticsExportCampaignsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAnalyticsExportCampaignsMutationMutation, GqlAnalyticsExportCampaignsMutationMutationVariables>(AnalyticsExportCampaignsMutationDocument, options);
      }
export type AnalyticsExportCampaignsMutationMutationHookResult = ReturnType<typeof useAnalyticsExportCampaignsMutationMutation>;
export type AnalyticsExportCampaignsMutationMutationResult = Apollo.MutationResult<GqlAnalyticsExportCampaignsMutationMutation>;
export type AnalyticsExportCampaignsMutationMutationOptions = Apollo.BaseMutationOptions<GqlAnalyticsExportCampaignsMutationMutation, GqlAnalyticsExportCampaignsMutationMutationVariables>;
export const AnalyticsExportCouponsMutationDocument = gql`
    mutation AnalyticsExportCouponsMutation($input: AnalyticsInput!, $sort: AnalyticsSort) {
  exportCouponsSummaries(input: $input, sort: $sort) {
    success
  }
}
    `;
export type GqlAnalyticsExportCouponsMutationMutationFn = Apollo.MutationFunction<GqlAnalyticsExportCouponsMutationMutation, GqlAnalyticsExportCouponsMutationMutationVariables>;

/**
 * __useAnalyticsExportCouponsMutationMutation__
 *
 * To run a mutation, you first call `useAnalyticsExportCouponsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExportCouponsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsExportCouponsMutationMutation, { data, loading, error }] = useAnalyticsExportCouponsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsExportCouponsMutationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAnalyticsExportCouponsMutationMutation, GqlAnalyticsExportCouponsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAnalyticsExportCouponsMutationMutation, GqlAnalyticsExportCouponsMutationMutationVariables>(AnalyticsExportCouponsMutationDocument, options);
      }
export type AnalyticsExportCouponsMutationMutationHookResult = ReturnType<typeof useAnalyticsExportCouponsMutationMutation>;
export type AnalyticsExportCouponsMutationMutationResult = Apollo.MutationResult<GqlAnalyticsExportCouponsMutationMutation>;
export type AnalyticsExportCouponsMutationMutationOptions = Apollo.BaseMutationOptions<GqlAnalyticsExportCouponsMutationMutation, GqlAnalyticsExportCouponsMutationMutationVariables>;
export const AnalyticsExportSpecialsMutationDocument = gql`
    mutation AnalyticsExportSpecialsMutation($input: AnalyticsInput!, $sort: AnalyticsSort) {
  exportSpecialsSummaries(input: $input, sort: $sort) {
    success
  }
}
    `;
export type GqlAnalyticsExportSpecialsMutationMutationFn = Apollo.MutationFunction<GqlAnalyticsExportSpecialsMutationMutation, GqlAnalyticsExportSpecialsMutationMutationVariables>;

/**
 * __useAnalyticsExportSpecialsMutationMutation__
 *
 * To run a mutation, you first call `useAnalyticsExportSpecialsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExportSpecialsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsExportSpecialsMutationMutation, { data, loading, error }] = useAnalyticsExportSpecialsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsExportSpecialsMutationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAnalyticsExportSpecialsMutationMutation, GqlAnalyticsExportSpecialsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAnalyticsExportSpecialsMutationMutation, GqlAnalyticsExportSpecialsMutationMutationVariables>(AnalyticsExportSpecialsMutationDocument, options);
      }
export type AnalyticsExportSpecialsMutationMutationHookResult = ReturnType<typeof useAnalyticsExportSpecialsMutationMutation>;
export type AnalyticsExportSpecialsMutationMutationResult = Apollo.MutationResult<GqlAnalyticsExportSpecialsMutationMutation>;
export type AnalyticsExportSpecialsMutationMutationOptions = Apollo.BaseMutationOptions<GqlAnalyticsExportSpecialsMutationMutation, GqlAnalyticsExportSpecialsMutationMutationVariables>;
export const AnalyticsMarketingSpecialsQueryDocument = gql`
    query AnalyticsMarketingSpecialsQuery($input: AnalyticsInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getMarketingSpecials(input: $input, pagination: $pagination, sort: $sort) {
    specials {
      specialId
      dispensaryId
      name
      type
      emailSent
      clickThroughPercentage
      conversionPercentage
      conversionChangePercentage
      averageOrderValue
      averageOrderValueChangePercentage
      totalSales
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useAnalyticsMarketingSpecialsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsMarketingSpecialsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMarketingSpecialsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMarketingSpecialsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsMarketingSpecialsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsMarketingSpecialsQueryQuery, GqlAnalyticsMarketingSpecialsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsMarketingSpecialsQueryQuery, GqlAnalyticsMarketingSpecialsQueryQueryVariables>(AnalyticsMarketingSpecialsQueryDocument, options);
      }
export function useAnalyticsMarketingSpecialsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsMarketingSpecialsQueryQuery, GqlAnalyticsMarketingSpecialsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsMarketingSpecialsQueryQuery, GqlAnalyticsMarketingSpecialsQueryQueryVariables>(AnalyticsMarketingSpecialsQueryDocument, options);
        }
export type AnalyticsMarketingSpecialsQueryQueryHookResult = ReturnType<typeof useAnalyticsMarketingSpecialsQueryQuery>;
export type AnalyticsMarketingSpecialsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsMarketingSpecialsQueryLazyQuery>;
export type AnalyticsMarketingSpecialsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsMarketingSpecialsQueryQuery, GqlAnalyticsMarketingSpecialsQueryQueryVariables>;
export const AnalyticsMobileAppMostVisitedPagesQueryDocument = gql`
    query AnalyticsMobileAppMostVisitedPagesQuery($input: AnalyticsInput!, $search: String) {
  getMobileAppAnalyticsMostVisitedPages(input: $input, search: $search) {
    pages {
      pagePath
      users
      views
    }
  }
}
    `;

/**
 * __useAnalyticsMobileAppMostVisitedPagesQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsMobileAppMostVisitedPagesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMobileAppMostVisitedPagesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMobileAppMostVisitedPagesQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAnalyticsMobileAppMostVisitedPagesQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsMobileAppMostVisitedPagesQueryQuery, GqlAnalyticsMobileAppMostVisitedPagesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsMobileAppMostVisitedPagesQueryQuery, GqlAnalyticsMobileAppMostVisitedPagesQueryQueryVariables>(AnalyticsMobileAppMostVisitedPagesQueryDocument, options);
      }
export function useAnalyticsMobileAppMostVisitedPagesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsMobileAppMostVisitedPagesQueryQuery, GqlAnalyticsMobileAppMostVisitedPagesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsMobileAppMostVisitedPagesQueryQuery, GqlAnalyticsMobileAppMostVisitedPagesQueryQueryVariables>(AnalyticsMobileAppMostVisitedPagesQueryDocument, options);
        }
export type AnalyticsMobileAppMostVisitedPagesQueryQueryHookResult = ReturnType<typeof useAnalyticsMobileAppMostVisitedPagesQueryQuery>;
export type AnalyticsMobileAppMostVisitedPagesQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsMobileAppMostVisitedPagesQueryLazyQuery>;
export type AnalyticsMobileAppMostVisitedPagesQueryQueryResult = Apollo.QueryResult<GqlAnalyticsMobileAppMostVisitedPagesQueryQuery, GqlAnalyticsMobileAppMostVisitedPagesQueryQueryVariables>;
export const AnalyticsMobileAppPageViewsQueryDocument = gql`
    query AnalyticsMobileAppPageViewsQuery($input: AnalyticsInput!) {
  getMobileAppAnalyticsPageViews(input: $input) {
    daily {
      date
      pageViews
      sessions
      totalDownloads
      users
    }
  }
}
    `;

/**
 * __useAnalyticsMobileAppPageViewsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsMobileAppPageViewsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMobileAppPageViewsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMobileAppPageViewsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsMobileAppPageViewsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsMobileAppPageViewsQueryQuery, GqlAnalyticsMobileAppPageViewsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsMobileAppPageViewsQueryQuery, GqlAnalyticsMobileAppPageViewsQueryQueryVariables>(AnalyticsMobileAppPageViewsQueryDocument, options);
      }
export function useAnalyticsMobileAppPageViewsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsMobileAppPageViewsQueryQuery, GqlAnalyticsMobileAppPageViewsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsMobileAppPageViewsQueryQuery, GqlAnalyticsMobileAppPageViewsQueryQueryVariables>(AnalyticsMobileAppPageViewsQueryDocument, options);
        }
export type AnalyticsMobileAppPageViewsQueryQueryHookResult = ReturnType<typeof useAnalyticsMobileAppPageViewsQueryQuery>;
export type AnalyticsMobileAppPageViewsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsMobileAppPageViewsQueryLazyQuery>;
export type AnalyticsMobileAppPageViewsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsMobileAppPageViewsQueryQuery, GqlAnalyticsMobileAppPageViewsQueryQueryVariables>;
export const AnalyticsExportProductsMutationDocument = gql`
    mutation AnalyticsExportProductsMutation($input: ProductsSummaryInput!, $sort: AnalyticsSort) {
  exportFilteredProductSummaries(input: $input, sort: $sort) {
    success
  }
}
    `;
export type GqlAnalyticsExportProductsMutationMutationFn = Apollo.MutationFunction<GqlAnalyticsExportProductsMutationMutation, GqlAnalyticsExportProductsMutationMutationVariables>;

/**
 * __useAnalyticsExportProductsMutationMutation__
 *
 * To run a mutation, you first call `useAnalyticsExportProductsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExportProductsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsExportProductsMutationMutation, { data, loading, error }] = useAnalyticsExportProductsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsExportProductsMutationMutation(baseOptions?: Apollo.MutationHookOptions<GqlAnalyticsExportProductsMutationMutation, GqlAnalyticsExportProductsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAnalyticsExportProductsMutationMutation, GqlAnalyticsExportProductsMutationMutationVariables>(AnalyticsExportProductsMutationDocument, options);
      }
export type AnalyticsExportProductsMutationMutationHookResult = ReturnType<typeof useAnalyticsExportProductsMutationMutation>;
export type AnalyticsExportProductsMutationMutationResult = Apollo.MutationResult<GqlAnalyticsExportProductsMutationMutation>;
export type AnalyticsExportProductsMutationMutationOptions = Apollo.BaseMutationOptions<GqlAnalyticsExportProductsMutationMutation, GqlAnalyticsExportProductsMutationMutationVariables>;
export const AnalyticsProductsQueryDocument = gql`
    query AnalyticsProductsQuery($input: ProductsSummaryInput!, $pagination: AnalyticsPagination, $sort: AnalyticsSort) {
  getFilteredProductSummaries(input: $input, pagination: $pagination, sort: $sort) {
    products {
      productId
      productName
      brandId
      brandName
      category
      strainType
      sales
      percentChange
      dollarChange
      dispensaryId
      numSold
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useAnalyticsProductsQueryQuery__
 *
 * To run a query within a React component, call `useAnalyticsProductsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsProductsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsProductsQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsProductsQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlAnalyticsProductsQueryQuery, GqlAnalyticsProductsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAnalyticsProductsQueryQuery, GqlAnalyticsProductsQueryQueryVariables>(AnalyticsProductsQueryDocument, options);
      }
export function useAnalyticsProductsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAnalyticsProductsQueryQuery, GqlAnalyticsProductsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAnalyticsProductsQueryQuery, GqlAnalyticsProductsQueryQueryVariables>(AnalyticsProductsQueryDocument, options);
        }
export type AnalyticsProductsQueryQueryHookResult = ReturnType<typeof useAnalyticsProductsQueryQuery>;
export type AnalyticsProductsQueryLazyQueryHookResult = ReturnType<typeof useAnalyticsProductsQueryLazyQuery>;
export type AnalyticsProductsQueryQueryResult = Apollo.QueryResult<GqlAnalyticsProductsQueryQuery, GqlAnalyticsProductsQueryQueryVariables>;
export const SalesOrdersQueryDocument = gql`
    query SalesOrdersQuery($input: SharedSalesInput!) {
  salesOrdersQuery(input: $input) {
    totalOrders
    totalSales
    revenueChange
    percentChange
    ordersByDate {
      date
      totalOrders
      totalSales
    }
  }
}
    `;

/**
 * __useSalesOrdersQueryQuery__
 *
 * To run a query within a React component, call `useSalesOrdersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrdersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrdersQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesOrdersQueryQuery(baseOptions: Apollo.QueryHookOptions<GqlSalesOrdersQueryQuery, GqlSalesOrdersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSalesOrdersQueryQuery, GqlSalesOrdersQueryQueryVariables>(SalesOrdersQueryDocument, options);
      }
export function useSalesOrdersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSalesOrdersQueryQuery, GqlSalesOrdersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSalesOrdersQueryQuery, GqlSalesOrdersQueryQueryVariables>(SalesOrdersQueryDocument, options);
        }
export type SalesOrdersQueryQueryHookResult = ReturnType<typeof useSalesOrdersQueryQuery>;
export type SalesOrdersQueryLazyQueryHookResult = ReturnType<typeof useSalesOrdersQueryLazyQuery>;
export type SalesOrdersQueryQueryResult = Apollo.QueryResult<GqlSalesOrdersQueryQuery, GqlSalesOrdersQueryQueryVariables>;
export const GetProductSalesByCategoryDocument = gql`
    query GetProductSalesByCategory($input: SharedSalesInput!) {
  getProductSalesByCategory(input: $input) {
    categoryOptions {
      key
      label
      value
    }
    lineItems {
      price
      productType
      categoryOption
      totalSales
      percentOfTotal
    }
    totalSales
  }
}
    `;

/**
 * __useGetProductSalesByCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductSalesByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSalesByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSalesByCategoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductSalesByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetProductSalesByCategoryQuery, GqlGetProductSalesByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetProductSalesByCategoryQuery, GqlGetProductSalesByCategoryQueryVariables>(GetProductSalesByCategoryDocument, options);
      }
export function useGetProductSalesByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetProductSalesByCategoryQuery, GqlGetProductSalesByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetProductSalesByCategoryQuery, GqlGetProductSalesByCategoryQueryVariables>(GetProductSalesByCategoryDocument, options);
        }
export type GetProductSalesByCategoryQueryHookResult = ReturnType<typeof useGetProductSalesByCategoryQuery>;
export type GetProductSalesByCategoryLazyQueryHookResult = ReturnType<typeof useGetProductSalesByCategoryLazyQuery>;
export type GetProductSalesByCategoryQueryResult = Apollo.QueryResult<GqlGetProductSalesByCategoryQuery, GqlGetProductSalesByCategoryQueryVariables>;
export const GetTopProductDocument = gql`
    query GetTopProduct($input: SharedSalesInput!) {
  getTopProduct(input: $input) {
    product {
      brand {
        id
        name
        imageUrl
      }
      brandId
      brandLogo
      Image
      images {
        _id
        url
        origin
        active
      }
      Name
      stockImage
      strainType
      type
    }
    total
  }
}
    `;

/**
 * __useGetTopProductQuery__
 *
 * To run a query within a React component, call `useGetTopProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTopProductQuery(baseOptions: Apollo.QueryHookOptions<GqlGetTopProductQuery, GqlGetTopProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetTopProductQuery, GqlGetTopProductQueryVariables>(GetTopProductDocument, options);
      }
export function useGetTopProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetTopProductQuery, GqlGetTopProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetTopProductQuery, GqlGetTopProductQueryVariables>(GetTopProductDocument, options);
        }
export type GetTopProductQueryHookResult = ReturnType<typeof useGetTopProductQuery>;
export type GetTopProductLazyQueryHookResult = ReturnType<typeof useGetTopProductLazyQuery>;
export type GetTopProductQueryResult = Apollo.QueryResult<GqlGetTopProductQuery, GqlGetTopProductQueryVariables>;
export const CreateDispensaryBrandDocument = gql`
    mutation CreateDispensaryBrand($name: String!, $dispensaryId: String!) {
  createBrandV2(brand: {name: $name, dispensaryId: $dispensaryId}) {
    id
    name
  }
}
    `;
export type GqlCreateDispensaryBrandMutationFn = Apollo.MutationFunction<GqlCreateDispensaryBrandMutation, GqlCreateDispensaryBrandMutationVariables>;

/**
 * __useCreateDispensaryBrandMutation__
 *
 * To run a mutation, you first call `useCreateDispensaryBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispensaryBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispensaryBrandMutation, { data, loading, error }] = useCreateDispensaryBrandMutation({
 *   variables: {
 *      name: // value for 'name'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCreateDispensaryBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDispensaryBrandMutation, GqlCreateDispensaryBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDispensaryBrandMutation, GqlCreateDispensaryBrandMutationVariables>(CreateDispensaryBrandDocument, options);
      }
export type CreateDispensaryBrandMutationHookResult = ReturnType<typeof useCreateDispensaryBrandMutation>;
export type CreateDispensaryBrandMutationResult = Apollo.MutationResult<GqlCreateDispensaryBrandMutation>;
export type CreateDispensaryBrandMutationOptions = Apollo.BaseMutationOptions<GqlCreateDispensaryBrandMutation, GqlCreateDispensaryBrandMutationVariables>;
export const CopyableSettingLocationsDocument = gql`
    query CopyableSettingLocations($enterpriseId: ID!, $dispensaryId: ID!, $settingPath: String!) {
  copyableSettingLocations(
    enterpriseId: $enterpriseId
    dispensaryId: $dispensaryId
    settingPath: $settingPath
  ) {
    settingPath
    source {
      dispensaryId
      name
      isSource
      isSet
      valueJson
      comparisonStatus
      canSync
      unavailableReason
    }
    locations {
      dispensaryId
      name
      isSource
      isSet
      valueJson
      comparisonStatus
      canSync
      unavailableReason
    }
  }
}
    `;

/**
 * __useCopyableSettingLocationsQuery__
 *
 * To run a query within a React component, call `useCopyableSettingLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyableSettingLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyableSettingLocationsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      dispensaryId: // value for 'dispensaryId'
 *      settingPath: // value for 'settingPath'
 *   },
 * });
 */
export function useCopyableSettingLocationsQuery(baseOptions: Apollo.QueryHookOptions<GqlCopyableSettingLocationsQuery, GqlCopyableSettingLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCopyableSettingLocationsQuery, GqlCopyableSettingLocationsQueryVariables>(CopyableSettingLocationsDocument, options);
      }
export function useCopyableSettingLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCopyableSettingLocationsQuery, GqlCopyableSettingLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCopyableSettingLocationsQuery, GqlCopyableSettingLocationsQueryVariables>(CopyableSettingLocationsDocument, options);
        }
export type CopyableSettingLocationsQueryHookResult = ReturnType<typeof useCopyableSettingLocationsQuery>;
export type CopyableSettingLocationsLazyQueryHookResult = ReturnType<typeof useCopyableSettingLocationsLazyQuery>;
export type CopyableSettingLocationsQueryResult = Apollo.QueryResult<GqlCopyableSettingLocationsQuery, GqlCopyableSettingLocationsQueryVariables>;
export const CopyableSettingsDocument = gql`
    query CopyableSettings {
  copyableSettings {
    allowedPrefixes
    allowedPaths
    keyedArrays
    deniedPaths
    superAdminOnlyPrefixes
  }
}
    `;

/**
 * __useCopyableSettingsQuery__
 *
 * To run a query within a React component, call `useCopyableSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyableSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyableSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCopyableSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GqlCopyableSettingsQuery, GqlCopyableSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCopyableSettingsQuery, GqlCopyableSettingsQueryVariables>(CopyableSettingsDocument, options);
      }
export function useCopyableSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCopyableSettingsQuery, GqlCopyableSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCopyableSettingsQuery, GqlCopyableSettingsQueryVariables>(CopyableSettingsDocument, options);
        }
export type CopyableSettingsQueryHookResult = ReturnType<typeof useCopyableSettingsQuery>;
export type CopyableSettingsLazyQueryHookResult = ReturnType<typeof useCopyableSettingsLazyQuery>;
export type CopyableSettingsQueryResult = Apollo.QueryResult<GqlCopyableSettingsQuery, GqlCopyableSettingsQueryVariables>;
export const BrandsForDropdownByIdsDocument = gql`
    query BrandsForDropdownByIds($ids: [String]!) {
  getBrandsV2(ids: $ids) {
    ...brandFragmentForDropdown
  }
}
    ${BrandFragmentForDropdownFragmentDoc}`;

/**
 * __useBrandsForDropdownByIdsQuery__
 *
 * To run a query within a React component, call `useBrandsForDropdownByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsForDropdownByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsForDropdownByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBrandsForDropdownByIdsQuery(baseOptions: Apollo.QueryHookOptions<GqlBrandsForDropdownByIdsQuery, GqlBrandsForDropdownByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlBrandsForDropdownByIdsQuery, GqlBrandsForDropdownByIdsQueryVariables>(BrandsForDropdownByIdsDocument, options);
      }
export function useBrandsForDropdownByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBrandsForDropdownByIdsQuery, GqlBrandsForDropdownByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlBrandsForDropdownByIdsQuery, GqlBrandsForDropdownByIdsQueryVariables>(BrandsForDropdownByIdsDocument, options);
        }
export type BrandsForDropdownByIdsQueryHookResult = ReturnType<typeof useBrandsForDropdownByIdsQuery>;
export type BrandsForDropdownByIdsLazyQueryHookResult = ReturnType<typeof useBrandsForDropdownByIdsLazyQuery>;
export type BrandsForDropdownByIdsQueryResult = Apollo.QueryResult<GqlBrandsForDropdownByIdsQuery, GqlBrandsForDropdownByIdsQueryVariables>;
export const GetMenuFiltersDocument = gql`
    query GetMenuFilters($dispensaryId: String!) {
  menuFiltersV2(dispensaryId: $dispensaryId) {
    brands {
      id
      name
    }
    strainTypes
    weights
    effects
    categoriesSubcategories {
      category
      subcategories
    }
  }
}
    `;

/**
 * __useGetMenuFiltersQuery__
 *
 * To run a query within a React component, call `useGetMenuFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuFiltersQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMenuFiltersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMenuFiltersQuery, GqlGetMenuFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMenuFiltersQuery, GqlGetMenuFiltersQueryVariables>(GetMenuFiltersDocument, options);
      }
export function useGetMenuFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMenuFiltersQuery, GqlGetMenuFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMenuFiltersQuery, GqlGetMenuFiltersQueryVariables>(GetMenuFiltersDocument, options);
        }
export type GetMenuFiltersQueryHookResult = ReturnType<typeof useGetMenuFiltersQuery>;
export type GetMenuFiltersLazyQueryHookResult = ReturnType<typeof useGetMenuFiltersLazyQuery>;
export type GetMenuFiltersQueryResult = Apollo.QueryResult<GqlGetMenuFiltersQuery, GqlGetMenuFiltersQueryVariables>;
export const GetCollectionsProductsDocument = gql`
    query GetCollectionsProducts($filter: productsFilterInput!) {
  filteredProducts(filter: $filter) {
    products {
      Name
      id
      type
      subcategory
      Status
    }
  }
}
    `;

/**
 * __useGetCollectionsProductsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsProductsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCollectionsProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionsProductsQuery, GqlGetCollectionsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionsProductsQuery, GqlGetCollectionsProductsQueryVariables>(GetCollectionsProductsDocument, options);
      }
export function useGetCollectionsProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionsProductsQuery, GqlGetCollectionsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionsProductsQuery, GqlGetCollectionsProductsQueryVariables>(GetCollectionsProductsDocument, options);
        }
export type GetCollectionsProductsQueryHookResult = ReturnType<typeof useGetCollectionsProductsQuery>;
export type GetCollectionsProductsLazyQueryHookResult = ReturnType<typeof useGetCollectionsProductsLazyQuery>;
export type GetCollectionsProductsQueryResult = Apollo.QueryResult<GqlGetCollectionsProductsQuery, GqlGetCollectionsProductsQueryVariables>;
export const GetCollectionsDocument = gql`
    query GetCollections($dispensaryId: String!, $customCategory: Boolean, $activeOnly: Boolean) {
  getCollections(
    dispensaryId: $dispensaryId
    customCategory: $customCategory
    activeOnly: $activeOnly
  ) {
    id
    slug
    dispensaryId
    title
    description
    allConditions
    productCount
    position
    image
    cardImage
    cardBadgeColor
    cardBadgeEnabled
    cardBadgeTitle
    cardDisplayName
    navigationEnabled
    navigationTitle
    channels
    conditions {
      id
      condition
      itemKey
      itemValue
      productCollectionId
    }
    customCategory
    isOutlet
    outletTimerEnabled
    outletTimerMessage
    enabled
    schedule {
      ...ScheduleFields
    }
    isActive
    isAccessibleToCurrentUser
    isExclusive
    onSaleOnly
    matchAllAudienceConditions
    audienceConditions {
      segmentId
    }
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      customCategory: // value for 'customCategory'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>(GetCollectionsDocument, options);
      }
export function useGetCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>;
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>;
export type GetCollectionsQueryResult = Apollo.QueryResult<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>;
export const GetCollectionDocument = gql`
    query GetCollection($dispensaryId: String!, $collectionId: String!, $customCategory: Boolean) {
  getCollection(
    dispensaryId: $dispensaryId
    collectionId: $collectionId
    customCategory: $customCategory
  ) {
    id
    slug
    dispensaryId
    title
    description
    allConditions
    productCount
    position
    image
    cardImage
    cardBadgeColor
    cardBadgeEnabled
    cardBadgeTitle
    cardDisplayName
    navigationEnabled
    navigationTitle
    channels
    conditions {
      id
      condition
      itemKey
      itemValue
      productCollectionId
    }
    customCategory
    isOutlet
    outletTimerEnabled
    outletTimerMessage
    enabled
    schedule {
      ...ScheduleFields
    }
    isAccessibleToCurrentUser
    isExclusive
    onSaleOnly
    matchAllAudienceConditions
    audienceConditions {
      segmentId
    }
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      collectionId: // value for 'collectionId'
 *      customCategory: // value for 'customCategory'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionQueryResult = Apollo.QueryResult<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>;
export const GetCollectionsNavigationDocument = gql`
    query GetCollectionsNavigation($dispensaryId: String!, $enabled: Boolean, $customCategory: Boolean, $activeOnly: Boolean) {
  getCollectionsNavigation(
    dispensaryId: $dispensaryId
    enabled: $enabled
    customCategory: $customCategory
    activeOnly: $activeOnly
  ) {
    id
    customCategory
    enabled
    schedule {
      ...ScheduleFields
    }
    isActive
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useGetCollectionsNavigationQuery__
 *
 * To run a query within a React component, call `useGetCollectionsNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsNavigationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      enabled: // value for 'enabled'
 *      customCategory: // value for 'customCategory'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetCollectionsNavigationQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>(GetCollectionsNavigationDocument, options);
      }
export function useGetCollectionsNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>(GetCollectionsNavigationDocument, options);
        }
export type GetCollectionsNavigationQueryHookResult = ReturnType<typeof useGetCollectionsNavigationQuery>;
export type GetCollectionsNavigationLazyQueryHookResult = ReturnType<typeof useGetCollectionsNavigationLazyQuery>;
export type GetCollectionsNavigationQueryResult = Apollo.QueryResult<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>;
export const CreateCollectionDocument = gql`
    mutation CreateCollection($dispensaryId: String!, $input: UpdateCollectionInput!) {
  createCollection(dispensaryId: $dispensaryId, input: $input) {
    id
    slug
    dispensaryId
    title
    description
    allConditions
    productCount
    image
    cardImage
    cardBadgeColor
    cardBadgeEnabled
    cardBadgeTitle
    cardDisplayName
    navigationEnabled
    navigationTitle
    channels
    conditions {
      id
      condition
      itemKey
      itemValue
      productCollectionId
    }
    customCategory
    isOutlet
    outletTimerEnabled
    outletTimerMessage
    enabled
    schedule {
      ...ScheduleFields
    }
    isActive
    isAccessibleToCurrentUser
    isExclusive
    onSaleOnly
    matchAllAudienceConditions
    audienceConditions {
      segmentId
    }
  }
}
    ${ScheduleFieldsFragmentDoc}`;
export type GqlCreateCollectionMutationFn = Apollo.MutationFunction<GqlCreateCollectionMutation, GqlCreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCollectionMutation, GqlCreateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCollectionMutation, GqlCreateCollectionMutationVariables>(CreateCollectionDocument, options);
      }
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>;
export type CreateCollectionMutationResult = Apollo.MutationResult<GqlCreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<GqlCreateCollectionMutation, GqlCreateCollectionMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation UpdateCollection($collectionId: String!, $input: UpdateCollectionInput!) {
  updateCollection(collectionId: $collectionId, input: $input) {
    id
    slug
    dispensaryId
    title
    description
    allConditions
    productCount
    image
    cardImage
    cardBadgeColor
    cardBadgeEnabled
    cardBadgeTitle
    cardDisplayName
    navigationEnabled
    navigationTitle
    channels
    conditions {
      id
      condition
      itemKey
      itemValue
      productCollectionId
    }
    customCategory
    isOutlet
    outletTimerEnabled
    outletTimerMessage
    enabled
    schedule {
      ...ScheduleFields
    }
    isActive
    isAccessibleToCurrentUser
    isExclusive
    onSaleOnly
    matchAllAudienceConditions
    audienceConditions {
      segmentId
    }
  }
}
    ${ScheduleFieldsFragmentDoc}`;
export type GqlUpdateCollectionMutationFn = Apollo.MutationFunction<GqlUpdateCollectionMutation, GqlUpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCollectionMutation, GqlUpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCollectionMutation, GqlUpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
      }
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<GqlUpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCollectionMutation, GqlUpdateCollectionMutationVariables>;
export const UpdateCollectionPositionsDocument = gql`
    mutation UpdateCollectionPositions($dispensaryId: String!, $input: UpdateCollectionPositionsInput!) {
  updateCollectionPositions(dispensaryId: $dispensaryId, input: $input) {
    id
    position
  }
}
    `;
export type GqlUpdateCollectionPositionsMutationFn = Apollo.MutationFunction<GqlUpdateCollectionPositionsMutation, GqlUpdateCollectionPositionsMutationVariables>;

/**
 * __useUpdateCollectionPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionPositionsMutation, { data, loading, error }] = useUpdateCollectionPositionsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionPositionsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCollectionPositionsMutation, GqlUpdateCollectionPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCollectionPositionsMutation, GqlUpdateCollectionPositionsMutationVariables>(UpdateCollectionPositionsDocument, options);
      }
export type UpdateCollectionPositionsMutationHookResult = ReturnType<typeof useUpdateCollectionPositionsMutation>;
export type UpdateCollectionPositionsMutationResult = Apollo.MutationResult<GqlUpdateCollectionPositionsMutation>;
export type UpdateCollectionPositionsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCollectionPositionsMutation, GqlUpdateCollectionPositionsMutationVariables>;
export const DeleteCollectionDocument = gql`
    mutation DeleteCollection($collectionId: String!) {
  deleteCollection(collectionId: $collectionId) {
    success
    message
  }
}
    `;
export type GqlDeleteCollectionMutationFn = Apollo.MutationFunction<GqlDeleteCollectionMutation, GqlDeleteCollectionMutationVariables>;

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useDeleteCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteCollectionMutation, GqlDeleteCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteCollectionMutation, GqlDeleteCollectionMutationVariables>(DeleteCollectionDocument, options);
      }
export type DeleteCollectionMutationHookResult = ReturnType<typeof useDeleteCollectionMutation>;
export type DeleteCollectionMutationResult = Apollo.MutationResult<GqlDeleteCollectionMutation>;
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<GqlDeleteCollectionMutation, GqlDeleteCollectionMutationVariables>;
export const GetCollectionProductCountDocument = gql`
    query GetCollectionProductCount($dispensaryId: String!, $input: GetCollectionProductCountInput!) {
  getCollectionProductCount(dispensaryId: $dispensaryId, input: $input) {
    id
    productCount
  }
}
    `;

/**
 * __useGetCollectionProductCountQuery__
 *
 * To run a query within a React component, call `useGetCollectionProductCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionProductCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionProductCountQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollectionProductCountQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionProductCountQuery, GqlGetCollectionProductCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionProductCountQuery, GqlGetCollectionProductCountQueryVariables>(GetCollectionProductCountDocument, options);
      }
export function useGetCollectionProductCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionProductCountQuery, GqlGetCollectionProductCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionProductCountQuery, GqlGetCollectionProductCountQueryVariables>(GetCollectionProductCountDocument, options);
        }
export type GetCollectionProductCountQueryHookResult = ReturnType<typeof useGetCollectionProductCountQuery>;
export type GetCollectionProductCountLazyQueryHookResult = ReturnType<typeof useGetCollectionProductCountLazyQuery>;
export type GetCollectionProductCountQueryResult = Apollo.QueryResult<GqlGetCollectionProductCountQuery, GqlGetCollectionProductCountQueryVariables>;
export const AvailableSegmentsDocument = gql`
    query AvailableSegments($dispensaryId: String!) {
  availableSegments(dispensaryId: $dispensaryId) {
    id
    name
    audienceCount
  }
}
    `;

/**
 * __useAvailableSegmentsQuery__
 *
 * To run a query within a React component, call `useAvailableSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableSegmentsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useAvailableSegmentsQuery(baseOptions: Apollo.QueryHookOptions<GqlAvailableSegmentsQuery, GqlAvailableSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAvailableSegmentsQuery, GqlAvailableSegmentsQueryVariables>(AvailableSegmentsDocument, options);
      }
export function useAvailableSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAvailableSegmentsQuery, GqlAvailableSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAvailableSegmentsQuery, GqlAvailableSegmentsQueryVariables>(AvailableSegmentsDocument, options);
        }
export type AvailableSegmentsQueryHookResult = ReturnType<typeof useAvailableSegmentsQuery>;
export type AvailableSegmentsLazyQueryHookResult = ReturnType<typeof useAvailableSegmentsLazyQuery>;
export type AvailableSegmentsQueryResult = Apollo.QueryResult<GqlAvailableSegmentsQuery, GqlAvailableSegmentsQueryVariables>;
export const GetCarouselProductsDocument = gql`
    query GetCarouselProducts($productsFilter: productsFilterInput!) {
  filteredProducts(filter: $productsFilter, page: 0, perPage: 15, useCache: true) {
    products {
      ...consumerBaseProductFragment
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetCarouselProductsQuery__
 *
 * To run a query within a React component, call `useGetCarouselProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarouselProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarouselProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *   },
 * });
 */
export function useGetCarouselProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCarouselProductsQuery, GqlGetCarouselProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCarouselProductsQuery, GqlGetCarouselProductsQueryVariables>(GetCarouselProductsDocument, options);
      }
export function useGetCarouselProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCarouselProductsQuery, GqlGetCarouselProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCarouselProductsQuery, GqlGetCarouselProductsQueryVariables>(GetCarouselProductsDocument, options);
        }
export type GetCarouselProductsQueryHookResult = ReturnType<typeof useGetCarouselProductsQuery>;
export type GetCarouselProductsLazyQueryHookResult = ReturnType<typeof useGetCarouselProductsLazyQuery>;
export type GetCarouselProductsQueryResult = Apollo.QueryResult<GqlGetCarouselProductsQuery, GqlGetCarouselProductsQueryVariables>;
export const GetCustomNavigationDocument = gql`
    query GetCustomNavigation($dispensaryId: String!) {
  getCustomNavigation(dispensaryId: $dispensaryId) {
    dispensaryId
    enabled
    id
    label
    items {
      connectedId
      id
      label
      navigationType
      openInNewTab
      position
      url
      items {
        connectedId
        id
        label
        navigationType
        openInNewTab
        position
        url
        items {
          connectedId
          id
          label
          navigationType
          openInNewTab
          position
          url
          items {
            connectedId
            id
            label
            navigationType
            openInNewTab
            position
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomNavigationQuery__
 *
 * To run a query within a React component, call `useGetCustomNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomNavigationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCustomNavigationQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCustomNavigationQuery, GqlGetCustomNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCustomNavigationQuery, GqlGetCustomNavigationQueryVariables>(GetCustomNavigationDocument, options);
      }
export function useGetCustomNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCustomNavigationQuery, GqlGetCustomNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCustomNavigationQuery, GqlGetCustomNavigationQueryVariables>(GetCustomNavigationDocument, options);
        }
export type GetCustomNavigationQueryHookResult = ReturnType<typeof useGetCustomNavigationQuery>;
export type GetCustomNavigationLazyQueryHookResult = ReturnType<typeof useGetCustomNavigationLazyQuery>;
export type GetCustomNavigationQueryResult = Apollo.QueryResult<GqlGetCustomNavigationQuery, GqlGetCustomNavigationQueryVariables>;
export const SaveCustomNavigationDocument = gql`
    mutation SaveCustomNavigation($input: SaveCustomNavigationInput!) {
  saveCustomNavigation(input: $input) {
    dispensaryId
    id
    label
    items {
      connectedId
      id
      label
      navigationType
      openInNewTab
      position
      url
      items {
        connectedId
        id
        label
        navigationType
        openInNewTab
        position
        url
        items {
          connectedId
          id
          label
          navigationType
          openInNewTab
          position
          url
          items {
            connectedId
            id
            label
            navigationType
            openInNewTab
            position
            url
          }
        }
      }
    }
  }
}
    `;
export type GqlSaveCustomNavigationMutationFn = Apollo.MutationFunction<GqlSaveCustomNavigationMutation, GqlSaveCustomNavigationMutationVariables>;

/**
 * __useSaveCustomNavigationMutation__
 *
 * To run a mutation, you first call `useSaveCustomNavigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomNavigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomNavigationMutation, { data, loading, error }] = useSaveCustomNavigationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCustomNavigationMutation(baseOptions?: Apollo.MutationHookOptions<GqlSaveCustomNavigationMutation, GqlSaveCustomNavigationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSaveCustomNavigationMutation, GqlSaveCustomNavigationMutationVariables>(SaveCustomNavigationDocument, options);
      }
export type SaveCustomNavigationMutationHookResult = ReturnType<typeof useSaveCustomNavigationMutation>;
export type SaveCustomNavigationMutationResult = Apollo.MutationResult<GqlSaveCustomNavigationMutation>;
export type SaveCustomNavigationMutationOptions = Apollo.BaseMutationOptions<GqlSaveCustomNavigationMutation, GqlSaveCustomNavigationMutationVariables>;
export const GetMenuCustomizationDocument = gql`
    query GetMenuCustomization($dispensaryId: String!) {
  filteredDispensaries(filter: {cNameOrID: $dispensaryId}) {
    webCustomizationSettings {
      colorSettings {
        navBarColor
        linkColor
      }
      fontSettings {
        family
      }
    }
    webCustomizationSettingsV2 {
      colors {
        navBar
        buttonsLinks
        staffPickTag
        discountTag
        productCardButton
        strainTypes {
          cbd
          cbg
          default
          highCBD
          hybrid
          indica
          indicaHybrid
          sativa
          sativaHybrid
          seed
          thc
        }
      }
      fonts {
        heading
        body
      }
      mobile {
        backgroundColor
        backgroundFlair
        buttonFlair
        dividerFlair
        loadingFlair
        headerBackgroundColor
        headerImageUrl
        headerImageUrlV2
        bottomBarActiveColor
        bottomBarBackgroundColor
        bottomBarInactiveColor
        bottomBarStyle
        headerNavigationStyle
        showTabLabels
        titleFlair
        titleFlairColor
        tabDisplay {
          showCart
          showConcierge
          showLoyalty
          showPay
          showSpecials
        }
        tabLabels {
          account
          cart
          concierge
          loyalty
          more
          pay
          shop
          specials
        }
      }
      textTransforms {
        buttons
        links
        tags
      }
      radius {
        default
      }
      categories {
        type
        style
        mobileDisplay
        items {
          category
          image
          collectionId
          cardImage
          cardDisplayName
          isOutlet
        }
      }
      productCards {
        defaultViewLarge
        defaultViewSmall
        fullWidthImages
        mobileAppDisplayOptions {
          backgroundColor
          brandColor
          buttonDisplay
          potencyColor
          potencyDisplay
          priceColor
          productNameColor
          showCollection
          showDiscountNames
          showEffects
          showPotencyDetails
          showProductWeight
          showStaffPick
          showStrainType
          strainTypeDisplay
          strikethroughPriceColor
          weightColor
        }
        showProductWeight
        textAlignment
        disableProductCardImageCycling
      }
      concierge {
        accentColorHex
        canvasColorHex
      }
    }
    menuBannerHtml
    menuBannerColor
    menuBannerTextBannerCollapsed
    ageVerificationBannerHtml
    ageVerificationBannerColor
    embedSettings {
      disclaimerTextHtml
    }
    categoryPhotos {
      src
      category
    }
    location {
      state
    }
    imageBanners {
      _id
      image
      mobileImage
      alt
      link
      openInNewTab
      bannerType
      connectedId
      connectedType
      platforms {
        enabled
        link
        openInNewTab
        type
      }
      position
      schedule {
        id
        startDate
        endDate
        timeRanges {
          dayOfWeek
          startTime
          endTime
        }
      }
      isActive
    }
    remoteExtensions {
      theme {
        extensionData {
          key
          value
        }
        manifestUrl
        modulePath
        scope
      }
    }
  }
  getCollections(
    dispensaryId: $dispensaryId
    customCategory: true
    activeOnly: true
  ) {
    id
    title
    image
    cardImage
    cardDisplayName
    customCategory
    isOutlet
  }
}
    `;

/**
 * __useGetMenuCustomizationQuery__
 *
 * To run a query within a React component, call `useGetMenuCustomizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCustomizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCustomizationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMenuCustomizationQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMenuCustomizationQuery, GqlGetMenuCustomizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMenuCustomizationQuery, GqlGetMenuCustomizationQueryVariables>(GetMenuCustomizationDocument, options);
      }
export function useGetMenuCustomizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMenuCustomizationQuery, GqlGetMenuCustomizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMenuCustomizationQuery, GqlGetMenuCustomizationQueryVariables>(GetMenuCustomizationDocument, options);
        }
export type GetMenuCustomizationQueryHookResult = ReturnType<typeof useGetMenuCustomizationQuery>;
export type GetMenuCustomizationLazyQueryHookResult = ReturnType<typeof useGetMenuCustomizationLazyQuery>;
export type GetMenuCustomizationQueryResult = Apollo.QueryResult<GqlGetMenuCustomizationQuery, GqlGetMenuCustomizationQueryVariables>;
export const UpdateMenuCustomizationDocument = gql`
    mutation UpdateMenuCustomization($dispensaryId: String!, $menuBannerHtml: String, $menuBannerColor: String, $menuBannerTextBannerCollapsed: Boolean, $ageVerificationBannerHtml: String, $ageVerificationBannerColor: String) {
  dispensaryUpdate(
    input: {id: $dispensaryId, profile: {menuBannerHtml: $menuBannerHtml, menuBannerColor: $menuBannerColor, menuBannerTextBannerCollapsed: $menuBannerTextBannerCollapsed, ageVerificationBannerHtml: $ageVerificationBannerHtml, ageVerificationBannerColor: $ageVerificationBannerColor}}
  ) {
    success
    message
  }
}
    `;
export type GqlUpdateMenuCustomizationMutationFn = Apollo.MutationFunction<GqlUpdateMenuCustomizationMutation, GqlUpdateMenuCustomizationMutationVariables>;

/**
 * __useUpdateMenuCustomizationMutation__
 *
 * To run a mutation, you first call `useUpdateMenuCustomizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuCustomizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuCustomizationMutation, { data, loading, error }] = useUpdateMenuCustomizationMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuBannerHtml: // value for 'menuBannerHtml'
 *      menuBannerColor: // value for 'menuBannerColor'
 *      menuBannerTextBannerCollapsed: // value for 'menuBannerTextBannerCollapsed'
 *      ageVerificationBannerHtml: // value for 'ageVerificationBannerHtml'
 *      ageVerificationBannerColor: // value for 'ageVerificationBannerColor'
 *   },
 * });
 */
export function useUpdateMenuCustomizationMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateMenuCustomizationMutation, GqlUpdateMenuCustomizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateMenuCustomizationMutation, GqlUpdateMenuCustomizationMutationVariables>(UpdateMenuCustomizationDocument, options);
      }
export type UpdateMenuCustomizationMutationHookResult = ReturnType<typeof useUpdateMenuCustomizationMutation>;
export type UpdateMenuCustomizationMutationResult = Apollo.MutationResult<GqlUpdateMenuCustomizationMutation>;
export type UpdateMenuCustomizationMutationOptions = Apollo.BaseMutationOptions<GqlUpdateMenuCustomizationMutation, GqlUpdateMenuCustomizationMutationVariables>;
export const UpdateWebCustomizationSettingsDocument = gql`
    mutation UpdateWebCustomizationSettings($dispensaryId: String!, $input: UpdateWebCustomizationSettingsInput!) {
  updateWebCustomizationSettings(dispensaryId: $dispensaryId, input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdateWebCustomizationSettingsMutationFn = Apollo.MutationFunction<GqlUpdateWebCustomizationSettingsMutation, GqlUpdateWebCustomizationSettingsMutationVariables>;

/**
 * __useUpdateWebCustomizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWebCustomizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebCustomizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebCustomizationSettingsMutation, { data, loading, error }] = useUpdateWebCustomizationSettingsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebCustomizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateWebCustomizationSettingsMutation, GqlUpdateWebCustomizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateWebCustomizationSettingsMutation, GqlUpdateWebCustomizationSettingsMutationVariables>(UpdateWebCustomizationSettingsDocument, options);
      }
export type UpdateWebCustomizationSettingsMutationHookResult = ReturnType<typeof useUpdateWebCustomizationSettingsMutation>;
export type UpdateWebCustomizationSettingsMutationResult = Apollo.MutationResult<GqlUpdateWebCustomizationSettingsMutation>;
export type UpdateWebCustomizationSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateWebCustomizationSettingsMutation, GqlUpdateWebCustomizationSettingsMutationVariables>;
export const UpdateWebCustomizationSettingsV2Document = gql`
    mutation UpdateWebCustomizationSettingsV2($dispensaryId: String!, $input: UpdateWebCustomizationSettingsV2Input!) {
  updateWebCustomizationSettingsV2(dispensaryId: $dispensaryId, input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdateWebCustomizationSettingsV2MutationFn = Apollo.MutationFunction<GqlUpdateWebCustomizationSettingsV2Mutation, GqlUpdateWebCustomizationSettingsV2MutationVariables>;

/**
 * __useUpdateWebCustomizationSettingsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateWebCustomizationSettingsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebCustomizationSettingsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebCustomizationSettingsV2Mutation, { data, loading, error }] = useUpdateWebCustomizationSettingsV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebCustomizationSettingsV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateWebCustomizationSettingsV2Mutation, GqlUpdateWebCustomizationSettingsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateWebCustomizationSettingsV2Mutation, GqlUpdateWebCustomizationSettingsV2MutationVariables>(UpdateWebCustomizationSettingsV2Document, options);
      }
export type UpdateWebCustomizationSettingsV2MutationHookResult = ReturnType<typeof useUpdateWebCustomizationSettingsV2Mutation>;
export type UpdateWebCustomizationSettingsV2MutationResult = Apollo.MutationResult<GqlUpdateWebCustomizationSettingsV2Mutation>;
export type UpdateWebCustomizationSettingsV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateWebCustomizationSettingsV2Mutation, GqlUpdateWebCustomizationSettingsV2MutationVariables>;
export const UpdateEnterpriseWebCustomizationSettingsV2Document = gql`
    mutation UpdateEnterpriseWebCustomizationSettingsV2($enterpriseId: String!, $input: UpdateWebCustomizationSettingsV2Input!, $dispensaryIds: [String!]) {
  updateEnterpriseWebCustomizationSettingsV2(
    enterpriseId: $enterpriseId
    input: $input
    dispensaryIds: $dispensaryIds
  ) {
    success
    message
  }
}
    `;
export type GqlUpdateEnterpriseWebCustomizationSettingsV2MutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseWebCustomizationSettingsV2Mutation, GqlUpdateEnterpriseWebCustomizationSettingsV2MutationVariables>;

/**
 * __useUpdateEnterpriseWebCustomizationSettingsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseWebCustomizationSettingsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseWebCustomizationSettingsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseWebCustomizationSettingsV2Mutation, { data, loading, error }] = useUpdateEnterpriseWebCustomizationSettingsV2Mutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *      dispensaryIds: // value for 'dispensaryIds'
 *   },
 * });
 */
export function useUpdateEnterpriseWebCustomizationSettingsV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseWebCustomizationSettingsV2Mutation, GqlUpdateEnterpriseWebCustomizationSettingsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseWebCustomizationSettingsV2Mutation, GqlUpdateEnterpriseWebCustomizationSettingsV2MutationVariables>(UpdateEnterpriseWebCustomizationSettingsV2Document, options);
      }
export type UpdateEnterpriseWebCustomizationSettingsV2MutationHookResult = ReturnType<typeof useUpdateEnterpriseWebCustomizationSettingsV2Mutation>;
export type UpdateEnterpriseWebCustomizationSettingsV2MutationResult = Apollo.MutationResult<GqlUpdateEnterpriseWebCustomizationSettingsV2Mutation>;
export type UpdateEnterpriseWebCustomizationSettingsV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseWebCustomizationSettingsV2Mutation, GqlUpdateEnterpriseWebCustomizationSettingsV2MutationVariables>;
export const UpdateRemoteExtensionsDocument = gql`
    mutation UpdateRemoteExtensions($dispensaryId: String!, $enterpriseId: String, $input: UpdateRemoteExtensionsInput!) {
  updateRemoteExtensions(
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    input: $input
  ) {
    success
    message
  }
}
    `;
export type GqlUpdateRemoteExtensionsMutationFn = Apollo.MutationFunction<GqlUpdateRemoteExtensionsMutation, GqlUpdateRemoteExtensionsMutationVariables>;

/**
 * __useUpdateRemoteExtensionsMutation__
 *
 * To run a mutation, you first call `useUpdateRemoteExtensionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemoteExtensionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemoteExtensionsMutation, { data, loading, error }] = useUpdateRemoteExtensionsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRemoteExtensionsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateRemoteExtensionsMutation, GqlUpdateRemoteExtensionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateRemoteExtensionsMutation, GqlUpdateRemoteExtensionsMutationVariables>(UpdateRemoteExtensionsDocument, options);
      }
export type UpdateRemoteExtensionsMutationHookResult = ReturnType<typeof useUpdateRemoteExtensionsMutation>;
export type UpdateRemoteExtensionsMutationResult = Apollo.MutationResult<GqlUpdateRemoteExtensionsMutation>;
export type UpdateRemoteExtensionsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateRemoteExtensionsMutation, GqlUpdateRemoteExtensionsMutationVariables>;
export const UpdateImageBannersDocument = gql`
    mutation UpdateImageBanners($dispensaryId: String!, $input: UpdateImageBannersInput!) {
  updateImageBanners(dispensaryId: $dispensaryId, input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdateImageBannersMutationFn = Apollo.MutationFunction<GqlUpdateImageBannersMutation, GqlUpdateImageBannersMutationVariables>;

/**
 * __useUpdateImageBannersMutation__
 *
 * To run a mutation, you first call `useUpdateImageBannersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageBannersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageBannersMutation, { data, loading, error }] = useUpdateImageBannersMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageBannersMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateImageBannersMutation, GqlUpdateImageBannersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateImageBannersMutation, GqlUpdateImageBannersMutationVariables>(UpdateImageBannersDocument, options);
      }
export type UpdateImageBannersMutationHookResult = ReturnType<typeof useUpdateImageBannersMutation>;
export type UpdateImageBannersMutationResult = Apollo.MutationResult<GqlUpdateImageBannersMutation>;
export type UpdateImageBannersMutationOptions = Apollo.BaseMutationOptions<GqlUpdateImageBannersMutation, GqlUpdateImageBannersMutationVariables>;
export const UpdateMenuSectionsDocument = gql`
    mutation UpdateMenuSections($dispensaryId: String!, $menuSections: [menuSectionBulkUpdateInput!], $deletes: [ID!]) {
  bulkUpdateMenuSections(
    dispensaryId: $dispensaryId
    menuSections: $menuSections
    deletes: $deletes
  ) {
    id
  }
}
    `;
export type GqlUpdateMenuSectionsMutationFn = Apollo.MutationFunction<GqlUpdateMenuSectionsMutation, GqlUpdateMenuSectionsMutationVariables>;

/**
 * __useUpdateMenuSectionsMutation__
 *
 * To run a mutation, you first call `useUpdateMenuSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuSectionsMutation, { data, loading, error }] = useUpdateMenuSectionsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuSections: // value for 'menuSections'
 *      deletes: // value for 'deletes'
 *   },
 * });
 */
export function useUpdateMenuSectionsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateMenuSectionsMutation, GqlUpdateMenuSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateMenuSectionsMutation, GqlUpdateMenuSectionsMutationVariables>(UpdateMenuSectionsDocument, options);
      }
export type UpdateMenuSectionsMutationHookResult = ReturnType<typeof useUpdateMenuSectionsMutation>;
export type UpdateMenuSectionsMutationResult = Apollo.MutationResult<GqlUpdateMenuSectionsMutation>;
export type UpdateMenuSectionsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateMenuSectionsMutation, GqlUpdateMenuSectionsMutationVariables>;
export const GetCollectionsForEmbedDocument = gql`
    query GetCollectionsForEmbed($dispensaryId: String!) {
  getCollections(
    dispensaryId: $dispensaryId
    customCategory: false
    activeOnly: false
  ) {
    id
    title
    enabled
  }
}
    `;

/**
 * __useGetCollectionsForEmbedQuery__
 *
 * To run a query within a React component, call `useGetCollectionsForEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsForEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsForEmbedQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCollectionsForEmbedQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionsForEmbedQuery, GqlGetCollectionsForEmbedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionsForEmbedQuery, GqlGetCollectionsForEmbedQueryVariables>(GetCollectionsForEmbedDocument, options);
      }
export function useGetCollectionsForEmbedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionsForEmbedQuery, GqlGetCollectionsForEmbedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionsForEmbedQuery, GqlGetCollectionsForEmbedQueryVariables>(GetCollectionsForEmbedDocument, options);
        }
export type GetCollectionsForEmbedQueryHookResult = ReturnType<typeof useGetCollectionsForEmbedQuery>;
export type GetCollectionsForEmbedLazyQueryHookResult = ReturnType<typeof useGetCollectionsForEmbedLazyQuery>;
export type GetCollectionsForEmbedQueryResult = Apollo.QueryResult<GqlGetCollectionsForEmbedQuery, GqlGetCollectionsForEmbedQueryVariables>;
export const GetMenuSectionsForEmbedDocument = gql`
    query GetMenuSectionsForEmbed($dispensaryId: String!) {
  getMenuSectionsAdmin(dispensaryId: $dispensaryId) {
    id
    label
    sectionType
    collectionId
  }
}
    `;

/**
 * __useGetMenuSectionsForEmbedQuery__
 *
 * To run a query within a React component, call `useGetMenuSectionsForEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuSectionsForEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuSectionsForEmbedQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMenuSectionsForEmbedQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMenuSectionsForEmbedQuery, GqlGetMenuSectionsForEmbedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMenuSectionsForEmbedQuery, GqlGetMenuSectionsForEmbedQueryVariables>(GetMenuSectionsForEmbedDocument, options);
      }
export function useGetMenuSectionsForEmbedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMenuSectionsForEmbedQuery, GqlGetMenuSectionsForEmbedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMenuSectionsForEmbedQuery, GqlGetMenuSectionsForEmbedQueryVariables>(GetMenuSectionsForEmbedDocument, options);
        }
export type GetMenuSectionsForEmbedQueryHookResult = ReturnType<typeof useGetMenuSectionsForEmbedQuery>;
export type GetMenuSectionsForEmbedLazyQueryHookResult = ReturnType<typeof useGetMenuSectionsForEmbedLazyQuery>;
export type GetMenuSectionsForEmbedQueryResult = Apollo.QueryResult<GqlGetMenuSectionsForEmbedQuery, GqlGetMenuSectionsForEmbedQueryVariables>;
export const CreateMenuSectionDocument = gql`
    mutation CreateMenuSection($menuSection: menuSectionCreateInput!) {
  createMenuSection(menuSection: $menuSection) {
    id
  }
}
    `;
export type GqlCreateMenuSectionMutationFn = Apollo.MutationFunction<GqlCreateMenuSectionMutation, GqlCreateMenuSectionMutationVariables>;

/**
 * __useCreateMenuSectionMutation__
 *
 * To run a mutation, you first call `useCreateMenuSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuSectionMutation, { data, loading, error }] = useCreateMenuSectionMutation({
 *   variables: {
 *      menuSection: // value for 'menuSection'
 *   },
 * });
 */
export function useCreateMenuSectionMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateMenuSectionMutation, GqlCreateMenuSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateMenuSectionMutation, GqlCreateMenuSectionMutationVariables>(CreateMenuSectionDocument, options);
      }
export type CreateMenuSectionMutationHookResult = ReturnType<typeof useCreateMenuSectionMutation>;
export type CreateMenuSectionMutationResult = Apollo.MutationResult<GqlCreateMenuSectionMutation>;
export type CreateMenuSectionMutationOptions = Apollo.BaseMutationOptions<GqlCreateMenuSectionMutation, GqlCreateMenuSectionMutationVariables>;
export const DestroyMenuSectionDocument = gql`
    mutation DestroyMenuSection($id: String!, $dispensaryId: String) {
  destroyMenuSection(id: $id, dispensaryId: $dispensaryId) {
    message
    success
  }
}
    `;
export type GqlDestroyMenuSectionMutationFn = Apollo.MutationFunction<GqlDestroyMenuSectionMutation, GqlDestroyMenuSectionMutationVariables>;

/**
 * __useDestroyMenuSectionMutation__
 *
 * To run a mutation, you first call `useDestroyMenuSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyMenuSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyMenuSectionMutation, { data, loading, error }] = useDestroyMenuSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useDestroyMenuSectionMutation(baseOptions?: Apollo.MutationHookOptions<GqlDestroyMenuSectionMutation, GqlDestroyMenuSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDestroyMenuSectionMutation, GqlDestroyMenuSectionMutationVariables>(DestroyMenuSectionDocument, options);
      }
export type DestroyMenuSectionMutationHookResult = ReturnType<typeof useDestroyMenuSectionMutation>;
export type DestroyMenuSectionMutationResult = Apollo.MutationResult<GqlDestroyMenuSectionMutation>;
export type DestroyMenuSectionMutationOptions = Apollo.BaseMutationOptions<GqlDestroyMenuSectionMutation, GqlDestroyMenuSectionMutationVariables>;
export const GetMenuSectionProductsAdminDocument = gql`
    query GetMenuSectionProductsAdmin($filter: productsFilterInput!) {
  filteredProducts(filter: $filter) {
    products {
      Name
      brand {
        id
        name
      }
      _id
      id
      collections {
        id
      }
      featured {
        current
      }
      type
      subcategory
      special
    }
  }
}
    `;

/**
 * __useGetMenuSectionProductsAdminQuery__
 *
 * To run a query within a React component, call `useGetMenuSectionProductsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuSectionProductsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuSectionProductsAdminQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMenuSectionProductsAdminQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMenuSectionProductsAdminQuery, GqlGetMenuSectionProductsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMenuSectionProductsAdminQuery, GqlGetMenuSectionProductsAdminQueryVariables>(GetMenuSectionProductsAdminDocument, options);
      }
export function useGetMenuSectionProductsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMenuSectionProductsAdminQuery, GqlGetMenuSectionProductsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMenuSectionProductsAdminQuery, GqlGetMenuSectionProductsAdminQueryVariables>(GetMenuSectionProductsAdminDocument, options);
        }
export type GetMenuSectionProductsAdminQueryHookResult = ReturnType<typeof useGetMenuSectionProductsAdminQuery>;
export type GetMenuSectionProductsAdminLazyQueryHookResult = ReturnType<typeof useGetMenuSectionProductsAdminLazyQuery>;
export type GetMenuSectionProductsAdminQueryResult = Apollo.QueryResult<GqlGetMenuSectionProductsAdminQuery, GqlGetMenuSectionProductsAdminQueryVariables>;
export const GetMenuSectionsAdminDocument = gql`
    query GetMenuSectionsAdmin($dispensaryId: String!) {
  getMenuSectionsAdmin(dispensaryId: $dispensaryId) {
    brandId
    category
    id
    image {
      _id
      image
      mobileImage
      alt
      link
      openInNewTab
      platforms {
        enabled
        link
        openInNewTab
        type
      }
      position
    }
    headingOverride
    label
    legacyLabel
    linkLabel
    position
    subcategory
    sectionType
    sectionName
    products
    collectionId
    sortBy
    collectionSchedule {
      ...ScheduleFields
    }
    mobileAppDisplayType
    mobileAppFlairType
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useGetMenuSectionsAdminQuery__
 *
 * To run a query within a React component, call `useGetMenuSectionsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuSectionsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuSectionsAdminQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMenuSectionsAdminQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMenuSectionsAdminQuery, GqlGetMenuSectionsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMenuSectionsAdminQuery, GqlGetMenuSectionsAdminQueryVariables>(GetMenuSectionsAdminDocument, options);
      }
export function useGetMenuSectionsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMenuSectionsAdminQuery, GqlGetMenuSectionsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMenuSectionsAdminQuery, GqlGetMenuSectionsAdminQueryVariables>(GetMenuSectionsAdminDocument, options);
        }
export type GetMenuSectionsAdminQueryHookResult = ReturnType<typeof useGetMenuSectionsAdminQuery>;
export type GetMenuSectionsAdminLazyQueryHookResult = ReturnType<typeof useGetMenuSectionsAdminLazyQuery>;
export type GetMenuSectionsAdminQueryResult = Apollo.QueryResult<GqlGetMenuSectionsAdminQuery, GqlGetMenuSectionsAdminQueryVariables>;
export const SortMenuSectionsDocument = gql`
    mutation SortMenuSections($dispensaryId: String!, $ids: [String!]!) {
  sortMenuSections(dispensaryId: $dispensaryId, ids: $ids) {
    message
    success
  }
}
    `;
export type GqlSortMenuSectionsMutationFn = Apollo.MutationFunction<GqlSortMenuSectionsMutation, GqlSortMenuSectionsMutationVariables>;

/**
 * __useSortMenuSectionsMutation__
 *
 * To run a mutation, you first call `useSortMenuSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortMenuSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortMenuSectionsMutation, { data, loading, error }] = useSortMenuSectionsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSortMenuSectionsMutation(baseOptions?: Apollo.MutationHookOptions<GqlSortMenuSectionsMutation, GqlSortMenuSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSortMenuSectionsMutation, GqlSortMenuSectionsMutationVariables>(SortMenuSectionsDocument, options);
      }
export type SortMenuSectionsMutationHookResult = ReturnType<typeof useSortMenuSectionsMutation>;
export type SortMenuSectionsMutationResult = Apollo.MutationResult<GqlSortMenuSectionsMutation>;
export type SortMenuSectionsMutationOptions = Apollo.BaseMutationOptions<GqlSortMenuSectionsMutation, GqlSortMenuSectionsMutationVariables>;
export const UpdateMenuSectionDocument = gql`
    mutation UpdateMenuSection($id: ID!, $menuSection: menuSectionUpdateInput!) {
  updateMenuSection(id: $id, menuSection: $menuSection) {
    id
  }
}
    `;
export type GqlUpdateMenuSectionMutationFn = Apollo.MutationFunction<GqlUpdateMenuSectionMutation, GqlUpdateMenuSectionMutationVariables>;

/**
 * __useUpdateMenuSectionMutation__
 *
 * To run a mutation, you first call `useUpdateMenuSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuSectionMutation, { data, loading, error }] = useUpdateMenuSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      menuSection: // value for 'menuSection'
 *   },
 * });
 */
export function useUpdateMenuSectionMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateMenuSectionMutation, GqlUpdateMenuSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateMenuSectionMutation, GqlUpdateMenuSectionMutationVariables>(UpdateMenuSectionDocument, options);
      }
export type UpdateMenuSectionMutationHookResult = ReturnType<typeof useUpdateMenuSectionMutation>;
export type UpdateMenuSectionMutationResult = Apollo.MutationResult<GqlUpdateMenuSectionMutation>;
export type UpdateMenuSectionMutationOptions = Apollo.BaseMutationOptions<GqlUpdateMenuSectionMutation, GqlUpdateMenuSectionMutationVariables>;
export const AdminIndexProductsDocument = gql`
    query AdminIndexProducts($productsFilter: productsFilterInput!, $page: Int, $perPage: Int) {
  filteredProducts(filter: $productsFilter, page: $page, perPage: $perPage) {
    products {
      id
      _id
      brand {
        id
        name
      }
      brandName
      CBD
      CBDContent {
        unit
        range
      }
      Description
      DispensaryID
      duplicatedProductId
      effects
      images {
        _id
        url
        active
      }
      medicalOnly
      Name
      Options
      POSMetaData {
        ...POSMetaDataFragment
      }
      recOnly
      recPrices
      medicalPrices
      Prices
      score
      Status
      strainType
      subcategory
      updatedAt
      THC
      THCContent {
        unit
        range
      }
      type
      weight
      isBelowThreshold
      isBelowKioskThreshold
      forcedPotencyUnit
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
        }
      }
    }
    queryInfo {
      totalCount
    }
  }
}
    ${PosMetaDataFragmentFragmentDoc}`;

/**
 * __useAdminIndexProductsQuery__
 *
 * To run a query within a React component, call `useAdminIndexProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminIndexProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminIndexProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAdminIndexProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlAdminIndexProductsQuery, GqlAdminIndexProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminIndexProductsQuery, GqlAdminIndexProductsQueryVariables>(AdminIndexProductsDocument, options);
      }
export function useAdminIndexProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminIndexProductsQuery, GqlAdminIndexProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminIndexProductsQuery, GqlAdminIndexProductsQueryVariables>(AdminIndexProductsDocument, options);
        }
export type AdminIndexProductsQueryHookResult = ReturnType<typeof useAdminIndexProductsQuery>;
export type AdminIndexProductsLazyQueryHookResult = ReturnType<typeof useAdminIndexProductsLazyQuery>;
export type AdminIndexProductsQueryResult = Apollo.QueryResult<GqlAdminIndexProductsQuery, GqlAdminIndexProductsQueryVariables>;
export const DisconnectProductDocument = gql`
    mutation DisconnectProduct($id: String!) {
  disconnectProduct(id: $id) {
    message
    success
  }
}
    `;
export type GqlDisconnectProductMutationFn = Apollo.MutationFunction<GqlDisconnectProductMutation, GqlDisconnectProductMutationVariables>;

/**
 * __useDisconnectProductMutation__
 *
 * To run a mutation, you first call `useDisconnectProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectProductMutation, { data, loading, error }] = useDisconnectProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisconnectProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlDisconnectProductMutation, GqlDisconnectProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDisconnectProductMutation, GqlDisconnectProductMutationVariables>(DisconnectProductDocument, options);
      }
export type DisconnectProductMutationHookResult = ReturnType<typeof useDisconnectProductMutation>;
export type DisconnectProductMutationResult = Apollo.MutationResult<GqlDisconnectProductMutation>;
export type DisconnectProductMutationOptions = Apollo.BaseMutationOptions<GqlDisconnectProductMutation, GqlDisconnectProductMutationVariables>;
export const SetGlobalMenuOrderDocument = gql`
    mutation SetGlobalMenuOrder($input: SetGlobalMenuOrderInput!) {
  setGlobalMenuOrder(input: $input) {
    success
    message
  }
}
    `;
export type GqlSetGlobalMenuOrderMutationFn = Apollo.MutationFunction<GqlSetGlobalMenuOrderMutation, GqlSetGlobalMenuOrderMutationVariables>;

/**
 * __useSetGlobalMenuOrderMutation__
 *
 * To run a mutation, you first call `useSetGlobalMenuOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalMenuOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalMenuOrderMutation, { data, loading, error }] = useSetGlobalMenuOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGlobalMenuOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlSetGlobalMenuOrderMutation, GqlSetGlobalMenuOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetGlobalMenuOrderMutation, GqlSetGlobalMenuOrderMutationVariables>(SetGlobalMenuOrderDocument, options);
      }
export type SetGlobalMenuOrderMutationHookResult = ReturnType<typeof useSetGlobalMenuOrderMutation>;
export type SetGlobalMenuOrderMutationResult = Apollo.MutationResult<GqlSetGlobalMenuOrderMutation>;
export type SetGlobalMenuOrderMutationOptions = Apollo.BaseMutationOptions<GqlSetGlobalMenuOrderMutation, GqlSetGlobalMenuOrderMutationVariables>;
export const SetCategoryMenuOrderDocument = gql`
    mutation SetCategoryMenuOrder($input: SetCategoryMenuOrderInput!) {
  setCategoryMenuOrder(input: $input) {
    success
    message
  }
}
    `;
export type GqlSetCategoryMenuOrderMutationFn = Apollo.MutationFunction<GqlSetCategoryMenuOrderMutation, GqlSetCategoryMenuOrderMutationVariables>;

/**
 * __useSetCategoryMenuOrderMutation__
 *
 * To run a mutation, you first call `useSetCategoryMenuOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCategoryMenuOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCategoryMenuOrderMutation, { data, loading, error }] = useSetCategoryMenuOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCategoryMenuOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlSetCategoryMenuOrderMutation, GqlSetCategoryMenuOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetCategoryMenuOrderMutation, GqlSetCategoryMenuOrderMutationVariables>(SetCategoryMenuOrderDocument, options);
      }
export type SetCategoryMenuOrderMutationHookResult = ReturnType<typeof useSetCategoryMenuOrderMutation>;
export type SetCategoryMenuOrderMutationResult = Apollo.MutationResult<GqlSetCategoryMenuOrderMutation>;
export type SetCategoryMenuOrderMutationOptions = Apollo.BaseMutationOptions<GqlSetCategoryMenuOrderMutation, GqlSetCategoryMenuOrderMutationVariables>;
export const RemoveCategoryMenuOrderDocument = gql`
    mutation RemoveCategoryMenuOrder($input: RemoveCategoryMenuOrderInput!) {
  removeCategoryMenuOrder(input: $input) {
    success
    message
  }
}
    `;
export type GqlRemoveCategoryMenuOrderMutationFn = Apollo.MutationFunction<GqlRemoveCategoryMenuOrderMutation, GqlRemoveCategoryMenuOrderMutationVariables>;

/**
 * __useRemoveCategoryMenuOrderMutation__
 *
 * To run a mutation, you first call `useRemoveCategoryMenuOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoryMenuOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoryMenuOrderMutation, { data, loading, error }] = useRemoveCategoryMenuOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCategoryMenuOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlRemoveCategoryMenuOrderMutation, GqlRemoveCategoryMenuOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRemoveCategoryMenuOrderMutation, GqlRemoveCategoryMenuOrderMutationVariables>(RemoveCategoryMenuOrderDocument, options);
      }
export type RemoveCategoryMenuOrderMutationHookResult = ReturnType<typeof useRemoveCategoryMenuOrderMutation>;
export type RemoveCategoryMenuOrderMutationResult = Apollo.MutationResult<GqlRemoveCategoryMenuOrderMutation>;
export type RemoveCategoryMenuOrderMutationOptions = Apollo.BaseMutationOptions<GqlRemoveCategoryMenuOrderMutation, GqlRemoveCategoryMenuOrderMutationVariables>;
export const SetCategoryFeaturedProductsDocument = gql`
    mutation SetCategoryFeaturedProducts($input: SetCategoryFeaturedProductsInput!) {
  setCategoryFeaturedProducts(input: $input) {
    success
    message
  }
}
    `;
export type GqlSetCategoryFeaturedProductsMutationFn = Apollo.MutationFunction<GqlSetCategoryFeaturedProductsMutation, GqlSetCategoryFeaturedProductsMutationVariables>;

/**
 * __useSetCategoryFeaturedProductsMutation__
 *
 * To run a mutation, you first call `useSetCategoryFeaturedProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCategoryFeaturedProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCategoryFeaturedProductsMutation, { data, loading, error }] = useSetCategoryFeaturedProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCategoryFeaturedProductsMutation(baseOptions?: Apollo.MutationHookOptions<GqlSetCategoryFeaturedProductsMutation, GqlSetCategoryFeaturedProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetCategoryFeaturedProductsMutation, GqlSetCategoryFeaturedProductsMutationVariables>(SetCategoryFeaturedProductsDocument, options);
      }
export type SetCategoryFeaturedProductsMutationHookResult = ReturnType<typeof useSetCategoryFeaturedProductsMutation>;
export type SetCategoryFeaturedProductsMutationResult = Apollo.MutationResult<GqlSetCategoryFeaturedProductsMutation>;
export type SetCategoryFeaturedProductsMutationOptions = Apollo.BaseMutationOptions<GqlSetCategoryFeaturedProductsMutation, GqlSetCategoryFeaturedProductsMutationVariables>;
export const SetCategoryFeaturedBrandsDocument = gql`
    mutation SetCategoryFeaturedBrands($input: SetCategoryFeaturedBrandsInput!) {
  setCategoryFeaturedBrands(input: $input) {
    success
    message
  }
}
    `;
export type GqlSetCategoryFeaturedBrandsMutationFn = Apollo.MutationFunction<GqlSetCategoryFeaturedBrandsMutation, GqlSetCategoryFeaturedBrandsMutationVariables>;

/**
 * __useSetCategoryFeaturedBrandsMutation__
 *
 * To run a mutation, you first call `useSetCategoryFeaturedBrandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCategoryFeaturedBrandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCategoryFeaturedBrandsMutation, { data, loading, error }] = useSetCategoryFeaturedBrandsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCategoryFeaturedBrandsMutation(baseOptions?: Apollo.MutationHookOptions<GqlSetCategoryFeaturedBrandsMutation, GqlSetCategoryFeaturedBrandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetCategoryFeaturedBrandsMutation, GqlSetCategoryFeaturedBrandsMutationVariables>(SetCategoryFeaturedBrandsDocument, options);
      }
export type SetCategoryFeaturedBrandsMutationHookResult = ReturnType<typeof useSetCategoryFeaturedBrandsMutation>;
export type SetCategoryFeaturedBrandsMutationResult = Apollo.MutationResult<GqlSetCategoryFeaturedBrandsMutation>;
export type SetCategoryFeaturedBrandsMutationOptions = Apollo.BaseMutationOptions<GqlSetCategoryFeaturedBrandsMutation, GqlSetCategoryFeaturedBrandsMutationVariables>;
export const UpdateProductStatusDocument = gql`
    mutation UpdateProductStatus($id: String, $status: String) {
  updateProductStatus(id: $id, status: $status) {
    _id
    id
    Status
  }
}
    `;
export type GqlUpdateProductStatusMutationFn = Apollo.MutationFunction<GqlUpdateProductStatusMutation, GqlUpdateProductStatusMutationVariables>;

/**
 * __useUpdateProductStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStatusMutation, { data, loading, error }] = useUpdateProductStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateProductStatusMutation, GqlUpdateProductStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateProductStatusMutation, GqlUpdateProductStatusMutationVariables>(UpdateProductStatusDocument, options);
      }
export type UpdateProductStatusMutationHookResult = ReturnType<typeof useUpdateProductStatusMutation>;
export type UpdateProductStatusMutationResult = Apollo.MutationResult<GqlUpdateProductStatusMutation>;
export type UpdateProductStatusMutationOptions = Apollo.BaseMutationOptions<GqlUpdateProductStatusMutation, GqlUpdateProductStatusMutationVariables>;
export const DeleteArchivedProductDocument = gql`
    mutation DeleteArchivedProduct($id: String!) {
  deleteArchivedProduct(id: $id) {
    success
    message
  }
}
    `;
export type GqlDeleteArchivedProductMutationFn = Apollo.MutationFunction<GqlDeleteArchivedProductMutation, GqlDeleteArchivedProductMutationVariables>;

/**
 * __useDeleteArchivedProductMutation__
 *
 * To run a mutation, you first call `useDeleteArchivedProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArchivedProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArchivedProductMutation, { data, loading, error }] = useDeleteArchivedProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArchivedProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteArchivedProductMutation, GqlDeleteArchivedProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteArchivedProductMutation, GqlDeleteArchivedProductMutationVariables>(DeleteArchivedProductDocument, options);
      }
export type DeleteArchivedProductMutationHookResult = ReturnType<typeof useDeleteArchivedProductMutation>;
export type DeleteArchivedProductMutationResult = Apollo.MutationResult<GqlDeleteArchivedProductMutation>;
export type DeleteArchivedProductMutationOptions = Apollo.BaseMutationOptions<GqlDeleteArchivedProductMutation, GqlDeleteArchivedProductMutationVariables>;
export const AdminMenuFiltersDocument = gql`
    query AdminMenuFilters($dispensaryId: String!, $pricingType: menuPricingTypes, $category: String, $search: String) {
  menuFiltersV2(
    dispensaryId: $dispensaryId
    pricingType: $pricingType
    category: $category
    search: $search
    userSegmentIds: []
  ) {
    brands {
      id
      name
    }
    categoriesSubcategories {
      category
      subcategories
    }
    strainTypes
  }
}
    `;

/**
 * __useAdminMenuFiltersQuery__
 *
 * To run a query within a React component, call `useAdminMenuFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMenuFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMenuFiltersQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      pricingType: // value for 'pricingType'
 *      category: // value for 'category'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminMenuFiltersQuery(baseOptions: Apollo.QueryHookOptions<GqlAdminMenuFiltersQuery, GqlAdminMenuFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminMenuFiltersQuery, GqlAdminMenuFiltersQueryVariables>(AdminMenuFiltersDocument, options);
      }
export function useAdminMenuFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminMenuFiltersQuery, GqlAdminMenuFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminMenuFiltersQuery, GqlAdminMenuFiltersQueryVariables>(AdminMenuFiltersDocument, options);
        }
export type AdminMenuFiltersQueryHookResult = ReturnType<typeof useAdminMenuFiltersQuery>;
export type AdminMenuFiltersLazyQueryHookResult = ReturnType<typeof useAdminMenuFiltersLazyQuery>;
export type AdminMenuFiltersQueryResult = Apollo.QueryResult<GqlAdminMenuFiltersQuery, GqlAdminMenuFiltersQueryVariables>;
export const GetOrdersForMessagingDocument = gql`
    query GetOrdersForMessaging($input: getOrdersInput!) {
  getOrders(input: $input) {
    queryInfo {
      totalCount
    }
    orders {
      createdAt
      customerId
      customerEmail
      customerName
      customerPhone
      dispensaryId
      _id
      orderId
      status
    }
  }
}
    `;

/**
 * __useGetOrdersForMessagingQuery__
 *
 * To run a query within a React component, call `useGetOrdersForMessagingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersForMessagingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersForMessagingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersForMessagingQuery(baseOptions: Apollo.QueryHookOptions<GqlGetOrdersForMessagingQuery, GqlGetOrdersForMessagingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetOrdersForMessagingQuery, GqlGetOrdersForMessagingQueryVariables>(GetOrdersForMessagingDocument, options);
      }
export function useGetOrdersForMessagingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetOrdersForMessagingQuery, GqlGetOrdersForMessagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetOrdersForMessagingQuery, GqlGetOrdersForMessagingQueryVariables>(GetOrdersForMessagingDocument, options);
        }
export type GetOrdersForMessagingQueryHookResult = ReturnType<typeof useGetOrdersForMessagingQuery>;
export type GetOrdersForMessagingLazyQueryHookResult = ReturnType<typeof useGetOrdersForMessagingLazyQuery>;
export type GetOrdersForMessagingQueryResult = Apollo.QueryResult<GqlGetOrdersForMessagingQuery, GqlGetOrdersForMessagingQueryVariables>;
export const CreateOrderingSuspensionV2Document = gql`
    mutation CreateOrderingSuspensionV2($dispensaryId: ID!) {
  createOrderingSuspensionV2(dispensaryId: $dispensaryId) {
    id
  }
}
    `;
export type GqlCreateOrderingSuspensionV2MutationFn = Apollo.MutationFunction<GqlCreateOrderingSuspensionV2Mutation, GqlCreateOrderingSuspensionV2MutationVariables>;

/**
 * __useCreateOrderingSuspensionV2Mutation__
 *
 * To run a mutation, you first call `useCreateOrderingSuspensionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderingSuspensionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderingSuspensionV2Mutation, { data, loading, error }] = useCreateOrderingSuspensionV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCreateOrderingSuspensionV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateOrderingSuspensionV2Mutation, GqlCreateOrderingSuspensionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateOrderingSuspensionV2Mutation, GqlCreateOrderingSuspensionV2MutationVariables>(CreateOrderingSuspensionV2Document, options);
      }
export type CreateOrderingSuspensionV2MutationHookResult = ReturnType<typeof useCreateOrderingSuspensionV2Mutation>;
export type CreateOrderingSuspensionV2MutationResult = Apollo.MutationResult<GqlCreateOrderingSuspensionV2Mutation>;
export type CreateOrderingSuspensionV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateOrderingSuspensionV2Mutation, GqlCreateOrderingSuspensionV2MutationVariables>;
export const EndOrderingSuspensionV2Document = gql`
    mutation EndOrderingSuspensionV2($dispensaryId: ID!) {
  endOrderingSuspensionV2(dispensaryId: $dispensaryId) {
    id
  }
}
    `;
export type GqlEndOrderingSuspensionV2MutationFn = Apollo.MutationFunction<GqlEndOrderingSuspensionV2Mutation, GqlEndOrderingSuspensionV2MutationVariables>;

/**
 * __useEndOrderingSuspensionV2Mutation__
 *
 * To run a mutation, you first call `useEndOrderingSuspensionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndOrderingSuspensionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endOrderingSuspensionV2Mutation, { data, loading, error }] = useEndOrderingSuspensionV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useEndOrderingSuspensionV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlEndOrderingSuspensionV2Mutation, GqlEndOrderingSuspensionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEndOrderingSuspensionV2Mutation, GqlEndOrderingSuspensionV2MutationVariables>(EndOrderingSuspensionV2Document, options);
      }
export type EndOrderingSuspensionV2MutationHookResult = ReturnType<typeof useEndOrderingSuspensionV2Mutation>;
export type EndOrderingSuspensionV2MutationResult = Apollo.MutationResult<GqlEndOrderingSuspensionV2Mutation>;
export type EndOrderingSuspensionV2MutationOptions = Apollo.BaseMutationOptions<GqlEndOrderingSuspensionV2Mutation, GqlEndOrderingSuspensionV2MutationVariables>;
export const GetOrderDocument = gql`
    query GetOrder($id: String!) {
  getOrder(id: $id) {
    archived
    order {
      coupon {
        _id
        active
        addedDate
        percentDiscount
        fixedDiscountInCents
        code
        dispensary
        expDate
        numAllowedUses
        numUses
        usedBy
      }
      manualDiscount {
        fixedDiscountInCents
        percentDiscount
      }
      createdAt
      credit
      curbsideArrivalInfo {
        arrivalInformation
      }
      deliveryFee
      driversLicense
      dispensary {
        _id
        name
        cName
        phone
        logoImage
        address
        timezone
        featureFlags {
          hideDeliveryEstimate
        }
        payByBankManualFinalizationAvailable
        retailer {
          enterpriseId
        }
      }
      id
      customer {
        _id
        emails {
          address
        }
        profile {
          medicalCard {
            expirationDate
            number
            state
            photo
          }
          driversLicense
          photoId
          firstName
          lastName
          email
          phone
          birthday
        }
      }
      mixAndMatch
      pos {
        name
        externalID
        failureType
        failureReason
        failureAcks {
          web
          terminal
        }
        humanReadableError
      }
      fleetManagementTask {
        adapter
        id
      }
      guestCustomer {
        firstName
        lastName
        email
        phone
        birthMonth
        birthDay
        birthYear
        photoId
      }
      medicalOrder
      medicalCard {
        expirationDate
        number
        state
        photo
      }
      otherFees
      orderId
      orders {
        basePrice
        option
        price
        additionalOption
        product {
          _id
          Name
          Image
          strainType
          type
          subcategory
          Options
          brandId
          brandName
          brand {
            _id
            name
          }
          AdditionalOptions
          THCContent {
            unit
            value
            range
          }
          CBDContent {
            unit
            value
            range
          }
          Prices
          preTaxRecPrices
          preTaxMedPrices
        }
        quantity
      }
      specialInstructions
      status
      statusTimes
      statusEvents {
        event
        at
        by
        byType
        agentName
      }
      taxAmount
      cannabisTax
      bottleDepositTaxCents
      tipAmount
      paymentFee
      paymentMethod
      dutchiePay {
        preAuth {
          paymentId
        }
      }
      subtotal
      totalCost
      isAfterHoursOrder
      isAnonymous
      isGuestOrder
      isPreviewOrder
      isKioskOrder
      originKioskId
      kioskName
      isCurbsidePickupOrder
      isDriveThruPickupOrder
      voiceCallInfo {
        callId
        assistantId
      }
      terminal
      autoConfirmed
      autoClosed
      driverName
      driverNumber
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
        address
        location {
          lat
          lng
          ln1
          ln2
          city
          state
          zipcode
        }
      }
      editEvents {
        at
        by
        byType
        agentName
      }
      isArchived
      archivedBy
      archivedAtISO
      cancellationReason
      updatedAt
      hypur {
        id
      }
      paysafe {
        card {
          type
          lastDigits
        }
        authorizations {
          id
          amount
        }
        settlements {
          id
          amount
          cancelled
        }
        refunds {
          id
          amount
        }
      }
      moneris {
        id
        status
        transactionNumber
        card {
          brand
          lastDigits
        }
      }
      appliedRewards {
        copy
        value
        operator
        brand
        redemptionAttempts {
          programResponse {
            rewardRedemption {
              id
              createdAt
              name
              description
            }
          }
          status
          redeemBy
        }
      }
      reservation {
        startTimeISO
        endTimeISO
      }
      receipt
    }
  }
}
    `;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GqlGetOrderQuery, GqlGetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetOrderQuery, GqlGetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetOrderQuery, GqlGetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetOrderQuery, GqlGetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GqlGetOrderQuery, GqlGetOrderQueryVariables>;
export const GetPayByBankFinalizationStatusForAdminDocument = gql`
    query GetPayByBankFinalizationStatusForAdmin($orderId: String!) {
  getPayByBankFinalizationStatus(orderId: $orderId) {
    status
  }
}
    `;

/**
 * __useGetPayByBankFinalizationStatusForAdminQuery__
 *
 * To run a query within a React component, call `useGetPayByBankFinalizationStatusForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayByBankFinalizationStatusForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayByBankFinalizationStatusForAdminQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetPayByBankFinalizationStatusForAdminQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPayByBankFinalizationStatusForAdminQuery, GqlGetPayByBankFinalizationStatusForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPayByBankFinalizationStatusForAdminQuery, GqlGetPayByBankFinalizationStatusForAdminQueryVariables>(GetPayByBankFinalizationStatusForAdminDocument, options);
      }
export function useGetPayByBankFinalizationStatusForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPayByBankFinalizationStatusForAdminQuery, GqlGetPayByBankFinalizationStatusForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPayByBankFinalizationStatusForAdminQuery, GqlGetPayByBankFinalizationStatusForAdminQueryVariables>(GetPayByBankFinalizationStatusForAdminDocument, options);
        }
export type GetPayByBankFinalizationStatusForAdminQueryHookResult = ReturnType<typeof useGetPayByBankFinalizationStatusForAdminQuery>;
export type GetPayByBankFinalizationStatusForAdminLazyQueryHookResult = ReturnType<typeof useGetPayByBankFinalizationStatusForAdminLazyQuery>;
export type GetPayByBankFinalizationStatusForAdminQueryResult = Apollo.QueryResult<GqlGetPayByBankFinalizationStatusForAdminQuery, GqlGetPayByBankFinalizationStatusForAdminQueryVariables>;
export const StartPayByBankFinalizationForAdminDocument = gql`
    mutation StartPayByBankFinalizationForAdmin($orderId: String!) {
  startPayByBankFinalization(orderId: $orderId) {
    status
  }
}
    `;
export type GqlStartPayByBankFinalizationForAdminMutationFn = Apollo.MutationFunction<GqlStartPayByBankFinalizationForAdminMutation, GqlStartPayByBankFinalizationForAdminMutationVariables>;

/**
 * __useStartPayByBankFinalizationForAdminMutation__
 *
 * To run a mutation, you first call `useStartPayByBankFinalizationForAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPayByBankFinalizationForAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPayByBankFinalizationForAdminMutation, { data, loading, error }] = useStartPayByBankFinalizationForAdminMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStartPayByBankFinalizationForAdminMutation(baseOptions?: Apollo.MutationHookOptions<GqlStartPayByBankFinalizationForAdminMutation, GqlStartPayByBankFinalizationForAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlStartPayByBankFinalizationForAdminMutation, GqlStartPayByBankFinalizationForAdminMutationVariables>(StartPayByBankFinalizationForAdminDocument, options);
      }
export type StartPayByBankFinalizationForAdminMutationHookResult = ReturnType<typeof useStartPayByBankFinalizationForAdminMutation>;
export type StartPayByBankFinalizationForAdminMutationResult = Apollo.MutationResult<GqlStartPayByBankFinalizationForAdminMutation>;
export type StartPayByBankFinalizationForAdminMutationOptions = Apollo.BaseMutationOptions<GqlStartPayByBankFinalizationForAdminMutation, GqlStartPayByBankFinalizationForAdminMutationVariables>;
export const CreatePrintJobDocument = gql`
    mutation CreatePrintJob($input: CreatePrintJobInput!) {
  createPrintJob(input: $input) {
    success
    printJob {
      _id
      referenceId
      dispensaryId
      printAfter
      assignedToPrinterId
      createdAt
      updatedAt
    }
  }
}
    `;
export type GqlCreatePrintJobMutationFn = Apollo.MutationFunction<GqlCreatePrintJobMutation, GqlCreatePrintJobMutationVariables>;

/**
 * __useCreatePrintJobMutation__
 *
 * To run a mutation, you first call `useCreatePrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintJobMutation, { data, loading, error }] = useCreatePrintJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrintJobMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePrintJobMutation, GqlCreatePrintJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePrintJobMutation, GqlCreatePrintJobMutationVariables>(CreatePrintJobDocument, options);
      }
export type CreatePrintJobMutationHookResult = ReturnType<typeof useCreatePrintJobMutation>;
export type CreatePrintJobMutationResult = Apollo.MutationResult<GqlCreatePrintJobMutation>;
export type CreatePrintJobMutationOptions = Apollo.BaseMutationOptions<GqlCreatePrintJobMutation, GqlCreatePrintJobMutationVariables>;
export const FilteredCouponsForDispensaryAdminDocument = gql`
    query FilteredCouponsForDispensaryAdmin($filter: couponsFilterInput, $sort: couponsSortInput, $pagination: couponsPaginationInput) {
  filteredCoupons(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    coupons {
      _id
      active
      addedDate
      applicableCategories {
        category
        subcategory
      }
      code
      dispensary
      dispensaryId
      expDate
      fixedDiscountInCents
      numAllowedUses
      numUses
      percentDiscount
      oneUsePerCustomer
      reimbursed
      restrictions {
        minimumPurchase
        minimumPurchaseInCents
        noSpecials
      }
      usedBy
    }
  }
}
    `;

/**
 * __useFilteredCouponsForDispensaryAdminQuery__
 *
 * To run a query within a React component, call `useFilteredCouponsForDispensaryAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCouponsForDispensaryAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCouponsForDispensaryAdminQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredCouponsForDispensaryAdminQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredCouponsForDispensaryAdminQuery, GqlFilteredCouponsForDispensaryAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredCouponsForDispensaryAdminQuery, GqlFilteredCouponsForDispensaryAdminQueryVariables>(FilteredCouponsForDispensaryAdminDocument, options);
      }
export function useFilteredCouponsForDispensaryAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredCouponsForDispensaryAdminQuery, GqlFilteredCouponsForDispensaryAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredCouponsForDispensaryAdminQuery, GqlFilteredCouponsForDispensaryAdminQueryVariables>(FilteredCouponsForDispensaryAdminDocument, options);
        }
export type FilteredCouponsForDispensaryAdminQueryHookResult = ReturnType<typeof useFilteredCouponsForDispensaryAdminQuery>;
export type FilteredCouponsForDispensaryAdminLazyQueryHookResult = ReturnType<typeof useFilteredCouponsForDispensaryAdminLazyQuery>;
export type FilteredCouponsForDispensaryAdminQueryResult = Apollo.QueryResult<GqlFilteredCouponsForDispensaryAdminQuery, GqlFilteredCouponsForDispensaryAdminQueryVariables>;
export const AdminEnterpriseProductsV2Document = gql`
    query AdminEnterpriseProductsV2($enterpriseId: ID!) {
  enterpriseProductsV2(enterpriseId: $enterpriseId) {
    products {
      brandId
      brandName
      dispensaryProducts {
        brandId
        brandName
        dispensaryId
        id
        status
        enterpriseProductId
      }
      enterpriseProductId
      medicalOnly
      medicalPrices
      name
      options
      prices
      priceSummaries {
        maxMedicalPrice
        maxPrice
        maxRecPrice
        minMedicalPrice
        minPrice
        minRecPrice
        option
      }
      recOnly
      recPrices
      subcategory
      type
    }
  }
}
    `;

/**
 * __useAdminEnterpriseProductsV2Query__
 *
 * To run a query within a React component, call `useAdminEnterpriseProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAdminEnterpriseProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEnterpriseProductsV2Query({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useAdminEnterpriseProductsV2Query(baseOptions: Apollo.QueryHookOptions<GqlAdminEnterpriseProductsV2Query, GqlAdminEnterpriseProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminEnterpriseProductsV2Query, GqlAdminEnterpriseProductsV2QueryVariables>(AdminEnterpriseProductsV2Document, options);
      }
export function useAdminEnterpriseProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminEnterpriseProductsV2Query, GqlAdminEnterpriseProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminEnterpriseProductsV2Query, GqlAdminEnterpriseProductsV2QueryVariables>(AdminEnterpriseProductsV2Document, options);
        }
export type AdminEnterpriseProductsV2QueryHookResult = ReturnType<typeof useAdminEnterpriseProductsV2Query>;
export type AdminEnterpriseProductsV2LazyQueryHookResult = ReturnType<typeof useAdminEnterpriseProductsV2LazyQuery>;
export type AdminEnterpriseProductsV2QueryResult = Apollo.QueryResult<GqlAdminEnterpriseProductsV2Query, GqlAdminEnterpriseProductsV2QueryVariables>;
export const GetEnterpriseSpecialDocument = gql`
    query GetEnterpriseSpecial($enterpriseSpecialId: ID!) {
  getEnterpriseSpecial(enterpriseSpecialId: $enterpriseSpecialId) {
    _id
    active
    applyRewardsToConditions
    excludeConditionItemsFromRewards
    menuDisplayName
    menuDisplayDescription
    menuDisplayImage
    bogoConditionLogicOperator
    bogoConditions {
      _id
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      inventoryTags
      enterpriseProductId
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        weights
        weightOperator
      }
      productGroup
      productId
      productIds
      productTags
      quantity
      selectedCategoriesAndSubcategories
      subcategoryIds
      subcategoryNames
      weight
      weightOperator
    }
    bogoRewardLogicOperator
    bogoRewards {
      _id
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      dollarDiscount
      enterpriseProductId
      enterpriseProductIds
      inventoryTags
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        matchOperator
        inventoryTags
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        weights
        weightOperator
      }
      productGroup
      productId
      productIds
      productTags
      percentDiscount
      quantity
      targetPrice
      selectedCategoriesAndSubcategories
      subcategoryIds
      subcategoryNames
      weight
    }
    cipher
    clicks
    complete
    createdAt
    createdBy
    description
    descriptionHtml
    discount
    discountedPrices
    discountToCart {
      _id
      enabled
      discountType
      value
    }
    discountPrecedence
    discountStacking
    dispensaryId
    dispensaries
    displayRank
    dollarDiscount
    duplicatedFrom
    earliestStartStamp
    emailSpecial
    endDay
    endStamp
    endTime
    enterpriseId
    enterpriseSpecialId
    excludedProducts {
      _id
      Name
      key
      conditions {
        _id
        Name
        key
      }
      rewards {
        _id
        Name
        key
      }
    }
    heading
    inactiveDispensaries
    isRecurring
    itemsForAPrice {
      _id
      enabled
      value
    }
    latestEndStamp
    localTime
    menuType
    name
    percentDiscount
    productDiscounts
    productGroup
    productGroupRewards
    products
    recurring {
      days
      endDate
      endTime
      setEndDate
      startTime
    }
    redemptionLimit
    saleDiscounts {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      discountAmount
      discountType
      inventoryTags
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        weights
        weightOperator
      }
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      weights
      weightOperator
    }
    scope
    source
    sourceId
    specialRestrictions
    stackingBehavior
    stackingMode
    startDay
    startStamp
    startTime
    specialType
    subject
    targetPrice
    timezone
    totalQuantity {
      enabled
      maxQuantity
      quantity
      quantityOperator
    }
    totalSpend {
      enabled
      maximumSpend
      minimumSpend
      spendOperator
    }
    totalWeight {
      enabled
      weight
      weightOperator
    }
    updatedAt
    updatedBy
    version
  }
}
    `;

/**
 * __useGetEnterpriseSpecialQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseSpecialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseSpecialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseSpecialQuery({
 *   variables: {
 *      enterpriseSpecialId: // value for 'enterpriseSpecialId'
 *   },
 * });
 */
export function useGetEnterpriseSpecialQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseSpecialQuery, GqlGetEnterpriseSpecialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseSpecialQuery, GqlGetEnterpriseSpecialQueryVariables>(GetEnterpriseSpecialDocument, options);
      }
export function useGetEnterpriseSpecialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseSpecialQuery, GqlGetEnterpriseSpecialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseSpecialQuery, GqlGetEnterpriseSpecialQueryVariables>(GetEnterpriseSpecialDocument, options);
        }
export type GetEnterpriseSpecialQueryHookResult = ReturnType<typeof useGetEnterpriseSpecialQuery>;
export type GetEnterpriseSpecialLazyQueryHookResult = ReturnType<typeof useGetEnterpriseSpecialLazyQuery>;
export type GetEnterpriseSpecialQueryResult = Apollo.QueryResult<GqlGetEnterpriseSpecialQuery, GqlGetEnterpriseSpecialQueryVariables>;
export const AdminSpecialsProductsDocument = gql`
    query AdminSpecialsProducts($productsFilter: productsFilterInput!, $page: Int, $perPage: Int) {
  filteredProducts(filter: $productsFilter, page: $page, perPage: $perPage) {
    products {
      _id
      brand {
        _id
        id
        description
        name
      }
      brandDescription
      brandId
      brandName
      DispensaryID
      enterpriseProductId
      id
      Image
      medicalOnly
      medicalPrices
      Name
      Options
      Prices
      recOnly
      recPrices
      Status
      subcategory
      type
      updatedAt
    }
  }
}
    `;

/**
 * __useAdminSpecialsProductsQuery__
 *
 * To run a query within a React component, call `useAdminSpecialsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSpecialsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSpecialsProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAdminSpecialsProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlAdminSpecialsProductsQuery, GqlAdminSpecialsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminSpecialsProductsQuery, GqlAdminSpecialsProductsQueryVariables>(AdminSpecialsProductsDocument, options);
      }
export function useAdminSpecialsProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminSpecialsProductsQuery, GqlAdminSpecialsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminSpecialsProductsQuery, GqlAdminSpecialsProductsQueryVariables>(AdminSpecialsProductsDocument, options);
        }
export type AdminSpecialsProductsQueryHookResult = ReturnType<typeof useAdminSpecialsProductsQuery>;
export type AdminSpecialsProductsLazyQueryHookResult = ReturnType<typeof useAdminSpecialsProductsLazyQuery>;
export type AdminSpecialsProductsQueryResult = Apollo.QueryResult<GqlAdminSpecialsProductsQuery, GqlAdminSpecialsProductsQueryVariables>;
export const UpdateSpecialMenuDesignDocument = gql`
    mutation updateSpecialMenuDesign($id: ID!, $input: MenuDesignInput!) {
  updateSpecialMenuDesign(id: $id, input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateSpecialMenuDesignMutationFn = Apollo.MutationFunction<GqlUpdateSpecialMenuDesignMutation, GqlUpdateSpecialMenuDesignMutationVariables>;

/**
 * __useUpdateSpecialMenuDesignMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialMenuDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialMenuDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialMenuDesignMutation, { data, loading, error }] = useUpdateSpecialMenuDesignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialMenuDesignMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSpecialMenuDesignMutation, GqlUpdateSpecialMenuDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSpecialMenuDesignMutation, GqlUpdateSpecialMenuDesignMutationVariables>(UpdateSpecialMenuDesignDocument, options);
      }
export type UpdateSpecialMenuDesignMutationHookResult = ReturnType<typeof useUpdateSpecialMenuDesignMutation>;
export type UpdateSpecialMenuDesignMutationResult = Apollo.MutationResult<GqlUpdateSpecialMenuDesignMutation>;
export type UpdateSpecialMenuDesignMutationOptions = Apollo.BaseMutationOptions<GqlUpdateSpecialMenuDesignMutation, GqlUpdateSpecialMenuDesignMutationVariables>;
export const GetEnterpriseSpecialsHistoryDocument = gql`
    query GetEnterpriseSpecialsHistory($enterpriseId: ID!, $enterpriseSpecialId: ID!) {
  getEnterpriseSpecialsHistory(
    enterpriseId: $enterpriseId
    enterpriseSpecialId: $enterpriseSpecialId
  ) {
    id
    enterpriseSpecialId
    versions {
      ...enterpriseSpecialData
    }
  }
}
    ${EnterpriseSpecialDataFragmentDoc}`;

/**
 * __useGetEnterpriseSpecialsHistoryQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseSpecialsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseSpecialsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseSpecialsHistoryQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      enterpriseSpecialId: // value for 'enterpriseSpecialId'
 *   },
 * });
 */
export function useGetEnterpriseSpecialsHistoryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseSpecialsHistoryQuery, GqlGetEnterpriseSpecialsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseSpecialsHistoryQuery, GqlGetEnterpriseSpecialsHistoryQueryVariables>(GetEnterpriseSpecialsHistoryDocument, options);
      }
export function useGetEnterpriseSpecialsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseSpecialsHistoryQuery, GqlGetEnterpriseSpecialsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseSpecialsHistoryQuery, GqlGetEnterpriseSpecialsHistoryQueryVariables>(GetEnterpriseSpecialsHistoryDocument, options);
        }
export type GetEnterpriseSpecialsHistoryQueryHookResult = ReturnType<typeof useGetEnterpriseSpecialsHistoryQuery>;
export type GetEnterpriseSpecialsHistoryLazyQueryHookResult = ReturnType<typeof useGetEnterpriseSpecialsHistoryLazyQuery>;
export type GetEnterpriseSpecialsHistoryQueryResult = Apollo.QueryResult<GqlGetEnterpriseSpecialsHistoryQuery, GqlGetEnterpriseSpecialsHistoryQueryVariables>;
export const ForceDiscountSyncDocument = gql`
    mutation forceDiscountSync($integrationId: String!) {
  forceDiscountSync(integration_id: $integrationId) {
    message
    success
  }
}
    `;
export type GqlForceDiscountSyncMutationFn = Apollo.MutationFunction<GqlForceDiscountSyncMutation, GqlForceDiscountSyncMutationVariables>;

/**
 * __useForceDiscountSyncMutation__
 *
 * To run a mutation, you first call `useForceDiscountSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDiscountSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDiscountSyncMutation, { data, loading, error }] = useForceDiscountSyncMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useForceDiscountSyncMutation(baseOptions?: Apollo.MutationHookOptions<GqlForceDiscountSyncMutation, GqlForceDiscountSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlForceDiscountSyncMutation, GqlForceDiscountSyncMutationVariables>(ForceDiscountSyncDocument, options);
      }
export type ForceDiscountSyncMutationHookResult = ReturnType<typeof useForceDiscountSyncMutation>;
export type ForceDiscountSyncMutationResult = Apollo.MutationResult<GqlForceDiscountSyncMutation>;
export type ForceDiscountSyncMutationOptions = Apollo.BaseMutationOptions<GqlForceDiscountSyncMutation, GqlForceDiscountSyncMutationVariables>;
export const GetSpecialsHistoryDocument = gql`
    query GetSpecialsHistory($specialId: ID!) {
  getSpecialsHistory(specialId: $specialId) {
    id
    versions {
      ...specialData
    }
  }
}
    ${SpecialDataFragmentDoc}`;

/**
 * __useGetSpecialsHistoryQuery__
 *
 * To run a query within a React component, call `useGetSpecialsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialsHistoryQuery({
 *   variables: {
 *      specialId: // value for 'specialId'
 *   },
 * });
 */
export function useGetSpecialsHistoryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetSpecialsHistoryQuery, GqlGetSpecialsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSpecialsHistoryQuery, GqlGetSpecialsHistoryQueryVariables>(GetSpecialsHistoryDocument, options);
      }
export function useGetSpecialsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSpecialsHistoryQuery, GqlGetSpecialsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSpecialsHistoryQuery, GqlGetSpecialsHistoryQueryVariables>(GetSpecialsHistoryDocument, options);
        }
export type GetSpecialsHistoryQueryHookResult = ReturnType<typeof useGetSpecialsHistoryQuery>;
export type GetSpecialsHistoryLazyQueryHookResult = ReturnType<typeof useGetSpecialsHistoryLazyQuery>;
export type GetSpecialsHistoryQueryResult = Apollo.QueryResult<GqlGetSpecialsHistoryQuery, GqlGetSpecialsHistoryQueryVariables>;
export const UpdateSingleDispensaryAdSettingsDocument = gql`
    mutation UpdateSingleDispensaryAdSettings($dispensaryId: String!, $settings: DispensaryAdSettingsInput!) {
  updateSingleDispensaryAdSettings(
    dispensaryId: $dispensaryId
    settings: $settings
  ) {
    id
    adSettings {
      enableAdsForDefault
      enableAdsForEmbedded
      enableAdsForKiosk
      enableAdsForStoreFront
    }
  }
}
    `;
export type GqlUpdateSingleDispensaryAdSettingsMutationFn = Apollo.MutationFunction<GqlUpdateSingleDispensaryAdSettingsMutation, GqlUpdateSingleDispensaryAdSettingsMutationVariables>;

/**
 * __useUpdateSingleDispensaryAdSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSingleDispensaryAdSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleDispensaryAdSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleDispensaryAdSettingsMutation, { data, loading, error }] = useUpdateSingleDispensaryAdSettingsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateSingleDispensaryAdSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSingleDispensaryAdSettingsMutation, GqlUpdateSingleDispensaryAdSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSingleDispensaryAdSettingsMutation, GqlUpdateSingleDispensaryAdSettingsMutationVariables>(UpdateSingleDispensaryAdSettingsDocument, options);
      }
export type UpdateSingleDispensaryAdSettingsMutationHookResult = ReturnType<typeof useUpdateSingleDispensaryAdSettingsMutation>;
export type UpdateSingleDispensaryAdSettingsMutationResult = Apollo.MutationResult<GqlUpdateSingleDispensaryAdSettingsMutation>;
export type UpdateSingleDispensaryAdSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateSingleDispensaryAdSettingsMutation, GqlUpdateSingleDispensaryAdSettingsMutationVariables>;
export const UpdateSingleDispensaryPersonalizationSettingsDocument = gql`
    mutation UpdateSingleDispensaryPersonalizationSettings($dispensaryId: String!, $settings: DispensaryPersonalizationSettingsInput!) {
  updateSingleDispensaryPersonalizationSettings(
    dispensaryId: $dispensaryId
    settings: $settings
  ) {
    id
    personalizationSettings {
      enablePersonalizationForDefault
      enablePersonalizationForEmbedded
      enablePersonalizationForKiosk
      enablePersonalizationForStoreFront
      enableSortByRelevance
    }
  }
}
    `;
export type GqlUpdateSingleDispensaryPersonalizationSettingsMutationFn = Apollo.MutationFunction<GqlUpdateSingleDispensaryPersonalizationSettingsMutation, GqlUpdateSingleDispensaryPersonalizationSettingsMutationVariables>;

/**
 * __useUpdateSingleDispensaryPersonalizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSingleDispensaryPersonalizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleDispensaryPersonalizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleDispensaryPersonalizationSettingsMutation, { data, loading, error }] = useUpdateSingleDispensaryPersonalizationSettingsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateSingleDispensaryPersonalizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSingleDispensaryPersonalizationSettingsMutation, GqlUpdateSingleDispensaryPersonalizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSingleDispensaryPersonalizationSettingsMutation, GqlUpdateSingleDispensaryPersonalizationSettingsMutationVariables>(UpdateSingleDispensaryPersonalizationSettingsDocument, options);
      }
export type UpdateSingleDispensaryPersonalizationSettingsMutationHookResult = ReturnType<typeof useUpdateSingleDispensaryPersonalizationSettingsMutation>;
export type UpdateSingleDispensaryPersonalizationSettingsMutationResult = Apollo.MutationResult<GqlUpdateSingleDispensaryPersonalizationSettingsMutation>;
export type UpdateSingleDispensaryPersonalizationSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateSingleDispensaryPersonalizationSettingsMutation, GqlUpdateSingleDispensaryPersonalizationSettingsMutationVariables>;
export const CreatePlusApiKeyV2Document = gql`
    mutation CreatePlusApiKeyV2($dispensaryId: String!, $keyType: PlusApiKeyType!) {
  createPlusApiKeyV2(dispensaryId: $dispensaryId, keyType: $keyType) {
    id
  }
}
    `;
export type GqlCreatePlusApiKeyV2MutationFn = Apollo.MutationFunction<GqlCreatePlusApiKeyV2Mutation, GqlCreatePlusApiKeyV2MutationVariables>;

/**
 * __useCreatePlusApiKeyV2Mutation__
 *
 * To run a mutation, you first call `useCreatePlusApiKeyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlusApiKeyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlusApiKeyV2Mutation, { data, loading, error }] = useCreatePlusApiKeyV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      keyType: // value for 'keyType'
 *   },
 * });
 */
export function useCreatePlusApiKeyV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePlusApiKeyV2Mutation, GqlCreatePlusApiKeyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePlusApiKeyV2Mutation, GqlCreatePlusApiKeyV2MutationVariables>(CreatePlusApiKeyV2Document, options);
      }
export type CreatePlusApiKeyV2MutationHookResult = ReturnType<typeof useCreatePlusApiKeyV2Mutation>;
export type CreatePlusApiKeyV2MutationResult = Apollo.MutationResult<GqlCreatePlusApiKeyV2Mutation>;
export type CreatePlusApiKeyV2MutationOptions = Apollo.BaseMutationOptions<GqlCreatePlusApiKeyV2Mutation, GqlCreatePlusApiKeyV2MutationVariables>;
export const CreatePlusEnterpriseApiKeyDocument = gql`
    mutation CreatePlusEnterpriseApiKey($enterpriseId: String!, $keyType: PlusApiKeyType!) {
  createPlusEnterpriseApiKey(enterpriseId: $enterpriseId, keyType: $keyType) {
    id
  }
}
    `;
export type GqlCreatePlusEnterpriseApiKeyMutationFn = Apollo.MutationFunction<GqlCreatePlusEnterpriseApiKeyMutation, GqlCreatePlusEnterpriseApiKeyMutationVariables>;

/**
 * __useCreatePlusEnterpriseApiKeyMutation__
 *
 * To run a mutation, you first call `useCreatePlusEnterpriseApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlusEnterpriseApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlusEnterpriseApiKeyMutation, { data, loading, error }] = useCreatePlusEnterpriseApiKeyMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      keyType: // value for 'keyType'
 *   },
 * });
 */
export function useCreatePlusEnterpriseApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePlusEnterpriseApiKeyMutation, GqlCreatePlusEnterpriseApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePlusEnterpriseApiKeyMutation, GqlCreatePlusEnterpriseApiKeyMutationVariables>(CreatePlusEnterpriseApiKeyDocument, options);
      }
export type CreatePlusEnterpriseApiKeyMutationHookResult = ReturnType<typeof useCreatePlusEnterpriseApiKeyMutation>;
export type CreatePlusEnterpriseApiKeyMutationResult = Apollo.MutationResult<GqlCreatePlusEnterpriseApiKeyMutation>;
export type CreatePlusEnterpriseApiKeyMutationOptions = Apollo.BaseMutationOptions<GqlCreatePlusEnterpriseApiKeyMutation, GqlCreatePlusEnterpriseApiKeyMutationVariables>;
export const ExpirePlusApiKeyDocument = gql`
    mutation ExpirePlusApiKey($id: String!) {
  expirePlusApiKey(id: $id) {
    id
  }
}
    `;
export type GqlExpirePlusApiKeyMutationFn = Apollo.MutationFunction<GqlExpirePlusApiKeyMutation, GqlExpirePlusApiKeyMutationVariables>;

/**
 * __useExpirePlusApiKeyMutation__
 *
 * To run a mutation, you first call `useExpirePlusApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpirePlusApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expirePlusApiKeyMutation, { data, loading, error }] = useExpirePlusApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpirePlusApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<GqlExpirePlusApiKeyMutation, GqlExpirePlusApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlExpirePlusApiKeyMutation, GqlExpirePlusApiKeyMutationVariables>(ExpirePlusApiKeyDocument, options);
      }
export type ExpirePlusApiKeyMutationHookResult = ReturnType<typeof useExpirePlusApiKeyMutation>;
export type ExpirePlusApiKeyMutationResult = Apollo.MutationResult<GqlExpirePlusApiKeyMutation>;
export type ExpirePlusApiKeyMutationOptions = Apollo.BaseMutationOptions<GqlExpirePlusApiKeyMutation, GqlExpirePlusApiKeyMutationVariables>;
export const ExpirePlusEnterpriseApiKeyDocument = gql`
    mutation ExpirePlusEnterpriseApiKey($id: String!) {
  expirePlusEnterpriseApiKey(id: $id) {
    id
  }
}
    `;
export type GqlExpirePlusEnterpriseApiKeyMutationFn = Apollo.MutationFunction<GqlExpirePlusEnterpriseApiKeyMutation, GqlExpirePlusEnterpriseApiKeyMutationVariables>;

/**
 * __useExpirePlusEnterpriseApiKeyMutation__
 *
 * To run a mutation, you first call `useExpirePlusEnterpriseApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpirePlusEnterpriseApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expirePlusEnterpriseApiKeyMutation, { data, loading, error }] = useExpirePlusEnterpriseApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpirePlusEnterpriseApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<GqlExpirePlusEnterpriseApiKeyMutation, GqlExpirePlusEnterpriseApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlExpirePlusEnterpriseApiKeyMutation, GqlExpirePlusEnterpriseApiKeyMutationVariables>(ExpirePlusEnterpriseApiKeyDocument, options);
      }
export type ExpirePlusEnterpriseApiKeyMutationHookResult = ReturnType<typeof useExpirePlusEnterpriseApiKeyMutation>;
export type ExpirePlusEnterpriseApiKeyMutationResult = Apollo.MutationResult<GqlExpirePlusEnterpriseApiKeyMutation>;
export type ExpirePlusEnterpriseApiKeyMutationOptions = Apollo.BaseMutationOptions<GqlExpirePlusEnterpriseApiKeyMutation, GqlExpirePlusEnterpriseApiKeyMutationVariables>;
export const GetEnterpriseIdForApiKeysDocument = gql`
    query GetEnterpriseIdForApiKeys($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    retailer {
      enterpriseId
    }
  }
}
    `;

/**
 * __useGetEnterpriseIdForApiKeysQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseIdForApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseIdForApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseIdForApiKeysQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useGetEnterpriseIdForApiKeysQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseIdForApiKeysQuery, GqlGetEnterpriseIdForApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseIdForApiKeysQuery, GqlGetEnterpriseIdForApiKeysQueryVariables>(GetEnterpriseIdForApiKeysDocument, options);
      }
export function useGetEnterpriseIdForApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseIdForApiKeysQuery, GqlGetEnterpriseIdForApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseIdForApiKeysQuery, GqlGetEnterpriseIdForApiKeysQueryVariables>(GetEnterpriseIdForApiKeysDocument, options);
        }
export type GetEnterpriseIdForApiKeysQueryHookResult = ReturnType<typeof useGetEnterpriseIdForApiKeysQuery>;
export type GetEnterpriseIdForApiKeysLazyQueryHookResult = ReturnType<typeof useGetEnterpriseIdForApiKeysLazyQuery>;
export type GetEnterpriseIdForApiKeysQueryResult = Apollo.QueryResult<GqlGetEnterpriseIdForApiKeysQuery, GqlGetEnterpriseIdForApiKeysQueryVariables>;
export const GetPlusApiKeysDocument = gql`
    query GetPlusApiKeys($dispensaryId: String!) {
  getPlusApiKeys(dispensaryId: $dispensaryId) {
    createdAt
    fresh
    id
    key
    keyType
    lastRequestAt
  }
}
    `;

/**
 * __useGetPlusApiKeysQuery__
 *
 * To run a query within a React component, call `useGetPlusApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlusApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlusApiKeysQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPlusApiKeysQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPlusApiKeysQuery, GqlGetPlusApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPlusApiKeysQuery, GqlGetPlusApiKeysQueryVariables>(GetPlusApiKeysDocument, options);
      }
export function useGetPlusApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPlusApiKeysQuery, GqlGetPlusApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPlusApiKeysQuery, GqlGetPlusApiKeysQueryVariables>(GetPlusApiKeysDocument, options);
        }
export type GetPlusApiKeysQueryHookResult = ReturnType<typeof useGetPlusApiKeysQuery>;
export type GetPlusApiKeysLazyQueryHookResult = ReturnType<typeof useGetPlusApiKeysLazyQuery>;
export type GetPlusApiKeysQueryResult = Apollo.QueryResult<GqlGetPlusApiKeysQuery, GqlGetPlusApiKeysQueryVariables>;
export const GetPlusEnterpriseApiKeysDocument = gql`
    query GetPlusEnterpriseApiKeys($enterpriseId: String!) {
  getPlusEnterpriseApiKeys(enterpriseId: $enterpriseId) {
    createdAt
    fresh
    id
    key
    keyType
    lastRequestAt
  }
}
    `;

/**
 * __useGetPlusEnterpriseApiKeysQuery__
 *
 * To run a query within a React component, call `useGetPlusEnterpriseApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlusEnterpriseApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlusEnterpriseApiKeysQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetPlusEnterpriseApiKeysQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPlusEnterpriseApiKeysQuery, GqlGetPlusEnterpriseApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPlusEnterpriseApiKeysQuery, GqlGetPlusEnterpriseApiKeysQueryVariables>(GetPlusEnterpriseApiKeysDocument, options);
      }
export function useGetPlusEnterpriseApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPlusEnterpriseApiKeysQuery, GqlGetPlusEnterpriseApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPlusEnterpriseApiKeysQuery, GqlGetPlusEnterpriseApiKeysQueryVariables>(GetPlusEnterpriseApiKeysDocument, options);
        }
export type GetPlusEnterpriseApiKeysQueryHookResult = ReturnType<typeof useGetPlusEnterpriseApiKeysQuery>;
export type GetPlusEnterpriseApiKeysLazyQueryHookResult = ReturnType<typeof useGetPlusEnterpriseApiKeysLazyQuery>;
export type GetPlusEnterpriseApiKeysQueryResult = Apollo.QueryResult<GqlGetPlusEnterpriseApiKeysQuery, GqlGetPlusEnterpriseApiKeysQueryVariables>;
export const GetDispensarySettingsAuditLogsDocument = gql`
    query GetDispensarySettingsAuditLogs($dispensaryId: ID, $source: String, $limit: Int, $offset: Int) {
  getDispensarySettingsAuditLogs(
    dispensaryId: $dispensaryId
    source: $source
    limit: $limit
    offset: $offset
  ) {
    logs {
      id
      dispensaryId
      source
      actorEmail
      actorUserId
      changedFields
      priorValues
      newValues
      createdAt
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useGetDispensarySettingsAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetDispensarySettingsAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispensarySettingsAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispensarySettingsAuditLogsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      source: // value for 'source'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDispensarySettingsAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetDispensarySettingsAuditLogsQuery, GqlGetDispensarySettingsAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDispensarySettingsAuditLogsQuery, GqlGetDispensarySettingsAuditLogsQueryVariables>(GetDispensarySettingsAuditLogsDocument, options);
      }
export function useGetDispensarySettingsAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDispensarySettingsAuditLogsQuery, GqlGetDispensarySettingsAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDispensarySettingsAuditLogsQuery, GqlGetDispensarySettingsAuditLogsQueryVariables>(GetDispensarySettingsAuditLogsDocument, options);
        }
export type GetDispensarySettingsAuditLogsQueryHookResult = ReturnType<typeof useGetDispensarySettingsAuditLogsQuery>;
export type GetDispensarySettingsAuditLogsLazyQueryHookResult = ReturnType<typeof useGetDispensarySettingsAuditLogsLazyQuery>;
export type GetDispensarySettingsAuditLogsQueryResult = Apollo.QueryResult<GqlGetDispensarySettingsAuditLogsQuery, GqlGetDispensarySettingsAuditLogsQueryVariables>;
export const DeleteDeviceV2Document = gql`
    mutation DeleteDeviceV2($id: ID!) {
  deleteDeviceV2(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteDeviceV2MutationFn = Apollo.MutationFunction<GqlDeleteDeviceV2Mutation, GqlDeleteDeviceV2MutationVariables>;

/**
 * __useDeleteDeviceV2Mutation__
 *
 * To run a mutation, you first call `useDeleteDeviceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceV2Mutation, { data, loading, error }] = useDeleteDeviceV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteDeviceV2Mutation, GqlDeleteDeviceV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteDeviceV2Mutation, GqlDeleteDeviceV2MutationVariables>(DeleteDeviceV2Document, options);
      }
export type DeleteDeviceV2MutationHookResult = ReturnType<typeof useDeleteDeviceV2Mutation>;
export type DeleteDeviceV2MutationResult = Apollo.MutationResult<GqlDeleteDeviceV2Mutation>;
export type DeleteDeviceV2MutationOptions = Apollo.BaseMutationOptions<GqlDeleteDeviceV2Mutation, GqlDeleteDeviceV2MutationVariables>;
export const ConsumeDeviceAccessCodeDocument = gql`
    mutation ConsumeDeviceAccessCode($accessCode: String!, $dispensaryId: String!) {
  consumeDeviceAccessCode(accessCode: $accessCode, dispensaryId: $dispensaryId) {
    accessCode
    channel
    channelKey
  }
}
    `;
export type GqlConsumeDeviceAccessCodeMutationFn = Apollo.MutationFunction<GqlConsumeDeviceAccessCodeMutation, GqlConsumeDeviceAccessCodeMutationVariables>;

/**
 * __useConsumeDeviceAccessCodeMutation__
 *
 * To run a mutation, you first call `useConsumeDeviceAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeDeviceAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeDeviceAccessCodeMutation, { data, loading, error }] = useConsumeDeviceAccessCodeMutation({
 *   variables: {
 *      accessCode: // value for 'accessCode'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useConsumeDeviceAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlConsumeDeviceAccessCodeMutation, GqlConsumeDeviceAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlConsumeDeviceAccessCodeMutation, GqlConsumeDeviceAccessCodeMutationVariables>(ConsumeDeviceAccessCodeDocument, options);
      }
export type ConsumeDeviceAccessCodeMutationHookResult = ReturnType<typeof useConsumeDeviceAccessCodeMutation>;
export type ConsumeDeviceAccessCodeMutationResult = Apollo.MutationResult<GqlConsumeDeviceAccessCodeMutation>;
export type ConsumeDeviceAccessCodeMutationOptions = Apollo.BaseMutationOptions<GqlConsumeDeviceAccessCodeMutation, GqlConsumeDeviceAccessCodeMutationVariables>;
export const UpdateAutoPrintDevicesV2Document = gql`
    mutation UpdateAutoPrintDevicesV2($dispensaryId: String!, $deviceIds: [String!]!) {
  updateAutoPrintDevicesV2(dispensaryId: $dispensaryId, deviceIds: $deviceIds) {
    message
    success
  }
}
    `;
export type GqlUpdateAutoPrintDevicesV2MutationFn = Apollo.MutationFunction<GqlUpdateAutoPrintDevicesV2Mutation, GqlUpdateAutoPrintDevicesV2MutationVariables>;

/**
 * __useUpdateAutoPrintDevicesV2Mutation__
 *
 * To run a mutation, you first call `useUpdateAutoPrintDevicesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoPrintDevicesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoPrintDevicesV2Mutation, { data, loading, error }] = useUpdateAutoPrintDevicesV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      deviceIds: // value for 'deviceIds'
 *   },
 * });
 */
export function useUpdateAutoPrintDevicesV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateAutoPrintDevicesV2Mutation, GqlUpdateAutoPrintDevicesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateAutoPrintDevicesV2Mutation, GqlUpdateAutoPrintDevicesV2MutationVariables>(UpdateAutoPrintDevicesV2Document, options);
      }
export type UpdateAutoPrintDevicesV2MutationHookResult = ReturnType<typeof useUpdateAutoPrintDevicesV2Mutation>;
export type UpdateAutoPrintDevicesV2MutationResult = Apollo.MutationResult<GqlUpdateAutoPrintDevicesV2Mutation>;
export type UpdateAutoPrintDevicesV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateAutoPrintDevicesV2Mutation, GqlUpdateAutoPrintDevicesV2MutationVariables>;
export const CreateReservationSlotsDocument = gql`
    mutation createReservationSlots($input: ReservationSlotsCreateInput!) {
  createReservationSlots(input: $input) {
    success
  }
}
    `;
export type GqlCreateReservationSlotsMutationFn = Apollo.MutationFunction<GqlCreateReservationSlotsMutation, GqlCreateReservationSlotsMutationVariables>;

/**
 * __useCreateReservationSlotsMutation__
 *
 * To run a mutation, you first call `useCreateReservationSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationSlotsMutation, { data, loading, error }] = useCreateReservationSlotsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReservationSlotsMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateReservationSlotsMutation, GqlCreateReservationSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateReservationSlotsMutation, GqlCreateReservationSlotsMutationVariables>(CreateReservationSlotsDocument, options);
      }
export type CreateReservationSlotsMutationHookResult = ReturnType<typeof useCreateReservationSlotsMutation>;
export type CreateReservationSlotsMutationResult = Apollo.MutationResult<GqlCreateReservationSlotsMutation>;
export type CreateReservationSlotsMutationOptions = Apollo.BaseMutationOptions<GqlCreateReservationSlotsMutation, GqlCreateReservationSlotsMutationVariables>;
export const DeleteSpecialHoursDocument = gql`
    mutation deleteSpecialHours($dispensaryId: String!, $specialHoursIds: [ID]!) {
  deleteSpecialHours(
    dispensaryId: $dispensaryId
    specialHoursIds: $specialHoursIds
  ) {
    success
  }
}
    `;
export type GqlDeleteSpecialHoursMutationFn = Apollo.MutationFunction<GqlDeleteSpecialHoursMutation, GqlDeleteSpecialHoursMutationVariables>;

/**
 * __useDeleteSpecialHoursMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialHoursMutation, { data, loading, error }] = useDeleteSpecialHoursMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      specialHoursIds: // value for 'specialHoursIds'
 *   },
 * });
 */
export function useDeleteSpecialHoursMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteSpecialHoursMutation, GqlDeleteSpecialHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteSpecialHoursMutation, GqlDeleteSpecialHoursMutationVariables>(DeleteSpecialHoursDocument, options);
      }
export type DeleteSpecialHoursMutationHookResult = ReturnType<typeof useDeleteSpecialHoursMutation>;
export type DeleteSpecialHoursMutationResult = Apollo.MutationResult<GqlDeleteSpecialHoursMutation>;
export type DeleteSpecialHoursMutationOptions = Apollo.BaseMutationOptions<GqlDeleteSpecialHoursMutation, GqlDeleteSpecialHoursMutationVariables>;
export const UpdateHoursSettingsDocument = gql`
    mutation updateHoursSettings($input: HoursSettingsUpdateInput!) {
  updateHoursSettings(input: $input) {
    success
  }
}
    `;
export type GqlUpdateHoursSettingsMutationFn = Apollo.MutationFunction<GqlUpdateHoursSettingsMutation, GqlUpdateHoursSettingsMutationVariables>;

/**
 * __useUpdateHoursSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateHoursSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHoursSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHoursSettingsMutation, { data, loading, error }] = useUpdateHoursSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHoursSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateHoursSettingsMutation, GqlUpdateHoursSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateHoursSettingsMutation, GqlUpdateHoursSettingsMutationVariables>(UpdateHoursSettingsDocument, options);
      }
export type UpdateHoursSettingsMutationHookResult = ReturnType<typeof useUpdateHoursSettingsMutation>;
export type UpdateHoursSettingsMutationResult = Apollo.MutationResult<GqlUpdateHoursSettingsMutation>;
export type UpdateHoursSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateHoursSettingsMutation, GqlUpdateHoursSettingsMutationVariables>;
export const ForceMenuPricingSyncDocument = gql`
    mutation forceMenuPricingSync($dispensaryId: String!) {
  forceMenuPricingSync(dispensary_id: $dispensaryId) {
    message
    success
  }
}
    `;
export type GqlForceMenuPricingSyncMutationFn = Apollo.MutationFunction<GqlForceMenuPricingSyncMutation, GqlForceMenuPricingSyncMutationVariables>;

/**
 * __useForceMenuPricingSyncMutation__
 *
 * To run a mutation, you first call `useForceMenuPricingSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceMenuPricingSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceMenuPricingSyncMutation, { data, loading, error }] = useForceMenuPricingSyncMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useForceMenuPricingSyncMutation(baseOptions?: Apollo.MutationHookOptions<GqlForceMenuPricingSyncMutation, GqlForceMenuPricingSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlForceMenuPricingSyncMutation, GqlForceMenuPricingSyncMutationVariables>(ForceMenuPricingSyncDocument, options);
      }
export type ForceMenuPricingSyncMutationHookResult = ReturnType<typeof useForceMenuPricingSyncMutation>;
export type ForceMenuPricingSyncMutationResult = Apollo.MutationResult<GqlForceMenuPricingSyncMutation>;
export type ForceMenuPricingSyncMutationOptions = Apollo.BaseMutationOptions<GqlForceMenuPricingSyncMutation, GqlForceMenuPricingSyncMutationVariables>;
export const IntegrationsDeleteInArmaDocument = gql`
    mutation IntegrationsDeleteInArma($integrationId: String!) {
  integrationsDeleteInArma(integrationId: $integrationId) {
    message
    success
  }
}
    `;
export type GqlIntegrationsDeleteInArmaMutationFn = Apollo.MutationFunction<GqlIntegrationsDeleteInArmaMutation, GqlIntegrationsDeleteInArmaMutationVariables>;

/**
 * __useIntegrationsDeleteInArmaMutation__
 *
 * To run a mutation, you first call `useIntegrationsDeleteInArmaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsDeleteInArmaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationsDeleteInArmaMutation, { data, loading, error }] = useIntegrationsDeleteInArmaMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationsDeleteInArmaMutation(baseOptions?: Apollo.MutationHookOptions<GqlIntegrationsDeleteInArmaMutation, GqlIntegrationsDeleteInArmaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlIntegrationsDeleteInArmaMutation, GqlIntegrationsDeleteInArmaMutationVariables>(IntegrationsDeleteInArmaDocument, options);
      }
export type IntegrationsDeleteInArmaMutationHookResult = ReturnType<typeof useIntegrationsDeleteInArmaMutation>;
export type IntegrationsDeleteInArmaMutationResult = Apollo.MutationResult<GqlIntegrationsDeleteInArmaMutation>;
export type IntegrationsDeleteInArmaMutationOptions = Apollo.BaseMutationOptions<GqlIntegrationsDeleteInArmaMutation, GqlIntegrationsDeleteInArmaMutationVariables>;
export const IntegrationsWipeMenuInArmaDocument = gql`
    mutation IntegrationsWipeMenuInArma($dispensaryId: String!, $integrationId: String!) {
  integrationsWipeMenuInArma(
    dispensaryId: $dispensaryId
    integrationId: $integrationId
  ) {
    success
    message
  }
}
    `;
export type GqlIntegrationsWipeMenuInArmaMutationFn = Apollo.MutationFunction<GqlIntegrationsWipeMenuInArmaMutation, GqlIntegrationsWipeMenuInArmaMutationVariables>;

/**
 * __useIntegrationsWipeMenuInArmaMutation__
 *
 * To run a mutation, you first call `useIntegrationsWipeMenuInArmaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsWipeMenuInArmaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationsWipeMenuInArmaMutation, { data, loading, error }] = useIntegrationsWipeMenuInArmaMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationsWipeMenuInArmaMutation(baseOptions?: Apollo.MutationHookOptions<GqlIntegrationsWipeMenuInArmaMutation, GqlIntegrationsWipeMenuInArmaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlIntegrationsWipeMenuInArmaMutation, GqlIntegrationsWipeMenuInArmaMutationVariables>(IntegrationsWipeMenuInArmaDocument, options);
      }
export type IntegrationsWipeMenuInArmaMutationHookResult = ReturnType<typeof useIntegrationsWipeMenuInArmaMutation>;
export type IntegrationsWipeMenuInArmaMutationResult = Apollo.MutationResult<GqlIntegrationsWipeMenuInArmaMutation>;
export type IntegrationsWipeMenuInArmaMutationOptions = Apollo.BaseMutationOptions<GqlIntegrationsWipeMenuInArmaMutation, GqlIntegrationsWipeMenuInArmaMutationVariables>;
export const GetConsumerPulseAccessDocument = gql`
    query GetConsumerPulseAccess($dispensaryId: String!) {
  getConsumerPulseAccess(dispensaryId: $dispensaryId) {
    eligible
    enabled
  }
}
    `;

/**
 * __useGetConsumerPulseAccessQuery__
 *
 * To run a query within a React component, call `useGetConsumerPulseAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerPulseAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerPulseAccessQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetConsumerPulseAccessQuery(baseOptions: Apollo.QueryHookOptions<GqlGetConsumerPulseAccessQuery, GqlGetConsumerPulseAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetConsumerPulseAccessQuery, GqlGetConsumerPulseAccessQueryVariables>(GetConsumerPulseAccessDocument, options);
      }
export function useGetConsumerPulseAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetConsumerPulseAccessQuery, GqlGetConsumerPulseAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetConsumerPulseAccessQuery, GqlGetConsumerPulseAccessQueryVariables>(GetConsumerPulseAccessDocument, options);
        }
export type GetConsumerPulseAccessQueryHookResult = ReturnType<typeof useGetConsumerPulseAccessQuery>;
export type GetConsumerPulseAccessLazyQueryHookResult = ReturnType<typeof useGetConsumerPulseAccessLazyQuery>;
export type GetConsumerPulseAccessQueryResult = Apollo.QueryResult<GqlGetConsumerPulseAccessQuery, GqlGetConsumerPulseAccessQueryVariables>;
export const UpdateConsumerPulseSettingsDocument = gql`
    mutation UpdateConsumerPulseSettings($input: UpdateConsumerPulseSettingsInput!) {
  updateConsumerPulseSettings(input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdateConsumerPulseSettingsMutationFn = Apollo.MutationFunction<GqlUpdateConsumerPulseSettingsMutation, GqlUpdateConsumerPulseSettingsMutationVariables>;

/**
 * __useUpdateConsumerPulseSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateConsumerPulseSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsumerPulseSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsumerPulseSettingsMutation, { data, loading, error }] = useUpdateConsumerPulseSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConsumerPulseSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateConsumerPulseSettingsMutation, GqlUpdateConsumerPulseSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateConsumerPulseSettingsMutation, GqlUpdateConsumerPulseSettingsMutationVariables>(UpdateConsumerPulseSettingsDocument, options);
      }
export type UpdateConsumerPulseSettingsMutationHookResult = ReturnType<typeof useUpdateConsumerPulseSettingsMutation>;
export type UpdateConsumerPulseSettingsMutationResult = Apollo.MutationResult<GqlUpdateConsumerPulseSettingsMutation>;
export type UpdateConsumerPulseSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateConsumerPulseSettingsMutation, GqlUpdateConsumerPulseSettingsMutationVariables>;
export const AddBlockedAddressDocument = gql`
    mutation AddBlockedAddress($dispensaryId: String!, $address: BlockedAddressInput!) {
  addBlockedAddress(dispensaryId: $dispensaryId, address: $address) {
    id
    address
    note
    createdAt
  }
}
    `;
export type GqlAddBlockedAddressMutationFn = Apollo.MutationFunction<GqlAddBlockedAddressMutation, GqlAddBlockedAddressMutationVariables>;

/**
 * __useAddBlockedAddressMutation__
 *
 * To run a mutation, you first call `useAddBlockedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlockedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlockedAddressMutation, { data, loading, error }] = useAddBlockedAddressMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddBlockedAddressMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddBlockedAddressMutation, GqlAddBlockedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAddBlockedAddressMutation, GqlAddBlockedAddressMutationVariables>(AddBlockedAddressDocument, options);
      }
export type AddBlockedAddressMutationHookResult = ReturnType<typeof useAddBlockedAddressMutation>;
export type AddBlockedAddressMutationResult = Apollo.MutationResult<GqlAddBlockedAddressMutation>;
export type AddBlockedAddressMutationOptions = Apollo.BaseMutationOptions<GqlAddBlockedAddressMutation, GqlAddBlockedAddressMutationVariables>;
export const RemoveBlockedAddressDocument = gql`
    mutation RemoveBlockedAddress($dispensaryId: String!, $id: String!) {
  removeBlockedAddress(dispensaryId: $dispensaryId, id: $id) {
    success
  }
}
    `;
export type GqlRemoveBlockedAddressMutationFn = Apollo.MutationFunction<GqlRemoveBlockedAddressMutation, GqlRemoveBlockedAddressMutationVariables>;

/**
 * __useRemoveBlockedAddressMutation__
 *
 * To run a mutation, you first call `useRemoveBlockedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockedAddressMutation, { data, loading, error }] = useRemoveBlockedAddressMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBlockedAddressMutation(baseOptions?: Apollo.MutationHookOptions<GqlRemoveBlockedAddressMutation, GqlRemoveBlockedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRemoveBlockedAddressMutation, GqlRemoveBlockedAddressMutationVariables>(RemoveBlockedAddressDocument, options);
      }
export type RemoveBlockedAddressMutationHookResult = ReturnType<typeof useRemoveBlockedAddressMutation>;
export type RemoveBlockedAddressMutationResult = Apollo.MutationResult<GqlRemoveBlockedAddressMutation>;
export type RemoveBlockedAddressMutationOptions = Apollo.BaseMutationOptions<GqlRemoveBlockedAddressMutation, GqlRemoveBlockedAddressMutationVariables>;
export const ReservationSlotsByOrderTypeDocument = gql`
    query ReservationSlotsByOrderType($dispensaryId: ID!, $reservationType: String) {
  getReservationSlotsByOrderType(
    dispensaryId: $dispensaryId
    reservationType: $reservationType
  ) {
    inStorePickup {
      maxReservationSlotsByDay {
        ...maxReservationSlotsByDayFragment
      }
      maxReservationSlotsByDate {
        ...maxReservationSlotFragment
      }
    }
    curbsidePickup {
      maxReservationSlotsByDay {
        ...maxReservationSlotsByDayFragment
      }
      maxReservationSlotsByDate {
        ...maxReservationSlotFragment
      }
    }
    driveThruPickup {
      maxReservationSlotsByDay {
        ...maxReservationSlotsByDayFragment
      }
      maxReservationSlotsByDate {
        ...maxReservationSlotFragment
      }
    }
    delivery {
      maxReservationSlotsByDay {
        ...maxReservationSlotsByDayFragment
      }
      maxReservationSlotsByDate {
        ...maxReservationSlotFragment
      }
    }
  }
}
    ${MaxReservationSlotsByDayFragmentFragmentDoc}
${MaxReservationSlotFragmentFragmentDoc}`;

/**
 * __useReservationSlotsByOrderTypeQuery__
 *
 * To run a query within a React component, call `useReservationSlotsByOrderTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationSlotsByOrderTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationSlotsByOrderTypeQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      reservationType: // value for 'reservationType'
 *   },
 * });
 */
export function useReservationSlotsByOrderTypeQuery(baseOptions: Apollo.QueryHookOptions<GqlReservationSlotsByOrderTypeQuery, GqlReservationSlotsByOrderTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlReservationSlotsByOrderTypeQuery, GqlReservationSlotsByOrderTypeQueryVariables>(ReservationSlotsByOrderTypeDocument, options);
      }
export function useReservationSlotsByOrderTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlReservationSlotsByOrderTypeQuery, GqlReservationSlotsByOrderTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlReservationSlotsByOrderTypeQuery, GqlReservationSlotsByOrderTypeQueryVariables>(ReservationSlotsByOrderTypeDocument, options);
        }
export type ReservationSlotsByOrderTypeQueryHookResult = ReturnType<typeof useReservationSlotsByOrderTypeQuery>;
export type ReservationSlotsByOrderTypeLazyQueryHookResult = ReturnType<typeof useReservationSlotsByOrderTypeLazyQuery>;
export type ReservationSlotsByOrderTypeQueryResult = Apollo.QueryResult<GqlReservationSlotsByOrderTypeQuery, GqlReservationSlotsByOrderTypeQueryVariables>;
export const GetRetailerEnrollmentStatusDocument = gql`
    query GetRetailerEnrollmentStatus($entityId: String!, $entityType: EntityTypes!) {
  getRetailerEnrollmentStatus(entityId: $entityId, entityType: $entityType) {
    enrollment {
      status
    }
  }
}
    `;

/**
 * __useGetRetailerEnrollmentStatusQuery__
 *
 * To run a query within a React component, call `useGetRetailerEnrollmentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailerEnrollmentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailerEnrollmentStatusQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetRetailerEnrollmentStatusQuery(baseOptions: Apollo.QueryHookOptions<GqlGetRetailerEnrollmentStatusQuery, GqlGetRetailerEnrollmentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetRetailerEnrollmentStatusQuery, GqlGetRetailerEnrollmentStatusQueryVariables>(GetRetailerEnrollmentStatusDocument, options);
      }
export function useGetRetailerEnrollmentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetRetailerEnrollmentStatusQuery, GqlGetRetailerEnrollmentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetRetailerEnrollmentStatusQuery, GqlGetRetailerEnrollmentStatusQueryVariables>(GetRetailerEnrollmentStatusDocument, options);
        }
export type GetRetailerEnrollmentStatusQueryHookResult = ReturnType<typeof useGetRetailerEnrollmentStatusQuery>;
export type GetRetailerEnrollmentStatusLazyQueryHookResult = ReturnType<typeof useGetRetailerEnrollmentStatusLazyQuery>;
export type GetRetailerEnrollmentStatusQueryResult = Apollo.QueryResult<GqlGetRetailerEnrollmentStatusQuery, GqlGetRetailerEnrollmentStatusQueryVariables>;
export const UnclaimKioskDocument = gql`
    mutation UnclaimKiosk($dispensaryId: String!, $kioskId: String!) {
  unclaimKiosk(dispensaryId: $dispensaryId, kioskId: $kioskId) {
    success
    message
  }
}
    `;
export type GqlUnclaimKioskMutationFn = Apollo.MutationFunction<GqlUnclaimKioskMutation, GqlUnclaimKioskMutationVariables>;

/**
 * __useUnclaimKioskMutation__
 *
 * To run a mutation, you first call `useUnclaimKioskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnclaimKioskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unclaimKioskMutation, { data, loading, error }] = useUnclaimKioskMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      kioskId: // value for 'kioskId'
 *   },
 * });
 */
export function useUnclaimKioskMutation(baseOptions?: Apollo.MutationHookOptions<GqlUnclaimKioskMutation, GqlUnclaimKioskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUnclaimKioskMutation, GqlUnclaimKioskMutationVariables>(UnclaimKioskDocument, options);
      }
export type UnclaimKioskMutationHookResult = ReturnType<typeof useUnclaimKioskMutation>;
export type UnclaimKioskMutationResult = Apollo.MutationResult<GqlUnclaimKioskMutation>;
export type UnclaimKioskMutationOptions = Apollo.BaseMutationOptions<GqlUnclaimKioskMutation, GqlUnclaimKioskMutationVariables>;
export const ListRetailerPaymentTypesStatusDocument = gql`
    query ListRetailerPaymentTypesStatus($ecommLocationId: String!) {
  listRetailerPaymentTypesStatus(ecommLocationId: $ecommLocationId) {
    paymentTypes {
      enabled
      type
      orderTypes {
        curbsidePickup
        driveThruPickup
        pickup
        delivery
      }
    }
  }
}
    `;

/**
 * __useListRetailerPaymentTypesStatusQuery__
 *
 * To run a query within a React component, call `useListRetailerPaymentTypesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRetailerPaymentTypesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRetailerPaymentTypesStatusQuery({
 *   variables: {
 *      ecommLocationId: // value for 'ecommLocationId'
 *   },
 * });
 */
export function useListRetailerPaymentTypesStatusQuery(baseOptions: Apollo.QueryHookOptions<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>(ListRetailerPaymentTypesStatusDocument, options);
      }
export function useListRetailerPaymentTypesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>(ListRetailerPaymentTypesStatusDocument, options);
        }
export type ListRetailerPaymentTypesStatusQueryHookResult = ReturnType<typeof useListRetailerPaymentTypesStatusQuery>;
export type ListRetailerPaymentTypesStatusLazyQueryHookResult = ReturnType<typeof useListRetailerPaymentTypesStatusLazyQuery>;
export type ListRetailerPaymentTypesStatusQueryResult = Apollo.QueryResult<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>;
export const PreviewReservationSlotStrandingsDocument = gql`
    mutation previewReservationSlotStrandings($input: ReservationSlotsCreateInput!) {
  previewReservationSlotStrandings(input: $input) {
    strandedCount
  }
}
    `;
export type GqlPreviewReservationSlotStrandingsMutationFn = Apollo.MutationFunction<GqlPreviewReservationSlotStrandingsMutation, GqlPreviewReservationSlotStrandingsMutationVariables>;

/**
 * __usePreviewReservationSlotStrandingsMutation__
 *
 * To run a mutation, you first call `usePreviewReservationSlotStrandingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewReservationSlotStrandingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewReservationSlotStrandingsMutation, { data, loading, error }] = usePreviewReservationSlotStrandingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewReservationSlotStrandingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlPreviewReservationSlotStrandingsMutation, GqlPreviewReservationSlotStrandingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlPreviewReservationSlotStrandingsMutation, GqlPreviewReservationSlotStrandingsMutationVariables>(PreviewReservationSlotStrandingsDocument, options);
      }
export type PreviewReservationSlotStrandingsMutationHookResult = ReturnType<typeof usePreviewReservationSlotStrandingsMutation>;
export type PreviewReservationSlotStrandingsMutationResult = Apollo.MutationResult<GqlPreviewReservationSlotStrandingsMutation>;
export type PreviewReservationSlotStrandingsMutationOptions = Apollo.BaseMutationOptions<GqlPreviewReservationSlotStrandingsMutation, GqlPreviewReservationSlotStrandingsMutationVariables>;
export const UpdateOrderingSettingsDocument = gql`
    mutation updateOrderingSettings($input: OrderingSettingsUpdateInput!) {
  updateOrderingSettings(input: $input) {
    success
  }
}
    `;
export type GqlUpdateOrderingSettingsMutationFn = Apollo.MutationFunction<GqlUpdateOrderingSettingsMutation, GqlUpdateOrderingSettingsMutationVariables>;

/**
 * __useUpdateOrderingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderingSettingsMutation, { data, loading, error }] = useUpdateOrderingSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateOrderingSettingsMutation, GqlUpdateOrderingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateOrderingSettingsMutation, GqlUpdateOrderingSettingsMutationVariables>(UpdateOrderingSettingsDocument, options);
      }
export type UpdateOrderingSettingsMutationHookResult = ReturnType<typeof useUpdateOrderingSettingsMutation>;
export type UpdateOrderingSettingsMutationResult = Apollo.MutationResult<GqlUpdateOrderingSettingsMutation>;
export type UpdateOrderingSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateOrderingSettingsMutation, GqlUpdateOrderingSettingsMutationVariables>;
export const UpdateReservationSlotsDocument = gql`
    mutation updateReservationSlots($input: ReservationSlotsUpdateInput!) {
  updateReservationSlots(input: $input) {
    success
  }
}
    `;
export type GqlUpdateReservationSlotsMutationFn = Apollo.MutationFunction<GqlUpdateReservationSlotsMutation, GqlUpdateReservationSlotsMutationVariables>;

/**
 * __useUpdateReservationSlotsMutation__
 *
 * To run a mutation, you first call `useUpdateReservationSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationSlotsMutation, { data, loading, error }] = useUpdateReservationSlotsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReservationSlotsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateReservationSlotsMutation, GqlUpdateReservationSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateReservationSlotsMutation, GqlUpdateReservationSlotsMutationVariables>(UpdateReservationSlotsDocument, options);
      }
export type UpdateReservationSlotsMutationHookResult = ReturnType<typeof useUpdateReservationSlotsMutation>;
export type UpdateReservationSlotsMutationResult = Apollo.MutationResult<GqlUpdateReservationSlotsMutation>;
export type UpdateReservationSlotsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateReservationSlotsMutation, GqlUpdateReservationSlotsMutationVariables>;
export const ActivatePrinterDocument = gql`
    mutation ActivatePrinter($deviceIdentifier: String!) {
  activatePrinter(deviceIdentifier: $deviceIdentifier) {
    success
    message
  }
}
    `;
export type GqlActivatePrinterMutationFn = Apollo.MutationFunction<GqlActivatePrinterMutation, GqlActivatePrinterMutationVariables>;

/**
 * __useActivatePrinterMutation__
 *
 * To run a mutation, you first call `useActivatePrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePrinterMutation, { data, loading, error }] = useActivatePrinterMutation({
 *   variables: {
 *      deviceIdentifier: // value for 'deviceIdentifier'
 *   },
 * });
 */
export function useActivatePrinterMutation(baseOptions?: Apollo.MutationHookOptions<GqlActivatePrinterMutation, GqlActivatePrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlActivatePrinterMutation, GqlActivatePrinterMutationVariables>(ActivatePrinterDocument, options);
      }
export type ActivatePrinterMutationHookResult = ReturnType<typeof useActivatePrinterMutation>;
export type ActivatePrinterMutationResult = Apollo.MutationResult<GqlActivatePrinterMutation>;
export type ActivatePrinterMutationOptions = Apollo.BaseMutationOptions<GqlActivatePrinterMutation, GqlActivatePrinterMutationVariables>;
export const DeletePrinterDocument = gql`
    mutation DeletePrinter($printerId: String!) {
  deletePrinter(printerId: $printerId) {
    success
  }
}
    `;
export type GqlDeletePrinterMutationFn = Apollo.MutationFunction<GqlDeletePrinterMutation, GqlDeletePrinterMutationVariables>;

/**
 * __useDeletePrinterMutation__
 *
 * To run a mutation, you first call `useDeletePrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrinterMutation, { data, loading, error }] = useDeletePrinterMutation({
 *   variables: {
 *      printerId: // value for 'printerId'
 *   },
 * });
 */
export function useDeletePrinterMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeletePrinterMutation, GqlDeletePrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeletePrinterMutation, GqlDeletePrinterMutationVariables>(DeletePrinterDocument, options);
      }
export type DeletePrinterMutationHookResult = ReturnType<typeof useDeletePrinterMutation>;
export type DeletePrinterMutationResult = Apollo.MutationResult<GqlDeletePrinterMutation>;
export type DeletePrinterMutationOptions = Apollo.BaseMutationOptions<GqlDeletePrinterMutation, GqlDeletePrinterMutationVariables>;
export const GetPrintersDocument = gql`
    query GetPrinters($dispensaryId: String!) {
  printers(dispensaryId: $dispensaryId) {
    _id
    name
    status
    deviceType
    deviceIdentifier
    adoptedAt
    adoptedBy
    lastSeenAt
    lastPrintAt
    lastJobId
    isRecentlyActive
    queueConfig {
      orderTypes
    }
    error
  }
}
    `;

/**
 * __useGetPrintersQuery__
 *
 * To run a query within a React component, call `useGetPrintersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintersQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPrintersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPrintersQuery, GqlGetPrintersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPrintersQuery, GqlGetPrintersQueryVariables>(GetPrintersDocument, options);
      }
export function useGetPrintersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPrintersQuery, GqlGetPrintersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPrintersQuery, GqlGetPrintersQueryVariables>(GetPrintersDocument, options);
        }
export type GetPrintersQueryHookResult = ReturnType<typeof useGetPrintersQuery>;
export type GetPrintersLazyQueryHookResult = ReturnType<typeof useGetPrintersLazyQuery>;
export type GetPrintersQueryResult = Apollo.QueryResult<GqlGetPrintersQuery, GqlGetPrintersQueryVariables>;
export const UpdatePrinterDocument = gql`
    mutation UpdatePrinter($input: UpdatePrinterInput!) {
  updatePrinter(input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdatePrinterMutationFn = Apollo.MutationFunction<GqlUpdatePrinterMutation, GqlUpdatePrinterMutationVariables>;

/**
 * __useUpdatePrinterMutation__
 *
 * To run a mutation, you first call `useUpdatePrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrinterMutation, { data, loading, error }] = useUpdatePrinterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrinterMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdatePrinterMutation, GqlUpdatePrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdatePrinterMutation, GqlUpdatePrinterMutationVariables>(UpdatePrinterDocument, options);
      }
export type UpdatePrinterMutationHookResult = ReturnType<typeof useUpdatePrinterMutation>;
export type UpdatePrinterMutationResult = Apollo.MutationResult<GqlUpdatePrinterMutation>;
export type UpdatePrinterMutationOptions = Apollo.BaseMutationOptions<GqlUpdatePrinterMutation, GqlUpdatePrinterMutationVariables>;
export const BulkCreateUsersDocument = gql`
    mutation BulkCreateUsers($input: [usersCreateInput!]!) {
  bulkCreateUsers(users: $input) {
    email
    success
    error
    user {
      _id
      fullName
      email
    }
  }
}
    `;
export type GqlBulkCreateUsersMutationFn = Apollo.MutationFunction<GqlBulkCreateUsersMutation, GqlBulkCreateUsersMutationVariables>;

/**
 * __useBulkCreateUsersMutation__
 *
 * To run a mutation, you first call `useBulkCreateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateUsersMutation, { data, loading, error }] = useBulkCreateUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateUsersMutation(baseOptions?: Apollo.MutationHookOptions<GqlBulkCreateUsersMutation, GqlBulkCreateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlBulkCreateUsersMutation, GqlBulkCreateUsersMutationVariables>(BulkCreateUsersDocument, options);
      }
export type BulkCreateUsersMutationHookResult = ReturnType<typeof useBulkCreateUsersMutation>;
export type BulkCreateUsersMutationResult = Apollo.MutationResult<GqlBulkCreateUsersMutation>;
export type BulkCreateUsersMutationOptions = Apollo.BaseMutationOptions<GqlBulkCreateUsersMutation, GqlBulkCreateUsersMutationVariables>;
export const GetEnterpriseAssetsDocument = gql`
    query GetEnterpriseAssets($chainId: String!) {
  filteredDispensaries(filter: {chain: $chainId}) {
    id
    name
    cName
    status
    address
    location {
      state
      city
    }
    logoImage
    embeddedLogoImage
    SpecialLogoImage
    listImage
    bannerImage
    menuBannerHtml
    menuBannerColor
    menuBannerTextBannerCollapsed
    categoryPhotos {
      src
      category
    }
    webCustomizationSettingsV2 {
      categories {
        items {
          category
          image
        }
      }
    }
    imageBanners {
      _id
      image
      mobileImage
      alt
      link
      openInNewTab
      bannerType
      connectedId
      connectedType
      platforms {
        enabled
        link
        openInNewTab
        type
      }
      position
      schedule {
        id
        startDate
        endDate
        timeRanges {
          dayOfWeek
          startTime
          endTime
        }
      }
      isActive
    }
  }
}
    `;

/**
 * __useGetEnterpriseAssetsQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseAssetsQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetEnterpriseAssetsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseAssetsQuery, GqlGetEnterpriseAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseAssetsQuery, GqlGetEnterpriseAssetsQueryVariables>(GetEnterpriseAssetsDocument, options);
      }
export function useGetEnterpriseAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseAssetsQuery, GqlGetEnterpriseAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseAssetsQuery, GqlGetEnterpriseAssetsQueryVariables>(GetEnterpriseAssetsDocument, options);
        }
export type GetEnterpriseAssetsQueryHookResult = ReturnType<typeof useGetEnterpriseAssetsQuery>;
export type GetEnterpriseAssetsLazyQueryHookResult = ReturnType<typeof useGetEnterpriseAssetsLazyQuery>;
export type GetEnterpriseAssetsQueryResult = Apollo.QueryResult<GqlGetEnterpriseAssetsQuery, GqlGetEnterpriseAssetsQueryVariables>;
export const GetEnterpriseLegalDisclaimersDocument = gql`
    query GetEnterpriseLegalDisclaimers($chainId: String!) {
  filteredDispensaries(filter: {chain: $chainId}) {
    id
    name
    location {
      state
      city
    }
    embedSettings {
      disclaimerTextHtml
    }
  }
}
    `;

/**
 * __useGetEnterpriseLegalDisclaimersQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseLegalDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseLegalDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseLegalDisclaimersQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetEnterpriseLegalDisclaimersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseLegalDisclaimersQuery, GqlGetEnterpriseLegalDisclaimersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseLegalDisclaimersQuery, GqlGetEnterpriseLegalDisclaimersQueryVariables>(GetEnterpriseLegalDisclaimersDocument, options);
      }
export function useGetEnterpriseLegalDisclaimersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseLegalDisclaimersQuery, GqlGetEnterpriseLegalDisclaimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseLegalDisclaimersQuery, GqlGetEnterpriseLegalDisclaimersQueryVariables>(GetEnterpriseLegalDisclaimersDocument, options);
        }
export type GetEnterpriseLegalDisclaimersQueryHookResult = ReturnType<typeof useGetEnterpriseLegalDisclaimersQuery>;
export type GetEnterpriseLegalDisclaimersLazyQueryHookResult = ReturnType<typeof useGetEnterpriseLegalDisclaimersLazyQuery>;
export type GetEnterpriseLegalDisclaimersQueryResult = Apollo.QueryResult<GqlGetEnterpriseLegalDisclaimersQuery, GqlGetEnterpriseLegalDisclaimersQueryVariables>;
export const EnterpriseAssetLibraryAssetUsagesDocument = gql`
    query EnterpriseAssetLibraryAssetUsages($enterpriseId: ID!, $contentHash: String!) {
  enterpriseAssetLibraryAssetUsages(
    enterpriseId: $enterpriseId
    contentHash: $contentHash
  ) {
    usageType
    dispensaryId
    dispensaryName
    label
    field
    url
  }
}
    `;

/**
 * __useEnterpriseAssetLibraryAssetUsagesQuery__
 *
 * To run a query within a React component, call `useEnterpriseAssetLibraryAssetUsagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryAssetUsagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseAssetLibraryAssetUsagesQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      contentHash: // value for 'contentHash'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryAssetUsagesQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseAssetLibraryAssetUsagesQuery, GqlEnterpriseAssetLibraryAssetUsagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseAssetLibraryAssetUsagesQuery, GqlEnterpriseAssetLibraryAssetUsagesQueryVariables>(EnterpriseAssetLibraryAssetUsagesDocument, options);
      }
export function useEnterpriseAssetLibraryAssetUsagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseAssetLibraryAssetUsagesQuery, GqlEnterpriseAssetLibraryAssetUsagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseAssetLibraryAssetUsagesQuery, GqlEnterpriseAssetLibraryAssetUsagesQueryVariables>(EnterpriseAssetLibraryAssetUsagesDocument, options);
        }
export type EnterpriseAssetLibraryAssetUsagesQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryAssetUsagesQuery>;
export type EnterpriseAssetLibraryAssetUsagesLazyQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryAssetUsagesLazyQuery>;
export type EnterpriseAssetLibraryAssetUsagesQueryResult = Apollo.QueryResult<GqlEnterpriseAssetLibraryAssetUsagesQuery, GqlEnterpriseAssetLibraryAssetUsagesQueryVariables>;
export const EnterpriseAssetLibraryAssetsDocument = gql`
    query EnterpriseAssetLibraryAssets($enterpriseId: ID!, $filters: LibraryAssetFilters) {
  enterpriseAssetLibraryAssets(enterpriseId: $enterpriseId, filters: $filters) {
    items {
      id
      enterpriseId
      name
      fileName
      contentHash
      url
      type
      mimeType
      width
      height
      fileSize
      folderId
      tags
      createdAt
      updatedAt
      createdBy
      aiGenerated
    }
    total
  }
}
    `;

/**
 * __useEnterpriseAssetLibraryAssetsQuery__
 *
 * To run a query within a React component, call `useEnterpriseAssetLibraryAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseAssetLibraryAssetsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryAssetsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseAssetLibraryAssetsQuery, GqlEnterpriseAssetLibraryAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseAssetLibraryAssetsQuery, GqlEnterpriseAssetLibraryAssetsQueryVariables>(EnterpriseAssetLibraryAssetsDocument, options);
      }
export function useEnterpriseAssetLibraryAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseAssetLibraryAssetsQuery, GqlEnterpriseAssetLibraryAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseAssetLibraryAssetsQuery, GqlEnterpriseAssetLibraryAssetsQueryVariables>(EnterpriseAssetLibraryAssetsDocument, options);
        }
export type EnterpriseAssetLibraryAssetsQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryAssetsQuery>;
export type EnterpriseAssetLibraryAssetsLazyQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryAssetsLazyQuery>;
export type EnterpriseAssetLibraryAssetsQueryResult = Apollo.QueryResult<GqlEnterpriseAssetLibraryAssetsQuery, GqlEnterpriseAssetLibraryAssetsQueryVariables>;
export const EnterpriseAssetLibraryCreateFolderDocument = gql`
    mutation EnterpriseAssetLibraryCreateFolder($enterpriseId: ID!, $name: String!, $parentId: ID) {
  enterpriseAssetLibraryCreateFolder(
    enterpriseId: $enterpriseId
    name: $name
    parentId: $parentId
  ) {
    id
    enterpriseId
    name
    parentId
    assetCount
  }
}
    `;
export type GqlEnterpriseAssetLibraryCreateFolderMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryCreateFolderMutation, GqlEnterpriseAssetLibraryCreateFolderMutationVariables>;

/**
 * __useEnterpriseAssetLibraryCreateFolderMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryCreateFolderMutation, { data, loading, error }] = useEnterpriseAssetLibraryCreateFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryCreateFolderMutation, GqlEnterpriseAssetLibraryCreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryCreateFolderMutation, GqlEnterpriseAssetLibraryCreateFolderMutationVariables>(EnterpriseAssetLibraryCreateFolderDocument, options);
      }
export type EnterpriseAssetLibraryCreateFolderMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryCreateFolderMutation>;
export type EnterpriseAssetLibraryCreateFolderMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryCreateFolderMutation>;
export type EnterpriseAssetLibraryCreateFolderMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryCreateFolderMutation, GqlEnterpriseAssetLibraryCreateFolderMutationVariables>;
export const EnterpriseAssetLibraryDeleteAssetsDocument = gql`
    mutation EnterpriseAssetLibraryDeleteAssets($enterpriseId: ID!, $ids: [ID!]!) {
  enterpriseAssetLibraryDeleteAssets(enterpriseId: $enterpriseId, ids: $ids) {
    success
    message
  }
}
    `;
export type GqlEnterpriseAssetLibraryDeleteAssetsMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryDeleteAssetsMutation, GqlEnterpriseAssetLibraryDeleteAssetsMutationVariables>;

/**
 * __useEnterpriseAssetLibraryDeleteAssetsMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryDeleteAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryDeleteAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryDeleteAssetsMutation, { data, loading, error }] = useEnterpriseAssetLibraryDeleteAssetsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryDeleteAssetsMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryDeleteAssetsMutation, GqlEnterpriseAssetLibraryDeleteAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryDeleteAssetsMutation, GqlEnterpriseAssetLibraryDeleteAssetsMutationVariables>(EnterpriseAssetLibraryDeleteAssetsDocument, options);
      }
export type EnterpriseAssetLibraryDeleteAssetsMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryDeleteAssetsMutation>;
export type EnterpriseAssetLibraryDeleteAssetsMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryDeleteAssetsMutation>;
export type EnterpriseAssetLibraryDeleteAssetsMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryDeleteAssetsMutation, GqlEnterpriseAssetLibraryDeleteAssetsMutationVariables>;
export const EnterpriseAssetLibraryDeleteFolderDocument = gql`
    mutation EnterpriseAssetLibraryDeleteFolder($enterpriseId: ID!, $id: ID!) {
  enterpriseAssetLibraryDeleteFolder(enterpriseId: $enterpriseId, id: $id) {
    success
    message
  }
}
    `;
export type GqlEnterpriseAssetLibraryDeleteFolderMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryDeleteFolderMutation, GqlEnterpriseAssetLibraryDeleteFolderMutationVariables>;

/**
 * __useEnterpriseAssetLibraryDeleteFolderMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryDeleteFolderMutation, { data, loading, error }] = useEnterpriseAssetLibraryDeleteFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryDeleteFolderMutation, GqlEnterpriseAssetLibraryDeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryDeleteFolderMutation, GqlEnterpriseAssetLibraryDeleteFolderMutationVariables>(EnterpriseAssetLibraryDeleteFolderDocument, options);
      }
export type EnterpriseAssetLibraryDeleteFolderMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryDeleteFolderMutation>;
export type EnterpriseAssetLibraryDeleteFolderMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryDeleteFolderMutation>;
export type EnterpriseAssetLibraryDeleteFolderMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryDeleteFolderMutation, GqlEnterpriseAssetLibraryDeleteFolderMutationVariables>;
export const EnterpriseAssetLibraryFinalizeAssetDocument = gql`
    mutation EnterpriseAssetLibraryFinalizeAsset($enterpriseId: ID!, $contentHash: String!, $name: String!, $fileName: String!, $mimeType: String!, $fileSize: Int!, $folderId: ID, $tags: [String!], $width: Int, $height: Int, $aiGenerated: Boolean) {
  enterpriseAssetLibraryFinalizeAsset(
    enterpriseId: $enterpriseId
    contentHash: $contentHash
    name: $name
    fileName: $fileName
    mimeType: $mimeType
    fileSize: $fileSize
    folderId: $folderId
    tags: $tags
    width: $width
    height: $height
    aiGenerated: $aiGenerated
  ) {
    id
    enterpriseId
    name
    fileName
    contentHash
    url
    type
    mimeType
    width
    height
    fileSize
    folderId
    tags
    createdAt
    updatedAt
    createdBy
    aiGenerated
  }
}
    `;
export type GqlEnterpriseAssetLibraryFinalizeAssetMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryFinalizeAssetMutation, GqlEnterpriseAssetLibraryFinalizeAssetMutationVariables>;

/**
 * __useEnterpriseAssetLibraryFinalizeAssetMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryFinalizeAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryFinalizeAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryFinalizeAssetMutation, { data, loading, error }] = useEnterpriseAssetLibraryFinalizeAssetMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      contentHash: // value for 'contentHash'
 *      name: // value for 'name'
 *      fileName: // value for 'fileName'
 *      mimeType: // value for 'mimeType'
 *      fileSize: // value for 'fileSize'
 *      folderId: // value for 'folderId'
 *      tags: // value for 'tags'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      aiGenerated: // value for 'aiGenerated'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryFinalizeAssetMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryFinalizeAssetMutation, GqlEnterpriseAssetLibraryFinalizeAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryFinalizeAssetMutation, GqlEnterpriseAssetLibraryFinalizeAssetMutationVariables>(EnterpriseAssetLibraryFinalizeAssetDocument, options);
      }
export type EnterpriseAssetLibraryFinalizeAssetMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryFinalizeAssetMutation>;
export type EnterpriseAssetLibraryFinalizeAssetMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryFinalizeAssetMutation>;
export type EnterpriseAssetLibraryFinalizeAssetMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryFinalizeAssetMutation, GqlEnterpriseAssetLibraryFinalizeAssetMutationVariables>;
export const EnterpriseAssetLibraryFoldersDocument = gql`
    query EnterpriseAssetLibraryFolders($enterpriseId: ID!) {
  enterpriseAssetLibraryFolders(enterpriseId: $enterpriseId) {
    id
    enterpriseId
    name
    parentId
    assetCount
  }
}
    `;

/**
 * __useEnterpriseAssetLibraryFoldersQuery__
 *
 * To run a query within a React component, call `useEnterpriseAssetLibraryFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseAssetLibraryFoldersQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryFoldersQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseAssetLibraryFoldersQuery, GqlEnterpriseAssetLibraryFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseAssetLibraryFoldersQuery, GqlEnterpriseAssetLibraryFoldersQueryVariables>(EnterpriseAssetLibraryFoldersDocument, options);
      }
export function useEnterpriseAssetLibraryFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseAssetLibraryFoldersQuery, GqlEnterpriseAssetLibraryFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseAssetLibraryFoldersQuery, GqlEnterpriseAssetLibraryFoldersQueryVariables>(EnterpriseAssetLibraryFoldersDocument, options);
        }
export type EnterpriseAssetLibraryFoldersQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryFoldersQuery>;
export type EnterpriseAssetLibraryFoldersLazyQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryFoldersLazyQuery>;
export type EnterpriseAssetLibraryFoldersQueryResult = Apollo.QueryResult<GqlEnterpriseAssetLibraryFoldersQuery, GqlEnterpriseAssetLibraryFoldersQueryVariables>;
export const EnterpriseAssetLibraryRequestUploadDocument = gql`
    mutation EnterpriseAssetLibraryRequestUpload($enterpriseId: ID!, $fileName: String!, $mimeType: String!, $fileSize: Int!, $contentHash: String!) {
  enterpriseAssetLibraryRequestUpload(
    enterpriseId: $enterpriseId
    fileName: $fileName
    mimeType: $mimeType
    fileSize: $fileSize
    contentHash: $contentHash
  ) {
    uploadUrl
    contentHash
    alreadyUploaded
    alreadyInLibrary
    expiresAt
    existingAsset {
      id
      enterpriseId
      name
      fileName
      contentHash
      url
      type
      mimeType
      width
      height
      fileSize
      folderId
      tags
      createdAt
      updatedAt
      createdBy
      aiGenerated
    }
  }
}
    `;
export type GqlEnterpriseAssetLibraryRequestUploadMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryRequestUploadMutation, GqlEnterpriseAssetLibraryRequestUploadMutationVariables>;

/**
 * __useEnterpriseAssetLibraryRequestUploadMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryRequestUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryRequestUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryRequestUploadMutation, { data, loading, error }] = useEnterpriseAssetLibraryRequestUploadMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      fileName: // value for 'fileName'
 *      mimeType: // value for 'mimeType'
 *      fileSize: // value for 'fileSize'
 *      contentHash: // value for 'contentHash'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryRequestUploadMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryRequestUploadMutation, GqlEnterpriseAssetLibraryRequestUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryRequestUploadMutation, GqlEnterpriseAssetLibraryRequestUploadMutationVariables>(EnterpriseAssetLibraryRequestUploadDocument, options);
      }
export type EnterpriseAssetLibraryRequestUploadMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryRequestUploadMutation>;
export type EnterpriseAssetLibraryRequestUploadMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryRequestUploadMutation>;
export type EnterpriseAssetLibraryRequestUploadMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryRequestUploadMutation, GqlEnterpriseAssetLibraryRequestUploadMutationVariables>;
export const EnterpriseAssetLibraryStartImportDocument = gql`
    mutation EnterpriseAssetLibraryStartImport($enterpriseId: ID!) {
  enterpriseAssetLibraryStartImport(enterpriseId: $enterpriseId) {
    jobId
    channel
  }
}
    `;
export type GqlEnterpriseAssetLibraryStartImportMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryStartImportMutation, GqlEnterpriseAssetLibraryStartImportMutationVariables>;

/**
 * __useEnterpriseAssetLibraryStartImportMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryStartImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryStartImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryStartImportMutation, { data, loading, error }] = useEnterpriseAssetLibraryStartImportMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryStartImportMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryStartImportMutation, GqlEnterpriseAssetLibraryStartImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryStartImportMutation, GqlEnterpriseAssetLibraryStartImportMutationVariables>(EnterpriseAssetLibraryStartImportDocument, options);
      }
export type EnterpriseAssetLibraryStartImportMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryStartImportMutation>;
export type EnterpriseAssetLibraryStartImportMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryStartImportMutation>;
export type EnterpriseAssetLibraryStartImportMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryStartImportMutation, GqlEnterpriseAssetLibraryStartImportMutationVariables>;
export const EnterpriseAssetLibraryStatsDocument = gql`
    query EnterpriseAssetLibraryStats($enterpriseId: ID!) {
  enterpriseAssetLibraryStats(enterpriseId: $enterpriseId) {
    total
    tagCounts {
      tag
      count
    }
  }
}
    `;

/**
 * __useEnterpriseAssetLibraryStatsQuery__
 *
 * To run a query within a React component, call `useEnterpriseAssetLibraryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseAssetLibraryStatsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryStatsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseAssetLibraryStatsQuery, GqlEnterpriseAssetLibraryStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseAssetLibraryStatsQuery, GqlEnterpriseAssetLibraryStatsQueryVariables>(EnterpriseAssetLibraryStatsDocument, options);
      }
export function useEnterpriseAssetLibraryStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseAssetLibraryStatsQuery, GqlEnterpriseAssetLibraryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseAssetLibraryStatsQuery, GqlEnterpriseAssetLibraryStatsQueryVariables>(EnterpriseAssetLibraryStatsDocument, options);
        }
export type EnterpriseAssetLibraryStatsQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryStatsQuery>;
export type EnterpriseAssetLibraryStatsLazyQueryHookResult = ReturnType<typeof useEnterpriseAssetLibraryStatsLazyQuery>;
export type EnterpriseAssetLibraryStatsQueryResult = Apollo.QueryResult<GqlEnterpriseAssetLibraryStatsQuery, GqlEnterpriseAssetLibraryStatsQueryVariables>;
export const EnterpriseAssetLibraryUpdateAssetDocument = gql`
    mutation EnterpriseAssetLibraryUpdateAsset($enterpriseId: ID!, $id: ID!, $name: String, $folderId: ID, $tags: [String!]) {
  enterpriseAssetLibraryUpdateAsset(
    enterpriseId: $enterpriseId
    id: $id
    name: $name
    folderId: $folderId
    tags: $tags
  ) {
    id
    enterpriseId
    name
    fileName
    contentHash
    url
    type
    mimeType
    width
    height
    fileSize
    folderId
    tags
    createdAt
    updatedAt
    createdBy
    aiGenerated
  }
}
    `;
export type GqlEnterpriseAssetLibraryUpdateAssetMutationFn = Apollo.MutationFunction<GqlEnterpriseAssetLibraryUpdateAssetMutation, GqlEnterpriseAssetLibraryUpdateAssetMutationVariables>;

/**
 * __useEnterpriseAssetLibraryUpdateAssetMutation__
 *
 * To run a mutation, you first call `useEnterpriseAssetLibraryUpdateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAssetLibraryUpdateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterpriseAssetLibraryUpdateAssetMutation, { data, loading, error }] = useEnterpriseAssetLibraryUpdateAssetMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      folderId: // value for 'folderId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEnterpriseAssetLibraryUpdateAssetMutation(baseOptions?: Apollo.MutationHookOptions<GqlEnterpriseAssetLibraryUpdateAssetMutation, GqlEnterpriseAssetLibraryUpdateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEnterpriseAssetLibraryUpdateAssetMutation, GqlEnterpriseAssetLibraryUpdateAssetMutationVariables>(EnterpriseAssetLibraryUpdateAssetDocument, options);
      }
export type EnterpriseAssetLibraryUpdateAssetMutationHookResult = ReturnType<typeof useEnterpriseAssetLibraryUpdateAssetMutation>;
export type EnterpriseAssetLibraryUpdateAssetMutationResult = Apollo.MutationResult<GqlEnterpriseAssetLibraryUpdateAssetMutation>;
export type EnterpriseAssetLibraryUpdateAssetMutationOptions = Apollo.BaseMutationOptions<GqlEnterpriseAssetLibraryUpdateAssetMutation, GqlEnterpriseAssetLibraryUpdateAssetMutationVariables>;
export const GetBoardFoldersDocument = gql`
    query GetBoardFolders($enterpriseId: ID!) {
  digitalDisplayBoardFolders(enterpriseId: $enterpriseId) {
    ...DigitalDisplayBoardFolderFields
  }
}
    ${DigitalDisplayBoardFolderFieldsFragmentDoc}`;

/**
 * __useGetBoardFoldersQuery__
 *
 * To run a query within a React component, call `useGetBoardFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardFoldersQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetBoardFoldersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetBoardFoldersQuery, GqlGetBoardFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBoardFoldersQuery, GqlGetBoardFoldersQueryVariables>(GetBoardFoldersDocument, options);
      }
export function useGetBoardFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBoardFoldersQuery, GqlGetBoardFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBoardFoldersQuery, GqlGetBoardFoldersQueryVariables>(GetBoardFoldersDocument, options);
        }
export type GetBoardFoldersQueryHookResult = ReturnType<typeof useGetBoardFoldersQuery>;
export type GetBoardFoldersLazyQueryHookResult = ReturnType<typeof useGetBoardFoldersLazyQuery>;
export type GetBoardFoldersQueryResult = Apollo.QueryResult<GqlGetBoardFoldersQuery, GqlGetBoardFoldersQueryVariables>;
export const GetDigitalDisplayBoardsTotalDocument = gql`
    query GetDigitalDisplayBoardsTotal($enterpriseId: ID!) {
  digitalDisplayBoards(enterpriseId: $enterpriseId, menuOnly: true, limit: 0) {
    total
  }
}
    `;

/**
 * __useGetDigitalDisplayBoardsTotalQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayBoardsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayBoardsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayBoardsTotalQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetDigitalDisplayBoardsTotalQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayBoardsTotalQuery, GqlGetDigitalDisplayBoardsTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayBoardsTotalQuery, GqlGetDigitalDisplayBoardsTotalQueryVariables>(GetDigitalDisplayBoardsTotalDocument, options);
      }
export function useGetDigitalDisplayBoardsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayBoardsTotalQuery, GqlGetDigitalDisplayBoardsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayBoardsTotalQuery, GqlGetDigitalDisplayBoardsTotalQueryVariables>(GetDigitalDisplayBoardsTotalDocument, options);
        }
export type GetDigitalDisplayBoardsTotalQueryHookResult = ReturnType<typeof useGetDigitalDisplayBoardsTotalQuery>;
export type GetDigitalDisplayBoardsTotalLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayBoardsTotalLazyQuery>;
export type GetDigitalDisplayBoardsTotalQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayBoardsTotalQuery, GqlGetDigitalDisplayBoardsTotalQueryVariables>;
export const CreateBoardFolderDocument = gql`
    mutation CreateBoardFolder($enterpriseId: ID!, $name: String!, $parentId: ID) {
  createDigitalDisplayBoardFolder(
    enterpriseId: $enterpriseId
    name: $name
    parentId: $parentId
  ) {
    ...DigitalDisplayBoardFolderFields
  }
}
    ${DigitalDisplayBoardFolderFieldsFragmentDoc}`;
export type GqlCreateBoardFolderMutationFn = Apollo.MutationFunction<GqlCreateBoardFolderMutation, GqlCreateBoardFolderMutationVariables>;

/**
 * __useCreateBoardFolderMutation__
 *
 * To run a mutation, you first call `useCreateBoardFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoardFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoardFolderMutation, { data, loading, error }] = useCreateBoardFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateBoardFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBoardFolderMutation, GqlCreateBoardFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBoardFolderMutation, GqlCreateBoardFolderMutationVariables>(CreateBoardFolderDocument, options);
      }
export type CreateBoardFolderMutationHookResult = ReturnType<typeof useCreateBoardFolderMutation>;
export type CreateBoardFolderMutationResult = Apollo.MutationResult<GqlCreateBoardFolderMutation>;
export type CreateBoardFolderMutationOptions = Apollo.BaseMutationOptions<GqlCreateBoardFolderMutation, GqlCreateBoardFolderMutationVariables>;
export const RenameBoardFolderDocument = gql`
    mutation RenameBoardFolder($enterpriseId: ID!, $id: ID!, $name: String!) {
  updateDigitalDisplayBoardFolder(
    enterpriseId: $enterpriseId
    id: $id
    name: $name
  ) {
    ...DigitalDisplayBoardFolderFields
  }
}
    ${DigitalDisplayBoardFolderFieldsFragmentDoc}`;
export type GqlRenameBoardFolderMutationFn = Apollo.MutationFunction<GqlRenameBoardFolderMutation, GqlRenameBoardFolderMutationVariables>;

/**
 * __useRenameBoardFolderMutation__
 *
 * To run a mutation, you first call `useRenameBoardFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameBoardFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameBoardFolderMutation, { data, loading, error }] = useRenameBoardFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameBoardFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlRenameBoardFolderMutation, GqlRenameBoardFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRenameBoardFolderMutation, GqlRenameBoardFolderMutationVariables>(RenameBoardFolderDocument, options);
      }
export type RenameBoardFolderMutationHookResult = ReturnType<typeof useRenameBoardFolderMutation>;
export type RenameBoardFolderMutationResult = Apollo.MutationResult<GqlRenameBoardFolderMutation>;
export type RenameBoardFolderMutationOptions = Apollo.BaseMutationOptions<GqlRenameBoardFolderMutation, GqlRenameBoardFolderMutationVariables>;
export const DeleteBoardFolderDocument = gql`
    mutation DeleteBoardFolder($enterpriseId: ID!, $id: ID!) {
  deleteDigitalDisplayBoardFolder(enterpriseId: $enterpriseId, id: $id) {
    success
  }
}
    `;
export type GqlDeleteBoardFolderMutationFn = Apollo.MutationFunction<GqlDeleteBoardFolderMutation, GqlDeleteBoardFolderMutationVariables>;

/**
 * __useDeleteBoardFolderMutation__
 *
 * To run a mutation, you first call `useDeleteBoardFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoardFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoardFolderMutation, { data, loading, error }] = useDeleteBoardFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBoardFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteBoardFolderMutation, GqlDeleteBoardFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteBoardFolderMutation, GqlDeleteBoardFolderMutationVariables>(DeleteBoardFolderDocument, options);
      }
export type DeleteBoardFolderMutationHookResult = ReturnType<typeof useDeleteBoardFolderMutation>;
export type DeleteBoardFolderMutationResult = Apollo.MutationResult<GqlDeleteBoardFolderMutation>;
export type DeleteBoardFolderMutationOptions = Apollo.BaseMutationOptions<GqlDeleteBoardFolderMutation, GqlDeleteBoardFolderMutationVariables>;
export const AddBoardsToBoardFolderDocument = gql`
    mutation AddBoardsToBoardFolder($enterpriseId: ID!, $id: ID!, $boardIds: [ID!]!) {
  addBoardsToDigitalDisplayBoardFolder(
    enterpriseId: $enterpriseId
    id: $id
    boardIds: $boardIds
  ) {
    ...DigitalDisplayBoardFolderFields
  }
}
    ${DigitalDisplayBoardFolderFieldsFragmentDoc}`;
export type GqlAddBoardsToBoardFolderMutationFn = Apollo.MutationFunction<GqlAddBoardsToBoardFolderMutation, GqlAddBoardsToBoardFolderMutationVariables>;

/**
 * __useAddBoardsToBoardFolderMutation__
 *
 * To run a mutation, you first call `useAddBoardsToBoardFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBoardsToBoardFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBoardsToBoardFolderMutation, { data, loading, error }] = useAddBoardsToBoardFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      boardIds: // value for 'boardIds'
 *   },
 * });
 */
export function useAddBoardsToBoardFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddBoardsToBoardFolderMutation, GqlAddBoardsToBoardFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAddBoardsToBoardFolderMutation, GqlAddBoardsToBoardFolderMutationVariables>(AddBoardsToBoardFolderDocument, options);
      }
export type AddBoardsToBoardFolderMutationHookResult = ReturnType<typeof useAddBoardsToBoardFolderMutation>;
export type AddBoardsToBoardFolderMutationResult = Apollo.MutationResult<GqlAddBoardsToBoardFolderMutation>;
export type AddBoardsToBoardFolderMutationOptions = Apollo.BaseMutationOptions<GqlAddBoardsToBoardFolderMutation, GqlAddBoardsToBoardFolderMutationVariables>;
export const RemoveBoardsFromBoardFolderDocument = gql`
    mutation RemoveBoardsFromBoardFolder($enterpriseId: ID!, $id: ID!, $boardIds: [ID!]!) {
  removeBoardsFromDigitalDisplayBoardFolder(
    enterpriseId: $enterpriseId
    id: $id
    boardIds: $boardIds
  ) {
    ...DigitalDisplayBoardFolderFields
  }
}
    ${DigitalDisplayBoardFolderFieldsFragmentDoc}`;
export type GqlRemoveBoardsFromBoardFolderMutationFn = Apollo.MutationFunction<GqlRemoveBoardsFromBoardFolderMutation, GqlRemoveBoardsFromBoardFolderMutationVariables>;

/**
 * __useRemoveBoardsFromBoardFolderMutation__
 *
 * To run a mutation, you first call `useRemoveBoardsFromBoardFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBoardsFromBoardFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBoardsFromBoardFolderMutation, { data, loading, error }] = useRemoveBoardsFromBoardFolderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      boardIds: // value for 'boardIds'
 *   },
 * });
 */
export function useRemoveBoardsFromBoardFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlRemoveBoardsFromBoardFolderMutation, GqlRemoveBoardsFromBoardFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRemoveBoardsFromBoardFolderMutation, GqlRemoveBoardsFromBoardFolderMutationVariables>(RemoveBoardsFromBoardFolderDocument, options);
      }
export type RemoveBoardsFromBoardFolderMutationHookResult = ReturnType<typeof useRemoveBoardsFromBoardFolderMutation>;
export type RemoveBoardsFromBoardFolderMutationResult = Apollo.MutationResult<GqlRemoveBoardsFromBoardFolderMutation>;
export type RemoveBoardsFromBoardFolderMutationOptions = Apollo.BaseMutationOptions<GqlRemoveBoardsFromBoardFolderMutation, GqlRemoveBoardsFromBoardFolderMutationVariables>;
export const GetDigitalDisplayBoardsDocument = gql`
    query GetDigitalDisplayBoards($enterpriseId: ID!, $search: String, $limit: Int, $offset: Int, $menuOnly: Boolean, $orientation: DigitalDisplayBoardOrientation, $layout: DigitalDisplayBoardLayout, $linkedToPlaylist: Boolean, $sortBy: String, $sortDirection: String, $folderIds: [ID!]) {
  digitalDisplayBoards(
    enterpriseId: $enterpriseId
    search: $search
    limit: $limit
    offset: $offset
    menuOnly: $menuOnly
    orientation: $orientation
    layout: $layout
    linkedToPlaylist: $linkedToPlaylist
    sortBy: $sortBy
    sortDirection: $sortDirection
    folderIds: $folderIds
  ) {
    items {
      ...DigitalDisplayBoardFields
    }
    total
  }
}
    ${DigitalDisplayBoardFieldsFragmentDoc}`;

/**
 * __useGetDigitalDisplayBoardsQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayBoardsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      menuOnly: // value for 'menuOnly'
 *      orientation: // value for 'orientation'
 *      layout: // value for 'layout'
 *      linkedToPlaylist: // value for 'linkedToPlaylist'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useGetDigitalDisplayBoardsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayBoardsQuery, GqlGetDigitalDisplayBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayBoardsQuery, GqlGetDigitalDisplayBoardsQueryVariables>(GetDigitalDisplayBoardsDocument, options);
      }
export function useGetDigitalDisplayBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayBoardsQuery, GqlGetDigitalDisplayBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayBoardsQuery, GqlGetDigitalDisplayBoardsQueryVariables>(GetDigitalDisplayBoardsDocument, options);
        }
export type GetDigitalDisplayBoardsQueryHookResult = ReturnType<typeof useGetDigitalDisplayBoardsQuery>;
export type GetDigitalDisplayBoardsLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayBoardsLazyQuery>;
export type GetDigitalDisplayBoardsQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayBoardsQuery, GqlGetDigitalDisplayBoardsQueryVariables>;
export const GetDigitalDisplayBoardDocument = gql`
    query GetDigitalDisplayBoard($enterpriseId: ID!, $id: ID!) {
  digitalDisplayBoard(enterpriseId: $enterpriseId, id: $id) {
    ...DigitalDisplayBoardFields
  }
}
    ${DigitalDisplayBoardFieldsFragmentDoc}`;

/**
 * __useGetDigitalDisplayBoardQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayBoardQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDigitalDisplayBoardQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayBoardQuery, GqlGetDigitalDisplayBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayBoardQuery, GqlGetDigitalDisplayBoardQueryVariables>(GetDigitalDisplayBoardDocument, options);
      }
export function useGetDigitalDisplayBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayBoardQuery, GqlGetDigitalDisplayBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayBoardQuery, GqlGetDigitalDisplayBoardQueryVariables>(GetDigitalDisplayBoardDocument, options);
        }
export type GetDigitalDisplayBoardQueryHookResult = ReturnType<typeof useGetDigitalDisplayBoardQuery>;
export type GetDigitalDisplayBoardLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayBoardLazyQuery>;
export type GetDigitalDisplayBoardQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayBoardQuery, GqlGetDigitalDisplayBoardQueryVariables>;
export const CreateDigitalDisplayBoardDocument = gql`
    mutation CreateDigitalDisplayBoard($enterpriseId: ID!, $name: String!, $layout: DigitalDisplayBoardLayout!, $orientation: DigitalDisplayBoardOrientation, $colorScheme: JSON, $menuColumns: JSON, $audioEnabled: Boolean, $assetId: ID) {
  createDigitalDisplayBoard(
    enterpriseId: $enterpriseId
    name: $name
    layout: $layout
    orientation: $orientation
    colorScheme: $colorScheme
    menuColumns: $menuColumns
    audioEnabled: $audioEnabled
    assetId: $assetId
  ) {
    ...DigitalDisplayBoardFields
  }
}
    ${DigitalDisplayBoardFieldsFragmentDoc}`;
export type GqlCreateDigitalDisplayBoardMutationFn = Apollo.MutationFunction<GqlCreateDigitalDisplayBoardMutation, GqlCreateDigitalDisplayBoardMutationVariables>;

/**
 * __useCreateDigitalDisplayBoardMutation__
 *
 * To run a mutation, you first call `useCreateDigitalDisplayBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigitalDisplayBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigitalDisplayBoardMutation, { data, loading, error }] = useCreateDigitalDisplayBoardMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      name: // value for 'name'
 *      layout: // value for 'layout'
 *      orientation: // value for 'orientation'
 *      colorScheme: // value for 'colorScheme'
 *      menuColumns: // value for 'menuColumns'
 *      audioEnabled: // value for 'audioEnabled'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useCreateDigitalDisplayBoardMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDigitalDisplayBoardMutation, GqlCreateDigitalDisplayBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDigitalDisplayBoardMutation, GqlCreateDigitalDisplayBoardMutationVariables>(CreateDigitalDisplayBoardDocument, options);
      }
export type CreateDigitalDisplayBoardMutationHookResult = ReturnType<typeof useCreateDigitalDisplayBoardMutation>;
export type CreateDigitalDisplayBoardMutationResult = Apollo.MutationResult<GqlCreateDigitalDisplayBoardMutation>;
export type CreateDigitalDisplayBoardMutationOptions = Apollo.BaseMutationOptions<GqlCreateDigitalDisplayBoardMutation, GqlCreateDigitalDisplayBoardMutationVariables>;
export const UpdateDigitalDisplayBoardDocument = gql`
    mutation UpdateDigitalDisplayBoard($enterpriseId: ID!, $id: ID!, $name: String, $layout: DigitalDisplayBoardLayout, $orientation: DigitalDisplayBoardOrientation, $colorScheme: JSON, $menuColumns: JSON, $audioEnabled: Boolean, $visible: Boolean, $assetId: ID) {
  updateDigitalDisplayBoard(
    enterpriseId: $enterpriseId
    id: $id
    name: $name
    layout: $layout
    orientation: $orientation
    colorScheme: $colorScheme
    menuColumns: $menuColumns
    audioEnabled: $audioEnabled
    visible: $visible
    assetId: $assetId
  ) {
    ...DigitalDisplayBoardFields
  }
}
    ${DigitalDisplayBoardFieldsFragmentDoc}`;
export type GqlUpdateDigitalDisplayBoardMutationFn = Apollo.MutationFunction<GqlUpdateDigitalDisplayBoardMutation, GqlUpdateDigitalDisplayBoardMutationVariables>;

/**
 * __useUpdateDigitalDisplayBoardMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalDisplayBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalDisplayBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalDisplayBoardMutation, { data, loading, error }] = useUpdateDigitalDisplayBoardMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      layout: // value for 'layout'
 *      orientation: // value for 'orientation'
 *      colorScheme: // value for 'colorScheme'
 *      menuColumns: // value for 'menuColumns'
 *      audioEnabled: // value for 'audioEnabled'
 *      visible: // value for 'visible'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useUpdateDigitalDisplayBoardMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDigitalDisplayBoardMutation, GqlUpdateDigitalDisplayBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDigitalDisplayBoardMutation, GqlUpdateDigitalDisplayBoardMutationVariables>(UpdateDigitalDisplayBoardDocument, options);
      }
export type UpdateDigitalDisplayBoardMutationHookResult = ReturnType<typeof useUpdateDigitalDisplayBoardMutation>;
export type UpdateDigitalDisplayBoardMutationResult = Apollo.MutationResult<GqlUpdateDigitalDisplayBoardMutation>;
export type UpdateDigitalDisplayBoardMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDigitalDisplayBoardMutation, GqlUpdateDigitalDisplayBoardMutationVariables>;
export const DeleteDigitalDisplayBoardDocument = gql`
    mutation DeleteDigitalDisplayBoard($enterpriseId: ID!, $id: ID!) {
  deleteDigitalDisplayBoard(enterpriseId: $enterpriseId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteDigitalDisplayBoardMutationFn = Apollo.MutationFunction<GqlDeleteDigitalDisplayBoardMutation, GqlDeleteDigitalDisplayBoardMutationVariables>;

/**
 * __useDeleteDigitalDisplayBoardMutation__
 *
 * To run a mutation, you first call `useDeleteDigitalDisplayBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigitalDisplayBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigitalDisplayBoardMutation, { data, loading, error }] = useDeleteDigitalDisplayBoardMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDigitalDisplayBoardMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteDigitalDisplayBoardMutation, GqlDeleteDigitalDisplayBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteDigitalDisplayBoardMutation, GqlDeleteDigitalDisplayBoardMutationVariables>(DeleteDigitalDisplayBoardDocument, options);
      }
export type DeleteDigitalDisplayBoardMutationHookResult = ReturnType<typeof useDeleteDigitalDisplayBoardMutation>;
export type DeleteDigitalDisplayBoardMutationResult = Apollo.MutationResult<GqlDeleteDigitalDisplayBoardMutation>;
export type DeleteDigitalDisplayBoardMutationOptions = Apollo.BaseMutationOptions<GqlDeleteDigitalDisplayBoardMutation, GqlDeleteDigitalDisplayBoardMutationVariables>;
export const DuplicateDigitalDisplayBoardDocument = gql`
    mutation DuplicateDigitalDisplayBoard($enterpriseId: ID!, $id: ID!, $folderId: ID) {
  duplicateDigitalDisplayBoard(
    enterpriseId: $enterpriseId
    id: $id
    folderId: $folderId
  ) {
    ...DigitalDisplayBoardFields
  }
}
    ${DigitalDisplayBoardFieldsFragmentDoc}`;
export type GqlDuplicateDigitalDisplayBoardMutationFn = Apollo.MutationFunction<GqlDuplicateDigitalDisplayBoardMutation, GqlDuplicateDigitalDisplayBoardMutationVariables>;

/**
 * __useDuplicateDigitalDisplayBoardMutation__
 *
 * To run a mutation, you first call `useDuplicateDigitalDisplayBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDigitalDisplayBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDigitalDisplayBoardMutation, { data, loading, error }] = useDuplicateDigitalDisplayBoardMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useDuplicateDigitalDisplayBoardMutation(baseOptions?: Apollo.MutationHookOptions<GqlDuplicateDigitalDisplayBoardMutation, GqlDuplicateDigitalDisplayBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDuplicateDigitalDisplayBoardMutation, GqlDuplicateDigitalDisplayBoardMutationVariables>(DuplicateDigitalDisplayBoardDocument, options);
      }
export type DuplicateDigitalDisplayBoardMutationHookResult = ReturnType<typeof useDuplicateDigitalDisplayBoardMutation>;
export type DuplicateDigitalDisplayBoardMutationResult = Apollo.MutationResult<GqlDuplicateDigitalDisplayBoardMutation>;
export type DuplicateDigitalDisplayBoardMutationOptions = Apollo.BaseMutationOptions<GqlDuplicateDigitalDisplayBoardMutation, GqlDuplicateDigitalDisplayBoardMutationVariables>;
export const MenuBoardEnterpriseDispensariesDocument = gql`
    query MenuBoardEnterpriseDispensaries($chainId: String!) {
  chainDispensaryNamesAndIds(chainId: $chainId) {
    id
    name
    cName
  }
}
    `;

/**
 * __useMenuBoardEnterpriseDispensariesQuery__
 *
 * To run a query within a React component, call `useMenuBoardEnterpriseDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuBoardEnterpriseDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuBoardEnterpriseDispensariesQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useMenuBoardEnterpriseDispensariesQuery(baseOptions: Apollo.QueryHookOptions<GqlMenuBoardEnterpriseDispensariesQuery, GqlMenuBoardEnterpriseDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMenuBoardEnterpriseDispensariesQuery, GqlMenuBoardEnterpriseDispensariesQueryVariables>(MenuBoardEnterpriseDispensariesDocument, options);
      }
export function useMenuBoardEnterpriseDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMenuBoardEnterpriseDispensariesQuery, GqlMenuBoardEnterpriseDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMenuBoardEnterpriseDispensariesQuery, GqlMenuBoardEnterpriseDispensariesQueryVariables>(MenuBoardEnterpriseDispensariesDocument, options);
        }
export type MenuBoardEnterpriseDispensariesQueryHookResult = ReturnType<typeof useMenuBoardEnterpriseDispensariesQuery>;
export type MenuBoardEnterpriseDispensariesLazyQueryHookResult = ReturnType<typeof useMenuBoardEnterpriseDispensariesLazyQuery>;
export type MenuBoardEnterpriseDispensariesQueryResult = Apollo.QueryResult<GqlMenuBoardEnterpriseDispensariesQuery, GqlMenuBoardEnterpriseDispensariesQueryVariables>;
export const GetDigitalDisplayDevicesDocument = gql`
    query GetDigitalDisplayDevices($enterpriseId: ID!) {
  digitalDisplayDevices(enterpriseId: $enterpriseId) {
    id
    name
    dispensaryId
    dispensaryName
    state
    city
    online
    lastSeenAt
  }
}
    `;

/**
 * __useGetDigitalDisplayDevicesQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayDevicesQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetDigitalDisplayDevicesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayDevicesQuery, GqlGetDigitalDisplayDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayDevicesQuery, GqlGetDigitalDisplayDevicesQueryVariables>(GetDigitalDisplayDevicesDocument, options);
      }
export function useGetDigitalDisplayDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayDevicesQuery, GqlGetDigitalDisplayDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayDevicesQuery, GqlGetDigitalDisplayDevicesQueryVariables>(GetDigitalDisplayDevicesDocument, options);
        }
export type GetDigitalDisplayDevicesQueryHookResult = ReturnType<typeof useGetDigitalDisplayDevicesQuery>;
export type GetDigitalDisplayDevicesLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayDevicesLazyQuery>;
export type GetDigitalDisplayDevicesQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayDevicesQuery, GqlGetDigitalDisplayDevicesQueryVariables>;
export const GetDigitalDisplayDocument = gql`
    query GetDigitalDisplay($deviceId: ID!) {
  digitalDisplay(deviceId: $deviceId) {
    deviceId
    orientation
    assignments {
      playlistId
      playlistName
      position
    }
  }
}
    `;

/**
 * __useGetDigitalDisplayQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useGetDigitalDisplayQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayQuery, GqlGetDigitalDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayQuery, GqlGetDigitalDisplayQueryVariables>(GetDigitalDisplayDocument, options);
      }
export function useGetDigitalDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayQuery, GqlGetDigitalDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayQuery, GqlGetDigitalDisplayQueryVariables>(GetDigitalDisplayDocument, options);
        }
export type GetDigitalDisplayQueryHookResult = ReturnType<typeof useGetDigitalDisplayQuery>;
export type GetDigitalDisplayLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayLazyQuery>;
export type GetDigitalDisplayQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayQuery, GqlGetDigitalDisplayQueryVariables>;
export const SetDigitalDisplayPlaylistsDocument = gql`
    mutation SetDigitalDisplayPlaylists($deviceId: ID!, $assignments: [DigitalDisplayAssignmentInput!]!) {
  setDigitalDisplayPlaylists(deviceId: $deviceId, assignments: $assignments) {
    deviceId
    orientation
    assignments {
      playlistId
      playlistName
      position
    }
  }
}
    `;
export type GqlSetDigitalDisplayPlaylistsMutationFn = Apollo.MutationFunction<GqlSetDigitalDisplayPlaylistsMutation, GqlSetDigitalDisplayPlaylistsMutationVariables>;

/**
 * __useSetDigitalDisplayPlaylistsMutation__
 *
 * To run a mutation, you first call `useSetDigitalDisplayPlaylistsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDigitalDisplayPlaylistsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDigitalDisplayPlaylistsMutation, { data, loading, error }] = useSetDigitalDisplayPlaylistsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useSetDigitalDisplayPlaylistsMutation(baseOptions?: Apollo.MutationHookOptions<GqlSetDigitalDisplayPlaylistsMutation, GqlSetDigitalDisplayPlaylistsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetDigitalDisplayPlaylistsMutation, GqlSetDigitalDisplayPlaylistsMutationVariables>(SetDigitalDisplayPlaylistsDocument, options);
      }
export type SetDigitalDisplayPlaylistsMutationHookResult = ReturnType<typeof useSetDigitalDisplayPlaylistsMutation>;
export type SetDigitalDisplayPlaylistsMutationResult = Apollo.MutationResult<GqlSetDigitalDisplayPlaylistsMutation>;
export type SetDigitalDisplayPlaylistsMutationOptions = Apollo.BaseMutationOptions<GqlSetDigitalDisplayPlaylistsMutation, GqlSetDigitalDisplayPlaylistsMutationVariables>;
export const UpdateDigitalDisplaySettingsDocument = gql`
    mutation UpdateDigitalDisplaySettings($deviceId: ID!, $orientation: String!) {
  updateDigitalDisplaySettings(deviceId: $deviceId, orientation: $orientation) {
    deviceId
    orientation
    assignments {
      playlistId
      playlistName
      position
    }
  }
}
    `;
export type GqlUpdateDigitalDisplaySettingsMutationFn = Apollo.MutationFunction<GqlUpdateDigitalDisplaySettingsMutation, GqlUpdateDigitalDisplaySettingsMutationVariables>;

/**
 * __useUpdateDigitalDisplaySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalDisplaySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalDisplaySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalDisplaySettingsMutation, { data, loading, error }] = useUpdateDigitalDisplaySettingsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      orientation: // value for 'orientation'
 *   },
 * });
 */
export function useUpdateDigitalDisplaySettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDigitalDisplaySettingsMutation, GqlUpdateDigitalDisplaySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDigitalDisplaySettingsMutation, GqlUpdateDigitalDisplaySettingsMutationVariables>(UpdateDigitalDisplaySettingsDocument, options);
      }
export type UpdateDigitalDisplaySettingsMutationHookResult = ReturnType<typeof useUpdateDigitalDisplaySettingsMutation>;
export type UpdateDigitalDisplaySettingsMutationResult = Apollo.MutationResult<GqlUpdateDigitalDisplaySettingsMutation>;
export type UpdateDigitalDisplaySettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDigitalDisplaySettingsMutation, GqlUpdateDigitalDisplaySettingsMutationVariables>;
export const RestartDigitalDisplayPlaylistDocument = gql`
    mutation RestartDigitalDisplayPlaylist($deviceId: ID!) {
  restartDigitalDisplayPlaylist(deviceId: $deviceId) {
    deviceId
  }
}
    `;
export type GqlRestartDigitalDisplayPlaylistMutationFn = Apollo.MutationFunction<GqlRestartDigitalDisplayPlaylistMutation, GqlRestartDigitalDisplayPlaylistMutationVariables>;

/**
 * __useRestartDigitalDisplayPlaylistMutation__
 *
 * To run a mutation, you first call `useRestartDigitalDisplayPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartDigitalDisplayPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartDigitalDisplayPlaylistMutation, { data, loading, error }] = useRestartDigitalDisplayPlaylistMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useRestartDigitalDisplayPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<GqlRestartDigitalDisplayPlaylistMutation, GqlRestartDigitalDisplayPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRestartDigitalDisplayPlaylistMutation, GqlRestartDigitalDisplayPlaylistMutationVariables>(RestartDigitalDisplayPlaylistDocument, options);
      }
export type RestartDigitalDisplayPlaylistMutationHookResult = ReturnType<typeof useRestartDigitalDisplayPlaylistMutation>;
export type RestartDigitalDisplayPlaylistMutationResult = Apollo.MutationResult<GqlRestartDigitalDisplayPlaylistMutation>;
export type RestartDigitalDisplayPlaylistMutationOptions = Apollo.BaseMutationOptions<GqlRestartDigitalDisplayPlaylistMutation, GqlRestartDigitalDisplayPlaylistMutationVariables>;
export const MenuBoardPreviewMenuFiltersDocument = gql`
    query MenuBoardPreviewMenuFilters($dispensaryId: String!) {
  menuFiltersV2(dispensaryId: $dispensaryId) {
    brands {
      id
      name
    }
    categoriesSubcategories {
      category
      subcategories
    }
  }
}
    `;

/**
 * __useMenuBoardPreviewMenuFiltersQuery__
 *
 * To run a query within a React component, call `useMenuBoardPreviewMenuFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuBoardPreviewMenuFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuBoardPreviewMenuFiltersQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useMenuBoardPreviewMenuFiltersQuery(baseOptions: Apollo.QueryHookOptions<GqlMenuBoardPreviewMenuFiltersQuery, GqlMenuBoardPreviewMenuFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMenuBoardPreviewMenuFiltersQuery, GqlMenuBoardPreviewMenuFiltersQueryVariables>(MenuBoardPreviewMenuFiltersDocument, options);
      }
export function useMenuBoardPreviewMenuFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMenuBoardPreviewMenuFiltersQuery, GqlMenuBoardPreviewMenuFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMenuBoardPreviewMenuFiltersQuery, GqlMenuBoardPreviewMenuFiltersQueryVariables>(MenuBoardPreviewMenuFiltersDocument, options);
        }
export type MenuBoardPreviewMenuFiltersQueryHookResult = ReturnType<typeof useMenuBoardPreviewMenuFiltersQuery>;
export type MenuBoardPreviewMenuFiltersLazyQueryHookResult = ReturnType<typeof useMenuBoardPreviewMenuFiltersLazyQuery>;
export type MenuBoardPreviewMenuFiltersQueryResult = Apollo.QueryResult<GqlMenuBoardPreviewMenuFiltersQuery, GqlMenuBoardPreviewMenuFiltersQueryVariables>;
export const MenuBoardPreviewProductsDocument = gql`
    query MenuBoardPreviewProducts($productsFilter: productsFilterInput!, $perPage: Int) {
  filteredProducts(filter: $productsFilter, perPage: $perPage) {
    products {
      id
      _id
      Name
      brand {
        imageUrl
        name
      }
      brandLogo
      brandName
      type
      strainType
      THCContent {
        range
        unit
      }
      CBDContent {
        range
        unit
      }
      totalTerpenes {
        range
        unit
      }
      Options
      Prices
      recPrices
      special
      recSpecialPrices
      Image
      images {
        url
        active
      }
    }
  }
}
    `;

/**
 * __useMenuBoardPreviewProductsQuery__
 *
 * To run a query within a React component, call `useMenuBoardPreviewProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuBoardPreviewProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuBoardPreviewProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMenuBoardPreviewProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlMenuBoardPreviewProductsQuery, GqlMenuBoardPreviewProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMenuBoardPreviewProductsQuery, GqlMenuBoardPreviewProductsQueryVariables>(MenuBoardPreviewProductsDocument, options);
      }
export function useMenuBoardPreviewProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMenuBoardPreviewProductsQuery, GqlMenuBoardPreviewProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMenuBoardPreviewProductsQuery, GqlMenuBoardPreviewProductsQueryVariables>(MenuBoardPreviewProductsDocument, options);
        }
export type MenuBoardPreviewProductsQueryHookResult = ReturnType<typeof useMenuBoardPreviewProductsQuery>;
export type MenuBoardPreviewProductsLazyQueryHookResult = ReturnType<typeof useMenuBoardPreviewProductsLazyQuery>;
export type MenuBoardPreviewProductsQueryResult = Apollo.QueryResult<GqlMenuBoardPreviewProductsQuery, GqlMenuBoardPreviewProductsQueryVariables>;
export const GetDigitalDisplayPlaylistsDocument = gql`
    query GetDigitalDisplayPlaylists($enterpriseId: ID!, $search: String, $status: DigitalDisplayPlaylistStatus, $limit: Int, $offset: Int, $orientation: DigitalDisplayBoardOrientation, $linkedToDisplay: Boolean, $sortBy: String, $sortDirection: String) {
  digitalDisplayPlaylists(
    enterpriseId: $enterpriseId
    search: $search
    status: $status
    limit: $limit
    offset: $offset
    orientation: $orientation
    linkedToDisplay: $linkedToDisplay
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    items {
      id
      enterpriseId
      name
      description
      status
      createdAt
      updatedAt
      boards {
        durationSeconds
        position
        board {
          id
          orientation
        }
      }
      scheduledChange {
        id
        scheduledAt
        status
      }
    }
    total
  }
}
    `;

/**
 * __useGetDigitalDisplayPlaylistsQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayPlaylistsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orientation: // value for 'orientation'
 *      linkedToDisplay: // value for 'linkedToDisplay'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetDigitalDisplayPlaylistsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayPlaylistsQuery, GqlGetDigitalDisplayPlaylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayPlaylistsQuery, GqlGetDigitalDisplayPlaylistsQueryVariables>(GetDigitalDisplayPlaylistsDocument, options);
      }
export function useGetDigitalDisplayPlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayPlaylistsQuery, GqlGetDigitalDisplayPlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayPlaylistsQuery, GqlGetDigitalDisplayPlaylistsQueryVariables>(GetDigitalDisplayPlaylistsDocument, options);
        }
export type GetDigitalDisplayPlaylistsQueryHookResult = ReturnType<typeof useGetDigitalDisplayPlaylistsQuery>;
export type GetDigitalDisplayPlaylistsLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayPlaylistsLazyQuery>;
export type GetDigitalDisplayPlaylistsQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayPlaylistsQuery, GqlGetDigitalDisplayPlaylistsQueryVariables>;
export const GetDigitalDisplayPlaylistDocument = gql`
    query GetDigitalDisplayPlaylist($enterpriseId: ID!, $id: ID!) {
  digitalDisplayPlaylist(enterpriseId: $enterpriseId, id: $id) {
    id
    enterpriseId
    name
    description
    status
    createdAt
    updatedAt
    boards {
      durationSeconds
      position
      board {
        id
        name
        layout
        orientation
        colorScheme
        menuColumns
        visible
        boardItem {
          assetId
          assetUrl
        }
      }
    }
    scheduledChange {
      id
      scheduledAt
      status
      name
      description
      playlistStatus
      boards {
        durationSeconds
        position
        board {
          id
          name
          layout
          orientation
          colorScheme
          menuColumns
          visible
          boardItem {
            assetId
            assetUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDigitalDisplayPlaylistQuery__
 *
 * To run a query within a React component, call `useGetDigitalDisplayPlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalDisplayPlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalDisplayPlaylistQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDigitalDisplayPlaylistQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDigitalDisplayPlaylistQuery, GqlGetDigitalDisplayPlaylistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDigitalDisplayPlaylistQuery, GqlGetDigitalDisplayPlaylistQueryVariables>(GetDigitalDisplayPlaylistDocument, options);
      }
export function useGetDigitalDisplayPlaylistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDigitalDisplayPlaylistQuery, GqlGetDigitalDisplayPlaylistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDigitalDisplayPlaylistQuery, GqlGetDigitalDisplayPlaylistQueryVariables>(GetDigitalDisplayPlaylistDocument, options);
        }
export type GetDigitalDisplayPlaylistQueryHookResult = ReturnType<typeof useGetDigitalDisplayPlaylistQuery>;
export type GetDigitalDisplayPlaylistLazyQueryHookResult = ReturnType<typeof useGetDigitalDisplayPlaylistLazyQuery>;
export type GetDigitalDisplayPlaylistQueryResult = Apollo.QueryResult<GqlGetDigitalDisplayPlaylistQuery, GqlGetDigitalDisplayPlaylistQueryVariables>;
export const CreateDigitalDisplayPlaylistDocument = gql`
    mutation CreateDigitalDisplayPlaylist($enterpriseId: ID!, $name: String!, $description: String, $status: DigitalDisplayPlaylistStatus) {
  createDigitalDisplayPlaylist(
    enterpriseId: $enterpriseId
    name: $name
    description: $description
    status: $status
  ) {
    id
  }
}
    `;
export type GqlCreateDigitalDisplayPlaylistMutationFn = Apollo.MutationFunction<GqlCreateDigitalDisplayPlaylistMutation, GqlCreateDigitalDisplayPlaylistMutationVariables>;

/**
 * __useCreateDigitalDisplayPlaylistMutation__
 *
 * To run a mutation, you first call `useCreateDigitalDisplayPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigitalDisplayPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigitalDisplayPlaylistMutation, { data, loading, error }] = useCreateDigitalDisplayPlaylistMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCreateDigitalDisplayPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDigitalDisplayPlaylistMutation, GqlCreateDigitalDisplayPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDigitalDisplayPlaylistMutation, GqlCreateDigitalDisplayPlaylistMutationVariables>(CreateDigitalDisplayPlaylistDocument, options);
      }
export type CreateDigitalDisplayPlaylistMutationHookResult = ReturnType<typeof useCreateDigitalDisplayPlaylistMutation>;
export type CreateDigitalDisplayPlaylistMutationResult = Apollo.MutationResult<GqlCreateDigitalDisplayPlaylistMutation>;
export type CreateDigitalDisplayPlaylistMutationOptions = Apollo.BaseMutationOptions<GqlCreateDigitalDisplayPlaylistMutation, GqlCreateDigitalDisplayPlaylistMutationVariables>;
export const UpdateDigitalDisplayPlaylistDocument = gql`
    mutation UpdateDigitalDisplayPlaylist($enterpriseId: ID!, $id: ID!, $name: String, $description: String, $status: DigitalDisplayPlaylistStatus, $boards: [DigitalDisplayPlaylistBoardInput!]) {
  updateDigitalDisplayPlaylist(
    enterpriseId: $enterpriseId
    id: $id
    name: $name
    description: $description
    status: $status
    boards: $boards
  ) {
    id
  }
}
    `;
export type GqlUpdateDigitalDisplayPlaylistMutationFn = Apollo.MutationFunction<GqlUpdateDigitalDisplayPlaylistMutation, GqlUpdateDigitalDisplayPlaylistMutationVariables>;

/**
 * __useUpdateDigitalDisplayPlaylistMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalDisplayPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalDisplayPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalDisplayPlaylistMutation, { data, loading, error }] = useUpdateDigitalDisplayPlaylistMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      boards: // value for 'boards'
 *   },
 * });
 */
export function useUpdateDigitalDisplayPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDigitalDisplayPlaylistMutation, GqlUpdateDigitalDisplayPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDigitalDisplayPlaylistMutation, GqlUpdateDigitalDisplayPlaylistMutationVariables>(UpdateDigitalDisplayPlaylistDocument, options);
      }
export type UpdateDigitalDisplayPlaylistMutationHookResult = ReturnType<typeof useUpdateDigitalDisplayPlaylistMutation>;
export type UpdateDigitalDisplayPlaylistMutationResult = Apollo.MutationResult<GqlUpdateDigitalDisplayPlaylistMutation>;
export type UpdateDigitalDisplayPlaylistMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDigitalDisplayPlaylistMutation, GqlUpdateDigitalDisplayPlaylistMutationVariables>;
export const DuplicateDigitalDisplayPlaylistDocument = gql`
    mutation DuplicateDigitalDisplayPlaylist($enterpriseId: ID!, $id: ID!) {
  duplicateDigitalDisplayPlaylist(enterpriseId: $enterpriseId, id: $id) {
    id
  }
}
    `;
export type GqlDuplicateDigitalDisplayPlaylistMutationFn = Apollo.MutationFunction<GqlDuplicateDigitalDisplayPlaylistMutation, GqlDuplicateDigitalDisplayPlaylistMutationVariables>;

/**
 * __useDuplicateDigitalDisplayPlaylistMutation__
 *
 * To run a mutation, you first call `useDuplicateDigitalDisplayPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDigitalDisplayPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDigitalDisplayPlaylistMutation, { data, loading, error }] = useDuplicateDigitalDisplayPlaylistMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateDigitalDisplayPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<GqlDuplicateDigitalDisplayPlaylistMutation, GqlDuplicateDigitalDisplayPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDuplicateDigitalDisplayPlaylistMutation, GqlDuplicateDigitalDisplayPlaylistMutationVariables>(DuplicateDigitalDisplayPlaylistDocument, options);
      }
export type DuplicateDigitalDisplayPlaylistMutationHookResult = ReturnType<typeof useDuplicateDigitalDisplayPlaylistMutation>;
export type DuplicateDigitalDisplayPlaylistMutationResult = Apollo.MutationResult<GqlDuplicateDigitalDisplayPlaylistMutation>;
export type DuplicateDigitalDisplayPlaylistMutationOptions = Apollo.BaseMutationOptions<GqlDuplicateDigitalDisplayPlaylistMutation, GqlDuplicateDigitalDisplayPlaylistMutationVariables>;
export const ArchiveDigitalDisplayPlaylistDocument = gql`
    mutation ArchiveDigitalDisplayPlaylist($enterpriseId: ID!, $id: ID!) {
  archiveDigitalDisplayPlaylist(enterpriseId: $enterpriseId, id: $id) {
    id
    status
  }
}
    `;
export type GqlArchiveDigitalDisplayPlaylistMutationFn = Apollo.MutationFunction<GqlArchiveDigitalDisplayPlaylistMutation, GqlArchiveDigitalDisplayPlaylistMutationVariables>;

/**
 * __useArchiveDigitalDisplayPlaylistMutation__
 *
 * To run a mutation, you first call `useArchiveDigitalDisplayPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDigitalDisplayPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDigitalDisplayPlaylistMutation, { data, loading, error }] = useArchiveDigitalDisplayPlaylistMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveDigitalDisplayPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<GqlArchiveDigitalDisplayPlaylistMutation, GqlArchiveDigitalDisplayPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlArchiveDigitalDisplayPlaylistMutation, GqlArchiveDigitalDisplayPlaylistMutationVariables>(ArchiveDigitalDisplayPlaylistDocument, options);
      }
export type ArchiveDigitalDisplayPlaylistMutationHookResult = ReturnType<typeof useArchiveDigitalDisplayPlaylistMutation>;
export type ArchiveDigitalDisplayPlaylistMutationResult = Apollo.MutationResult<GqlArchiveDigitalDisplayPlaylistMutation>;
export type ArchiveDigitalDisplayPlaylistMutationOptions = Apollo.BaseMutationOptions<GqlArchiveDigitalDisplayPlaylistMutation, GqlArchiveDigitalDisplayPlaylistMutationVariables>;
export const ScheduleDigitalDisplayPlaylistChangeDocument = gql`
    mutation ScheduleDigitalDisplayPlaylistChange($enterpriseId: ID!, $id: ID!, $scheduledAt: String!, $name: String, $description: String, $status: DigitalDisplayPlaylistStatus, $boards: [DigitalDisplayPlaylistBoardInput!]) {
  scheduleDigitalDisplayPlaylistChange(
    enterpriseId: $enterpriseId
    id: $id
    scheduledAt: $scheduledAt
    name: $name
    description: $description
    status: $status
    boards: $boards
  ) {
    id
    scheduledAt
    status
  }
}
    `;
export type GqlScheduleDigitalDisplayPlaylistChangeMutationFn = Apollo.MutationFunction<GqlScheduleDigitalDisplayPlaylistChangeMutation, GqlScheduleDigitalDisplayPlaylistChangeMutationVariables>;

/**
 * __useScheduleDigitalDisplayPlaylistChangeMutation__
 *
 * To run a mutation, you first call `useScheduleDigitalDisplayPlaylistChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDigitalDisplayPlaylistChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDigitalDisplayPlaylistChangeMutation, { data, loading, error }] = useScheduleDigitalDisplayPlaylistChangeMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      scheduledAt: // value for 'scheduledAt'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      boards: // value for 'boards'
 *   },
 * });
 */
export function useScheduleDigitalDisplayPlaylistChangeMutation(baseOptions?: Apollo.MutationHookOptions<GqlScheduleDigitalDisplayPlaylistChangeMutation, GqlScheduleDigitalDisplayPlaylistChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlScheduleDigitalDisplayPlaylistChangeMutation, GqlScheduleDigitalDisplayPlaylistChangeMutationVariables>(ScheduleDigitalDisplayPlaylistChangeDocument, options);
      }
export type ScheduleDigitalDisplayPlaylistChangeMutationHookResult = ReturnType<typeof useScheduleDigitalDisplayPlaylistChangeMutation>;
export type ScheduleDigitalDisplayPlaylistChangeMutationResult = Apollo.MutationResult<GqlScheduleDigitalDisplayPlaylistChangeMutation>;
export type ScheduleDigitalDisplayPlaylistChangeMutationOptions = Apollo.BaseMutationOptions<GqlScheduleDigitalDisplayPlaylistChangeMutation, GqlScheduleDigitalDisplayPlaylistChangeMutationVariables>;
export const CancelDigitalDisplayPlaylistScheduledChangeDocument = gql`
    mutation CancelDigitalDisplayPlaylistScheduledChange($enterpriseId: ID!, $id: ID!) {
  cancelDigitalDisplayPlaylistScheduledChange(
    enterpriseId: $enterpriseId
    id: $id
  ) {
    id
    status
  }
}
    `;
export type GqlCancelDigitalDisplayPlaylistScheduledChangeMutationFn = Apollo.MutationFunction<GqlCancelDigitalDisplayPlaylistScheduledChangeMutation, GqlCancelDigitalDisplayPlaylistScheduledChangeMutationVariables>;

/**
 * __useCancelDigitalDisplayPlaylistScheduledChangeMutation__
 *
 * To run a mutation, you first call `useCancelDigitalDisplayPlaylistScheduledChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDigitalDisplayPlaylistScheduledChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDigitalDisplayPlaylistScheduledChangeMutation, { data, loading, error }] = useCancelDigitalDisplayPlaylistScheduledChangeMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelDigitalDisplayPlaylistScheduledChangeMutation(baseOptions?: Apollo.MutationHookOptions<GqlCancelDigitalDisplayPlaylistScheduledChangeMutation, GqlCancelDigitalDisplayPlaylistScheduledChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCancelDigitalDisplayPlaylistScheduledChangeMutation, GqlCancelDigitalDisplayPlaylistScheduledChangeMutationVariables>(CancelDigitalDisplayPlaylistScheduledChangeDocument, options);
      }
export type CancelDigitalDisplayPlaylistScheduledChangeMutationHookResult = ReturnType<typeof useCancelDigitalDisplayPlaylistScheduledChangeMutation>;
export type CancelDigitalDisplayPlaylistScheduledChangeMutationResult = Apollo.MutationResult<GqlCancelDigitalDisplayPlaylistScheduledChangeMutation>;
export type CancelDigitalDisplayPlaylistScheduledChangeMutationOptions = Apollo.BaseMutationOptions<GqlCancelDigitalDisplayPlaylistScheduledChangeMutation, GqlCancelDigitalDisplayPlaylistScheduledChangeMutationVariables>;
export const GetRetailersByEnterpriseIdDocument = gql`
    query GetRetailersByEnterpriseId($enterpriseIds: [ID!]!) {
  getRetailersByEnterpriseId(enterpriseIds: $enterpriseIds) {
    dispensaryId
    name
    profile {
      location {
        city
        state
      }
      medicalDispensary
      recDispensary
    }
  }
}
    `;

/**
 * __useGetRetailersByEnterpriseIdQuery__
 *
 * To run a query within a React component, call `useGetRetailersByEnterpriseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailersByEnterpriseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailersByEnterpriseIdQuery({
 *   variables: {
 *      enterpriseIds: // value for 'enterpriseIds'
 *   },
 * });
 */
export function useGetRetailersByEnterpriseIdQuery(baseOptions: Apollo.QueryHookOptions<GqlGetRetailersByEnterpriseIdQuery, GqlGetRetailersByEnterpriseIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetRetailersByEnterpriseIdQuery, GqlGetRetailersByEnterpriseIdQueryVariables>(GetRetailersByEnterpriseIdDocument, options);
      }
export function useGetRetailersByEnterpriseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetRetailersByEnterpriseIdQuery, GqlGetRetailersByEnterpriseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetRetailersByEnterpriseIdQuery, GqlGetRetailersByEnterpriseIdQueryVariables>(GetRetailersByEnterpriseIdDocument, options);
        }
export type GetRetailersByEnterpriseIdQueryHookResult = ReturnType<typeof useGetRetailersByEnterpriseIdQuery>;
export type GetRetailersByEnterpriseIdLazyQueryHookResult = ReturnType<typeof useGetRetailersByEnterpriseIdLazyQuery>;
export type GetRetailersByEnterpriseIdQueryResult = Apollo.QueryResult<GqlGetRetailersByEnterpriseIdQuery, GqlGetRetailersByEnterpriseIdQueryVariables>;
export const GetEnterpriseDocument = gql`
    query GetEnterprise($enterpriseId: ID!) {
  getEnterprise(id: $enterpriseId) {
    id
    hasDposLoyalty
    voiceAiEnabled
    uniqueName
  }
}
    `;

/**
 * __useGetEnterpriseQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetEnterpriseQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseQuery, GqlGetEnterpriseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseQuery, GqlGetEnterpriseQueryVariables>(GetEnterpriseDocument, options);
      }
export function useGetEnterpriseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseQuery, GqlGetEnterpriseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseQuery, GqlGetEnterpriseQueryVariables>(GetEnterpriseDocument, options);
        }
export type GetEnterpriseQueryHookResult = ReturnType<typeof useGetEnterpriseQuery>;
export type GetEnterpriseLazyQueryHookResult = ReturnType<typeof useGetEnterpriseLazyQuery>;
export type GetEnterpriseQueryResult = Apollo.QueryResult<GqlGetEnterpriseQuery, GqlGetEnterpriseQueryVariables>;
export const EnterpriseWebsiteDomainsDocument = gql`
    query EnterpriseWebsiteDomains($enterpriseId: ID!) {
  enterpriseDomains(enterpriseId: $enterpriseId) {
    id
    hostname
    websiteId
  }
}
    `;

/**
 * __useEnterpriseWebsiteDomainsQuery__
 *
 * To run a query within a React component, call `useEnterpriseWebsiteDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseWebsiteDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseWebsiteDomainsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseWebsiteDomainsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseWebsiteDomainsQuery, GqlEnterpriseWebsiteDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseWebsiteDomainsQuery, GqlEnterpriseWebsiteDomainsQueryVariables>(EnterpriseWebsiteDomainsDocument, options);
      }
export function useEnterpriseWebsiteDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseWebsiteDomainsQuery, GqlEnterpriseWebsiteDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseWebsiteDomainsQuery, GqlEnterpriseWebsiteDomainsQueryVariables>(EnterpriseWebsiteDomainsDocument, options);
        }
export type EnterpriseWebsiteDomainsQueryHookResult = ReturnType<typeof useEnterpriseWebsiteDomainsQuery>;
export type EnterpriseWebsiteDomainsLazyQueryHookResult = ReturnType<typeof useEnterpriseWebsiteDomainsLazyQuery>;
export type EnterpriseWebsiteDomainsQueryResult = Apollo.QueryResult<GqlEnterpriseWebsiteDomainsQuery, GqlEnterpriseWebsiteDomainsQueryVariables>;
export const GetLocationGroupsDocument = gql`
    query GetLocationGroups($enterpriseId: ID!) {
  locationGroups(enterpriseId: $enterpriseId) {
    id
    name
    description
    enterpriseId
    retailerIds
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLocationGroupsQuery__
 *
 * To run a query within a React component, call `useGetLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGroupsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetLocationGroupsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetLocationGroupsQuery, GqlGetLocationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetLocationGroupsQuery, GqlGetLocationGroupsQueryVariables>(GetLocationGroupsDocument, options);
      }
export function useGetLocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetLocationGroupsQuery, GqlGetLocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetLocationGroupsQuery, GqlGetLocationGroupsQueryVariables>(GetLocationGroupsDocument, options);
        }
export type GetLocationGroupsQueryHookResult = ReturnType<typeof useGetLocationGroupsQuery>;
export type GetLocationGroupsLazyQueryHookResult = ReturnType<typeof useGetLocationGroupsLazyQuery>;
export type GetLocationGroupsQueryResult = Apollo.QueryResult<GqlGetLocationGroupsQuery, GqlGetLocationGroupsQueryVariables>;
export const GetLocationGroupDocument = gql`
    query GetLocationGroup($enterpriseId: ID!, $id: ID!) {
  locationGroup(enterpriseId: $enterpriseId, id: $id) {
    id
    name
    description
    enterpriseId
    retailerIds
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLocationGroupQuery__
 *
 * To run a query within a React component, call `useGetLocationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGroupQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationGroupQuery(baseOptions: Apollo.QueryHookOptions<GqlGetLocationGroupQuery, GqlGetLocationGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetLocationGroupQuery, GqlGetLocationGroupQueryVariables>(GetLocationGroupDocument, options);
      }
export function useGetLocationGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetLocationGroupQuery, GqlGetLocationGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetLocationGroupQuery, GqlGetLocationGroupQueryVariables>(GetLocationGroupDocument, options);
        }
export type GetLocationGroupQueryHookResult = ReturnType<typeof useGetLocationGroupQuery>;
export type GetLocationGroupLazyQueryHookResult = ReturnType<typeof useGetLocationGroupLazyQuery>;
export type GetLocationGroupQueryResult = Apollo.QueryResult<GqlGetLocationGroupQuery, GqlGetLocationGroupQueryVariables>;
export const CreateLocationGroupDocument = gql`
    mutation CreateLocationGroup($enterpriseId: ID!, $name: String!, $description: String, $retailerIds: [ID!]) {
  createLocationGroup(
    enterpriseId: $enterpriseId
    name: $name
    description: $description
    retailerIds: $retailerIds
  ) {
    id
    name
    description
    retailerIds
  }
}
    `;
export type GqlCreateLocationGroupMutationFn = Apollo.MutationFunction<GqlCreateLocationGroupMutation, GqlCreateLocationGroupMutationVariables>;

/**
 * __useCreateLocationGroupMutation__
 *
 * To run a mutation, you first call `useCreateLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationGroupMutation, { data, loading, error }] = useCreateLocationGroupMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      retailerIds: // value for 'retailerIds'
 *   },
 * });
 */
export function useCreateLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateLocationGroupMutation, GqlCreateLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateLocationGroupMutation, GqlCreateLocationGroupMutationVariables>(CreateLocationGroupDocument, options);
      }
export type CreateLocationGroupMutationHookResult = ReturnType<typeof useCreateLocationGroupMutation>;
export type CreateLocationGroupMutationResult = Apollo.MutationResult<GqlCreateLocationGroupMutation>;
export type CreateLocationGroupMutationOptions = Apollo.BaseMutationOptions<GqlCreateLocationGroupMutation, GqlCreateLocationGroupMutationVariables>;
export const UpdateLocationGroupDocument = gql`
    mutation UpdateLocationGroup($enterpriseId: ID!, $id: ID!, $name: String, $description: String, $retailerIds: [ID!]) {
  updateLocationGroup(
    enterpriseId: $enterpriseId
    id: $id
    name: $name
    description: $description
    retailerIds: $retailerIds
  ) {
    id
    name
    description
    retailerIds
  }
}
    `;
export type GqlUpdateLocationGroupMutationFn = Apollo.MutationFunction<GqlUpdateLocationGroupMutation, GqlUpdateLocationGroupMutationVariables>;

/**
 * __useUpdateLocationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationGroupMutation, { data, loading, error }] = useUpdateLocationGroupMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      retailerIds: // value for 'retailerIds'
 *   },
 * });
 */
export function useUpdateLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateLocationGroupMutation, GqlUpdateLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateLocationGroupMutation, GqlUpdateLocationGroupMutationVariables>(UpdateLocationGroupDocument, options);
      }
export type UpdateLocationGroupMutationHookResult = ReturnType<typeof useUpdateLocationGroupMutation>;
export type UpdateLocationGroupMutationResult = Apollo.MutationResult<GqlUpdateLocationGroupMutation>;
export type UpdateLocationGroupMutationOptions = Apollo.BaseMutationOptions<GqlUpdateLocationGroupMutation, GqlUpdateLocationGroupMutationVariables>;
export const DeleteLocationGroupDocument = gql`
    mutation DeleteLocationGroup($enterpriseId: ID!, $id: ID!) {
  deleteLocationGroup(enterpriseId: $enterpriseId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteLocationGroupMutationFn = Apollo.MutationFunction<GqlDeleteLocationGroupMutation, GqlDeleteLocationGroupMutationVariables>;

/**
 * __useDeleteLocationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationGroupMutation, { data, loading, error }] = useDeleteLocationGroupMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteLocationGroupMutation, GqlDeleteLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteLocationGroupMutation, GqlDeleteLocationGroupMutationVariables>(DeleteLocationGroupDocument, options);
      }
export type DeleteLocationGroupMutationHookResult = ReturnType<typeof useDeleteLocationGroupMutation>;
export type DeleteLocationGroupMutationResult = Apollo.MutationResult<GqlDeleteLocationGroupMutation>;
export type DeleteLocationGroupMutationOptions = Apollo.BaseMutationOptions<GqlDeleteLocationGroupMutation, GqlDeleteLocationGroupMutationVariables>;
export const GetEnterpriseDispensariesDocument = gql`
    query GetEnterpriseDispensaries($chainId: String) {
  chainDispensaryNamesAndIds(chainId: $chainId) {
    id
    name
    address
    location {
      city
      state
    }
    retailer {
      id
    }
  }
}
    `;

/**
 * __useGetEnterpriseDispensariesQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseDispensariesQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetEnterpriseDispensariesQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetEnterpriseDispensariesQuery, GqlGetEnterpriseDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseDispensariesQuery, GqlGetEnterpriseDispensariesQueryVariables>(GetEnterpriseDispensariesDocument, options);
      }
export function useGetEnterpriseDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseDispensariesQuery, GqlGetEnterpriseDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseDispensariesQuery, GqlGetEnterpriseDispensariesQueryVariables>(GetEnterpriseDispensariesDocument, options);
        }
export type GetEnterpriseDispensariesQueryHookResult = ReturnType<typeof useGetEnterpriseDispensariesQuery>;
export type GetEnterpriseDispensariesLazyQueryHookResult = ReturnType<typeof useGetEnterpriseDispensariesLazyQuery>;
export type GetEnterpriseDispensariesQueryResult = Apollo.QueryResult<GqlGetEnterpriseDispensariesQuery, GqlGetEnterpriseDispensariesQueryVariables>;
export const GetEnterpriseBrandOrderDocument = gql`
    query GetEnterpriseBrandOrder($chainId: String!) {
  filteredDispensaries(filter: {chain: $chainId}) {
    id
    name
    location {
      state
      city
    }
    featuredBrandsSettings {
      category
      brandIds
    }
  }
}
    `;

/**
 * __useGetEnterpriseBrandOrderQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseBrandOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseBrandOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseBrandOrderQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetEnterpriseBrandOrderQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseBrandOrderQuery, GqlGetEnterpriseBrandOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseBrandOrderQuery, GqlGetEnterpriseBrandOrderQueryVariables>(GetEnterpriseBrandOrderDocument, options);
      }
export function useGetEnterpriseBrandOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseBrandOrderQuery, GqlGetEnterpriseBrandOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseBrandOrderQuery, GqlGetEnterpriseBrandOrderQueryVariables>(GetEnterpriseBrandOrderDocument, options);
        }
export type GetEnterpriseBrandOrderQueryHookResult = ReturnType<typeof useGetEnterpriseBrandOrderQuery>;
export type GetEnterpriseBrandOrderLazyQueryHookResult = ReturnType<typeof useGetEnterpriseBrandOrderLazyQuery>;
export type GetEnterpriseBrandOrderQueryResult = Apollo.QueryResult<GqlGetEnterpriseBrandOrderQuery, GqlGetEnterpriseBrandOrderQueryVariables>;
export const GetEnterpriseMenuSortingDocument = gql`
    query GetEnterpriseMenuSorting($chainId: String!) {
  filteredDispensaries(filter: {chain: $chainId}) {
    id
    name
    cName
    location {
      state
      city
    }
    menuOrder
    menuOrderSettings {
      category
      menuOrder
    }
    activeCategories
  }
}
    `;

/**
 * __useGetEnterpriseMenuSortingQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseMenuSortingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseMenuSortingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseMenuSortingQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetEnterpriseMenuSortingQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseMenuSortingQuery, GqlGetEnterpriseMenuSortingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseMenuSortingQuery, GqlGetEnterpriseMenuSortingQueryVariables>(GetEnterpriseMenuSortingDocument, options);
      }
export function useGetEnterpriseMenuSortingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseMenuSortingQuery, GqlGetEnterpriseMenuSortingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseMenuSortingQuery, GqlGetEnterpriseMenuSortingQueryVariables>(GetEnterpriseMenuSortingDocument, options);
        }
export type GetEnterpriseMenuSortingQueryHookResult = ReturnType<typeof useGetEnterpriseMenuSortingQuery>;
export type GetEnterpriseMenuSortingLazyQueryHookResult = ReturnType<typeof useGetEnterpriseMenuSortingLazyQuery>;
export type GetEnterpriseMenuSortingQueryResult = Apollo.QueryResult<GqlGetEnterpriseMenuSortingQuery, GqlGetEnterpriseMenuSortingQueryVariables>;
export const GetEnterpriseSpecialsDocument = gql`
    query GetEnterpriseSpecials($enterpriseId: ID!) {
  enterpriseSpecials(enterpriseId: $enterpriseId) {
    active
    complete
    createdAt
    dispensaryId
    endDay
    endStamp
    enterpriseId
    enterpriseSpecialId
    id
    inactiveDispensaries
    isRecurring
    localTime
    name
    recurring {
      days
      endDate
      endTime
      setEndDate
      startTime
    }
    scope
    specialType
    startDay
    startStamp
    timezone
    updatedAt
    version
  }
}
    `;

/**
 * __useGetEnterpriseSpecialsQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseSpecialsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetEnterpriseSpecialsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseSpecialsQuery, GqlGetEnterpriseSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseSpecialsQuery, GqlGetEnterpriseSpecialsQueryVariables>(GetEnterpriseSpecialsDocument, options);
      }
export function useGetEnterpriseSpecialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseSpecialsQuery, GqlGetEnterpriseSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseSpecialsQuery, GqlGetEnterpriseSpecialsQueryVariables>(GetEnterpriseSpecialsDocument, options);
        }
export type GetEnterpriseSpecialsQueryHookResult = ReturnType<typeof useGetEnterpriseSpecialsQuery>;
export type GetEnterpriseSpecialsLazyQueryHookResult = ReturnType<typeof useGetEnterpriseSpecialsLazyQuery>;
export type GetEnterpriseSpecialsQueryResult = Apollo.QueryResult<GqlGetEnterpriseSpecialsQuery, GqlGetEnterpriseSpecialsQueryVariables>;
export const ImportProductReviewsDocument = gql`
    mutation ImportProductReviews($dispensaryId: String!, $csv: String!) {
  importProductReviews(dispensaryId: $dispensaryId, csv: $csv) {
    success
    message
  }
}
    `;
export type GqlImportProductReviewsMutationFn = Apollo.MutationFunction<GqlImportProductReviewsMutation, GqlImportProductReviewsMutationVariables>;

/**
 * __useImportProductReviewsMutation__
 *
 * To run a mutation, you first call `useImportProductReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProductReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProductReviewsMutation, { data, loading, error }] = useImportProductReviewsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useImportProductReviewsMutation(baseOptions?: Apollo.MutationHookOptions<GqlImportProductReviewsMutation, GqlImportProductReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlImportProductReviewsMutation, GqlImportProductReviewsMutationVariables>(ImportProductReviewsDocument, options);
      }
export type ImportProductReviewsMutationHookResult = ReturnType<typeof useImportProductReviewsMutation>;
export type ImportProductReviewsMutationResult = Apollo.MutationResult<GqlImportProductReviewsMutation>;
export type ImportProductReviewsMutationOptions = Apollo.BaseMutationOptions<GqlImportProductReviewsMutation, GqlImportProductReviewsMutationVariables>;
export const GetAdminProductReviewsDocument = gql`
    query GetAdminProductReviews($productId: String, $dispensaryIds: [String!], $status: ReviewStatus, $startDate: String, $page: Int, $limit: Int) {
  getAdminProductReviews(
    productId: $productId
    dispensaryIds: $dispensaryIds
    status: $status
    startDate: $startDate
    page: $page
    limit: $limit
  ) {
    productReviews {
      ...AdminProductReviewFields
    }
    meta {
      totalCount
      totalPages
      perPage
    }
  }
}
    ${AdminProductReviewFieldsFragmentDoc}`;

/**
 * __useGetAdminProductReviewsQuery__
 *
 * To run a query within a React component, call `useGetAdminProductReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminProductReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminProductReviewsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      dispensaryIds: // value for 'dispensaryIds'
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAdminProductReviewsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetAdminProductReviewsQuery, GqlGetAdminProductReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetAdminProductReviewsQuery, GqlGetAdminProductReviewsQueryVariables>(GetAdminProductReviewsDocument, options);
      }
export function useGetAdminProductReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetAdminProductReviewsQuery, GqlGetAdminProductReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetAdminProductReviewsQuery, GqlGetAdminProductReviewsQueryVariables>(GetAdminProductReviewsDocument, options);
        }
export type GetAdminProductReviewsQueryHookResult = ReturnType<typeof useGetAdminProductReviewsQuery>;
export type GetAdminProductReviewsLazyQueryHookResult = ReturnType<typeof useGetAdminProductReviewsLazyQuery>;
export type GetAdminProductReviewsQueryResult = Apollo.QueryResult<GqlGetAdminProductReviewsQuery, GqlGetAdminProductReviewsQueryVariables>;
export const GetAdminReviewFilterOptionsDocument = gql`
    query GetAdminReviewFilterOptions($dispensaryIds: [String!], $status: ReviewStatus, $startDate: String) {
  getAdminReviewFilterOptions(
    dispensaryIds: $dispensaryIds
    status: $status
    startDate: $startDate
  ) {
    productIds
    dispensaryIds
  }
}
    `;

/**
 * __useGetAdminReviewFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetAdminReviewFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminReviewFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminReviewFilterOptionsQuery({
 *   variables: {
 *      dispensaryIds: // value for 'dispensaryIds'
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetAdminReviewFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetAdminReviewFilterOptionsQuery, GqlGetAdminReviewFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetAdminReviewFilterOptionsQuery, GqlGetAdminReviewFilterOptionsQueryVariables>(GetAdminReviewFilterOptionsDocument, options);
      }
export function useGetAdminReviewFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetAdminReviewFilterOptionsQuery, GqlGetAdminReviewFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetAdminReviewFilterOptionsQuery, GqlGetAdminReviewFilterOptionsQueryVariables>(GetAdminReviewFilterOptionsDocument, options);
        }
export type GetAdminReviewFilterOptionsQueryHookResult = ReturnType<typeof useGetAdminReviewFilterOptionsQuery>;
export type GetAdminReviewFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetAdminReviewFilterOptionsLazyQuery>;
export type GetAdminReviewFilterOptionsQueryResult = Apollo.QueryResult<GqlGetAdminReviewFilterOptionsQuery, GqlGetAdminReviewFilterOptionsQueryVariables>;
export const GetReviewProductNamesDocument = gql`
    query GetReviewProductNames($filter: productsFilterInput!, $perPage: Int) {
  filteredProducts(filter: $filter, perPage: $perPage) {
    products {
      id
      _id
      Name
    }
  }
}
    `;

/**
 * __useGetReviewProductNamesQuery__
 *
 * To run a query within a React component, call `useGetReviewProductNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewProductNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewProductNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetReviewProductNamesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetReviewProductNamesQuery, GqlGetReviewProductNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetReviewProductNamesQuery, GqlGetReviewProductNamesQueryVariables>(GetReviewProductNamesDocument, options);
      }
export function useGetReviewProductNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetReviewProductNamesQuery, GqlGetReviewProductNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetReviewProductNamesQuery, GqlGetReviewProductNamesQueryVariables>(GetReviewProductNamesDocument, options);
        }
export type GetReviewProductNamesQueryHookResult = ReturnType<typeof useGetReviewProductNamesQuery>;
export type GetReviewProductNamesLazyQueryHookResult = ReturnType<typeof useGetReviewProductNamesLazyQuery>;
export type GetReviewProductNamesQueryResult = Apollo.QueryResult<GqlGetReviewProductNamesQuery, GqlGetReviewProductNamesQueryVariables>;
export const ModerateProductReviewDocument = gql`
    mutation ModerateProductReview($input: ModerateProductReviewInput!) {
  moderateProductReview(input: $input) {
    ...AdminProductReviewFields
  }
}
    ${AdminProductReviewFieldsFragmentDoc}`;
export type GqlModerateProductReviewMutationFn = Apollo.MutationFunction<GqlModerateProductReviewMutation, GqlModerateProductReviewMutationVariables>;

/**
 * __useModerateProductReviewMutation__
 *
 * To run a mutation, you first call `useModerateProductReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModerateProductReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderateProductReviewMutation, { data, loading, error }] = useModerateProductReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModerateProductReviewMutation(baseOptions?: Apollo.MutationHookOptions<GqlModerateProductReviewMutation, GqlModerateProductReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlModerateProductReviewMutation, GqlModerateProductReviewMutationVariables>(ModerateProductReviewDocument, options);
      }
export type ModerateProductReviewMutationHookResult = ReturnType<typeof useModerateProductReviewMutation>;
export type ModerateProductReviewMutationResult = Apollo.MutationResult<GqlModerateProductReviewMutation>;
export type ModerateProductReviewMutationOptions = Apollo.BaseMutationOptions<GqlModerateProductReviewMutation, GqlModerateProductReviewMutationVariables>;
export const DeleteReviewDocument = gql`
    mutation DeleteReview($id: String!) {
  deleteReview(id: $id) {
    success
    message
  }
}
    `;
export type GqlDeleteReviewMutationFn = Apollo.MutationFunction<GqlDeleteReviewMutation, GqlDeleteReviewMutationVariables>;

/**
 * __useDeleteReviewMutation__
 *
 * To run a mutation, you first call `useDeleteReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewMutation, { data, loading, error }] = useDeleteReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteReviewMutation, GqlDeleteReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteReviewMutation, GqlDeleteReviewMutationVariables>(DeleteReviewDocument, options);
      }
export type DeleteReviewMutationHookResult = ReturnType<typeof useDeleteReviewMutation>;
export type DeleteReviewMutationResult = Apollo.MutationResult<GqlDeleteReviewMutation>;
export type DeleteReviewMutationOptions = Apollo.BaseMutationOptions<GqlDeleteReviewMutation, GqlDeleteReviewMutationVariables>;
export const EnterpriseAdSettingsDocument = gql`
    query EnterpriseAdSettings($enterpriseId: ID!) {
  enterpriseAdSettings(enterpriseId: $enterpriseId) {
    id
    name
    adSettings {
      enableAdsForDefault
      enableAdsForEmbedded
      enableAdsForKiosk
      enableAdsForStoreFront
    }
    status
  }
}
    `;

/**
 * __useEnterpriseAdSettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseAdSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseAdSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseAdSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseAdSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseAdSettingsQuery, GqlEnterpriseAdSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseAdSettingsQuery, GqlEnterpriseAdSettingsQueryVariables>(EnterpriseAdSettingsDocument, options);
      }
export function useEnterpriseAdSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseAdSettingsQuery, GqlEnterpriseAdSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseAdSettingsQuery, GqlEnterpriseAdSettingsQueryVariables>(EnterpriseAdSettingsDocument, options);
        }
export type EnterpriseAdSettingsQueryHookResult = ReturnType<typeof useEnterpriseAdSettingsQuery>;
export type EnterpriseAdSettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseAdSettingsLazyQuery>;
export type EnterpriseAdSettingsQueryResult = Apollo.QueryResult<GqlEnterpriseAdSettingsQuery, GqlEnterpriseAdSettingsQueryVariables>;
export const EnterprisePersonalizationSettingsDocument = gql`
    query EnterprisePersonalizationSettings($enterpriseId: ID!) {
  enterprisePersonalizationSettings(enterpriseId: $enterpriseId) {
    id
    name
    personalizationSettings {
      enablePersonalizationForDefault
      enablePersonalizationForEmbedded
      enablePersonalizationForKiosk
      enablePersonalizationForStoreFront
      enableSortByRelevance
    }
    status
  }
}
    `;

/**
 * __useEnterprisePersonalizationSettingsQuery__
 *
 * To run a query within a React component, call `useEnterprisePersonalizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterprisePersonalizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterprisePersonalizationSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterprisePersonalizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterprisePersonalizationSettingsQuery, GqlEnterprisePersonalizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterprisePersonalizationSettingsQuery, GqlEnterprisePersonalizationSettingsQueryVariables>(EnterprisePersonalizationSettingsDocument, options);
      }
export function useEnterprisePersonalizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterprisePersonalizationSettingsQuery, GqlEnterprisePersonalizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterprisePersonalizationSettingsQuery, GqlEnterprisePersonalizationSettingsQueryVariables>(EnterprisePersonalizationSettingsDocument, options);
        }
export type EnterprisePersonalizationSettingsQueryHookResult = ReturnType<typeof useEnterprisePersonalizationSettingsQuery>;
export type EnterprisePersonalizationSettingsLazyQueryHookResult = ReturnType<typeof useEnterprisePersonalizationSettingsLazyQuery>;
export type EnterprisePersonalizationSettingsQueryResult = Apollo.QueryResult<GqlEnterprisePersonalizationSettingsQuery, GqlEnterprisePersonalizationSettingsQueryVariables>;
export const UpdateEnterpriseAdSettingsDocument = gql`
    mutation updateEnterpriseAdSettings($enterpriseId: ID!, $settings: DispensaryAdSettingsInput!) {
  updateEnterpriseAdSettings(enterpriseId: $enterpriseId, settings: $settings) {
    adSettings {
      enableAdsForDefault
      enableAdsForEmbedded
      enableAdsForKiosk
      enableAdsForStoreFront
    }
  }
}
    `;
export type GqlUpdateEnterpriseAdSettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseAdSettingsMutation, GqlUpdateEnterpriseAdSettingsMutationVariables>;

/**
 * __useUpdateEnterpriseAdSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseAdSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseAdSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseAdSettingsMutation, { data, loading, error }] = useUpdateEnterpriseAdSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateEnterpriseAdSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseAdSettingsMutation, GqlUpdateEnterpriseAdSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseAdSettingsMutation, GqlUpdateEnterpriseAdSettingsMutationVariables>(UpdateEnterpriseAdSettingsDocument, options);
      }
export type UpdateEnterpriseAdSettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseAdSettingsMutation>;
export type UpdateEnterpriseAdSettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseAdSettingsMutation>;
export type UpdateEnterpriseAdSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseAdSettingsMutation, GqlUpdateEnterpriseAdSettingsMutationVariables>;
export const UpdateEnterprisePersonalizationSettingsDocument = gql`
    mutation updateEnterprisePersonalizationSettings($enterpriseId: ID!, $settings: DispensaryPersonalizationSettingsInput!) {
  updateEnterprisePersonalizationSettings(
    enterpriseId: $enterpriseId
    settings: $settings
  ) {
    personalizationSettings {
      enablePersonalizationForDefault
      enablePersonalizationForEmbedded
      enablePersonalizationForKiosk
      enablePersonalizationForStoreFront
      enableSortByRelevance
    }
  }
}
    `;
export type GqlUpdateEnterprisePersonalizationSettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterprisePersonalizationSettingsMutation, GqlUpdateEnterprisePersonalizationSettingsMutationVariables>;

/**
 * __useUpdateEnterprisePersonalizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterprisePersonalizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterprisePersonalizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterprisePersonalizationSettingsMutation, { data, loading, error }] = useUpdateEnterprisePersonalizationSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateEnterprisePersonalizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterprisePersonalizationSettingsMutation, GqlUpdateEnterprisePersonalizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterprisePersonalizationSettingsMutation, GqlUpdateEnterprisePersonalizationSettingsMutationVariables>(UpdateEnterprisePersonalizationSettingsDocument, options);
      }
export type UpdateEnterprisePersonalizationSettingsMutationHookResult = ReturnType<typeof useUpdateEnterprisePersonalizationSettingsMutation>;
export type UpdateEnterprisePersonalizationSettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterprisePersonalizationSettingsMutation>;
export type UpdateEnterprisePersonalizationSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterprisePersonalizationSettingsMutation, GqlUpdateEnterprisePersonalizationSettingsMutationVariables>;
export const GetPlusOAuthProvidersDocument = gql`
    query GetPlusOAuthProviders($enterpriseId: String!) {
  getPlusOAuthProviders(enterpriseId: $enterpriseId) {
    authorizationUrl
    clientId
    enterpriseId
    id
    name
    site
    tokenUrl
    userInfoUrl
  }
}
    `;

/**
 * __useGetPlusOAuthProvidersQuery__
 *
 * To run a query within a React component, call `useGetPlusOAuthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlusOAuthProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlusOAuthProvidersQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetPlusOAuthProvidersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPlusOAuthProvidersQuery, GqlGetPlusOAuthProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPlusOAuthProvidersQuery, GqlGetPlusOAuthProvidersQueryVariables>(GetPlusOAuthProvidersDocument, options);
      }
export function useGetPlusOAuthProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPlusOAuthProvidersQuery, GqlGetPlusOAuthProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPlusOAuthProvidersQuery, GqlGetPlusOAuthProvidersQueryVariables>(GetPlusOAuthProvidersDocument, options);
        }
export type GetPlusOAuthProvidersQueryHookResult = ReturnType<typeof useGetPlusOAuthProvidersQuery>;
export type GetPlusOAuthProvidersLazyQueryHookResult = ReturnType<typeof useGetPlusOAuthProvidersLazyQuery>;
export type GetPlusOAuthProvidersQueryResult = Apollo.QueryResult<GqlGetPlusOAuthProvidersQuery, GqlGetPlusOAuthProvidersQueryVariables>;
export const UpdatePlusOAuthProviderDocument = gql`
    mutation UpdatePlusOAuthProvider($enterpriseId: String!, $input: PlusOAuthProviderInput!) {
  updatePlusOAuthProvider(enterpriseId: $enterpriseId, input: $input) {
    authorizationUrl
    clientId
    enterpriseId
    id
    name
    site
    tokenUrl
    userInfoUrl
  }
}
    `;
export type GqlUpdatePlusOAuthProviderMutationFn = Apollo.MutationFunction<GqlUpdatePlusOAuthProviderMutation, GqlUpdatePlusOAuthProviderMutationVariables>;

/**
 * __useUpdatePlusOAuthProviderMutation__
 *
 * To run a mutation, you first call `useUpdatePlusOAuthProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlusOAuthProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlusOAuthProviderMutation, { data, loading, error }] = useUpdatePlusOAuthProviderMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlusOAuthProviderMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdatePlusOAuthProviderMutation, GqlUpdatePlusOAuthProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdatePlusOAuthProviderMutation, GqlUpdatePlusOAuthProviderMutationVariables>(UpdatePlusOAuthProviderDocument, options);
      }
export type UpdatePlusOAuthProviderMutationHookResult = ReturnType<typeof useUpdatePlusOAuthProviderMutation>;
export type UpdatePlusOAuthProviderMutationResult = Apollo.MutationResult<GqlUpdatePlusOAuthProviderMutation>;
export type UpdatePlusOAuthProviderMutationOptions = Apollo.BaseMutationOptions<GqlUpdatePlusOAuthProviderMutation, GqlUpdatePlusOAuthProviderMutationVariables>;
export const CreateEnterpriseDomainDocument = gql`
    mutation CreateEnterpriseDomain($enterpriseId: ID!, $hostname: String!, $domainType: EnterpriseDomainType!, $websiteId: String!, $locationGroupId: ID) {
  createEnterpriseDomain(
    enterpriseId: $enterpriseId
    hostname: $hostname
    domainType: $domainType
    websiteId: $websiteId
    locationGroupId: $locationGroupId
  ) {
    id
    hostname
    domainType
    status
    sslStatus
  }
}
    `;
export type GqlCreateEnterpriseDomainMutationFn = Apollo.MutationFunction<GqlCreateEnterpriseDomainMutation, GqlCreateEnterpriseDomainMutationVariables>;

/**
 * __useCreateEnterpriseDomainMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseDomainMutation, { data, loading, error }] = useCreateEnterpriseDomainMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      hostname: // value for 'hostname'
 *      domainType: // value for 'domainType'
 *      websiteId: // value for 'websiteId'
 *      locationGroupId: // value for 'locationGroupId'
 *   },
 * });
 */
export function useCreateEnterpriseDomainMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseDomainMutation, GqlCreateEnterpriseDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseDomainMutation, GqlCreateEnterpriseDomainMutationVariables>(CreateEnterpriseDomainDocument, options);
      }
export type CreateEnterpriseDomainMutationHookResult = ReturnType<typeof useCreateEnterpriseDomainMutation>;
export type CreateEnterpriseDomainMutationResult = Apollo.MutationResult<GqlCreateEnterpriseDomainMutation>;
export type CreateEnterpriseDomainMutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseDomainMutation, GqlCreateEnterpriseDomainMutationVariables>;
export const DeleteEnterpriseDomainDocument = gql`
    mutation DeleteEnterpriseDomain($enterpriseId: ID!, $id: ID!) {
  deleteEnterpriseDomain(enterpriseId: $enterpriseId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteEnterpriseDomainMutationFn = Apollo.MutationFunction<GqlDeleteEnterpriseDomainMutation, GqlDeleteEnterpriseDomainMutationVariables>;

/**
 * __useDeleteEnterpriseDomainMutation__
 *
 * To run a mutation, you first call `useDeleteEnterpriseDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnterpriseDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnterpriseDomainMutation, { data, loading, error }] = useDeleteEnterpriseDomainMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnterpriseDomainMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteEnterpriseDomainMutation, GqlDeleteEnterpriseDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteEnterpriseDomainMutation, GqlDeleteEnterpriseDomainMutationVariables>(DeleteEnterpriseDomainDocument, options);
      }
export type DeleteEnterpriseDomainMutationHookResult = ReturnType<typeof useDeleteEnterpriseDomainMutation>;
export type DeleteEnterpriseDomainMutationResult = Apollo.MutationResult<GqlDeleteEnterpriseDomainMutation>;
export type DeleteEnterpriseDomainMutationOptions = Apollo.BaseMutationOptions<GqlDeleteEnterpriseDomainMutation, GqlDeleteEnterpriseDomainMutationVariables>;
export const EnterpriseDomainSetupInstructionsDocument = gql`
    query EnterpriseDomainSetupInstructions($enterpriseId: ID!, $id: ID!) {
  enterpriseDomainSetupInstructions(enterpriseId: $enterpriseId, id: $id) {
    records {
      recordType
      name
      value
    }
  }
}
    `;

/**
 * __useEnterpriseDomainSetupInstructionsQuery__
 *
 * To run a query within a React component, call `useEnterpriseDomainSetupInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseDomainSetupInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseDomainSetupInstructionsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnterpriseDomainSetupInstructionsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseDomainSetupInstructionsQuery, GqlEnterpriseDomainSetupInstructionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseDomainSetupInstructionsQuery, GqlEnterpriseDomainSetupInstructionsQueryVariables>(EnterpriseDomainSetupInstructionsDocument, options);
      }
export function useEnterpriseDomainSetupInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseDomainSetupInstructionsQuery, GqlEnterpriseDomainSetupInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseDomainSetupInstructionsQuery, GqlEnterpriseDomainSetupInstructionsQueryVariables>(EnterpriseDomainSetupInstructionsDocument, options);
        }
export type EnterpriseDomainSetupInstructionsQueryHookResult = ReturnType<typeof useEnterpriseDomainSetupInstructionsQuery>;
export type EnterpriseDomainSetupInstructionsLazyQueryHookResult = ReturnType<typeof useEnterpriseDomainSetupInstructionsLazyQuery>;
export type EnterpriseDomainSetupInstructionsQueryResult = Apollo.QueryResult<GqlEnterpriseDomainSetupInstructionsQuery, GqlEnterpriseDomainSetupInstructionsQueryVariables>;
export const EnterpriseDomainsDocument = gql`
    query EnterpriseDomains($enterpriseId: ID!) {
  enterpriseDomains(enterpriseId: $enterpriseId) {
    id
    hostname
    domainType
    status
    sslStatus
  }
}
    `;

/**
 * __useEnterpriseDomainsQuery__
 *
 * To run a query within a React component, call `useEnterpriseDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseDomainsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseDomainsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseDomainsQuery, GqlEnterpriseDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseDomainsQuery, GqlEnterpriseDomainsQueryVariables>(EnterpriseDomainsDocument, options);
      }
export function useEnterpriseDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseDomainsQuery, GqlEnterpriseDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseDomainsQuery, GqlEnterpriseDomainsQueryVariables>(EnterpriseDomainsDocument, options);
        }
export type EnterpriseDomainsQueryHookResult = ReturnType<typeof useEnterpriseDomainsQuery>;
export type EnterpriseDomainsLazyQueryHookResult = ReturnType<typeof useEnterpriseDomainsLazyQuery>;
export type EnterpriseDomainsQueryResult = Apollo.QueryResult<GqlEnterpriseDomainsQuery, GqlEnterpriseDomainsQueryVariables>;
export const MintEnterpriseDomainEntriTokenDocument = gql`
    mutation MintEnterpriseDomainEntriToken($enterpriseId: ID!, $id: ID!) {
  mintEnterpriseDomainEntriToken(enterpriseId: $enterpriseId, id: $id) {
    token
    applicationId
    dnsRecords {
      type
      host
      value
      ttl
    }
  }
}
    `;
export type GqlMintEnterpriseDomainEntriTokenMutationFn = Apollo.MutationFunction<GqlMintEnterpriseDomainEntriTokenMutation, GqlMintEnterpriseDomainEntriTokenMutationVariables>;

/**
 * __useMintEnterpriseDomainEntriTokenMutation__
 *
 * To run a mutation, you first call `useMintEnterpriseDomainEntriTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMintEnterpriseDomainEntriTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mintEnterpriseDomainEntriTokenMutation, { data, loading, error }] = useMintEnterpriseDomainEntriTokenMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMintEnterpriseDomainEntriTokenMutation(baseOptions?: Apollo.MutationHookOptions<GqlMintEnterpriseDomainEntriTokenMutation, GqlMintEnterpriseDomainEntriTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMintEnterpriseDomainEntriTokenMutation, GqlMintEnterpriseDomainEntriTokenMutationVariables>(MintEnterpriseDomainEntriTokenDocument, options);
      }
export type MintEnterpriseDomainEntriTokenMutationHookResult = ReturnType<typeof useMintEnterpriseDomainEntriTokenMutation>;
export type MintEnterpriseDomainEntriTokenMutationResult = Apollo.MutationResult<GqlMintEnterpriseDomainEntriTokenMutation>;
export type MintEnterpriseDomainEntriTokenMutationOptions = Apollo.BaseMutationOptions<GqlMintEnterpriseDomainEntriTokenMutation, GqlMintEnterpriseDomainEntriTokenMutationVariables>;
export const VerifyEnterpriseDomainDocument = gql`
    mutation VerifyEnterpriseDomain($enterpriseId: ID!, $id: ID!) {
  verifyEnterpriseDomain(enterpriseId: $enterpriseId, id: $id) {
    id
    hostname
    domainType
    status
    sslStatus
  }
}
    `;
export type GqlVerifyEnterpriseDomainMutationFn = Apollo.MutationFunction<GqlVerifyEnterpriseDomainMutation, GqlVerifyEnterpriseDomainMutationVariables>;

/**
 * __useVerifyEnterpriseDomainMutation__
 *
 * To run a mutation, you first call `useVerifyEnterpriseDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEnterpriseDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEnterpriseDomainMutation, { data, loading, error }] = useVerifyEnterpriseDomainMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifyEnterpriseDomainMutation(baseOptions?: Apollo.MutationHookOptions<GqlVerifyEnterpriseDomainMutation, GqlVerifyEnterpriseDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlVerifyEnterpriseDomainMutation, GqlVerifyEnterpriseDomainMutationVariables>(VerifyEnterpriseDomainDocument, options);
      }
export type VerifyEnterpriseDomainMutationHookResult = ReturnType<typeof useVerifyEnterpriseDomainMutation>;
export type VerifyEnterpriseDomainMutationResult = Apollo.MutationResult<GqlVerifyEnterpriseDomainMutation>;
export type VerifyEnterpriseDomainMutationOptions = Apollo.BaseMutationOptions<GqlVerifyEnterpriseDomainMutation, GqlVerifyEnterpriseDomainMutationVariables>;
export const UpdateEnterpriseVoiceAiEnablementDocument = gql`
    mutation UpdateEnterpriseVoiceAiEnablement($enterpriseId: ID!, $voiceAiEnabled: Boolean!) {
  updateEnterpriseVoiceAiEnablement(
    enterpriseId: $enterpriseId
    voiceAiEnabled: $voiceAiEnabled
  ) {
    id
    voiceAiEnabled
  }
}
    `;
export type GqlUpdateEnterpriseVoiceAiEnablementMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseVoiceAiEnablementMutation, GqlUpdateEnterpriseVoiceAiEnablementMutationVariables>;

/**
 * __useUpdateEnterpriseVoiceAiEnablementMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseVoiceAiEnablementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseVoiceAiEnablementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseVoiceAiEnablementMutation, { data, loading, error }] = useUpdateEnterpriseVoiceAiEnablementMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      voiceAiEnabled: // value for 'voiceAiEnabled'
 *   },
 * });
 */
export function useUpdateEnterpriseVoiceAiEnablementMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseVoiceAiEnablementMutation, GqlUpdateEnterpriseVoiceAiEnablementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseVoiceAiEnablementMutation, GqlUpdateEnterpriseVoiceAiEnablementMutationVariables>(UpdateEnterpriseVoiceAiEnablementDocument, options);
      }
export type UpdateEnterpriseVoiceAiEnablementMutationHookResult = ReturnType<typeof useUpdateEnterpriseVoiceAiEnablementMutation>;
export type UpdateEnterpriseVoiceAiEnablementMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseVoiceAiEnablementMutation>;
export type UpdateEnterpriseVoiceAiEnablementMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseVoiceAiEnablementMutation, GqlUpdateEnterpriseVoiceAiEnablementMutationVariables>;
export const EnterpriseCustomDomainForEnrollmentDocument = gql`
    query EnterpriseCustomDomainForEnrollment($chainId: String!) {
  filteredDispensaries(filter: {chain: $chainId}) {
    id
    embeddedMenuUrl
    customDomainSettings {
      domain
    }
  }
}
    `;

/**
 * __useEnterpriseCustomDomainForEnrollmentQuery__
 *
 * To run a query within a React component, call `useEnterpriseCustomDomainForEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseCustomDomainForEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseCustomDomainForEnrollmentQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useEnterpriseCustomDomainForEnrollmentQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseCustomDomainForEnrollmentQuery, GqlEnterpriseCustomDomainForEnrollmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseCustomDomainForEnrollmentQuery, GqlEnterpriseCustomDomainForEnrollmentQueryVariables>(EnterpriseCustomDomainForEnrollmentDocument, options);
      }
export function useEnterpriseCustomDomainForEnrollmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseCustomDomainForEnrollmentQuery, GqlEnterpriseCustomDomainForEnrollmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseCustomDomainForEnrollmentQuery, GqlEnterpriseCustomDomainForEnrollmentQueryVariables>(EnterpriseCustomDomainForEnrollmentDocument, options);
        }
export type EnterpriseCustomDomainForEnrollmentQueryHookResult = ReturnType<typeof useEnterpriseCustomDomainForEnrollmentQuery>;
export type EnterpriseCustomDomainForEnrollmentLazyQueryHookResult = ReturnType<typeof useEnterpriseCustomDomainForEnrollmentLazyQuery>;
export type EnterpriseCustomDomainForEnrollmentQueryResult = Apollo.QueryResult<GqlEnterpriseCustomDomainForEnrollmentQuery, GqlEnterpriseCustomDomainForEnrollmentQueryVariables>;
export const ChainUserPermissionsReportDocument = gql`
    query ChainUserPermissionsReport($chainId: String!) {
  chainUserPermissionsReport(chainId: $chainId) {
    _id
    email
    fullName
    phone
    roleAtDispensary
    homeLocationName
    hasAllLocations
    locationNames
    locationCount
    unknownLocationCount
    permissions {
      allLocations
      analytics
      billing
      customers
      driver
      enterpriseAdmin
      enterpriseSpecials
      menu
      messaging
      orders
      promote
      settings
      users
    }
  }
}
    `;

/**
 * __useChainUserPermissionsReportQuery__
 *
 * To run a query within a React component, call `useChainUserPermissionsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useChainUserPermissionsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChainUserPermissionsReportQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useChainUserPermissionsReportQuery(baseOptions: Apollo.QueryHookOptions<GqlChainUserPermissionsReportQuery, GqlChainUserPermissionsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlChainUserPermissionsReportQuery, GqlChainUserPermissionsReportQueryVariables>(ChainUserPermissionsReportDocument, options);
      }
export function useChainUserPermissionsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlChainUserPermissionsReportQuery, GqlChainUserPermissionsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlChainUserPermissionsReportQuery, GqlChainUserPermissionsReportQueryVariables>(ChainUserPermissionsReportDocument, options);
        }
export type ChainUserPermissionsReportQueryHookResult = ReturnType<typeof useChainUserPermissionsReportQuery>;
export type ChainUserPermissionsReportLazyQueryHookResult = ReturnType<typeof useChainUserPermissionsReportLazyQuery>;
export type ChainUserPermissionsReportQueryResult = Apollo.QueryResult<GqlChainUserPermissionsReportQuery, GqlChainUserPermissionsReportQueryVariables>;
export const ExportChainUserPermissionsDocument = gql`
    query ExportChainUserPermissions($chainId: String!) {
  exportChainUserPermissions(chainId: $chainId) {
    csv
  }
}
    `;

/**
 * __useExportChainUserPermissionsQuery__
 *
 * To run a query within a React component, call `useExportChainUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportChainUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportChainUserPermissionsQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useExportChainUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GqlExportChainUserPermissionsQuery, GqlExportChainUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlExportChainUserPermissionsQuery, GqlExportChainUserPermissionsQueryVariables>(ExportChainUserPermissionsDocument, options);
      }
export function useExportChainUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlExportChainUserPermissionsQuery, GqlExportChainUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlExportChainUserPermissionsQuery, GqlExportChainUserPermissionsQueryVariables>(ExportChainUserPermissionsDocument, options);
        }
export type ExportChainUserPermissionsQueryHookResult = ReturnType<typeof useExportChainUserPermissionsQuery>;
export type ExportChainUserPermissionsLazyQueryHookResult = ReturnType<typeof useExportChainUserPermissionsLazyQuery>;
export type ExportChainUserPermissionsQueryResult = Apollo.QueryResult<GqlExportChainUserPermissionsQuery, GqlExportChainUserPermissionsQueryVariables>;
export const EnterpriseDispensaryLocationKeywordsDocument = gql`
    query EnterpriseDispensaryLocationKeywords($chainId: String!) {
  enterpriseDispensaryLocationKeywords(chainId: $chainId) {
    cName
    name
    address
  }
}
    `;

/**
 * __useEnterpriseDispensaryLocationKeywordsQuery__
 *
 * To run a query within a React component, call `useEnterpriseDispensaryLocationKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseDispensaryLocationKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseDispensaryLocationKeywordsQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useEnterpriseDispensaryLocationKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseDispensaryLocationKeywordsQuery, GqlEnterpriseDispensaryLocationKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseDispensaryLocationKeywordsQuery, GqlEnterpriseDispensaryLocationKeywordsQueryVariables>(EnterpriseDispensaryLocationKeywordsDocument, options);
      }
export function useEnterpriseDispensaryLocationKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseDispensaryLocationKeywordsQuery, GqlEnterpriseDispensaryLocationKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseDispensaryLocationKeywordsQuery, GqlEnterpriseDispensaryLocationKeywordsQueryVariables>(EnterpriseDispensaryLocationKeywordsDocument, options);
        }
export type EnterpriseDispensaryLocationKeywordsQueryHookResult = ReturnType<typeof useEnterpriseDispensaryLocationKeywordsQuery>;
export type EnterpriseDispensaryLocationKeywordsLazyQueryHookResult = ReturnType<typeof useEnterpriseDispensaryLocationKeywordsLazyQuery>;
export type EnterpriseDispensaryLocationKeywordsQueryResult = Apollo.QueryResult<GqlEnterpriseDispensaryLocationKeywordsQuery, GqlEnterpriseDispensaryLocationKeywordsQueryVariables>;
export const BulkCreateEnterpriseUsersDocument = gql`
    mutation BulkCreateEnterpriseUsers($chainId: String!, $csv: String!) {
  bulkCreateEnterpriseUsers(chainId: $chainId, csv: $csv) {
    success
    createdCount
    failedRows {
      row
      email
      reason
    }
  }
}
    `;
export type GqlBulkCreateEnterpriseUsersMutationFn = Apollo.MutationFunction<GqlBulkCreateEnterpriseUsersMutation, GqlBulkCreateEnterpriseUsersMutationVariables>;

/**
 * __useBulkCreateEnterpriseUsersMutation__
 *
 * To run a mutation, you first call `useBulkCreateEnterpriseUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateEnterpriseUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateEnterpriseUsersMutation, { data, loading, error }] = useBulkCreateEnterpriseUsersMutation({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useBulkCreateEnterpriseUsersMutation(baseOptions?: Apollo.MutationHookOptions<GqlBulkCreateEnterpriseUsersMutation, GqlBulkCreateEnterpriseUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlBulkCreateEnterpriseUsersMutation, GqlBulkCreateEnterpriseUsersMutationVariables>(BulkCreateEnterpriseUsersDocument, options);
      }
export type BulkCreateEnterpriseUsersMutationHookResult = ReturnType<typeof useBulkCreateEnterpriseUsersMutation>;
export type BulkCreateEnterpriseUsersMutationResult = Apollo.MutationResult<GqlBulkCreateEnterpriseUsersMutation>;
export type BulkCreateEnterpriseUsersMutationOptions = Apollo.BaseMutationOptions<GqlBulkCreateEnterpriseUsersMutation, GqlBulkCreateEnterpriseUsersMutationVariables>;
export const GetVoiceAgentsDocument = gql`
    query GetVoiceAgents($enterpriseId: ID!) {
  voiceAgents(enterpriseId: $enterpriseId) {
    id
    name
    phoneNumber
    phoneNumberStatus
    fallbackPhoneNumber
    externalId
    locationGroupId
    enterprisePrompt
    superAdminPrompt
    spanishEnabled
    phoneOrderingEnabled
    locationTransferNumbers {
      retailerId
      transferPhoneNumber
    }
    updatedAt
  }
}
    `;

/**
 * __useGetVoiceAgentsQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetVoiceAgentsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetVoiceAgentsQuery, GqlGetVoiceAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetVoiceAgentsQuery, GqlGetVoiceAgentsQueryVariables>(GetVoiceAgentsDocument, options);
      }
export function useGetVoiceAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetVoiceAgentsQuery, GqlGetVoiceAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetVoiceAgentsQuery, GqlGetVoiceAgentsQueryVariables>(GetVoiceAgentsDocument, options);
        }
export type GetVoiceAgentsQueryHookResult = ReturnType<typeof useGetVoiceAgentsQuery>;
export type GetVoiceAgentsLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentsLazyQuery>;
export type GetVoiceAgentsQueryResult = Apollo.QueryResult<GqlGetVoiceAgentsQuery, GqlGetVoiceAgentsQueryVariables>;
export const GetVoiceAgentDocument = gql`
    query GetVoiceAgent($enterpriseId: ID!, $id: ID!) {
  voiceAgent(enterpriseId: $enterpriseId, id: $id) {
    id
    name
    phoneNumber
    phoneNumberStatus
    fallbackPhoneNumber
    externalId
    locationGroupId
    enterprisePrompt
    superAdminPrompt
    spanishEnabled
    phoneOrderingEnabled
    locationTransferNumbers {
      retailerId
      transferPhoneNumber
    }
    updatedAt
  }
}
    `;

/**
 * __useGetVoiceAgentQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVoiceAgentQuery(baseOptions: Apollo.QueryHookOptions<GqlGetVoiceAgentQuery, GqlGetVoiceAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetVoiceAgentQuery, GqlGetVoiceAgentQueryVariables>(GetVoiceAgentDocument, options);
      }
export function useGetVoiceAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetVoiceAgentQuery, GqlGetVoiceAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetVoiceAgentQuery, GqlGetVoiceAgentQueryVariables>(GetVoiceAgentDocument, options);
        }
export type GetVoiceAgentQueryHookResult = ReturnType<typeof useGetVoiceAgentQuery>;
export type GetVoiceAgentLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentLazyQuery>;
export type GetVoiceAgentQueryResult = Apollo.QueryResult<GqlGetVoiceAgentQuery, GqlGetVoiceAgentQueryVariables>;
export const CreateVoiceAgentDocument = gql`
    mutation CreateVoiceAgent($enterpriseId: ID!, $name: String!, $locationGroupId: ID!, $fallbackPhoneNumber: String, $enterprisePrompt: String, $superAdminPrompt: String, $spanishEnabled: Boolean, $phoneOrderingEnabled: Boolean) {
  createVoiceAgent(
    enterpriseId: $enterpriseId
    name: $name
    locationGroupId: $locationGroupId
    fallbackPhoneNumber: $fallbackPhoneNumber
    enterprisePrompt: $enterprisePrompt
    superAdminPrompt: $superAdminPrompt
    spanishEnabled: $spanishEnabled
    phoneOrderingEnabled: $phoneOrderingEnabled
  ) {
    id
    name
    phoneNumber
    fallbackPhoneNumber
    locationGroupId
    enterprisePrompt
    superAdminPrompt
    spanishEnabled
    phoneOrderingEnabled
  }
}
    `;
export type GqlCreateVoiceAgentMutationFn = Apollo.MutationFunction<GqlCreateVoiceAgentMutation, GqlCreateVoiceAgentMutationVariables>;

/**
 * __useCreateVoiceAgentMutation__
 *
 * To run a mutation, you first call `useCreateVoiceAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoiceAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoiceAgentMutation, { data, loading, error }] = useCreateVoiceAgentMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      name: // value for 'name'
 *      locationGroupId: // value for 'locationGroupId'
 *      fallbackPhoneNumber: // value for 'fallbackPhoneNumber'
 *      enterprisePrompt: // value for 'enterprisePrompt'
 *      superAdminPrompt: // value for 'superAdminPrompt'
 *      spanishEnabled: // value for 'spanishEnabled'
 *      phoneOrderingEnabled: // value for 'phoneOrderingEnabled'
 *   },
 * });
 */
export function useCreateVoiceAgentMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateVoiceAgentMutation, GqlCreateVoiceAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateVoiceAgentMutation, GqlCreateVoiceAgentMutationVariables>(CreateVoiceAgentDocument, options);
      }
export type CreateVoiceAgentMutationHookResult = ReturnType<typeof useCreateVoiceAgentMutation>;
export type CreateVoiceAgentMutationResult = Apollo.MutationResult<GqlCreateVoiceAgentMutation>;
export type CreateVoiceAgentMutationOptions = Apollo.BaseMutationOptions<GqlCreateVoiceAgentMutation, GqlCreateVoiceAgentMutationVariables>;
export const UpdateVoiceAgentDocument = gql`
    mutation UpdateVoiceAgent($enterpriseId: ID!, $id: ID!, $name: String, $locationGroupId: ID, $fallbackPhoneNumber: String, $enterprisePrompt: String, $superAdminPrompt: String, $spanishEnabled: Boolean, $phoneOrderingEnabled: Boolean, $locationTransferNumbers: [LocationTransferNumberInput!]) {
  updateVoiceAgent(
    enterpriseId: $enterpriseId
    id: $id
    name: $name
    locationGroupId: $locationGroupId
    fallbackPhoneNumber: $fallbackPhoneNumber
    enterprisePrompt: $enterprisePrompt
    superAdminPrompt: $superAdminPrompt
    spanishEnabled: $spanishEnabled
    phoneOrderingEnabled: $phoneOrderingEnabled
    locationTransferNumbers: $locationTransferNumbers
  ) {
    id
    name
    phoneNumber
    phoneNumberStatus
    fallbackPhoneNumber
    locationGroupId
    enterprisePrompt
    superAdminPrompt
    spanishEnabled
    phoneOrderingEnabled
    locationTransferNumbers {
      retailerId
      transferPhoneNumber
    }
    updatedAt
  }
}
    `;
export type GqlUpdateVoiceAgentMutationFn = Apollo.MutationFunction<GqlUpdateVoiceAgentMutation, GqlUpdateVoiceAgentMutationVariables>;

/**
 * __useUpdateVoiceAgentMutation__
 *
 * To run a mutation, you first call `useUpdateVoiceAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoiceAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoiceAgentMutation, { data, loading, error }] = useUpdateVoiceAgentMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      locationGroupId: // value for 'locationGroupId'
 *      fallbackPhoneNumber: // value for 'fallbackPhoneNumber'
 *      enterprisePrompt: // value for 'enterprisePrompt'
 *      superAdminPrompt: // value for 'superAdminPrompt'
 *      spanishEnabled: // value for 'spanishEnabled'
 *      phoneOrderingEnabled: // value for 'phoneOrderingEnabled'
 *      locationTransferNumbers: // value for 'locationTransferNumbers'
 *   },
 * });
 */
export function useUpdateVoiceAgentMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateVoiceAgentMutation, GqlUpdateVoiceAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateVoiceAgentMutation, GqlUpdateVoiceAgentMutationVariables>(UpdateVoiceAgentDocument, options);
      }
export type UpdateVoiceAgentMutationHookResult = ReturnType<typeof useUpdateVoiceAgentMutation>;
export type UpdateVoiceAgentMutationResult = Apollo.MutationResult<GqlUpdateVoiceAgentMutation>;
export type UpdateVoiceAgentMutationOptions = Apollo.BaseMutationOptions<GqlUpdateVoiceAgentMutation, GqlUpdateVoiceAgentMutationVariables>;
export const DeleteVoiceAgentDocument = gql`
    mutation DeleteVoiceAgent($enterpriseId: ID!, $id: ID!) {
  deleteVoiceAgent(enterpriseId: $enterpriseId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteVoiceAgentMutationFn = Apollo.MutationFunction<GqlDeleteVoiceAgentMutation, GqlDeleteVoiceAgentMutationVariables>;

/**
 * __useDeleteVoiceAgentMutation__
 *
 * To run a mutation, you first call `useDeleteVoiceAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoiceAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoiceAgentMutation, { data, loading, error }] = useDeleteVoiceAgentMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVoiceAgentMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteVoiceAgentMutation, GqlDeleteVoiceAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteVoiceAgentMutation, GqlDeleteVoiceAgentMutationVariables>(DeleteVoiceAgentDocument, options);
      }
export type DeleteVoiceAgentMutationHookResult = ReturnType<typeof useDeleteVoiceAgentMutation>;
export type DeleteVoiceAgentMutationResult = Apollo.MutationResult<GqlDeleteVoiceAgentMutation>;
export type DeleteVoiceAgentMutationOptions = Apollo.BaseMutationOptions<GqlDeleteVoiceAgentMutation, GqlDeleteVoiceAgentMutationVariables>;
export const ProvisionVoiceAgentPhoneNumberDocument = gql`
    mutation ProvisionVoiceAgentPhoneNumber($enterpriseId: ID!, $id: ID!, $areaCode: String!, $fallbackPhoneNumber: String) {
  provisionVoiceAgentPhoneNumber(
    enterpriseId: $enterpriseId
    id: $id
    areaCode: $areaCode
    fallbackPhoneNumber: $fallbackPhoneNumber
  ) {
    id
    phoneNumber
    phoneNumberStatus
    fallbackPhoneNumber
  }
}
    `;
export type GqlProvisionVoiceAgentPhoneNumberMutationFn = Apollo.MutationFunction<GqlProvisionVoiceAgentPhoneNumberMutation, GqlProvisionVoiceAgentPhoneNumberMutationVariables>;

/**
 * __useProvisionVoiceAgentPhoneNumberMutation__
 *
 * To run a mutation, you first call `useProvisionVoiceAgentPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionVoiceAgentPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionVoiceAgentPhoneNumberMutation, { data, loading, error }] = useProvisionVoiceAgentPhoneNumberMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *      areaCode: // value for 'areaCode'
 *      fallbackPhoneNumber: // value for 'fallbackPhoneNumber'
 *   },
 * });
 */
export function useProvisionVoiceAgentPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<GqlProvisionVoiceAgentPhoneNumberMutation, GqlProvisionVoiceAgentPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlProvisionVoiceAgentPhoneNumberMutation, GqlProvisionVoiceAgentPhoneNumberMutationVariables>(ProvisionVoiceAgentPhoneNumberDocument, options);
      }
export type ProvisionVoiceAgentPhoneNumberMutationHookResult = ReturnType<typeof useProvisionVoiceAgentPhoneNumberMutation>;
export type ProvisionVoiceAgentPhoneNumberMutationResult = Apollo.MutationResult<GqlProvisionVoiceAgentPhoneNumberMutation>;
export type ProvisionVoiceAgentPhoneNumberMutationOptions = Apollo.BaseMutationOptions<GqlProvisionVoiceAgentPhoneNumberMutation, GqlProvisionVoiceAgentPhoneNumberMutationVariables>;
export const GetVoiceAgentCallsDocument = gql`
    query GetVoiceAgentCalls($enterpriseId: ID!, $assistantId: ID!, $days: Int!) {
  voiceAgentCalls(
    enterpriseId: $enterpriseId
    assistantId: $assistantId
    days: $days
  ) {
    id
    status
    endedReason
    createdAt
    startedAt
    endedAt
    durationSeconds
    customerPhone
    assistantPhone
    cost
    successEvaluation
  }
}
    `;

/**
 * __useGetVoiceAgentCallsQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentCallsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      assistantId: // value for 'assistantId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetVoiceAgentCallsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetVoiceAgentCallsQuery, GqlGetVoiceAgentCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetVoiceAgentCallsQuery, GqlGetVoiceAgentCallsQueryVariables>(GetVoiceAgentCallsDocument, options);
      }
export function useGetVoiceAgentCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetVoiceAgentCallsQuery, GqlGetVoiceAgentCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetVoiceAgentCallsQuery, GqlGetVoiceAgentCallsQueryVariables>(GetVoiceAgentCallsDocument, options);
        }
export type GetVoiceAgentCallsQueryHookResult = ReturnType<typeof useGetVoiceAgentCallsQuery>;
export type GetVoiceAgentCallsLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentCallsLazyQuery>;
export type GetVoiceAgentCallsQueryResult = Apollo.QueryResult<GqlGetVoiceAgentCallsQuery, GqlGetVoiceAgentCallsQueryVariables>;
export const GetVoiceAgentCallDocument = gql`
    query GetVoiceAgentCall($enterpriseId: ID!, $assistantId: ID!, $callId: ID!) {
  voiceAgentCall(
    enterpriseId: $enterpriseId
    assistantId: $assistantId
    callId: $callId
  ) {
    id
    status
    endedReason
    createdAt
    startedAt
    endedAt
    durationSeconds
    customerPhone
    assistantPhone
    cost
    successEvaluation
    summary
    structuredData
    recordingUrl
    transcript {
      role
      message
      time
    }
  }
}
    `;

/**
 * __useGetVoiceAgentCallQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentCallQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      assistantId: // value for 'assistantId'
 *      callId: // value for 'callId'
 *   },
 * });
 */
export function useGetVoiceAgentCallQuery(baseOptions: Apollo.QueryHookOptions<GqlGetVoiceAgentCallQuery, GqlGetVoiceAgentCallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetVoiceAgentCallQuery, GqlGetVoiceAgentCallQueryVariables>(GetVoiceAgentCallDocument, options);
      }
export function useGetVoiceAgentCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetVoiceAgentCallQuery, GqlGetVoiceAgentCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetVoiceAgentCallQuery, GqlGetVoiceAgentCallQueryVariables>(GetVoiceAgentCallDocument, options);
        }
export type GetVoiceAgentCallQueryHookResult = ReturnType<typeof useGetVoiceAgentCallQuery>;
export type GetVoiceAgentCallLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentCallLazyQuery>;
export type GetVoiceAgentCallQueryResult = Apollo.QueryResult<GqlGetVoiceAgentCallQuery, GqlGetVoiceAgentCallQueryVariables>;
export const GetVoiceAgentCallAnalyticsDocument = gql`
    query GetVoiceAgentCallAnalytics($enterpriseId: ID!, $assistantId: ID!, $days: Int!) {
  voiceAgentCallAnalytics(
    enterpriseId: $enterpriseId
    assistantId: $assistantId
    days: $days
  ) {
    id
    days
    totalCalls
    totalMinutes
    averageDurationSeconds
    successRate
    dailyCallVolume {
      date
      count
    }
    endReasonDistribution {
      endedReason
      count
    }
  }
}
    `;

/**
 * __useGetVoiceAgentCallAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentCallAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentCallAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentCallAnalyticsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      assistantId: // value for 'assistantId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetVoiceAgentCallAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetVoiceAgentCallAnalyticsQuery, GqlGetVoiceAgentCallAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetVoiceAgentCallAnalyticsQuery, GqlGetVoiceAgentCallAnalyticsQueryVariables>(GetVoiceAgentCallAnalyticsDocument, options);
      }
export function useGetVoiceAgentCallAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetVoiceAgentCallAnalyticsQuery, GqlGetVoiceAgentCallAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetVoiceAgentCallAnalyticsQuery, GqlGetVoiceAgentCallAnalyticsQueryVariables>(GetVoiceAgentCallAnalyticsDocument, options);
        }
export type GetVoiceAgentCallAnalyticsQueryHookResult = ReturnType<typeof useGetVoiceAgentCallAnalyticsQuery>;
export type GetVoiceAgentCallAnalyticsLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentCallAnalyticsLazyQuery>;
export type GetVoiceAgentCallAnalyticsQueryResult = Apollo.QueryResult<GqlGetVoiceAgentCallAnalyticsQuery, GqlGetVoiceAgentCallAnalyticsQueryVariables>;
export const WebStudioChainDispensariesDocument = gql`
    query WebStudioChainDispensaries($chainId: String!) {
  chainDispensaryNamesAndIds(chainId: $chainId) {
    id
    cName
  }
}
    `;

/**
 * __useWebStudioChainDispensariesQuery__
 *
 * To run a query within a React component, call `useWebStudioChainDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebStudioChainDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebStudioChainDispensariesQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useWebStudioChainDispensariesQuery(baseOptions: Apollo.QueryHookOptions<GqlWebStudioChainDispensariesQuery, GqlWebStudioChainDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlWebStudioChainDispensariesQuery, GqlWebStudioChainDispensariesQueryVariables>(WebStudioChainDispensariesDocument, options);
      }
export function useWebStudioChainDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWebStudioChainDispensariesQuery, GqlWebStudioChainDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlWebStudioChainDispensariesQuery, GqlWebStudioChainDispensariesQueryVariables>(WebStudioChainDispensariesDocument, options);
        }
export type WebStudioChainDispensariesQueryHookResult = ReturnType<typeof useWebStudioChainDispensariesQuery>;
export type WebStudioChainDispensariesLazyQueryHookResult = ReturnType<typeof useWebStudioChainDispensariesLazyQuery>;
export type WebStudioChainDispensariesQueryResult = Apollo.QueryResult<GqlWebStudioChainDispensariesQuery, GqlWebStudioChainDispensariesQueryVariables>;
export const WebStudioWebsiteThemeDocument = gql`
    query WebStudioWebsiteTheme($dispensaryId: String!) {
  filteredDispensaries(filter: {cNameOrID: $dispensaryId}) {
    webCustomizationSettingsV2 {
      colors {
        navBar
        buttonsLinks
        productCardButton
        staffPickTag
        discountTag
        strainTypes {
          indica
          sativa
          hybrid
        }
      }
      fonts {
        heading
        body
      }
    }
  }
}
    `;

/**
 * __useWebStudioWebsiteThemeQuery__
 *
 * To run a query within a React component, call `useWebStudioWebsiteThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebStudioWebsiteThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebStudioWebsiteThemeQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useWebStudioWebsiteThemeQuery(baseOptions: Apollo.QueryHookOptions<GqlWebStudioWebsiteThemeQuery, GqlWebStudioWebsiteThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlWebStudioWebsiteThemeQuery, GqlWebStudioWebsiteThemeQueryVariables>(WebStudioWebsiteThemeDocument, options);
      }
export function useWebStudioWebsiteThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlWebStudioWebsiteThemeQuery, GqlWebStudioWebsiteThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlWebStudioWebsiteThemeQuery, GqlWebStudioWebsiteThemeQueryVariables>(WebStudioWebsiteThemeDocument, options);
        }
export type WebStudioWebsiteThemeQueryHookResult = ReturnType<typeof useWebStudioWebsiteThemeQuery>;
export type WebStudioWebsiteThemeLazyQueryHookResult = ReturnType<typeof useWebStudioWebsiteThemeLazyQuery>;
export type WebStudioWebsiteThemeQueryResult = Apollo.QueryResult<GqlWebStudioWebsiteThemeQuery, GqlWebStudioWebsiteThemeQueryVariables>;
export const GetCmsWebsiteDocument = gql`
    query GetCmsWebsite($enterpriseId: String!) {
  cmsWebsites(enterpriseId: $enterpriseId) {
    websites {
      id
      name
      cName
    }
  }
}
    `;

/**
 * __useGetCmsWebsiteQuery__
 *
 * To run a query within a React component, call `useGetCmsWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsWebsiteQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useGetCmsWebsiteQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCmsWebsiteQuery, GqlGetCmsWebsiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCmsWebsiteQuery, GqlGetCmsWebsiteQueryVariables>(GetCmsWebsiteDocument, options);
      }
export function useGetCmsWebsiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCmsWebsiteQuery, GqlGetCmsWebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCmsWebsiteQuery, GqlGetCmsWebsiteQueryVariables>(GetCmsWebsiteDocument, options);
        }
export type GetCmsWebsiteQueryHookResult = ReturnType<typeof useGetCmsWebsiteQuery>;
export type GetCmsWebsiteLazyQueryHookResult = ReturnType<typeof useGetCmsWebsiteLazyQuery>;
export type GetCmsWebsiteQueryResult = Apollo.QueryResult<GqlGetCmsWebsiteQuery, GqlGetCmsWebsiteQueryVariables>;
export const GetCmsVariantsDocument = gql`
    query GetCmsVariants($enterpriseId: String!, $modelId: String!, $websiteId: String) {
  cmsVariants(
    enterpriseId: $enterpriseId
    modelId: $modelId
    websiteId: $websiteId
  ) {
    variants {
      variantId
      variantKey
      publishedVersionId
      isDefault
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetCmsVariantsQuery__
 *
 * To run a query within a React component, call `useGetCmsVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsVariantsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      modelId: // value for 'modelId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useGetCmsVariantsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCmsVariantsQuery, GqlGetCmsVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCmsVariantsQuery, GqlGetCmsVariantsQueryVariables>(GetCmsVariantsDocument, options);
      }
export function useGetCmsVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCmsVariantsQuery, GqlGetCmsVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCmsVariantsQuery, GqlGetCmsVariantsQueryVariables>(GetCmsVariantsDocument, options);
        }
export type GetCmsVariantsQueryHookResult = ReturnType<typeof useGetCmsVariantsQuery>;
export type GetCmsVariantsLazyQueryHookResult = ReturnType<typeof useGetCmsVariantsLazyQuery>;
export type GetCmsVariantsQueryResult = Apollo.QueryResult<GqlGetCmsVariantsQuery, GqlGetCmsVariantsQueryVariables>;
export const GetCmsContentForPublishDocument = gql`
    query GetCmsContentForPublish($enterpriseId: String!, $modelId: String!, $variantKey: String!, $websiteId: String) {
  cmsContent(
    enterpriseId: $enterpriseId
    modelId: $modelId
    variantKey: $variantKey
    websiteId: $websiteId
  ) {
    data
  }
}
    `;

/**
 * __useGetCmsContentForPublishQuery__
 *
 * To run a query within a React component, call `useGetCmsContentForPublishQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsContentForPublishQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsContentForPublishQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      modelId: // value for 'modelId'
 *      variantKey: // value for 'variantKey'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useGetCmsContentForPublishQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCmsContentForPublishQuery, GqlGetCmsContentForPublishQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCmsContentForPublishQuery, GqlGetCmsContentForPublishQueryVariables>(GetCmsContentForPublishDocument, options);
      }
export function useGetCmsContentForPublishLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCmsContentForPublishQuery, GqlGetCmsContentForPublishQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCmsContentForPublishQuery, GqlGetCmsContentForPublishQueryVariables>(GetCmsContentForPublishDocument, options);
        }
export type GetCmsContentForPublishQueryHookResult = ReturnType<typeof useGetCmsContentForPublishQuery>;
export type GetCmsContentForPublishLazyQueryHookResult = ReturnType<typeof useGetCmsContentForPublishLazyQuery>;
export type GetCmsContentForPublishQueryResult = Apollo.QueryResult<GqlGetCmsContentForPublishQuery, GqlGetCmsContentForPublishQueryVariables>;
export const PublishCmsVariantDocument = gql`
    mutation PublishCmsVariant($enterpriseId: String!, $modelId: String!, $variantKey: String!, $data: JSONObject!, $websiteId: String!) {
  saveCmsContentVersion(
    enterpriseId: $enterpriseId
    modelId: $modelId
    variantKey: $variantKey
    data: $data
    status: published
    websiteId: $websiteId
  ) {
    status
  }
}
    `;
export type GqlPublishCmsVariantMutationFn = Apollo.MutationFunction<GqlPublishCmsVariantMutation, GqlPublishCmsVariantMutationVariables>;

/**
 * __usePublishCmsVariantMutation__
 *
 * To run a mutation, you first call `usePublishCmsVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCmsVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCmsVariantMutation, { data, loading, error }] = usePublishCmsVariantMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      modelId: // value for 'modelId'
 *      variantKey: // value for 'variantKey'
 *      data: // value for 'data'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePublishCmsVariantMutation(baseOptions?: Apollo.MutationHookOptions<GqlPublishCmsVariantMutation, GqlPublishCmsVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlPublishCmsVariantMutation, GqlPublishCmsVariantMutationVariables>(PublishCmsVariantDocument, options);
      }
export type PublishCmsVariantMutationHookResult = ReturnType<typeof usePublishCmsVariantMutation>;
export type PublishCmsVariantMutationResult = Apollo.MutationResult<GqlPublishCmsVariantMutation>;
export type PublishCmsVariantMutationOptions = Apollo.BaseMutationOptions<GqlPublishCmsVariantMutation, GqlPublishCmsVariantMutationVariables>;
export const GetCmsPagesDocument = gql`
    query GetCmsPages($enterpriseId: String!, $websiteId: String) {
  cmsPages(enterpriseId: $enterpriseId, websiteId: $websiteId) {
    pages {
      variantId
      variantKey
      name
      urlPath
      publishedVersionId
      isDefault
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetCmsPagesQuery__
 *
 * To run a query within a React component, call `useGetCmsPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsPagesQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useGetCmsPagesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCmsPagesQuery, GqlGetCmsPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCmsPagesQuery, GqlGetCmsPagesQueryVariables>(GetCmsPagesDocument, options);
      }
export function useGetCmsPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCmsPagesQuery, GqlGetCmsPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCmsPagesQuery, GqlGetCmsPagesQueryVariables>(GetCmsPagesDocument, options);
        }
export type GetCmsPagesQueryHookResult = ReturnType<typeof useGetCmsPagesQuery>;
export type GetCmsPagesLazyQueryHookResult = ReturnType<typeof useGetCmsPagesLazyQuery>;
export type GetCmsPagesQueryResult = Apollo.QueryResult<GqlGetCmsPagesQuery, GqlGetCmsPagesQueryVariables>;
export const PublishCmsPageDocument = gql`
    mutation PublishCmsPage($enterpriseId: String!, $websiteId: String!, $variantKey: String!, $name: String!, $urlPath: String!, $data: JSONObject!) {
  savePage(
    enterpriseId: $enterpriseId
    websiteId: $websiteId
    variantKey: $variantKey
    name: $name
    urlPath: $urlPath
    data: $data
    status: published
  ) {
    status
  }
}
    `;
export type GqlPublishCmsPageMutationFn = Apollo.MutationFunction<GqlPublishCmsPageMutation, GqlPublishCmsPageMutationVariables>;

/**
 * __usePublishCmsPageMutation__
 *
 * To run a mutation, you first call `usePublishCmsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCmsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCmsPageMutation, { data, loading, error }] = usePublishCmsPageMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      websiteId: // value for 'websiteId'
 *      variantKey: // value for 'variantKey'
 *      name: // value for 'name'
 *      urlPath: // value for 'urlPath'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePublishCmsPageMutation(baseOptions?: Apollo.MutationHookOptions<GqlPublishCmsPageMutation, GqlPublishCmsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlPublishCmsPageMutation, GqlPublishCmsPageMutationVariables>(PublishCmsPageDocument, options);
      }
export type PublishCmsPageMutationHookResult = ReturnType<typeof usePublishCmsPageMutation>;
export type PublishCmsPageMutationResult = Apollo.MutationResult<GqlPublishCmsPageMutation>;
export type PublishCmsPageMutationOptions = Apollo.BaseMutationOptions<GqlPublishCmsPageMutation, GqlPublishCmsPageMutationVariables>;
export const GetEnterpriseByNameDocument = gql`
    query GetEnterpriseByName($uniqueName: ID!) {
  getEnterpriseByName(uniqueName: $uniqueName) {
    id
    uniqueName
  }
}
    `;

/**
 * __useGetEnterpriseByNameQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseByNameQuery({
 *   variables: {
 *      uniqueName: // value for 'uniqueName'
 *   },
 * });
 */
export function useGetEnterpriseByNameQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnterpriseByNameQuery, GqlGetEnterpriseByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnterpriseByNameQuery, GqlGetEnterpriseByNameQueryVariables>(GetEnterpriseByNameDocument, options);
      }
export function useGetEnterpriseByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnterpriseByNameQuery, GqlGetEnterpriseByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnterpriseByNameQuery, GqlGetEnterpriseByNameQueryVariables>(GetEnterpriseByNameDocument, options);
        }
export type GetEnterpriseByNameQueryHookResult = ReturnType<typeof useGetEnterpriseByNameQuery>;
export type GetEnterpriseByNameLazyQueryHookResult = ReturnType<typeof useGetEnterpriseByNameLazyQuery>;
export type GetEnterpriseByNameQueryResult = Apollo.QueryResult<GqlGetEnterpriseByNameQuery, GqlGetEnterpriseByNameQueryVariables>;
export const PrintedMenuBrandingColorsDocument = gql`
    query PrintedMenuBrandingColors($dispensaryId: String!) {
  filteredDispensaries(filter: {cNameOrID: $dispensaryId}) {
    webCustomizationSettingsV2 {
      colors {
        navBar
        buttonsLinks
        staffPickTag
        discountTag
      }
    }
  }
}
    `;

/**
 * __usePrintedMenuBrandingColorsQuery__
 *
 * To run a query within a React component, call `usePrintedMenuBrandingColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintedMenuBrandingColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintedMenuBrandingColorsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function usePrintedMenuBrandingColorsQuery(baseOptions: Apollo.QueryHookOptions<GqlPrintedMenuBrandingColorsQuery, GqlPrintedMenuBrandingColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlPrintedMenuBrandingColorsQuery, GqlPrintedMenuBrandingColorsQueryVariables>(PrintedMenuBrandingColorsDocument, options);
      }
export function usePrintedMenuBrandingColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPrintedMenuBrandingColorsQuery, GqlPrintedMenuBrandingColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlPrintedMenuBrandingColorsQuery, GqlPrintedMenuBrandingColorsQueryVariables>(PrintedMenuBrandingColorsDocument, options);
        }
export type PrintedMenuBrandingColorsQueryHookResult = ReturnType<typeof usePrintedMenuBrandingColorsQuery>;
export type PrintedMenuBrandingColorsLazyQueryHookResult = ReturnType<typeof usePrintedMenuBrandingColorsLazyQuery>;
export type PrintedMenuBrandingColorsQueryResult = Apollo.QueryResult<GqlPrintedMenuBrandingColorsQuery, GqlPrintedMenuBrandingColorsQueryVariables>;
export const AdminPrintedMenuProductsDocument = gql`
    query AdminPrintedMenuProducts($productsFilter: productsFilterInput!, $page: Int, $perPage: Int) {
  filteredProducts(filter: $productsFilter, page: $page, perPage: $perPage) {
    products {
      id
      _id
      DispensaryID
      enterpriseProductId
      Name
      Prices
      Options
      medicalOnly
      rawOptions
      recOnly
      recPrices
      medicalPrices
      Image
      images {
        _id
        origin
        url
        active
      }
      stockImage
      special
      specialData {
        bogoSpecials {
          excludeConditionItemsFromRewards
          bogoConditionLogicOperator
          bogoConditions {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              subcategoryIds
              subcategoryNames
              strainIds
              vendorIds
              weights
              weightOperator
            }
            inventoryTags
            productGroup
            productId
            productIds
            productTags
            quantity
            subcategoryIds
            subcategoryNames
            strainIds
            vendorIds
            weight
            weightOperator
          }
          bogoRewardLogicOperator
          bogoRewards {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            dollarDiscount
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              subcategoryIds
              subcategoryNames
              strainIds
              vendorIds
              weights
              weightOperator
            }
            inventoryTags
            productGroup
            productId
            productIds
            percentDiscount
            productTags
            quantity
            subcategoryIds
            subcategoryNames
            strainIds
            vendorIds
            targetPrice
            weight
          }
          createdBy
          directPOSProductIdMapping
          rawPOSWeightMapping
          endStamp
          excludedProducts {
            conditions {
              _id
              key
              Name
            }
            rewards {
              _id
              key
              Name
            }
          }
          isRecurring
          itemsForAPrice {
            _id
            enabled
            value
          }
          discountBundle {
            _id
            applyTo
            discountType
            enabled
            limit
            value
          }
          menuType
          minorVersion
          paymentRestrictions {
            payByBankSignupIncentive
          }
          recurringEndDate
          redemptionLimit
          specialId
          specialName
          specialType
          totalQuantity {
            enabled
            maxQuantity
            quantity
            quantityOperator
          }
          totalWeight {
            enabled
            weight
            weightOperator
          }
          totalSpend {
            enabled
            maximumSpend
            minimumSpend
            spendOperator
          }
          version
        }
        saleSpecials {
          createdBy
          directPOSProductIdMapping
          rawPOSWeightMapping
          discount
          dollarDiscount
          menuType
          minorVersion
          paymentRestrictions {
            payByBankSignupIncentive
          }
          percentDiscount
          saleDiscounts {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            discountAmount
            discountType
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              subcategoryIds
              subcategoryNames
              strainIds
              vendorIds
              weights
              weightOperator
            }
            inventoryTags
            productGroup
            productIds
            productTags
            subcategoryIds
            subcategoryNames
            strainIds
            vendorIds
            weights
            weightOperator
          }
          specialName
          source
          sourceId
          specialId
          specialRestrictions
          specialType
          stackingMode
          eligibleProductOptions
          targetPrice
          version
        }
        discount
        percentDiscount
      }
      recSpecialPrices
      medicalSpecialPrices
      posSyncedPricingApplied {
        medical
        recreational
      }
      featured {
        current
      }
      brandId
      brand {
        id
        name
        imageUrl
      }
      brandName
      brandLogo
      Status
      type
      subcategory
      strainType
      updatedAt
      createdAt
      CBD
      CBDContent {
        unit
        range
      }
      THC
      THCContent {
        unit
        range
      }
      weight
    }
    queryInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useAdminPrintedMenuProductsQuery__
 *
 * To run a query within a React component, call `useAdminPrintedMenuProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPrintedMenuProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPrintedMenuProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAdminPrintedMenuProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlAdminPrintedMenuProductsQuery, GqlAdminPrintedMenuProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminPrintedMenuProductsQuery, GqlAdminPrintedMenuProductsQueryVariables>(AdminPrintedMenuProductsDocument, options);
      }
export function useAdminPrintedMenuProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminPrintedMenuProductsQuery, GqlAdminPrintedMenuProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminPrintedMenuProductsQuery, GqlAdminPrintedMenuProductsQueryVariables>(AdminPrintedMenuProductsDocument, options);
        }
export type AdminPrintedMenuProductsQueryHookResult = ReturnType<typeof useAdminPrintedMenuProductsQuery>;
export type AdminPrintedMenuProductsLazyQueryHookResult = ReturnType<typeof useAdminPrintedMenuProductsLazyQuery>;
export type AdminPrintedMenuProductsQueryResult = Apollo.QueryResult<GqlAdminPrintedMenuProductsQuery, GqlAdminPrintedMenuProductsQueryVariables>;
export const GetExportDocument = gql`
    query GetExport($id: String!) {
  getExport(id: $id) {
    url
  }
}
    `;

/**
 * __useGetExportQuery__
 *
 * To run a query within a React component, call `useGetExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExportQuery(baseOptions: Apollo.QueryHookOptions<GqlGetExportQuery, GqlGetExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetExportQuery, GqlGetExportQueryVariables>(GetExportDocument, options);
      }
export function useGetExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetExportQuery, GqlGetExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetExportQuery, GqlGetExportQueryVariables>(GetExportDocument, options);
        }
export type GetExportQueryHookResult = ReturnType<typeof useGetExportQuery>;
export type GetExportLazyQueryHookResult = ReturnType<typeof useGetExportLazyQuery>;
export type GetExportQueryResult = Apollo.QueryResult<GqlGetExportQuery, GqlGetExportQueryVariables>;
export const MeAdminDocument = gql`
    query MeAdmin {
  meAdmin {
    _id
    createdAt
    chainDispensaryIds
    enterpriseId
    emails {
      address
    }
    dispensary {
      chain
      customDomainSettings {
        domain
      }
      embeddedMenuUrl
      id
      name
      location {
        city
        state
        country
        zipcode
      }
      phone
      status
      tier
      timezone
    }
    profile {
      audioNotificationsOnNewArrivalsDisabled
      audioNotificationsOnNewOrdersDisabled
      browserNotification
      chainID
      desktopNotification
      dispensaryId
      emailNotifications
      firstName
      fullName
      lastName
      isWeeklyReportEnabled
      permissions {
        allLocations
        billing
        analytics
        customers
        dispensaryIds
        driver
        enterpriseAdmin
        enterpriseSpecials
        manageAds
        managePersonalization
        menu
        menuReview
        messaging
        superMenuReview
        orders
        promote
        settings
        users
        tasks
        techSupportFeatures
      }
      phone
      roleAtDispensary
      streamTokens {
        dispensaryId
        token
      }
      type
      firstViewedTOS
      acceptedTOS
    }
    zendeskWidgetToken
    zendeskSingleSignOnToken
  }
}
    `;

/**
 * __useMeAdminQuery__
 *
 * To run a query within a React component, call `useMeAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeAdminQuery(baseOptions?: Apollo.QueryHookOptions<GqlMeAdminQuery, GqlMeAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMeAdminQuery, GqlMeAdminQueryVariables>(MeAdminDocument, options);
      }
export function useMeAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMeAdminQuery, GqlMeAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMeAdminQuery, GqlMeAdminQueryVariables>(MeAdminDocument, options);
        }
export type MeAdminQueryHookResult = ReturnType<typeof useMeAdminQuery>;
export type MeAdminLazyQueryHookResult = ReturnType<typeof useMeAdminLazyQuery>;
export type MeAdminQueryResult = Apollo.QueryResult<GqlMeAdminQuery, GqlMeAdminQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($input: getOrdersInput!) {
  getOrders(input: $input) {
    orders {
      createdAt
      customerId
      customerEmail
      customerName
      customerPhone
      firstName
      lastName
      delivery
      durationEstimates {
        delivery {
          lowInMinutes
          highInMinutes
        }
        pickup {
          lowInMinutes
          highInMinutes
        }
      }
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
      }
      dispensaryId
      dispensaryName
      dispoTimezone
      deliveryOption
      duration
      effectiveStatus
      orderId
      orderType
      status
      reopened
      totalCost
      isAnonymous
      isKioskOrder
      originKioskId
      kioskName
      isAfterHoursOrder
      voiceCallInfo {
        callId
        assistantId
      }
      _id
      fleetManagementTask {
        id
        adapter
      }
      pos {
        externalID
        failureAcks {
          terminal
          web
        }
        failureReason
        failureType
        humanReadableError
        name
      }
      reservation {
        startTimeISO
        endTimeISO
      }
    }
  }
}
    `;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GqlGetOrdersQuery, GqlGetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetOrdersQuery, GqlGetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetOrdersQuery, GqlGetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetOrdersQuery, GqlGetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GqlGetOrdersQuery, GqlGetOrdersQueryVariables>;
export const RevertBrandMergeDocument = gql`
    mutation RevertBrandMerge($id: String!) {
  revertBrandMerge(id: $id) {
    id
  }
}
    `;
export type GqlRevertBrandMergeMutationFn = Apollo.MutationFunction<GqlRevertBrandMergeMutation, GqlRevertBrandMergeMutationVariables>;

/**
 * __useRevertBrandMergeMutation__
 *
 * To run a mutation, you first call `useRevertBrandMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertBrandMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertBrandMergeMutation, { data, loading, error }] = useRevertBrandMergeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevertBrandMergeMutation(baseOptions?: Apollo.MutationHookOptions<GqlRevertBrandMergeMutation, GqlRevertBrandMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRevertBrandMergeMutation, GqlRevertBrandMergeMutationVariables>(RevertBrandMergeDocument, options);
      }
export type RevertBrandMergeMutationHookResult = ReturnType<typeof useRevertBrandMergeMutation>;
export type RevertBrandMergeMutationResult = Apollo.MutationResult<GqlRevertBrandMergeMutation>;
export type RevertBrandMergeMutationOptions = Apollo.BaseMutationOptions<GqlRevertBrandMergeMutation, GqlRevertBrandMergeMutationVariables>;
export const BrandMergeHistoryIndexDocument = gql`
    query BrandMergeHistoryIndex($filters: brandMergeHistoriesFilters, $page: brandMergeHistoriesPagination, $sort: brandMergeHistoriesSort) {
  getBrandMergeHistories(filters: $filters, page: $page, sort: $sort) {
    brandMergeHistories {
      id
      sourceBrand {
        id
        name
        dispensary {
          id
          name
        }
      }
      destinationBrand {
        id
        name
        dispensary {
          id
          name
        }
      }
      createdAt
      revertedAt
      user {
        email
      }
    }
    queryInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useBrandMergeHistoryIndexQuery__
 *
 * To run a query within a React component, call `useBrandMergeHistoryIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandMergeHistoryIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandMergeHistoryIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBrandMergeHistoryIndexQuery(baseOptions?: Apollo.QueryHookOptions<GqlBrandMergeHistoryIndexQuery, GqlBrandMergeHistoryIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlBrandMergeHistoryIndexQuery, GqlBrandMergeHistoryIndexQueryVariables>(BrandMergeHistoryIndexDocument, options);
      }
export function useBrandMergeHistoryIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBrandMergeHistoryIndexQuery, GqlBrandMergeHistoryIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlBrandMergeHistoryIndexQuery, GqlBrandMergeHistoryIndexQueryVariables>(BrandMergeHistoryIndexDocument, options);
        }
export type BrandMergeHistoryIndexQueryHookResult = ReturnType<typeof useBrandMergeHistoryIndexQuery>;
export type BrandMergeHistoryIndexLazyQueryHookResult = ReturnType<typeof useBrandMergeHistoryIndexLazyQuery>;
export type BrandMergeHistoryIndexQueryResult = Apollo.QueryResult<GqlBrandMergeHistoryIndexQuery, GqlBrandMergeHistoryIndexQueryVariables>;
export const MergeBrandsDocument = gql`
    mutation MergeBrands($collisionIds: [String!]!) {
  mergeBrands(ids: $collisionIds) {
    success
  }
}
    `;
export type GqlMergeBrandsMutationFn = Apollo.MutationFunction<GqlMergeBrandsMutation, GqlMergeBrandsMutationVariables>;

/**
 * __useMergeBrandsMutation__
 *
 * To run a mutation, you first call `useMergeBrandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeBrandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeBrandsMutation, { data, loading, error }] = useMergeBrandsMutation({
 *   variables: {
 *      collisionIds: // value for 'collisionIds'
 *   },
 * });
 */
export function useMergeBrandsMutation(baseOptions?: Apollo.MutationHookOptions<GqlMergeBrandsMutation, GqlMergeBrandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMergeBrandsMutation, GqlMergeBrandsMutationVariables>(MergeBrandsDocument, options);
      }
export type MergeBrandsMutationHookResult = ReturnType<typeof useMergeBrandsMutation>;
export type MergeBrandsMutationResult = Apollo.MutationResult<GqlMergeBrandsMutation>;
export type MergeBrandsMutationOptions = Apollo.BaseMutationOptions<GqlMergeBrandsMutation, GqlMergeBrandsMutationVariables>;
export const GetActiveDispensariesDocument = gql`
    query GetActiveDispensaries($params: activeDispensariesInput) {
  activeDispensaries(params: $params) {
    dispensaries {
      _id
      profile {
        name
      }
    }
  }
}
    `;

/**
 * __useGetActiveDispensariesQuery__
 *
 * To run a query within a React component, call `useGetActiveDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDispensariesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetActiveDispensariesQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetActiveDispensariesQuery, GqlGetActiveDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetActiveDispensariesQuery, GqlGetActiveDispensariesQueryVariables>(GetActiveDispensariesDocument, options);
      }
export function useGetActiveDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetActiveDispensariesQuery, GqlGetActiveDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetActiveDispensariesQuery, GqlGetActiveDispensariesQueryVariables>(GetActiveDispensariesDocument, options);
        }
export type GetActiveDispensariesQueryHookResult = ReturnType<typeof useGetActiveDispensariesQuery>;
export type GetActiveDispensariesLazyQueryHookResult = ReturnType<typeof useGetActiveDispensariesLazyQuery>;
export type GetActiveDispensariesQueryResult = Apollo.QueryResult<GqlGetActiveDispensariesQuery, GqlGetActiveDispensariesQueryVariables>;
export const GetBrandCollisionsDocument = gql`
    query GetBrandCollisions($filters: brandCollisionFilters, $sort: brandCollisionsSort, $pagination: pagination) {
  getBrandCollisions(filters: $filters, sort: $sort, pagination: $pagination) {
    brandCollisions {
      createdAt
      id
      isAllowed
      firstBrand {
        dispensary {
          id
          name
        }
        id
        name
        productsCount
      }
      secondBrand {
        dispensary {
          id
          name
        }
        id
        name
        productsCount
      }
    }
    queryInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useGetBrandCollisionsQuery__
 *
 * To run a query within a React component, call `useGetBrandCollisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCollisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCollisionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBrandCollisionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetBrandCollisionsQuery, GqlGetBrandCollisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBrandCollisionsQuery, GqlGetBrandCollisionsQueryVariables>(GetBrandCollisionsDocument, options);
      }
export function useGetBrandCollisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBrandCollisionsQuery, GqlGetBrandCollisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBrandCollisionsQuery, GqlGetBrandCollisionsQueryVariables>(GetBrandCollisionsDocument, options);
        }
export type GetBrandCollisionsQueryHookResult = ReturnType<typeof useGetBrandCollisionsQuery>;
export type GetBrandCollisionsLazyQueryHookResult = ReturnType<typeof useGetBrandCollisionsLazyQuery>;
export type GetBrandCollisionsQueryResult = Apollo.QueryResult<GqlGetBrandCollisionsQuery, GqlGetBrandCollisionsQueryVariables>;
export const GetFilteredDispensariesDocument = gql`
    query GetFilteredDispensaries($filter: dispensariesFilterInput) {
  filteredDispensaries(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useGetFilteredDispensariesQuery__
 *
 * To run a query within a React component, call `useGetFilteredDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredDispensariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFilteredDispensariesQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetFilteredDispensariesQuery, GqlGetFilteredDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetFilteredDispensariesQuery, GqlGetFilteredDispensariesQueryVariables>(GetFilteredDispensariesDocument, options);
      }
export function useGetFilteredDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetFilteredDispensariesQuery, GqlGetFilteredDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetFilteredDispensariesQuery, GqlGetFilteredDispensariesQueryVariables>(GetFilteredDispensariesDocument, options);
        }
export type GetFilteredDispensariesQueryHookResult = ReturnType<typeof useGetFilteredDispensariesQuery>;
export type GetFilteredDispensariesLazyQueryHookResult = ReturnType<typeof useGetFilteredDispensariesLazyQuery>;
export type GetFilteredDispensariesQueryResult = Apollo.QueryResult<GqlGetFilteredDispensariesQuery, GqlGetFilteredDispensariesQueryVariables>;
export const MergeBrandDocument = gql`
    mutation MergeBrand($id: String!, $destinationBrandId: String!) {
  mergeBrand(id: $id, destinationBrandId: $destinationBrandId) {
    id
  }
}
    `;
export type GqlMergeBrandMutationFn = Apollo.MutationFunction<GqlMergeBrandMutation, GqlMergeBrandMutationVariables>;

/**
 * __useMergeBrandMutation__
 *
 * To run a mutation, you first call `useMergeBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeBrandMutation, { data, loading, error }] = useMergeBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      destinationBrandId: // value for 'destinationBrandId'
 *   },
 * });
 */
export function useMergeBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlMergeBrandMutation, GqlMergeBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMergeBrandMutation, GqlMergeBrandMutationVariables>(MergeBrandDocument, options);
      }
export type MergeBrandMutationHookResult = ReturnType<typeof useMergeBrandMutation>;
export type MergeBrandMutationResult = Apollo.MutationResult<GqlMergeBrandMutation>;
export type MergeBrandMutationOptions = Apollo.BaseMutationOptions<GqlMergeBrandMutation, GqlMergeBrandMutationVariables>;
export const UpdateBrandCollisionDocument = gql`
    mutation UpdateBrandCollision($id: String!, $input: brandCollisionInput!) {
  updateBrandCollision(id: $id, brandCollision: $input) {
    id
  }
}
    `;
export type GqlUpdateBrandCollisionMutationFn = Apollo.MutationFunction<GqlUpdateBrandCollisionMutation, GqlUpdateBrandCollisionMutationVariables>;

/**
 * __useUpdateBrandCollisionMutation__
 *
 * To run a mutation, you first call `useUpdateBrandCollisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandCollisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandCollisionMutation, { data, loading, error }] = useUpdateBrandCollisionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandCollisionMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateBrandCollisionMutation, GqlUpdateBrandCollisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateBrandCollisionMutation, GqlUpdateBrandCollisionMutationVariables>(UpdateBrandCollisionDocument, options);
      }
export type UpdateBrandCollisionMutationHookResult = ReturnType<typeof useUpdateBrandCollisionMutation>;
export type UpdateBrandCollisionMutationResult = Apollo.MutationResult<GqlUpdateBrandCollisionMutation>;
export type UpdateBrandCollisionMutationOptions = Apollo.BaseMutationOptions<GqlUpdateBrandCollisionMutation, GqlUpdateBrandCollisionMutationVariables>;
export const BrandMergeToolIndexDocument = gql`
    query BrandMergeToolIndex($filters: searchBrandsFilters, $pagination: paginationInput, $search: String, $sort: searchBrandsSort) {
  searchBrandsV2(
    filters: $filters
    pagination: $pagination
    search: $search
    sort: $sort
  ) {
    brands {
      id
      brandCollisions {
        createdAt
        id
        isAllowed
        firstBrand {
          dispensary {
            id
            name
          }
          id
          name
          productsCount
        }
        secondBrand {
          dispensary {
            id
            name
          }
          id
          name
          productsCount
        }
      }
    }
    queryInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useBrandMergeToolIndexQuery__
 *
 * To run a query within a React component, call `useBrandMergeToolIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandMergeToolIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandMergeToolIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBrandMergeToolIndexQuery(baseOptions?: Apollo.QueryHookOptions<GqlBrandMergeToolIndexQuery, GqlBrandMergeToolIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlBrandMergeToolIndexQuery, GqlBrandMergeToolIndexQueryVariables>(BrandMergeToolIndexDocument, options);
      }
export function useBrandMergeToolIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBrandMergeToolIndexQuery, GqlBrandMergeToolIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlBrandMergeToolIndexQuery, GqlBrandMergeToolIndexQueryVariables>(BrandMergeToolIndexDocument, options);
        }
export type BrandMergeToolIndexQueryHookResult = ReturnType<typeof useBrandMergeToolIndexQuery>;
export type BrandMergeToolIndexLazyQueryHookResult = ReturnType<typeof useBrandMergeToolIndexLazyQuery>;
export type BrandMergeToolIndexQueryResult = Apollo.QueryResult<GqlBrandMergeToolIndexQuery, GqlBrandMergeToolIndexQueryVariables>;
export const SearchEnterpriseByNameDocument = gql`
    query SearchEnterpriseByName($keyword: String!) {
  searchEnterpriseByName(keyword: $keyword) {
    id
    name
  }
}
    `;

/**
 * __useSearchEnterpriseByNameQuery__
 *
 * To run a query within a React component, call `useSearchEnterpriseByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEnterpriseByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEnterpriseByNameQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useSearchEnterpriseByNameQuery(baseOptions: Apollo.QueryHookOptions<GqlSearchEnterpriseByNameQuery, GqlSearchEnterpriseByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSearchEnterpriseByNameQuery, GqlSearchEnterpriseByNameQueryVariables>(SearchEnterpriseByNameDocument, options);
      }
export function useSearchEnterpriseByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSearchEnterpriseByNameQuery, GqlSearchEnterpriseByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSearchEnterpriseByNameQuery, GqlSearchEnterpriseByNameQueryVariables>(SearchEnterpriseByNameDocument, options);
        }
export type SearchEnterpriseByNameQueryHookResult = ReturnType<typeof useSearchEnterpriseByNameQuery>;
export type SearchEnterpriseByNameLazyQueryHookResult = ReturnType<typeof useSearchEnterpriseByNameLazyQuery>;
export type SearchEnterpriseByNameQueryResult = Apollo.QueryResult<GqlSearchEnterpriseByNameQuery, GqlSearchEnterpriseByNameQueryVariables>;
export const VerifyBucketProductsDocument = gql`
    mutation VerifyBucketProducts($ids: [String!]!) {
  verifyBucketProducts(ids: $ids) {
    message
    success
  }
}
    `;
export type GqlVerifyBucketProductsMutationFn = Apollo.MutationFunction<GqlVerifyBucketProductsMutation, GqlVerifyBucketProductsMutationVariables>;

/**
 * __useVerifyBucketProductsMutation__
 *
 * To run a mutation, you first call `useVerifyBucketProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyBucketProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyBucketProductsMutation, { data, loading, error }] = useVerifyBucketProductsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVerifyBucketProductsMutation(baseOptions?: Apollo.MutationHookOptions<GqlVerifyBucketProductsMutation, GqlVerifyBucketProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlVerifyBucketProductsMutation, GqlVerifyBucketProductsMutationVariables>(VerifyBucketProductsDocument, options);
      }
export type VerifyBucketProductsMutationHookResult = ReturnType<typeof useVerifyBucketProductsMutation>;
export type VerifyBucketProductsMutationResult = Apollo.MutationResult<GqlVerifyBucketProductsMutation>;
export type VerifyBucketProductsMutationOptions = Apollo.BaseMutationOptions<GqlVerifyBucketProductsMutation, GqlVerifyBucketProductsMutationVariables>;
export const GetBulkBucketProductReviewDocument = gql`
    query GetBulkBucketProductReview($pagination: paginationInput!, $filter: SearchBucketProductFilter, $sort: SearchBucketProductSort) {
  searchBucketProducts(pagination: $pagination, filter: $filter, sort: $sort) {
    bucketProducts {
      id
      reviewedAt
      reviewedByUser {
        _id
        fullName
        firstName
        lastName
      }
      product {
        CBDContent {
          unit
          range
        }
        Status
        DispensaryID
        id
        libraryProduct {
          brand {
            name
          }
          category
          cbdContent {
            unit
            range
          }
          name
          thcContent {
            unit
            range
          }
        }
        POSMetaData {
          ...POSMetaDataFragment
        }
        THCContent {
          unit
          range
        }
      }
      verified
      oldProductData {
        CBDContent {
          unit
          range
        }
        THCContent {
          unit
          range
        }
        Name
        brand {
          name
        }
        brandId
        brandName
        POSMetaData {
          ...POSMetaDataFragment
        }
        type
        subcategory
      }
    }
    meta {
      totalCount
      reviewers {
        _id
        fullName
        firstName
        lastName
      }
    }
  }
}
    ${PosMetaDataFragmentFragmentDoc}`;

/**
 * __useGetBulkBucketProductReviewQuery__
 *
 * To run a query within a React component, call `useGetBulkBucketProductReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkBucketProductReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkBucketProductReviewQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBulkBucketProductReviewQuery(baseOptions: Apollo.QueryHookOptions<GqlGetBulkBucketProductReviewQuery, GqlGetBulkBucketProductReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBulkBucketProductReviewQuery, GqlGetBulkBucketProductReviewQueryVariables>(GetBulkBucketProductReviewDocument, options);
      }
export function useGetBulkBucketProductReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBulkBucketProductReviewQuery, GqlGetBulkBucketProductReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBulkBucketProductReviewQuery, GqlGetBulkBucketProductReviewQueryVariables>(GetBulkBucketProductReviewDocument, options);
        }
export type GetBulkBucketProductReviewQueryHookResult = ReturnType<typeof useGetBulkBucketProductReviewQuery>;
export type GetBulkBucketProductReviewLazyQueryHookResult = ReturnType<typeof useGetBulkBucketProductReviewLazyQuery>;
export type GetBulkBucketProductReviewQueryResult = Apollo.QueryResult<GqlGetBulkBucketProductReviewQuery, GqlGetBulkBucketProductReviewQueryVariables>;
export const CheckInBucketV2Document = gql`
    mutation CheckInBucketV2($uuid: String!) {
  checkInBucketV2(uuid: $uuid) {
    id
  }
}
    `;
export type GqlCheckInBucketV2MutationFn = Apollo.MutationFunction<GqlCheckInBucketV2Mutation, GqlCheckInBucketV2MutationVariables>;

/**
 * __useCheckInBucketV2Mutation__
 *
 * To run a mutation, you first call `useCheckInBucketV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInBucketV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInBucketV2Mutation, { data, loading, error }] = useCheckInBucketV2Mutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCheckInBucketV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCheckInBucketV2Mutation, GqlCheckInBucketV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCheckInBucketV2Mutation, GqlCheckInBucketV2MutationVariables>(CheckInBucketV2Document, options);
      }
export type CheckInBucketV2MutationHookResult = ReturnType<typeof useCheckInBucketV2Mutation>;
export type CheckInBucketV2MutationResult = Apollo.MutationResult<GqlCheckInBucketV2Mutation>;
export type CheckInBucketV2MutationOptions = Apollo.BaseMutationOptions<GqlCheckInBucketV2Mutation, GqlCheckInBucketV2MutationVariables>;
export const CheckOutBucketV2Document = gql`
    mutation CheckOutBucketV2($bucketId: String!, $uuid: String!) {
  checkOutBucketV2(bucketId: $bucketId, uuid: $uuid) {
    completedReviewsCount
    checkedOutAt
    checkedOutBy {
      _id
      firstName
      lastName
    }
    id
    name
    products {
      ...adminContentBaseProductFragment
      brand {
        _id
        id
        name
      }
      matchedLibraryItems {
        _id
        name
        score
      }
      dispensary {
        id
        location {
          state
        }
        medicalDispensary
        medicalOnly
        name
        recDispensary
        storeSettings {
          isolatedMenus
        }
        timezone
      }
      libraryProduct {
        id
        name
      }
      speculativeEdits {
        ...adminContentBaseProductFragment
      }
    }
    productsCount
    teamName
  }
}
    ${AdminContentBaseProductFragmentFragmentDoc}`;
export type GqlCheckOutBucketV2MutationFn = Apollo.MutationFunction<GqlCheckOutBucketV2Mutation, GqlCheckOutBucketV2MutationVariables>;

/**
 * __useCheckOutBucketV2Mutation__
 *
 * To run a mutation, you first call `useCheckOutBucketV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOutBucketV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOutBucketV2Mutation, { data, loading, error }] = useCheckOutBucketV2Mutation({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCheckOutBucketV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCheckOutBucketV2Mutation, GqlCheckOutBucketV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCheckOutBucketV2Mutation, GqlCheckOutBucketV2MutationVariables>(CheckOutBucketV2Document, options);
      }
export type CheckOutBucketV2MutationHookResult = ReturnType<typeof useCheckOutBucketV2Mutation>;
export type CheckOutBucketV2MutationResult = Apollo.MutationResult<GqlCheckOutBucketV2Mutation>;
export type CheckOutBucketV2MutationOptions = Apollo.BaseMutationOptions<GqlCheckOutBucketV2Mutation, GqlCheckOutBucketV2MutationVariables>;
export const CheckOutBucketV3Document = gql`
    mutation CheckOutBucketV3($bucketId: String!, $uuid: String!) {
  checkOutBucketV3(bucketId: $bucketId, uuid: $uuid) {
    completedReviewsCount
    checkedOutAt
    checkedOutBy {
      _id
      firstName
      lastName
    }
    id
    name
    productIds
    productsCount
    teamName
  }
}
    `;
export type GqlCheckOutBucketV3MutationFn = Apollo.MutationFunction<GqlCheckOutBucketV3Mutation, GqlCheckOutBucketV3MutationVariables>;

/**
 * __useCheckOutBucketV3Mutation__
 *
 * To run a mutation, you first call `useCheckOutBucketV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOutBucketV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOutBucketV3Mutation, { data, loading, error }] = useCheckOutBucketV3Mutation({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCheckOutBucketV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCheckOutBucketV3Mutation, GqlCheckOutBucketV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCheckOutBucketV3Mutation, GqlCheckOutBucketV3MutationVariables>(CheckOutBucketV3Document, options);
      }
export type CheckOutBucketV3MutationHookResult = ReturnType<typeof useCheckOutBucketV3Mutation>;
export type CheckOutBucketV3MutationResult = Apollo.MutationResult<GqlCheckOutBucketV3Mutation>;
export type CheckOutBucketV3MutationOptions = Apollo.BaseMutationOptions<GqlCheckOutBucketV3Mutation, GqlCheckOutBucketV3MutationVariables>;
export const CloseBucketDocument = gql`
    mutation CloseBucket($id: String!) {
  closeBucket(id: $id) {
    id
  }
}
    `;
export type GqlCloseBucketMutationFn = Apollo.MutationFunction<GqlCloseBucketMutation, GqlCloseBucketMutationVariables>;

/**
 * __useCloseBucketMutation__
 *
 * To run a mutation, you first call `useCloseBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeBucketMutation, { data, loading, error }] = useCloseBucketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseBucketMutation(baseOptions?: Apollo.MutationHookOptions<GqlCloseBucketMutation, GqlCloseBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCloseBucketMutation, GqlCloseBucketMutationVariables>(CloseBucketDocument, options);
      }
export type CloseBucketMutationHookResult = ReturnType<typeof useCloseBucketMutation>;
export type CloseBucketMutationResult = Apollo.MutationResult<GqlCloseBucketMutation>;
export type CloseBucketMutationOptions = Apollo.BaseMutationOptions<GqlCloseBucketMutation, GqlCloseBucketMutationVariables>;
export const ConnectProductPreviewDocument = gql`
    mutation ConnectProductPreview($id: String!, $libraryProductId: String!) {
  connectProductPreview(id: $id, libraryProductId: $libraryProductId) {
    previewProduct {
      product {
        _id
        id
        additionalOptions
        brand {
          id
          imageUrl
          name
        }
        brandId
        brandLogo
        brandName
        cbdContent {
          range
          unit
        }
        cName
        description
        descriptionHtml
        dispensaryId
        dispensaryName
        duplicatedProductId
        effects
        image
        integrationKey
        isBelowKioskThreshold
        isBelowThreshold
        matchedLibraryItems {
          _id
        }
        matchedLibraryItemsConfidence
        medicalOnly
        medicalPrices
        name
        options
        overrides
        posMetaData {
          ...POSMetaDataFragment
        }
        prices
        recOnly
        recPrices
        strainType
        status
        subcategory
        thcContent {
          range
          unit
        }
        type
        weight
      }
      productImages {
        _id
        url
        origin
        active
        label
        description
      }
      productBatch {
        id
      }
      terpenes {
        id
        terpeneId
        name
        unit
        active
      }
      appliedLibraryAttributes {
        additionalOptions
        brand {
          id
          imageUrl
          name
        }
        brandId
        brandLogo
        brandName
        cbdContent {
          range
          unit
        }
        cName
        description
        descriptionHtml
        dispensaryId
        dispensaryName
        duplicatedProductId
        effects
        image
        integrationKey
        isBelowKioskThreshold
        isBelowThreshold
        matchedLibraryItems {
          _id
        }
        matchedLibraryItemsConfidence
        medicalOnly
        medicalPrices
        modifiedAttributes
        name
        options
        posMetaData {
          ...POSMetaDataFragment
        }
        prices
        recOnly
        recPrices
        strainType
        status
        subcategory
        thcContent {
          range
          unit
        }
        type
        weight
      }
    }
  }
}
    ${PosMetaDataFragmentFragmentDoc}`;
export type GqlConnectProductPreviewMutationFn = Apollo.MutationFunction<GqlConnectProductPreviewMutation, GqlConnectProductPreviewMutationVariables>;

/**
 * __useConnectProductPreviewMutation__
 *
 * To run a mutation, you first call `useConnectProductPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectProductPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectProductPreviewMutation, { data, loading, error }] = useConnectProductPreviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      libraryProductId: // value for 'libraryProductId'
 *   },
 * });
 */
export function useConnectProductPreviewMutation(baseOptions?: Apollo.MutationHookOptions<GqlConnectProductPreviewMutation, GqlConnectProductPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlConnectProductPreviewMutation, GqlConnectProductPreviewMutationVariables>(ConnectProductPreviewDocument, options);
      }
export type ConnectProductPreviewMutationHookResult = ReturnType<typeof useConnectProductPreviewMutation>;
export type ConnectProductPreviewMutationResult = Apollo.MutationResult<GqlConnectProductPreviewMutation>;
export type ConnectProductPreviewMutationOptions = Apollo.BaseMutationOptions<GqlConnectProductPreviewMutation, GqlConnectProductPreviewMutationVariables>;
export const CreateBucketV2Document = gql`
    mutation CreateBucketV2($bucket: createBucketInput!) {
  createBucketV2(bucket: $bucket) {
    id
  }
}
    `;
export type GqlCreateBucketV2MutationFn = Apollo.MutationFunction<GqlCreateBucketV2Mutation, GqlCreateBucketV2MutationVariables>;

/**
 * __useCreateBucketV2Mutation__
 *
 * To run a mutation, you first call `useCreateBucketV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBucketV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBucketV2Mutation, { data, loading, error }] = useCreateBucketV2Mutation({
 *   variables: {
 *      bucket: // value for 'bucket'
 *   },
 * });
 */
export function useCreateBucketV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBucketV2Mutation, GqlCreateBucketV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBucketV2Mutation, GqlCreateBucketV2MutationVariables>(CreateBucketV2Document, options);
      }
export type CreateBucketV2MutationHookResult = ReturnType<typeof useCreateBucketV2Mutation>;
export type CreateBucketV2MutationResult = Apollo.MutationResult<GqlCreateBucketV2Mutation>;
export type CreateBucketV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateBucketV2Mutation, GqlCreateBucketV2MutationVariables>;
export const CreateBucketV3Document = gql`
    mutation CreateBucketV3($bucket: createBucketInputV3!) {
  createBucketV3(bucket: $bucket) {
    id
  }
}
    `;
export type GqlCreateBucketV3MutationFn = Apollo.MutationFunction<GqlCreateBucketV3Mutation, GqlCreateBucketV3MutationVariables>;

/**
 * __useCreateBucketV3Mutation__
 *
 * To run a mutation, you first call `useCreateBucketV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBucketV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBucketV3Mutation, { data, loading, error }] = useCreateBucketV3Mutation({
 *   variables: {
 *      bucket: // value for 'bucket'
 *   },
 * });
 */
export function useCreateBucketV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBucketV3Mutation, GqlCreateBucketV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBucketV3Mutation, GqlCreateBucketV3MutationVariables>(CreateBucketV3Document, options);
      }
export type CreateBucketV3MutationHookResult = ReturnType<typeof useCreateBucketV3Mutation>;
export type CreateBucketV3MutationResult = Apollo.MutationResult<GqlCreateBucketV3Mutation>;
export type CreateBucketV3MutationOptions = Apollo.BaseMutationOptions<GqlCreateBucketV3Mutation, GqlCreateBucketV3MutationVariables>;
export const DisconnectBucketProductDocument = gql`
    mutation DisconnectBucketProduct($bucketId: String!, $productId: String!) {
  disconnectBucketProduct(bucketId: $bucketId, productId: $productId) {
    message
    success
  }
}
    `;
export type GqlDisconnectBucketProductMutationFn = Apollo.MutationFunction<GqlDisconnectBucketProductMutation, GqlDisconnectBucketProductMutationVariables>;

/**
 * __useDisconnectBucketProductMutation__
 *
 * To run a mutation, you first call `useDisconnectBucketProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectBucketProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectBucketProductMutation, { data, loading, error }] = useDisconnectBucketProductMutation({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDisconnectBucketProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlDisconnectBucketProductMutation, GqlDisconnectBucketProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDisconnectBucketProductMutation, GqlDisconnectBucketProductMutationVariables>(DisconnectBucketProductDocument, options);
      }
export type DisconnectBucketProductMutationHookResult = ReturnType<typeof useDisconnectBucketProductMutation>;
export type DisconnectBucketProductMutationResult = Apollo.MutationResult<GqlDisconnectBucketProductMutation>;
export type DisconnectBucketProductMutationOptions = Apollo.BaseMutationOptions<GqlDisconnectBucketProductMutation, GqlDisconnectBucketProductMutationVariables>;
export const SkipBucketProductV2Document = gql`
    mutation SkipBucketProductV2($bucketId: String!, $productId: String!, $skipReasons: [SkipReasonEnum!]!) {
  skipBucketProductV2(
    bucketId: $bucketId
    productId: $productId
    skipReasons: $skipReasons
  ) {
    message
    success
  }
}
    `;
export type GqlSkipBucketProductV2MutationFn = Apollo.MutationFunction<GqlSkipBucketProductV2Mutation, GqlSkipBucketProductV2MutationVariables>;

/**
 * __useSkipBucketProductV2Mutation__
 *
 * To run a mutation, you first call `useSkipBucketProductV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipBucketProductV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipBucketProductV2Mutation, { data, loading, error }] = useSkipBucketProductV2Mutation({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      productId: // value for 'productId'
 *      skipReasons: // value for 'skipReasons'
 *   },
 * });
 */
export function useSkipBucketProductV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlSkipBucketProductV2Mutation, GqlSkipBucketProductV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSkipBucketProductV2Mutation, GqlSkipBucketProductV2MutationVariables>(SkipBucketProductV2Document, options);
      }
export type SkipBucketProductV2MutationHookResult = ReturnType<typeof useSkipBucketProductV2Mutation>;
export type SkipBucketProductV2MutationResult = Apollo.MutationResult<GqlSkipBucketProductV2Mutation>;
export type SkipBucketProductV2MutationOptions = Apollo.BaseMutationOptions<GqlSkipBucketProductV2Mutation, GqlSkipBucketProductV2MutationVariables>;
export const SkipBucketProductDocument = gql`
    mutation SkipBucketProduct($bucketId: String!, $productId: String!) {
  skipBucketProduct(bucketId: $bucketId, productId: $productId) {
    message
    success
  }
}
    `;
export type GqlSkipBucketProductMutationFn = Apollo.MutationFunction<GqlSkipBucketProductMutation, GqlSkipBucketProductMutationVariables>;

/**
 * __useSkipBucketProductMutation__
 *
 * To run a mutation, you first call `useSkipBucketProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipBucketProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipBucketProductMutation, { data, loading, error }] = useSkipBucketProductMutation({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useSkipBucketProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlSkipBucketProductMutation, GqlSkipBucketProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSkipBucketProductMutation, GqlSkipBucketProductMutationVariables>(SkipBucketProductDocument, options);
      }
export type SkipBucketProductMutationHookResult = ReturnType<typeof useSkipBucketProductMutation>;
export type SkipBucketProductMutationResult = Apollo.MutationResult<GqlSkipBucketProductMutation>;
export type SkipBucketProductMutationOptions = Apollo.BaseMutationOptions<GqlSkipBucketProductMutation, GqlSkipBucketProductMutationVariables>;
export const ConnectNewProductPreviewDocument = gql`
    query ConnectNewProductPreview($dispensaryId: String!, $libraryProductId: String!) {
  connectNewProductPreview(
    dispensaryId: $dispensaryId
    libraryProductId: $libraryProductId
  ) {
    previewProduct {
      product {
        _id
        id
        additionalOptions
        brand {
          id
          imageUrl
          name
        }
        brandId
        brandLogo
        brandName
        cbdContent {
          range
          unit
        }
        cName
        description
        descriptionHtml
        dispensaryId
        dispensaryName
        duplicatedProductId
        effects
        image
        integrationKey
        isBelowKioskThreshold
        isBelowThreshold
        matchedLibraryItems {
          _id
        }
        matchedLibraryItemsConfidence
        medicalOnly
        medicalPrices
        name
        options
        overrides
        posMetaData {
          ...POSMetaDataFragment
        }
        prices
        recOnly
        recPrices
        strainType
        status
        subcategory
        thcContent {
          range
          unit
        }
        type
        weight
      }
      productImages {
        _id
        url
        origin
        active
        label
        description
      }
      productBatch {
        id
      }
      terpenes {
        id
        terpeneId
        name
        unit
        active
      }
      appliedLibraryAttributes {
        additionalOptions
        brand {
          id
          imageUrl
          name
        }
        brandId
        brandLogo
        brandName
        cbdContent {
          range
          unit
        }
        cName
        description
        descriptionHtml
        dispensaryId
        dispensaryName
        duplicatedProductId
        effects
        image
        integrationKey
        isBelowKioskThreshold
        isBelowThreshold
        matchedLibraryItems {
          _id
        }
        matchedLibraryItemsConfidence
        medicalOnly
        medicalPrices
        modifiedAttributes
        name
        options
        posMetaData {
          ...POSMetaDataFragment
        }
        prices
        recOnly
        recPrices
        strainType
        status
        subcategory
        thcContent {
          range
          unit
        }
        type
        weight
      }
    }
  }
}
    ${PosMetaDataFragmentFragmentDoc}`;

/**
 * __useConnectNewProductPreviewQuery__
 *
 * To run a query within a React component, call `useConnectNewProductPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectNewProductPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectNewProductPreviewQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      libraryProductId: // value for 'libraryProductId'
 *   },
 * });
 */
export function useConnectNewProductPreviewQuery(baseOptions: Apollo.QueryHookOptions<GqlConnectNewProductPreviewQuery, GqlConnectNewProductPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlConnectNewProductPreviewQuery, GqlConnectNewProductPreviewQueryVariables>(ConnectNewProductPreviewDocument, options);
      }
export function useConnectNewProductPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlConnectNewProductPreviewQuery, GqlConnectNewProductPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlConnectNewProductPreviewQuery, GqlConnectNewProductPreviewQueryVariables>(ConnectNewProductPreviewDocument, options);
        }
export type ConnectNewProductPreviewQueryHookResult = ReturnType<typeof useConnectNewProductPreviewQuery>;
export type ConnectNewProductPreviewLazyQueryHookResult = ReturnType<typeof useConnectNewProductPreviewLazyQuery>;
export type ConnectNewProductPreviewQueryResult = Apollo.QueryResult<GqlConnectNewProductPreviewQuery, GqlConnectNewProductPreviewQueryVariables>;
export const ContentStatisticsDocument = gql`
    query ContentStatistics {
  contentStatistics {
    connectedPercentage
    menuScore
  }
}
    `;

/**
 * __useContentStatisticsQuery__
 *
 * To run a query within a React component, call `useContentStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GqlContentStatisticsQuery, GqlContentStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlContentStatisticsQuery, GqlContentStatisticsQueryVariables>(ContentStatisticsDocument, options);
      }
export function useContentStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlContentStatisticsQuery, GqlContentStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlContentStatisticsQuery, GqlContentStatisticsQueryVariables>(ContentStatisticsDocument, options);
        }
export type ContentStatisticsQueryHookResult = ReturnType<typeof useContentStatisticsQuery>;
export type ContentStatisticsLazyQueryHookResult = ReturnType<typeof useContentStatisticsLazyQuery>;
export type ContentStatisticsQueryResult = Apollo.QueryResult<GqlContentStatisticsQuery, GqlContentStatisticsQueryVariables>;
export const GetBucketsDocument = gql`
    query GetBuckets($sort: brandsSortInput) {
  getBuckets(sort: $sort) {
    ...bucketListFragment
  }
}
    ${BucketListFragmentFragmentDoc}`;

/**
 * __useGetBucketsQuery__
 *
 * To run a query within a React component, call `useGetBucketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBucketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBucketsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBucketsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetBucketsQuery, GqlGetBucketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBucketsQuery, GqlGetBucketsQueryVariables>(GetBucketsDocument, options);
      }
export function useGetBucketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBucketsQuery, GqlGetBucketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBucketsQuery, GqlGetBucketsQueryVariables>(GetBucketsDocument, options);
        }
export type GetBucketsQueryHookResult = ReturnType<typeof useGetBucketsQuery>;
export type GetBucketsLazyQueryHookResult = ReturnType<typeof useGetBucketsLazyQuery>;
export type GetBucketsQueryResult = Apollo.QueryResult<GqlGetBucketsQuery, GqlGetBucketsQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($productsFilter: productsFilterInput!) {
  filteredProducts(filter: $productsFilter) {
    products {
      ...adminContentBaseProductFragment
      brand {
        _id
        id
        name
      }
      matchedLibraryItems {
        _id
        name
        score
      }
      dispensary {
        id
        location {
          state
        }
        medicalDispensary
        medicalOnly
        name
        recDispensary
        storeSettings {
          isolatedMenus
        }
        timezone
      }
      libraryProduct {
        id
        name
      }
      speculativeEdits {
        ...adminContentBaseProductFragment
      }
    }
  }
}
    ${AdminContentBaseProductFragmentFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GqlGetProductQuery, GqlGetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetProductQuery, GqlGetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetProductQuery, GqlGetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetProductQuery, GqlGetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GqlGetProductQuery, GqlGetProductQueryVariables>;
export const RefreshBucketDocument = gql`
    query RefreshBucket($id: String!) {
  getBucket(id: $id) {
    ...bucketListFragment
  }
}
    ${BucketListFragmentFragmentDoc}`;

/**
 * __useRefreshBucketQuery__
 *
 * To run a query within a React component, call `useRefreshBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshBucketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshBucketQuery(baseOptions: Apollo.QueryHookOptions<GqlRefreshBucketQuery, GqlRefreshBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlRefreshBucketQuery, GqlRefreshBucketQueryVariables>(RefreshBucketDocument, options);
      }
export function useRefreshBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRefreshBucketQuery, GqlRefreshBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlRefreshBucketQuery, GqlRefreshBucketQueryVariables>(RefreshBucketDocument, options);
        }
export type RefreshBucketQueryHookResult = ReturnType<typeof useRefreshBucketQuery>;
export type RefreshBucketLazyQueryHookResult = ReturnType<typeof useRefreshBucketLazyQuery>;
export type RefreshBucketQueryResult = Apollo.QueryResult<GqlRefreshBucketQuery, GqlRefreshBucketQueryVariables>;
export const CopyLibraryProductDocument = gql`
    mutation CopyLibraryProduct($id: String!, $stateLibraryIds: [String!]!) {
  copyLibraryProduct(id: $id, stateLibraryIds: $stateLibraryIds) {
    libraryProducts {
      dispensaryId
    }
    meta {
      errors {
        type
        errors
        state_library_id
      }
    }
  }
}
    `;
export type GqlCopyLibraryProductMutationFn = Apollo.MutationFunction<GqlCopyLibraryProductMutation, GqlCopyLibraryProductMutationVariables>;

/**
 * __useCopyLibraryProductMutation__
 *
 * To run a mutation, you first call `useCopyLibraryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyLibraryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyLibraryProductMutation, { data, loading, error }] = useCopyLibraryProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stateLibraryIds: // value for 'stateLibraryIds'
 *   },
 * });
 */
export function useCopyLibraryProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlCopyLibraryProductMutation, GqlCopyLibraryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCopyLibraryProductMutation, GqlCopyLibraryProductMutationVariables>(CopyLibraryProductDocument, options);
      }
export type CopyLibraryProductMutationHookResult = ReturnType<typeof useCopyLibraryProductMutation>;
export type CopyLibraryProductMutationResult = Apollo.MutationResult<GqlCopyLibraryProductMutation>;
export type CopyLibraryProductMutationOptions = Apollo.BaseMutationOptions<GqlCopyLibraryProductMutation, GqlCopyLibraryProductMutationVariables>;
export const CreateBucketForLibraryItemDocument = gql`
    mutation CreateBucketForLibraryItem($libraryItemId: ID!) {
  createBucketForLibraryItem(libraryItemId: $libraryItemId) {
    id
  }
}
    `;
export type GqlCreateBucketForLibraryItemMutationFn = Apollo.MutationFunction<GqlCreateBucketForLibraryItemMutation, GqlCreateBucketForLibraryItemMutationVariables>;

/**
 * __useCreateBucketForLibraryItemMutation__
 *
 * To run a mutation, you first call `useCreateBucketForLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBucketForLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBucketForLibraryItemMutation, { data, loading, error }] = useCreateBucketForLibraryItemMutation({
 *   variables: {
 *      libraryItemId: // value for 'libraryItemId'
 *   },
 * });
 */
export function useCreateBucketForLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBucketForLibraryItemMutation, GqlCreateBucketForLibraryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBucketForLibraryItemMutation, GqlCreateBucketForLibraryItemMutationVariables>(CreateBucketForLibraryItemDocument, options);
      }
export type CreateBucketForLibraryItemMutationHookResult = ReturnType<typeof useCreateBucketForLibraryItemMutation>;
export type CreateBucketForLibraryItemMutationResult = Apollo.MutationResult<GqlCreateBucketForLibraryItemMutation>;
export type CreateBucketForLibraryItemMutationOptions = Apollo.BaseMutationOptions<GqlCreateBucketForLibraryItemMutation, GqlCreateBucketForLibraryItemMutationVariables>;
export const DeleteLibraryProductDocument = gql`
    mutation DeleteLibraryProduct($id: String!) {
  deleteLibraryProduct(id: $id) {
    id
  }
}
    `;
export type GqlDeleteLibraryProductMutationFn = Apollo.MutationFunction<GqlDeleteLibraryProductMutation, GqlDeleteLibraryProductMutationVariables>;

/**
 * __useDeleteLibraryProductMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryProductMutation, { data, loading, error }] = useDeleteLibraryProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteLibraryProductMutation, GqlDeleteLibraryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteLibraryProductMutation, GqlDeleteLibraryProductMutationVariables>(DeleteLibraryProductDocument, options);
      }
export type DeleteLibraryProductMutationHookResult = ReturnType<typeof useDeleteLibraryProductMutation>;
export type DeleteLibraryProductMutationResult = Apollo.MutationResult<GqlDeleteLibraryProductMutation>;
export type DeleteLibraryProductMutationOptions = Apollo.BaseMutationOptions<GqlDeleteLibraryProductMutation, GqlDeleteLibraryProductMutationVariables>;
export const UpdateLibraryProductDocument = gql`
    mutation UpdateLibraryProduct($id: String!, $updates: UpdatedLibraryProduct!) {
  updateLibraryProduct(id: $id, updates: $updates) {
    libraryProduct {
      dispensaryId
    }
  }
}
    `;
export type GqlUpdateLibraryProductMutationFn = Apollo.MutationFunction<GqlUpdateLibraryProductMutation, GqlUpdateLibraryProductMutationVariables>;

/**
 * __useUpdateLibraryProductMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryProductMutation, { data, loading, error }] = useUpdateLibraryProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateLibraryProductMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateLibraryProductMutation, GqlUpdateLibraryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateLibraryProductMutation, GqlUpdateLibraryProductMutationVariables>(UpdateLibraryProductDocument, options);
      }
export type UpdateLibraryProductMutationHookResult = ReturnType<typeof useUpdateLibraryProductMutation>;
export type UpdateLibraryProductMutationResult = Apollo.MutationResult<GqlUpdateLibraryProductMutation>;
export type UpdateLibraryProductMutationOptions = Apollo.BaseMutationOptions<GqlUpdateLibraryProductMutation, GqlUpdateLibraryProductMutationVariables>;
export const FindLibraryProductsDocument = gql`
    query FindLibraryProducts($id: String!) {
  findLibraryProducts(id: $id) {
    libraryProducts {
      dispensaryId
    }
  }
}
    `;

/**
 * __useFindLibraryProductsQuery__
 *
 * To run a query within a React component, call `useFindLibraryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLibraryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLibraryProductsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindLibraryProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlFindLibraryProductsQuery, GqlFindLibraryProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFindLibraryProductsQuery, GqlFindLibraryProductsQueryVariables>(FindLibraryProductsDocument, options);
      }
export function useFindLibraryProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFindLibraryProductsQuery, GqlFindLibraryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFindLibraryProductsQuery, GqlFindLibraryProductsQueryVariables>(FindLibraryProductsDocument, options);
        }
export type FindLibraryProductsQueryHookResult = ReturnType<typeof useFindLibraryProductsQuery>;
export type FindLibraryProductsLazyQueryHookResult = ReturnType<typeof useFindLibraryProductsLazyQuery>;
export type FindLibraryProductsQueryResult = Apollo.QueryResult<GqlFindLibraryProductsQuery, GqlFindLibraryProductsQueryVariables>;
export const GetLibraryProductDocument = gql`
    query GetLibraryProduct($id: String!) {
  getLibraryProduct(id: $id) {
    id
    brand {
      id
      name
      isGlobal
      _id
    }
    category
    cbdContent {
      unit
      range
    }
    cannabinoidRatio
    connectedCount
    description
    descriptionHtml
    dispensaryId
    dosageMg
    effects
    gtin
    image
    images {
      _id
      url
      active
      origin
    }
    name
    options
    packSize
    prices
    productTemplate
    sku
    strainType
    stockImage
    subcategory
    productBatchId
    suggestedCannabinoidRatio
    suggestedDosageMg
    suggestedPackSize
    suggestedWeightGrams
    cannabinoids {
      cannabinoidId
      cannabinoid {
        id
        description
        name
      }
      unit
      value
      active
    }
    terpenes {
      name
      id
      terpeneId
      unit
      value
      active
      libraryTerpene {
        name
      }
    }
    thcContent {
      unit
      range
    }
    weightGrams
  }
}
    `;

/**
 * __useGetLibraryProductQuery__
 *
 * To run a query within a React component, call `useGetLibraryProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLibraryProductQuery(baseOptions: Apollo.QueryHookOptions<GqlGetLibraryProductQuery, GqlGetLibraryProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetLibraryProductQuery, GqlGetLibraryProductQueryVariables>(GetLibraryProductDocument, options);
      }
export function useGetLibraryProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetLibraryProductQuery, GqlGetLibraryProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetLibraryProductQuery, GqlGetLibraryProductQueryVariables>(GetLibraryProductDocument, options);
        }
export type GetLibraryProductQueryHookResult = ReturnType<typeof useGetLibraryProductQuery>;
export type GetLibraryProductLazyQueryHookResult = ReturnType<typeof useGetLibraryProductLazyQuery>;
export type GetLibraryProductQueryResult = Apollo.QueryResult<GqlGetLibraryProductQuery, GqlGetLibraryProductQueryVariables>;
export const GetLibraryProductChangeEventsDocument = gql`
    query GetLibraryProductChangeEvents($productId: ID!) {
  productChangeEvents(productId: $productId) {
    id
    createdAt
    createdBy
    createdByUser {
      firstName
      lastName
      fullName
    }
    event
    metadata
    newValues
    oldValues
    productId
    versionId
  }
}
    `;

/**
 * __useGetLibraryProductChangeEventsQuery__
 *
 * To run a query within a React component, call `useGetLibraryProductChangeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryProductChangeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryProductChangeEventsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetLibraryProductChangeEventsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetLibraryProductChangeEventsQuery, GqlGetLibraryProductChangeEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetLibraryProductChangeEventsQuery, GqlGetLibraryProductChangeEventsQueryVariables>(GetLibraryProductChangeEventsDocument, options);
      }
export function useGetLibraryProductChangeEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetLibraryProductChangeEventsQuery, GqlGetLibraryProductChangeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetLibraryProductChangeEventsQuery, GqlGetLibraryProductChangeEventsQueryVariables>(GetLibraryProductChangeEventsDocument, options);
        }
export type GetLibraryProductChangeEventsQueryHookResult = ReturnType<typeof useGetLibraryProductChangeEventsQuery>;
export type GetLibraryProductChangeEventsLazyQueryHookResult = ReturnType<typeof useGetLibraryProductChangeEventsLazyQuery>;
export type GetLibraryProductChangeEventsQueryResult = Apollo.QueryResult<GqlGetLibraryProductChangeEventsQuery, GqlGetLibraryProductChangeEventsQueryVariables>;
export const StateLibrariesIndexDocument = gql`
    query StateLibrariesIndex {
  getStateLibraries {
    id
    name
    state
  }
}
    `;

/**
 * __useStateLibrariesIndexQuery__
 *
 * To run a query within a React component, call `useStateLibrariesIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateLibrariesIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateLibrariesIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useStateLibrariesIndexQuery(baseOptions?: Apollo.QueryHookOptions<GqlStateLibrariesIndexQuery, GqlStateLibrariesIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlStateLibrariesIndexQuery, GqlStateLibrariesIndexQueryVariables>(StateLibrariesIndexDocument, options);
      }
export function useStateLibrariesIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStateLibrariesIndexQuery, GqlStateLibrariesIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlStateLibrariesIndexQuery, GqlStateLibrariesIndexQueryVariables>(StateLibrariesIndexDocument, options);
        }
export type StateLibrariesIndexQueryHookResult = ReturnType<typeof useStateLibrariesIndexQuery>;
export type StateLibrariesIndexLazyQueryHookResult = ReturnType<typeof useStateLibrariesIndexLazyQuery>;
export type StateLibrariesIndexQueryResult = Apollo.QueryResult<GqlStateLibrariesIndexQuery, GqlStateLibrariesIndexQueryVariables>;
export const LibraryProductChangeImpactV2Document = gql`
    query LibraryProductChangeImpactV2($id: String!, $updates: UpdatedLibraryProduct!) {
  libraryProductChangeImpactV2(id: $id, updates: $updates) {
    totalCount {
      count
    }
  }
}
    `;

/**
 * __useLibraryProductChangeImpactV2Query__
 *
 * To run a query within a React component, call `useLibraryProductChangeImpactV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLibraryProductChangeImpactV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryProductChangeImpactV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useLibraryProductChangeImpactV2Query(baseOptions: Apollo.QueryHookOptions<GqlLibraryProductChangeImpactV2Query, GqlLibraryProductChangeImpactV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlLibraryProductChangeImpactV2Query, GqlLibraryProductChangeImpactV2QueryVariables>(LibraryProductChangeImpactV2Document, options);
      }
export function useLibraryProductChangeImpactV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlLibraryProductChangeImpactV2Query, GqlLibraryProductChangeImpactV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlLibraryProductChangeImpactV2Query, GqlLibraryProductChangeImpactV2QueryVariables>(LibraryProductChangeImpactV2Document, options);
        }
export type LibraryProductChangeImpactV2QueryHookResult = ReturnType<typeof useLibraryProductChangeImpactV2Query>;
export type LibraryProductChangeImpactV2LazyQueryHookResult = ReturnType<typeof useLibraryProductChangeImpactV2LazyQuery>;
export type LibraryProductChangeImpactV2QueryResult = Apollo.QueryResult<GqlLibraryProductChangeImpactV2Query, GqlLibraryProductChangeImpactV2QueryVariables>;
export const LibraryProductChangeImpactV3Document = gql`
    mutation LibraryProductChangeImpactV3($id: String!, $updates: UpdatedLibraryProduct!) {
  libraryProductChangeImpactV3(id: $id, updates: $updates) {
    totalCount {
      count
    }
  }
}
    `;
export type GqlLibraryProductChangeImpactV3MutationFn = Apollo.MutationFunction<GqlLibraryProductChangeImpactV3Mutation, GqlLibraryProductChangeImpactV3MutationVariables>;

/**
 * __useLibraryProductChangeImpactV3Mutation__
 *
 * To run a mutation, you first call `useLibraryProductChangeImpactV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLibraryProductChangeImpactV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [libraryProductChangeImpactV3Mutation, { data, loading, error }] = useLibraryProductChangeImpactV3Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useLibraryProductChangeImpactV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlLibraryProductChangeImpactV3Mutation, GqlLibraryProductChangeImpactV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLibraryProductChangeImpactV3Mutation, GqlLibraryProductChangeImpactV3MutationVariables>(LibraryProductChangeImpactV3Document, options);
      }
export type LibraryProductChangeImpactV3MutationHookResult = ReturnType<typeof useLibraryProductChangeImpactV3Mutation>;
export type LibraryProductChangeImpactV3MutationResult = Apollo.MutationResult<GqlLibraryProductChangeImpactV3Mutation>;
export type LibraryProductChangeImpactV3MutationOptions = Apollo.BaseMutationOptions<GqlLibraryProductChangeImpactV3Mutation, GqlLibraryProductChangeImpactV3MutationVariables>;
export const LibraryProductsIndexDocument = gql`
    query LibraryProductsIndex($filters: searchLibraryProductsFilters, $pagination: paginationInput, $search: String, $sort: searchLibraryProductsSort) {
  searchLibraryProducts(
    filters: $filters
    pagination: $pagination
    search: $search
    sort: $sort
  ) {
    libraryProducts {
      brand {
        id
        isGlobal
        name
      }
      category
      connectedCount
      createdAt
      createdBy {
        firstName
        fullName
        lastName
      }
      description
      dispensaryId
      id
      menuScore
      name
      subcategory
      updatedAt
      updatedByBrand
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useLibraryProductsIndexQuery__
 *
 * To run a query within a React component, call `useLibraryProductsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryProductsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryProductsIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLibraryProductsIndexQuery(baseOptions?: Apollo.QueryHookOptions<GqlLibraryProductsIndexQuery, GqlLibraryProductsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlLibraryProductsIndexQuery, GqlLibraryProductsIndexQueryVariables>(LibraryProductsIndexDocument, options);
      }
export function useLibraryProductsIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlLibraryProductsIndexQuery, GqlLibraryProductsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlLibraryProductsIndexQuery, GqlLibraryProductsIndexQueryVariables>(LibraryProductsIndexDocument, options);
        }
export type LibraryProductsIndexQueryHookResult = ReturnType<typeof useLibraryProductsIndexQuery>;
export type LibraryProductsIndexLazyQueryHookResult = ReturnType<typeof useLibraryProductsIndexLazyQuery>;
export type LibraryProductsIndexQueryResult = Apollo.QueryResult<GqlLibraryProductsIndexQuery, GqlLibraryProductsIndexQueryVariables>;
export const ProductFiltersDocument = gql`
    query ProductFilters {
  productFilters {
    dispensaryDropdownOptions {
      key
      label
      state
      status
      value
    }
    chainDropdownOptions {
      key
      label
      value
    }
    statesDropdownOptions {
      key
      label
      value
    }
  }
}
    `;

/**
 * __useProductFiltersQuery__
 *
 * To run a query within a React component, call `useProductFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GqlProductFiltersQuery, GqlProductFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlProductFiltersQuery, GqlProductFiltersQueryVariables>(ProductFiltersDocument, options);
      }
export function useProductFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductFiltersQuery, GqlProductFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlProductFiltersQuery, GqlProductFiltersQueryVariables>(ProductFiltersDocument, options);
        }
export type ProductFiltersQueryHookResult = ReturnType<typeof useProductFiltersQuery>;
export type ProductFiltersLazyQueryHookResult = ReturnType<typeof useProductFiltersLazyQuery>;
export type ProductFiltersQueryResult = Apollo.QueryResult<GqlProductFiltersQuery, GqlProductFiltersQueryVariables>;
export const SuperProductsDocument = gql`
    query SuperProducts($filter: superProductsInput!) {
  superProducts(filter: $filter) {
    products {
      _id
      id
      brand {
        id
        name
      }
      brandId
      brandName
      dispensary {
        id
        name
      }
      DispensaryID
      matchedLibraryItemsConfidence
      Name
      score
      strainType
      type
    }
    queryInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useSuperProductsQuery__
 *
 * To run a query within a React component, call `useSuperProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperProductsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSuperProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlSuperProductsQuery, GqlSuperProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSuperProductsQuery, GqlSuperProductsQueryVariables>(SuperProductsDocument, options);
      }
export function useSuperProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSuperProductsQuery, GqlSuperProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSuperProductsQuery, GqlSuperProductsQueryVariables>(SuperProductsDocument, options);
        }
export type SuperProductsQueryHookResult = ReturnType<typeof useSuperProductsQuery>;
export type SuperProductsLazyQueryHookResult = ReturnType<typeof useSuperProductsLazyQuery>;
export type SuperProductsQueryResult = Apollo.QueryResult<GqlSuperProductsQuery, GqlSuperProductsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: String!) {
  getConsumerUser(id: $id) {
    _id
    email
    profile {
      phone
      phoneVerifiedAt
      textNotifications
      emailNotifications
      emailOptIn
    }
    customers {
      _id
      emailSubscription
      dispensaryName
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GqlGetUserQuery, GqlGetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetUserQuery, GqlGetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetUserQuery, GqlGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetUserQuery, GqlGetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GqlGetUserQuery, GqlGetUserQueryVariables>;
export const DispensaryUpdateStatusDocument = gql`
    mutation DispensaryUpdateStatus($input: dispensaryUpdateStatusInput!) {
  dispensaryUpdateStatus(input: $input) {
    success
  }
}
    `;
export type GqlDispensaryUpdateStatusMutationFn = Apollo.MutationFunction<GqlDispensaryUpdateStatusMutation, GqlDispensaryUpdateStatusMutationVariables>;

/**
 * __useDispensaryUpdateStatusMutation__
 *
 * To run a mutation, you first call `useDispensaryUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryUpdateStatusMutation, { data, loading, error }] = useDispensaryUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispensaryUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<GqlDispensaryUpdateStatusMutation, GqlDispensaryUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDispensaryUpdateStatusMutation, GqlDispensaryUpdateStatusMutationVariables>(DispensaryUpdateStatusDocument, options);
      }
export type DispensaryUpdateStatusMutationHookResult = ReturnType<typeof useDispensaryUpdateStatusMutation>;
export type DispensaryUpdateStatusMutationResult = Apollo.MutationResult<GqlDispensaryUpdateStatusMutation>;
export type DispensaryUpdateStatusMutationOptions = Apollo.BaseMutationOptions<GqlDispensaryUpdateStatusMutation, GqlDispensaryUpdateStatusMutationVariables>;
export const PendingDispensariesDocument = gql`
    query PendingDispensaries($searchStr: String, $sort: sortInput, $page: Int, $perPage: Int) {
  pendingDispensaries(
    searchStr: $searchStr
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    dispensaries {
      createdAtISO
      id
      name
      phone
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __usePendingDispensariesQuery__
 *
 * To run a query within a React component, call `usePendingDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingDispensariesQuery({
 *   variables: {
 *      searchStr: // value for 'searchStr'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePendingDispensariesQuery(baseOptions?: Apollo.QueryHookOptions<GqlPendingDispensariesQuery, GqlPendingDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlPendingDispensariesQuery, GqlPendingDispensariesQueryVariables>(PendingDispensariesDocument, options);
      }
export function usePendingDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlPendingDispensariesQuery, GqlPendingDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlPendingDispensariesQuery, GqlPendingDispensariesQueryVariables>(PendingDispensariesDocument, options);
        }
export type PendingDispensariesQueryHookResult = ReturnType<typeof usePendingDispensariesQuery>;
export type PendingDispensariesLazyQueryHookResult = ReturnType<typeof usePendingDispensariesLazyQuery>;
export type PendingDispensariesQueryResult = Apollo.QueryResult<GqlPendingDispensariesQuery, GqlPendingDispensariesQueryVariables>;
export const SuperGetOrdersDocument = gql`
    query SuperGetOrders($input: getOrdersInput!) {
  getOrders(input: $input) {
    orders {
      _id
      createdAt
      customerId
      customerName
      delivery
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
      }
      dispensaryId
      dispensaryName
      dispoTimezone
      duration
      durationEstimates {
        delivery {
          highInMinutes
          lowInMinutes
        }
        pickup {
          highInMinutes
          lowInMinutes
        }
      }
      isAnonymous
      isAfterHoursOrder
      isKioskOrder
      orderId
      status
      totalCost
    }
  }
}
    `;

/**
 * __useSuperGetOrdersQuery__
 *
 * To run a query within a React component, call `useSuperGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperGetOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GqlSuperGetOrdersQuery, GqlSuperGetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSuperGetOrdersQuery, GqlSuperGetOrdersQueryVariables>(SuperGetOrdersDocument, options);
      }
export function useSuperGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSuperGetOrdersQuery, GqlSuperGetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSuperGetOrdersQuery, GqlSuperGetOrdersQueryVariables>(SuperGetOrdersDocument, options);
        }
export type SuperGetOrdersQueryHookResult = ReturnType<typeof useSuperGetOrdersQuery>;
export type SuperGetOrdersLazyQueryHookResult = ReturnType<typeof useSuperGetOrdersLazyQuery>;
export type SuperGetOrdersQueryResult = Apollo.QueryResult<GqlSuperGetOrdersQuery, GqlSuperGetOrdersQueryVariables>;
export const UpdateChainDispensariesImageDocument = gql`
    mutation UpdateChainDispensariesImage($dispensaryId: String!, $imageVariantKey: ImageVariantKeyEnum!) {
  updateChainDispensariesImage(
    dispensaryId: $dispensaryId
    image_variant_keys: [$imageVariantKey]
  ) {
    success
    message
  }
}
    `;
export type GqlUpdateChainDispensariesImageMutationFn = Apollo.MutationFunction<GqlUpdateChainDispensariesImageMutation, GqlUpdateChainDispensariesImageMutationVariables>;

/**
 * __useUpdateChainDispensariesImageMutation__
 *
 * To run a mutation, you first call `useUpdateChainDispensariesImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChainDispensariesImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChainDispensariesImageMutation, { data, loading, error }] = useUpdateChainDispensariesImageMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      imageVariantKey: // value for 'imageVariantKey'
 *   },
 * });
 */
export function useUpdateChainDispensariesImageMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateChainDispensariesImageMutation, GqlUpdateChainDispensariesImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateChainDispensariesImageMutation, GqlUpdateChainDispensariesImageMutationVariables>(UpdateChainDispensariesImageDocument, options);
      }
export type UpdateChainDispensariesImageMutationHookResult = ReturnType<typeof useUpdateChainDispensariesImageMutation>;
export type UpdateChainDispensariesImageMutationResult = Apollo.MutationResult<GqlUpdateChainDispensariesImageMutation>;
export type UpdateChainDispensariesImageMutationOptions = Apollo.BaseMutationOptions<GqlUpdateChainDispensariesImageMutation, GqlUpdateChainDispensariesImageMutationVariables>;
export const SuperAdminsTableDocument = gql`
    query SuperAdminsTable {
  filteredUsers(filter: {superadmin: true}) {
    _id
    email
    fullName
    firstName
    lastName
    permissions {
      menuReview
      superMenuReview
    }
  }
}
    `;

/**
 * __useSuperAdminsTableQuery__
 *
 * To run a query within a React component, call `useSuperAdminsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminsTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperAdminsTableQuery(baseOptions?: Apollo.QueryHookOptions<GqlSuperAdminsTableQuery, GqlSuperAdminsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSuperAdminsTableQuery, GqlSuperAdminsTableQueryVariables>(SuperAdminsTableDocument, options);
      }
export function useSuperAdminsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSuperAdminsTableQuery, GqlSuperAdminsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSuperAdminsTableQuery, GqlSuperAdminsTableQueryVariables>(SuperAdminsTableDocument, options);
        }
export type SuperAdminsTableQueryHookResult = ReturnType<typeof useSuperAdminsTableQuery>;
export type SuperAdminsTableLazyQueryHookResult = ReturnType<typeof useSuperAdminsTableLazyQuery>;
export type SuperAdminsTableQueryResult = Apollo.QueryResult<GqlSuperAdminsTableQuery, GqlSuperAdminsTableQueryVariables>;
export const GetDispensariesAdSettingsByMenuVariantDocument = gql`
    query GetDispensariesAdSettingsByMenuVariant($input: getDispensariesAdSettingsByMenuVariantInput!) {
  getDispensariesAdSettingsByMenuVariant(input: $input) {
    id
    name
    adSettings {
      enableAdsForDefault
      enableAdsForEmbedded
      enableAdsForKiosk
      enableAdsForStoreFront
    }
  }
}
    `;

/**
 * __useGetDispensariesAdSettingsByMenuVariantQuery__
 *
 * To run a query within a React component, call `useGetDispensariesAdSettingsByMenuVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispensariesAdSettingsByMenuVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispensariesAdSettingsByMenuVariantQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDispensariesAdSettingsByMenuVariantQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDispensariesAdSettingsByMenuVariantQuery, GqlGetDispensariesAdSettingsByMenuVariantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDispensariesAdSettingsByMenuVariantQuery, GqlGetDispensariesAdSettingsByMenuVariantQueryVariables>(GetDispensariesAdSettingsByMenuVariantDocument, options);
      }
export function useGetDispensariesAdSettingsByMenuVariantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDispensariesAdSettingsByMenuVariantQuery, GqlGetDispensariesAdSettingsByMenuVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDispensariesAdSettingsByMenuVariantQuery, GqlGetDispensariesAdSettingsByMenuVariantQueryVariables>(GetDispensariesAdSettingsByMenuVariantDocument, options);
        }
export type GetDispensariesAdSettingsByMenuVariantQueryHookResult = ReturnType<typeof useGetDispensariesAdSettingsByMenuVariantQuery>;
export type GetDispensariesAdSettingsByMenuVariantLazyQueryHookResult = ReturnType<typeof useGetDispensariesAdSettingsByMenuVariantLazyQuery>;
export type GetDispensariesAdSettingsByMenuVariantQueryResult = Apollo.QueryResult<GqlGetDispensariesAdSettingsByMenuVariantQuery, GqlGetDispensariesAdSettingsByMenuVariantQueryVariables>;
export const UpdateDispensaryAdSettingsDocument = gql`
    mutation UpdateDispensaryAdSettings($input: updateDispensaryAdSettingsInput!) {
  updateDispensaryAdSettings(input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdateDispensaryAdSettingsMutationFn = Apollo.MutationFunction<GqlUpdateDispensaryAdSettingsMutation, GqlUpdateDispensaryAdSettingsMutationVariables>;

/**
 * __useUpdateDispensaryAdSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDispensaryAdSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDispensaryAdSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDispensaryAdSettingsMutation, { data, loading, error }] = useUpdateDispensaryAdSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDispensaryAdSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDispensaryAdSettingsMutation, GqlUpdateDispensaryAdSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDispensaryAdSettingsMutation, GqlUpdateDispensaryAdSettingsMutationVariables>(UpdateDispensaryAdSettingsDocument, options);
      }
export type UpdateDispensaryAdSettingsMutationHookResult = ReturnType<typeof useUpdateDispensaryAdSettingsMutation>;
export type UpdateDispensaryAdSettingsMutationResult = Apollo.MutationResult<GqlUpdateDispensaryAdSettingsMutation>;
export type UpdateDispensaryAdSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDispensaryAdSettingsMutation, GqlUpdateDispensaryAdSettingsMutationVariables>;
export const ImportCustomerCsvDocument = gql`
    mutation ImportCustomerCSV($dispensaryId: String!, $CSV: String!) {
  importCustomerCSV(dispensaryId: $dispensaryId, CSV: $CSV) {
    success
    message
  }
}
    `;
export type GqlImportCustomerCsvMutationFn = Apollo.MutationFunction<GqlImportCustomerCsvMutation, GqlImportCustomerCsvMutationVariables>;

/**
 * __useImportCustomerCsvMutation__
 *
 * To run a mutation, you first call `useImportCustomerCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCustomerCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCustomerCsvMutation, { data, loading, error }] = useImportCustomerCsvMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      CSV: // value for 'CSV'
 *   },
 * });
 */
export function useImportCustomerCsvMutation(baseOptions?: Apollo.MutationHookOptions<GqlImportCustomerCsvMutation, GqlImportCustomerCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlImportCustomerCsvMutation, GqlImportCustomerCsvMutationVariables>(ImportCustomerCsvDocument, options);
      }
export type ImportCustomerCsvMutationHookResult = ReturnType<typeof useImportCustomerCsvMutation>;
export type ImportCustomerCsvMutationResult = Apollo.MutationResult<GqlImportCustomerCsvMutation>;
export type ImportCustomerCsvMutationOptions = Apollo.BaseMutationOptions<GqlImportCustomerCsvMutation, GqlImportCustomerCsvMutationVariables>;
export const ImportDeliveryZipCodesDocument = gql`
    mutation ImportDeliveryZipCodes($dispensaryId: String!, $csv: String!) {
  importDeliveryZipCodes(dispensaryId: $dispensaryId, csv: $csv) {
    success
    message
  }
}
    `;
export type GqlImportDeliveryZipCodesMutationFn = Apollo.MutationFunction<GqlImportDeliveryZipCodesMutation, GqlImportDeliveryZipCodesMutationVariables>;

/**
 * __useImportDeliveryZipCodesMutation__
 *
 * To run a mutation, you first call `useImportDeliveryZipCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDeliveryZipCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDeliveryZipCodesMutation, { data, loading, error }] = useImportDeliveryZipCodesMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useImportDeliveryZipCodesMutation(baseOptions?: Apollo.MutationHookOptions<GqlImportDeliveryZipCodesMutation, GqlImportDeliveryZipCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlImportDeliveryZipCodesMutation, GqlImportDeliveryZipCodesMutationVariables>(ImportDeliveryZipCodesDocument, options);
      }
export type ImportDeliveryZipCodesMutationHookResult = ReturnType<typeof useImportDeliveryZipCodesMutation>;
export type ImportDeliveryZipCodesMutationResult = Apollo.MutationResult<GqlImportDeliveryZipCodesMutation>;
export type ImportDeliveryZipCodesMutationOptions = Apollo.BaseMutationOptions<GqlImportDeliveryZipCodesMutation, GqlImportDeliveryZipCodesMutationVariables>;
export const GetDispensariesByPersonalizationSettingsDocument = gql`
    query GetDispensariesByPersonalizationSettings($input: getDispensariesByPersonalizationSettingsInput!) {
  getDispensariesByPersonalizationSettings(input: $input) {
    id
    name
    personalizationSettings {
      enablePersonalizationForDefault
      enablePersonalizationForEmbedded
      enablePersonalizationForKiosk
      enablePersonalizationForStoreFront
    }
  }
}
    `;

/**
 * __useGetDispensariesByPersonalizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetDispensariesByPersonalizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispensariesByPersonalizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispensariesByPersonalizationSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDispensariesByPersonalizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDispensariesByPersonalizationSettingsQuery, GqlGetDispensariesByPersonalizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDispensariesByPersonalizationSettingsQuery, GqlGetDispensariesByPersonalizationSettingsQueryVariables>(GetDispensariesByPersonalizationSettingsDocument, options);
      }
export function useGetDispensariesByPersonalizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDispensariesByPersonalizationSettingsQuery, GqlGetDispensariesByPersonalizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDispensariesByPersonalizationSettingsQuery, GqlGetDispensariesByPersonalizationSettingsQueryVariables>(GetDispensariesByPersonalizationSettingsDocument, options);
        }
export type GetDispensariesByPersonalizationSettingsQueryHookResult = ReturnType<typeof useGetDispensariesByPersonalizationSettingsQuery>;
export type GetDispensariesByPersonalizationSettingsLazyQueryHookResult = ReturnType<typeof useGetDispensariesByPersonalizationSettingsLazyQuery>;
export type GetDispensariesByPersonalizationSettingsQueryResult = Apollo.QueryResult<GqlGetDispensariesByPersonalizationSettingsQuery, GqlGetDispensariesByPersonalizationSettingsQueryVariables>;
export const UpdateDispensaryPersonalizationSettingsDocument = gql`
    mutation UpdateDispensaryPersonalizationSettings($input: updateDispensaryPersonalizationSettingsInput!) {
  updateDispensaryPersonalizationSettings(input: $input) {
    success
    message
  }
}
    `;
export type GqlUpdateDispensaryPersonalizationSettingsMutationFn = Apollo.MutationFunction<GqlUpdateDispensaryPersonalizationSettingsMutation, GqlUpdateDispensaryPersonalizationSettingsMutationVariables>;

/**
 * __useUpdateDispensaryPersonalizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDispensaryPersonalizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDispensaryPersonalizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDispensaryPersonalizationSettingsMutation, { data, loading, error }] = useUpdateDispensaryPersonalizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDispensaryPersonalizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDispensaryPersonalizationSettingsMutation, GqlUpdateDispensaryPersonalizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDispensaryPersonalizationSettingsMutation, GqlUpdateDispensaryPersonalizationSettingsMutationVariables>(UpdateDispensaryPersonalizationSettingsDocument, options);
      }
export type UpdateDispensaryPersonalizationSettingsMutationHookResult = ReturnType<typeof useUpdateDispensaryPersonalizationSettingsMutation>;
export type UpdateDispensaryPersonalizationSettingsMutationResult = Apollo.MutationResult<GqlUpdateDispensaryPersonalizationSettingsMutation>;
export type UpdateDispensaryPersonalizationSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDispensaryPersonalizationSettingsMutation, GqlUpdateDispensaryPersonalizationSettingsMutationVariables>;
export const UpdateCnameDocument = gql`
    mutation UpdateCname($dispensaryId: String!, $cname: String!) {
  updateCname(dispensaryId: $dispensaryId, cname: $cname) {
    success
    message
  }
}
    `;
export type GqlUpdateCnameMutationFn = Apollo.MutationFunction<GqlUpdateCnameMutation, GqlUpdateCnameMutationVariables>;

/**
 * __useUpdateCnameMutation__
 *
 * To run a mutation, you first call `useUpdateCnameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCnameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCnameMutation, { data, loading, error }] = useUpdateCnameMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      cname: // value for 'cname'
 *   },
 * });
 */
export function useUpdateCnameMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCnameMutation, GqlUpdateCnameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCnameMutation, GqlUpdateCnameMutationVariables>(UpdateCnameDocument, options);
      }
export type UpdateCnameMutationHookResult = ReturnType<typeof useUpdateCnameMutation>;
export type UpdateCnameMutationResult = Apollo.MutationResult<GqlUpdateCnameMutation>;
export type UpdateCnameMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCnameMutation, GqlUpdateCnameMutationVariables>;
export const UpdateUserEmailDocument = gql`
    mutation UpdateUserEmail($currentEmail: String!, $newEmail: String!) {
  updateUserEmail(currentEmail: $currentEmail, newEmail: $newEmail) {
    success
    message
  }
}
    `;
export type GqlUpdateUserEmailMutationFn = Apollo.MutationFunction<GqlUpdateUserEmailMutation, GqlUpdateUserEmailMutationVariables>;

/**
 * __useUpdateUserEmailMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmailMutation, { data, loading, error }] = useUpdateUserEmailMutation({
 *   variables: {
 *      currentEmail: // value for 'currentEmail'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useUpdateUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateUserEmailMutation, GqlUpdateUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateUserEmailMutation, GqlUpdateUserEmailMutationVariables>(UpdateUserEmailDocument, options);
      }
export type UpdateUserEmailMutationHookResult = ReturnType<typeof useUpdateUserEmailMutation>;
export type UpdateUserEmailMutationResult = Apollo.MutationResult<GqlUpdateUserEmailMutation>;
export type UpdateUserEmailMutationOptions = Apollo.BaseMutationOptions<GqlUpdateUserEmailMutation, GqlUpdateUserEmailMutationVariables>;
export const UpdateUserPermissionsDocument = gql`
    mutation UpdateUserPermissions($email: String!, $permission: String!) {
  updateUserPermissions(email: $email, permission: $permission) {
    success
    message
  }
}
    `;
export type GqlUpdateUserPermissionsMutationFn = Apollo.MutationFunction<GqlUpdateUserPermissionsMutation, GqlUpdateUserPermissionsMutationVariables>;

/**
 * __useUpdateUserPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateUserPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPermissionsMutation, { data, loading, error }] = useUpdateUserPermissionsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useUpdateUserPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateUserPermissionsMutation, GqlUpdateUserPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateUserPermissionsMutation, GqlUpdateUserPermissionsMutationVariables>(UpdateUserPermissionsDocument, options);
      }
export type UpdateUserPermissionsMutationHookResult = ReturnType<typeof useUpdateUserPermissionsMutation>;
export type UpdateUserPermissionsMutationResult = Apollo.MutationResult<GqlUpdateUserPermissionsMutation>;
export type UpdateUserPermissionsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateUserPermissionsMutation, GqlUpdateUserPermissionsMutationVariables>;
export const UpdateUserRoleV2Document = gql`
    mutation UpdateUserRoleV2($email: String!, $role: UserRoles!) {
  updateUserRoleV2(email: $email, role: $role) {
    success
    message
  }
}
    `;
export type GqlUpdateUserRoleV2MutationFn = Apollo.MutationFunction<GqlUpdateUserRoleV2Mutation, GqlUpdateUserRoleV2MutationVariables>;

/**
 * __useUpdateUserRoleV2Mutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleV2Mutation, { data, loading, error }] = useUpdateUserRoleV2Mutation({
 *   variables: {
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateUserRoleV2Mutation, GqlUpdateUserRoleV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateUserRoleV2Mutation, GqlUpdateUserRoleV2MutationVariables>(UpdateUserRoleV2Document, options);
      }
export type UpdateUserRoleV2MutationHookResult = ReturnType<typeof useUpdateUserRoleV2Mutation>;
export type UpdateUserRoleV2MutationResult = Apollo.MutationResult<GqlUpdateUserRoleV2Mutation>;
export type UpdateUserRoleV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateUserRoleV2Mutation, GqlUpdateUserRoleV2MutationVariables>;
export const SuperAdminConsumerUserByEmailDocument = gql`
    query SuperAdminConsumerUserByEmail($email: String!) {
  superAdminConsumerUserByEmail(email: $email) {
    id
    name
    email
    isSso
    ssoProvider
  }
}
    `;

/**
 * __useSuperAdminConsumerUserByEmailQuery__
 *
 * To run a query within a React component, call `useSuperAdminConsumerUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminConsumerUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminConsumerUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSuperAdminConsumerUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GqlSuperAdminConsumerUserByEmailQuery, GqlSuperAdminConsumerUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSuperAdminConsumerUserByEmailQuery, GqlSuperAdminConsumerUserByEmailQueryVariables>(SuperAdminConsumerUserByEmailDocument, options);
      }
export function useSuperAdminConsumerUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSuperAdminConsumerUserByEmailQuery, GqlSuperAdminConsumerUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSuperAdminConsumerUserByEmailQuery, GqlSuperAdminConsumerUserByEmailQueryVariables>(SuperAdminConsumerUserByEmailDocument, options);
        }
export type SuperAdminConsumerUserByEmailQueryHookResult = ReturnType<typeof useSuperAdminConsumerUserByEmailQuery>;
export type SuperAdminConsumerUserByEmailLazyQueryHookResult = ReturnType<typeof useSuperAdminConsumerUserByEmailLazyQuery>;
export type SuperAdminConsumerUserByEmailQueryResult = Apollo.QueryResult<GqlSuperAdminConsumerUserByEmailQuery, GqlSuperAdminConsumerUserByEmailQueryVariables>;
export const RemoveConsumerSsoDocument = gql`
    mutation RemoveConsumerSso($userId: ID!) {
  removeConsumerSso(userId: $userId) {
    success
  }
}
    `;
export type GqlRemoveConsumerSsoMutationFn = Apollo.MutationFunction<GqlRemoveConsumerSsoMutation, GqlRemoveConsumerSsoMutationVariables>;

/**
 * __useRemoveConsumerSsoMutation__
 *
 * To run a mutation, you first call `useRemoveConsumerSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConsumerSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConsumerSsoMutation, { data, loading, error }] = useRemoveConsumerSsoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveConsumerSsoMutation(baseOptions?: Apollo.MutationHookOptions<GqlRemoveConsumerSsoMutation, GqlRemoveConsumerSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRemoveConsumerSsoMutation, GqlRemoveConsumerSsoMutationVariables>(RemoveConsumerSsoDocument, options);
      }
export type RemoveConsumerSsoMutationHookResult = ReturnType<typeof useRemoveConsumerSsoMutation>;
export type RemoveConsumerSsoMutationResult = Apollo.MutationResult<GqlRemoveConsumerSsoMutation>;
export type RemoveConsumerSsoMutationOptions = Apollo.BaseMutationOptions<GqlRemoveConsumerSsoMutation, GqlRemoveConsumerSsoMutationVariables>;